// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/images/icons/tablesort--asc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/images/icons/tablesort--desc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/images/icons/play.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/fonts/Axiforma-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/assets/fonts/Axiforma-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/assets/fonts/Axiforma-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/assets/fonts/Axiforma-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/src/assets/fonts/Axiforma-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/src/assets/fonts/Axiforma-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/src/images/icons/select-arrow-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/src/images/icons/arrow-next-light-blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/src/images/icons/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/src/images/icons/download-circle-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/src/images/icons/icon-fullscreen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/src/images/icons/check-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("/src/images/icons/chevron-down-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("/src/images/icons/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("/src/assets/fonts/Axiforma-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("/src/assets/fonts/Axiforma-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("/src/assets/fonts/Axiforma-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("/src/assets/fonts/Axiforma-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("/src/assets/fonts/Axiforma-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("/src/assets/fonts/Axiforma-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("/src/assets/fonts/Axiforma-Book.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("/src/assets/fonts/Axiforma-Book.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("/src/assets/fonts/Axiforma-BookItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("/src/assets/fonts/Axiforma-BookItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("/src/assets/fonts/Axiforma-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("/src/assets/fonts/Axiforma-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("/src/assets/fonts/Axiforma-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("/src/assets/fonts/Axiforma-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("/src/assets/fonts/Axiforma-BlackItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("/src/assets/fonts/Axiforma-BlackItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("/src/images/icons/earth-grid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("/src/images/icons/chevron-down-dark-blue-round.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("/src/images/icons/login.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("/src/images/icons/phone.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("/src/images/icons/playInverted.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @license GPL-2.0-or-later https://www.drupal.org/licensing/faq */
.entity-browser-form__img img,
.layout-builder-configure-block img {
    width: 100% !important;
    height: auto;
}

.linkit-ui-autocomplete {
    position: fixed !important;
}

@media (min-width: 768px) {
    .offset-md-1 {
        margin-left: 8.33333% !important;
    }

    .offset-right-1 {
        margin-right: 8.33333% !important;
    }

    .col-sm-40 {
        flex: 0 0 40% !important;
        max-width: 40% !important;
    }

    .col-sm-39 {
        flex: 0 0 31.66666% !important;
        max-width: 31.66666% !important;
    }

    .col-sm-38 {
        flex: 0 0 23.33333% !important;
        max-width: 23.33333% !important;
    }

    .col-sm-60 {
        flex: 0 0 60% !important;
        max-width: 60% !important;
    }

    .col-sm-59 {
        flex: 0 0 51.66666% !important;
        max-width: 51.66666% !important;
    }

    .col-sm-58 {
        flex: 0 0 43.33333% !important;
        max-width: 43.33333% !important;
    }

    .col-12 {
        flex-shrink: 1 !important;
    }

    .layout__flex {
        display: flex;
    }

    .col-sm-flex {
        display: flex;
        flex-wrap: wrap;
    }

    .col-sm-flex>*,
    .col-sm-flex-1>* {
        flex: 1 0 100% !important;
    }

    .col-sm-flex-2>* {
        flex: 1 0 calc(100% / 2 - 10px) !important;
        max-width: calc(100% / 2 - 10px);
    }

    .col-sm-flex-3>* {
        flex: 1 0 calc(100% / 3 - 10px) !important;
        max-width: calc(100% / 3 - 10px);
    }

    .col-sm-flex-4>* {
        flex: 1 0 calc(100% / 4 - 10px) !important;
        max-width: calc(100% / 4 - 10px);
    }

    .col-sm-flex-5>* {
        flex: 1 0 calc(100% / 5 - 10px) !important;
        max-width: calc(100% / 5 - 10px);
    }

    .col-sm-flex-6>* {
        flex: 1 0 calc(100% / 6 - 10px) !important;
        max-width: calc(100% / 6 - 10px);
    }
}

@media (max-width: 767px) {
    .col-sm-flex.justify-content-start {
        text-align: left;
    }

    .col-sm-flex.justify-content-center {
        text-align: center;
    }

    .col-sm-flex.justify-content-end {
        text-align: right;
    }
}

.pt {
    padding-top: 50px;
}

.pb {
    padding-bottom: 50px;
}

@media (max-width: 768px) {
    .pb {
        padding-bottom: 0;
    }

    .pt {
        padding-top: 0;
    }
}

@media (min-width: 769px) {
    .pt {
        padding-top: 160px;
    }

    .pb {
        padding-bottom: 160px;
    }

    .mt {
        margin-top: 60px;
    }

    .mb {
        margin-bottom: 60px;
    }
}

.layout-two-columns-with-action__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    grid-template-areas: "left" "right" "action";

    @media (min-width: 768px) {
        gap: 3.5rem;
    }
}

@media (min-width: 768px) {
    .layout-two-columns-with-action__container {
        grid-template-columns: 1fr 1fr;
        grid-template-areas: "left right" "action right";
    }

    .layout-two-columns-with-action__container.layout-two-columns-with-action-reversed {
        grid-template-areas: "right left" "right action";
    }
}

.layout-two-columns-with-action__action {
    grid-area: action;
    justify-self: start;
    align-self: end;
}

.layout-two-columns-with-action__left {
    grid-area: left;
}

.layout-two-columns-with-action__right {
    grid-area: right;
}

.ui-helper-hidden {
    display: none;
}

.ui-helper-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

.ui-helper-reset {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    line-height: 1.3;
    text-decoration: none;
    font-size: 100%;
    list-style: none;
}

.ui-helper-clearfix:before,
.ui-helper-clearfix:after {
    content: "";
    display: table;
    border-collapse: collapse;
}

.ui-helper-clearfix:after {
    clear: both;
}

.ui-helper-zfix {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    opacity: 0;
    -ms-filter: "alpha(opacity=0)";
}

.ui-front {
    z-index: 100;
}

.ui-state-disabled {
    cursor: default !important;
    pointer-events: none;
}

.ui-icon {
    display: inline-block;
    vertical-align: middle;
    margin-top: -.25em;
    position: relative;
    text-indent: -99999px;
    overflow: hidden;
    background-repeat: no-repeat;
}

.ui-widget-icon-block {
    left: 50%;
    margin-left: -8px;
    display: block;
}

.ui-widget-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.ui-controlgroup {
    vertical-align: middle;
    display: inline-block;
}

.ui-controlgroup>.ui-controlgroup-item {
    float: left;
    margin-left: 0;
    margin-right: 0;
}

.ui-controlgroup>.ui-controlgroup-item:focus,
.ui-controlgroup>.ui-controlgroup-item.ui-visual-focus {
    z-index: 9999;
}

.ui-controlgroup-vertical>.ui-controlgroup-item {
    display: block;
    float: none;
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
    text-align: left;
}

.ui-controlgroup-vertical .ui-controlgroup-item {
    box-sizing: border-box;
}

.ui-controlgroup .ui-controlgroup-label {
    padding: .4em 1em;
}

.ui-controlgroup .ui-controlgroup-label span {
    font-size: 80%;
}

.ui-controlgroup-horizontal .ui-controlgroup-label+.ui-controlgroup-item {
    border-left: none;
}

.ui-controlgroup-vertical .ui-controlgroup-label+.ui-controlgroup-item {
    border-top: none;
}

.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {
    border-right: none;
}

.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {
    border-bottom: none;
}

.ui-controlgroup-vertical .ui-spinner-input {
    width: 75%;
    width: calc(100% - 2.4em);
}

.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {
    border-top-style: solid;
}

.ui-checkboxradio-label .ui-icon-background {
    box-shadow: inset 1px 1px 1px #ccc;
    border-radius: .12em;
    border: none;
}

.ui-checkboxradio-radio-label .ui-icon-background {
    width: 16px;
    height: 16px;
    border-radius: 1em;
    overflow: visible;
    border: none;
}

.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,
.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {
    background-image: none;
    width: 8px;
    height: 8px;
    border-width: 4px;
    border-style: solid;
}

.ui-checkboxradio-disabled {
    pointer-events: none;
}

.ui-resizable {
    position: relative;
}

.ui-resizable-handle {
    position: absolute;
    font-size: 0.1px;
    display: block;
    touch-action: none;
}

.ui-resizable-disabled .ui-resizable-handle,
.ui-resizable-autohide .ui-resizable-handle {
    display: none;
}

.ui-resizable-n {
    cursor: n-resize;
    height: 7px;
    width: 100%;
    top: -5px;
    left: 0;
}

.ui-resizable-s {
    cursor: s-resize;
    height: 7px;
    width: 100%;
    bottom: -5px;
    left: 0;
}

.ui-resizable-e {
    cursor: e-resize;
    width: 7px;
    right: -5px;
    top: 0;
    height: 100%;
}

.ui-resizable-w {
    cursor: w-resize;
    width: 7px;
    left: -5px;
    top: 0;
    height: 100%;
}

.ui-resizable-se {
    cursor: se-resize;
    width: 12px;
    height: 12px;
    right: 1px;
    bottom: 1px;
}

.ui-resizable-sw {
    cursor: sw-resize;
    width: 9px;
    height: 9px;
    left: -5px;
    bottom: -5px;
}

.ui-resizable-nw {
    cursor: nw-resize;
    width: 9px;
    height: 9px;
    left: -5px;
    top: -5px;
}

.ui-resizable-ne {
    cursor: ne-resize;
    width: 9px;
    height: 9px;
    right: -5px;
    top: -5px;
}

.ui-button {
    padding: .4em 1em;
    display: inline-block;
    position: relative;
    line-height: normal;
    margin-right: .1em;
    cursor: pointer;
    vertical-align: middle;
    text-align: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    overflow: visible;
}

.ui-button,
.ui-button:link,
.ui-button:visited,
.ui-button:hover,
.ui-button:active {
    text-decoration: none;
}

.ui-button-icon-only {
    width: 2em;
    box-sizing: border-box;
    text-indent: -9999px;
    white-space: nowrap;
}

input.ui-button.ui-button-icon-only {
    text-indent: 0;
}

.ui-button-icon-only .ui-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -8px;
    margin-left: -8px;
}

.ui-button.ui-icon-notext .ui-icon {
    padding: 0;
    width: 2.1em;
    height: 2.1em;
    text-indent: -9999px;
    white-space: nowrap;
}

input.ui-button.ui-icon-notext .ui-icon {
    width: auto;
    height: auto;
    text-indent: 0;
    white-space: normal;
    padding: .4em 1em;
}

input.ui-button::-moz-focus-inner,
button.ui-button::-moz-focus-inner {
    border: 0;
    padding: 0;
}

.ui-dialog {
    position: absolute;
    top: 0;
    left: 0;
    padding: .2em;
    outline: 0;
}

.ui-dialog .ui-dialog-titlebar {
    padding: .4em 1em;
    position: relative;
}

.ui-dialog .ui-dialog-title {
    float: left;
    margin: .1em 0;
    white-space: nowrap;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ui-dialog .ui-dialog-titlebar-close {
    position: absolute;
    right: .3em;
    top: 50%;
    width: 20px;
    margin: -10px 0 0 0;
    padding: 1px;
    height: 20px;
}

.ui-dialog .ui-dialog-content {
    position: relative;
    border: 0;
    padding: .5em 1em;
    background: none;
    overflow: auto;
}

.ui-dialog .ui-dialog-buttonpane {
    text-align: left;
    border-width: 1px 0 0 0;
    background-image: none;
    margin-top: .5em;
    padding: .3em 1em .5em .4em;
}

.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {
    float: right;
}

.ui-dialog .ui-dialog-buttonpane button {
    margin: .5em .4em .5em 0;
    cursor: pointer;
}

.ui-dialog .ui-resizable-n {
    height: 2px;
    top: 0;
}

.ui-dialog .ui-resizable-e {
    width: 2px;
    right: 0;
}

.ui-dialog .ui-resizable-s {
    height: 2px;
    bottom: 0;
}

.ui-dialog .ui-resizable-w {
    width: 2px;
    left: 0;
}

.ui-dialog .ui-resizable-se,
.ui-dialog .ui-resizable-sw,
.ui-dialog .ui-resizable-ne,
.ui-dialog .ui-resizable-nw {
    width: 7px;
    height: 7px;
}

.ui-dialog .ui-resizable-se {
    right: 0;
    bottom: 0;
}

.ui-dialog .ui-resizable-sw {
    left: 0;
    bottom: 0;
}

.ui-dialog .ui-resizable-ne {
    right: 0;
    top: 0;
}

.ui-dialog .ui-resizable-nw {
    left: 0;
    top: 0;
}

.ui-draggable .ui-dialog-titlebar {
    cursor: move;
}

.text-align-left {
    text-align: left;
}

.text-align-right {
    text-align: right;
}

.text-align-center {
    text-align: center;
}

.text-align-justify {
    text-align: justify;
}

.align-left {
    float: left;
}

.align-right {
    float: right;
}

.align-center {
    display: block;
    margin-right: auto;
    margin-left: auto;
}

.fieldgroup {
    padding: 0;
    border-width: 0;
}

.container-inline div,
.container-inline label {
    display: inline;
}

.container-inline .details-wrapper {
    display: block;
}

.clearfix:after {
    display: table;
    clear: both;
    content: "";
}

.js details:not([open]) .details-wrapper {
    display: none;
}

.hidden {
    display: none;
}

.visually-hidden {
    position: absolute !important;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    width: 1px;
    height: 1px;
    word-wrap: normal;
}

.visually-hidden.focusable:active,
.visually-hidden.focusable:focus {
    position: static !important;
    overflow: visible;
    clip: auto;
    width: auto;
    height: auto;
}

.invisible {
    visibility: hidden;
}

.item-list__comma-list,
.item-list__comma-list li {
    display: inline;
}

.item-list__comma-list {
    margin: 0;
    padding: 0;
}

.item-list__comma-list li:after {
    content: ", ";
}

.item-list__comma-list li:last-child:after {
    content: "";
}

.js .js-hide {
    display: none;
}

.js-show {
    display: none;
}

.js .js-show {
    display: block;
}

.nowrap {
    white-space: nowrap;
}

.position-container {
    position: relative;
}

.reset-appearance {
    margin: 0;
    padding: 0;
    border: 0 none;
    background: transparent;
    line-height: inherit;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.resize-none {
    resize: none;
}

.resize-vertical {
    min-height: 2em;
    resize: vertical;
}

.resize-horizontal {
    max-width: 100%;
    resize: horizontal;
}

.resize-both {
    max-width: 100%;
    min-height: 2em;
    resize: both;
}

.system-status-counter__status-icon {
    display: inline-block;
    width: 25px;
    height: 25px;
    vertical-align: middle;
}

.system-status-counter__status-icon:before {
    display: block;
    content: "";
    background-repeat: no-repeat;
    background-position: center 2px;
    background-size: 20px;
}

/* 
.system-status-counter__status-icon--error:before {
    background-image: url(/src/images/icons/error.svg);
}

.system-status-counter__status-icon--warning:before {
    background-image: url(/src/images/icons/warning.svg);
}

.system-status-counter__status-icon--checked:before {
    background-image: url(/src/images/icons/checked.svg);
} */

.system-status-report-counters__item {
    width: 100%;
    margin-bottom: 0.5em;
    padding: 0.5em 0;
    text-align: center;
    white-space: nowrap;
    background-color: rgba(0, 0, 0, 0.063);
}

@media screen and (min-width: 60em) {
    .system-status-report-counters {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .system-status-report-counters__item--half-width {
        width: 49%;
    }

    .system-status-report-counters__item--third-width {
        width: 33%;
    }
}

.system-status-general-info__item {
    margin-top: 1em;
    padding: 0 1em 1em;
    border: 1px solid #ccc;
}

.system-status-general-info__item-title {
    border-bottom: 1px solid #ccc;
}

.tablesort {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: 100%;
}

.tablesort--asc {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.tablesort--desc {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.progress {
    position: relative;
}

.progress__track {
    min-width: 100px;
    max-width: 100%;
    height: 16px;
    margin-top: 5px;
    border: 1px solid;
    background-color: #fff;
}

.progress__bar {
    width: 3%;
    min-width: 3%;
    max-width: 100%;
    height: 1.5em;
    background-color: #000;
}

.progress__description,
.progress__percentage {
    overflow: hidden;
    margin-top: 0.2em;
    color: #555;
    font-size: 0.875em;
}

.progress__description {
    float: left;
}

[dir="rtl"] .progress__description {
    float: right;
}

.progress__percentage {
    float: right;
}

[dir="rtl"] .progress__percentage {
    float: left;
}

.progress--small .progress__track {
    height: 7px;
}

.progress--small .progress__bar {
    height: 7px;
    background-size: 20px 20px;
}

.ajax-progress {
    display: inline-block;
    padding: 1px 5px 2px 5px;
}

[dir="rtl"] .ajax-progress {
    float: right;
}


.ajax-progress-throbber .message {
    display: inline;
    padding: 1px 5px 2px;
}

tr .ajax-progress-throbber .throbber {
    margin: 0 2px;
}

.ajax-progress-bar {
    width: 16em;
}

.ajax-progress-fullscreen {
    position: fixed;
    z-index: 1000;
    top: 48.5%;
    left: 49%;
    width: 24px;
    height: 24px;
    padding: 4px;
    opacity: 0.9;
    border-radius: 7px;
    background-color: #232323;
    background-repeat: no-repeat;
    background-position: center center;
}

[dir="rtl"] .ajax-progress-fullscreen {
    right: 49%;
    left: auto;
}

.video-embed-field-responsive-video {
    position: relative;
}

.video-embed-field-responsive-video:after {
    content: '';
    display: block;
    padding-bottom: 56.25%;
}

.video-embed-field-responsive-video iframe {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
}

.video-embed-field-responsive-modal {
    max-width: 100%;
}

.video-embed-field-lazy {
    cursor: pointer;
    position: relative;
}

.video-embed-field-lazy img {
    width: 100%;
}

.video-embed-field-lazy-play {
    height: 72px;
    width: 72px;
    left: 50%;
    top: 50%;
    margin-left: -36px;
    margin-top: -36px;
    position: absolute;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
    cursor: pointer;
    background-size: 72px 72px;
}

*,
:after,
:before {
    border: 0 solid #e5e7eb;
    box-sizing: border-box
}

:after,
:before {
    --tw-content: ""
}

html {
    -webkit-text-size-adjust: 100%;
    font-feature-settings: normal;
    font-family: Axiforma, ui-sans-serif, system-ui;
    font-variation-settings: normal;
    line-height: 1.5;
    -moz-tab-size: 4;
      -o-tab-size: 4;
         tab-size: 4
}

body {
    line-height: inherit;
    margin: 0
}

hr {
    border-top-width: 1px;
    color: inherit;
    height: 0
}

abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-size: inherit;
    font-weight: inherit
}

a {
    color: inherit;
    text-decoration: inherit
}

b,
strong {
    font-weight: bolder
}

code,
kbd,
pre,
samp {
    font-feature-settings: normal;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
    font-size: 1em;
    font-variation-settings: normal
}

small {
    font-size: 80%
}

sub,
sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: initial
}

sub {
    bottom: -.25em
}

sup {
    top: -.5em
}

table {
    border-collapse: collapse;
    border-color: inherit;
    text-indent: 0
}

button,
input,
optgroup,
select,
textarea {
    font-feature-settings: inherit;
    color: inherit;
    font-family: inherit;
    font-size: 100%;
    font-variation-settings: inherit;
    font-weight: inherit;
    line-height: inherit;
    margin: 0;
    padding: 0
}

button,
select {
    text-transform: none
}

[type=button],
[type=reset],
[type=submit],
button {
    -webkit-appearance: button;
    background-color: initial;
    background-image: none
}

:-moz-focusring {
    outline: auto
}

:-moz-ui-invalid {
    box-shadow: none
}

progress {
    vertical-align: initial
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
    height: auto
}

[type=search] {
    -webkit-appearance: textfield;
    outline-offset: -2px
}

::-webkit-search-decoration {
    -webkit-appearance: none
}

::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit
}

summary {
    display: list-item
}

blockquote,
dd,
dl,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
pre {
    margin: 0
}

fieldset {
    margin: 0
}

fieldset,
legend {
    padding: 0
}

menu,
ol,
ul {
    list-style: none;
    margin: 0;
    padding: 0
}

dialog {
    padding: 0
}

textarea {
    resize: vertical
}

input::-moz-placeholder, textarea::-moz-placeholder {
    color: #9ca3af;
    opacity: 1
}

input::placeholder,
textarea::placeholder {
    color: #9ca3af;
    opacity: 1
}

[role=button],
button {
    cursor: pointer
}

:disabled {
    cursor: default
}

audio,
canvas,
embed,
iframe,
img,
object,
svg,
video {
    display: block;
    vertical-align: middle
}

img,
video {
    height: auto;
    max-width: 100%
}

[hidden] {
    display: none
}

*,
:after,
:before {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, .5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia:
}

::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, .5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia:
}

.container {
    width: 100%
}

@media (min-width: 640px) {
    .container {
        max-width: 640px
    }
}

@media (min-width: 768px) {
    .container {
        max-width: 768px
    }
}

@media (min-width: 1024px) {
    .container {
        max-width: 1024px
    }
}

@media (min-width: 1280px) {
    .container {
        max-width: 1280px
    }
}

@media (min-width: 1536px) {
    .container {
        max-width: 1536px
    }
}

#premier-tech-calculator :is(.pointer-events-none) {
    pointer-events: none
}

#premier-tech-calculator :is(.visible) {
    visibility: visible
}

#premier-tech-calculator :is(.static) {
    position: static
}

#premier-tech-calculator :is(.fixed) {
    position: fixed
}

#premier-tech-calculator :is(.absolute) {
    position: absolute
}

#premier-tech-calculator :is(.relative) {
    position: relative
}

#premier-tech-calculator :is(.bottom-4) {
    bottom: 16px
}

#premier-tech-calculator :is(.left-0) {
    left: 0
}

#premier-tech-calculator :is(.left-4) {
    left: 16px
}

#premier-tech-calculator :is(.right-3) {
    right: 12px
}

#premier-tech-calculator :is(.right-4) {
    right: 16px
}

#premier-tech-calculator :is(.top-0) {
    top: 0
}

#premier-tech-calculator :is(.top-11) {
    top: 44px
}

#premier-tech-calculator :is(.top-2) {
    top: 8px
}

#premier-tech-calculator :is(.top-\\[10px\\]) {
    top: 10px
}

#premier-tech-calculator :is(.z-10) {
    z-index: 10
}

#premier-tech-calculator :is(.z-20) {
    z-index: 20
}

#premier-tech-calculator :is(.col-span-2) {
    grid-column: span 2/span 2
}

#premier-tech-calculator :is(.\\!m-0) {
    margin: 0 !important
}

#premier-tech-calculator :is(.\\!my-10) {
    margin-bottom: 40px !important;
    margin-top: 40px !important
}

#premier-tech-calculator :is(.\\!my-14) {
    margin-bottom: 56px !important;
    margin-top: 56px !important
}

#premier-tech-calculator :is(.\\!my-2) {
    margin-bottom: 8px !important;
    margin-top: 8px !important
}

#premier-tech-calculator :is(.\\!my-8) {
    margin-bottom: 32px !important;
    margin-top: 32px !important
}

#premier-tech-calculator :is(.mx-auto) {
    margin-left: auto;
    margin-right: auto
}

#premier-tech-calculator :is(.my-14) {
    margin-bottom: 56px;
    margin-top: 56px
}

#premier-tech-calculator :is(.my-4) {
    margin-bottom: 16px;
    margin-top: 16px
}

#premier-tech-calculator :is(.my-8) {
    margin-bottom: 32px;
    margin-top: 32px
}

#premier-tech-calculator :is(.\\!-mt-8) {
    margin-top: -32px !important
}

#premier-tech-calculator :is(.\\!mb-0) {
    margin-bottom: 0 !important
}

#premier-tech-calculator :is(.\\!mb-1) {
    margin-bottom: 4px !important
}

#premier-tech-calculator :is(.\\!mb-1\\.5) {
    margin-bottom: 6px !important
}

#premier-tech-calculator :is(.\\!mb-4) {
    margin-bottom: 16px !important
}

#premier-tech-calculator :is(.\\!mb-6) {
    margin-bottom: 24px !important
}

#premier-tech-calculator :is(.\\!mb-8) {
    margin-bottom: 32px !important
}

#premier-tech-calculator :is(.\\!ml-2) {
    margin-left: 8px !important
}

#premier-tech-calculator :is(.\\!mr-0) {
    margin-right: 0 !important
}

#premier-tech-calculator :is(.\\!mr-2) {
    margin-right: 8px !important
}

#premier-tech-calculator :is(.\\!mr-4) {
    margin-right: 16px !important
}

#premier-tech-calculator :is(.\\!mt-0) {
    margin-top: 0 !important
}

#premier-tech-calculator :is(.\\!mt-10) {
    margin-top: 40px !important
}

#premier-tech-calculator :is(.\\!mt-2) {
    margin-top: 8px !important
}

#premier-tech-calculator :is(.\\!mt-4) {
    margin-top: 16px !important
}

#premier-tech-calculator :is(.\\!mt-5) {
    margin-top: 20px !important
}

#premier-tech-calculator :is(.\\!mt-7) {
    margin-top: 28px !important
}

#premier-tech-calculator :is(.\\!mt-8) {
    margin-top: 32px !important
}

#premier-tech-calculator :is(.-ml-\\[230px\\]) {
    margin-left: -230px
}

#premier-tech-calculator :is(.-mt-1) {
    margin-top: -4px
}

#premier-tech-calculator :is(.-mt-1\\.5) {
    margin-top: -6px
}

#premier-tech-calculator :is(.-mt-\\[2px\\]) {
    margin-top: -2px
}

#premier-tech-calculator :is(.mb-1) {
    margin-bottom: 4px
}

#premier-tech-calculator :is(.mb-4) {
    margin-bottom: 16px
}

#premier-tech-calculator :is(.ml-4) {
    margin-left: 16px
}

#premier-tech-calculator :is(.ml-6) {
    margin-left: 24px
}

#premier-tech-calculator :is(.ml-\\[230px\\]) {
    margin-left: 230px
}

#premier-tech-calculator :is(.mr-4) {
    margin-right: 16px
}

#premier-tech-calculator :is(.mr-6) {
    margin-right: 24px
}

#premier-tech-calculator :is(.mt-1) {
    margin-top: 4px
}

#premier-tech-calculator :is(.mt-10) {
    margin-top: 40px
}

#premier-tech-calculator :is(.mt-12) {
    margin-top: 48px
}

#premier-tech-calculator :is(.mt-4) {
    margin-top: 16px
}

#premier-tech-calculator :is(.mt-5) {
    margin-top: 20px
}

#premier-tech-calculator :is(.mt-8) {
    margin-top: 32px
}

#premier-tech-calculator :is(.mt-\\[200px\\]) {
    margin-top: 200px
}

#premier-tech-calculator :is(.mt-\\[75px\\]) {
    margin-top: 75px
}

#premier-tech-calculator :is(.block) {
    display: block
}

#premier-tech-calculator :is(.flex) {
    display: flex
}

#premier-tech-calculator :is(.grid) {
    display: grid
}

#premier-tech-calculator :is(.hidden) {
    display: none
}

#premier-tech-calculator :is(.h-1) {
    height: 4px
}

#premier-tech-calculator :is(.h-2) {
    height: 8px
}

#premier-tech-calculator :is(.h-6) {
    height: 24px
}

#premier-tech-calculator :is(.h-8) {
    height: 32px
}

#premier-tech-calculator :is(.h-9) {
    height: 36px
}

#premier-tech-calculator :is(.h-\\[350px\\]) {
    height: 350px
}

#premier-tech-calculator :is(.h-\\[65px\\]) {
    height: 65px
}

#premier-tech-calculator :is(.h-auto) {
    height: auto
}

#premier-tech-calculator :is(.h-full) {
    height: 100%
}

#premier-tech-calculator :is(.min-h-\\[60\\%\\]) {
    min-height: 60%
}

#premier-tech-calculator :is(.\\!w-auto) {
    width: auto !important
}

#premier-tech-calculator :is(.\\!w-full) {
    width: 100% !important
}

#premier-tech-calculator :is(.w-2) {
    width: 8px
}

#premier-tech-calculator :is(.w-6) {
    width: 24px
}

#premier-tech-calculator :is(.w-7) {
    width: 28px
}

#premier-tech-calculator :is(.w-\\[60px\\]) {
    width: 60px
}

#premier-tech-calculator :is(.w-auto) {
    width: auto
}

#premier-tech-calculator :is(.w-full) {
    width: 100%
}

#premier-tech-calculator :is(.max-w-full) {
    max-width: 100%
}

#premier-tech-calculator :is(.max-w-screen-xl) {
    max-width: 1280px
}

#premier-tech-calculator :is(.flex-none) {
    flex: none
}

#premier-tech-calculator :is(.grow) {
    flex-grow: 1
}

#premier-tech-calculator :is(.-translate-y-4) {
    --tw-translate-y: -16px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

#premier-tech-calculator :is(.translate-y-1) {
    --tw-translate-y: 4px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

#premier-tech-calculator :is(.rotate-180) {
    --tw-rotate: 180deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

#premier-tech-calculator :is(.transform) {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

#premier-tech-calculator :is(.cursor-pointer) {
    cursor: pointer
}

#premier-tech-calculator :is(.select-none) {
    -webkit-user-select: none;
    -moz-user-select: none;
         user-select: none
}

#premier-tech-calculator :is(.appearance-none) {
    -webkit-appearance: none;
    -moz-appearance: none;
         appearance: none
}

#premier-tech-calculator :is(.grid-cols-1) {
    grid-template-columns: repeat(1, minmax(0, 1fr))
}

#premier-tech-calculator :is(.grid-cols-2) {
    grid-template-columns: repeat(2, minmax(0, 1fr))
}

#premier-tech-calculator :is(.flex-col) {
    flex-direction: column
}

#premier-tech-calculator :is(.flex-wrap) {
    flex-wrap: wrap
}

#premier-tech-calculator :is(.content-center) {
    align-content: center
}

#premier-tech-calculator :is(.items-start) {
    align-items: flex-start
}

#premier-tech-calculator :is(.items-center) {
    align-items: center
}

#premier-tech-calculator :is(.justify-center) {
    justify-content: center
}

#premier-tech-calculator :is(.justify-between) {
    justify-content: space-between
}

#premier-tech-calculator :is(.gap-1) {
    gap: 4px
}

#premier-tech-calculator :is(.gap-2) {
    gap: 8px
}

#premier-tech-calculator :is(.gap-4) {
    gap: 16px
}

#premier-tech-calculator :is(.gap-8) {
    gap: 32px
}

#premier-tech-calculator :is(.gap-x-6) {
    -moz-column-gap: 24px;
         column-gap: 24px
}

#premier-tech-calculator :is(.gap-x-8) {
    -moz-column-gap: 32px;
         column-gap: 32px
}

#premier-tech-calculator :is(.gap-y-4) {
    row-gap: 16px
}

#premier-tech-calculator :is(.overflow-hidden) {
    overflow: hidden
}

#premier-tech-calculator :is(.whitespace-normal) {
    white-space: normal
}

#premier-tech-calculator :is(.break-words) {
    overflow-wrap: break-word
}

#premier-tech-calculator :is(.rounded) {
    border-radius: 4px
}

#premier-tech-calculator :is(.rounded-2xl) {
    border-radius: 16px
}

#premier-tech-calculator :is(.rounded-3xl) {
    border-radius: 24px
}

#premier-tech-calculator :is(.rounded-\\[20px\\]) {
    border-radius: 20px
}

#premier-tech-calculator :is(.rounded-full) {
    border-radius: 9999px
}

#premier-tech-calculator :is(.rounded-lg) {
    border-radius: 8px
}

#premier-tech-calculator :is(.rounded-xl) {
    border-radius: 12px
}

#premier-tech-calculator :is(.rounded-bl-2xl) {
    border-bottom-left-radius: 16px
}

#premier-tech-calculator :is(.rounded-bl-xl) {
    border-bottom-left-radius: 12px
}

#premier-tech-calculator :is(.rounded-br-2xl) {
    border-bottom-right-radius: 16px
}

#premier-tech-calculator :is(.rounded-br-xl) {
    border-bottom-right-radius: 12px
}

#premier-tech-calculator :is(.rounded-tl-2xl) {
    border-top-left-radius: 16px
}

#premier-tech-calculator :is(.rounded-tl-xl) {
    border-top-left-radius: 12px
}

#premier-tech-calculator :is(.rounded-tr-2xl) {
    border-top-right-radius: 16px
}

#premier-tech-calculator :is(.rounded-tr-xl) {
    border-top-right-radius: 12px
}

#premier-tech-calculator :is(.\\!border) {
    border-width: 1px !important
}

#premier-tech-calculator :is(.border) {
    border-width: 1px
}

#premier-tech-calculator :is(.\\!border-b) {
    border-bottom-width: 1px !important
}

#premier-tech-calculator :is(.\\!border-b-4) {
    border-bottom-width: 4px !important
}

#premier-tech-calculator :is(.\\!border-mainBlue) {
    --tw-border-opacity: 1 !important;
    border-color: rgb(4 30 66/var(--tw-border-opacity)) !important
}

#premier-tech-calculator :is(.\\!border-paleGray) {
    --tw-border-opacity: 1 !important;
    border-color: rgb(189 194 201/var(--tw-border-opacity)) !important
}

#premier-tech-calculator :is(.\\!border-secondaryBlue) {
    --tw-border-opacity: 1 !important;
    border-color: rgb(65 182 230/var(--tw-border-opacity)) !important
}

#premier-tech-calculator :is(.\\!border-transparent) {
    border-color: transparent !important
}

#premier-tech-calculator :is(.border-darkGray) {
    --tw-border-opacity: 1;
    border-color: rgb(138 141 143/var(--tw-border-opacity))
}

#premier-tech-calculator :is(.border-secondaryBlue) {
    --tw-border-opacity: 1;
    border-color: rgb(65 182 230/var(--tw-border-opacity))
}

#premier-tech-calculator :is(.border-tertiaryBlue) {
    --tw-border-opacity: 1;
    border-color: rgb(0 119 200/var(--tw-border-opacity))
}

#premier-tech-calculator :is(.border-b-error) {
    --tw-border-opacity: 1;
    border-bottom-color: rgb(233 52 63/var(--tw-border-opacity))
}

#premier-tech-calculator :is(.border-b-paleGray) {
    --tw-border-opacity: 1;
    border-bottom-color: rgb(189 194 201/var(--tw-border-opacity))
}

#premier-tech-calculator :is(.bg-darkGray-300) {
    --tw-bg-opacity: 1;
    background-color: rgb(180 182 183/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-error-50) {
    --tw-bg-opacity: 1;
    background-color: rgb(255 227 229/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-green-200) {
    --tw-bg-opacity: 1;
    background-color: rgb(187 247 208/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-lightBlue) {
    --tw-bg-opacity: 1;
    background-color: rgb(223 245 254/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-lightBlue-500) {
    --tw-bg-opacity: 1;
    background-color: rgb(223 245 254/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-lightGray) {
    --tw-bg-opacity: 1;
    background-color: rgb(242 246 248/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-lightGray\\/80) {
    background-color: rgba(242, 246, 248, .8)
}

#premier-tech-calculator :is(.bg-mainBlue) {
    --tw-bg-opacity: 1;
    background-color: rgb(4 30 66/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-paleGray-500) {
    --tw-bg-opacity: 1;
    background-color: rgb(189 194 201/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-secondaryBlue) {
    --tw-bg-opacity: 1;
    background-color: rgb(65 182 230/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-secondaryBlue-600) {
    --tw-bg-opacity: 1;
    background-color: rgb(28 158 211/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-tertiaryBlue) {
    --tw-bg-opacity: 1;
    background-color: rgb(0 119 200/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.bg-transparent) {
    background-color: initial
}

#premier-tech-calculator :is(.bg-white) {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.stroke-error) {
    stroke: #e9343f
}

#premier-tech-calculator :is(.\\!p-0) {
    padding: 0 !important
}

#premier-tech-calculator :is(.\\!p-4) {
    padding: 16px !important
}

#premier-tech-calculator :is(.p-1) {
    padding: 4px
}

#premier-tech-calculator :is(.p-2) {
    padding: 8px
}

#premier-tech-calculator :is(.p-3) {
    padding: 12px
}

#premier-tech-calculator :is(.p-4) {
    padding: 16px
}

#premier-tech-calculator :is(.p-7) {
    padding: 28px
}

#premier-tech-calculator :is(.\\!px-2) {
    padding-left: 8px !important;
    padding-right: 8px !important
}

#premier-tech-calculator :is(.\\!px-3) {
    padding-left: 12px !important;
    padding-right: 12px !important
}

#premier-tech-calculator :is(.\\!px-4) {
    padding-left: 16px !important;
    padding-right: 16px !important
}

#premier-tech-calculator :is(.\\!px-6) {
    padding-left: 24px !important;
    padding-right: 24px !important
}

#premier-tech-calculator :is(.\\!px-8) {
    padding-left: 32px !important;
    padding-right: 32px !important
}

#premier-tech-calculator :is(.\\!py-0) {
    padding-bottom: 0 !important;
    padding-top: 0 !important
}

#premier-tech-calculator :is(.\\!py-0\\.5) {
    padding-bottom: 2px !important;
    padding-top: 2px !important
}

#premier-tech-calculator :is(.\\!py-1) {
    padding-bottom: 4px !important;
    padding-top: 4px !important
}

#premier-tech-calculator :is(.\\!py-1\\.5) {
    padding-bottom: 6px !important;
    padding-top: 6px !important
}

#premier-tech-calculator :is(.\\!py-12) {
    padding-bottom: 48px !important;
    padding-top: 48px !important
}

#premier-tech-calculator :is(.\\!py-2) {
    padding-bottom: 8px !important;
    padding-top: 8px !important
}

#premier-tech-calculator :is(.\\!py-5) {
    padding-bottom: 20px !important;
    padding-top: 20px !important
}

#premier-tech-calculator :is(.\\!py-8) {
    padding-bottom: 32px !important;
    padding-top: 32px !important
}

#premier-tech-calculator :is(.px-4) {
    padding-left: 16px;
    padding-right: 16px
}

#premier-tech-calculator :is(.px-6) {
    padding-left: 24px;
    padding-right: 24px
}

#premier-tech-calculator :is(.py-2) {
    padding-bottom: 8px;
    padding-top: 8px
}

#premier-tech-calculator :is(.py-4) {
    padding-bottom: 16px;
    padding-top: 16px
}

#premier-tech-calculator :is(.\\!pb-4) {
    padding-bottom: 16px !important
}

#premier-tech-calculator :is(.\\!pl-4) {
    padding-left: 16px !important
}

#premier-tech-calculator :is(.\\!pr-3) {
    padding-right: 12px !important
}

#premier-tech-calculator :is(.pl-1) {
    padding-left: 4px
}

#premier-tech-calculator :is(.pl-1\\.5) {
    padding-left: 6px
}

#premier-tech-calculator :is(.text-center) {
    text-align: center
}

#premier-tech-calculator :is(.font-sans) {
    font-family: Axiforma, ui-sans-serif, system-ui
}

#premier-tech-calculator :is(.text-4xl) {
    font-size: 36px
}

#premier-tech-calculator :is(.text-base) {
    font-size: 16px
}

#premier-tech-calculator :is(.text-lg) {
    font-size: 18px
}

#premier-tech-calculator :is(.text-sm) {
    font-size: 14px
}

#premier-tech-calculator :is(.text-xl) {
    font-size: 20px
}

#premier-tech-calculator :is(.text-xs) {
    font-size: 12px
}

#premier-tech-calculator :is(.font-bold) {
    font-weight: 700
}

#premier-tech-calculator :is(.font-extrabold) {
    font-weight: 800
}

#premier-tech-calculator :is(.font-normal) {
    font-weight: 400
}

#premier-tech-calculator :is(.font-thin) {
    font-weight: 100
}

#premier-tech-calculator :is(.uppercase) {
    text-transform: uppercase
}

#premier-tech-calculator :is(.lowercase) {
    text-transform: lowercase
}

#premier-tech-calculator :is(.capitalize) {
    text-transform: capitalize
}

#premier-tech-calculator :is(.leading-\\[18px\\]) {
    line-height: 18px
}

#premier-tech-calculator :is(.text-darkGray) {
    --tw-text-opacity: 1;
    color: rgb(138 141 143/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.text-darkGray-300) {
    --tw-text-opacity: 1;
    color: rgb(180 182 183/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.text-error) {
    --tw-text-opacity: 1;
    color: rgb(233 52 63 / var(--tw-text-opacity))
}

#premier-tech-calculator :is(.text-mainBlue) {
    --tw-text-opacity: 1;
    color: rgb(4 30 66/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.text-secondaryBlue) {
    --tw-text-opacity: 1;
    color: rgb(65 182 230/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.text-sky-800) {
    --tw-text-opacity: 1;
    color: rgb(7 89 133/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.text-tertiaryBlue) {
    --tw-text-opacity: 1;
    color: rgb(0 119 200/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.text-transparent) {
    color: transparent
}

#premier-tech-calculator :is(.text-white) {
    --tw-text-opacity: 1;
    color: rgb(255 255 255/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.opacity-50) {
    opacity: .5
}

#premier-tech-calculator :is(.shadow-md) {
    --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -2px rgba(0, 0, 0, .1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

#premier-tech-calculator :is(.shadow-xl) {
    --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, .1), 0 8px 10px -6px rgba(0, 0, 0, .1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

#premier-tech-calculator :is(.outline) {
    outline-style: solid
}

#premier-tech-calculator :is(.ring-2) {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)
}

#premier-tech-calculator :is(.ring-sky-300) {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(125 211 252/var(--tw-ring-opacity))
}

#premier-tech-calculator :is(.backdrop-blur-sm) {
    --tw-backdrop-blur: blur(4px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)
}

#premier-tech-calculator :is(.transition-all) {
    transition-duration: .15s;
    transition-property: all;
    transition-timing-function: cubic-bezier(.4, 0, .2, 1)
}

@font-face {
    font-display: swap;
    font-family: Axiforma;
    font-style: normal;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype")
}

@font-face {
    font-display: swap;
    font-family: Axiforma;
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype")
}

#premier-tech-calculator {
    font-size: 16px !important
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    opacity: 0
}

input[type=number] {
    -moz-appearance: textfield
}

.arrow-up:after {
    border-bottom: 5px solid #fff;
    left: 30px;
    top: -5px
}

.arrow-down:after,
.arrow-up:after {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    content: "";
    height: 0;
    position: absolute;
    width: 0
}

.arrow-down:after {
    border-top: 5px solid #fff;
    left: 25px;
    top: 20px
}

@media (min-width: 768px) {
    .arrow-up:after {
        border-bottom: 10px solid #fff;
        left: 35px;
        top: -10px
    }

    .arrow-down:after,
    .arrow-up:after {
        border-left: 10px solid transparent;
        border-right: 10px solid transparent
    }

    .arrow-down:after {
        border-top: 10px solid #fff;
        left: 30px;
        top: 35px
    }
}

.select-arrow:after {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) 50% no-repeat;
    content: "";
    height: 6px;
    position: absolute;
    right: 0;
    top: 11px;
    width: 12px
}

.result-row>span>span {
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    margin-left: 2px
}

.shine-animate {
    animation: shine 1.5s ease-in-out 1
}

@keyframes shine {
    0% {
        filter: brightness(1)
    }

    25% {
        filter: brightness(1.2)
    }

    50% {
        filter: brightness(.9)
    }

    75% {
        filter: brightness(1.25)
    }

    to {
        filter: brightness(1)
    }
}

input[type=range]::-webkit-slider-thumb {
    --tw-border-opacity: 1;
    --tw-bg-opacity: 1;
    -webkit-appearance: none;
    appearance: none;
    background-color: rgb(223 245 254/var(--tw-bg-opacity));
    border-color: rgb(65 182 230/var(--tw-border-opacity));
    border-radius: 9999px;
    border-style: solid;
    border-width: 4px;
    height: 24px;
    width: 24px
}

input[type=range]::-moz-range-thumb {
    --tw-border-opacity: 1;
    --tw-bg-opacity: 1;
    background-color: rgb(223 245 254/var(--tw-bg-opacity));
    border-color: rgb(65 182 230/var(--tw-border-opacity));
    border-radius: 9999px;
    border-style: solid;
    border-width: 4px;
    height: 24px;
    width: 24px
}

.rc-input-number input {
    -webkit-appearance: none;
    -moz-appearance: none;
         appearance: none;
    background-color: initial;
    padding: 8px 16px;
    width: 100%
}

@media not all and (min-width: 768px) {
    .view3d__container canvas {
        height: 100% !important;
        width: auto !important
    }
}

#premier-tech-calculator :is(.invalid\\:border-error:invalid) {
    --tw-border-opacity: 1;
    border-color: rgb(233 52 63/var(--tw-border-opacity))
}

#premier-tech-calculator :is(.hover\\:\\!border-sky-300:hover) {
    --tw-border-opacity: 1 !important;
    border-color: rgb(125 211 252/var(--tw-border-opacity)) !important
}

#premier-tech-calculator :is(.hover\\:bg-mainBlue:hover) {
    --tw-bg-opacity: 1;
    background-color: rgb(4 30 66/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.hover\\:bg-secondaryBlue:hover) {
    --tw-bg-opacity: 1;
    background-color: rgb(65 182 230/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.hover\\:bg-secondaryBlue-600:hover) {
    --tw-bg-opacity: 1;
    background-color: rgb(28 158 211/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.hover\\:text-white:hover) {
    --tw-text-opacity: 1;
    color: rgb(255 255 255/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.disabled\\:\\!border-paleGray:disabled) {
    --tw-border-opacity: 1 !important;
    border-color: rgb(189 194 201/var(--tw-border-opacity)) !important
}

#premier-tech-calculator :is(.disabled\\:\\!border-paleGray-400:disabled) {
    --tw-border-opacity: 1 !important;
    border-color: rgb(211 215 219/var(--tw-border-opacity)) !important
}

#premier-tech-calculator :is(.disabled\\:bg-paleGray-300:disabled) {
    --tw-bg-opacity: 1;
    background-color: rgb(234 235 238/var(--tw-bg-opacity))
}

#premier-tech-calculator :is(.disabled\\:text-darkGray:disabled) {
    --tw-text-opacity: 1;
    color: rgb(138 141 143/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.disabled\\:text-paleGray:disabled) {
    --tw-text-opacity: 1;
    color: rgb(189 194 201/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.disabled\\:text-paleGray-500:disabled) {
    --tw-text-opacity: 1;
    color: rgb(189 194 201/var(--tw-text-opacity))
}

#premier-tech-calculator :is(.disabled\\:shadow-none:disabled) {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

@media (min-width: 640px) {
    #premier-tech-calculator :is(.sm\\:col-span-1) {
        grid-column: span 1/span 1
    }

    #premier-tech-calculator :is(.sm\\:\\!my-5) {
        margin-bottom: 20px !important;
        margin-top: 20px !important
    }

    #premier-tech-calculator :is(.sm\\:ml-\\[-400px\\]) {
        margin-left: -400px
    }

    #premier-tech-calculator :is(.sm\\:ml-\\[400px\\]) {
        margin-left: 400px
    }

    #premier-tech-calculator :is(.sm\\:mt-\\[150px\\]) {
        margin-top: 150px
    }

    #premier-tech-calculator :is(.sm\\:mt-\\[300px\\]) {
        margin-top: 300px
    }

    #premier-tech-calculator :is(.sm\\:\\!flex) {
        display: flex !important
    }

    #premier-tech-calculator :is(.sm\\:flex) {
        display: flex
    }

    #premier-tech-calculator :is(.sm\\:grid-cols-2) {
        grid-template-columns: repeat(2, minmax(0, 1fr))
    }

    #premier-tech-calculator :is(.sm\\:grid-cols-3) {
        grid-template-columns: repeat(3, minmax(0, 1fr))
    }

    #premier-tech-calculator :is(.sm\\:gap-x-4) {
        -moz-column-gap: 16px;
             column-gap: 16px
    }

    #premier-tech-calculator :is(.sm\\:text-sm) {
        font-size: 14px
    }
}

@media (min-width: 768px) {
    #premier-tech-calculator :is(.md\\:\\!my-0) {
        margin-bottom: 0 !important;
        margin-top: 0 !important
    }

    #premier-tech-calculator :is(.md\\:\\!my-8) {
        margin-bottom: 32px !important;
        margin-top: 32px !important
    }

    #premier-tech-calculator :is(.md\\:my-0) {
        margin-bottom: 0;
        margin-top: 0
    }

    #premier-tech-calculator :is(.md\\:\\!mb-0) {
        margin-bottom: 0 !important
    }

    #premier-tech-calculator :is(.md\\:\\!mb-24) {
        margin-bottom: 96px !important
    }

    #premier-tech-calculator :is(.md\\:\\!mr-6) {
        margin-right: 24px !important
    }

    #premier-tech-calculator :is(.md\\:ml-\\[-260px\\]) {
        margin-left: -260px
    }

    #premier-tech-calculator :is(.md\\:ml-\\[260px\\]) {
        margin-left: 260px
    }

    #premier-tech-calculator :is(.md\\:mt-24) {
        margin-top: 96px
    }

    #premier-tech-calculator :is(.md\\:mt-\\[230px\\]) {
        margin-top: 230px
    }

    #premier-tech-calculator :is(.md\\:mt-\\[75px\\]) {
        margin-top: 75px
    }

    #premier-tech-calculator :is(.md\\:flex) {
        display: flex
    }

    #premier-tech-calculator :is(.md\\:h-\\[720px\\]) {
        height: 720px
    }

    #premier-tech-calculator :is(.md\\:\\!w-auto) {
        width: auto !important
    }

    #premier-tech-calculator :is(.md\\:w-2\\/5) {
        width: 40%
    }

    #premier-tech-calculator :is(.md\\:w-3\\/5) {
        width: 60%
    }

    #premier-tech-calculator :is(.md\\:grid-cols-1) {
        grid-template-columns: repeat(1, minmax(0, 1fr))
    }

    #premier-tech-calculator :is(.md\\:grid-cols-3) {
        grid-template-columns: repeat(3, minmax(0, 1fr))
    }

    #premier-tech-calculator :is(.md\\:gap-12) {
        gap: 48px
    }

    #premier-tech-calculator :is(.md\\:gap-6) {
        gap: 24px
    }

    #premier-tech-calculator :is(.md\\:\\!p-0) {
        padding: 0 !important
    }

    #premier-tech-calculator :is(.md\\:\\!px-4) {
        padding-left: 16px !important;
        padding-right: 16px !important
    }

    #premier-tech-calculator :is(.md\\:\\!px-6) {
        padding-left: 24px !important;
        padding-right: 24px !important
    }

    #premier-tech-calculator :is(.md\\:\\!px-8) {
        padding-left: 32px !important;
        padding-right: 32px !important
    }

    #premier-tech-calculator :is(.md\\:\\!py-2) {
        padding-bottom: 8px !important;
        padding-top: 8px !important
    }

    #premier-tech-calculator :is(.md\\:\\!py-44) {
        padding-bottom: 176px !important;
        padding-top: 176px !important
    }

    #premier-tech-calculator :is(.md\\:text-sm) {
        font-size: 14px
    }
}

@media (min-width: 1024px) {
    #premier-tech-calculator :is(.lg\\:\\!mt-0) {
        margin-top: 0 !important
    }

    #premier-tech-calculator :is(.lg\\:ml-\\[-310px\\]) {
        margin-left: -310px
    }

    #premier-tech-calculator :is(.lg\\:ml-\\[310px\\]) {
        margin-left: 310px
    }

    #premier-tech-calculator :is(.lg\\:mt-\\[150px\\]) {
        margin-top: 150px
    }

    #premier-tech-calculator :is(.lg\\:mt-\\[280px\\]) {
        margin-top: 280px
    }

    #premier-tech-calculator :is(.lg\\:inline-block) {
        display: inline-block
    }

    #premier-tech-calculator :is(.lg\\:flex) {
        display: flex
    }

    #premier-tech-calculator :is(.lg\\:min-h-\\[720px\\]) {
        min-height: 720px
    }

    #premier-tech-calculator :is(.lg\\:w-5\\/12) {
        width: 41.666667%
    }

    #premier-tech-calculator :is(.lg\\:w-7\\/12) {
        width: 58.333333%
    }

    #premier-tech-calculator :is(.lg\\:basis-\\[155px\\]) {
        flex-basis: 155px
    }

    #premier-tech-calculator :is(.lg\\:-translate-y-8) {
        --tw-translate-y: -32px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
    }

    #premier-tech-calculator :is(.lg\\:grid-cols-2) {
        grid-template-columns: repeat(2, minmax(0, 1fr))
    }

    #premier-tech-calculator :is(.lg\\:grid-cols-4) {
        grid-template-columns: repeat(4, minmax(0, 1fr))
    }

    #premier-tech-calculator :is(.lg\\:flex-row) {
        flex-direction: row
    }

    #premier-tech-calculator :is(.lg\\:items-start) {
        align-items: flex-start
    }

    #premier-tech-calculator :is(.lg\\:text-lg) {
        font-size: 18px
    }
}

@media (min-width: 1280px) {
    #premier-tech-calculator :is(.xl\\:\\!px-0) {
        padding-left: 0 !important;
        padding-right: 0 !important
    }
}

#premier-tech-calculator :is(.\\[\\&\\>svg\\>path\\:nth-child\\(1\\)\\]\\:stroke-error>svg>path:first-child) {
    stroke: #e9343f
}

#premier-tech-calculator :is(.\\[\\&\\>svg\\>path\\:nth-child\\(2\\)\\]\\:stroke-error>svg>path:nth-child(2)) {
    stroke: #e9343f
}

#premier-tech-calculator :is(.\\[\\&\\>svg\\>path\\:nth-child\\(3\\)\\]\\:stroke-error>svg>path:nth-child(3)) {
    stroke: #e9343f
}

#premier-tech-calculator :is(.\\[\\&\\>svg\\>path\\:nth-child\\(4\\)\\]\\:stroke-error>svg>path:nth-child(4)) {
    stroke: #e9343f
}

.ui-widget {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1em;
}

.ui-widget .ui-widget {
    font-size: 1em;
}

.ui-widget input,
.ui-widget select,
.ui-widget textarea,
.ui-widget button {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1em;
}

.ui-widget.ui-widget-content {
    border: 1px solid #c5c5c5;
}

.ui-widget-content {
    border: 1px solid #dddddd;
    background: #ffffff;
    color: #333333;
}

.ui-widget-content a {
    color: #333333;
}

.ui-widget-header {
    border: 1px solid #dddddd;
    background: #e9e9e9;
    color: #333333;
    font-weight: bold;
}

.ui-widget-header a {
    color: #333333;
}

.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default,
.ui-button,
html .ui-button.ui-state-disabled:hover,
html .ui-button.ui-state-disabled:active {
    border: 1px solid #c5c5c5;
    background: #f6f6f6;
    font-weight: normal;
    color: #454545;
}

.ui-state-default a,
.ui-state-default a:link,
.ui-state-default a:visited,
a.ui-button,
a:link.ui-button,
a:visited.ui-button,
.ui-button {
    color: #454545;
    text-decoration: none;
}

.ui-state-hover,
.ui-widget-content .ui-state-hover,
.ui-widget-header .ui-state-hover,
.ui-state-focus,
.ui-widget-content .ui-state-focus,
.ui-widget-header .ui-state-focus,
.ui-button:hover,
.ui-button:focus {
    border: 1px solid #cccccc;
    background: #ededed;
    font-weight: normal;
    color: #2b2b2b;
}

.ui-state-hover a,
.ui-state-hover a:hover,
.ui-state-hover a:link,
.ui-state-hover a:visited,
.ui-state-focus a,
.ui-state-focus a:hover,
.ui-state-focus a:link,
.ui-state-focus a:visited,
a.ui-button:hover,
a.ui-button:focus {
    color: #2b2b2b;
    text-decoration: none;
}

.ui-visual-focus {
    box-shadow: 0 0 3px 1px rgb(94, 158, 214);
}

.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active,
a.ui-button:active,
.ui-button:active,
.ui-button.ui-state-active:hover {
    border: 1px solid #003eff;
    background: #007fff;
    font-weight: normal;
    color: #ffffff;
}

.ui-icon-background,
.ui-state-active .ui-icon-background {
    border: #003eff;
    background-color: #ffffff;
}

.ui-state-active a,
.ui-state-active a:link,
.ui-state-active a:visited {
    color: #ffffff;
    text-decoration: none;
}

.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
    border: 1px solid #dad55e;
    background: #fffa90;
    color: #777620;
}

.ui-state-checked {
    border: 1px solid #dad55e;
    background: #fffa90;
}

.ui-state-highlight a,
.ui-widget-content .ui-state-highlight a,
.ui-widget-header .ui-state-highlight a {
    color: #777620;
}

.ui-state-error,
.ui-widget-content .ui-state-error,
.ui-widget-header .ui-state-error {
    border: 1px solid #f1a899;
    background: #fddfdf;
    color: #5f3f3f;
}

.ui-state-error a,
.ui-widget-content .ui-state-error a,
.ui-widget-header .ui-state-error a {
    color: #5f3f3f;
}

.ui-state-error-text,
.ui-widget-content .ui-state-error-text,
.ui-widget-header .ui-state-error-text {
    color: #5f3f3f;
}

.ui-priority-primary,
.ui-widget-content .ui-priority-primary,
.ui-widget-header .ui-priority-primary {
    font-weight: bold;
}

.ui-priority-secondary,
.ui-widget-content .ui-priority-secondary,
.ui-widget-header .ui-priority-secondary {
    opacity: .7;
    -ms-filter: "alpha(opacity=70)";
    font-weight: normal;
}

.ui-state-disabled,
.ui-widget-content .ui-state-disabled,
.ui-widget-header .ui-state-disabled {
    opacity: .35;
    -ms-filter: "alpha(opacity=35)";
    background-image: none;
}

.ui-state-disabled .ui-icon {
    -ms-filter: "alpha(opacity=35)";
}

.ui-icon {
    width: 16px;
    height: 16px;
}

/* 
.ui-icon,
.ui-widget-content .ui-icon {
    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_444444_256x240.png);
}

.ui-widget-header .ui-icon {
    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_444444_256x240.png);
} */
/* 
.ui-state-hover .ui-icon,
.ui-state-focus .ui-icon,
.ui-button:hover .ui-icon,
.ui-button:focus .ui-icon {
    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_555555_256x240.png);
}

.ui-state-active .ui-icon,
.ui-button:active .ui-icon {
    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_ffffff_256x240.png);
}

.ui-state-highlight .ui-icon,
.ui-button .ui-state-highlight.ui-icon {
    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_777620_256x240.png);
}

.ui-state-error .ui-icon,
.ui-state-error-text .ui-icon {
    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_cc0000_256x240.png);
}

.ui-button .ui-icon {
    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_777777_256x240.png);
} */

.ui-icon-blank.ui-icon-blank.ui-icon-blank {
    background-image: none;
}

.ui-icon-caret-1-n {
    background-position: 0 0;
}

.ui-icon-caret-1-ne {
    background-position: -16px 0;
}

.ui-icon-caret-1-e {
    background-position: -32px 0;
}

.ui-icon-caret-1-se {
    background-position: -48px 0;
}

.ui-icon-caret-1-s {
    background-position: -65px 0;
}

.ui-icon-caret-1-sw {
    background-position: -80px 0;
}

.ui-icon-caret-1-w {
    background-position: -96px 0;
}

.ui-icon-caret-1-nw {
    background-position: -112px 0;
}

.ui-icon-caret-2-n-s {
    background-position: -128px 0;
}

.ui-icon-caret-2-e-w {
    background-position: -144px 0;
}

.ui-icon-triangle-1-n {
    background-position: 0 -16px;
}

.ui-icon-triangle-1-ne {
    background-position: -16px -16px;
}

.ui-icon-triangle-1-e {
    background-position: -32px -16px;
}

.ui-icon-triangle-1-se {
    background-position: -48px -16px;
}

.ui-icon-triangle-1-s {
    background-position: -65px -16px;
}

.ui-icon-triangle-1-sw {
    background-position: -80px -16px;
}

.ui-icon-triangle-1-w {
    background-position: -96px -16px;
}

.ui-icon-triangle-1-nw {
    background-position: -112px -16px;
}

.ui-icon-triangle-2-n-s {
    background-position: -128px -16px;
}

.ui-icon-triangle-2-e-w {
    background-position: -144px -16px;
}

.ui-icon-arrow-1-n {
    background-position: 0 -32px;
}

.ui-icon-arrow-1-ne {
    background-position: -16px -32px;
}

.ui-icon-arrow-1-e {
    background-position: -32px -32px;
}

.ui-icon-arrow-1-se {
    background-position: -48px -32px;
}

.ui-icon-arrow-1-s {
    background-position: -65px -32px;
}

.ui-icon-arrow-1-sw {
    background-position: -80px -32px;
}

.ui-icon-arrow-1-w {
    background-position: -96px -32px;
}

.ui-icon-arrow-1-nw {
    background-position: -112px -32px;
}

.ui-icon-arrow-2-n-s {
    background-position: -128px -32px;
}

.ui-icon-arrow-2-ne-sw {
    background-position: -144px -32px;
}

.ui-icon-arrow-2-e-w {
    background-position: -160px -32px;
}

.ui-icon-arrow-2-se-nw {
    background-position: -176px -32px;
}

.ui-icon-arrowstop-1-n {
    background-position: -192px -32px;
}

.ui-icon-arrowstop-1-e {
    background-position: -208px -32px;
}

.ui-icon-arrowstop-1-s {
    background-position: -224px -32px;
}

.ui-icon-arrowstop-1-w {
    background-position: -240px -32px;
}

.ui-icon-arrowthick-1-n {
    background-position: 1px -48px;
}

.ui-icon-arrowthick-1-ne {
    background-position: -16px -48px;
}

.ui-icon-arrowthick-1-e {
    background-position: -32px -48px;
}

.ui-icon-arrowthick-1-se {
    background-position: -48px -48px;
}

.ui-icon-arrowthick-1-s {
    background-position: -64px -48px;
}

.ui-icon-arrowthick-1-sw {
    background-position: -80px -48px;
}

.ui-icon-arrowthick-1-w {
    background-position: -96px -48px;
}

.ui-icon-arrowthick-1-nw {
    background-position: -112px -48px;
}

.ui-icon-arrowthick-2-n-s {
    background-position: -128px -48px;
}

.ui-icon-arrowthick-2-ne-sw {
    background-position: -144px -48px;
}

.ui-icon-arrowthick-2-e-w {
    background-position: -160px -48px;
}

.ui-icon-arrowthick-2-se-nw {
    background-position: -176px -48px;
}

.ui-icon-arrowthickstop-1-n {
    background-position: -192px -48px;
}

.ui-icon-arrowthickstop-1-e {
    background-position: -208px -48px;
}

.ui-icon-arrowthickstop-1-s {
    background-position: -224px -48px;
}

.ui-icon-arrowthickstop-1-w {
    background-position: -240px -48px;
}

.ui-icon-arrowreturnthick-1-w {
    background-position: 0 -64px;
}

.ui-icon-arrowreturnthick-1-n {
    background-position: -16px -64px;
}

.ui-icon-arrowreturnthick-1-e {
    background-position: -32px -64px;
}

.ui-icon-arrowreturnthick-1-s {
    background-position: -48px -64px;
}

.ui-icon-arrowreturn-1-w {
    background-position: -64px -64px;
}

.ui-icon-arrowreturn-1-n {
    background-position: -80px -64px;
}

.ui-icon-arrowreturn-1-e {
    background-position: -96px -64px;
}

.ui-icon-arrowreturn-1-s {
    background-position: -112px -64px;
}

.ui-icon-arrowrefresh-1-w {
    background-position: -128px -64px;
}

.ui-icon-arrowrefresh-1-n {
    background-position: -144px -64px;
}

.ui-icon-arrowrefresh-1-e {
    background-position: -160px -64px;
}

.ui-icon-arrowrefresh-1-s {
    background-position: -176px -64px;
}

.ui-icon-arrow-4 {
    background-position: 0 -80px;
}

.ui-icon-arrow-4-diag {
    background-position: -16px -80px;
}

.ui-icon-extlink {
    background-position: -32px -80px;
}

.ui-icon-newwin {
    background-position: -48px -80px;
}

.ui-icon-refresh {
    background-position: -64px -80px;
}

.ui-icon-shuffle {
    background-position: -80px -80px;
}

.ui-icon-transfer-e-w {
    background-position: -96px -80px;
}

.ui-icon-transferthick-e-w {
    background-position: -112px -80px;
}

.ui-icon-folder-collapsed {
    background-position: 0 -96px;
}

.ui-icon-folder-open {
    background-position: -16px -96px;
}

.ui-icon-document {
    background-position: -32px -96px;
}

.ui-icon-document-b {
    background-position: -48px -96px;
}

.ui-icon-note {
    background-position: -64px -96px;
}

.ui-icon-mail-closed {
    background-position: -80px -96px;
}

.ui-icon-mail-open {
    background-position: -96px -96px;
}

.ui-icon-suitcase {
    background-position: -112px -96px;
}

.ui-icon-comment {
    background-position: -128px -96px;
}

.ui-icon-person {
    background-position: -144px -96px;
}

.ui-icon-print {
    background-position: -160px -96px;
}

.ui-icon-trash {
    background-position: -176px -96px;
}

.ui-icon-locked {
    background-position: -192px -96px;
}

.ui-icon-unlocked {
    background-position: -208px -96px;
}

.ui-icon-bookmark {
    background-position: -224px -96px;
}

.ui-icon-tag {
    background-position: -240px -96px;
}

.ui-icon-home {
    background-position: 0 -112px;
}

.ui-icon-flag {
    background-position: -16px -112px;
}

.ui-icon-calendar {
    background-position: -32px -112px;
}

.ui-icon-cart {
    background-position: -48px -112px;
}

.ui-icon-pencil {
    background-position: -64px -112px;
}

.ui-icon-clock {
    background-position: -80px -112px;
}

.ui-icon-disk {
    background-position: -96px -112px;
}

.ui-icon-calculator {
    background-position: -112px -112px;
}

.ui-icon-zoomin {
    background-position: -128px -112px;
}

.ui-icon-zoomout {
    background-position: -144px -112px;
}

.ui-icon-search {
    background-position: -160px -112px;
}

.ui-icon-wrench {
    background-position: -176px -112px;
}

.ui-icon-gear {
    background-position: -192px -112px;
}

.ui-icon-heart {
    background-position: -208px -112px;
}

.ui-icon-star {
    background-position: -224px -112px;
}

.ui-icon-link {
    background-position: -240px -112px;
}

.ui-icon-cancel {
    background-position: 0 -128px;
}

.ui-icon-plus {
    background-position: -16px -128px;
}

.ui-icon-plusthick {
    background-position: -32px -128px;
}

.ui-icon-minus {
    background-position: -48px -128px;
}

.ui-icon-minusthick {
    background-position: -64px -128px;
}

.ui-icon-close {
    background-position: -80px -128px;
}

.ui-icon-closethick {
    background-position: -96px -128px;
}

.ui-icon-key {
    background-position: -112px -128px;
}

.ui-icon-lightbulb {
    background-position: -128px -128px;
}

.ui-icon-scissors {
    background-position: -144px -128px;
}

.ui-icon-clipboard {
    background-position: -160px -128px;
}

.ui-icon-copy {
    background-position: -176px -128px;
}

.ui-icon-contact {
    background-position: -192px -128px;
}

.ui-icon-image {
    background-position: -208px -128px;
}

.ui-icon-video {
    background-position: -224px -128px;
}

.ui-icon-script {
    background-position: -240px -128px;
}

.ui-icon-alert {
    background-position: 0 -144px;
}

.ui-icon-info {
    background-position: -16px -144px;
}

.ui-icon-notice {
    background-position: -32px -144px;
}

.ui-icon-help {
    background-position: -48px -144px;
}

.ui-icon-check {
    background-position: -64px -144px;
}

.ui-icon-bullet {
    background-position: -80px -144px;
}

.ui-icon-radio-on {
    background-position: -96px -144px;
}

.ui-icon-radio-off {
    background-position: -112px -144px;
}

.ui-icon-pin-w {
    background-position: -128px -144px;
}

.ui-icon-pin-s {
    background-position: -144px -144px;
}

.ui-icon-play {
    background-position: 0 -160px;
}

.ui-icon-pause {
    background-position: -16px -160px;
}

.ui-icon-seek-next {
    background-position: -32px -160px;
}

.ui-icon-seek-prev {
    background-position: -48px -160px;
}

.ui-icon-seek-end {
    background-position: -64px -160px;
}

.ui-icon-seek-start {
    background-position: -80px -160px;
}

.ui-icon-seek-first {
    background-position: -80px -160px;
}

.ui-icon-stop {
    background-position: -96px -160px;
}

.ui-icon-eject {
    background-position: -112px -160px;
}

.ui-icon-volume-off {
    background-position: -128px -160px;
}

.ui-icon-volume-on {
    background-position: -144px -160px;
}

.ui-icon-power {
    background-position: 0 -176px;
}

.ui-icon-signal-diag {
    background-position: -16px -176px;
}

.ui-icon-signal {
    background-position: -32px -176px;
}

.ui-icon-battery-0 {
    background-position: -48px -176px;
}

.ui-icon-battery-1 {
    background-position: -64px -176px;
}

.ui-icon-battery-2 {
    background-position: -80px -176px;
}

.ui-icon-battery-3 {
    background-position: -96px -176px;
}

.ui-icon-circle-plus {
    background-position: 0 -192px;
}

.ui-icon-circle-minus {
    background-position: -16px -192px;
}

.ui-icon-circle-close {
    background-position: -32px -192px;
}

.ui-icon-circle-triangle-e {
    background-position: -48px -192px;
}

.ui-icon-circle-triangle-s {
    background-position: -64px -192px;
}

.ui-icon-circle-triangle-w {
    background-position: -80px -192px;
}

.ui-icon-circle-triangle-n {
    background-position: -96px -192px;
}

.ui-icon-circle-arrow-e {
    background-position: -112px -192px;
}

.ui-icon-circle-arrow-s {
    background-position: -128px -192px;
}

.ui-icon-circle-arrow-w {
    background-position: -144px -192px;
}

.ui-icon-circle-arrow-n {
    background-position: -160px -192px;
}

.ui-icon-circle-zoomin {
    background-position: -176px -192px;
}

.ui-icon-circle-zoomout {
    background-position: -192px -192px;
}

.ui-icon-circle-check {
    background-position: -208px -192px;
}

.ui-icon-circlesmall-plus {
    background-position: 0 -208px;
}

.ui-icon-circlesmall-minus {
    background-position: -16px -208px;
}

.ui-icon-circlesmall-close {
    background-position: -32px -208px;
}

.ui-icon-squaresmall-plus {
    background-position: -48px -208px;
}

.ui-icon-squaresmall-minus {
    background-position: -64px -208px;
}

.ui-icon-squaresmall-close {
    background-position: -80px -208px;
}

.ui-icon-grip-dotted-vertical {
    background-position: 0 -224px;
}

.ui-icon-grip-dotted-horizontal {
    background-position: -16px -224px;
}

.ui-icon-grip-solid-vertical {
    background-position: -32px -224px;
}

.ui-icon-grip-solid-horizontal {
    background-position: -48px -224px;
}

.ui-icon-gripsmall-diagonal-se {
    background-position: -64px -224px;
}

.ui-icon-grip-diagonal-se {
    background-position: -80px -224px;
}

.ui-corner-all,
.ui-corner-top,
.ui-corner-left,
.ui-corner-tl {
    border-top-left-radius: 3px;
}

.ui-corner-all,
.ui-corner-top,
.ui-corner-right,
.ui-corner-tr {
    border-top-right-radius: 3px;
}

.ui-corner-all,
.ui-corner-bottom,
.ui-corner-left,
.ui-corner-bl {
    border-bottom-left-radius: 3px;
}

.ui-corner-all,
.ui-corner-bottom,
.ui-corner-right,
.ui-corner-br {
    border-bottom-right-radius: 3px;
}

.ui-widget-overlay {
    background: #aaaaaa;
    opacity: .3;
    -ms-filter: "alpha(opacity=30)";
}

.ui-widget-shadow {
    box-shadow: 0 0 5px #666666;
}

.theme-100 .pt-global-footer {
    background-color: #000000;
}

.pt-global-footer {
    position: relative;
    display: flex;
    background-color: #041e42;
    color: #fff;
    padding: 16px 21px;
    z-index: 1000;
}

.layout-builder-block .pt-global-footer {
    z-index: 499;
}

.pt-global-footer-logo {
    max-width: 200px
}

.pt-global-footer-logo a {
    display: flex;
    align-items: center
}

.pt-global-footer-logo a #pt-global-footer-logo-pt {
    width: 100%
}

.pt-global-footer-logo a #pt-global-footer-logo-secondaire {
    height: 42px;
    margin-left: 8px
}

.pt-global-footer-menu {
    padding: 0;
    margin: 0 0 0 126px;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
}

.pt-global-footer-menu-element {
    padding-right: 30px;
    display: flex;
    align-items: center;
}

.pt-global-footer-menu-link {
    color: #fff;
    text-decoration: none;
    transition: 0.3s color ease;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.02em;
}

span.pt-global-footer-menu-link {
    font-size: 14px !important;
}

.pt-global-footer-menu-link:hover {
    color: #41b6e6;
    text-decoration: none;
}

span.pt-global-footer-menu-link:hover {
    color: #41b6e6 !important;
    text-decoration: none;
}

.pt-global-footer-text {
    margin-left: auto;
}

@media screen and (max-width: 768px) {
    .pt-global-footer {
        flex-direction: column;
        padding: 0;
    }

    .pt-global-footer-menu {
        order: 0;
        margin: 0;
        border-bottom: 2px solid #364B68;
        padding: 16px 17px 0;
    }

    .pt-global-footer-menu-element {
        margin-bottom: 16px;
    }

    .pt-global-footer-logo {
        order: 1;
        margin: 0;
        max-width: 150px;
        padding: 10px 12px;
        flex: 0 0 auto;
    }

    .pt-global-footer-menu-link {
        font-size: 12px;
    }

    span.pt-global-footer-menu-link {
        font-size: 12px !important;
        margin-bottom: 0 !important;
    }
}

/* @license GPL-2.0-or-later https://www.drupal.org/licensing/faq */
:root {
    --secondary-font: Axiforma;
    --link-decoration: none;
    --link-color: #0077C8;
    --link-hover-color: #0060A1;
    --btn-txt-color: #041E42;
    --text-color: #041E42
}

.webform-confirmation-modal--content,
.wysiwyg {
    --link-decoration: underline
}

:root {
    --color-light-blue: hsl(197.4545454545deg, 76.7441860465%, 57.8431372549%);
    --color-light-blue-h: 197.4545454545deg;
    --color-light-blue-s: 76.7441860465%;
    --color-light-blue-l: 57.8431372549%;
    --color-dark-blue: hsl(214.8387096774deg, 88.5714285714%, 13.7254901961%);
    --color-dark-blue-h: 214.8387096774deg;
    --color-dark-blue-s: 88.5714285714%;
    --color-dark-blue-l: 13.7254901961%;
    --color-white: #FFFFFF;
    --color-other-light-blue: #41B6E6
}

.fill-light-blue-var {
    fill: var(--color-light-blue)
}

.pt-fill-blue-primary {
    fill: #041e42
}

.pt-fill-white-secondary {
    fill: #fff
}

.pt-fill-light-blue-secondary {
    fill: #41b6e6
}

.pt-fill-grey-secondary {
    fill: #8a8d8f
}

.pt-fill-light-blue-tertiary {
    fill: #0077c8
}

.pt-fill-blue-tertiary {
    fill: #04325e
}

.pt-fill-grey-tertiary {
    fill: #54585a
}

.pt-fill-white-tertiary {
    fill: #f2f6f8
}

.liveline-fill-primary {
    fill: #1791f9
}

.liveline-fill-secondary {
    fill: #4ffafe
}

.pt-fill-green {
    fill: #00a84f
}

.pt-fill-red {
    fill: #e21b23
}

.pt-fill-orange {
    fill: #f05c22
}

.pt-fill-yellow {
    fill: #fcba30
}

.pt-fill-black {
    fill: #000
}

:root {
    --blue: #007bff;
    --indigo: #6610f2;
    --purple: #6f42c1;
    --pink: #e83e8c;
    --red: #dc3545;
    --orange: #fd7e14;
    --yellow: #ffc107;
    --green: #28a745;
    --teal: #20c997;
    --cyan: #17a2b8;
    --white: #fff;
    --gray: #6c757d;
    --gray-dark: #343a40;
    --primary: #007bff;
    --secondary: #6c757d;
    --success: #28a745;
    --info: #17a2b8;
    --warning: #ffc107;
    --danger: #dc3545;
    --light: #f8f9fa;
    --dark: #343a40;
    --breakpoint-xs: 0;
    --breakpoint-sm: 576px;
    --breakpoint-md: 768px;
    --breakpoint-lg: 992px;
    --breakpoint-xl: 1200px;
    --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace
}

*,
::after,
::before {
    box-sizing: border-box
}

html {
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent
}

article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
    display: block
}

body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff
}

[tabindex="-1"]:focus:not(:focus-visible) {
    outline: 0 !important
}

hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin-top: 0;
    margin-bottom: .8rem
}

p {
    margin-top: 0;
    margin-bottom: 1.6rem
}

abbr[data-original-title],
abbr[title] {
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
            text-decoration: underline dotted;
    cursor: help;
    border-bottom: 0;
    -webkit-text-decoration-skip-ink: none;
            text-decoration-skip-ink: none
}

address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit
}

dl,
ol,
ul {
    margin-top: 0;
    margin-bottom: 1rem
}

ol ol,
ol ul,
ul ol,
ul ul {
    margin-bottom: 0
}

dt {
    font-weight: 700
}

dd {
    margin-bottom: .5rem;
    margin-left: 0
}

blockquote {
    margin: 0 0 1rem
}

b,
strong {
    font-weight: bolder
}

small {
    font-size: 80%
}

sub,
sup {
    position: relative;
    font-size: 75%;
    line-height: 0;
    vertical-align: baseline
}

sub {
    bottom: -.25em
}

sup {
    top: -.5em
}

a {
    color: var(--link-color);
    -webkit-text-decoration: var(--link-decoration);
            text-decoration: var(--link-decoration);
    background-color: transparent
}

a:hover {
    color: var(--link-hover-color);
    -webkit-text-decoration: var(--link-decoration);
            text-decoration: var(--link-decoration)
}

a:not([href]) {
    color: inherit;
    text-decoration: none
}

a:not([href]):hover {
    color: inherit;
    text-decoration: none
}

code,
kbd,
pre,
samp {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 1em
}

pre {
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto
}

figure {
    margin: 0 0 1rem
}

img {
    vertical-align: middle;
    border-style: none
}

svg {
    overflow: hidden;
    vertical-align: middle
}

table {
    border-collapse: collapse
}

caption {
    padding-top: .75rem;
    padding-bottom: .75rem;
    color: #6c757d;
    text-align: left;
    caption-side: bottom
}

th {
    text-align: inherit
}

.table-wrapper {
    overflow: auto
}

label {
    display: inline-block;
    margin-bottom: .5rem
}

button {
    border-radius: 0
}

button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color
}

button,
input,
optgroup,
select,
textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit
}

button,
input {
    overflow: visible
}

button,
select {
    text-transform: none
}

select {
    word-wrap: normal
}

[type=button],
[type=reset],
[type=submit],
button {
    -webkit-appearance: button
}

[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled),
button:not(:disabled) {
    cursor: pointer
}

[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner,
button::-moz-focus-inner {
    padding: 0;
    border-style: none
}

input[type=checkbox],
input[type=radio] {
    box-sizing: border-box;
    padding: 0
}

input[type=date],
input[type=datetime-local],
input[type=month],
input[type=time] {
    -webkit-appearance: listbox
}

textarea {
    overflow: auto;
    resize: vertical
}

fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0
}

legend {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin-bottom: .5rem;
    font-size: 1.5rem;
    line-height: inherit;
    color: inherit;
    white-space: normal
}

progress {
    vertical-align: baseline
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
    height: auto
}

[type=search] {
    outline-offset: -2px;
    -webkit-appearance: none
}

[type=search]::-webkit-search-decoration {
    -webkit-appearance: none
}

::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button
}

output {
    display: inline-block
}

summary {
    display: list-item;
    cursor: pointer
}

template {
    display: none
}

[hidden] {
    display: none !important
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    margin-bottom: .8rem;
    font-weight: 500;
    line-height: 1.2
}

.h1,
h1 {
    font-size: 4rem
}

.h2,
h2 {
    font-size: 3.2rem
}

.h3,
h3 {
    font-size: 2.8rem
}

.h4,
h4 {
    font-size: 2.4rem
}

.h5,
h5 {
    font-size: 2rem
}

.h6,
h6 {
    font-size: 1.6rem
}

.lead {
    font-size: 2rem;
    font-weight: 300
}

.display-1 {
    font-size: 6rem;
    font-weight: 300;
    line-height: 1.2
}

.display-2 {
    font-size: 5.5rem;
    font-weight: 300;
    line-height: 1.2
}

.display-3 {
    font-size: 4.5rem;
    font-weight: 300;
    line-height: 1.2
}

.display-4 {
    font-size: 3.5rem;
    font-weight: 300;
    line-height: 1.2
}

hr {
    margin-top: 1.6rem;
    margin-bottom: 1.6rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, .1)
}

.small,
small {
    font-size: 80%;
    font-weight: 400
}

.mark,
mark {
    padding: .2em;
    background-color: #fcf8e3
}

.list-unstyled {
    padding-left: 0;
    list-style: none
}

.list-inline {
    padding-left: 0;
    list-style: none
}

.list-inline-item {
    display: inline-block
}

.list-inline-item:not(:last-child) {
    margin-right: .5rem
}

.initialism {
    font-size: 90%;
    text-transform: uppercase
}

.blockquote {
    margin-bottom: 1.6rem;
    font-size: 2rem
}

.blockquote-footer {
    display: block;
    font-size: 80%;
    color: #6c757d
}

.blockquote-footer::before {
    content: "— "
}

code {
    font-size: 87.5%;
    color: #e83e8c;
    word-wrap: break-word
}

a>code {
    color: inherit
}

kbd {
    padding: .2rem .4rem;
    font-size: 87.5%;
    color: #fff;
    background-color: #212529;
    border-radius: .2rem
}

kbd kbd {
    padding: 0;
    font-size: 100%;
    font-weight: 700
}

pre {
    display: block;
    font-size: 87.5%;
    color: #212529
}

pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal
}

.pre-scrollable {
    max-height: 340px;
    overflow-y: scroll
}

.container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto
}

@media (min-width: 576px) {
    .container {
        max-width: 540px
    }
}

@media (min-width: 768px) {
    .container {
        max-width: 720px
    }
}

@media (min-width: 992px) {
    .container {
        max-width: 960px
    }
}

@media (min-width: 1200px) {
    .container {
        max-width: 1140px
    }
}

.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto
}

@media (min-width: 576px) {

    .container,
    .container-sm {
        max-width: 540px
    }
}

@media (min-width: 768px) {

    .container,
    .container-md,
    .container-sm {
        max-width: 720px
    }
}

@media (min-width: 992px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm {
        max-width: 960px
    }
}

@media (min-width: 1200px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl {
        max-width: 1140px
    }
}

.row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px
}

.no-gutters {
    margin-right: 0;
    margin-left: 0
}

.no-gutters>.col,
.no-gutters>[class*=col-] {
    padding-right: 0;
    padding-left: 0
}

.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto {
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px
}

.col {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%
}

.row-cols-1>* {
    flex: 0 0 100%;
    max-width: 100%
}

.row-cols-2>* {
    flex: 0 0 50%;
    max-width: 50%
}

.row-cols-3>* {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%
}

.row-cols-4>* {
    flex: 0 0 25%;
    max-width: 25%
}

.row-cols-5>* {
    flex: 0 0 20%;
    max-width: 20%
}

.row-cols-6>* {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%
}

.col-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%
}

.col-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%
}

.col-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%
}

.col-3 {
    flex: 0 0 25%;
    max-width: 25%
}

.col-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%
}

.col-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%
}

.col-6 {
    flex: 0 0 50%;
    max-width: 50%
}

.col-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%
}

.col-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%
}

.col-9 {
    flex: 0 0 75%;
    max-width: 75%
}

.col-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%
}

.col-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%
}

.col-12 {
    flex: 0 0 100%;
    max-width: 100%
}

.order-first {
    order: -1
}

.order-last {
    order: 13
}

.order-0 {
    order: 0
}

.order-1 {
    order: 1
}

.order-2 {
    order: 2
}

.order-3 {
    order: 3
}

.order-4 {
    order: 4
}

.order-5 {
    order: 5
}

.order-6 {
    order: 6
}

.order-7 {
    order: 7
}

.order-8 {
    order: 8
}

.order-9 {
    order: 9
}

.order-10 {
    order: 10
}

.order-11 {
    order: 11
}

.order-12 {
    order: 12
}

.offset-1 {
    margin-left: 8.3333333333%
}

.offset-2 {
    margin-left: 16.6666666667%
}

.offset-3 {
    margin-left: 25%
}

.offset-4 {
    margin-left: 33.3333333333%
}

.offset-5 {
    margin-left: 41.6666666667%
}

.offset-6 {
    margin-left: 50%
}

.offset-7 {
    margin-left: 58.3333333333%
}

.offset-8 {
    margin-left: 66.6666666667%
}

.offset-9 {
    margin-left: 75%
}

.offset-10 {
    margin-left: 83.3333333333%
}

.offset-11 {
    margin-left: 91.6666666667%
}

@media (min-width: 576px) {
    .col-sm {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%
    }

    .row-cols-sm-1>* {
        flex: 0 0 100%;
        max-width: 100%
    }

    .row-cols-sm-2>* {
        flex: 0 0 50%;
        max-width: 50%
    }

    .row-cols-sm-3>* {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%
    }

    .row-cols-sm-4>* {
        flex: 0 0 25%;
        max-width: 25%
    }

    .row-cols-sm-5>* {
        flex: 0 0 20%;
        max-width: 20%
    }

    .row-cols-sm-6>* {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%
    }

    .col-sm-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%
    }

    .col-sm-1 {
        flex: 0 0 8.3333333333%;
        max-width: 8.3333333333%
    }

    .col-sm-2 {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%
    }

    .col-sm-3 {
        flex: 0 0 25%;
        max-width: 25%
    }

    .col-sm-4 {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%
    }

    .col-sm-5 {
        flex: 0 0 41.6666666667%;
        max-width: 41.6666666667%
    }

    .col-sm-6 {
        flex: 0 0 50%;
        max-width: 50%
    }

    .col-sm-7 {
        flex: 0 0 58.3333333333%;
        max-width: 58.3333333333%
    }

    .col-sm-8 {
        flex: 0 0 66.6666666667%;
        max-width: 66.6666666667%
    }

    .col-sm-9 {
        flex: 0 0 75%;
        max-width: 75%
    }

    .col-sm-10 {
        flex: 0 0 83.3333333333%;
        max-width: 83.3333333333%
    }

    .col-sm-11 {
        flex: 0 0 91.6666666667%;
        max-width: 91.6666666667%
    }

    .col-sm-12 {
        flex: 0 0 100%;
        max-width: 100%
    }

    .order-sm-first {
        order: -1
    }

    .order-sm-last {
        order: 13
    }

    .order-sm-0 {
        order: 0
    }

    .order-sm-1 {
        order: 1
    }

    .order-sm-2 {
        order: 2
    }

    .order-sm-3 {
        order: 3
    }

    .order-sm-4 {
        order: 4
    }

    .order-sm-5 {
        order: 5
    }

    .order-sm-6 {
        order: 6
    }

    .order-sm-7 {
        order: 7
    }

    .order-sm-8 {
        order: 8
    }

    .order-sm-9 {
        order: 9
    }

    .order-sm-10 {
        order: 10
    }

    .order-sm-11 {
        order: 11
    }

    .order-sm-12 {
        order: 12
    }

    .offset-sm-0 {
        margin-left: 0
    }

    .offset-sm-1 {
        margin-left: 8.3333333333%
    }

    .offset-sm-2 {
        margin-left: 16.6666666667%
    }

    .offset-sm-3 {
        margin-left: 25%
    }

    .offset-sm-4 {
        margin-left: 33.3333333333%
    }

    .offset-sm-5 {
        margin-left: 41.6666666667%
    }

    .offset-sm-6 {
        margin-left: 50%
    }

    .offset-sm-7 {
        margin-left: 58.3333333333%
    }

    .offset-sm-8 {
        margin-left: 66.6666666667%
    }

    .offset-sm-9 {
        margin-left: 75%
    }

    .offset-sm-10 {
        margin-left: 83.3333333333%
    }

    .offset-sm-11 {
        margin-left: 91.6666666667%
    }
}

@media (min-width: 768px) {
    .col-md {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%
    }

    .row-cols-md-1>* {
        flex: 0 0 100%;
        max-width: 100%
    }

    .row-cols-md-2>* {
        flex: 0 0 50%;
        max-width: 50%
    }

    .row-cols-md-3>* {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%
    }

    .row-cols-md-4>* {
        flex: 0 0 25%;
        max-width: 25%
    }

    .row-cols-md-5>* {
        flex: 0 0 20%;
        max-width: 20%
    }

    .row-cols-md-6>* {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%
    }

    .col-md-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%
    }

    .col-md-1 {
        flex: 0 0 8.3333333333%;
        max-width: 8.3333333333%
    }

    .col-md-2 {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%
    }

    .col-md-3 {
        flex: 0 0 25%;
        max-width: 25%
    }

    .col-md-4 {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%
    }

    .col-md-5 {
        flex: 0 0 41.6666666667%;
        max-width: 41.6666666667%
    }

    .col-md-6 {
        flex: 0 0 50%;
        max-width: 50%
    }

    .col-md-7 {
        flex: 0 0 58.3333333333%;
        max-width: 58.3333333333%
    }

    .col-md-8 {
        flex: 0 0 66.6666666667%;
        max-width: 66.6666666667%
    }

    .col-md-9 {
        flex: 0 0 75%;
        max-width: 75%
    }

    .col-md-10 {
        flex: 0 0 83.3333333333%;
        max-width: 83.3333333333%
    }

    .col-md-11 {
        flex: 0 0 91.6666666667%;
        max-width: 91.6666666667%
    }

    .col-md-12 {
        flex: 0 0 100%;
        max-width: 100%
    }

    .order-md-first {
        order: -1
    }

    .order-md-last {
        order: 13
    }

    .order-md-0 {
        order: 0
    }

    .order-md-1 {
        order: 1
    }

    .order-md-2 {
        order: 2
    }

    .order-md-3 {
        order: 3
    }

    .order-md-4 {
        order: 4
    }

    .order-md-5 {
        order: 5
    }

    .order-md-6 {
        order: 6
    }

    .order-md-7 {
        order: 7
    }

    .order-md-8 {
        order: 8
    }

    .order-md-9 {
        order: 9
    }

    .order-md-10 {
        order: 10
    }

    .order-md-11 {
        order: 11
    }

    .order-md-12 {
        order: 12
    }

    .offset-md-0 {
        margin-left: 0
    }

    .offset-md-1 {
        margin-left: 8.3333333333%
    }

    .offset-md-2 {
        margin-left: 16.6666666667%
    }

    .offset-md-3 {
        margin-left: 25%
    }

    .offset-md-4 {
        margin-left: 33.3333333333%
    }

    .offset-md-5 {
        margin-left: 41.6666666667%
    }

    .offset-md-6 {
        margin-left: 50%
    }

    .offset-md-7 {
        margin-left: 58.3333333333%
    }

    .offset-md-8 {
        margin-left: 66.6666666667%
    }

    .offset-md-9 {
        margin-left: 75%
    }

    .offset-md-10 {
        margin-left: 83.3333333333%
    }

    .offset-md-11 {
        margin-left: 91.6666666667%
    }
}

@media (min-width: 992px) {
    .col-lg {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%
    }

    .row-cols-lg-1>* {
        flex: 0 0 100%;
        max-width: 100%
    }

    .row-cols-lg-2>* {
        flex: 0 0 50%;
        max-width: 50%
    }

    .row-cols-lg-3>* {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%
    }

    .row-cols-lg-4>* {
        flex: 0 0 25%;
        max-width: 25%
    }

    .row-cols-lg-5>* {
        flex: 0 0 20%;
        max-width: 20%
    }

    .row-cols-lg-6>* {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%
    }

    .col-lg-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%
    }

    .col-lg-1 {
        flex: 0 0 8.3333333333%;
        max-width: 8.3333333333%
    }

    .col-lg-2 {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%
    }

    .col-lg-3 {
        flex: 0 0 25%;
        max-width: 25%
    }

    .col-lg-4 {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%
    }

    .col-lg-5 {
        flex: 0 0 41.6666666667%;
        max-width: 41.6666666667%
    }

    .col-lg-6 {
        flex: 0 0 50%;
        max-width: 50%
    }

    .col-lg-7 {
        flex: 0 0 58.3333333333%;
        max-width: 58.3333333333%
    }

    .col-lg-8 {
        flex: 0 0 66.6666666667%;
        max-width: 66.6666666667%
    }

    .col-lg-9 {
        flex: 0 0 75%;
        max-width: 75%
    }

    .col-lg-10 {
        flex: 0 0 83.3333333333%;
        max-width: 83.3333333333%
    }

    .col-lg-11 {
        flex: 0 0 91.6666666667%;
        max-width: 91.6666666667%
    }

    .col-lg-12 {
        flex: 0 0 100%;
        max-width: 100%
    }

    .order-lg-first {
        order: -1
    }

    .order-lg-last {
        order: 13
    }

    .order-lg-0 {
        order: 0
    }

    .order-lg-1 {
        order: 1
    }

    .order-lg-2 {
        order: 2
    }

    .order-lg-3 {
        order: 3
    }

    .order-lg-4 {
        order: 4
    }

    .order-lg-5 {
        order: 5
    }

    .order-lg-6 {
        order: 6
    }

    .order-lg-7 {
        order: 7
    }

    .order-lg-8 {
        order: 8
    }

    .order-lg-9 {
        order: 9
    }

    .order-lg-10 {
        order: 10
    }

    .order-lg-11 {
        order: 11
    }

    .order-lg-12 {
        order: 12
    }

    .offset-lg-0 {
        margin-left: 0
    }

    .offset-lg-1 {
        margin-left: 8.3333333333%
    }

    .offset-lg-2 {
        margin-left: 16.6666666667%
    }

    .offset-lg-3 {
        margin-left: 25%
    }

    .offset-lg-4 {
        margin-left: 33.3333333333%
    }

    .offset-lg-5 {
        margin-left: 41.6666666667%
    }

    .offset-lg-6 {
        margin-left: 50%
    }

    .offset-lg-7 {
        margin-left: 58.3333333333%
    }

    .offset-lg-8 {
        margin-left: 66.6666666667%
    }

    .offset-lg-9 {
        margin-left: 75%
    }

    .offset-lg-10 {
        margin-left: 83.3333333333%
    }

    .offset-lg-11 {
        margin-left: 91.6666666667%
    }
}

@media (min-width: 1200px) {
    .col-xl {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%
    }

    .row-cols-xl-1>* {
        flex: 0 0 100%;
        max-width: 100%
    }

    .row-cols-xl-2>* {
        flex: 0 0 50%;
        max-width: 50%
    }

    .row-cols-xl-3>* {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%
    }

    .row-cols-xl-4>* {
        flex: 0 0 25%;
        max-width: 25%
    }

    .row-cols-xl-5>* {
        flex: 0 0 20%;
        max-width: 20%
    }

    .row-cols-xl-6>* {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%
    }

    .col-xl-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%
    }

    .col-xl-1 {
        flex: 0 0 8.3333333333%;
        max-width: 8.3333333333%
    }

    .col-xl-2 {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%
    }

    .col-xl-3 {
        flex: 0 0 25%;
        max-width: 25%
    }

    .col-xl-4 {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%
    }

    .col-xl-5 {
        flex: 0 0 41.6666666667%;
        max-width: 41.6666666667%
    }

    .col-xl-6 {
        flex: 0 0 50%;
        max-width: 50%
    }

    .col-xl-7 {
        flex: 0 0 58.3333333333%;
        max-width: 58.3333333333%
    }

    .col-xl-8 {
        flex: 0 0 66.6666666667%;
        max-width: 66.6666666667%
    }

    .col-xl-9 {
        flex: 0 0 75%;
        max-width: 75%
    }

    .col-xl-10 {
        flex: 0 0 83.3333333333%;
        max-width: 83.3333333333%
    }

    .col-xl-11 {
        flex: 0 0 91.6666666667%;
        max-width: 91.6666666667%
    }

    .col-xl-12 {
        flex: 0 0 100%;
        max-width: 100%
    }

    .order-xl-first {
        order: -1
    }

    .order-xl-last {
        order: 13
    }

    .order-xl-0 {
        order: 0
    }

    .order-xl-1 {
        order: 1
    }

    .order-xl-2 {
        order: 2
    }

    .order-xl-3 {
        order: 3
    }

    .order-xl-4 {
        order: 4
    }

    .order-xl-5 {
        order: 5
    }

    .order-xl-6 {
        order: 6
    }

    .order-xl-7 {
        order: 7
    }

    .order-xl-8 {
        order: 8
    }

    .order-xl-9 {
        order: 9
    }

    .order-xl-10 {
        order: 10
    }

    .order-xl-11 {
        order: 11
    }

    .order-xl-12 {
        order: 12
    }

    .offset-xl-0 {
        margin-left: 0
    }

    .offset-xl-1 {
        margin-left: 8.3333333333%
    }

    .offset-xl-2 {
        margin-left: 16.6666666667%
    }

    .offset-xl-3 {
        margin-left: 25%
    }

    .offset-xl-4 {
        margin-left: 33.3333333333%
    }

    .offset-xl-5 {
        margin-left: 41.6666666667%
    }

    .offset-xl-6 {
        margin-left: 50%
    }

    .offset-xl-7 {
        margin-left: 58.3333333333%
    }

    .offset-xl-8 {
        margin-left: 66.6666666667%
    }

    .offset-xl-9 {
        margin-left: 75%
    }

    .offset-xl-10 {
        margin-left: 83.3333333333%
    }

    .offset-xl-11 {
        margin-left: 91.6666666667%
    }
}

.table {
    width: 100%;
    margin-bottom: 1.6rem;
    color: #212529
}

.table td,
.table th {
    padding: .75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6
}

.table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6
}

.table tbody+tbody {
    border-top: 2px solid #dee2e6
}

.table-sm td,
.table-sm th {
    padding: .3rem
}

.table-bordered {
    border: 1px solid #dee2e6
}

.table-bordered td,
.table-bordered th {
    border: 1px solid #dee2e6
}

.table-bordered thead td,
.table-bordered thead th {
    border-bottom-width: 2px
}

.table-borderless tbody+tbody,
.table-borderless td,
.table-borderless th,
.table-borderless thead th {
    border: 0
}

.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05)
}

.table-hover tbody tr:hover {
    color: #212529;
    background-color: rgba(0, 0, 0, .075)
}

.table-primary,
.table-primary>td,
.table-primary>th {
    background-color: rgb(183.6, 218.04, 255)
}

.table-primary tbody+tbody,
.table-primary td,
.table-primary th,
.table-primary thead th {
    border-color: rgb(122.4, 186.36, 255)
}

.table-hover .table-primary:hover {
    background-color: rgb(158.1, 204.84, 255)
}

.table-hover .table-primary:hover>td,
.table-hover .table-primary:hover>th {
    background-color: rgb(158.1, 204.84, 255)
}

.table-secondary,
.table-secondary>td,
.table-secondary>th {
    background-color: rgb(213.84, 216.36, 218.6)
}

.table-secondary tbody+tbody,
.table-secondary td,
.table-secondary th,
.table-secondary thead th {
    border-color: rgb(178.56, 183.24, 187.4)
}

.table-hover .table-secondary:hover {
    background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747)
}

.table-hover .table-secondary:hover>td,
.table-hover .table-secondary:hover>th {
    background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747)
}

.table-success,
.table-success>td,
.table-success>th {
    background-color: rgb(194.8, 230.36, 202.92)
}

.table-success tbody+tbody,
.table-success td,
.table-success th,
.table-success thead th {
    border-color: rgb(143.2, 209.24, 158.28)
}

.table-hover .table-success:hover {
    background-color: rgb(176.7059405941, 222.9540594059, 187.2665346535)
}

.table-hover .table-success:hover>td,
.table-hover .table-success:hover>th {
    background-color: rgb(176.7059405941, 222.9540594059, 187.2665346535)
}

.table-info,
.table-info>td,
.table-info>th {
    background-color: rgb(190.04, 228.96, 235.12)
}

.table-info tbody+tbody,
.table-info td,
.table-info th,
.table-info thead th {
    border-color: rgb(134.36, 206.64, 218.08)
}

.table-hover .table-info:hover {
    background-color: rgb(170.5152475248, 221.1332673267, 229.1447524752)
}

.table-hover .table-info:hover>td,
.table-hover .table-info:hover>th {
    background-color: rgb(170.5152475248, 221.1332673267, 229.1447524752)
}

.table-warning,
.table-warning>td,
.table-warning>th {
    background-color: rgb(255, 237.64, 185.56)
}

.table-warning tbody+tbody,
.table-warning td,
.table-warning th,
.table-warning thead th {
    border-color: rgb(255, 222.76, 126.04)
}

.table-hover .table-warning:hover {
    background-color: rgb(255, 231.265, 160.06)
}

.table-hover .table-warning:hover>td,
.table-hover .table-warning:hover>th {
    background-color: rgb(255, 231.265, 160.06)
}

.table-danger,
.table-danger>td,
.table-danger>th {
    background-color: rgb(245.2, 198.44, 202.92)
}

.table-danger tbody+tbody,
.table-danger td,
.table-danger th,
.table-danger thead th {
    border-color: rgb(236.8, 149.96, 158.28)
}

.table-hover .table-danger:hover {
    background-color: rgb(241.4341772152, 176.7058227848, 182.9073417722)
}

.table-hover .table-danger:hover>td,
.table-hover .table-danger:hover>th {
    background-color: rgb(241.4341772152, 176.7058227848, 182.9073417722)
}

.table-light,
.table-light>td,
.table-light>th {
    background-color: rgb(253.04, 253.32, 253.6)
}

.table-light tbody+tbody,
.table-light td,
.table-light th,
.table-light thead th {
    border-color: rgb(251.36, 251.88, 252.4)
}

.table-hover .table-light:hover {
    background-color: rgb(238.165, 240.57, 242.975)
}

.table-hover .table-light:hover>td,
.table-hover .table-light:hover>th {
    background-color: rgb(238.165, 240.57, 242.975)
}

.table-dark,
.table-dark>td,
.table-dark>th {
    background-color: rgb(198.16, 199.84, 201.52)
}

.table-dark tbody+tbody,
.table-dark td,
.table-dark th,
.table-dark thead th {
    border-color: rgb(149.44, 152.56, 155.68)
}

.table-hover .table-dark:hover {
    background-color: rgb(185.0216751269, 187.09, 189.1583248731)
}

.table-hover .table-dark:hover>td,
.table-hover .table-dark:hover>th {
    background-color: rgb(185.0216751269, 187.09, 189.1583248731)
}

.table-active,
.table-active>td,
.table-active>th {
    background-color: rgba(0, 0, 0, .075)
}

.table-hover .table-active:hover {
    background-color: rgba(0, 0, 0, .075)
}

.table-hover .table-active:hover>td,
.table-hover .table-active:hover>th {
    background-color: rgba(0, 0, 0, .075)
}

.table .thead-dark th {
    color: #fff;
    background-color: #343a40;
    border-color: rgb(69.1465517241, 77.125, 85.1034482759)
}

.table .thead-light th {
    color: #495057;
    background-color: #e9ecef;
    border-color: #dee2e6
}

.table-dark {
    color: #fff;
    background-color: #343a40
}

.table-dark td,
.table-dark th,
.table-dark thead th {
    border-color: rgb(69.1465517241, 77.125, 85.1034482759)
}

.table-dark.table-bordered {
    border: 0
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(255, 255, 255, .05)
}

.table-dark.table-hover tbody tr:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, .075)
}

@media (max-width: 575.98px) {
    .table-responsive-sm {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }

    .table-responsive-sm>.table-bordered {
        border: 0
    }
}

@media (max-width: 767.98px) {
    .table-responsive-md {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }

    .table-responsive-md>.table-bordered {
        border: 0
    }
}

@media (max-width: 991.98px) {
    .table-responsive-lg {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }

    .table-responsive-lg>.table-bordered {
        border: 0
    }
}

@media (max-width: 1199.98px) {
    .table-responsive-xl {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }

    .table-responsive-xl>.table-bordered {
        border: 0
    }
}

.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch
}

.table-responsive>.table-bordered {
    border: 0
}

.fade {
    transition: opacity .15s linear
}

@media (prefers-reduced-motion:reduce) {
    .fade {
        transition: none
    }
}

.fade:not(.show) {
    opacity: 0
}

.collapse:not(.show) {
    display: none
}

.collapsing {
    position: relative;
    height: 0;
    overflow: hidden;
    transition: height .35s ease
}

@media (prefers-reduced-motion:reduce) {
    .collapsing {
        transition: none
    }
}

.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%
}

.input-group>.custom-file,
.input-group>.custom-select,
.input-group>.form-control,
.input-group>.form-control-plaintext {
    position: relative;
    flex: 1 1 0%;
    min-width: 0;
    margin-bottom: 0
}

.input-group>.custom-file+.custom-file,
.input-group>.custom-file+.custom-select,
.input-group>.custom-file+.form-control,
.input-group>.custom-select+.custom-file,
.input-group>.custom-select+.custom-select,
.input-group>.custom-select+.form-control,
.input-group>.form-control+.custom-file,
.input-group>.form-control+.custom-select,
.input-group>.form-control+.form-control,
.input-group>.form-control-plaintext+.custom-file,
.input-group>.form-control-plaintext+.custom-select,
.input-group>.form-control-plaintext+.form-control {
    margin-left: -1px
}

.input-group>.custom-file .custom-file-input:focus~.custom-file-label,
.input-group>.custom-select:focus,
.input-group>.form-control:focus {
    z-index: 3
}

.input-group>.custom-file .custom-file-input:focus {
    z-index: 4
}

.input-group>.custom-select:not(:last-child),
.input-group>.form-control:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.input-group>.custom-select:not(:first-child),
.input-group>.form-control:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.input-group>.custom-file {
    display: flex;
    align-items: center
}

.input-group>.custom-file:not(:last-child) .custom-file-label,
.input-group>.custom-file:not(:last-child) .custom-file-label::after {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.input-group>.custom-file:not(:first-child) .custom-file-label {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.input-group-append,
.input-group-prepend {
    display: flex
}

.input-group-append .btn,
.input-group-prepend .btn {
    position: relative;
    z-index: 2
}

.input-group-append .btn:focus,
.input-group-prepend .btn:focus {
    z-index: 3
}

.input-group-append .btn+.btn,
.input-group-append .btn+.input-group-text,
.input-group-append .input-group-text+.btn,
.input-group-append .input-group-text+.input-group-text,
.input-group-prepend .btn+.btn,
.input-group-prepend .btn+.input-group-text,
.input-group-prepend .input-group-text+.btn,
.input-group-prepend .input-group-text+.input-group-text {
    margin-left: -1px
}

.input-group-prepend {
    margin-right: -1px
}

.input-group-append {
    margin-left: -1px
}

.input-group-text {
    display: flex;
    align-items: center;
    padding: .375rem .75rem;
    margin-bottom: 0;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    text-align: center;
    white-space: nowrap;
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-radius: .25rem
}

.input-group-text input[type=checkbox],
.input-group-text input[type=radio] {
    margin-top: 0
}

.input-group-lg>.custom-select,
.input-group-lg>.form-control:not(textarea) {
    height: calc(1.5em + 1rem + 2px)
}

.input-group-lg>.custom-select,
.input-group-lg>.form-control,
.input-group-lg>.input-group-append>.btn,
.input-group-lg>.input-group-append>.input-group-text,
.input-group-lg>.input-group-prepend>.btn,
.input-group-lg>.input-group-prepend>.input-group-text {
    padding: .5rem 1rem;
    font-size: 2rem;
    line-height: 1.5;
    border-radius: .3rem
}

.input-group-sm>.custom-select,
.input-group-sm>.form-control:not(textarea) {
    height: calc(1.5em + .5rem + 2px)
}

.input-group-sm>.custom-select,
.input-group-sm>.form-control,
.input-group-sm>.input-group-append>.btn,
.input-group-sm>.input-group-append>.input-group-text,
.input-group-sm>.input-group-prepend>.btn,
.input-group-sm>.input-group-prepend>.input-group-text {
    padding: .25rem .5rem;
    font-size: 1.4rem;
    line-height: 1.5;
    border-radius: .2rem
}

.input-group-lg>.custom-select,
.input-group-sm>.custom-select {
    padding-right: 1.75rem
}

.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),
.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),
.input-group>.input-group-append:not(:last-child)>.btn,
.input-group>.input-group-append:not(:last-child)>.input-group-text,
.input-group>.input-group-prepend>.btn,
.input-group>.input-group-prepend>.input-group-text {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.input-group>.input-group-append>.btn,
.input-group>.input-group-append>.input-group-text,
.input-group>.input-group-prepend:first-child>.btn:not(:first-child),
.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),
.input-group>.input-group-prepend:not(:first-child)>.btn,
.input-group>.input-group-prepend:not(:first-child)>.input-group-text {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.nav {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none
}

.nav-link {
    display: block;
    padding: .5rem 1rem
}

.nav-link:focus,
.nav-link:hover {
    text-decoration: none
}

.nav-link.disabled {
    color: #6c757d;
    pointer-events: none;
    cursor: default
}

.nav-tabs {
    border-bottom: 1px solid #dee2e6
}

.nav-tabs .nav-item {
    margin-bottom: -1px
}

.nav-tabs .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
    border-color: #e9ecef #e9ecef #dee2e6
}

.nav-tabs .nav-link.disabled {
    color: #6c757d;
    background-color: transparent;
    border-color: transparent
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff
}

.nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.nav-pills .nav-link {
    border-radius: .25rem
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    color: #fff;
    background-color: #007bff
}

.nav-fill .nav-item {
    flex: 1 1 auto;
    text-align: center
}

.nav-justified .nav-item {
    flex-basis: 0;
    flex-grow: 1;
    text-align: center
}

.tab-content>.tab-pane {
    display: none
}

.tab-content>.active {
    display: block
}

.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: .25rem
}

.card>hr {
    margin-right: 0;
    margin-left: 0
}

.card>.list-group:first-child .list-group-item:first-child {
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem
}

.card>.list-group:last-child .list-group-item:last-child {
    border-bottom-right-radius: .25rem;
    border-bottom-left-radius: .25rem
}

.card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem
}

.card-title {
    margin-bottom: .75rem
}

.card-subtitle {
    margin-top: -.375rem;
    margin-bottom: 0
}

.card-text:last-child {
    margin-bottom: 0
}

.card-link:hover {
    text-decoration: none
}

.card-link+.card-link {
    margin-left: 1.25rem
}

.card-header {
    padding: .75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, .03);
    border-bottom: 1px solid rgba(0, 0, 0, .125)
}

.card-header:first-child {
    border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0
}

.card-header+.list-group .list-group-item:first-child {
    border-top: 0
}

.card-footer {
    padding: .75rem 1.25rem;
    background-color: rgba(0, 0, 0, .03);
    border-top: 1px solid rgba(0, 0, 0, .125)
}

.card-footer:last-child {
    border-radius: 0 0 calc(.25rem - 1px) calc(.25rem - 1px)
}

.card-header-tabs {
    margin-right: -.625rem;
    margin-bottom: -.75rem;
    margin-left: -.625rem;
    border-bottom: 0
}

.card-header-pills {
    margin-right: -.625rem;
    margin-left: -.625rem
}

.card-img-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 1.25rem
}

.card-img,
.card-img-bottom,
.card-img-top {
    flex-shrink: 0;
    width: 100%
}

.card-img,
.card-img-top {
    border-top-left-radius: calc(.25rem - 1px);
    border-top-right-radius: calc(.25rem - 1px)
}

.card-img,
.card-img-bottom {
    border-bottom-right-radius: calc(.25rem - 1px);
    border-bottom-left-radius: calc(.25rem - 1px)
}

.card-deck .card {
    margin-bottom: 15px
}

@media (min-width: 576px) {
    .card-deck {
        display: flex;
        flex-flow: row wrap;
        margin-right: -15px;
        margin-left: -15px
    }

    .card-deck .card {
        flex: 1 0 0%;
        margin-right: 15px;
        margin-bottom: 0;
        margin-left: 15px
    }
}

.card-group>.card {
    margin-bottom: 15px
}

@media (min-width: 576px) {
    .card-group {
        display: flex;
        flex-flow: row wrap
    }

    .card-group>.card {
        flex: 1 0 0%;
        margin-bottom: 0
    }

    .card-group>.card+.card {
        margin-left: 0;
        border-left: 0
    }

    .card-group>.card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0
    }

    .card-group>.card:not(:last-child) .card-header,
    .card-group>.card:not(:last-child) .card-img-top {
        border-top-right-radius: 0
    }

    .card-group>.card:not(:last-child) .card-footer,
    .card-group>.card:not(:last-child) .card-img-bottom {
        border-bottom-right-radius: 0
    }

    .card-group>.card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0
    }

    .card-group>.card:not(:first-child) .card-header,
    .card-group>.card:not(:first-child) .card-img-top {
        border-top-left-radius: 0
    }

    .card-group>.card:not(:first-child) .card-footer,
    .card-group>.card:not(:first-child) .card-img-bottom {
        border-bottom-left-radius: 0
    }
}

.card-columns .card {
    margin-bottom: .75rem
}

@media (min-width: 576px) {
    .card-columns {
        -moz-column-count: 3;
             column-count: 3;
        -moz-column-gap: 1.25rem;
             column-gap: 1.25rem;
        orphans: 1;
        widows: 1
    }

    .card-columns .card {
        display: inline-block;
        width: 100%
    }
}

.accordion>.card {
    overflow: hidden
}

.accordion>.card:not(:last-of-type) {
    border-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0
}

.accordion>.card:not(:first-of-type) {
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.accordion>.card>.card-header {
    border-radius: 0;
    margin-bottom: -1px
}

.breadcrumb {
    display: flex;
    flex-wrap: wrap;
    padding: 0 0;
    margin-bottom: 0;
    font-size: 1.8rem;
    list-style: none;
    background-color: transparent;
    border-radius: .25rem
}

.breadcrumb-back {
    max-height: 25px
}

.breadcrumb-item+.breadcrumb-item {
    padding-left: .5rem
}

.breadcrumb-item+.breadcrumb-item::before {
    display: inline-block;
    padding-right: .5rem;
    color: #8a8d8f;
    content: "/"
}

.breadcrumb-item+.breadcrumb-item:hover::before {
    text-decoration: underline;
    text-decoration: none
}

.breadcrumb-item.active {
    color: #6c757d
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .25rem
}

.alert-heading {
    color: inherit
}

.alert-link {
    font-weight: 700
}

.alert-dismissible {
    padding-right: 4.9rem
}

.alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 0;
    padding: .75rem 1.25rem;
    color: inherit
}

.alert-primary {
    color: rgb(0, 63.96, 132.6);
    background-color: rgb(204, 228.6, 255);
    border-color: rgb(183.6, 218.04, 255)
}

.alert-primary hr {
    border-top-color: rgb(158.1, 204.84, 255)
}

.alert-primary .alert-link {
    color: rgb(0, 39.36, 81.6)
}

.alert-secondary {
    color: rgb(56.16, 60.84, 65);
    background-color: rgb(225.6, 227.4, 229);
    border-color: rgb(213.84, 216.36, 218.6)
}

.alert-secondary hr {
    border-top-color: rgb(200.3075090253, 203.6560288809, 206.6324909747)
}

.alert-secondary .alert-link {
    color: rgb(32.5205150215, 35.2305579399, 37.6394849785)
}

.alert-success {
    color: rgb(20.8, 86.84, 35.88);
    background-color: rgb(212, 237.4, 217.8);
    border-color: rgb(194.8, 230.36, 202.92)
}

.alert-success hr {
    border-top-color: rgb(176.7059405941, 222.9540594059, 187.2665346535)
}

.alert-success .alert-link {
    color: rgb(10.9449275362, 45.6950724638, 18.88)
}

.alert-info {
    color: rgb(11.96, 84.24, 95.68);
    background-color: rgb(208.6, 236.4, 240.8);
    border-color: rgb(190.04, 228.96, 235.12)
}

.alert-info hr {
    border-top-color: rgb(170.5152475248, 221.1332673267, 229.1447524752)
}

.alert-info .alert-link {
    color: rgb(6.2933333333, 44.3269565217, 50.3466666667)
}

.alert-warning {
    color: rgb(132.6, 100.36, 3.64);
    background-color: rgb(255, 242.6, 205.4);
    border-color: rgb(255, 237.64, 185.56)
}

.alert-warning hr {
    border-top-color: rgb(255, 231.265, 160.06)
}

.alert-warning .alert-link {
    color: rgb(82.9625954198, 62.7912977099, 2.2774045802)
}

.alert-danger {
    color: rgb(114.4, 27.56, 35.88);
    background-color: rgb(248, 214.6, 217.8);
    border-color: rgb(245.2, 198.44, 202.92)
}

.alert-danger hr {
    border-top-color: rgb(241.4341772152, 176.7058227848, 182.9073417722)
}

.alert-danger .alert-link {
    color: rgb(73.3010989011, 17.6589010989, 22.9898901099)
}

.alert-light {
    color: rgb(128.96, 129.48, 130);
    background-color: rgb(253.6, 253.8, 254);
    border-color: rgb(253.04, 253.32, 253.6)
}

.alert-light hr {
    border-top-color: rgb(238.165, 240.57, 242.975)
}

.alert-light .alert-link {
    color: rgb(103.5492351816, 103.98, 104.4107648184)
}

.alert-dark {
    color: rgb(27.04, 30.16, 33.28);
    background-color: rgb(214.4, 215.6, 216.8);
    border-color: rgb(198.16, 199.84, 201.52)
}

.alert-dark hr {
    border-top-color: rgb(185.0216751269, 187.09, 189.1583248731)
}

.alert-dark .alert-link {
    color: rgb(4.1779310345, 4.66, 5.1420689655)
}

.media {
    display: flex;
    align-items: flex-start
}

.media-body {
    flex: 1
}

.list-group {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0
}

.list-group-item-action {
    width: 100%;
    color: #495057;
    text-align: inherit
}

.list-group-item-action:focus,
.list-group-item-action:hover {
    z-index: 1;
    color: #495057;
    text-decoration: none;
    background-color: #f8f9fa
}

.list-group-item-action:active {
    color: #212529;
    background-color: #e9ecef
}

.list-group-item {
    position: relative;
    display: block;
    padding: .75rem 1.25rem;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, .125)
}

.list-group-item:first-child {
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem
}

.list-group-item:last-child {
    border-bottom-right-radius: .25rem;
    border-bottom-left-radius: .25rem
}

.list-group-item.disabled,
.list-group-item:disabled {
    color: #6c757d;
    pointer-events: none;
    background-color: #fff
}

.list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff
}

.list-group-item+.list-group-item {
    border-top-width: 0
}

.list-group-item+.list-group-item.active {
    margin-top: -1px;
    border-top-width: 1px
}

.list-group-horizontal {
    flex-direction: row
}

.list-group-horizontal .list-group-item:first-child {
    border-bottom-left-radius: .25rem;
    border-top-right-radius: 0
}

.list-group-horizontal .list-group-item:last-child {
    border-top-right-radius: .25rem;
    border-bottom-left-radius: 0
}

.list-group-horizontal .list-group-item.active {
    margin-top: 0
}

.list-group-horizontal .list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0
}

.list-group-horizontal .list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px
}

@media (min-width: 576px) {
    .list-group-horizontal-sm {
        flex-direction: row
    }

    .list-group-horizontal-sm .list-group-item:first-child {
        border-bottom-left-radius: .25rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-sm .list-group-item:last-child {
        border-top-right-radius: .25rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-sm .list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-sm .list-group-item+.list-group-item {
        border-top-width: 1px;
        border-left-width: 0
    }

    .list-group-horizontal-sm .list-group-item+.list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px
    }
}

@media (min-width: 768px) {
    .list-group-horizontal-md {
        flex-direction: row
    }

    .list-group-horizontal-md .list-group-item:first-child {
        border-bottom-left-radius: .25rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-md .list-group-item:last-child {
        border-top-right-radius: .25rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-md .list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-md .list-group-item+.list-group-item {
        border-top-width: 1px;
        border-left-width: 0
    }

    .list-group-horizontal-md .list-group-item+.list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px
    }
}

@media (min-width: 992px) {
    .list-group-horizontal-lg {
        flex-direction: row
    }

    .list-group-horizontal-lg .list-group-item:first-child {
        border-bottom-left-radius: .25rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-lg .list-group-item:last-child {
        border-top-right-radius: .25rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-lg .list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-lg .list-group-item+.list-group-item {
        border-top-width: 1px;
        border-left-width: 0
    }

    .list-group-horizontal-lg .list-group-item+.list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px
    }
}

@media (min-width: 1200px) {
    .list-group-horizontal-xl {
        flex-direction: row
    }

    .list-group-horizontal-xl .list-group-item:first-child {
        border-bottom-left-radius: .25rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-xl .list-group-item:last-child {
        border-top-right-radius: .25rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-xl .list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-xl .list-group-item+.list-group-item {
        border-top-width: 1px;
        border-left-width: 0
    }

    .list-group-horizontal-xl .list-group-item+.list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px
    }
}

.list-group-flush .list-group-item {
    border-right-width: 0;
    border-left-width: 0;
    border-radius: 0
}

.list-group-flush .list-group-item:first-child {
    border-top-width: 0
}

.list-group-flush:last-child .list-group-item:last-child {
    border-bottom-width: 0
}

.list-group-item-primary {
    color: rgb(0, 63.96, 132.6);
    background-color: rgb(183.6, 218.04, 255)
}

.list-group-item-primary.list-group-item-action:focus,
.list-group-item-primary.list-group-item-action:hover {
    color: rgb(0, 63.96, 132.6);
    background-color: rgb(158.1, 204.84, 255)
}

.list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: rgb(0, 63.96, 132.6);
    border-color: rgb(0, 63.96, 132.6)
}

.list-group-item-secondary {
    color: rgb(56.16, 60.84, 65);
    background-color: rgb(213.84, 216.36, 218.6)
}

.list-group-item-secondary.list-group-item-action:focus,
.list-group-item-secondary.list-group-item-action:hover {
    color: rgb(56.16, 60.84, 65);
    background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747)
}

.list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: rgb(56.16, 60.84, 65);
    border-color: rgb(56.16, 60.84, 65)
}

.list-group-item-success {
    color: rgb(20.8, 86.84, 35.88);
    background-color: rgb(194.8, 230.36, 202.92)
}

.list-group-item-success.list-group-item-action:focus,
.list-group-item-success.list-group-item-action:hover {
    color: rgb(20.8, 86.84, 35.88);
    background-color: rgb(176.7059405941, 222.9540594059, 187.2665346535)
}

.list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: rgb(20.8, 86.84, 35.88);
    border-color: rgb(20.8, 86.84, 35.88)
}

.list-group-item-info {
    color: rgb(11.96, 84.24, 95.68);
    background-color: rgb(190.04, 228.96, 235.12)
}

.list-group-item-info.list-group-item-action:focus,
.list-group-item-info.list-group-item-action:hover {
    color: rgb(11.96, 84.24, 95.68);
    background-color: rgb(170.5152475248, 221.1332673267, 229.1447524752)
}

.list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: rgb(11.96, 84.24, 95.68);
    border-color: rgb(11.96, 84.24, 95.68)
}

.list-group-item-warning {
    color: rgb(132.6, 100.36, 3.64);
    background-color: rgb(255, 237.64, 185.56)
}

.list-group-item-warning.list-group-item-action:focus,
.list-group-item-warning.list-group-item-action:hover {
    color: rgb(132.6, 100.36, 3.64);
    background-color: rgb(255, 231.265, 160.06)
}

.list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: rgb(132.6, 100.36, 3.64);
    border-color: rgb(132.6, 100.36, 3.64)
}

.list-group-item-danger {
    color: rgb(114.4, 27.56, 35.88);
    background-color: rgb(245.2, 198.44, 202.92)
}

.list-group-item-danger.list-group-item-action:focus,
.list-group-item-danger.list-group-item-action:hover {
    color: rgb(114.4, 27.56, 35.88);
    background-color: rgb(241.4341772152, 176.7058227848, 182.9073417722)
}

.list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: rgb(114.4, 27.56, 35.88);
    border-color: rgb(114.4, 27.56, 35.88)
}

.list-group-item-light {
    color: rgb(128.96, 129.48, 130);
    background-color: rgb(253.04, 253.32, 253.6)
}

.list-group-item-light.list-group-item-action:focus,
.list-group-item-light.list-group-item-action:hover {
    color: rgb(128.96, 129.48, 130);
    background-color: rgb(238.165, 240.57, 242.975)
}

.list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: rgb(128.96, 129.48, 130);
    border-color: rgb(128.96, 129.48, 130)
}

.list-group-item-dark {
    color: rgb(27.04, 30.16, 33.28);
    background-color: rgb(198.16, 199.84, 201.52)
}

.list-group-item-dark.list-group-item-action:focus,
.list-group-item-dark.list-group-item-action:hover {
    color: rgb(27.04, 30.16, 33.28);
    background-color: rgb(185.0216751269, 187.09, 189.1583248731)
}

.list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: rgb(27.04, 30.16, 33.28);
    border-color: rgb(27.04, 30.16, 33.28)
}

.close {
    float: right;
    font-size: 2.4rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5
}

.close:hover {
    color: #000;
    text-decoration: none
}

.close:not(:disabled):not(.disabled):focus,
.close:not(:disabled):not(.disabled):hover {
    opacity: .75
}

button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none
}

a.close.disabled {
    pointer-events: none
}

.modal-open {
    overflow: hidden
}

.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    display: none;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0
}

.modal-dialog {
    position: relative;
    width: auto;
    margin: .5rem;
    pointer-events: none
}

.modal.fade .modal-dialog {
    transition: transform .3s ease-out;
    transform: translate(0, -50px)
}

@media (prefers-reduced-motion:reduce) {
    .modal.fade .modal-dialog {
        transition: none
    }
}

.modal.show .modal-dialog {
    transform: none
}

.modal.modal-static .modal-dialog {
    transform: scale(1.02)
}

.modal-dialog-scrollable {
    display: flex;
    max-height: calc(100% - 1rem)
}

.modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 1rem);
    overflow: hidden
}

.modal-dialog-scrollable .modal-footer,
.modal-dialog-scrollable .modal-header {
    flex-shrink: 0
}

.modal-dialog-scrollable .modal-body {
    overflow-y: auto
}

.modal-dialog-centered {
    display: flex;
    align-items: center;
    min-height: calc(100% - 1rem)
}

.modal-dialog-centered::before {
    display: block;
    height: calc(100vh - 1rem);
    content: ""
}

.modal-dialog-centered.modal-dialog-scrollable {
    flex-direction: column;
    justify-content: center;
    height: 100%
}

.modal-dialog-centered.modal-dialog-scrollable .modal-content {
    max-height: none
}

.modal-dialog-centered.modal-dialog-scrollable::before {
    content: none
}

.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: .3rem;
    outline: 0
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #000
}

.modal-backdrop.fade {
    opacity: 0
}

.modal-backdrop.show {
    opacity: .5
}

.modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 1rem 1rem;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: calc(.3rem - 1px);
    border-top-right-radius: calc(.3rem - 1px)
}

.modal-header .close {
    padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto
}

.modal-title {
    margin-bottom: 0;
    line-height: 1.5
}

.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 1rem
}

.modal-footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    padding: .75rem;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: calc(.3rem - 1px);
    border-bottom-left-radius: calc(.3rem - 1px)
}

.modal-footer>* {
    margin: .25rem
}

.modal-scrollbar-measure {
    position: absolute;
    top: -9999px;
    width: 50px;
    height: 50px;
    overflow: scroll
}

@media (min-width: 576px) {
    .modal-dialog {
        max-width: 500px;
        margin: 1.75rem auto
    }

    .modal-dialog-scrollable {
        max-height: calc(100% - 3.5rem)
    }

    .modal-dialog-scrollable .modal-content {
        max-height: calc(100vh - 3.5rem)
    }

    .modal-dialog-centered {
        min-height: calc(100% - 3.5rem)
    }

    .modal-dialog-centered::before {
        height: calc(100vh - 3.5rem)
    }

    .modal-sm {
        max-width: 300px
    }
}

@media (min-width: 992px) {

    .modal-lg,
    .modal-xl {
        max-width: 800px
    }
}

@media (min-width: 1200px) {
    .modal-xl {
        max-width: 1140px
    }
}

.tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: 1.4rem;
    word-wrap: break-word;
    opacity: 0
}

.tooltip.show {
    opacity: .9
}

.tooltip .arrow {
    position: absolute;
    display: block;
    width: .8rem;
    height: .4rem
}

.tooltip .arrow::before {
    position: absolute;
    content: "";
    border-color: transparent;
    border-style: solid
}

.bs-tooltip-auto[x-placement^=top],
.bs-tooltip-top {
    padding: .4rem 0
}

.bs-tooltip-auto[x-placement^=top] .arrow,
.bs-tooltip-top .arrow {
    bottom: 0
}

.bs-tooltip-auto[x-placement^=top] .arrow::before,
.bs-tooltip-top .arrow::before {
    top: 0;
    border-width: .4rem .4rem 0;
    border-top-color: #000
}

.bs-tooltip-auto[x-placement^=right],
.bs-tooltip-right {
    padding: 0 .4rem
}

.bs-tooltip-auto[x-placement^=right] .arrow,
.bs-tooltip-right .arrow {
    left: 0;
    width: .4rem;
    height: .8rem
}

.bs-tooltip-auto[x-placement^=right] .arrow::before,
.bs-tooltip-right .arrow::before {
    right: 0;
    border-width: .4rem .4rem .4rem 0;
    border-right-color: #000
}

.bs-tooltip-auto[x-placement^=bottom],
.bs-tooltip-bottom {
    padding: .4rem 0
}

.bs-tooltip-auto[x-placement^=bottom] .arrow,
.bs-tooltip-bottom .arrow {
    top: 0
}

.bs-tooltip-auto[x-placement^=bottom] .arrow::before,
.bs-tooltip-bottom .arrow::before {
    bottom: 0;
    border-width: 0 .4rem .4rem;
    border-bottom-color: #000
}

.bs-tooltip-auto[x-placement^=left],
.bs-tooltip-left {
    padding: 0 .4rem
}

.bs-tooltip-auto[x-placement^=left] .arrow,
.bs-tooltip-left .arrow {
    right: 0;
    width: .4rem;
    height: .8rem
}

.bs-tooltip-auto[x-placement^=left] .arrow::before,
.bs-tooltip-left .arrow::before {
    left: 0;
    border-width: .4rem 0 .4rem .4rem;
    border-left-color: #000
}

.tooltip-inner {
    max-width: 200px;
    padding: .25rem .5rem;
    color: #fff;
    text-align: center;
    background-color: #000;
    border-radius: .25rem
}

.align-baseline {
    vertical-align: baseline !important
}

.align-top {
    vertical-align: top !important
}

.align-middle {
    vertical-align: middle !important
}

.align-bottom {
    vertical-align: bottom !important
}

.align-text-bottom {
    vertical-align: text-bottom !important
}

.align-text-top {
    vertical-align: text-top !important
}

.bg-primary {
    background-color: #007bff !important
}

a.bg-primary:focus,
a.bg-primary:hover,
button.bg-primary:focus,
button.bg-primary:hover {
    background-color: rgb(0, 98.4, 204) !important
}

.bg-secondary {
    background-color: #6c757d !important
}

a.bg-secondary:focus,
a.bg-secondary:hover,
button.bg-secondary:focus,
button.bg-secondary:hover {
    background-color: rgb(84.3605150215, 91.3905579399, 97.6394849785) !important
}

.bg-success {
    background-color: #28a745 !important
}

a.bg-success:focus,
a.bg-success:hover,
button.bg-success:focus,
button.bg-success:hover {
    background-color: rgb(30.1449275362, 125.8550724638, 52) !important
}

.bg-info {
    background-color: #17a2b8 !important
}

a.bg-info:focus,
a.bg-info:hover,
button.bg-info:focus,
button.bg-info:hover {
    background-color: rgb(17.3333333333, 122.0869565217, 138.6666666667) !important
}

.bg-warning {
    background-color: #ffc107 !important
}

a.bg-warning:focus,
a.bg-warning:hover,
button.bg-warning:focus,
button.bg-warning:hover {
    background-color: rgb(211, 158.25, 0) !important
}

.bg-danger {
    background-color: #dc3545 !important
}

a.bg-danger:focus,
a.bg-danger:hover,
button.bg-danger:focus,
button.bg-danger:hover {
    background-color: rgb(189.2151898734, 32.7848101266, 47.7721518987) !important
}

.bg-light {
    background-color: #f8f9fa !important
}

a.bg-light:focus,
a.bg-light:hover,
button.bg-light:focus,
button.bg-light:hover {
    background-color: rgb(218.25, 223.5, 228.75) !important
}

.bg-dark {
    background-color: #343a40 !important
}

a.bg-dark:focus,
a.bg-dark:hover,
button.bg-dark:focus,
button.bg-dark:hover {
    background-color: rgb(29.1379310345, 32.5, 35.8620689655) !important
}

.bg-white {
    background-color: #fff !important
}

.bg-transparent {
    background-color: transparent !important
}

.border {
    border: 1px solid #dee2e6 !important
}

.border-top {
    border-top: 1px solid #dee2e6 !important
}

.border-right {
    border-right: 1px solid #dee2e6 !important
}

.border-bottom {
    border-bottom: 1px solid #dee2e6 !important
}

.border-left {
    border-left: 1px solid #dee2e6 !important
}

.border-0 {
    border: 0 !important
}

.border-top-0 {
    border-top: 0 !important
}

.border-right-0 {
    border-right: 0 !important
}

.border-bottom-0 {
    border-bottom: 0 !important
}

.border-left-0 {
    border-left: 0 !important
}

.border-primary {
    border-color: #007bff !important
}

.border-secondary {
    border-color: #6c757d !important
}

.border-success {
    border-color: #28a745 !important
}

.border-info {
    border-color: #17a2b8 !important
}

.border-warning {
    border-color: #ffc107 !important
}

.border-danger {
    border-color: #dc3545 !important
}

.border-light {
    border-color: #f8f9fa !important
}

.border-dark {
    border-color: #343a40 !important
}

.border-white {
    border-color: #fff !important
}

.rounded-sm {
    border-radius: .2rem !important
}

.rounded {
    border-radius: .25rem !important
}

.rounded-top {
    border-top-left-radius: .25rem !important;
    border-top-right-radius: .25rem !important
}

.rounded-right {
    border-top-right-radius: .25rem !important;
    border-bottom-right-radius: .25rem !important
}

.rounded-bottom {
    border-bottom-right-radius: .25rem !important;
    border-bottom-left-radius: .25rem !important
}

.rounded-left {
    border-top-left-radius: .25rem !important;
    border-bottom-left-radius: .25rem !important
}

.rounded-lg {
    border-radius: .3rem !important
}

.rounded-circle {
    border-radius: 50% !important
}

.rounded-pill {
    border-radius: 50rem !important
}

.rounded-0 {
    border-radius: 0 !important
}

.clearfix::after {
    display: block;
    clear: both;
    content: ""
}

.d-none {
    display: none !important
}

.d-inline {
    display: inline !important
}

.d-inline-block {
    display: inline-block !important
}

.d-block {
    display: block !important
}

.d-table {
    display: table !important
}

.d-table-row {
    display: table-row !important
}

.d-table-cell {
    display: table-cell !important
}

.d-flex {
    display: flex !important
}

.d-inline-flex {
    display: inline-flex !important
}

@media (min-width: 576px) {
    .d-sm-none {
        display: none !important
    }

    .d-sm-inline {
        display: inline !important
    }

    .d-sm-inline-block {
        display: inline-block !important
    }

    .d-sm-block {
        display: block !important
    }

    .d-sm-table {
        display: table !important
    }

    .d-sm-table-row {
        display: table-row !important
    }

    .d-sm-table-cell {
        display: table-cell !important
    }

    .d-sm-flex {
        display: flex !important
    }

    .d-sm-inline-flex {
        display: inline-flex !important
    }
}

@media (min-width: 768px) {
    .d-md-none {
        display: none !important
    }

    .d-md-inline {
        display: inline !important
    }

    .d-md-inline-block {
        display: inline-block !important
    }

    .d-md-block {
        display: block !important
    }

    .d-md-table {
        display: table !important
    }

    .d-md-table-row {
        display: table-row !important
    }

    .d-md-table-cell {
        display: table-cell !important
    }

    .d-md-flex {
        display: flex !important
    }

    .d-md-inline-flex {
        display: inline-flex !important
    }
}

@media (min-width: 992px) {
    .d-lg-none {
        display: none !important
    }

    .d-lg-inline {
        display: inline !important
    }

    .d-lg-inline-block {
        display: inline-block !important
    }

    .d-lg-block {
        display: block !important
    }

    .d-lg-table {
        display: table !important
    }

    .d-lg-table-row {
        display: table-row !important
    }

    .d-lg-table-cell {
        display: table-cell !important
    }

    .d-lg-flex {
        display: flex !important
    }

    .d-lg-inline-flex {
        display: inline-flex !important
    }
}

@media (min-width: 1200px) {
    .d-xl-none {
        display: none !important
    }

    .d-xl-inline {
        display: inline !important
    }

    .d-xl-inline-block {
        display: inline-block !important
    }

    .d-xl-block {
        display: block !important
    }

    .d-xl-table {
        display: table !important
    }

    .d-xl-table-row {
        display: table-row !important
    }

    .d-xl-table-cell {
        display: table-cell !important
    }

    .d-xl-flex {
        display: flex !important
    }

    .d-xl-inline-flex {
        display: inline-flex !important
    }
}

@media print {
    .d-print-none {
        display: none !important
    }

    .d-print-inline {
        display: inline !important
    }

    .d-print-inline-block {
        display: inline-block !important
    }

    .d-print-block {
        display: block !important
    }

    .d-print-table {
        display: table !important
    }

    .d-print-table-row {
        display: table-row !important
    }

    .d-print-table-cell {
        display: table-cell !important
    }

    .d-print-flex {
        display: flex !important
    }

    .d-print-inline-flex {
        display: inline-flex !important
    }
}

.embed-responsive {
    position: relative;
    display: block;
    width: 100%;
    padding: 0;
    overflow: hidden
}

.embed-responsive::before {
    display: block;
    content: ""
}

.embed-responsive .embed-responsive-item,
.embed-responsive embed,
.embed-responsive iframe,
.embed-responsive object,
.embed-responsive video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0
}

.embed-responsive-21by9::before {
    padding-top: .4285714286
}

.embed-responsive-16by9::before {
    padding-top: .5625
}

.embed-responsive-4by3::before {
    padding-top: .75
}

.embed-responsive-1by1::before {
    padding-top: 1
}

.flex-row {
    flex-direction: row !important
}

.flex-column {
    flex-direction: column !important
}

.flex-row-reverse {
    flex-direction: row-reverse !important
}

.flex-column-reverse {
    flex-direction: column-reverse !important
}

.flex-wrap {
    flex-wrap: wrap !important
}

.flex-nowrap {
    flex-wrap: nowrap !important
}

.flex-wrap-reverse {
    flex-wrap: wrap-reverse !important
}

.flex-fill {
    flex: 1 1 auto !important
}

.flex-grow-0 {
    flex-grow: 0 !important
}

.flex-grow-1 {
    flex-grow: 1 !important
}

.flex-shrink-0 {
    flex-shrink: 0 !important
}

.flex-shrink-1 {
    flex-shrink: 1 !important
}

.justify-content-start {
    justify-content: flex-start !important
}

.justify-content-end {
    justify-content: flex-end !important
}

.justify-content-center {
    justify-content: center !important
}

.justify-content-between {
    justify-content: space-between !important
}

.justify-content-around {
    justify-content: space-around !important
}

.align-items-start {
    align-items: flex-start !important
}

.align-items-end {
    align-items: flex-end !important
}

.align-items-center {
    align-items: center !important
}

.align-items-baseline {
    align-items: baseline !important
}

.align-items-stretch {
    align-items: stretch !important
}

.align-content-start {
    align-content: flex-start !important
}

.align-content-end {
    align-content: flex-end !important
}

.align-content-center {
    align-content: center !important
}

.align-content-between {
    align-content: space-between !important
}

.align-content-around {
    align-content: space-around !important
}

.align-content-stretch {
    align-content: stretch !important
}

.align-self-auto {
    align-self: auto !important
}

.align-self-start {
    align-self: flex-start !important
}

.align-self-end {
    align-self: flex-end !important
}

.align-self-center {
    align-self: center !important
}

.align-self-baseline {
    align-self: baseline !important
}

.align-self-stretch {
    align-self: stretch !important
}

@media (min-width: 576px) {
    .flex-sm-row {
        flex-direction: row !important
    }

    .flex-sm-column {
        flex-direction: column !important
    }

    .flex-sm-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-sm-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-sm-wrap {
        flex-wrap: wrap !important
    }

    .flex-sm-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-sm-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .flex-sm-fill {
        flex: 1 1 auto !important
    }

    .flex-sm-grow-0 {
        flex-grow: 0 !important
    }

    .flex-sm-grow-1 {
        flex-grow: 1 !important
    }

    .flex-sm-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-sm-shrink-1 {
        flex-shrink: 1 !important
    }

    .justify-content-sm-start {
        justify-content: flex-start !important
    }

    .justify-content-sm-end {
        justify-content: flex-end !important
    }

    .justify-content-sm-center {
        justify-content: center !important
    }

    .justify-content-sm-between {
        justify-content: space-between !important
    }

    .justify-content-sm-around {
        justify-content: space-around !important
    }

    .align-items-sm-start {
        align-items: flex-start !important
    }

    .align-items-sm-end {
        align-items: flex-end !important
    }

    .align-items-sm-center {
        align-items: center !important
    }

    .align-items-sm-baseline {
        align-items: baseline !important
    }

    .align-items-sm-stretch {
        align-items: stretch !important
    }

    .align-content-sm-start {
        align-content: flex-start !important
    }

    .align-content-sm-end {
        align-content: flex-end !important
    }

    .align-content-sm-center {
        align-content: center !important
    }

    .align-content-sm-between {
        align-content: space-between !important
    }

    .align-content-sm-around {
        align-content: space-around !important
    }

    .align-content-sm-stretch {
        align-content: stretch !important
    }

    .align-self-sm-auto {
        align-self: auto !important
    }

    .align-self-sm-start {
        align-self: flex-start !important
    }

    .align-self-sm-end {
        align-self: flex-end !important
    }

    .align-self-sm-center {
        align-self: center !important
    }

    .align-self-sm-baseline {
        align-self: baseline !important
    }

    .align-self-sm-stretch {
        align-self: stretch !important
    }
}

@media (min-width: 768px) {
    .flex-md-row {
        flex-direction: row !important
    }

    .flex-md-column {
        flex-direction: column !important
    }

    .flex-md-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-md-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-md-wrap {
        flex-wrap: wrap !important
    }

    .flex-md-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-md-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .flex-md-fill {
        flex: 1 1 auto !important
    }

    .flex-md-grow-0 {
        flex-grow: 0 !important
    }

    .flex-md-grow-1 {
        flex-grow: 1 !important
    }

    .flex-md-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-md-shrink-1 {
        flex-shrink: 1 !important
    }

    .justify-content-md-start {
        justify-content: flex-start !important
    }

    .justify-content-md-end {
        justify-content: flex-end !important
    }

    .justify-content-md-center {
        justify-content: center !important
    }

    .justify-content-md-between {
        justify-content: space-between !important
    }

    .justify-content-md-around {
        justify-content: space-around !important
    }

    .align-items-md-start {
        align-items: flex-start !important
    }

    .align-items-md-end {
        align-items: flex-end !important
    }

    .align-items-md-center {
        align-items: center !important
    }

    .align-items-md-baseline {
        align-items: baseline !important
    }

    .align-items-md-stretch {
        align-items: stretch !important
    }

    .align-content-md-start {
        align-content: flex-start !important
    }

    .align-content-md-end {
        align-content: flex-end !important
    }

    .align-content-md-center {
        align-content: center !important
    }

    .align-content-md-between {
        align-content: space-between !important
    }

    .align-content-md-around {
        align-content: space-around !important
    }

    .align-content-md-stretch {
        align-content: stretch !important
    }

    .align-self-md-auto {
        align-self: auto !important
    }

    .align-self-md-start {
        align-self: flex-start !important
    }

    .align-self-md-end {
        align-self: flex-end !important
    }

    .align-self-md-center {
        align-self: center !important
    }

    .align-self-md-baseline {
        align-self: baseline !important
    }

    .align-self-md-stretch {
        align-self: stretch !important
    }
}

@media (min-width: 992px) {
    .flex-lg-row {
        flex-direction: row !important
    }

    .flex-lg-column {
        flex-direction: column !important
    }

    .flex-lg-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-lg-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-lg-wrap {
        flex-wrap: wrap !important
    }

    .flex-lg-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-lg-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .flex-lg-fill {
        flex: 1 1 auto !important
    }

    .flex-lg-grow-0 {
        flex-grow: 0 !important
    }

    .flex-lg-grow-1 {
        flex-grow: 1 !important
    }

    .flex-lg-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-lg-shrink-1 {
        flex-shrink: 1 !important
    }

    .justify-content-lg-start {
        justify-content: flex-start !important
    }

    .justify-content-lg-end {
        justify-content: flex-end !important
    }

    .justify-content-lg-center {
        justify-content: center !important
    }

    .justify-content-lg-between {
        justify-content: space-between !important
    }

    .justify-content-lg-around {
        justify-content: space-around !important
    }

    .align-items-lg-start {
        align-items: flex-start !important
    }

    .align-items-lg-end {
        align-items: flex-end !important
    }

    .align-items-lg-center {
        align-items: center !important
    }

    .align-items-lg-baseline {
        align-items: baseline !important
    }

    .align-items-lg-stretch {
        align-items: stretch !important
    }

    .align-content-lg-start {
        align-content: flex-start !important
    }

    .align-content-lg-end {
        align-content: flex-end !important
    }

    .align-content-lg-center {
        align-content: center !important
    }

    .align-content-lg-between {
        align-content: space-between !important
    }

    .align-content-lg-around {
        align-content: space-around !important
    }

    .align-content-lg-stretch {
        align-content: stretch !important
    }

    .align-self-lg-auto {
        align-self: auto !important
    }

    .align-self-lg-start {
        align-self: flex-start !important
    }

    .align-self-lg-end {
        align-self: flex-end !important
    }

    .align-self-lg-center {
        align-self: center !important
    }

    .align-self-lg-baseline {
        align-self: baseline !important
    }

    .align-self-lg-stretch {
        align-self: stretch !important
    }
}

@media (min-width: 1200px) {
    .flex-xl-row {
        flex-direction: row !important
    }

    .flex-xl-column {
        flex-direction: column !important
    }

    .flex-xl-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-xl-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-xl-wrap {
        flex-wrap: wrap !important
    }

    .flex-xl-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-xl-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .flex-xl-fill {
        flex: 1 1 auto !important
    }

    .flex-xl-grow-0 {
        flex-grow: 0 !important
    }

    .flex-xl-grow-1 {
        flex-grow: 1 !important
    }

    .flex-xl-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-xl-shrink-1 {
        flex-shrink: 1 !important
    }

    .justify-content-xl-start {
        justify-content: flex-start !important
    }

    .justify-content-xl-end {
        justify-content: flex-end !important
    }

    .justify-content-xl-center {
        justify-content: center !important
    }

    .justify-content-xl-between {
        justify-content: space-between !important
    }

    .justify-content-xl-around {
        justify-content: space-around !important
    }

    .align-items-xl-start {
        align-items: flex-start !important
    }

    .align-items-xl-end {
        align-items: flex-end !important
    }

    .align-items-xl-center {
        align-items: center !important
    }

    .align-items-xl-baseline {
        align-items: baseline !important
    }

    .align-items-xl-stretch {
        align-items: stretch !important
    }

    .align-content-xl-start {
        align-content: flex-start !important
    }

    .align-content-xl-end {
        align-content: flex-end !important
    }

    .align-content-xl-center {
        align-content: center !important
    }

    .align-content-xl-between {
        align-content: space-between !important
    }

    .align-content-xl-around {
        align-content: space-around !important
    }

    .align-content-xl-stretch {
        align-content: stretch !important
    }

    .align-self-xl-auto {
        align-self: auto !important
    }

    .align-self-xl-start {
        align-self: flex-start !important
    }

    .align-self-xl-end {
        align-self: flex-end !important
    }

    .align-self-xl-center {
        align-self: center !important
    }

    .align-self-xl-baseline {
        align-self: baseline !important
    }

    .align-self-xl-stretch {
        align-self: stretch !important
    }
}

.float-left {
    float: left !important
}

.float-right {
    float: right !important
}

.float-none {
    float: none !important
}

@media (min-width: 576px) {
    .float-sm-left {
        float: left !important
    }

    .float-sm-right {
        float: right !important
    }

    .float-sm-none {
        float: none !important
    }
}

@media (min-width: 768px) {
    .float-md-left {
        float: left !important
    }

    .float-md-right {
        float: right !important
    }

    .float-md-none {
        float: none !important
    }
}

@media (min-width: 992px) {
    .float-lg-left {
        float: left !important
    }

    .float-lg-right {
        float: right !important
    }

    .float-lg-none {
        float: none !important
    }
}

@media (min-width: 1200px) {
    .float-xl-left {
        float: left !important
    }

    .float-xl-right {
        float: right !important
    }

    .float-xl-none {
        float: none !important
    }
}

.overflow-auto {
    overflow: auto !important
}

.overflow-hidden {
    overflow: hidden !important
}

.position-static {
    position: static !important
}

.position-relative {
    position: relative !important
}

.position-absolute {
    position: absolute !important
}

.position-fixed {
    position: fixed !important
}

.position-sticky {
    position: sticky !important
}

.fixed-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030
}

.fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030
}

@supports (position: sticky) {
    .sticky-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip: auto;
    white-space: normal
}

.shadow-sm {
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important
}

.shadow {
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important
}

.shadow-lg {
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, .175) !important
}

.shadow-none {
    box-shadow: none !important
}

.w-25 {
    width: 25% !important
}

.w-50 {
    width: 50% !important
}

.w-75 {
    width: 75% !important
}

.w-100 {
    width: 100% !important
}

.w-auto {
    width: auto !important
}

.h-25 {
    height: 25% !important
}

.h-50 {
    height: 50% !important
}

.h-75 {
    height: 75% !important
}

.h-100 {
    height: 100% !important
}

.h-auto {
    height: auto !important
}

.mw-100 {
    max-width: 100% !important
}

.mh-100 {
    max-height: 100% !important
}

.min-vw-100 {
    min-width: 100vw !important
}

.min-vh-100 {
    min-height: 100vh !important
}

.vw-100 {
    width: 100vw !important
}

.vh-100 {
    height: 100vh !important
}

.stretched-link::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    pointer-events: auto;
    content: "";
    background-color: rgba(0, 0, 0, 0)
}

.m-0 {
    margin: 0 !important
}

.mt-0,
.my-0 {
    margin-top: 0 !important
}

.mr-0,
.mx-0 {
    margin-right: 0 !important
}

.mb-0,
.my-0 {
    margin-bottom: 0 !important
}

.ml-0,
.mx-0 {
    margin-left: 0 !important
}

.m-1 {
    margin: .4rem !important
}

.mt-1,
.my-1 {
    margin-top: .4rem !important
}

.mr-1,
.mx-1 {
    margin-right: .4rem !important
}

.mb-1,
.my-1 {
    margin-bottom: .4rem !important
}

.ml-1,
.mx-1 {
    margin-left: .4rem !important
}

.m-2 {
    margin: .8rem !important
}

.mt-2,
.my-2 {
    margin-top: .8rem !important
}

.mr-2,
.mx-2 {
    margin-right: .8rem !important
}

.mb-2,
.my-2 {
    margin-bottom: .8rem !important
}

.ml-2,
.mx-2 {
    margin-left: .8rem !important
}

.m-3 {
    margin: 1.6rem !important
}

.mt-3,
.my-3 {
    margin-top: 1.6rem !important
}

.mr-3,
.mx-3 {
    margin-right: 1.6rem !important
}

.mb-3,
.my-3 {
    margin-bottom: 1.6rem !important
}

.ml-3,
.mx-3 {
    margin-left: 1.6rem !important
}

.m-4 {
    margin: 2.4rem !important
}

.mt-4,
.my-4 {
    margin-top: 2.4rem !important
}

.mr-4,
.mx-4 {
    margin-right: 2.4rem !important
}

.mb-4,
.my-4 {
    margin-bottom: 2.4rem !important
}

.ml-4,
.mx-4 {
    margin-left: 2.4rem !important
}

.m-5 {
    margin: 4.8rem !important
}

.mt-5,
.my-5 {
    margin-top: 4.8rem !important
}

.mr-5,
.mx-5 {
    margin-right: 4.8rem !important
}

.mb-5,
.my-5 {
    margin-bottom: 4.8rem !important
}

.ml-5,
.mx-5 {
    margin-left: 4.8rem !important
}

.p-0 {
    padding: 0 !important
}

.pt-0,
.py-0 {
    padding-top: 0 !important
}

.pr-0,
.px-0 {
    padding-right: 0 !important
}

.pb-0,
.py-0 {
    padding-bottom: 0 !important
}

.pl-0,
.px-0 {
    padding-left: 0 !important
}

.p-1 {
    padding: .4rem !important
}

.pt-1,
.py-1 {
    padding-top: .4rem !important
}

.pr-1,
.px-1 {
    padding-right: .4rem !important
}

.pb-1,
.py-1 {
    padding-bottom: .4rem !important
}

.pl-1,
.px-1 {
    padding-left: .4rem !important
}

.p-2 {
    padding: .8rem !important
}

.pt-2,
.py-2 {
    padding-top: .8rem !important
}

.pr-2,
.px-2 {
    padding-right: .8rem !important
}

.pb-2,
.py-2 {
    padding-bottom: .8rem !important
}

.pl-2,
.px-2 {
    padding-left: .8rem !important
}

.p-3 {
    padding: 1.6rem !important
}

.pt-3,
.py-3 {
    padding-top: 1.6rem !important
}

.pr-3,
.px-3 {
    padding-right: 1.6rem !important
}

.pb-3,
.py-3 {
    padding-bottom: 1.6rem !important
}

.pl-3,
.px-3 {
    padding-left: 1.6rem !important
}

.p-4 {
    padding: 2.4rem !important
}

.pt-4,
.py-4 {
    padding-top: 2.4rem !important
}

.pr-4,
.px-4 {
    padding-right: 2.4rem !important
}

.pb-4,
.py-4 {
    padding-bottom: 2.4rem !important
}

.pl-4,
.px-4 {
    padding-left: 2.4rem !important
}

.p-5 {
    padding: 4.8rem !important
}

.pt-5,
.py-5 {
    padding-top: 4.8rem !important
}

.pr-5,
.px-5 {
    padding-right: 4.8rem !important
}

.pb-5,
.py-5 {
    padding-bottom: 4.8rem !important
}

.pl-5,
.px-5 {
    padding-left: 4.8rem !important
}

.m-n1 {
    margin: -.4rem !important
}

.mt-n1,
.my-n1 {
    margin-top: -.4rem !important
}

.mr-n1,
.mx-n1 {
    margin-right: -.4rem !important
}

.mb-n1,
.my-n1 {
    margin-bottom: -.4rem !important
}

.ml-n1,
.mx-n1 {
    margin-left: -.4rem !important
}

.m-n2 {
    margin: -.8rem !important
}

.mt-n2,
.my-n2 {
    margin-top: -.8rem !important
}

.mr-n2,
.mx-n2 {
    margin-right: -.8rem !important
}

.mb-n2,
.my-n2 {
    margin-bottom: -.8rem !important
}

.ml-n2,
.mx-n2 {
    margin-left: -.8rem !important
}

.m-n3 {
    margin: -1.6rem !important
}

.mt-n3,
.my-n3 {
    margin-top: -1.6rem !important
}

.mr-n3,
.mx-n3 {
    margin-right: -1.6rem !important
}

.mb-n3,
.my-n3 {
    margin-bottom: -1.6rem !important
}

.ml-n3,
.mx-n3 {
    margin-left: -1.6rem !important
}

.m-n4 {
    margin: -2.4rem !important
}

.mt-n4,
.my-n4 {
    margin-top: -2.4rem !important
}

.mr-n4,
.mx-n4 {
    margin-right: -2.4rem !important
}

.mb-n4,
.my-n4 {
    margin-bottom: -2.4rem !important
}

.ml-n4,
.mx-n4 {
    margin-left: -2.4rem !important
}

.m-n5 {
    margin: -4.8rem !important
}

.mt-n5,
.my-n5 {
    margin-top: -4.8rem !important
}

.mr-n5,
.mx-n5 {
    margin-right: -4.8rem !important
}

.mb-n5,
.my-n5 {
    margin-bottom: -4.8rem !important
}

.ml-n5,
.mx-n5 {
    margin-left: -4.8rem !important
}

.m-auto {
    margin: auto !important
}

.mt-auto,
.my-auto {
    margin-top: auto !important
}

.mr-auto,
.mx-auto {
    margin-right: auto !important
}

.mb-auto,
.my-auto {
    margin-bottom: auto !important
}

.ml-auto,
.mx-auto {
    margin-left: auto !important
}

@media (min-width: 576px) {
    .m-sm-0 {
        margin: 0 !important
    }

    .mt-sm-0,
    .my-sm-0 {
        margin-top: 0 !important
    }

    .mr-sm-0,
    .mx-sm-0 {
        margin-right: 0 !important
    }

    .mb-sm-0,
    .my-sm-0 {
        margin-bottom: 0 !important
    }

    .ml-sm-0,
    .mx-sm-0 {
        margin-left: 0 !important
    }

    .m-sm-1 {
        margin: .4rem !important
    }

    .mt-sm-1,
    .my-sm-1 {
        margin-top: .4rem !important
    }

    .mr-sm-1,
    .mx-sm-1 {
        margin-right: .4rem !important
    }

    .mb-sm-1,
    .my-sm-1 {
        margin-bottom: .4rem !important
    }

    .ml-sm-1,
    .mx-sm-1 {
        margin-left: .4rem !important
    }

    .m-sm-2 {
        margin: .8rem !important
    }

    .mt-sm-2,
    .my-sm-2 {
        margin-top: .8rem !important
    }

    .mr-sm-2,
    .mx-sm-2 {
        margin-right: .8rem !important
    }

    .mb-sm-2,
    .my-sm-2 {
        margin-bottom: .8rem !important
    }

    .ml-sm-2,
    .mx-sm-2 {
        margin-left: .8rem !important
    }

    .m-sm-3 {
        margin: 1.6rem !important
    }

    .mt-sm-3,
    .my-sm-3 {
        margin-top: 1.6rem !important
    }

    .mr-sm-3,
    .mx-sm-3 {
        margin-right: 1.6rem !important
    }

    .mb-sm-3,
    .my-sm-3 {
        margin-bottom: 1.6rem !important
    }

    .ml-sm-3,
    .mx-sm-3 {
        margin-left: 1.6rem !important
    }

    .m-sm-4 {
        margin: 2.4rem !important
    }

    .mt-sm-4,
    .my-sm-4 {
        margin-top: 2.4rem !important
    }

    .mr-sm-4,
    .mx-sm-4 {
        margin-right: 2.4rem !important
    }

    .mb-sm-4,
    .my-sm-4 {
        margin-bottom: 2.4rem !important
    }

    .ml-sm-4,
    .mx-sm-4 {
        margin-left: 2.4rem !important
    }

    .m-sm-5 {
        margin: 4.8rem !important
    }

    .mt-sm-5,
    .my-sm-5 {
        margin-top: 4.8rem !important
    }

    .mr-sm-5,
    .mx-sm-5 {
        margin-right: 4.8rem !important
    }

    .mb-sm-5,
    .my-sm-5 {
        margin-bottom: 4.8rem !important
    }

    .ml-sm-5,
    .mx-sm-5 {
        margin-left: 4.8rem !important
    }

    .p-sm-0 {
        padding: 0 !important
    }

    .pt-sm-0,
    .py-sm-0 {
        padding-top: 0 !important
    }

    .pr-sm-0,
    .px-sm-0 {
        padding-right: 0 !important
    }

    .pb-sm-0,
    .py-sm-0 {
        padding-bottom: 0 !important
    }

    .pl-sm-0,
    .px-sm-0 {
        padding-left: 0 !important
    }

    .p-sm-1 {
        padding: .4rem !important
    }

    .pt-sm-1,
    .py-sm-1 {
        padding-top: .4rem !important
    }

    .pr-sm-1,
    .px-sm-1 {
        padding-right: .4rem !important
    }

    .pb-sm-1,
    .py-sm-1 {
        padding-bottom: .4rem !important
    }

    .pl-sm-1,
    .px-sm-1 {
        padding-left: .4rem !important
    }

    .p-sm-2 {
        padding: .8rem !important
    }

    .pt-sm-2,
    .py-sm-2 {
        padding-top: .8rem !important
    }

    .pr-sm-2,
    .px-sm-2 {
        padding-right: .8rem !important
    }

    .pb-sm-2,
    .py-sm-2 {
        padding-bottom: .8rem !important
    }

    .pl-sm-2,
    .px-sm-2 {
        padding-left: .8rem !important
    }

    .p-sm-3 {
        padding: 1.6rem !important
    }

    .pt-sm-3,
    .py-sm-3 {
        padding-top: 1.6rem !important
    }

    .pr-sm-3,
    .px-sm-3 {
        padding-right: 1.6rem !important
    }

    .pb-sm-3,
    .py-sm-3 {
        padding-bottom: 1.6rem !important
    }

    .pl-sm-3,
    .px-sm-3 {
        padding-left: 1.6rem !important
    }

    .p-sm-4 {
        padding: 2.4rem !important
    }

    .pt-sm-4,
    .py-sm-4 {
        padding-top: 2.4rem !important
    }

    .pr-sm-4,
    .px-sm-4 {
        padding-right: 2.4rem !important
    }

    .pb-sm-4,
    .py-sm-4 {
        padding-bottom: 2.4rem !important
    }

    .pl-sm-4,
    .px-sm-4 {
        padding-left: 2.4rem !important
    }

    .p-sm-5 {
        padding: 4.8rem !important
    }

    .pt-sm-5,
    .py-sm-5 {
        padding-top: 4.8rem !important
    }

    .pr-sm-5,
    .px-sm-5 {
        padding-right: 4.8rem !important
    }

    .pb-sm-5,
    .py-sm-5 {
        padding-bottom: 4.8rem !important
    }

    .pl-sm-5,
    .px-sm-5 {
        padding-left: 4.8rem !important
    }

    .m-sm-n1 {
        margin: -.4rem !important
    }

    .mt-sm-n1,
    .my-sm-n1 {
        margin-top: -.4rem !important
    }

    .mr-sm-n1,
    .mx-sm-n1 {
        margin-right: -.4rem !important
    }

    .mb-sm-n1,
    .my-sm-n1 {
        margin-bottom: -.4rem !important
    }

    .ml-sm-n1,
    .mx-sm-n1 {
        margin-left: -.4rem !important
    }

    .m-sm-n2 {
        margin: -.8rem !important
    }

    .mt-sm-n2,
    .my-sm-n2 {
        margin-top: -.8rem !important
    }

    .mr-sm-n2,
    .mx-sm-n2 {
        margin-right: -.8rem !important
    }

    .mb-sm-n2,
    .my-sm-n2 {
        margin-bottom: -.8rem !important
    }

    .ml-sm-n2,
    .mx-sm-n2 {
        margin-left: -.8rem !important
    }

    .m-sm-n3 {
        margin: -1.6rem !important
    }

    .mt-sm-n3,
    .my-sm-n3 {
        margin-top: -1.6rem !important
    }

    .mr-sm-n3,
    .mx-sm-n3 {
        margin-right: -1.6rem !important
    }

    .mb-sm-n3,
    .my-sm-n3 {
        margin-bottom: -1.6rem !important
    }

    .ml-sm-n3,
    .mx-sm-n3 {
        margin-left: -1.6rem !important
    }

    .m-sm-n4 {
        margin: -2.4rem !important
    }

    .mt-sm-n4,
    .my-sm-n4 {
        margin-top: -2.4rem !important
    }

    .mr-sm-n4,
    .mx-sm-n4 {
        margin-right: -2.4rem !important
    }

    .mb-sm-n4,
    .my-sm-n4 {
        margin-bottom: -2.4rem !important
    }

    .ml-sm-n4,
    .mx-sm-n4 {
        margin-left: -2.4rem !important
    }

    .m-sm-n5 {
        margin: -4.8rem !important
    }

    .mt-sm-n5,
    .my-sm-n5 {
        margin-top: -4.8rem !important
    }

    .mr-sm-n5,
    .mx-sm-n5 {
        margin-right: -4.8rem !important
    }

    .mb-sm-n5,
    .my-sm-n5 {
        margin-bottom: -4.8rem !important
    }

    .ml-sm-n5,
    .mx-sm-n5 {
        margin-left: -4.8rem !important
    }

    .m-sm-auto {
        margin: auto !important
    }

    .mt-sm-auto,
    .my-sm-auto {
        margin-top: auto !important
    }

    .mr-sm-auto,
    .mx-sm-auto {
        margin-right: auto !important
    }

    .mb-sm-auto,
    .my-sm-auto {
        margin-bottom: auto !important
    }

    .ml-sm-auto,
    .mx-sm-auto {
        margin-left: auto !important
    }
}

@media (min-width: 768px) {
    .m-md-0 {
        margin: 0 !important
    }

    .mt-md-0,
    .my-md-0 {
        margin-top: 0 !important
    }

    .mr-md-0,
    .mx-md-0 {
        margin-right: 0 !important
    }

    .mb-md-0,
    .my-md-0 {
        margin-bottom: 0 !important
    }

    .ml-md-0,
    .mx-md-0 {
        margin-left: 0 !important
    }

    .m-md-1 {
        margin: .4rem !important
    }

    .mt-md-1,
    .my-md-1 {
        margin-top: .4rem !important
    }

    .mr-md-1,
    .mx-md-1 {
        margin-right: .4rem !important
    }

    .mb-md-1,
    .my-md-1 {
        margin-bottom: .4rem !important
    }

    .ml-md-1,
    .mx-md-1 {
        margin-left: .4rem !important
    }

    .m-md-2 {
        margin: .8rem !important
    }

    .mt-md-2,
    .my-md-2 {
        margin-top: .8rem !important
    }

    .mr-md-2,
    .mx-md-2 {
        margin-right: .8rem !important
    }

    .mb-md-2,
    .my-md-2 {
        margin-bottom: .8rem !important
    }

    .ml-md-2,
    .mx-md-2 {
        margin-left: .8rem !important
    }

    .m-md-3 {
        margin: 1.6rem !important
    }

    .mt-md-3,
    .my-md-3 {
        margin-top: 1.6rem !important
    }

    .mr-md-3,
    .mx-md-3 {
        margin-right: 1.6rem !important
    }

    .mb-md-3,
    .my-md-3 {
        margin-bottom: 1.6rem !important
    }

    .ml-md-3,
    .mx-md-3 {
        margin-left: 1.6rem !important
    }

    .m-md-4 {
        margin: 2.4rem !important
    }

    .mt-md-4,
    .my-md-4 {
        margin-top: 2.4rem !important
    }

    .mr-md-4,
    .mx-md-4 {
        margin-right: 2.4rem !important
    }

    .mb-md-4,
    .my-md-4 {
        margin-bottom: 2.4rem !important
    }

    .ml-md-4,
    .mx-md-4 {
        margin-left: 2.4rem !important
    }

    .m-md-5 {
        margin: 4.8rem !important
    }

    .mt-md-5,
    .my-md-5 {
        margin-top: 4.8rem !important
    }

    .mr-md-5,
    .mx-md-5 {
        margin-right: 4.8rem !important
    }

    .mb-md-5,
    .my-md-5 {
        margin-bottom: 4.8rem !important
    }

    .ml-md-5,
    .mx-md-5 {
        margin-left: 4.8rem !important
    }

    .p-md-0 {
        padding: 0 !important
    }

    .pt-md-0,
    .py-md-0 {
        padding-top: 0 !important
    }

    .pr-md-0,
    .px-md-0 {
        padding-right: 0 !important
    }

    .pb-md-0,
    .py-md-0 {
        padding-bottom: 0 !important
    }

    .pl-md-0,
    .px-md-0 {
        padding-left: 0 !important
    }

    .p-md-1 {
        padding: .4rem !important
    }

    .pt-md-1,
    .py-md-1 {
        padding-top: .4rem !important
    }

    .pr-md-1,
    .px-md-1 {
        padding-right: .4rem !important
    }

    .pb-md-1,
    .py-md-1 {
        padding-bottom: .4rem !important
    }

    .pl-md-1,
    .px-md-1 {
        padding-left: .4rem !important
    }

    .p-md-2 {
        padding: .8rem !important
    }

    .pt-md-2,
    .py-md-2 {
        padding-top: .8rem !important
    }

    .pr-md-2,
    .px-md-2 {
        padding-right: .8rem !important
    }

    .pb-md-2,
    .py-md-2 {
        padding-bottom: .8rem !important
    }

    .pl-md-2,
    .px-md-2 {
        padding-left: .8rem !important
    }

    .p-md-3 {
        padding: 1.6rem !important
    }

    .pt-md-3,
    .py-md-3 {
        padding-top: 1.6rem !important
    }

    .pr-md-3,
    .px-md-3 {
        padding-right: 1.6rem !important
    }

    .pb-md-3,
    .py-md-3 {
        padding-bottom: 1.6rem !important
    }

    .pl-md-3,
    .px-md-3 {
        padding-left: 1.6rem !important
    }

    .p-md-4 {
        padding: 2.4rem !important
    }

    .pt-md-4,
    .py-md-4 {
        padding-top: 2.4rem !important
    }

    .pr-md-4,
    .px-md-4 {
        padding-right: 2.4rem !important
    }

    .pb-md-4,
    .py-md-4 {
        padding-bottom: 2.4rem !important
    }

    .pl-md-4,
    .px-md-4 {
        padding-left: 2.4rem !important
    }

    .p-md-5 {
        padding: 4.8rem !important
    }

    .pt-md-5,
    .py-md-5 {
        padding-top: 4.8rem !important
    }

    .pr-md-5,
    .px-md-5 {
        padding-right: 4.8rem !important
    }

    .pb-md-5,
    .py-md-5 {
        padding-bottom: 4.8rem !important
    }

    .pl-md-5,
    .px-md-5 {
        padding-left: 4.8rem !important
    }

    .m-md-n1 {
        margin: -.4rem !important
    }

    .mt-md-n1,
    .my-md-n1 {
        margin-top: -.4rem !important
    }

    .mr-md-n1,
    .mx-md-n1 {
        margin-right: -.4rem !important
    }

    .mb-md-n1,
    .my-md-n1 {
        margin-bottom: -.4rem !important
    }

    .ml-md-n1,
    .mx-md-n1 {
        margin-left: -.4rem !important
    }

    .m-md-n2 {
        margin: -.8rem !important
    }

    .mt-md-n2,
    .my-md-n2 {
        margin-top: -.8rem !important
    }

    .mr-md-n2,
    .mx-md-n2 {
        margin-right: -.8rem !important
    }

    .mb-md-n2,
    .my-md-n2 {
        margin-bottom: -.8rem !important
    }

    .ml-md-n2,
    .mx-md-n2 {
        margin-left: -.8rem !important
    }

    .m-md-n3 {
        margin: -1.6rem !important
    }

    .mt-md-n3,
    .my-md-n3 {
        margin-top: -1.6rem !important
    }

    .mr-md-n3,
    .mx-md-n3 {
        margin-right: -1.6rem !important
    }

    .mb-md-n3,
    .my-md-n3 {
        margin-bottom: -1.6rem !important
    }

    .ml-md-n3,
    .mx-md-n3 {
        margin-left: -1.6rem !important
    }

    .m-md-n4 {
        margin: -2.4rem !important
    }

    .mt-md-n4,
    .my-md-n4 {
        margin-top: -2.4rem !important
    }

    .mr-md-n4,
    .mx-md-n4 {
        margin-right: -2.4rem !important
    }

    .mb-md-n4,
    .my-md-n4 {
        margin-bottom: -2.4rem !important
    }

    .ml-md-n4,
    .mx-md-n4 {
        margin-left: -2.4rem !important
    }

    .m-md-n5 {
        margin: -4.8rem !important
    }

    .mt-md-n5,
    .my-md-n5 {
        margin-top: -4.8rem !important
    }

    .mr-md-n5,
    .mx-md-n5 {
        margin-right: -4.8rem !important
    }

    .mb-md-n5,
    .my-md-n5 {
        margin-bottom: -4.8rem !important
    }

    .ml-md-n5,
    .mx-md-n5 {
        margin-left: -4.8rem !important
    }

    .m-md-auto {
        margin: auto !important
    }

    .mt-md-auto,
    .my-md-auto {
        margin-top: auto !important
    }

    .mr-md-auto,
    .mx-md-auto {
        margin-right: auto !important
    }

    .mb-md-auto,
    .my-md-auto {
        margin-bottom: auto !important
    }

    .ml-md-auto,
    .mx-md-auto {
        margin-left: auto !important
    }
}

@media (min-width: 992px) {
    .m-lg-0 {
        margin: 0 !important
    }

    .mt-lg-0,
    .my-lg-0 {
        margin-top: 0 !important
    }

    .mr-lg-0,
    .mx-lg-0 {
        margin-right: 0 !important
    }

    .mb-lg-0,
    .my-lg-0 {
        margin-bottom: 0 !important
    }

    .ml-lg-0,
    .mx-lg-0 {
        margin-left: 0 !important
    }

    .m-lg-1 {
        margin: .4rem !important
    }

    .mt-lg-1,
    .my-lg-1 {
        margin-top: .4rem !important
    }

    .mr-lg-1,
    .mx-lg-1 {
        margin-right: .4rem !important
    }

    .mb-lg-1,
    .my-lg-1 {
        margin-bottom: .4rem !important
    }

    .ml-lg-1,
    .mx-lg-1 {
        margin-left: .4rem !important
    }

    .m-lg-2 {
        margin: .8rem !important
    }

    .mt-lg-2,
    .my-lg-2 {
        margin-top: .8rem !important
    }

    .mr-lg-2,
    .mx-lg-2 {
        margin-right: .8rem !important
    }

    .mb-lg-2,
    .my-lg-2 {
        margin-bottom: .8rem !important
    }

    .ml-lg-2,
    .mx-lg-2 {
        margin-left: .8rem !important
    }

    .m-lg-3 {
        margin: 1.6rem !important
    }

    .mt-lg-3,
    .my-lg-3 {
        margin-top: 1.6rem !important
    }

    .mr-lg-3,
    .mx-lg-3 {
        margin-right: 1.6rem !important
    }

    .mb-lg-3,
    .my-lg-3 {
        margin-bottom: 1.6rem !important
    }

    .ml-lg-3,
    .mx-lg-3 {
        margin-left: 1.6rem !important
    }

    .m-lg-4 {
        margin: 2.4rem !important
    }

    .mt-lg-4,
    .my-lg-4 {
        margin-top: 2.4rem !important
    }

    .mr-lg-4,
    .mx-lg-4 {
        margin-right: 2.4rem !important
    }

    .mb-lg-4,
    .my-lg-4 {
        margin-bottom: 2.4rem !important
    }

    .ml-lg-4,
    .mx-lg-4 {
        margin-left: 2.4rem !important
    }

    .m-lg-5 {
        margin: 4.8rem !important
    }

    .mt-lg-5,
    .my-lg-5 {
        margin-top: 4.8rem !important
    }

    .mr-lg-5,
    .mx-lg-5 {
        margin-right: 4.8rem !important
    }

    .mb-lg-5,
    .my-lg-5 {
        margin-bottom: 4.8rem !important
    }

    .ml-lg-5,
    .mx-lg-5 {
        margin-left: 4.8rem !important
    }

    .p-lg-0 {
        padding: 0 !important
    }

    .pt-lg-0,
    .py-lg-0 {
        padding-top: 0 !important
    }

    .pr-lg-0,
    .px-lg-0 {
        padding-right: 0 !important
    }

    .pb-lg-0,
    .py-lg-0 {
        padding-bottom: 0 !important
    }

    .pl-lg-0,
    .px-lg-0 {
        padding-left: 0 !important
    }

    .p-lg-1 {
        padding: .4rem !important
    }

    .pt-lg-1,
    .py-lg-1 {
        padding-top: .4rem !important
    }

    .pr-lg-1,
    .px-lg-1 {
        padding-right: .4rem !important
    }

    .pb-lg-1,
    .py-lg-1 {
        padding-bottom: .4rem !important
    }

    .pl-lg-1,
    .px-lg-1 {
        padding-left: .4rem !important
    }

    .p-lg-2 {
        padding: .8rem !important
    }

    .pt-lg-2,
    .py-lg-2 {
        padding-top: .8rem !important
    }

    .pr-lg-2,
    .px-lg-2 {
        padding-right: .8rem !important
    }

    .pb-lg-2,
    .py-lg-2 {
        padding-bottom: .8rem !important
    }

    .pl-lg-2,
    .px-lg-2 {
        padding-left: .8rem !important
    }

    .p-lg-3 {
        padding: 1.6rem !important
    }

    .pt-lg-3,
    .py-lg-3 {
        padding-top: 1.6rem !important
    }

    .pr-lg-3,
    .px-lg-3 {
        padding-right: 1.6rem !important
    }

    .pb-lg-3,
    .py-lg-3 {
        padding-bottom: 1.6rem !important
    }

    .pl-lg-3,
    .px-lg-3 {
        padding-left: 1.6rem !important
    }

    .p-lg-4 {
        padding: 2.4rem !important
    }

    .pt-lg-4,
    .py-lg-4 {
        padding-top: 2.4rem !important
    }

    .pr-lg-4,
    .px-lg-4 {
        padding-right: 2.4rem !important
    }

    .pb-lg-4,
    .py-lg-4 {
        padding-bottom: 2.4rem !important
    }

    .pl-lg-4,
    .px-lg-4 {
        padding-left: 2.4rem !important
    }

    .p-lg-5 {
        padding: 4.8rem !important
    }

    .pt-lg-5,
    .py-lg-5 {
        padding-top: 4.8rem !important
    }

    .pr-lg-5,
    .px-lg-5 {
        padding-right: 4.8rem !important
    }

    .pb-lg-5,
    .py-lg-5 {
        padding-bottom: 4.8rem !important
    }

    .pl-lg-5,
    .px-lg-5 {
        padding-left: 4.8rem !important
    }

    .m-lg-n1 {
        margin: -.4rem !important
    }

    .mt-lg-n1,
    .my-lg-n1 {
        margin-top: -.4rem !important
    }

    .mr-lg-n1,
    .mx-lg-n1 {
        margin-right: -.4rem !important
    }

    .mb-lg-n1,
    .my-lg-n1 {
        margin-bottom: -.4rem !important
    }

    .ml-lg-n1,
    .mx-lg-n1 {
        margin-left: -.4rem !important
    }

    .m-lg-n2 {
        margin: -.8rem !important
    }

    .mt-lg-n2,
    .my-lg-n2 {
        margin-top: -.8rem !important
    }

    .mr-lg-n2,
    .mx-lg-n2 {
        margin-right: -.8rem !important
    }

    .mb-lg-n2,
    .my-lg-n2 {
        margin-bottom: -.8rem !important
    }

    .ml-lg-n2,
    .mx-lg-n2 {
        margin-left: -.8rem !important
    }

    .m-lg-n3 {
        margin: -1.6rem !important
    }

    .mt-lg-n3,
    .my-lg-n3 {
        margin-top: -1.6rem !important
    }

    .mr-lg-n3,
    .mx-lg-n3 {
        margin-right: -1.6rem !important
    }

    .mb-lg-n3,
    .my-lg-n3 {
        margin-bottom: -1.6rem !important
    }

    .ml-lg-n3,
    .mx-lg-n3 {
        margin-left: -1.6rem !important
    }

    .m-lg-n4 {
        margin: -2.4rem !important
    }

    .mt-lg-n4,
    .my-lg-n4 {
        margin-top: -2.4rem !important
    }

    .mr-lg-n4,
    .mx-lg-n4 {
        margin-right: -2.4rem !important
    }

    .mb-lg-n4,
    .my-lg-n4 {
        margin-bottom: -2.4rem !important
    }

    .ml-lg-n4,
    .mx-lg-n4 {
        margin-left: -2.4rem !important
    }

    .m-lg-n5 {
        margin: -4.8rem !important
    }

    .mt-lg-n5,
    .my-lg-n5 {
        margin-top: -4.8rem !important
    }

    .mr-lg-n5,
    .mx-lg-n5 {
        margin-right: -4.8rem !important
    }

    .mb-lg-n5,
    .my-lg-n5 {
        margin-bottom: -4.8rem !important
    }

    .ml-lg-n5,
    .mx-lg-n5 {
        margin-left: -4.8rem !important
    }

    .m-lg-auto {
        margin: auto !important
    }

    .mt-lg-auto,
    .my-lg-auto {
        margin-top: auto !important
    }

    .mr-lg-auto,
    .mx-lg-auto {
        margin-right: auto !important
    }

    .mb-lg-auto,
    .my-lg-auto {
        margin-bottom: auto !important
    }

    .ml-lg-auto,
    .mx-lg-auto {
        margin-left: auto !important
    }
}

@media (min-width: 1200px) {
    .m-xl-0 {
        margin: 0 !important
    }

    .mt-xl-0,
    .my-xl-0 {
        margin-top: 0 !important
    }

    .mr-xl-0,
    .mx-xl-0 {
        margin-right: 0 !important
    }

    .mb-xl-0,
    .my-xl-0 {
        margin-bottom: 0 !important
    }

    .ml-xl-0,
    .mx-xl-0 {
        margin-left: 0 !important
    }

    .m-xl-1 {
        margin: .4rem !important
    }

    .mt-xl-1,
    .my-xl-1 {
        margin-top: .4rem !important
    }

    .mr-xl-1,
    .mx-xl-1 {
        margin-right: .4rem !important
    }

    .mb-xl-1,
    .my-xl-1 {
        margin-bottom: .4rem !important
    }

    .ml-xl-1,
    .mx-xl-1 {
        margin-left: .4rem !important
    }

    .m-xl-2 {
        margin: .8rem !important
    }

    .mt-xl-2,
    .my-xl-2 {
        margin-top: .8rem !important
    }

    .mr-xl-2,
    .mx-xl-2 {
        margin-right: .8rem !important
    }

    .mb-xl-2,
    .my-xl-2 {
        margin-bottom: .8rem !important
    }

    .ml-xl-2,
    .mx-xl-2 {
        margin-left: .8rem !important
    }

    .m-xl-3 {
        margin: 1.6rem !important
    }

    .mt-xl-3,
    .my-xl-3 {
        margin-top: 1.6rem !important
    }

    .mr-xl-3,
    .mx-xl-3 {
        margin-right: 1.6rem !important
    }

    .mb-xl-3,
    .my-xl-3 {
        margin-bottom: 1.6rem !important
    }

    .ml-xl-3,
    .mx-xl-3 {
        margin-left: 1.6rem !important
    }

    .m-xl-4 {
        margin: 2.4rem !important
    }

    .mt-xl-4,
    .my-xl-4 {
        margin-top: 2.4rem !important
    }

    .mr-xl-4,
    .mx-xl-4 {
        margin-right: 2.4rem !important
    }

    .mb-xl-4,
    .my-xl-4 {
        margin-bottom: 2.4rem !important
    }

    .ml-xl-4,
    .mx-xl-4 {
        margin-left: 2.4rem !important
    }

    .m-xl-5 {
        margin: 4.8rem !important
    }

    .mt-xl-5,
    .my-xl-5 {
        margin-top: 4.8rem !important
    }

    .mr-xl-5,
    .mx-xl-5 {
        margin-right: 4.8rem !important
    }

    .mb-xl-5,
    .my-xl-5 {
        margin-bottom: 4.8rem !important
    }

    .ml-xl-5,
    .mx-xl-5 {
        margin-left: 4.8rem !important
    }

    .p-xl-0 {
        padding: 0 !important
    }

    .pt-xl-0,
    .py-xl-0 {
        padding-top: 0 !important
    }

    .pr-xl-0,
    .px-xl-0 {
        padding-right: 0 !important
    }

    .pb-xl-0,
    .py-xl-0 {
        padding-bottom: 0 !important
    }

    .pl-xl-0,
    .px-xl-0 {
        padding-left: 0 !important
    }

    .p-xl-1 {
        padding: .4rem !important
    }

    .pt-xl-1,
    .py-xl-1 {
        padding-top: .4rem !important
    }

    .pr-xl-1,
    .px-xl-1 {
        padding-right: .4rem !important
    }

    .pb-xl-1,
    .py-xl-1 {
        padding-bottom: .4rem !important
    }

    .pl-xl-1,
    .px-xl-1 {
        padding-left: .4rem !important
    }

    .p-xl-2 {
        padding: .8rem !important
    }

    .pt-xl-2,
    .py-xl-2 {
        padding-top: .8rem !important
    }

    .pr-xl-2,
    .px-xl-2 {
        padding-right: .8rem !important
    }

    .pb-xl-2,
    .py-xl-2 {
        padding-bottom: .8rem !important
    }

    .pl-xl-2,
    .px-xl-2 {
        padding-left: .8rem !important
    }

    .p-xl-3 {
        padding: 1.6rem !important
    }

    .pt-xl-3,
    .py-xl-3 {
        padding-top: 1.6rem !important
    }

    .pr-xl-3,
    .px-xl-3 {
        padding-right: 1.6rem !important
    }

    .pb-xl-3,
    .py-xl-3 {
        padding-bottom: 1.6rem !important
    }

    .pl-xl-3,
    .px-xl-3 {
        padding-left: 1.6rem !important
    }

    .p-xl-4 {
        padding: 2.4rem !important
    }

    .pt-xl-4,
    .py-xl-4 {
        padding-top: 2.4rem !important
    }

    .pr-xl-4,
    .px-xl-4 {
        padding-right: 2.4rem !important
    }

    .pb-xl-4,
    .py-xl-4 {
        padding-bottom: 2.4rem !important
    }

    .pl-xl-4,
    .px-xl-4 {
        padding-left: 2.4rem !important
    }

    .p-xl-5 {
        padding: 4.8rem !important
    }

    .pt-xl-5,
    .py-xl-5 {
        padding-top: 4.8rem !important
    }

    .pr-xl-5,
    .px-xl-5 {
        padding-right: 4.8rem !important
    }

    .pb-xl-5,
    .py-xl-5 {
        padding-bottom: 4.8rem !important
    }

    .pl-xl-5,
    .px-xl-5 {
        padding-left: 4.8rem !important
    }

    .m-xl-n1 {
        margin: -.4rem !important
    }

    .mt-xl-n1,
    .my-xl-n1 {
        margin-top: -.4rem !important
    }

    .mr-xl-n1,
    .mx-xl-n1 {
        margin-right: -.4rem !important
    }

    .mb-xl-n1,
    .my-xl-n1 {
        margin-bottom: -.4rem !important
    }

    .ml-xl-n1,
    .mx-xl-n1 {
        margin-left: -.4rem !important
    }

    .m-xl-n2 {
        margin: -.8rem !important
    }

    .mt-xl-n2,
    .my-xl-n2 {
        margin-top: -.8rem !important
    }

    .mr-xl-n2,
    .mx-xl-n2 {
        margin-right: -.8rem !important
    }

    .mb-xl-n2,
    .my-xl-n2 {
        margin-bottom: -.8rem !important
    }

    .ml-xl-n2,
    .mx-xl-n2 {
        margin-left: -.8rem !important
    }

    .m-xl-n3 {
        margin: -1.6rem !important
    }

    .mt-xl-n3,
    .my-xl-n3 {
        margin-top: -1.6rem !important
    }

    .mr-xl-n3,
    .mx-xl-n3 {
        margin-right: -1.6rem !important
    }

    .mb-xl-n3,
    .my-xl-n3 {
        margin-bottom: -1.6rem !important
    }

    .ml-xl-n3,
    .mx-xl-n3 {
        margin-left: -1.6rem !important
    }

    .m-xl-n4 {
        margin: -2.4rem !important
    }

    .mt-xl-n4,
    .my-xl-n4 {
        margin-top: -2.4rem !important
    }

    .mr-xl-n4,
    .mx-xl-n4 {
        margin-right: -2.4rem !important
    }

    .mb-xl-n4,
    .my-xl-n4 {
        margin-bottom: -2.4rem !important
    }

    .ml-xl-n4,
    .mx-xl-n4 {
        margin-left: -2.4rem !important
    }

    .m-xl-n5 {
        margin: -4.8rem !important
    }

    .mt-xl-n5,
    .my-xl-n5 {
        margin-top: -4.8rem !important
    }

    .mr-xl-n5,
    .mx-xl-n5 {
        margin-right: -4.8rem !important
    }

    .mb-xl-n5,
    .my-xl-n5 {
        margin-bottom: -4.8rem !important
    }

    .ml-xl-n5,
    .mx-xl-n5 {
        margin-left: -4.8rem !important
    }

    .m-xl-auto {
        margin: auto !important
    }

    .mt-xl-auto,
    .my-xl-auto {
        margin-top: auto !important
    }

    .mr-xl-auto,
    .mx-xl-auto {
        margin-right: auto !important
    }

    .mb-xl-auto,
    .my-xl-auto {
        margin-bottom: auto !important
    }

    .ml-xl-auto,
    .mx-xl-auto {
        margin-left: auto !important
    }
}

.text-monospace {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important
}

.text-justify {
    text-align: justify !important
}

.text-wrap {
    white-space: normal !important
}

.text-nowrap {
    white-space: nowrap !important
}

.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.text-left {
    text-align: left !important
}

.text-right {
    text-align: right !important
}

.text-center {
    text-align: center !important
}

@media (min-width: 576px) {
    .text-sm-left {
        text-align: left !important
    }

    .text-sm-right {
        text-align: right !important
    }

    .text-sm-center {
        text-align: center !important
    }
}

@media (min-width: 768px) {
    .text-md-left {
        text-align: left !important
    }

    .text-md-right {
        text-align: right !important
    }

    .text-md-center {
        text-align: center !important
    }
}

@media (min-width: 992px) {
    .text-lg-left {
        text-align: left !important
    }

    .text-lg-right {
        text-align: right !important
    }

    .text-lg-center {
        text-align: center !important
    }
}

@media (min-width: 1200px) {
    .text-xl-left {
        text-align: left !important
    }

    .text-xl-right {
        text-align: right !important
    }

    .text-xl-center {
        text-align: center !important
    }
}

.text-lowercase {
    text-transform: lowercase !important
}

.text-uppercase {
    text-transform: uppercase !important
}

.text-capitalize {
    text-transform: capitalize !important
}

.font-weight-light {
    font-weight: 300 !important
}

.font-weight-lighter {
    font-weight: lighter !important
}

.font-weight-normal {
    font-weight: 400 !important
}

.font-weight-bold {
    font-weight: 700 !important
}

.font-weight-bolder {
    font-weight: bolder !important
}

.font-italic {
    font-style: italic !important
}

.text-white {
    color: #fff !important
}

.text-primary {
    color: #007bff !important
}

a.text-primary:focus,
a.text-primary:hover {
    color: rgb(0, 86.1, 178.5) !important
}

.text-secondary {
    color: #6c757d !important
}

a.text-secondary:focus,
a.text-secondary:hover {
    color: rgb(72.5407725322, 78.5858369099, 83.9592274678) !important
}

.text-success {
    color: #28a745 !important
}

a.text-success:focus,
a.text-success:hover {
    color: rgb(25.2173913043, 105.2826086957, 43.5) !important
}

.text-info {
    color: #17a2b8 !important
}

a.text-info:focus,
a.text-info:hover {
    color: rgb(14.5, 102.1304347826, 116) !important
}

.text-warning {
    color: #ffc107 !important
}

a.text-warning:focus,
a.text-warning:hover {
    color: rgb(185.5, 139.125, 0) !important
}

.text-danger {
    color: #dc3545 !important
}

a.text-danger:focus,
a.text-danger:hover {
    color: rgb(167.4810126582, 29.0189873418, 42.2848101266) !important
}

.text-light {
    color: #f8f9fa !important
}

a.text-light:focus,
a.text-light:hover {
    color: rgb(203.375, 210.75, 218.125) !important
}

.text-dark {
    color: #343a40 !important
}

a.text-dark:focus,
a.text-dark:hover {
    color: rgb(17.7068965517, 19.75, 21.7931034483) !important
}

.text-body {
    color: #212529 !important
}

.text-muted {
    color: #6c757d !important
}

.text-black-50 {
    color: rgba(0, 0, 0, .5) !important
}

.text-white-50 {
    color: rgba(255, 255, 255, .5) !important
}

.text-hide {
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0
}

.text-decoration-none {
    text-decoration: none !important
}

.text-break {
    word-break: break-word !important;
    overflow-wrap: break-word !important
}

.text-reset {
    color: inherit !important
}

.visible {
    visibility: visible !important
}

.invisible {
    visibility: hidden !important
}

@media print {

    *,
    ::after,
    ::before {
        text-shadow: none !important;
        box-shadow: none !important
    }

    a:not(.btn) {
        text-decoration: underline
    }

    abbr[title]::after {
        content: " (" attr(title) ")"
    }

    pre {
        white-space: pre-wrap !important
    }

    blockquote,
    pre {
        border: 1px solid #adb5bd;
        page-break-inside: avoid
    }

    thead {
        display: table-header-group
    }

    img,
    tr {
        page-break-inside: avoid
    }

    h2,
    h3,
    p {
        orphans: 3;
        widows: 3
    }

    h2,
    h3 {
        page-break-after: avoid
    }

    @page {
        size: a3
    }

    body {
        min-width: 992px !important
    }

    .container {
        min-width: 992px !important
    }

    .navbar {
        display: none
    }

    .badge {
        border: 1px solid #000
    }

    .table {
        border-collapse: collapse !important
    }

    .table td,
    .table th {
        background-color: #fff !important
    }

    .table-bordered td,
    .table-bordered th {
        border: 1px solid #dee2e6 !important
    }

    .table-dark {
        color: inherit
    }

    .table-dark tbody+tbody,
    .table-dark td,
    .table-dark th,
    .table-dark thead th {
        border-color: #dee2e6
    }

    .table .thead-dark th {
        color: inherit;
        border-color: #dee2e6
    }
}

.btn,
.btn-100-primary,
.btn-primary,
.theme-100 .btn,
.theme-100 .btn-primary,
.theme-100 a.btn-primary,
a.btn,
a.btn-100-primary,
a.btn-primary {
    border-radius: 20px;
    display: inline-flex;
    min-height: 40px;
    color: var(--text-color);
    border: none;
    font-weight: 700;
    text-decoration: none !important;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    --text-color: var(--btn-txt-color);
    padding: 0 25px;
    min-width: 165px;
    background-color: var(--color-light-blue);
    box-shadow: 0 10px 17px -10px rgba(0, 0, 0, .5);
    text-align: center;
    transition: background-color .3s ease, box-shadow .3s ease
}

.btn-100-primary:hover,
.btn-primary:hover,
.btn:hover,
a.btn-primary:hover {
    color: var(--text-color)
}

.btn a,
.btn-100-primary a,
.btn-primary a,
.theme-100 .btn a,
.theme-100 .btn-primary a,
a.btn-primary a {
    color: inherit
}

.btn-100-primary:hover,
.btn-primary:hover,
.btn:hover,
a.btn-primary:hover {
    box-shadow: none;
    background-color: hsl(var(--color-light-blue-h), var(--color-light-blue-s), calc(var(--color-light-blue-l) - 10%))
}

.btn--inverted,
.btn-secondary,
a.btn-secondary {
    border-radius: 20px;
    display: inline-flex;
    color: var(--text-color);
    border: none;
    font-weight: 700;
    text-decoration: none !important;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    min-height: 37px;
    padding: 0 25px;
    background-color: transparent;
    text-align: center;
    min-width: 165px;
    transition: box-shadow .3s ease, color .3s ease;
    box-shadow: 0 0 0 1.5px var(--color-light-blue)
}

.btn--inverted:hover,
.btn-secondary:hover,
a.btn-secondary:hover {
    color: var(--text-color)
}

.btn--inverted a,
.btn-secondary a,
a.btn-secondary a {
    color: inherit
}

.btn--inverted:hover,
.btn-secondary:hover,
a.btn-secondary:hover {
    box-shadow: 0 0 0 3px var(--color-light-blue)
}

.btn-tertiary,
a.btn-tertiary {
    border-radius: 20px;
    display: inline-flex;
    color: var(--text-color);
    border: none;
    font-weight: 700;
    text-decoration: none !important;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 0;
    box-shadow: 0 1.5px 0 0 var(--color-light-blue);
    padding: 0;
    min-height: 25px;
    background-color: transparent;
    transition: box-shadow .3s ease, color .3s ease
}

.btn-tertiary:hover,
a.btn-tertiary:hover {
    color: var(--text-color)
}

.btn-tertiary a,
a.btn-tertiary a {
    color: inherit
}

.btn-tertiary:hover,
a.btn-tertiary:hover {
    box-shadow: 0 3px 0 0 var(--color-light-blue)
}

.btn-100-primary,
.theme-100 .btn,
.theme-100 .btn-100-primary,
.theme-100 .btn-primary,
.theme-100 a.btn-primary,
a.btn-100-primary {
    border-radius: 20px;
    display: inline-flex;
    min-height: 40px;
    color: var(--text-color);
    border: none;
    font-weight: 700;
    text-decoration: none !important;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    --text-color: #FFFFFF;
    --bg-pos-X: 0%;
    --bg-pos-Y: 0%;
    --bg-opacity: 0;
    --bg-width: 100px;
    background-image: linear-gradient(-55deg, #e04f39 0, #e0457b 50%, #0077c8 100%);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
    overflow: hidden
}

.btn-100-primary:hover,
.theme-100 .btn-primary:hover,
.theme-100 .btn:hover,
.theme-100 a.btn-primary:hover,
a.btn-100-primary:hover {
    color: var(--text-color)
}

.btn-100-primary a,
.theme-100 .btn a,
.theme-100 .btn-100-primary a,
.theme-100 .btn-primary a,
.theme-100 a.btn-primary a,
a.btn-100-primary a {
    color: inherit
}

.btn-100-primary::before,
.theme-100 .btn-100-primary::before,
.theme-100 .btn-primary::before,
.theme-100 .btn::before,
.theme-100 a.btn-primary::before,
a.btn-100-primary::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(255, 255, 255, .3) 0, rgba(0, 0, 0, 0) 50%);
    background-repeat: no-repeat;
    background-size: var(--bg-width) var(--bg-width);
    background-position: var(--bg-pos-X) var(--bg-pos-Y);
    opacity: 1;
    transition: opacity .3s ease
}

.btn-100-primary:hover,
.theme-100 .btn-primary:hover,
.theme-100 .btn:hover,
.theme-100 a.btn-primary:hover,
a.btn-100-primary:hover {
    box-shadow: none
}

.btn-100-primary:hover::before,
.theme-100 .btn-primary:hover::before,
.theme-100 .btn:hover::before,
.theme-100 a.btn-primary:hover::before,
a.btn-100-primary:hover::before {
    opacity: 1
}

.btn-100-tertiary,
.theme-100 .btn-tertiary,
.theme-100 a.btn-tertiary,
a.btn-100-tertiary {
    border-radius: 20px;
    display: inline-flex;
    min-height: 40px;
    color: var(--text-color);
    border: none;
    font-weight: 700;
    text-decoration: none !important;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #000;
    border-radius: 0;
    min-height: unset;
    padding: 0;
    --color-light-blue: #000000;
    background-color: transparent;
    box-shadow: none;
    transition: box-shadow .3s ease, color .3s ease;
    position: relative
}

.btn-100-tertiary:hover,
.theme-100 .btn-tertiary:hover,
.theme-100 a.btn-tertiary:hover,
a.btn-100-tertiary:hover {
    color: var(--text-color)
}

.btn-100-tertiary a,
.theme-100 .btn-tertiary a,
.theme-100 a.btn-tertiary a,
a.btn-100-tertiary a {
    color: inherit
}

.btn-100-tertiary::before,
.theme-100 .btn-tertiary::before,
.theme-100 a.btn-tertiary::before,
a.btn-100-tertiary::before {
    content: "";
    position: absolute;
    height: 1px;
    width: 100%;
    transform: scaleY(1.5);
    bottom: 0;
    left: 0;
    background: linear-gradient(-55deg, #e04f39 0, #e0457b 50%, #0077c8 100%);
    transition: transform .3s ease
}

.btn-100-tertiary:hover::before,
.theme-100 .btn-tertiary:hover::before,
.theme-100 a.btn-tertiary:hover::before,
a.btn-100-tertiary:hover::before {
    transform: scaleY(3)
}

.layout__black .btn-100-tertiary,
.layout__black .theme-100 .btn-tertiary,
.layout__black .theme-100 a.btn-tertiary,
.layout__black a.btn-100-tertiary,
.layout__blue .btn-100-tertiary,
.layout__blue .theme-100 .btn-tertiary,
.layout__blue .theme-100 a.btn-tertiary,
.layout__blue a.btn-100-tertiary,
.layout__dark_grey .btn-100-tertiary,
.layout__dark_grey .theme-100 .btn-tertiary,
.layout__dark_grey .theme-100 a.btn-tertiary,
.layout__dark_grey a.btn-100-tertiary,
.layout__light_blue .btn-100-tertiary,
.layout__light_blue .theme-100 .btn-tertiary,
.layout__light_blue .theme-100 a.btn-tertiary,
.layout__light_blue a.btn-100-tertiary {
    color: #fff
}

.layout__black,
.wrapper__elipsis__black {
    --bg-color: #000000;
    --text-color: #FFFFFF
}

.layout__blue,
.wrapper__elipsis__blue {
    --bg-color: #041E42;
    --text-color: #FFFFFF;
    box-shadow: #041e42 0 .2rem 0 0
}

.layout__dark_grey,
.wrapper__elipsis__dark_grey {
    --bg-color: #484B4D;
    --text-color: #FFFFFF
}

.layout__light_blue,
.wrapper__elipsis__light_blue {
    --bg-color: #0077C8;
    --text-color: #FFFFFF
}

.layout__white,
.wrapper__elipsis__white {
    --bg-color: #FFFFFF;
    --text-color: #041E42
}

.layout__grey,
.wrapper__elipsis__grey {
    --bg-color: #F2F6F8;
    --text-color: #041E42
}

.layout__grey__white,
.wrapper__elipsis__grey__white {
    --bg-color: linear-gradient(0deg, #FFFFFF 0%, #FFFFFF 50%, #F2F6F8 50%, #F2F6F8 100%);
    --text-color: #041E42;
    flex: 0 1 auto
}

.layout__gradient_blue,
.wrapper__elipsis__gradient_blue {
    --bg-color: linear-gradient(90deg, #1791F9 0%, #4FFAFE 100%);
    --text-color: #000000
}

#toolbar-administration {
    position: relative;
    z-index: 2000
}

.ui-dialog {
    z-index: 501 !important
}

.alt-font {
    --secondary-font: "Roboto Flex"
}

.alt-font>:not(xlarge):not(h1):not(h2):not(h3):not(h4) {
    font-family: var(--secondary-font)
}

main[role=main] {
    position: relative
}

main[role=main].main--menu-hidden {
    margin-top: 0
}

.toolbar-horizontal.toolbar-tray-open main[role=main].main--with-header-bar {
    margin-top: 94px
}

@media (min-width: 992px) {
    .toolbar-horizontal.toolbar-tray-open main[role=main].main--with-header-bar {
        margin-top: 130px
    }
}

.toolbar-horizontal.toolbar-tray-open main[role=main].main--with-header-bar.main--menu-hidden {
    margin-top: 0
}

.error-message {
    font-size: .8em;
    color: #e21b23
}

.webform-submission-form .form-item .form-date.error,
.webform-submission-form .form-item .form-email.error,
.webform-submission-form .form-item .form-tel.error,
.webform-submission-form .form-item .form-text.error,
.webform-submission-form .form-item .form-url.error {
    border-bottom-color: #e21b23
}

.icon-360 {
    width: 90px;
    height: 90px;
    margin: 50px 0;
    cursor: pointer
}

.icon-360__circle {
    fill: #41b6e6
}

.icon-360__arrow {
    fill: #fff;
    animation-name: spin;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    transform-origin: 44px 45px
}

@keyframes spin {
    0% {
        transform: translate(45 45);
        transform: rotate(0)
    }

    50% {
        transform: translate(45 45);
        transform: rotate(360deg)
    }

    100% {
        transform: translate(45 45);
        transform: rotate(360deg)
    }
}

.icon-360__360 {
    fill: #fff
}

.icon-360__loader {
    position: absolute;
    border: 16px solid #fff;
    border-top: 16px solid #04325e;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
    top: 25%;
    left: 0;
    right: 0;
    margin: auto;
    filter: none;
    visibility: hidden;
    z-index: 9999
}

.icon-360__loader:hover {
    cursor: wait
}

@keyframes spin {
    0% {
        transform: rotate(0)
    }

    100% {
        transform: rotate(360deg)
    }
}

.threesixty:hover {
    cursor: ew-resize
}

.anchor-list>div {
    display: inline-block
}

.anchor-list>div>div>a {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 700;
    font-size: 1.8rem;
    line-height: .89em;
    color: #41b6e6;
    border-bottom: 2px solid #41b6e6;
    margin-bottom: 19px;
    padding-bottom: 19px
}

.anchor-list>div>div>a:after {
    content: " ";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100%;
    margin-left: 30px;
    width: 18px;
    height: 18px;
    transition: transform .3s;
    right: 0
}

.anchor-list>div>div>a:hover {
    text-decoration: none
}

.anchor-list>div>div>a:hover:after {
    transform: translateX(5px)
}

.anchor-list>div>div:first-child>a {
    margin-top: 19px
}

.anchor-list>div>div:last-child>a {
    border-bottom: none !important;
    padding-bottom: 0
}

.anchor-list__dark>div>div>a {
    color: #041e42;
    border-bottom: 2px solid #041e42
}

/* 
.anchor-list__dark>div>div>a:after {
    background-image: url(/src/images/icons/arrow-next-dark-blue.svg)
} */

.article_list__gobackurl {
    font-size: 1.8rem;
    line-height: 1.33em;
    color: #04325e;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    padding-bottom: 5px
}

.article_list__gobackurl--leftshift {
    left: 0
}

.article_list__social_media__caption {
    display: none
}

.views-element-container .article_list__social_media {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -10px
}

.views-element-container .article_list__social_media .social-media__title {
    display: none
}

.views-element-container .article_list__social_media__caption {
    display: block;
    margin-right: 15px
}

.views-element-container .article_list__social_media__caption--modifier {
    font-size: 1.6rem
}

.views-element-container .article_list__social_media ul.menu--social-media.social-media__nav {
    margin-bottom: 0
}

@media (max-width: 991.98px) {
    .views-element-container .article_list__social_media {
        display: none
    }
}

.article_list .views-element-container .menu--social-media.social-media__nav .social-media__nav__icon {
    width: 4.8rem;
    height: 4.8rem
}

.article-long-summary {
    margin: 0 5px;
    background-color: #fff;
    border-bottom: 2px solid #f2f6f8
}

@media (min-width: 992px) {
    .article-long-summary {
        margin: 50px 0;
        background-color: #f2f6f8;
        border-bottom: none
    }
}

.article-long-summary .field--field-long-summary-image {
    height: 100%
}

.article-long-summary .field--field-long-summary-image .drupal-media {
    height: 100%
}

.article-long-summary .field--field-long-summary-image .drupal-media .drupal-media__image {
    height: 100%
}

.article-long-summary .field--field-long-summary-image .drupal-media .drupal-media__image img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover
}

.article-long-summary .article-long-summary--featured {
    background-color: #041e42
}

@media (min-width: 992px) {
    .article-long-summary .article-long-summary--featured {
        min-height: 436px
    }
}

@media (min-width: 1200px) {
    .article-long-summary .article-long-summary--featured {
        min-height: 489px
    }
}

.article-long-summary .article-long-summary--featured .article-image {
    display: block;
    padding-bottom: 0
}

@media (min-width: 992px) {
    .article-long-summary .article-long-summary--featured .long-summary-description {
        padding-bottom: 20px
    }
}

@media (min-width: 1200px) {
    .article-long-summary .article-long-summary--featured .long-summary-description {
        padding-bottom: 40px
    }
}

.article-long-summary .article-text {
    padding: 25px 50px 20px 27px
}

@media (min-width: 992px) {
    .article-long-summary .article-text {
        padding: 85px 100px 85px 65px
    }
}

.article-long-summary .article-title .node-title {
    font-size: 2.4rem;
    line-height: 3rem;
    font-weight: 600
}

.article-long-summary .article-date {
    padding-bottom: 20px;
    font-size: 1.4rem
}

@media (min-width: 992px) {
    .article-long-summary .article-date {
        padding-bottom: 30px
    }
}

.article-long-summary .long-summary-description {
    padding-bottom: 40px;
    display: none
}

@media (min-width: 992px) {
    .article-long-summary .long-summary-description {
        display: block
    }
}

.article-long-summary .article-category {
    padding-bottom: 10px
}

@media (min-width: 992px) {
    .article-long-summary .article-category {
        padding-bottom: 30px
    }
}

.article-long-summary .article-image {
    background-size: cover;
    padding-bottom: 100%;
    display: none
}

@media (min-width: 992px) {
    .article-long-summary .article-image {
        padding-bottom: 0;
        display: block
    }
}

.article-long-summary .article-text a:hover {
    text-decoration: none
}

@media screen and (max-width: 991px) {
    #views-exposed-form-article-list-block-article-list {
        padding-bottom: 36px
    }
}

#views-exposed-form-article-list-block-article-list .form-radios {
    margin: 0;
    padding: 0
}

#views-exposed-form-article-list-block-article-list .form-select {
    padding: 0;
    border: none;
    background: 0 0
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id {
    display: inline-block
}

@media (min-width: 768px) and (max-width:991.98px) {
    #views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id {
        margin-bottom: 20px
    }
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-select.bef-links {
    padding: 0;
    border: none;
    background: 0 0
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id a.bef-links {
    opacity: 0;
    position: fixed;
    width: 0
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios {
    display: flex
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios .js-form-item {
    list-style: none
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios .js-form-item a {
    display: inline-block;
    font-size: 1.8rem;
    line-height: 1.33em;
    color: #04325e;
    font-weight: 700;
    margin: 0 20px;
    padding-bottom: 5px
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios .js-form-item a:first-child {
    margin-left: 0
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios .js-form-item a.bef-link--selected,
#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios .js-form-item a:hover {
    color: #41b6e6;
    border-bottom: 4px solid #41b6e6
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id a,
#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id label {
    font-size: 1.8rem;
    line-height: 1.33em;
    color: #04325e;
    font-weight: 700;
    margin: 0 10px;
    padding-bottom: 5px
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id a:first-child,
#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id label:first-child {
    margin-left: 0
}

#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .bef-link--selected,
#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id a:hover {
    color: #41b6e6;
    border-bottom: 4px solid #41b6e6
}

#views-exposed-form-article-list-block-article-list input[type=submit] {
    display: none
}

#views-exposed-form-article-list-block-article-list .btn-pager-category {
    display: none
}

#views-exposed-form-article-list-block-article-list .btn-after,
#views-exposed-form-article-list-block-article-list .btn-before {
    display: none
}

@media (max-width: 767.98px) {

    #views-exposed-form-article-list-block-article-list .btn-after,
    #views-exposed-form-article-list-block-article-list .btn-before {
        display: block
    }
}

@media (min-width: 992px) {
    #views-exposed-form-article-list-block-article-list .article-list-filters {
        margin-bottom: 25px
    }
}

@media (max-width: 767.98px) {
    #views-exposed-form-article-list-block-article-list fieldset {
        position: relative
    }

    #views-exposed-form-article-list-block-article-list fieldset .article-list-filters {
        position: relative
    }

    #views-exposed-form-article-list-block-article-list fieldset .article-list-filters .btn-pager-category {
        position: absolute;
        top: 3px;
        z-index: 1;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
        background-size: contain;
        background-repeat: no-repeat;
        text-indent: -9999px;
        outline: 0;
        height: 14px;
        width: 14px
    }

    #views-exposed-form-article-list-block-article-list fieldset .article-list-filters .btn-next-category {
        display: block;
        right: 5px;
        transform: rotate(-90deg)
    }

    #views-exposed-form-article-list-block-article-list fieldset .article-list-filters .btn-previous-category {
        left: 0;
        transform: rotate(90deg)
    }

    #views-exposed-form-article-list-block-article-list fieldset.after-gradient:after {
        content: "";
        display: block;
        width: 95px;
        position: absolute;
        height: 30px;
        top: 0;
        right: 0;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff);
        pointer-events: none
    }

    #views-exposed-form-article-list-block-article-list fieldset.before-gradient:before {
        content: "";
        display: block;
        width: 95px;
        position: absolute;
        height: 30px;
        top: 0;
        left: 0;
        background: linear-gradient(to left, rgba(255, 255, 255, 0), #fff);
        pointer-events: none;
        z-index: 1
    }

    #views-exposed-form-article-list-block-article-list .form-radios {
        width: 90%;
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap
    }
}

@media (max-width: 767.98px) and (max-width:767.98px) {
    #views-exposed-form-article-list-block-article-list .form-radios {
        margin-left: 15px
    }

    #views-exposed-form-article-list-block-article-list .form-radios::-webkit-scrollbar {
        display: none
    }
}

.views-element-container .pager .pager__items {
    text-align: center;
    padding: 15px 0
}

.related-articles-row {
    padding-bottom: 74px
}

@media screen and (max-width: 991px) {
    .related-articles-row {
        padding-bottom: 33px
    }
}

.related-articles-title {
    font-size: 4rem;
    line-height: 1.2em;
    font-weight: 700;
    padding: 74px 0 31px
}

@media screen and (max-width: 991px) {
    .related-articles-title {
        font-size: 2.3rem;
        line-height: 1.3em;
        padding: 33px 0 20px
    }
}

.short-article {
    display: flex;
    flex-wrap: wrap
}

.article-short-summary {
    background-color: #fff;
    height: 100%;
    box-shadow: 0 0 10px rgba(0, 0, 0, .5);
    transition: box-shadow .3s ease
}

.article-short-summary:hover {
    box-shadow: 0 0 3px rgba(0, 0, 0, .5)
}

.article-short-summary:hover .short-summary__view__image {
    transform: scale(1.1)
}

.layout__grey .article-short-summary {
    background-color: #f2f6f8
}

.layout__blue .article-short-summary {
    box-shadow: none;
    background-color: #0c2b57;
    transition: background-color .3s ease
}

.layout__blue .article-short-summary:hover {
    background-color: #0b274f
}

.article-short-summary .disabled-btn {
    flex: 0 0 auto
}

.article-short-summary .disabled-btn .btn {
    color: #41b6e6;
    font-weight: 700;
    background-color: transparent
}

.article-short-summary .short-summary__text {
    padding: 3.5rem 5.1rem 5.7rem 2.9rem
}

@media (max-width: 767.98px) {
    .article-short-summary .short-summary__text {
        padding: 2.5rem 2.1rem 2.8rem 2rem
    }
}

.article-short-summary .short-summary__text__description .node-title {
    display: block;
    font-size: 2rem;
    line-height: 3.3rem;
    font-weight: 700;
    font-family: Axiforma;
    color: var(--text-color);
    padding-bottom: 2rem
}

.article-short-summary .short-summary__text__date {
    padding-bottom: 3.5rem
}

.article-short-summary .short-summary__text__readmore .btn {
    padding: 0 .2rem 0 0
}

.article-short-summary .short-summary__text__category {
    padding-bottom: 2rem
}

.article-short-summary .short-summary__text__category a {
    color: #41b6e6
}

.article-short-summary .short-summary__view {
    overflow: hidden
}

.article-short-summary .short-summary__view__image {
    font-size: 2.8rem;
    line-height: 1.25;
    color: #041e42;
    font-weight: 700;
    transition: transform .3s ease
}

.grid-equal-height .badge.horizontal,
.grid-equal-height .badge.horizontal.link--v-bottom,
.grid-equal-height .badge:not(.vertical) {
    height: calc(100% - 1em)
}

.badge__link-bottom {
    height: 100%
}

.layout-builder__section .badge__link-bottom {
    height: auto
}

.badge {
    margin: 15px 0;
    height: auto;
    text-align: center;
    display: flex;
    transition: all .3s ease
}

.badge.link--v-bottom {
    height: calc(100% - 2em)
}

.badge.vertical {
    flex-direction: column
}

.badge.vertical .badge__text_block {
    display: none
}

.badge.vertical.layout__blue .badge__description,
.badge.vertical.layout__blue .badge__title,
.badge.vertical.layout__grey .badge__description,
.badge.vertical.layout__grey .badge__title,
.badge.vertical.layout__white .badge__description,
.badge.vertical.layout__white .badge__title {
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    backface-visibility: hidden
}

.badge.vertical .badge__description {
    padding-bottom: 2.4rem
}

.badge.horizontal {
    display: flex;
    flex-direction: row;
    padding-bottom: 0;
    width: 100%
}

.badge.horizontal a>.badge__description,
.badge.horizontal a>.badge__link,
.badge.horizontal a>.badge__title,
.badge.horizontal>.badge__description,
.badge.horizontal>.badge__link,
.badge.horizontal>.badge__title {
    display: none
}

.badge.horizontal .badge__title {
    margin-bottom: 0
}

.badge.horizontal .badge__text_block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0 0 60%;
    min-height: 7em;
    padding-left: 1rem;
    padding-right: 1rem;
    max-width: 100%
}

.badge.horizontal .badge__text_block .badge__description.v-top {
    justify-content: flex-start
}

.badge.horizontal .badge__text_block .badge__description.v-center {
    justify-content: center
}

.badge.horizontal .badge__text_block .badge__description.v-bottom {
    justify-content: flex-end
}

.badge.horizontal .badge__image--col100,
.badge.horizontal .badge__image--col25,
.badge.horizontal .badge__image--col33,
.badge.horizontal .badge__image--col50,
.badge.horizontal .badge__image--col75 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0 0 40%;
    overflow: hidden;
    max-width: 45%
}

.badge.horizontal .badge__image--col100 img,
.badge.horizontal .badge__image--col25 img,
.badge.horizontal .badge__image--col33 img,
.badge.horizontal .badge__image--col50 img,
.badge.horizontal .badge__image--col75 img {
    transition: all .3s ease-in-out
}

.badge.horizontal .badge__image--col100>div,
.badge.horizontal .badge__image--col100>div .drupal-media,
.badge.horizontal .badge__image--col100>div .drupal-media .drupal-media__image,
.badge.horizontal .badge__image--col25>div,
.badge.horizontal .badge__image--col25>div .drupal-media,
.badge.horizontal .badge__image--col25>div .drupal-media .drupal-media__image,
.badge.horizontal .badge__image--col33>div,
.badge.horizontal .badge__image--col33>div .drupal-media,
.badge.horizontal .badge__image--col33>div .drupal-media .drupal-media__image,
.badge.horizontal .badge__image--col50>div,
.badge.horizontal .badge__image--col50>div .drupal-media,
.badge.horizontal .badge__image--col50>div .drupal-media .drupal-media__image,
.badge.horizontal .badge__image--col75>div,
.badge.horizontal .badge__image--col75>div .drupal-media,
.badge.horizontal .badge__image--col75>div .drupal-media .drupal-media__image {
    height: 100%
}

.badge.horizontal.link--v-bottom {
    height: auto
}

@media (max-width: 767.98px) {
    .badge.horizontal.vertical--mobile {
        flex-direction: column;
        height: 100%
    }

    .badge.horizontal.vertical--mobile a>.badge__description,
    .badge.horizontal.vertical--mobile a>.badge__link,
    .badge.horizontal.vertical--mobile a>.badge__title,
    .badge.horizontal.vertical--mobile>.badge__description,
    .badge.horizontal.vertical--mobile>.badge__link,
    .badge.horizontal.vertical--mobile>.badge__title {
        display: none
    }

    .badge.horizontal.vertical--mobile .badge__image--col100,
    .badge.horizontal.vertical--mobile .badge__image--col25,
    .badge.horizontal.vertical--mobile .badge__image--col33,
    .badge.horizontal.vertical--mobile .badge__image--col50,
    .badge.horizontal.vertical--mobile .badge__image--col75 {
        max-width: 100%
    }

    .badge.horizontal.vertical--mobile .badge__text_block {
        max-width: 100%
    }
}

.badge.horizontal .image-top {
    justify-content: flex-start
}

.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary),
.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary):hover {
    color: var(--link-color);
    text-decoration: none
}

.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary) .badge__description,
.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary) .badge__text_block,
.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary):hover .badge__description,
.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary):hover .badge__text_block {
    color: var(--text-color)
}

@media (min-width: 576px) {
    .badge.link--v-bottom>a {
        display: flex;
        flex-direction: column;
        height: 100%
    }

    .badge.link--v-bottom div:not(.v-bottom)>.badge__link {
        display: flex;
        height: 100%;
        align-items: flex-end
    }

    .badge.link--v-bottom .badge__description.v-center {
        margin-top: auto
    }

    .badge.link--v-bottom>.badge__link,
    .badge.link--v-bottom>a>.badge__link {
        margin-top: auto
    }
}

.badge.fully--clickable {
    text-decoration: none;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .5)
}

.badge.fully--clickable.horizontal a {
    display: flex;
    flex-direction: row;
    width: 100%
}

@media (max-width: 767.98px) {
    .badge.fully--clickable.horizontal.vertical--mobile a {
        flex-direction: column
    }
}

.badge.fully--clickable:hover {
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, .5);
    text-decoration: none
}

.badge.outline {
    border: 1px solid #d2d2d2;
    border-radius: 5px
}

.badge.outline.vertical img {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    overflow: hidden;
    transition: all .3s ease-in-out
}

.badge.outline.vertical .badge__image--col100,
.badge.outline.vertical .badge__image--col25,
.badge.outline.vertical .badge__image--col33,
.badge.outline.vertical .badge__image--col50,
.badge.outline.vertical .badge__image--col75 {
    border-bottom: 1px solid #d2d2d2
}

.badge.outline.vertical .badge__image--col100.no_image,
.badge.outline.vertical .badge__image--col25.no_image,
.badge.outline.vertical .badge__image--col33.no_image,
.badge.outline.vertical .badge__image--col50.no_image,
.badge.outline.vertical .badge__image--col75.no_image {
    border-bottom: none
}

.badge.outline.horizontal img {
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    overflow: hidden
}

.badge.outline.horizontal .badge__image--col100,
.badge.outline.horizontal .badge__image--col25,
.badge.outline.horizontal .badge__image--col33,
.badge.outline.horizontal .badge__image--col50,
.badge.outline.horizontal .badge__image--col75 {
    border-right: 1px solid #d2d2d2;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px
}

@media (max-width: 767.98px) {
    .badge.outline.horizontal.vertical--mobile img {
        overflow: hidden;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 0
    }

    .badge.outline.horizontal.vertical--mobile .badge__image--col100,
    .badge.outline.horizontal.vertical--mobile .badge__image--col25,
    .badge.outline.horizontal.vertical--mobile .badge__image--col33,
    .badge.outline.horizontal.vertical--mobile .badge__image--col50,
    .badge.outline.horizontal.vertical--mobile .badge__image--col75 {
        border-bottom: 1px solid #d2d2d2;
        border-right: 0;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 0
    }
}

.badge.limit-width {
    max-width: 33vw;
    margin: 15px auto
}

.badge .inner-spacing {
    padding: 15px
}

.badge .inner-spacing img {
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important
}

.badge.image-zoom .badge__image--col100 .drupal-media__image.drupal-media__image--full-width,
.badge.image-zoom .badge__image--col25 .drupal-media__image.drupal-media__image--full-width,
.badge.image-zoom .badge__image--col33 .drupal-media__image.drupal-media__image--full-width,
.badge.image-zoom .badge__image--col50 .drupal-media__image.drupal-media__image--full-width,
.badge.image-zoom .badge__image--col75 .drupal-media__image.drupal-media__image--full-width {
    overflow: hidden
}

.badge.image-zoom .badge__image--col100 .drupal-media__image.drupal-media__image--full-width img,
.badge.image-zoom .badge__image--col25 .drupal-media__image.drupal-media__image--full-width img,
.badge.image-zoom .badge__image--col33 .drupal-media__image.drupal-media__image--full-width img,
.badge.image-zoom .badge__image--col50 .drupal-media__image.drupal-media__image--full-width img,
.badge.image-zoom .badge__image--col75 .drupal-media__image.drupal-media__image--full-width img {
    transition: transform .3s ease
}

.badge.image-zoom:hover .badge__image--col100 img,
.badge.image-zoom:hover .badge__image--col25 img,
.badge.image-zoom:hover .badge__image--col33 img,
.badge.image-zoom:hover .badge__image--col50 img,
.badge.image-zoom:hover .badge__image--col75 img {
    transform: scale(1.1)
}

.badge__image {
    height: auto
}

.badge__image img {
    max-width: 100%;
    margin-bottom: 16px
}

.badge__image--col100,
.badge__image--col25,
.badge__image--col33,
.badge__image--col50,
.badge__image--col75 {
    height: auto
}

.badge__image--col100 .drupal-media .drupal-media__image--full-width img,
.badge__image--col100 .drupal-media .drupal-media__image--full-width svg,
.badge__image--col25 .drupal-media .drupal-media__image--full-width img,
.badge__image--col25 .drupal-media .drupal-media__image--full-width svg,
.badge__image--col33 .drupal-media .drupal-media__image--full-width img,
.badge__image--col33 .drupal-media .drupal-media__image--full-width svg,
.badge__image--col50 .drupal-media .drupal-media__image--full-width img,
.badge__image--col50 .drupal-media .drupal-media__image--full-width svg,
.badge__image--col75 .drupal-media .drupal-media__image--full-width img,
.badge__image--col75 .drupal-media .drupal-media__image--full-width svg {
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover
}

.badge__image--col25 .drupal-media .drupal-media__image--full-width img,
.badge__image--col25 .drupal-media .drupal-media__image--full-width svg {
    width: 25%;
    border-radius: 0
}

.badge__image--col33 .drupal-media .drupal-media__image--full-width img,
.badge__image--col33 .drupal-media .drupal-media__image--full-width svg {
    width: 33%;
    border-radius: 0
}

.badge__image--col50 .drupal-media .drupal-media__image--full-width img,
.badge__image--col50 .drupal-media .drupal-media__image--full-width svg {
    width: 50%;
    border-radius: 0
}

.badge__image--col75 .drupal-media .drupal-media__image--full-width img,
.badge__image--col75 .drupal-media .drupal-media__image--full-width svg {
    width: 75%;
    border-radius: 0
}

.badge__image--col100 .drupal-media .drupal-media__image--full-width img,
.badge__image--col100 .drupal-media .drupal-media__image--full-width svg {
    width: 100%
}

.badge__title {
    font-size: 2.2rem;
    line-height: 1.45em;
    font-weight: 700
}

.badge__description {
    display: flex;
    flex-direction: column;
    font-size: 1.4rem;
    line-height: 1.71em;
    font-weight: 400;
    height: 100%;
    padding-top: 1rem
}

.badge__description p {
    margin-bottom: 0;
    word-wrap: break-word;
    overflow-wrap: break-word
}

.badge__description.v-top {
    margin-top: 0
}

.badge__description.v-bottom {
    margin-top: auto
}

.badge .badge__description.text-center .badge__link {
    display: flex;
    justify-content: center
}

.badge .badge__description.text-right .badge__link {
    display: flex;
    justify-content: flex-end
}

.badge .badge__description.text-left .badge__link {
    display: flex;
    justify-content: flex-start
}

.badge .layout__black,
.badge .layout__gradient_blue,
.badge .layout__grey,
.badge.layout__blue {
    background-color: var(--bg-color);
    box-shadow: unset
}

.badge.layout__grey.outline {
    border: 1px solid #f5f6f6
}

.badge.layout__grey.horizontal .badge__image--col100,
.badge.layout__grey.horizontal .badge__image--col25,
.badge.layout__grey.horizontal .badge__image--col33,
.badge.layout__grey.horizontal .badge__image--col50,
.badge.layout__grey.horizontal .badge__image--col75 {
    border-right: 1px solid #f5f6f6
}

@media (max-width: 767.98px) {

    .badge.layout__grey.horizontal.vertical--mobile .badge__image--col100,
    .badge.layout__grey.horizontal.vertical--mobile .badge__image--col25,
    .badge.layout__grey.horizontal.vertical--mobile .badge__image--col33,
    .badge.layout__grey.horizontal.vertical--mobile .badge__image--col50,
    .badge.layout__grey.horizontal.vertical--mobile .badge__image--col75 {
        border-bottom: 1px solid #f5f6f6
    }
}

.badge.layout__white .wysiwyg .link--download:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___})
}

.align-self-stretch .entity-media {
    height: 100%
}

.layout .media__card {
    height: 100%;
    padding: 40px 36px
}

.block--carousel {
    position: relative;
    width: 100%
}

.block--carousel-tips .swiper {
    padding-left: 1.6rem
}

.block--carousel-tips .swiper .swiper-button-prev {
    left: -4px
}

.block--carousel .swiper .swiper-wrapper .swiper-slide>article a {
    display: inline-block;
    width: 100%
}

.block--carousel .swiper .swiper-wrapper .swiper-slide>article a:hover h2 {
    text-decoration: underline
}

.block--carousel .swiper .swiper-wrapper .swiper-slide>article a:hover .swiper-slide--img img {
    transform: scale(1.1)
}

.block--carousel .swiper .swiper-wrapper .swiper-slide>article a:hover p .read-more-link {
    color: var(--link-hover-color)
}

.block--carousel p {
    color: #54585a;
    font-size: 1.5rem;
    line-height: 1.45em
}

.layout__black .block--carousel p,
.layout__blue .block--carousel p,
.layout__dark_grey .block--carousel p,
.layout__light_blue .block--carousel p {
    color: #d2d2d2
}

@media (max-width: 991.98px) {
    .block--carousel .swiper .swiper-wrapper {
        margin-left: 0
    }
}

.block--carousel .swiper .swiper-wrapper .swiper-slide h2 {
    color: #041e42;
    font-size: 1.8rem;
    line-height: 3rem;
    font-weight: 900;
    margin-bottom: 12px
}

.layout__black .block--carousel .swiper .swiper-wrapper .swiper-slide h2,
.layout__blue .block--carousel .swiper .swiper-wrapper .swiper-slide h2,
.layout__dark_grey .block--carousel .swiper .swiper-wrapper .swiper-slide h2,
.layout__light_blue .block--carousel .swiper .swiper-wrapper .swiper-slide h2 {
    color: #fff
}

.block--carousel .swiper .swiper-wrapper .swiper-slide p {
    color: #8a8d8f;
    font-size: 1.5rem;
    line-height: 2.2rem;
    margin-bottom: 0
}

.block--carousel .swiper .swiper-wrapper .swiper-slide p .read-more-link {
    display: block;
    color: var(--link-color);
    text-decoration: underline
}

.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img {
    position: relative
}

.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .image-container {
    overflow: hidden;
    border-radius: 10px;
    z-index: 1
}

.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .swiper-tag {
    position: absolute;
    top: 8px;
    left: -4px;
    background: #fff;
    font-size: 1.2rem;
    color: #041e42;
    padding: 4px 8px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    box-shadow: 3px 1px 10px 2px rgba(0, 0, 0, .1);
    font-weight: 600;
    z-index: 2
}

.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .swiper-action {
    position: absolute;
    bottom: 8px;
    display: block;
    width: 32px;
    height: 32px
}

.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .swiper-action--fullscreen {
    right: 8px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___})
}

.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .swiper-action--play {
    left: 8px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
}

.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .swiper-action--duration {
    right: 8px;
    height: 16px;
    color: #fff;
    font-size: 1.2rem
}

.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .splash-video-play-button {
    display: none
}

@media (min-width: 768px) {
    .block--carousel .swiper .swiper-wrapper .swiper-slide.swiper-slide--full-width .swiper-slide--img {
        display: inline-block;
        vertical-align: top;
        width: 33%
    }

    .block--carousel .swiper .swiper-wrapper .swiper-slide.swiper-slide--full-width .swiper-slide--content {
        display: inline-flex;
        padding-left: 16px;
        position: absolute;
        height: 100%
    }

    .block--carousel .swiper .swiper-wrapper .swiper-slide.swiper-slide--full-width .swiper-slide--inner {
        margin: auto
    }
}

@media (max-width: 767.98px) {
    .block--carousel .swiper .swiper-wrapper .swiper-slide.swiper-slide--full-width .swiper-slide--inner {
        margin-top: 16px
    }
}

.block--carousel .swiper .swiper-wrapper .swiper-slide:not(.swiper-slide--full-width) .swiper-slide--inner {
    margin-top: 16px
}

.block--carousel .swiper .swiper-wrapper .swiper-slide-description--tablet {
    display: none
}

@media (min-width: 768px) and (max-width:1199.98px) {
    .block--carousel .swiper .swiper-wrapper .swiper-slide--full-width .swiper-slide-description {
        display: none
    }

    .block--carousel .swiper .swiper-wrapper .swiper-slide--full-width .swiper-slide-description--tablet {
        display: block
    }
}

.block--carousel .swiper .swiper-button-prev {
    top: calc(50% - 18px)
}

@media (max-width: 991.98px) {
    .block--carousel .swiper .swiper-button-prev {
        top: unset;
        bottom: 10px
    }
}

.block--carousel .swiper .swiper-button-next {
    right: calc(10% - 16px);
    top: calc(50% - 18px)
}

@media (max-width: 991.98px) {
    .block--carousel .swiper .swiper-button-next {
        top: unset;
        bottom: 10px;
        right: 0
    }
}

.block--carousel.swiper-tag--hidden .swiper-tag {
    display: none
}

.theme-100 .swiper .swiper-wrapper .swiper-slide h2 {
    color: #000
}

.swiper-container {
    position: relative
}

.carousel-sided-arrows,
.slick--skin--pt-sided-arrows {
    margin: 0
}

.carousel-sided-arrows .slick-track,
.slick--skin--pt-sided-arrows .slick-track {
    display: flex;
    align-items: center
}

.carousel-sided-arrows .slick-arrow,
.slick--skin--pt-sided-arrows .slick-arrow {
    margin: 0;
    visibility: visible
}

@media (min-width: 768px) {

    .carousel-sided-arrows .slick-arrow,
    .slick--skin--pt-sided-arrows .slick-arrow {
        margin: 0 15px
    }
}

@media (max-width: 767.98px) {

    .carousel-sided-arrows .slick-arrow svg,
    .slick--skin--pt-sided-arrows .slick-arrow svg {
        width: 38px;
        height: 38px
    }
}

.carousel-sided-arrows .slick__arrow .slick-disabled,
.slick--skin--pt-sided-arrows .slick__arrow .slick-disabled {
    opacity: 0;
    transition: opacity .2s ease
}

.slick--optionset--carousel-arrows-dotless-unlimite .carousel-media__container {
    width: 90px;
    padding: 0
}

@media (min-width: 768px) {
    .slick--optionset--carousel-arrows-dotless-unlimite .carousel-media__container {
        width: 110px
    }
}

.slick--optionset--carousel-arrows-dotless-unlimite .slick-list,
.slick--optionset--carousel-limited-variable-slides .slick-list {
    width: 80%;
    padding-left: 35px;
    margin: auto
}

@media (min-width: 768px) {

    .slick--optionset--carousel-arrows-dotless-unlimite .slick-list,
    .slick--optionset--carousel-limited-variable-slides .slick-list {
        padding-left: 0
    }
}

@media (min-width: 992px) {

    .slick--optionset--carousel-arrows-dotless-unlimite .slick-list,
    .slick--optionset--carousel-limited-variable-slides .slick-list {
        width: 90%
    }
}

.slick--optionset--carousel-arrows-dotless-unlimite .slick-slide,
.slick--optionset--carousel-limited-variable-slides .slick-slide {
    margin: 0 20px
}

@media (min-width: 992px) {

    .slick--optionset--carousel-arrows-dotless-unlimite .slick-slide,
    .slick--optionset--carousel-limited-variable-slides .slick-slide {
        margin: 0 35px
    }
}

.zoom-shade .slick--optionset--carousel-arrows-unlimited-center {
    margin: 5% 0
}

.zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick__slider {
    padding: 0 50px
}

@media (max-width: 767.98px) {
    .zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick__slider {
        padding: 0
    }
}

.zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick-slide {
    opacity: 0;
    transition: opacity .2s ease, transform .3s ease;
    width: 486px;
    max-width: 100%;
    margin: 0 16px
}

@media (max-width: 767.98px) {
    .zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick-slide {
        width: 245px;
        margin: 0
    }
}

.zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick_slide__active {
    transform: scale(1);
    opacity: .4
}

.zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick_slide__current {
    transform: scale(1.13);
    opacity: 1
}

.zoom-shade .slick--optionset--carousel-arrows-unlimited-center .main-image-container picture {
    max-width: 100%
}

.zoom-shade .slick-list {
    overflow: visible
}

.zoom-shade.theme-100 .image_description {
    background: linear-gradient(0deg, rgba(0, 0, 0, .75) 0, rgba(0, 0, 0, .75) 66%, rgba(0, 0, 0, 0) 100%)
}

@media (max-width: 767.98px) {
    .zoom-shade.theme-100 .image_description {
        background-color: #000
    }
}

.zoom-shade.theme-100 .image_description p {
    color: #fff
}

.zoom-shade.theme-100 .slick-arrow svg rect {
    fill: #e0457b
}

@media (max-width: 767.98px) {
    .zoom-shade.theme-100.showDescription .image__veil::after {
        background: linear-gradient(0deg, #000 0, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0) 100%)
    }
}

.zoom-shade .image_description {
    position: absolute;
    bottom: -2px;
    left: -1px;
    width: calc(100% + 1px);
    height: 66%;
    background: linear-gradient(0deg, rgba(4, 30, 66, .75) 0, rgba(4, 30, 66, .75) 66%, rgba(4, 30, 66, 0) 100%)
}

@media (max-width: 767.98px) {
    .zoom-shade .image_description {
        background-color: #041e42
    }
}

.zoom-shade .image_description .text-container {
    position: absolute;
    bottom: 0;
    padding: 32px
}

@media (max-width: 767.98px) {
    .zoom-shade .image_description .text-container {
        position: relative;
        padding: 24px
    }
}

.zoom-shade .image_description p {
    color: #fff
}

@media (max-width: 767.98px) {
    .zoom-shade .image_description {
        position: relative;
        bottom: 0
    }
}

.zoom-shade .image_description p {
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    position: relative;
    -webkit-line-clamp: 3;
    margin-bottom: 8px
}

@media (max-width: 767.98px) {
    .zoom-shade .image_description p {
        -webkit-line-clamp: 4
    }
}

.zoom-shade .cta .btn--inverted,
.zoom-shade .cta .btn-secondary,
.zoom-shade .cta .btn-tertiary {
    color: #fff
}

.cke_editable .zoom-shade .cta .btn--inverted.link--download:after,
.cke_editable .zoom-shade .cta .btn-secondary.link--download:after,
.cke_editable .zoom-shade .cta .btn-tertiary.link--download:after,
.wysiwyg .zoom-shade .cta .btn--inverted.link--download:after,
.wysiwyg .zoom-shade .cta .btn-secondary.link--download:after,
.wysiwyg .zoom-shade .cta .btn-tertiary.link--download:after,
.zoom-shade .cta .btn-secondary.btn__arrow:after,
.zoom-shade .cta .btn-secondary.btn__download:after,
.zoom-shade .cta .btn-secondary.btn__upload:after,
.zoom-shade .cta .btn-secondary.btn__video:after,
.zoom-shade .cta .btn-tertiary.btn__arrow:after,
.zoom-shade .cta .btn-tertiary.btn__download:after,
.zoom-shade .cta .btn-tertiary.btn__upload:after,
.zoom-shade .cta .btn-tertiary.btn__video:after,
.zoom-shade .cta .btn__arrow.btn--inverted:after,
.zoom-shade .cta .btn__download.btn--inverted:after,
.zoom-shade .cta .btn__upload.btn--inverted:after,
.zoom-shade .cta .btn__video.btn--inverted:after,
.zoom-shade .cta .cke_editable .btn--inverted.link--download:after,
.zoom-shade .cta .cke_editable .btn-secondary.link--download:after,
.zoom-shade .cta .cke_editable .btn-tertiary.link--download:after,
.zoom-shade .cta .wysiwyg .btn--inverted.link--download:after,
.zoom-shade .cta .wysiwyg .btn-secondary.link--download:after,
.zoom-shade .cta .wysiwyg .btn-tertiary.link--download:after {
    background: #fff
}

.zoom-shade.hideDescription .image_description {
    display: none
}

@media (max-width: 767.98px) {
    .zoom-shade.showDescription .image__veil {
        position: relative
    }

    .zoom-shade.showDescription .image__veil::after {
        content: "";
        position: absolute;
        left: -1px;
        top: 1px;
        width: calc(100% + 1px);
        height: 100%;
        background: linear-gradient(0deg, #041e42 0, rgba(4, 30, 66, 0) 25%, rgba(4, 30, 66, 0) 100%)
    }
}

.slick--optionset--carousel-limited-variable-slides .carousel-media__container {
    width: 110px
}

@media (max-width: 767.98px) {
    .slick--optionset--carousel-limited-variable-slides .carousel-media__container {
        width: 90px
    }
}

.slick--optionset--carousel-limited-variable-slides .carousel-media__container__title {
    font-size: 1.8rem;
    display: flex;
    justify-content: center;
    margin: 20px 0 0 0;
    font-weight: 400;
    text-align: center
}

.slick--optionset--carousel-limited-variable-slides .slick-slide {
    margin: 0 23px
}

.carousel-media {
    margin-bottom: 100px
}

@media screen and (min-width: 1024px) {
    .carousel-media {
        margin: 0 0 100px 120px
    }
}

@media screen and (max-width: 768px) {
    .carousel-media .slick__arrow--mobile {
        margin-top: 50px
    }
}

@media screen and (max-width: 768px) and (max-width:767.98px) {
    .carousel-media .slick-slide {
        margin: 0 30px
    }
}

@media screen and (min-width: 1024px) {
    .carousel-media__container {
        width: 400px
    }
}

@media (min-width: 1200px) {
    .carousel-media__container:hover .carousel-media__container__main-box__title {
        opacity: 0
    }

    .carousel-media__container:hover .carousel-media__container__infos-box {
        opacity: 1
    }
}

@media screen and (max-width: 1023px) {
    .carousel-media__container {
        width: 335px;
        margin: auto;
        padding-bottom: 40px
    }
}

@media screen and (max-width: 767px) {
    .carousel-media__container {
        padding-bottom: 0
    }
}

.carousel-media__container__title {
    margin: 30px 0 0 30px;
    color: #04325e;
    font-weight: 700;
    font-size: 3.2rem
}

.carousel-media__container__main-box {
    margin-top: -20px
}

.carousel-media__container__main-box__image {
    min-height: 1px;
    max-height: 430px;
    overflow: hidden;
    margin-top: 20px
}

.carousel-media__container__main-box__info-icon {
    display: block;
    position: absolute;
    top: 300px;
    right: 20px;
    width: 42px
}

.carousel-media__container__main-box__info-icon--hide {
    opacity: 0
}

.carousel-media__container__main-box__info-icon__svg {
    fill: #fff
}

@media screen and (min-width: 1025px) {
    .carousel-media__container__main-box__info-icon {
        display: none
    }
}

.carousel-media__container__infos-box {
    height: 100%;
    width: 100%;
    max-width: 400px;
    background-color: rgba(4, 50, 94, .8);
    opacity: 0;
    transition: opacity .3s ease;
    position: absolute;
    top: 0;
    color: #fff;
    padding: 0 30px
}

@media screen and (max-width: 768px) {
    .carousel-media__container__infos-box {
        max-width: 335px
    }
}

.carousel-media__container__infos-box--mobile {
    opacity: 1
}

.carousel-media__container__infos-box__description {
    padding-top: 20px;
    margin-top: 30px
}

.carousel-media__container__infos-box__description .wysiwyg p {
    color: #fff
}

.carousel-media__container__infos-box__description.layout__blue {
    box-shadow: none
}

.carousel-media__container__infos-box__description.layout__blue .wysiwyg ul:not(.contextual-links) li {
    color: #fff
}

.carousel-media__container__infos-box__description.layout__blue .wysiwyg ul:not(.contextual-links) li:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___})
}

.carousel-media__container__infos-box .layout__blue {
    background-color: transparent
}

.carousel-media__container__infos-box__cross-box {
    display: block;
    width: 42px;
    transform: rotate(45deg);
    position: absolute;
    right: 0;
    top: 0
}

@media screen and (min-width: 1025px) {
    .carousel-media__container__infos-box__cross-box {
        display: none
    }
}

.carousel-media__container__infos-box__cross-box__cross {
    fill: #41b6e6
}

.field--name-field-client-success-video .main-image-container .splash-video-play-button {
    display: none
}

.client-success__blue-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #041e42;
    color: #fff;
    flex: 0 0 50%
}

@media (max-width: 991.98px) {
    .client-success__blue-overlay {
        position: relative;
        left: 0;
        width: 100%;
        justify-content: center;
        align-items: center;
        background: #041e42;
        color: #fff
    }
}

.client-success__container {
    position: relative;
    max-width: 80vw;
    margin: auto
}

@media (max-width: 767.98px) {
    .client-success__container {
        max-width: 100vw
    }
}

@media (min-width: 768px) {
    .client-success__container {
        display: flex
    }
}

.client-success__container .drupal-media {
    flex: 0 0 50%
}

.client-success__container .main-image-container {
    justify-content: flex-start;
    height: 100%
}

.client-success__container .main-image-container picture {
    height: 100%
}

.client-success__container .main-image-container picture img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: left;
       object-position: left
}

@media (max-width: 991.98px) {
    .client-success__container .main-image-container picture picture {
        width: 100%;
        height: 100%
    }
}

.client-success__logo-container {
    width: 75%;
    margin: auto
}

.client-success__logo-container img {
    max-width: 100%
}

.client-success__logo {
    height: auto;
    padding: 1.5em
}

.client-success__textQuote {
    line-height: 1.8;
    max-width: 75%;
    margin: auto;
    font-weight: 100
}

@media (max-width: 991.98px) {
    .client-success__textQuote {
        text-align: center;
        max-width: 100%
    }
    .ellipsis-content-overlay {
        -webkit-mask-image: linear-gradient(to bottom, #000 65%, transparent 100%);
        mask-image: linear-gradient(to bottom, #000 50%, transparent 100%)
    }
    .ellipsis-render-container .ellipsis-content-section.read-more {
        height: 200px;
        overflow: hidden
    }
}

.ellipsis-render-container .ellipsis-content-section.read-more .ellipsis-overlay {
    position: absolute;
    height: 9.6rem;
    bottom: 36px;
    z-index: 10;
    width: 100%
}

@media (max-width: 991.98px) {
    .ellipsis-render-container .ellipsis-button-section {
        height: 67px;
        width: 100%;
        padding-top: 16px
    }
    .ellipsis-load-more-button.read-more__link {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 10px;
        height: 20px;
        cursor: pointer;
        width: 20px;
        opacity: 15%;
        position: absolute;
        left: 50%;
        transform: translate(-50%)
    }
    .layout__blue .ellipsis-load-more-button.read-more__link {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
        opacity: 35%
    }
}

.embedded-video .video-embed-field-responsive-video:after {
    padding-bottom: 0
}

.pt-footer {
    background-color: #f2f6f8
}

.pt-footer__top {
    border-bottom: 1px solid rgba(138, 141, 143, .4);
    height: 80px;
    margin-bottom: 50px
}

@media (max-width: 767.98px) {
    .pt-footer__top {
        margin-bottom: 25px
    }
}

.pt-footer__menu>div {
    width: 100%
}

@media (min-width: 768px) {
    .pt-footer__menu>div {
        flex-wrap: wrap;
        justify-content: flex-end
    }
}

.pt-footer__menu>div nav {
    width: 100%
}

@media (min-width: 768px) {
    .pt-footer__menu>div nav {
        flex: 1 0 25%
    }
}

.pt-footer__menu ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style-type: none
}

.pt-footer__menu ul.menu-level-0 {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    max-width: 1300px
}

.pt-footer__menu ul.menu-level-0>.menu-item {
    padding: 0 1.5rem;
    width: 25%
}

@media (max-width: 767.98px) {
    .pt-footer__menu ul.menu-level-0>.menu-item {
        width: 100%
    }
}

.pt-footer__menu ul li {
    margin-bottom: 34px
}

@media (max-width: 767.98px) {
    .pt-footer__menu ul li {
        margin-bottom: 15px
    }
}

.pt-footer__menu ul li a {
    font-size: 1.7rem;
    line-height: 1.4em;
    color: #8a8d8f
}

.pt-footer__menu ul li a.font-weight-bold {
    color: #041e42
}

.pt-footer__menu__social p {
    color: #04325e;
    font-size: 1.7rem;
    line-height: 1.4em;
    font-weight: 700;
    margin-bottom: 0
}

.pt-footer__copyright p {
    color: #8a8d8f;
    font-size: 1.4rem;
    line-height: .64em
}

.pt-footer--inverted {
    background-color: #041e42
}

.pt-footer--inverted a {
    color: #8a8d8f
}

.pt-footer--inverted a.font-weight-extrabold {
    color: #fff
}

.block--gallery {
    position: relative;
    width: 575px;
    max-width: 100%;
    margin: 0 auto
}

@media (max-width: 991.98px) {
    .block--gallery {
        width: 90vw
    }
}

.block--gallery .swiper {
    aspect-ratio: 1/1
}

.block--gallery .swiper .swiper-wrapper {
    margin-bottom: 0;
    border-radius: inherit
}

.block--gallery .swiper .swiper-wrapper .swiper-slide {
    background-color: #fff;
    border-radius: inherit;
    border: 1px solid #c7cfd7
}

@media (max-width: 991.98px) {

    .block--gallery .swiper-button-next,
    .block--gallery .swiper-button-prev {
        display: none
    }
}

#colorbox.colorbox--gallery {
    height: 100% !important;
    width: 100vw !important
}

#colorbox.colorbox--gallery #cboxContent {
    width: calc(100vw - 30px) !important;
    height: auto !important
}

#colorbox.colorbox--gallery #cboxContent .swiper-image-mobile img {
    width: 100%
}

:not(.layout-builder-block).landing-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 9;
    background-color: #fff
}

.media-2-columns__thumbnail img {
    width: 100%
}

.media-2-columns__play {
    position: relative;
    display: block
}

.media-2-columns__play:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 100%;
    width: 100%;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center
}

.media-2-columns__content h3 {
    color: #04325e;
    font-size: 1.8rem;
    line-height: 1.56em;
    font-weight: 700
}

.media-2-columns__content p {
    color: #04325e;
    font-size: 1.4rem;
    line-height: 1.43em
}

@media (min-width: 768px) {
    .media-2-columns__content p {
        line-height: 1.71em
    }
}

.media-2-columns .video-embed-field-responsive-video:after {
    padding-bottom: 0
}

.region--primary-menu .block--menu-button {
    position: fixed;
    bottom: 15px;
    left: 0;
    padding-top: 10px !important
}

@media (min-width: 1200px) {
    .region--primary-menu .block--menu-button {
        position: relative;
        bottom: 0;
        background-color: #484b4d;
        height: 100%
    }

    .region--primary-menu .block--menu-button a {
        position: relative;
        top: 4px
    }
}

.region--primary-menu .layout .block--menu-button {
    display: none
}

.region--hamburger-menu .block--menu-button a,
.region--primary-menu .block--menu-button a {
    border-radius: 5px;
    background-color: #fff;
    color: #000;
    font-size: 1.4rem;
    line-height: 1.2em;
    font-family: canada-type-gibson, sans-serif;
    font-weight: 500;
    padding: 8px 15px;
    min-width: 130px;
    min-height: 35px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, .1607843137)
}

.region--hamburger-menu .block--menu-button a.btn--where:before,
.region--primary-menu .block--menu-button a.btn--where:before {
    --btn-text-color: none;
    content: "";
    display: inline-block;
    width: 10px;
    height: 14px;
    margin-right: 5px;
    /* background-image: url(/src/images/icons/icon-wheretobuy.svg); */
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100%
}

.block--menu-footer {
    --text-color: #000000;
    line-height: 1.2em;
    padding-right: 15px;
    padding-left: 15px
}

@media (min-width: 1200px) {
    .block--menu-footer {
        background-color: #484b4d;
        --text-color: #FFFFFF
    }
}

.block--menu-footer--title {
    font-family: canada-type-gibson, sans-serif;
    font-size: 1.5rem;
    font-weight: 600
}

@media (min-width: 1200px) {
    .block--menu-footer--title {
        font-size: 1.4rem;
        font-weight: 500
    }
}

.block--menu-footer--description {
    font-size: 1.4rem;
    line-height: 1.6em;
    color: #4b4b4b
}

.block--menu-footer--phone {
    order: 2
}

.block--menu-footer--phone a {
    color: #000 !important;
    text-decoration: underline;
    font-size: 1.6rem
}

@media (min-width: 1200px) {
    .block--menu-footer--phone a {
        color: #fff !important;
        font-size: 1.3rem
    }
}

.block--menu-footer--phone a:before {
    position: relative;
    top: 3px;
    content: "";
    display: inline-block;
    width: 17px;
    height: 17px;
    margin-right: 5px;
    /* background-image: url(/src/images/icons/icon-telephone.svg); */
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100%
}

@media (min-width: 1200px) {
    .block--menu-footer--phone a:before {
        /* background-image: url(/src/images/icons/icon-telephone-white.svg) */
    }
}

.block--menu-footer--phone a:hover {
    text-decoration: none
}

.block--menu-footer--email {
    font-size: 1.6rem;
    order: 1
}

@media (min-width: 1200px) {
    .block--menu-footer--email {
        border-left: 1px solid #6c757d;
        font-size: 1.3rem
    }
}

.block--menu-footer--email a {
    color: #000 !important;
    text-decoration: underline
}

@media (min-width: 1200px) {
    .block--menu-footer--email a {
        color: #fff !important
    }
}

.block--menu-footer--email a:before {
    position: relative;
    top: 3px;
    content: "";
    display: inline-block;
    width: 17px;
    height: 17px;
    margin-right: 5px;
    /* background-image: url(/src/images/icons/icon-email.svg); */
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100%
}

/* 
@media (min-width: 1200px) {
    .block--menu-footer--email a:before {
        /* background-image: url(/src/images/icons/icon-email-white.svg) 
}
}*/
.block--menu-footer--email a:hover {
    text-decoration: none
}

.truncate {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    width: 100%;
    position: relative;
    -webkit-line-clamp: 1
}

@media (max-width: 991.98px) {
    .truncate {
        -webkit-line-clamp: 2
    }
}

@media (max-width: 575.98px) {
    .truncate {
        -webkit-line-clamp: 3
    }
}

.truncate p {
    margin: 0
}

.layout-container>.promotional-banner {
    display: none;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    width: 100%;
    padding: 16px 50px;
    z-index: 1;
    color: var(--text-color);
    box-shadow: none
}

.layout-container>.promotional-banner:after {
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--bg-color);
    opacity: .8;
    position: absolute;
    z-index: -1
}

@media (max-width: 1199.98px) {
    .layout-container>.promotional-banner {
        padding: 16px 36px 16px 16px
    }
}

.layout-container>.promotional-banner svg path {
    fill: var(--text-color)
}

.layout-container>.promotional-banner a {
    margin-left: 40px;
    flex: 0 0 auto
}

@media (max-width: 1199.98px) {
    .layout-container>.promotional-banner a {
        margin-left: 0;
        margin-top: 16px
    }
}

.layout-container>.promotional-banner .btn__redirection::after {
    min-width: 12px;
    width: 12px;
    height: 12px
}

.layout-container>.promotional-banner .close-promotional-banner {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
    width: 12px;
    height: 12px;
    display: flex
}

.layout-container>.promotional-banner--header-hidden {
    margin-top: -10px
}

@media (min-width: 1200px) {
    .layout-container>.promotional-banner--header-hidden {
        margin-top: -36px
    }
}

.layout-container #block-ptbase-child-main-menu .promotional-banner,
.layout-container .region--hamburger-menu-wilson .promotional-banner {
    background-color: var(--bg-color);
    box-shadow: none;
    text-align: left;
    padding: 16px 50px 16px 15px;
    position: relative;
    margin: 16px 0
}

.layout-container #block-ptbase-child-main-menu .promotional-banner .btn-100-tertiary::after,
.layout-container #block-ptbase-child-main-menu .promotional-banner .btn-tertiary::after,
.layout-container .region--hamburger-menu-wilson .promotional-banner .btn-100-tertiary::after,
.layout-container .region--hamburger-menu-wilson .promotional-banner .btn-tertiary::after {
    min-width: 12px;
    width: 12px;
    height: 12px
}

.layout-container #block-ptbase-child-main-menu .promotional-banner .truncate,
.layout-container .region--hamburger-menu-wilson .promotional-banner .truncate {
    -webkit-line-clamp: 3
}

.layout-container #block-ptbase-child-main-menu .promotional-banner a,
.layout-container .region--hamburger-menu-wilson .promotional-banner a {
    margin-top: 16px
}

.layout-container #block-ptbase-child-main-menu .promotional-banner .close-promotional-banner,
.layout-container .region--hamburger-menu-wilson .promotional-banner .close-promotional-banner {
    display: none
}

@media (min-width: 1200px) {

    .layout-container #block-ptbase-child-main-menu .promotional-banner,
    .layout-container .region--hamburger-menu-wilson .promotional-banner {
        display: none
    }
}

.next-block-arrow {
    display: flex;
    pointer-events: none;
    position: absolute;
    bottom: 0;
    width: 100%
}

.next-block-arrow.layout-builder-block {
    position: relative;
    pointer-events: auto
}

.next-block-arrow__alignment {
    width: 50px;
    cursor: pointer;
    transition: all .3s ease;
    pointer-events: auto
}

.next-block-arrow__alignment:hover {
    transform: translateY(10px);
    -ms-transform: translateY(10px);
    -webkit-transform: translateY(10px)
}

.next-block-arrow__alignment--left {
    justify-content: flex-start
}

.next-block-arrow__alignment--center {
    justify-content: center
}

.next-block-arrow__alignment--right {
    justify-content: flex-end
}

.next-block-arrow__alignment--color {
    fill: #04325e
}

.layout__white .next-block-arrow__alignment--color {
    fill: #04325e
}

.layout__grey .next-block-arrow__alignment--color {
    fill: #04325e
}

.layout__blue .next-block-arrow__alignment--color {
    fill: #fff
}

.layout__black .next-block-arrow__alignment--color {
    fill: #fff
}

.next-block-arrow__color--blue .next-block-arrow__alignment--color {
    fill: #04325e !important
}

.next-block-arrow__color--white .next-block-arrow__alignment--color {
    fill: #fff !important
}

@keyframes moving-border {
    25% {
        -o-border-image: linear-gradient(90deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1;
           border-image: linear-gradient(90deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1
    }

    50% {
        -o-border-image: linear-gradient(180deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1;
           border-image: linear-gradient(180deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1
    }

    75% {
        -o-border-image: linear-gradient(270deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1;
           border-image: linear-gradient(270deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1
    }

    100% {
        -o-border-image: linear-gradient(360deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1;
           border-image: linear-gradient(360deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1
    }
}

.block-quote {
    margin: auto;
    position: relative;
    max-height: 80vh;
    overflow: hidden;
    z-index: 99;
    justify-content: center;
    align-items: center
}

@media (max-width: 991.98px) {
    .block-quote {
        max-height: none
    }
}

.block-quote--pt {
    border: 8px solid #41b6e6
}

.block-quote--100 {
    --fade-deg: 45deg;
    border-style: solid;
    border-width: 8px;
    -o-border-image: linear-gradient(0deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1;
       border-image: linear-gradient(0deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1;
    animation: moving-border 25s linear infinite
}

.block-quote__media p {
    margin: 0
}

.block-quote__text {
    padding: 42px 32px
}

.block-quote__text--person {
    padding-top: 36px;
    font-weight: 700
}

.slideshow__wysiwyg {
    position: absolute;
    bottom: 30%;
    max-width: 400px;
    left: 8.33%
}

.slideshow__wysiwyg .big--title {
    margin-bottom: 0
}

.slideshow__wysiwyg p {
    margin: 0
}

.slideshow--left .slideshow__wysiwyg {
    left: 8.33%
}

.slideshow--left .slick--skin--pt-lines .slick-dots {
    left: 8.33%
}

.slideshow--right .slideshow__wysiwyg {
    right: 8.33%;
    left: unset
}

.slideshow--right .slick--skin--pt-lines .slick-dots {
    right: 8.33%;
    left: unset
}

.social-media-sharing ul {
    margin-bottom: 0
}

.social-media-sharing li {
    margin-right: 0;
    margin-left: 8px
}

.social-media-sharing__logo {
    width: 32px;
    height: 32px;
    background: 0 0;
    margin-bottom: 4px;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, .1607843137);
    border-radius: 50%;
    transition: all .3s ease
}

.social-media-sharing__logo g,
.social-media-sharing__logo path,
.social-media-sharing__logo svg {
    fill: var(--color-dark-blue)
}

.social-media-sharing__logo:hover {
    box-shadow: none;
    background-color: #f2f6f8
}

.social-media-sharing .share {
    transition: transform .3s ease;
    display: inline-block
}

.social-media-sharing .share img {
    width: 32px;
    height: 32px
}

.social-media-sharing__text {
    display: none
}

.layout__grey .social-media-sharing__logo:hover {
    background-color: #e8ebed
}

.layout__blue .social-media-sharing__logo {
    background-color: #17407a
}

.layout__blue .social-media-sharing__logo g,
.layout__blue .social-media-sharing__logo path,
.layout__blue .social-media-sharing__logo svg {
    fill: #fff
}

.layout__blue .social-media-sharing__logo:hover {
    background-color: #133666
}

.layout__black .social-media-sharing__logo,
.layout__dark_grey .social-media-sharing__logo {
    background-color: #4d4d4d
}

.layout__black .social-media-sharing__logo g,
.layout__black .social-media-sharing__logo path,
.layout__black .social-media-sharing__logo svg,
.layout__dark_grey .social-media-sharing__logo g,
.layout__dark_grey .social-media-sharing__logo path,
.layout__dark_grey .social-media-sharing__logo svg {
    fill: #fff
}

.layout__black .social-media-sharing__logo:hover,
.layout__dark_grey .social-media-sharing__logo:hover {
    background-color: #333
}

@media (min-width: 576px) {
    .social-share--hide-desktop:not(.layout-builder-block) {
        display: none
    }
}

.date-block {
    width: 100%
}

.filtering-articles-list {
    position: relative;
    background: #f2f6f8 0 0 no-repeat padding-box
}

.filtering-articles-list-banner {
    padding: 30px 0 0;
    position: relative;
    display: block
}

.filtering-articles-list-banner .back-news-list {
    color: #0077c8;
    padding: 6px 24px 6px 44px;
    background: rgba(255, 255, 255, .6);
    border-radius: 0 18px 18px 0;
    display: inline-flex;
    align-items: center;
    position: relative;
    z-index: 2;
    transition: all .3s ease-in-out
}

.filtering-articles-list-banner .back-news-list::before {
    content: "";
    width: 18px;
    height: 12px;
    margin-right: 3px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/arrow-previous-light-blue.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/arrow-previous-light-blue.svg); */
    background-color: #0077c8;
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease
}

.filtering-articles-list-banner .back-news-list:hover {
    text-decoration: underline;
    background: rgba(255, 255, 255, .8);
    color: var(--link-hover-color)
}

.filtering-articles-list-banner .back-news-list:hover:before {
    background-color: var(--link-hover-color)
}

@media (max-width: 767.98px) {
    .filtering-articles-list-banner .back-news-list {
        padding-left: 15px;
        margin-top: 25px;
        text-decoration: underline;
        background: rgba(255, 255, 255, .6);
        color: var(--link-hover-color)
    }

    .filtering-articles-list-banner .back-news-list:before {
        background-color: var(--link-hover-color)
    }
}

.filtering-articles-list-banner-bkg {
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 2px;
    left: 0;
    background: linear-gradient(to bottom, rgba(255, 0, 0, 0) 0, #f2f6f8 90%);
    z-index: 2
}

@media (max-width: 767.98px) {
    .filtering-articles-list-banner-bkg {
        background: linear-gradient(to bottom, rgba(255, 0, 0, 0) -50%, #f2f6f8 80%)
    }
}

.filtering-articles-list-banner-image {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2
}

.filtering-articles-list-text {
    padding: 45px;
    position: relative;
    z-index: 2
}

@media (max-width: 767.98px) {
    .filtering-articles-list-text {
        padding: 30px 15px
    }
}

.filtering-articles-list-text h1 {
    font-weight: 700;
    margin-bottom: 2px
}

.filtering-articles-list-text .description {
    max-width: 60%;
    padding-left: 2px
}

@media (max-width: 767.98px) {
    .filtering-articles-list-text .description {
        max-width: none
    }
}

.filtering-articles-list-raw {
    align-items: flex-start
}

@media (max-width: 767.98px) {
    .filtering-articles-list-raw {
        background-color: #f2f6f8
    }
}

.filtering-articles-list .filters-mobile-open-btn {
    padding: 8px;
    text-align: center;
    border: 1.5px solid #41b6e6;
    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, .1607843137);
    border-radius: 8px;
    color: #041e42;
    width: calc(100% - 30px);
    margin-left: 15px;
    z-index: 5;
    position: relative;
    display: none
}

.filtering-articles-list .filters-mobile-open-btn::before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 13px;
    margin-right: 5px;
    /* background-image: url(/src/images/icons/filters.svg); */
    background-size: contain
}

@media (max-width: 767.98px) {
    .filtering-articles-list .filters-mobile-open-btn {
        display: block
    }
}

.filtering-articles-list .filters-mobile-close-btn {
    position: absolute;
    top: 33px;
    right: 15px;
    background-color: transparent;
    border: 1.5px solid #41b6e6;
    text-align: center;
    width: 36px;
    height: 36px;
    line-height: 40px;
    border-radius: 50%;
    box-shadow: none;
    display: none
}

.filtering-articles-list .filters-mobile-close-btn::after {
    content: "";
    display: inline-block;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    width: 16px;
    height: 16px
}

@media (max-width: 767.98px) {
    .filtering-articles-list .filters-mobile-close-btn {
        display: block
    }
}

.filtering-articles-list .filtering-articles-wrap {
    background: #fff 0 0 no-repeat padding-box;
    border-radius: 0 16px 16px 0;
    padding: 32px 25px 38px 60px
}

@media (max-width: 767.98px) {
    .filtering-articles-list .filtering-articles-wrap {
        position: absolute;
        top: 0;
        left: -15px;
        width: calc(100vw - 45px);
        z-index: 5;
        padding: 33px 15px;
        transition: all .3s ease-in-out;
        transform: translateX(calc(-100% - 45px))
    }

    .filtering-articles-list .filtering-articles-wrap.opened {
        transform: none;
        padding-left: 30px
    }

    .filtering-articles-list .filtering-articles-wrap.opened::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: -60px;
        width: 60px;
        height: 100%;
        background: #041e42;
        opacity: .5
    }
}

.filtering-articles-list .filtering-articles-wrap .filters-details {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px
}

@media (max-width: 767.98px) {
    .filtering-articles-list .filtering-articles-wrap .filters-details {
        flex-direction: column
    }
}

.filtering-articles-list .filtering-articles-wrap .filters-counter {
    display: inline-block;
    vertical-align: top
}

.filtering-articles-list .filtering-articles-wrap .filters-counter h2 .active-filters-counter-h2 {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    margin-left: 15px;
    width: 20px;
    height: 20px;
    border: 1px solid #041e42;
    border-radius: 50%;
    color: #041e42;
    text-align: center
}

.filtering-articles-list .filtering-articles-wrap .filters-counter span {
    color: #8a8d8f
}

.filtering-articles-list .filtering-articles-wrap hr {
    border-top: 1px solid #8a8d8f;
    margin: 45px 0 42px
}

.filtering-articles-list .filtering-articles-wrap hr.filters-separatpr-mobile {
    display: none
}

@media (max-width: 767.98px) {
    .filtering-articles-list .filtering-articles-wrap hr.filters-separatpr-mobile {
        display: block
    }
}

.filtering-articles-list .filters-reset-btn {
    text-align: right;
    margin-top: 5px
}

@media (max-width: 767.98px) {
    .filtering-articles-list .filters-reset-btn {
        margin-top: 14px
    }
}

.filtering-articles-list .facet-clear-all {
    position: relative;
    color: #0077c8
}

.filtering-articles-list .facet-clear-all::before {
    content: "";
    position: absolute;
    left: 19px;
    bottom: 4px;
    height: 1px;
    background: #0060a1
}

.filtering-articles-list .facet-clear-all:hover {
    color: #0060a1
}

.filtering-articles-list .facet-clear-all:hover::before {
    right: 0
}

.filtering-articles-list .facet-clear-all:hover .close-btn:after,
.filtering-articles-list .facet-clear-all:hover .close-btn:before {
    background-color: #0060a1
}

.filtering-articles-list .facet-clear-all .close-btn {
    position: relative;
    display: inline-block;
    vertical-align: super;
    width: 10px;
    height: 10px;
    margin-right: 8px
}

.filtering-articles-list .facet-clear-all .close-btn:hover {
    opacity: 1
}

.filtering-articles-list .facet-clear-all .close-btn:after,
.filtering-articles-list .facet-clear-all .close-btn:before {
    position: absolute;
    top: 5px;
    left: 3px;
    content: "";
    height: 12px;
    width: 2px;
    background-color: #0077c8
}

.filtering-articles-list .facet-clear-all .close-btn:before {
    transform: rotate(45deg)
}

.filtering-articles-list .facet-clear-all .close-btn:after {
    transform: rotate(-45deg)
}

@media (max-width: 767.98px) {
    .filtering-articles-list .facet-clear-all {
        color: #0060a1
    }

    .filtering-articles-list .facet-clear-all::before {
        right: 0
    }

    .filtering-articles-list .facet-clear-all .close-btn:after,
    .filtering-articles-list .facet-clear-all .close-btn:before {
        background-color: #0060a1
    }
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox {
    list-style: none;
    padding-left: 10px
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item {
    margin-bottom: 25px
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item.facet-item--expanded.open .plus-icon::after {
    transform: rotate(90deg)
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item.facet-item--expanded .plus-icon {
    display: inline-block !important
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>.facets-checkbox[id^=tags] {
    display: none
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>.facets-checkbox[id^=tags]>ul {
    padding-left: 16px
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox {
    --form-radio-border: #041E42;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    margin-right: 10px;
    width: 17px;
    height: 17px;
    box-shadow: 0 0 0 1px var(--form-radio-border);
    border-radius: 4px;
    /* background: no-repeat top/50% url(/src/images/icons/checkmark-white.svg), #fff; */
    transition: box-shadow .2s ease, background .2s ease
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:hover {
    --form-radio-border: #041E42;
    /* background: no-repeat center/50% url(/src/images/icons/checkmark-white.svg), #8a8d8f */
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:hover.disabled:not(:checked) {
    background: rgba(4, 30, 66, .3)
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:checked {
    box-shadow: none;
    --form-bg-color: pt-blue-primary;
    /* background: no-repeat center/50% url(/src/images/icons/checkmark-white.svg), #041e42 */
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:checked.disabled {
    --form-bg-color: pt-blue-primary;
    opacity: .5;
    box-shadow: none
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:checked.disabled:hover {
    --form-bg-color: pt-blue-primary;
    opacity: .5;
    box-shadow: none
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:checked:hover {
    box-shadow: 0 0 0 1px var(--form-radio-border);
    --form-bg-color: rgba(4, 30, 66, 0.7)
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>.facets-widget- {
    display: none;
    padding-bottom: 1px
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>.facets-widget->ul {
    padding-left: 16px
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value {
    font-weight: 700;
    color: #041e42;
    cursor: pointer;
    position: relative
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value .plus-icon {
    display: none;
    position: relative;
    width: 16px;
    height: 16px;
    top: 0;
    left: -8px
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value .plus-icon::after,
.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value .plus-icon::before {
    content: "";
    background: #0077c8 0 0 no-repeat padding-box;
    position: absolute;
    transition: all .3s ease-in-out
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value .plus-icon::before {
    top: 9px;
    left: 0;
    width: 16px;
    height: 3px
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value .plus-icon::after {
    top: 3px;
    width: 3px;
    height: 16px;
    left: 7px
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .term-description {
    color: #041e42;
    margin-top: 6px;
    margin-bottom: 17px;
    display: none;
    padding-left: 16px
}

.open .filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .term-description {
    display: block
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facet-item-children-count {
    color: #041e42;
    border: 1px solid #041e42;
    width: 20px;
    height: 20px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    text-align: center;
    vertical-align: initial;
    margin-left: 10px
}

.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facet-item {
    list-style: none;
    margin-bottom: 10px
}

.filtering-articles-list .categories-filter {
    display: block
}

@media (max-width: 767.98px) {
    .filtering-articles-list .categories-filter {
        display: none
    }
}

.filtering-articles-list .categories-filter.mobile {
    display: none;
    width: 100%;
    padding: 0 15px
}

@media (max-width: 767.98px) {
    .filtering-articles-list .categories-filter.mobile {
        display: block
    }
}

.filtering-articles-list .categories-filter.mobile hr {
    border-top: 1px solid #8a8d8f;
    margin: 40px 0 50px
}

.filtering-articles-list .categories-filter-title {
    margin-bottom: 10px
}

.filtering-articles-list .categories-filter .facets-widget-links>ul {
    list-style: none;
    margin-bottom: 22px;
    padding: 0
}

.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item {
    position: relative;
    margin-bottom: 22px
}

.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a {
    letter-spacing: 0;
    color: #0077c8;
    position: relative;
    padding-bottom: 5px
}

.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a::after {
    content: "";
    width: 100%;
    height: 1px;
    background: #0077c8;
    position: absolute;
    left: 0;
    bottom: 0;
    transition: all .1s ease-in-out
}

.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a .facet-item__status {
    display: none
}

.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a.is-active {
    color: #041e42
}

.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a.is-active::after {
    width: 0 !important
}

.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a:hover::after {
    height: 3px;
    background: #0060a1
}

.filtering-articles-list .filtering-articles-content {
    padding-left: 30px;
    padding-right: 50px
}

@media (max-width: 767.98px) {
    .filtering-articles-list .filtering-articles-content {
        padding: 0 15px;
        margin: 0
    }
}

.filtering-articles-list .filtering-articles-content .articles-sort-counter {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px
}

@media (max-width: 767.98px) {
    .filtering-articles-list .filtering-articles-content .articles-sort-counter {
        padding: 0 15px
    }
}

.filtering-articles-list .filtering-articles-content .articles-sort-counter #edit-sort-by,
.filtering-articles-list .filtering-articles-content .articles-sort-counter #edit-submit-filtering-articles {
    display: none
}

.filtering-articles-list .filtering-articles-content .articles-sort-counter label.edit-sort-by {
    font-weight: 700;
    color: #041e42
}

.filtering-articles-list .filtering-articles-content .articles-sort-counter select#edit-sort-order {
    position: relative;
    width: 186px;
    height: 40px;
    border: 0;
    color: #041e42;
    border-radius: 8px;
    padding: 0 15px;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    /* background-image: url(/src/images/icons/chevron-down-dark-blue.svg); */
    background-repeat: no-repeat;
    background-size: 13px;
    background-position: calc(100% - 15px) 50%
}

.filtering-articles-list .filtering-articles-content .articles-sort-counter .form-item-sort-by {
    display: inline-block;
    width: 186px;
    text-align: left
}

.filtering-articles-list .filtering-articles-content .articles-sort-counter .counter {
    color: #54585a
}

.filtering-articles-list .facets-applied {
    padding-top: 37px;
    position: relative
}

.filtering-articles-list .facets-applied.no-filters {
    margin: 0
}

.filtering-articles-list .facets-applied.mobile {
    max-height: none;
    margin-bottom: 0;
    padding: 10px 0 0;
    display: none
}

@media (max-width: 767.98px) {
    .filtering-articles-list .facets-applied.mobile {
        display: block
    }
}

.filtering-articles-list .facets-applied.mobile .applied-facets-tags {
    margin: 0
}

.filtering-articles-list .facets-applied.mobile .applied-facets-tags .facet-tag {
    margin: 0 8px 15px 0
}

@media (max-width: 767.98px) {
    .filtering-articles-list .facets-applied {
        max-height: 120px;
        overflow: hidden;
        margin-bottom: 64px;
        padding: 32px 15px 0;
        transition: all .3s ease-in-out
    }
}

.filtering-articles-list .facets-applied-title {
    font-weight: 700;
    color: #041e42
}

.filtering-articles-list .facets-applied .empty-tags-label {
    color: #041e42
}

.filtering-articles-list .facets-applied .applied-facets-tags {
    margin-top: 12px;
    margin-bottom: 42px
}

.filtering-articles-list .facets-applied .facet-tag {
    color: #041e42;
    background-color: #f2f6f8;
    padding: 0 10px;
    border: 2px solid #041e42;
    border-radius: 10px;
    margin: 0 15px 12px 0;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    transition: all .3s ease-in-out
}

.filtering-articles-list .facets-applied .facet-tag .remove {
    padding: 0;
    border: 0;
    width: 16px;
    height: 16px;
    vertical-align: text-top;
    margin-left: 12px;
    background-color: transparent;
    /* background-image: url(/src/images/icons/x-dark-blue.svg); */
    background-size: 8px 8px;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%
}

.filtering-articles-list .facets-applied .facet-tag .remove:hover {
    background-color: #fff
}

.filtering-articles-list .facets-applied .facet-tag:hover {
    background-color: #e8ebed
}

.filtering-articles-list .facets-applied .facet-clear-all {
    margin-left: 30px
}

.filtering-articles-list .facets-applied .ellipsis-buttons {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    z-index: 3
}

@media (min-width: 576px) {
    .filtering-articles-list .facets-applied .ellipsis-buttons {
        display: none !important
    }
}

.filtering-articles-list .facets-applied .ellipsis-buttons button {
    padding: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
    font-weight: 700;
    color: #041e42;
    border-bottom: 1px solid #41b6e6
}

.filtering-articles-list .facets-applied .ellipsis-buttons button::before {
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 6px;
    /* background-image: url(/src/images/icons/x-dark-blue.svg); */
    transform: rotate(45deg)
}

.filtering-articles-list .facets-applied .ellipsis-overlay {
    background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 20%, #f2f6f8 80%, #f2f6f8 100%);
    position: absolute;
    display: block;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    z-index: 2
}

@media (min-width: 576px) {
    .filtering-articles-list .facets-applied .ellipsis-overlay {
        display: none !important
    }
}

.filtering-articles-list .article-long-summary--featured {
    background: 0 0;
    box-shadow: none
}

.filtering-articles-list .article-long-summary--featured .article-text {
    border-radius: 8px 0 0 8px;
    background: #041e42
}

@media (max-width: 767.98px) {
    .filtering-articles-list .article-long-summary--featured .article-text {
        border-radius: 0 0 8px 8px
    }
}

.filtering-articles-list .article-long-summary--featured .article-image .drupal-media__image--full-width img {
    border-radius: 0 8px 8px 0
}

@media (max-width: 767.98px) {
    .filtering-articles-list .article-long-summary--featured .article-image .drupal-media__image--full-width img {
        border-radius: 8px 8px 0 0
    }
}

.filtering-articles-list .article-long-summary {
    margin-top: 0
}

@media (max-width: 767.98px) {
    .filtering-articles-list .article-long-summary {
        margin: 0;
        padding: 0 15px;
        background-color: #f2f6f8
    }
    .filtering-articles-list .article-short-summary {
        padding: 0 15px;
        background-color: #f2f6f8;
        box-shadow: none
    }

    .filtering-articles-list .article-short-summary .short-summary__text {
        background-color: #fff;
        border-radius: 0 0 8px 8px
    }

    .filtering-articles-list .article-short-summary .drupal-media__image--full-width img {
        border-radius: 8px 8px 0 0
    }
}

.wysiwyg-accordion {
    margin-bottom: 7px;
    margin-top: 7px;
    transition: all .3s ease-in-out
}

.wysiwyg-accordion:not(.border-bottom) .wysiwyg-accordion__title,
.wysiwyg-accordion:not(.outline) .wysiwyg-accordion__title {
    padding-bottom: 12px
}

.wysiwyg-accordion.outline .accordion-container {
    box-shadow: 0 0 0 1px #8a8d8f;
    border-radius: 10px;
    position: relative
}

.wysiwyg-accordion.outline .accordion-container:hover {
    box-shadow: 0 0 0 2px #8a8d8f
}

.wysiwyg-accordion.outline a {
    padding: 10px 25px
}

.wysiwyg-accordion.outline .wysiwyg-accordion__title {
    padding: 8px 0
}

.wysiwyg-accordion.outline .wysiwyg-accordion__title.left {
    padding: 0
}

.wysiwyg-accordion.outline .wysiwyg-accordion__body p {
    margin-bottom: 0
}

.wysiwyg-accordion .right .text {
    margin-left: 0
}

.wysiwyg-accordion .right a {
    justify-content: space-between
}

.wysiwyg-accordion .icon {
    max-width: 16px;
    width: 100%;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center
}

.wysiwyg-accordion .icon:before {
    content: "";
    display: block;
    position: absolute;
    width: 16px;
    height: 2px
}

.wysiwyg-accordion .icon:after {
    content: "";
    display: block;
    width: 2px;
    height: 16px;
    transition: transform .3s ease
}

.wysiwyg-accordion .text {
    margin-left: 10px
}

.wysiwyg-accordion.bottom-border .accordion-container {
    box-shadow: 0 1px 0 0 #8a8d8f
}

.wysiwyg-accordion.bottom-border .accordion-container:hover {
    box-shadow: 0 2px 0 0 #8a8d8f
}

.wysiwyg-accordion.bottom-border .wysiwyg-accordion__body p {
    margin-bottom: 0;
    margin-top: 5px
}

.wysiwyg-accordion.bottom-border .wysiwyg-accordion__title {
    padding-bottom: 8px
}

.wysiwyg-accordion .opener {
    flex-direction: row;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start
}

.wysiwyg-accordion__body {
    padding: 0 45px 25px 25px
}

.wysiwyg-accordion__title.left {
    padding-bottom: 25px
}

.wysiwyg-accordion__title a {
    font-weight: 700;
    font-size: 1.8rem;
    line-height: 2.8rem;
    font-family: Axiforma;
    position: relative;
    --text-color: #41B6E6;
    display: inline-flex
}

.wysiwyg-accordion__title a:hover {
    text-decoration: none;
    cursor: pointer
}

.wysiwyg-accordion__title a:hover:after,
.wysiwyg-accordion__title a:hover:before {
    width: 3px
}

.wysiwyg-accordion__title a:not(.collapsed) .icon:after {
    transform: rotate(90deg)
}

.wysiwyg-accordion__title__dark a {
    --text-color: var(--color-dark-blue)
}

.wysiwyg-accordion__title__dark a .icon:after,
.wysiwyg-accordion__title__dark a .icon:before {
    background-color: var(--color-dark-blue)
}

.wysiwyg-accordion__title__light a {
    --text-color: var(--color-light-blue)
}

.wysiwyg-accordion__title__light a .icon:after,
.wysiwyg-accordion__title__light a .icon:before {
    background-color: var(--color-light-blue)
}

.theme-100.wysiwyg-accordion .wysiwyg-accordion__title a {
    --text-color: \$pt-white-secondary
}

.theme-100.wysiwyg-accordion .wysiwyg-accordion__title a .icon:after,
.theme-100.wysiwyg-accordion .wysiwyg-accordion__title a .icon:before {
    background-color: #fff
}

.social-media__title {
    font-size: 2.8rem;
    line-height: 1.1em;
    font-weight: 700
}

@media screen and (max-width: 767px) {
    .social-media__title {
        font-size: 2.3rem;
        line-height: 1.3em
    }
}

.social-media__nav {
    padding-left: 0;
    display: flex;
    list-style: none
}

.social-media__nav__icon {
    outline: 0;
    text-indent: -9999px;
    background-repeat: no-repeat;
    width: 25px;
    height: 25px;
    margin-right: 4px
}

.social-media__nav__icon:before {
    content: unset !important
}

.social-media__nav__icon a {
    display: block;
    width: 100%;
    height: 100%
}

/* 
.social-media__nav__facebook {
    background-image: url(/src/images/icons/facebook-white.svg)
}

.social-media__nav__instagram {
    background-image: url(/src/images/icons/instagram-white.svg)
}

.social-media__nav__linkedin {
    background-image: url(/src/images/icons/linkedin-white.svg)
}

.social-media__nav__pinterest {
    background-image: url(/src/images/icons/pinterest-white.svg)
}

.social-media__nav__twitter {
    background-image: url(/src/images/icons/twitter-white.svg)
}

.social-media__nav__youtube {
    background-image: url(/src/images/icons/youtube-white.svg)
} */

.social-media--big .social-media__nav__icon {
    width: 52px;
    height: 52px
}

/* 
.layout__grey .social-media__nav__facebook,
.layout__white .social-media__nav__facebook,
.pt-footer__ptsa .social-media__nav__facebook,
.ptwe-footer .social-media__nav__facebook {
    background-image: url(/src/images/icons/facebook-light-blue.svg)
}

.layout__grey .social-media__nav__instagram,
.layout__white .social-media__nav__instagram,
.pt-footer__ptsa .social-media__nav__instagram,
.ptwe-footer .social-media__nav__instagram {
    background-image: url(/src/images/icons/instagram-light-blue.svg)
}

.layout__grey .social-media__nav__linkedin,
.layout__white .social-media__nav__linkedin,
.pt-footer__ptsa .social-media__nav__linkedin,
.ptwe-footer .social-media__nav__linkedin {
    background-image: url(/src/images/icons/linkedin-light-blue.svg)
}

.layout__grey .social-media__nav__pinterest,
.layout__white .social-media__nav__pinterest,
.pt-footer__ptsa .social-media__nav__pinterest,
.ptwe-footer .social-media__nav__pinterest {
    background-image: url(/src/images/icons/pinterest-light-blue.svg)
}

.layout__grey .social-media__nav__twitter,
.layout__white .social-media__nav__twitter,
.pt-footer__ptsa .social-media__nav__twitter,
.ptwe-footer .social-media__nav__twitter {
    background-image: url(/src/images/icons/twitter-light-blue.svg)
}

.layout__grey .social-media__nav__youtube,
.layout__white .social-media__nav__youtube,
.pt-footer__ptsa .social-media__nav__youtube,
.ptwe-footer .social-media__nav__youtube {
    background-image: url(/src/images/icons/youtube-light-blue.svg)
} */

.pt-footer__ptsa .social-media__nav__icon,
.ptwe-footer .social-media__nav__icon {
    width: 25px;
    height: 25px
}

/* 
.pt-footer__ptsa .social-media__nav__facebook,
.ptwe-footer .social-media__nav__facebook {
    background-image: url(/src/images/icons/facebook.svg)
}

.pt-footer__ptsa .social-media__nav__instagram,
.ptwe-footer .social-media__nav__instagram {
    background-image: url(/src/images/icons/instagram.svg)
}

.pt-footer__ptsa .social-media__nav__linkedin,
.ptwe-footer .social-media__nav__linkedin {
    background-image: url(/src/images/icons/linkedin.svg)
}

.pt-footer__ptsa .social-media__nav__pinterest,
.ptwe-footer .social-media__nav__pinterest {
    background-image: url(/src/images/icons/pinterest.svg)
}

.pt-footer__ptsa .social-media__nav__twitter,
.ptwe-footer .social-media__nav__twitter {
    background-image: url(/src/images/icons/twitter.svg)
}

.pt-footer__ptsa .social-media__nav__youtube,
.ptwe-footer .social-media__nav__youtube {
    background-image: url(/src/images/icons/youtube.svg)
} */

.media__quote {
    color: #000
}

.media__quote__body {
    font-weight: 700;
    font-size: 3.4rem;
    line-height: 1.18em;
    padding-bottom: 15px
}

.media__quote__signature__name {
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 1.14em;
    padding-bottom: 5px
}

.media__quote__signature__title {
    font-size: 1.1rem;
    line-height: 1.45em
}

.node-grid {
    display: flex;
    flex-direction: column;
    margin: 0 auto auto auto;
    position: relative
}

.node-grid__image div {
    display: flex;
    flex: 1 0 auto;
    align-items: center;
    justify-content: center;
    justify-items: center
}

.node-grid__veil {
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: 0;
    transition: opacity .3s ease;
    background: #041e42;
    z-index: 9
}

.node-grid__main-container {
    position: relative;
    width: auto;
    overflow: hidden
}

@media (max-width: 767.98px) {
    .node-grid__main-container img {
        width: 100%
    }
}

.node-grid__title {
    padding: 13px 0 8px;
    text-align: center
}

.node-grid__text {
    display: none;
    color: #f2f6f8;
    position: absolute;
    bottom: 10%
}

.node-grid__wysiwyg p {
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0
}

.node-grid__link {
    box-shadow: none
}

.node-grid__link a {
    margin-bottom: 0;
    color: #41b6e6;
    letter-spacing: 1px
}

.node-grid__btn div {
    display: inline;
    white-space: nowrap
}

.node-grid:hover .node-grid__text {
    display: block;
    z-index: 10
}

@media (max-width: 767.98px) {
    .node-grid:hover .node-grid__text {
        display: none
    }
}

.node-grid:hover .node-grid__veil {
    opacity: .92
}

@media (max-width: 767.98px) {
    .node-grid:hover .node-grid__veil {
        opacity: 0
    }
}

.layout__black .node-grid__text,
.layout__black .node-grid__title,
.layout__blue .node-grid__text,
.layout__blue .node-grid__title,
.layout__gradient_blue .node-grid__text,
.layout__gradient_blue .node-grid__title {
    color: #fff
}

@media (min-width: 1200px) {
    .col-lg-5ths {
        flex: 0 0 20%;
        position: relative;
        min-height: 1px;
        padding-left: 15px;
        padding-right: 15px
    }
}

.node-hgrid .listing {
    display: inline-flex;
    flex-direction: column;
    border: 1px solid #8a8d8f;
    border-radius: 5px
}

@media (min-width: 992px) {
    .node-hgrid .listing {
        flex-direction: row;
        width: 100%
    }
}

.node-hgrid .listing__image {
    max-width: 165px;
    border-radius: 5px 5px 0 0;
    overflow: hidden;
    flex: 50% 0 1
}

@media (min-width: 992px) {
    .node-hgrid .listing__image {
        border-right: 1px solid #8a8d8f;
        border-radius: 10px
    }
}

.node-hgrid .listing__image img {
    border-radius: 5px 5px 0 0;
    transition: transform .3s ease
}

@media (min-width: 992px) {
    .node-hgrid .listing__image img {
        border-radius: 10px
    }
}

.node-hgrid .listing__text {
    max-width: 250px;
    color: #000;
    margin: 10px;
    flex: 50% 1 0
}

@media (min-width: 992px) {
    .node-hgrid .listing__text {
        margin: auto 10px
    }
}

.node-hgrid .listing__title {
    font-weight: 600;
    font-size: 1.5rem
}

.node-hgrid .listing__link {
    font-size: 1.2rem;
    display: flex
}

.node-hgrid .listing__link:after {
    content: "";
    display: inline-block;
    position: relative;
    width: 16px;
    height: 18px;
    margin-left: 3px;
    /* background-image: url(/src/images/icons/arrow-next-black.svg); */
    background-repeat: no-repeat;
    background-position: center center;
    transition: transform .3s ease
}

.node-hgrid .listing:hover .listing__image img {
    transform: scale(1.1)
}

.node-hgrid .listing:hover .listing__link:after {
    transform: translateX(5px)
}

.shadow-media {
    box-shadow: 15px 15px 30px 0 rgba(0, 0, 0, .15);
    margin-bottom: 40px
}

.author-box {
    display: flex;
    margin-bottom: 16px
}

.author-box .column {
    position: relative
}

.author-box .author-image .drupal-media img {
    width: 76px;
    border: 2px solid #f2f6f8;
    border-radius: 250px;
    background: #fff 0 0 no-repeat padding-box
}

.author-box .author-details {
    margin: auto 24px;
    max-width: 225px;
    width: 100%
}

.author-box .author-details .author-name {
    margin-bottom: 4px;
    line-height: 2.8rem
}

.author-box .author-details .author-description,
.author-box .author-details .author-organization {
    line-height: 2.8rem
}

.author-box .author-details .author-name,
.author-box .author-details .author-organization {
    font-weight: 700
}

.back-to-top {
    position: absolute;
    right: 15px;
    bottom: 15px;
    color: #41b6e6;
    padding: 5px 15px;
    font-size: 1.6rem;
    font-weight: 600;
    letter-spacing: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    letter-spacing: .4px;
    text-indent: -50000px
}

@media (min-width: 768px) {
    .back-to-top {
        padding: 10px 30px;
        right: 15px;
        top: 15px;
        text-indent: 0;
        height: 50px
    }
}

.back-to-top__svg {
    display: block;
    margin-left: 10px;
    width: 38px;
    height: 38px
}

@media (min-width: 768px) {
    .back-to-top__svg {
        width: 50px;
        height: 50px
    }
}

.badge-list {
    margin: 13px 0
}

.badge-list__title {
    font-size: 2.8rem;
    font-weight: 700;
    margin-bottom: 10px
}

.badge-list__description {
    font-size: 1.4rem
}

@media (min-width: 768px) and (max-width:991.98px) {
    .team-members {
        margin-left: -40px
    }
}

.team-members .badge-list__text-block {
    color: #041e42;
    padding-left: 32px
}

@media (max-width: 767.98px) {
    .team-members .badge-list__text-block {
        padding-left: 15px
    }
}

.team-members .badge-list__image {
    margin: 0;
    padding: 0;
    display: contents
}

@media (max-width: 1199.98px) {
    .team-members .badge-list__image {
        display: block
    }
}

@media (max-width: 767.98px) {
    .team-members .badge-list__image {
        flex-basis: auto;
        text-align: center;
        padding-top: 40px;
        padding-bottom: 15px
    }
}

.team-members .badge-list__image picture {
    margin: 0
}

@media (max-width: 1199.98px) {
    .team-members .badge-list__image picture {
        margin: auto;
        padding-bottom: 10px
    }
}

.team-members .badge-list__image picture img {
    width: 228px
}

.features {
    max-width: 300px
}

.features .badge-list__image {
    margin: 0;
    padding-bottom: 30px
}

.features .badge-list__image.text-align-center .media__image {
    margin: 0 auto
}

.features .badge-list__image picture {
    margin: 0
}

.features .badge-list__image .media__image {
    width: 100px
}

.features .badge-list__image .media__image img {
    height: 100px
}

.features .badge-list__title {
    --text-color: #41B6E6
}

.features .badge-list__description {
    --text-color: #8A8D8F
}

.features .badge-list__title {
    font-size: 2.2rem;
    font-weight: 500
}

.badge-features-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    max-width: 100%
}

.badge-features-container>div {
    flex-grow: 1;
    flex-basis: 0
}

.btn__filter,
a.btn__filter {
    padding: 10px 15px;
    display: flex;
    border-radius: 5px;
    position: absolute;
    width: 80%;
    top: 20px;
    right: 0;
    bottom: 0;
    left: 0;
    color: #000;
    margin: 0 auto;
    font-size: 1.5rem;
    text-align: left;
    cursor: pointer;
    line-height: 15px;
    height: 35px;
    border: none;
    margin: 5px;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, .1607843137);
    transition: all ease .3s
}

.btn__filter:focus,
.btn__filter:hover,
a.btn__filter:focus,
a.btn__filter:hover {
    background-color: #f2f6f8;
    color: #041e42;
    outline: 0
}

.btn__filter .svg-before,
a.btn__filter .svg-before {
    width: 18px;
    margin-right: 15px;
    display: flex
}

.btn__filter .svg-before #lineOne,
a.btn__filter .svg-before #lineOne {
    transform: translate(3px, 3px) rotate(-90deg)
}

.btn__filter .svg-before #lineTwo,
a.btn__filter .svg-before #lineTwo {
    transform: translate(3px, 8px) rotate(-90deg)
}

.btn__filter .svg-before #lineThree,
a.btn__filter .svg-before #lineThree {
    transform: translate(3px, 13px) rotate(-90deg)
}

.btn__filter .svg-before #dotOne,
.btn__filter .svg-before #dotThree,
.btn__filter .svg-before #dotTwo,
a.btn__filter .svg-before #dotOne,
a.btn__filter .svg-before #dotThree,
a.btn__filter .svg-before #dotTwo {
    transition: transform .3s ease
}

.btn__filter .svg-before #dotOne,
.btn__filter .svg-before #dotThree,
a.btn__filter .svg-before #dotOne,
a.btn__filter .svg-before #dotThree {
    transform: translateX(-6.5px)
}

.btn__filter .svg-before #dotTwo,
a.btn__filter .svg-before #dotTwo {
    transform: translateX(6.5px)
}

.btn__filter .svg-after,
a.btn__filter .svg-after {
    width: 14px;
    display: flex;
    position: absolute;
    right: 15px;
    transition: transform .3s ease;
    transform: scale(1)
}

.btn__cross,
a.btn__cross {
    padding: 10px 50px 10px 25px
}

.btn__cross:before,
a.btn__cross:before {
    content: "";
    width: 19px;
    height: 19px;
    position: absolute;
    display: inline-block;
    border-radius: 25px;
    background-color: #041e42;
    right: 15px;
    top: 9px
}

.btn__cross:after,
a.btn__cross:after {
    content: " ";
    width: 16px;
    /* background: url(/src/images/icons/close-button-white.svg); */
    height: 16px;
    background-size: 100%;
    background-repeat: no-repeat;
    margin-left: 8px;
    position: absolute;
    right: 16.5px;
    top: 10px;
    transform: translate3d(0, 0, 0);
    transition: transform ease .2s
}

.btn__cross:hover:after,
a.btn__cross:hover:after {
    transform: scale(1.1)
}

.btn__filter.collapsed:after {
    opacity: 0
}

.btn__filter.collapsed .svg-before #dotOne,
.btn__filter.collapsed .svg-before #dotThree,
.btn__filter.collapsed .svg-before #dotTwo {
    transform: translateX(0)
}

.btn__filter.collapsed .svg-after {
    transform: scale(0)
}

layout__black,
layout__blue,
layout__dark_grey,
layout__light_blue {
    --link-color: #41B6E6;
    --link-hover-color: #0077C8
}

.cta-block {
    position: relative;
    right: 0;
    align-items: center;
    z-index: 1;
    transition: .3s ease-in
}

.cta-block--desktop {
    display: none
}

@media (min-width: 1200px) {
    .cta-block--desktop {
        display: flex
    }
}

.cta-block a {
    background-color: #041e42;
    --text-color: #FFFFFF
}

.cta-block a:hover {
    background-color: #041e42
}

.cta-block.block-cta--hidden {
    transform: translateX(-500px);
    position: relative;
    opacity: 0
}

.cta-block--mobile .d-xl-none {
    display: none
}

.cta-description {
    display: none
}

.hamburger-menu .cta-block {
    z-index: 999;
    width: 100%;
    margin: 30px 0
}

.hamburger-menu .cta-block li {
    align-items: flex-end;
    display: flex;
    flex-direction: column
}

.hamburger-menu .cta-block li a {
    background-color: #041e42
}

.hamburger-menu .cta-block.sticky-left .menu-item {
    justify-content: flex-start
}

.hamburger-menu .cta-block.sticky-right .menu-item {
    justify-content: flex-end
}

.hamburger-menu .cta-block .cta-description {
    display: block;
    text-align: left
}

@media (min-width: 1200px) {
    .hamburger-menu .cta-block {
        display: none
    }
}

.region--primary-menu .hamburger-menu .menu-level-0>.menu-item {
    align-items: flex-start
}

.region--primary-menu .hamburger-menu .menu-level-0>.menu-item>.menu-link.btn {
    background-color: #041e42;
    color: #fff
}

.layout-container>.cta-block {
    z-index: 999;
    position: fixed;
    bottom: 0;
    width: 100%;
    display: none;
    padding: 0 15px 15px;
    background-image: linear-gradient(0deg, #fff, transparent)
}

@media (max-width: 1199.98px) {
    .layout-container>.cta-block {
        display: flex
    }
}

.layout-container>.cta-block.sticky-right {
    justify-content: flex-end
}

.layout-container>.cta-block.sticky-left {
    justify-content: flex-start
}

.pt-form__checkbox {
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    margin-right: 10px;
    width: 21px;
    height: 21px;
    border: 1px solid #616365;
    border-radius: 3px;
    background: #fff;
    transition: background .1s ease
}

.pt-form__checkbox:hover {
    /* background: url(/src/images/icons/checkmark-white.svg), #8a8d8f; */
    background-size: 50%, 100%;
    background-position: 50%;
    background-repeat: no-repeat
}

.pt-form__checkbox:checked {
    /* background: url(/src/images/icons/checkmark-white.svg), #041e42; */
    background-size: 50%, 100%;
    background-position: 50%;
    background-repeat: no-repeat
}

.pt-form .align-checkbox-label {
    margin-left: 31px
}

.entity-media--cover_fit {
    height: 100%
}

.drupal-media--cover-fit {
    height: 100%
}

.drupal-media--cover-fit .drupal-media__image {
    height: 100%
}

.drupal-media--cover-fit .drupal-media__image picture {
    height: 100%
}

.drupal-media--cover-fit .drupal-media__image picture img {
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center center;
       object-position: center center;
    display: block;
    width: 100%;
    height: 100%;
    visibility: hidden
}

.exposed-search {
    align-items: center;
    display: flex;
    height: 26px;
    position: relative
}

.exposed-search .form-item label {
    position: fixed;
    top: -100px;
    visibility: hidden;
    z-index: -1
}

.exposed-search .form-actions {
    display: flex;
    height: 15px;
    position: absolute;
    right: 1.65rem;
    width: 15px
}

.exposed-search .form-actions input {
    /* background: transparent url(/src/images/icons/search.svg) no-repeat center center/cover; */
    border: 0;
    font-size: 0;
    height: 15px;
    margin: 0;
    padding: 0;
    width: 15px
}

.exposed-search .form-text {
    border: 0;
    border-radius: 4px;
    color: #7b7b7b;
    font-size: 1.2rem;
    height: 26px;
    padding: 0 4.65rem 0 1.65rem;
    width: 289px
}

div,
h1,
h2,
h3,
h4,
p {
    color: var(--text-color)
}

body {
    color: var(--text-color);
    background: 0 0;
    font-family: var(--secondary-font);
    font-style: normal
}

.pt-font--pt-blue-primary {
    color: #041e42
}

.pt-font--pt-white-secondary {
    color: #fff
}

.pt-font--pt-light-blue-secondary {
    color: #41b6e6
}

.pt-font--pt-grey-secondary {
    color: #8a8d8f
}

.pt-font--pt-grey {
    color: #c7cfd7
}

.pt-font--pt-light-blue-tertiary {
    color: #0077c8
}

.pt-font--pt-blue-tertiary {
    color: #04325e
}

.pt-font--pt-grey-tertiary {
    color: #54585a
}

.pt-font--pt-white-tertiary {
    color: #f2f6f8
}

.pt-font--liveline-primary {
    color: #1791f9
}

.pt-font--liveline-secondary {
    color: #4ffafe
}

.pt-font--wilson-dark-grey {
    color: #484b4d
}

.pt-font--pt-green {
    color: #00a84f
}

.pt-font--pt-red {
    color: #e21b23
}

.pt-font--pt-orange {
    color: #f05c22
}

.pt-font--pt-yellow {
    color: #fcba30
}

.pt-font--pt-black {
    color: #000
}

.pt-font--epic-pink {
    color: #e0457b
}

.pt-font--passionate-tangerine {
    color: #e04f39
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff");
    font-weight: 100;
    font-style: normal;
    font-display: swap
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff");
    font-weight: 200;
    font-style: normal;
    font-display: swap
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff");
    font-weight: 200;
    font-style: italic;
    font-display: swap
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff");
    font-weight: 300;
    font-style: normal;
    font-display: swap
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff");
    font-weight: 300;
    font-style: italic;
    font-display: swap
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
    font-weight: 400;
    font-style: normal;
    font-display: swap
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff");
    font-weight: 400;
    font-style: italic;
    font-display: swap
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff");
    font-weight: 500;
    font-style: normal;
    font-display: swap
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
    font-weight: 700;
    font-style: normal;
    font-display: swap
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff");
    font-weight: 900;
    font-style: normal;
    font-display: swap
}

@font-face {
    font-family: Axiforma;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff");
    font-weight: 900;
    font-style: italic;
    font-display: swap
}


@media (min-width: 992px) {
    .collapse.dont-collapse-sm {
        display: block;
        height: auto !important;
        visibility: visible
    }
}

.toolbox-footer {
    position: relative;
    color: var(--color-dark-blue);
    display: inline-grid;
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin: 0 15px
}

.toolbox-footer .btn__arrow:after {
    min-width: 10px;
    width: 10px
}

.toolbox-footer .contextual-region {
    position: unset
}

.toolbox-footer .grid-span {
    grid-column: span 2
}

@media (min-width: 992px) {
    .toolbox-footer .grid-span {
        grid-column: span 3
    }
}

.toolbox-footer a {
    color: var(--color-dark-blue)
}

.toolbox-footer a:hover {
    color: var(--color-dark-blue)
}

@media (min-width: 992px) {
    .toolbox-footer {
        display: grid;
        grid-template-columns: 40% 35% 25%;
        grid-template-rows: repeat(6, min-content);
        margin: 0 auto;
        margin: 0 50px
    }
}

.toolbox-footer .menus {
    font-size: 1.4rem
}

@media (min-width: 992px) {
    .toolbox-footer .menus a {
        position: relative
    }

    .toolbox-footer .menus a:before {
        content: "";
        overflow: hidden;
        position: absolute;
        height: 2px;
        background: #da291c;
        bottom: -2px;
        width: 0;
        transition: width .3s ease
    }

    .toolbox-footer .menus a:hover:before {
        width: 100%
    }
    .toolbox-footer .menus {
        grid-column: 2;
        grid-row: 1/span 2;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
        grid-auto-flow: column;
        padding-left: 30px;
        border-left: 1px solid #c7cfd7
    }
}

.toolbox-footer .menus ul {
    padding-left: 0
}

@media (min-width: 992px) {
    .toolbox-footer .menus .menu-1 li:first-of-type {
        padding-top: 0
    }
}

.toolbox-footer .menus .menu-1 a:not(.font-weight-bold) a,
.toolbox-footer .menus .menu-2 a:not(.font-weight-bold) a {
    font-weight: 400
}

.toolbox-footer .menus .menu-1 li,
.toolbox-footer .menus .menu-2 li {
    padding-top: 25px;
    padding-left: 10px;
    color: var(--color-dark-blue)
}

@media (max-width: 991.98px) {

    .toolbox-footer .menus .menu-1 li,
    .toolbox-footer .menus .menu-2 li {
        border-bottom: 1px solid #c7cfd7
    }
}

.toolbox-footer .menus .menu-2 li:first-of-type {
    padding-top: 50px
}

.toolbox-footer .menus .menu-3 {
    margin-top: 50px
}

@media (min-width: 992px) {
    .toolbox-footer .menus .menu-3 {
        margin-top: 0
    }
}

@media (max-width: 991.98px) {

    .toolbox-footer .menus .menu-3 .menu-collapse li,
    .toolbox-footer .menus .menu-4 .menu-collapse li {
        padding-left: 20px
    }
}

.toolbox-footer .menus .menu-3 li,
.toolbox-footer .menus .menu-4 li {
    padding-left: 10px
}

.toolbox-footer .menus .menu-3 h4,
.toolbox-footer .menus .menu-4 h4 {
    font-weight: 600;
    margin-bottom: 0;
    position: relative
}

@media (max-width: 991.98px) {

    .toolbox-footer .menus .menu-3 h4:before,
    .toolbox-footer .menus .menu-4 h4:before {
        content: "";
        position: absolute;
        width: 10px;
        height: 1px;
        right: 10px;
        background: var(--color-dark-blue);
        top: 50%;
        transform: rotate(90deg);
        transition: transform .3s ease
    }

    .toolbox-footer .menus .menu-3 h4:after,
    .toolbox-footer .menus .menu-4 h4:after {
        content: "";
        position: absolute;
        width: 10px;
        height: 1px;
        right: 10px;
        top: 50%;
        background: var(--color-dark-blue)
    }

    .toolbox-footer .menus .menu-3 h4:not(.collapsed):before,
    .toolbox-footer .menus .menu-4 h4:not(.collapsed):before {
        content: "";
        position: absolute;
        width: 10px;
        height: 1px;
        right: 10px;
        background: var(--color-dark-blue);
        top: 50%;
        transform: rotate(0)
    }
}

.toolbox-footer .menus .menu-3 h4,
.toolbox-footer .menus .menu-4 h4 {
    margin-top: 25px;
    padding-top: 25px;
    padding-left: 10px;
    color: var(--color-dark-blue);
    padding-top: 0
}

@media (max-width: 991.98px) {

    .toolbox-footer .menus .menu-3 h4,
    .toolbox-footer .menus .menu-4 h4 {
        border-bottom: 1px solid #c7cfd7
    }
}

@media (min-width: 992px) {

    .toolbox-footer .menus .menu-3 h4,
    .toolbox-footer .menus .menu-4 h4 {
        margin-top: 0
    }
}

.toolbox-footer__header {
    display: flex;
    position: relative;
    width: 100%;
    height: 45px;
    margin-bottom: 35px;
    justify-content: space-between;
    box-shadow: 0 5px 5px 1px #d2d2d2
}

.toolbox-footer__header .back-to-top {
    position: relative;
    text-indent: 0;
    right: unset;
    top: unset;
    bottom: unset;
    padding: 0;
    margin-right: 15px
}

@media (min-width: 992px) {
    .toolbox-footer__header .back-to-top {
        margin-right: 30px
    }
}

.toolbox-footer__header .back-to-top h4 {
    color: #000;
    margin-left: 5px;
    margin-bottom: 0
}

.toolbox-footer__header .back-to-top__svg {
    display: flex;
    margin: auto;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: #000;
    padding: 6px
}

@media (min-width: 992px) {
    .toolbox-footer__header .back-to-top__svg {
        width: 30px;
        height: 30px;
        display: flex;
        top: unset
    }
}

.toolbox-footer .contact-us {
    font-size: 1.4rem;
    padding-right: 10px;
    padding-left: 10px
}

@media (min-width: 992px) {
    .toolbox-footer .contact-us {
        padding-left: 0;
        grid-column: 1
    }
}

.toolbox-footer .contact-us .phone {
    padding: 8px 11.5px;
    border-radius: 5px;
    margin-right: 25px
}

@media (min-width: 992px) {
    .toolbox-footer .contact-us .phone {
        padding-left: 0
    }
}

@media (max-width: 991.98px) {
    .toolbox-footer .contact-us .phone {
        border: 1px solid #c7cfd7
    }
}

.toolbox-footer .contact-us .mail {
    padding: 7px 11.5px;
    border-radius: 5px
}

@media (max-width: 991.98px) {
    .toolbox-footer .contact-us .mail {
        border: 1px solid #c7cfd7
    }
}

.toolbox-footer ul {
    list-style: none;
    color: var(--color-dark-blue)
}

.toolbox-footer .company {
    font-size: 1.2rem;
    color: #616365
}

@media (min-width: 992px) {
    .toolbox-footer .company {
        grid-column: 1;
        grid-row: 1
    }
}

.toolbox-footer .company img {
    width: 33%
}

.toolbox-footer .brands {
    justify-items: center;
    align-items: center;
    position: relative;
    padding-left: 10px;
    margin-top: 50px;
    margin-bottom: 25px
}

@media (min-width: 992px) {
    .toolbox-footer .brands {
        grid-column: span 3;
        width: calc(100% + 100px);
        display: flex;
        transform: translateX(-50px);
        flex-direction: column;
        align-items: center;
        padding: 15px 0;
        box-shadow: 0 0 5px 1px #d2d2d2
    }
}

@media (max-width: 991.98px) {
    .toolbox-footer .brands h4 {
        border-bottom: 1px solid #c7cfd7
    }
}

.toolbox-footer .brands h4 {
    font-weight: 600;
    margin-bottom: 0;
    position: relative
}

@media (max-width: 991.98px) {
    .toolbox-footer .brands h4:before {
        content: "";
        position: absolute;
        width: 10px;
        height: 1px;
        right: 10px;
        background: var(--color-dark-blue);
        top: 50%;
        transform: rotate(90deg);
        transition: transform .3s ease
    }

    .toolbox-footer .brands h4:after {
        content: "";
        position: absolute;
        width: 10px;
        height: 1px;
        right: 10px;
        top: 50%;
        background: var(--color-dark-blue)
    }

    .toolbox-footer .brands h4:not(.collapsed):before {
        content: "";
        position: absolute;
        width: 10px;
        height: 1px;
        right: 10px;
        background: var(--color-dark-blue);
        top: 50%;
        transform: rotate(0)
    }
}

.toolbox-footer .brands img {
    width: 80px
}

.toolbox-footer .brands ul {
    display: flex;
    margin-right: 5px;
    justify-items: center;
    align-items: center
}

@media (max-width: 1199.98px) {
    .toolbox-footer .brands ul {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-row-gap: 10px;
        padding-left: 0
    }
}

.toolbox-footer .brands ul li {
    width: -moz-max-content;
    width: max-content
}

@media (min-width: 992px) {
    .toolbox-footer .brands ul li {
        padding: 0 20px
    }
}

.toolbox-footer .brands__link.btn__arrow {
    position: relative;
    font-weight: 400;
    font-size: 1.4rem;
    width: -moz-fit-content;
    width: fit-content;
    grid-column-start: 4;
    max-width: 80px
}

.toolbox-footer .brands__link.btn__arrow:after {
    position: absolute;
    right: 0
}

.toolbox-footer .other-brands {
    margin-bottom: 50px;
    padding-left: 10px
}

@media (min-width: 992px) {
    .toolbox-footer .other-brands {
        grid-column: span 3;
        width: 100vw;
        display: flex;
        margin-left: -50vw;
        position: relative;
        left: 50%;
        flex-direction: column;
        align-items: center;
        padding: 15px 0
    }
}

@media (max-width: 991.98px) {
    .toolbox-footer .other-brands h4 {
        border-bottom: 1px solid #c7cfd7
    }
}

.toolbox-footer .other-brands h4 {
    font-weight: 600;
    margin-bottom: 0;
    position: relative
}

@media (max-width: 991.98px) {
    .toolbox-footer .other-brands h4:before {
        content: "";
        position: absolute;
        width: 10px;
        height: 1px;
        right: 10px;
        background: var(--color-dark-blue);
        top: 50%;
        transform: rotate(90deg);
        transition: transform .3s ease
    }

    .toolbox-footer .other-brands h4:after {
        content: "";
        position: absolute;
        width: 10px;
        height: 1px;
        right: 10px;
        top: 50%;
        background: var(--color-dark-blue)
    }

    .toolbox-footer .other-brands h4:not(.collapsed):before {
        content: "";
        position: absolute;
        width: 10px;
        height: 1px;
        right: 10px;
        background: var(--color-dark-blue);
        top: 50%;
        transform: rotate(0)
    }
}

.toolbox-footer .other-brands ul {
    padding-left: 10px
}

@media (min-width: 992px) {
    .toolbox-footer .other-brands ul {
        display: flex;
        margin-right: 5px
    }
    .toolbox-footer .other-brands ul li {
        padding: 0 30px
    }
}

.toolbox-footer .other-brands__link .link-text {
    font-size: 1.4rem;
    margin-bottom: 5px;
    width: -moz-fit-content;
    width: fit-content;
    position: relative
}

.toolbox-footer .other-brands__link .link-text:after {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    top: 25%;
    margin-left: 5px;
    /* background-image: url(/src/images/icons/icon-external-link.svg) */
}

.toolbox-footer .menu-collapse {
    margin-top: 10px
}

@media (min-width: 992px) {
    .toolbox-footer .menu-collapse {
        display: block
    }
}

.toolbox-footer .socials {
    display: flex;
    align-items: center;
    margin-bottom: 5px
}

.toolbox-footer .socials ul {
    padding-left: 0;
    display: flex;
    margin-bottom: 0
}

.toolbox-footer .socials li {
    padding-right: 25px
}

@media (min-width: 992px) {
    .toolbox-footer .socials li {
        padding-right: 20px
    }
}

.toolbox-footer .socials .icon {
    display: block;
    text-indent: -50000px;
    width: 20px;
    background-repeat: no-repeat
}

/* 
.toolbox-footer .socials .facebook {
    background-image: url(/src/images/icons/icon-facebook.svg);
    background-position: 50% 50%
}

.toolbox-footer .socials .instagram {
    background-image: url(/src/images/icons/icon-instagram.svg);
    background-position: 50% 50%
}

.toolbox-footer .socials .pinterest {
    background-image: url(/src/images/icons/icon-pinterest.svg);
    background-position: 50% 50%
}

.toolbox-footer .socials .youtube {
    background-image: url(/src/images/icons/icon-youtube.svg);
    background-position: 50% 50%
} */

.toolbox-footer .btn__arrow {
    --color-light-blue: var(--color-dark-blue)
}

.toolbox-footer .btn__arrow a {
    font-weight: 500
}

.toolbox-footer .copyright p {
    font-size: 1rem;
    color: #c7cfd7
}

.toolbox-footer .footer-links {
    font-size: 1rem;
    color: #c7cfd7
}

.toolbox-footer .footer-links ul {
    display: flex;
    padding-left: 0
}

.toolbox-footer .footer-links li a {
    margin: 0 10px
}

@media (max-width: 991.98px) {
    .toolbox-footer .footer-links li a {
        border-bottom: 1px solid #c7cfd7
    }
}

.toolbox-footer .footer-links li a:first-of-type {
    margin-left: 0
}

.toolbox-footer .lang-switcher.pt-langswitcher {
    justify-self: center;
    margin-bottom: 5px
}

@media (min-width: 992px) {
    .toolbox-footer .lang-switcher.pt-langswitcher {
        grid-column: 3;
        grid-row: 2;
        align-self: baseline;
        justify-self: end
    }
}

.toolbox-footer .newsletters {
    margin-bottom: 40px;
    margin-top: 25px
}

@media (min-width: 992px) {
    .toolbox-footer .newsletters {
        margin-top: 0;
        grid-column: 3;
        grid-row: 1;
        justify-self: center
    }
    .toolbox-footer .copyright {
        grid-column: 1/span 3;
        grid-row: 6;
        justify-self: left;
        align-self: center
    }
    .toolbox-footer .footer-links {
        grid-column: 1/span 3;
        grid-row: 6;
        justify-self: center;
        align-self: center
    }
    .toolbox-footer .socials {
        grid-column: 1/span 3;
        grid-row: 6;
        justify-self: end;
        align-self: center
    }
}

.pt-footer__logo_secondaire a img {
    transition: all .3s ease-in-out
}

.pt-footer__logo_secondaire a img:hover {
    transform: scale(1.05)
}

.font-weight-extrabold {
    font-weight: 700 !important
}

.font-weight-bold--arrow:after,
.font-weight-extrabold--arrow:after {
    /* background-image: url(/src/images/icons/arrow-next-black.svg); */
    background-repeat: no-repeat;
    width: 30px;
    height: 30px;
    transition: left .2s ease-out;
    left: 0;
    position: relative;
    content: "";
    display: inline-block;
    background-color: transparent;
    vertical-align: middle;
    top: -1px
}

.font-weight-bold--arrow:after:hover:after,
.font-weight-extrabold--arrow:after:hover:after {
    /* background-image: url(/src/images/icons/arrow-next-light-blue-old.svg); */
    left: 3px
}

.ui-dialog[aria-describedby=drupal-modal] .ui-dialog-titlebar {
    background: 0 0;
    border: none;
    height: 45px
}

.ui-dialog[aria-describedby=drupal-modal] .ui-widget-content {
    border: none;
    background-color: #fff
}

.ui-dialog[aria-describedby=drupal-modal] .ui-widget.ui-widget-content {
    border: none
}

.ui-dialog[aria-describedby=drupal-modal] .ui-dialog-title {
    display: none
}

.ui-dialog[aria-describedby=drupal-modal] .ui-front .ui-dialog-content {
    background-color: #fff
}

.ui-dialog[aria-describedby=drupal-modal] .ui-dialog-buttonpane {
    background-color: #fff;
    height: 9.6rem;
    text-align: left;
    border-width: 1px 0 0 0;
    background-image: none;
    margin-top: 0;
    padding: .3em 1em .5em .4em
}

.ui-dialog[aria-describedby=drupal-modal] .ui-icon-closethick {
    display: none
}

.ui-dialog[aria-describedby=drupal-modal] .ui-button.ui-corner-all.ui-widget.ui-button-icon-only.ui-dialog-titlebar-close {
    position: absolute;
    /* background: url(/src/images/icons/close-button-light.svg) no-repeat; */
    background-position: center center;
    background-size: contain;
    width: 3.52rem;
    height: 3.52rem;
    text-indent: -9999px;
    top: 0;
    right: 7px;
    border: none
}

.ui-dialog[aria-describedby=drupal-modal] .ui-button.ui-corner-all.ui-widget.ui-button-icon-only.ui-dialog-titlebar-close:hover {
    /* background: url(/src/images/icons/close-button-dark.svg) no-repeat; */
    background-position: center center;
    background-size: contain
}

.ui-dialog[aria-describedby=drupal-modal] .download-button {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    margin-top: 6.4rem;
    margin-bottom: 2.4rem
}

.ui-dialog[aria-describedby=drupal-modal] .js-webform-confirmation-back-link-ajax {
    color: #041e42 !important;
    font-weight: 700
}

.ui-dialog[aria-describedby=drupal-modal] .webform-button--submit {
    cursor: pointer;
    background-color: #41b6e6
}

.ui-dialog[aria-describedby=drupal-modal] .webform-button--submit:hover {
    background-color: #41b6e6 !important;
    font-weight: 700 !important
}

@media screen and (max-width: 767.98px) and (orientation:portrait) {
    .ui-dialog[aria-describedby=drupal-modal] .ui-dialog-buttonpane .ui-dialog-buttonset+.form-actions {
        float: left
    }

    .ui-dialog[aria-describedby=drupal-modal] .ui-dialog.ui-widget-content.ui-front {
        max-width: 95vw
    }
}

@media screen and (max-width: 767.98px) and (orientation:landscape) {
    .ui-dialog[aria-describedby=drupal-modal] .ui-dialog-buttonpane .ui-dialog-buttonset+.form-actions {
        float: left
    }

    .ui-dialog[aria-describedby=drupal-modal] .ui-dialog.ui-widget-content.ui-front {
        max-width: 75vw;
        left: 12.5vw
    }
}

.ui-dialog[aria-describedby=drupal-modal] .webform-confirmation__back {
    display: none
}

.ui-dialog[aria-describedby=drupal-modal].ui-widget-content.ui-front {
    background-color: transparent;
    max-width: 750px;
    border: 0
}

@media screen and (max-width: 767.98px) and (orientation:portrait) {
    .ui-dialog[aria-describedby=drupal-modal].ui-widget-content.ui-front {
        max-width: 95vw
    }
}

@media screen and (max-width: 767.98px) and (orientation:landscape) {
    .ui-dialog[aria-describedby=drupal-modal].ui-widget-content.ui-front {
        max-width: 70vw;
        left: 15vw
    }
}

.ui-widget-overlay {
    background-color: rgba(4, 30, 66, .95)
}

@media (max-width: 767.98px) {
    .ui-dialog.ui-widget-content.ui-front {
        max-width: 100% !important
    }
}

.ajax-spinner--fullscreen {
    z-index: 9999;
    background-color: rgba(255, 255, 255, .7);
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center
}

.ajax-progress-throbber .throbber {
    display: none;
    padding: 0;
    background: transparent no-repeat 0 center
}

@keyframes waiting_spinner {
    from {
        transform: rotate(0)
    }

    to {
        transform: rotate(359deg)
    }
}

.header-bar {
    align-items: center;
    background-color: #f2f6f8;
    border-bottom: 1px solid #c7cfd7;
    display: none;
    height: 36px;
    left: 0;
    padding-left: 5px;
    padding-right: 5rem;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1400;
    transition: top .16s ease
}

@media (min-width: 1200px) {
    .header-bar {
        display: flex;
        z-index: 200
    }
}

.header-bar--hidden {
    top: -36px
}

.header-bar .marketlanguageswitcher__selector {
    align-items: center;
    color: #4a5b72;
    display: flex;
    font-size: 1.2rem;
    height: auto;
    margin: 0;
    padding: 0;
    width: auto
}

.header-bar .marketlanguageswitcher__selector:hover {
    font-weight: 400
}

.header-bar .marketlanguageswitcher__selector:hover::after {
    transform: rotate(0)
}

.header-bar .marketlanguageswitcher__selector::before {
    background-size: cover;
    height: 15px;
    top: 0;
    width: 15px
}

.header-bar .marketlanguageswitcher__selector::after {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 4px;
    margin: 0 0 0 10px;
    width: 9px
}

.header-bar__right {
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: flex-end
}

.header-bar .views-exposed-form {
    margin-left: 2.9rem
}

.toolbar-horizontal.toolbar-tray-open .header-bar {
    top: 79px
}

.toolbar-horizontal.toolbar-tray-open .header-bar--hidden {
    top: -36px
}

.highlighted {
    position: absolute;
    top: 170px;
    right: 50%;
    width: 75%;
    z-index: 500;
    display: flex;
    flex-direction: column;
    align-items: center;
    transform: translateX(50%);
    max-width: 900px
}

@media (min-width: 1200px) {
    .highlighted {
        width: 50%
    }
}

.pt-langswitcher :focus-visible {
    outline: 0
}

.pt-langswitcher:focus-visible {
    outline: 0;
    box-shadow: inset 0 0 0 1px #000;
    border-radius: 6px
}

.pt-langswitcher .dropdown-container {
    position: relative;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    border-radius: 5px;
    margin-bottom: 1px
}

.pt-langswitcher .dropdown-container:hover {
    background-color: #fff
}

.pt-langswitcher .dropdown-container:hover .dropdown-container__veil {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 8%, #fff 50%)
}

.pt-langswitcher .dropdown-container p {
    display: none
}

.pt-langswitcher .dropdown-container .language-switcher-language-url,
.pt-langswitcher .dropdown-container .links {
    border: none;
    background: 0 0;
    padding: 9px 30px;
    position: relative;
    max-width: 150px;
    font-size: 1.2rem;
    color: #4a5b72;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none
}

.pt-langswitcher .dropdown-container__veil {
    height: calc(100% - 18px);
    width: 30%;
    background: linear-gradient(90deg, rgba(242, 246, 248, 0) 8%, #f2f6f8 50%);
    position: absolute;
    right: 1px;
    pointer-events: none
}

.pt-langswitcher .dropdown-container__arrow,
.pt-langswitcher .dropdown-container__earth {
    position: absolute;
    display: flex;
    pointer-events: none
}

.pt-langswitcher .dropdown-container__arrow::before,
.pt-langswitcher .dropdown-container__earth::before {
    background-position: center center;
    background-repeat: no-repeat;
    content: "";
    display: inline-block
}

.pt-langswitcher .dropdown-container__earth {
    display: flex;
    left: 10px
}

.pt-langswitcher .dropdown-container__earth::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
    width: 12px;
    height: 12px;
    background-size: cover
}

.pt-langswitcher .dropdown-container__arrow {
    display: flex;
    right: 10px
}

.pt-langswitcher .dropdown-container__arrow::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    background-size: contain;
    height: 4px;
    width: 9px
}

.pt-langswitcher--inverted .dropdown-container .language-switcher-language-url,
.pt-langswitcher--inverted .dropdown-container .links {
    color: #fff
}

.pt-langswitcher--inverted .dropdown-container .language-switcher-language-url option,
.pt-langswitcher--inverted .dropdown-container .links option {
    background: #04325e
}

.pt-langswitcher--inverted .dropdown-container:hover {
    background-color: #04325e
}

.pt-langswitcher--inverted .dropdown-container:hover .dropdown-container__veil {
    background: linear-gradient(90deg, rgba(4, 53, 46, 0) 8%, #04325e 50%)
}

.pt-langswitcher--inverted .dropdown-container__veil {
    background: linear-gradient(90deg, rgba(4, 30, 66, 0) 8%, #041e42 50%)
}

/* 
.pt-langswitcher--inverted .dropdown-container__earth::before {
    background-image: url(/src/images/icons/earth-grid-white.svg)
}

.pt-langswitcher--inverted .dropdown-container__arrow::before {
    background-image: url(/src/images/icons/chevron-down-white.svg)
} */

@media (max-width: 1199.98px) {
    #block-ptbase-child-main-menu .pt-langswitcher {
        width: 100%;
        transition: .3s ease-in
    }

    #block-ptbase-child-main-menu .pt-langswitcher.lang-switcher--hidden {
        transform: translateX(-200px)
    }
}

.region--hamburger-menu-wilson .pt-langswitcher,
footer .pt-langswitcher {
    display: inline-flex;
    align-items: center;
    position: relative
}

.region--hamburger-menu-wilson .pt-langswitcher .dropdown-container .language-switcher-language-url,
.region--hamburger-menu-wilson .pt-langswitcher .dropdown-container .links,
footer .pt-langswitcher .dropdown-container .language-switcher-language-url,
footer .pt-langswitcher .dropdown-container .links {
    font-size: 1.6rem;
    padding: 9px 30px 9px 45px;
    max-width: 185px
}

.region--hamburger-menu-wilson .pt-langswitcher .dropdown-container__earth:before,
footer .pt-langswitcher .dropdown-container__earth:before {
    height: 24px;
    width: 24px
}

.region--hamburger-menu-wilson .pt-langswitcher .dropdown-container__arrow:before,
footer .pt-langswitcher .dropdown-container__arrow:before {
    height: 8px;
    width: 13px
}

.hamburger-menu .pt-langswitcher {
    display: none;
    padding: 30px 5px
}

.hamburger-menu .pt-langswitcher .dropdown-container__veil {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 8%, #fff 50%)
}

@media (max-width: 1199.98px) {
    .hamburger-menu .pt-langswitcher {
        display: flex
    }
}

.in_layout_builder .banner,
.simplelogin-bg .banner {
    display: none
}

.region--content {
    position: relative
}

.region--content .banner {
    position: absolute;
    width: 100%;
    z-index: 99;
    background-color: rgba(255, 255, 255, .95)
}

.region--content .banner .container {
    margin: 0;
    max-width: 100%
}

.language-redirection-banner {
    position: relative;
    align-items: flex-end;
    display: none;
    max-width: none;
    border-bottom: 1px solid rgba(138, 141, 143, .4);
    border-top: solid 1.5px #c7cfd7;
    padding: 15px;
    --color-light-blue: #41B6E6
}

@media (max-width: 991.98px) {
    .language-redirection-banner {
        align-items: flex-start;
        flex-direction: column
    }
}

@media (min-width: 1200px) {
    .language-redirection-banner .language-redirection-banner-inner :not(:last-child) {
        margin-right: 25px
    }
}

.language-redirection-banner .text {
    margin: 0 0 10px 35px;
    color: #041e42;
    font-size: 1.4rem
}

@media (max-width: 991.98px) {
    .language-redirection-banner .text {
        margin: 0
    }
}

.language-redirection-banner .text .welcome-text {
    display: flex;
    margin-bottom: 5px;
    font-size: 1.8rem;
    font-weight: 700
}

@media (max-width: 991.98px) {
    .language-redirection-banner .text .welcome-text {
        flex-direction: column
    }
}

.language-redirection-banner .text .block-body {
    margin-bottom: 0
}

.language-redirection-banner .marketlanguageswitcher__selector,
.language-redirection-banner select {
    color: #041e42;
    background-color: #f2f6f8;
    border: none;
    width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-size: 1.8rem;
    padding: 0 40px 0 13px
}

.language-redirection-banner .sel-language-redirection,
.language-redirection-banner select {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    background-repeat: no-repeat;
    background-position: calc(100% - 20px);
    background-size: 16px;
    height: 40px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden
}

.language-redirection-banner .sel-language-redirection option.selected,
.language-redirection-banner select option.selected {
    font-weight: 700
}

.language-redirection-banner .sel-language-redirection:after,
.language-redirection-banner select:after {
    content: "";
    position: absolute;
    width: 75px;
    height: 40px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}), linear-gradient(90deg, rgba(255, 255, 255, 0) 0, #f2f6f8 50%);
    right: 0;
    top: 0;
    background-position: calc(100% - 20px), right;
    background-repeat: no-repeat;
    background-size: 16px, 100%;
    border-radius: inherit
}

.language-redirection-banner .language-switcher,
.language-redirection-banner .marketlanguageswitcher {
    display: flex;
    position: relative;
    border-radius: 4px;
    width: 100%;
    max-width: 325px;
    margin: 0 10px;
    box-shadow: 0 0 0 1px #b3bbbf;
    transition: .3s
}

.language-redirection-banner .language-switcher:hover,
.language-redirection-banner .marketlanguageswitcher:hover {
    box-shadow: 0 0 0 3px #41b6e6
}

@media (max-width: 991.98px) {

    .language-redirection-banner .language-switcher,
    .language-redirection-banner .marketlanguageswitcher {
        max-width: 100%;
        margin: 10px 0
    }
}

.language-redirection-banner .language-switcher .sel-language-redirection,
.language-redirection-banner .marketlanguageswitcher .sel-language-redirection {
    border-radius: inherit
}

@media (max-width: 991.98px) {
    .language-redirection-banner .btn-language-redirection {
        align-self: flex-end
    }
}

.language-redirection-banner .btn-close {
    justify-content: flex-end;
    margin-left: auto;
    padding-right: 20px;
    position: absolute;
    top: 0;
    right: 0
}

.language-redirection-banner .btn-close-banner {
    color: #8a8d8f;
    font-size: 1.6rem;
    font-weight: 700;
    text-decoration: none;
    position: absolute;
    right: 15px;
    top: 10px
}

.language-redirection-banner .btn-close-banner svg {
    fill: #041e42;
    width: 13px;
    height: 13px
}

.layout-container {
    position: relative;
    overflow-x: hidden
}

@media (max-width: 767.98px) {
    .layout-container {
        overflow-y: hidden
    }
}

img {
    -ms-interpolation-mode: bicubic;
    height: auto
}

html {
    scroll-behavior: smooth;
    scroll-padding-top: 70px
}

body {
    font-size: 1.8rem
}

div[data-drupal-messages] {
    width: 100%
}

.site-width {
    margin-left: auto;
    margin-right: auto;
    max-width: 1300px
}

.layout {
    position: relative;
    background: var(--bg-color)
}

.layout__background {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: top left;
       object-position: top left;
    z-index: 0
}

.layout__gradient {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0
}

.layout__actually_transparent {
    background-color: transparent;
    box-shadow: none
}

.background-image-valign--center .layout__background {
    -o-object-position: center left;
       object-position: center left
}

.background-image-valign--bottom .layout__background {
    -o-object-position: bottom left;
       object-position: bottom left
}

@media (max-width: 991.98px) {
    .background-image-mobile-valign--center .layout__background {
        -o-object-position: center left;
           object-position: center left
    }

    .background-image-mobile-valign--bottom .layout__background {
        -o-object-position: bottom left;
           object-position: bottom left
    }
}

@media (max-width: 767.98px) {
    .layout__grey--nomobile {
        --bg-color: #FFFFFF
    }
}

.layout__banner {
    padding: 50px calc(50px - 1.6rem)
}

@media (max-width: 767.98px) {
    .layout__banner {
        padding: 40px calc(40px - 1.6rem)
    }
}

@media (min-width: 1200px) {
    .custom-5-col {
        flex: 0 0 20%;
        max-width: 20%
    }
}

.pt-grid-layout {
    display: grid
}

.pt-grid-layout--1-col {
    grid-template-columns: 1fr
}

.pt-grid-layout--2-col {
    grid-template-columns: repeat(2, 1fr)
}

.pt-grid-layout--3-col {
    grid-template-columns: repeat(3, 1fr)
}

.pt-grid-layout--4-col {
    grid-template-columns: repeat(4, 1fr)
}

.pt-grid-layout--5-col {
    grid-template-columns: repeat(5, 1fr)
}

.pt-grid-layout--6-col {
    grid-template-columns: repeat(6, 1fr)
}

@media (min-width: 576px) and (max-width:991.98px) {
    .pt-grid-layout.grid-tablet--1 {
        grid-template-columns: 1fr
    }

    .pt-grid-layout.grid-tablet--2 {
        grid-template-columns: repeat(2, 1fr)
    }

    .pt-grid-layout.grid-tablet--3 {
        grid-template-columns: repeat(3, 1fr)
    }

    .pt-grid-layout.grid-tablet--4 {
        grid-template-columns: repeat(4, 1fr)
    }
}

@media (max-width: 575.98px) {
    .pt-grid-layout.grid-mobile--1 {
        grid-template-columns: 1fr
    }

    .pt-grid-layout.grid-mobile--2 {
        grid-template-columns: repeat(2, 1fr)
    }

    .pt-grid-layout.grid-mobile--3 {
        grid-template-columns: repeat(3, 1fr)
    }
}

.pt-grid-layout.grid-justify-items-start {
    justify-items: flex-start
}

.pt-grid-layout.grid-justify-items-center {
    justify-items: center
}

.pt-grid-layout.grid-justify-items-end {
    justify-items: flex-end
}

.pt-grid-layout.grid-justify-items-stretch {
    justify-items: stretch
}

.pt-grid-layout.grid-align-items-start {
    align-items: flex-start
}

.pt-grid-layout.grid-align-items-center {
    align-items: center
}

.pt-grid-layout.grid-align-items-end {
    align-items: flex-end
}

.pt-grid-layout.grid-align-items-stretch {
    align-items: stretch
}

.pt-grid-layout.grid-hgap--xs {
    -moz-column-gap: 1rem;
         column-gap: 1rem
}

.pt-grid-layout.grid-hgap--sm {
    -moz-column-gap: 2rem;
         column-gap: 2rem
}

.pt-grid-layout.grid-hgap--md {
    -moz-column-gap: 3rem;
         column-gap: 3rem
}

.pt-grid-layout.grid-hgap--lg {
    -moz-column-gap: 4rem;
         column-gap: 4rem
}

.pt-grid-layout.grid-vgap--xs {
    row-gap: 1rem
}

.pt-grid-layout.grid-vgap--sm {
    row-gap: 2rem
}

.pt-grid-layout.grid-vgap--md {
    row-gap: 3rem
}

.pt-grid-layout.grid-vgap--lg {
    row-gap: 4rem
}

.pt-grid-layout.grid-equal-height {
    grid-auto-rows: 1fr
}

.pt-grid-layout.grid-equal-height.grid-align-items-start {
    align-items: unset
}

.pt-grid-layout.grid-row-equal-height {
    grid-auto-rows: auto
}

.pt-grid-layout.grid-row-equal-height.grid-align-items-start {
    align-items: unset
}

@media (min-width: 768px) {

    .col-xl-fit-content,
    .col-xl-flex-fill {
        width: auto
    }

    .col-xl-fit-content {
        flex: 0 0 auto
    }

    .col-xl-flex-fill {
        flex: 1 1 min-content
    }
}

@media (min-width: 576px) and (max-width:991.98px) {

    .col-sm-fit-content,
    .col-sm-flex-fill {
        width: auto
    }

    .col-sm-fit-content {
        flex: 0 0 auto
    }

    .col-sm-flex-fill {
        flex: 1 1 min-content
    }
}

.layout-builder-configure-block div[role=alert] {
    color: red !important
}

.layout-builder-configure-block div[role=alert] li {
    color: red !important
}

details {
    font-size: 1.2rem
}

.layout-builder-block {
    padding: 0;
    background: 0 0
}

.layout-builder__region {
    outline: 1px dashed #2f91da
}

.layout-builder__region:first-child {
    margin-left: 0
}

.layout-builder__add-section {
    margin-bottom: .5em;
    padding: 1.2em;
    outline: 1px dashed #979797
}

.layout-builder__add-block {
    padding: .8em
}

.layout-builder {
    background: 0 0;
    padding: 0;
    border: none
}

.layout-builder__link--remove {
    margin-left: 5px;
    margin-top: 5px
}

.layout-builder__section {
    margin-bottom: .5em;
    outline: 1px dashed #979797
}

.layout-builder-form {
    padding-left: 15px;
    padding-right: 15px
}

.region--hamburger-menu>nav .menu-item:focus,
.region--hamburger-menu>nav a:focus,
.region--primary-menu>nav .menu-item:focus,
.region--primary-menu>nav a:focus {
    outline: 0
}

.region--hamburger-menu>nav .menu-item:focus-visible,
.region--hamburger-menu>nav a:focus-visible,
.region--primary-menu>nav .menu-item:focus-visible,
.region--primary-menu>nav a:focus-visible {
    box-shadow: inset 0 0 0 1px #041e42;
    outline: 0
}

.region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0,
.region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0 {
    justify-content: center
}

.region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child,
.region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child {
    padding: 0
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child,
    .region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child {
        margin-right: unset;
        padding: 0 1.5rem
    }
}

.region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    font-size: 1.6rem !important
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
        font-size: 1.4rem !important
    }
}

.region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    content: ""
}

.region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover,
.region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover {
    color: #f2f6f8
}

.region--hamburger-menu>nav .layout .container-fluid,
.region--hamburger-menu>nav .layout .container-lg,
.region--hamburger-menu>nav .layout .container-md,
.region--hamburger-menu>nav .layout .container-sm,
.region--hamburger-menu>nav .layout .container-xl,
.region--primary-menu>nav .layout .container-fluid,
.region--primary-menu>nav .layout .container-lg,
.region--primary-menu>nav .layout .container-md,
.region--primary-menu>nav .layout .container-sm,
.region--primary-menu>nav .layout .container-xl {
    padding-right: 0
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid,
    .region--hamburger-menu>nav .layout .container-lg,
    .region--hamburger-menu>nav .layout .container-md,
    .region--hamburger-menu>nav .layout .container-sm,
    .region--hamburger-menu>nav .layout .container-xl,
    .region--primary-menu>nav .layout .container-fluid,
    .region--primary-menu>nav .layout .container-lg,
    .region--primary-menu>nav .layout .container-md,
    .region--primary-menu>nav .layout .container-sm,
    .region--primary-menu>nav .layout .container-xl {
        padding-left: 0
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region h2,
.region--hamburger-menu>nav .layout .container-lg .layout__region h2,
.region--hamburger-menu>nav .layout .container-md .layout__region h2,
.region--hamburger-menu>nav .layout .container-sm .layout__region h2,
.region--hamburger-menu>nav .layout .container-xl .layout__region h2,
.region--primary-menu>nav .layout .container-fluid .layout__region h2,
.region--primary-menu>nav .layout .container-lg .layout__region h2,
.region--primary-menu>nav .layout .container-md .layout__region h2,
.region--primary-menu>nav .layout .container-sm .layout__region h2,
.region--primary-menu>nav .layout .container-xl .layout__region h2 {
    font-size: 1.4rem;
    line-height: 1.2em;
    font-weight: 400;
    color: #54585a;
    margin-left: 30px
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region h2,
    .region--hamburger-menu>nav .layout .container-lg .layout__region h2,
    .region--hamburger-menu>nav .layout .container-md .layout__region h2,
    .region--hamburger-menu>nav .layout .container-sm .layout__region h2,
    .region--hamburger-menu>nav .layout .container-xl .layout__region h2,
    .region--primary-menu>nav .layout .container-fluid .layout__region h2,
    .region--primary-menu>nav .layout .container-lg .layout__region h2,
    .region--primary-menu>nav .layout .container-md .layout__region h2,
    .region--primary-menu>nav .layout .container-sm .layout__region h2,
    .region--primary-menu>nav .layout .container-xl .layout__region h2 {
        margin-left: 0
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region nav,
.region--hamburger-menu>nav .layout .container-lg .layout__region nav,
.region--hamburger-menu>nav .layout .container-md .layout__region nav,
.region--hamburger-menu>nav .layout .container-sm .layout__region nav,
.region--hamburger-menu>nav .layout .container-xl .layout__region nav,
.region--primary-menu>nav .layout .container-fluid .layout__region nav,
.region--primary-menu>nav .layout .container-lg .layout__region nav,
.region--primary-menu>nav .layout .container-md .layout__region nav,
.region--primary-menu>nav .layout .container-sm .layout__region nav,
.region--primary-menu>nav .layout .container-xl .layout__region nav {
    padding-bottom: 60px;
    margin-left: 30px
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region nav,
    .region--hamburger-menu>nav .layout .container-lg .layout__region nav,
    .region--hamburger-menu>nav .layout .container-md .layout__region nav,
    .region--hamburger-menu>nav .layout .container-sm .layout__region nav,
    .region--hamburger-menu>nav .layout .container-xl .layout__region nav,
    .region--primary-menu>nav .layout .container-fluid .layout__region nav,
    .region--primary-menu>nav .layout .container-lg .layout__region nav,
    .region--primary-menu>nav .layout .container-md .layout__region nav,
    .region--primary-menu>nav .layout .container-sm .layout__region nav,
    .region--primary-menu>nav .layout .container-xl .layout__region nav {
        padding-bottom: 0;
        margin-left: 0
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0,
.region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0,
.region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0,
.region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0,
.region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0,
.region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0,
.region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0,
.region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0,
.region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0,
.region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 {
    display: block;
    border-top: 1px solid #c7cfd7;
    background-color: unset;
    padding-top: 0;
    vertical-align: top
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
.region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
.region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
.region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
.region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
.region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
.region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
.region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
.region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
.region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child) {
    padding-top: 0;
    border-top: none
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0,
    .region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0,
    .region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0,
    .region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0,
    .region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0,
    .region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0,
    .region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0,
    .region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0,
    .region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0,
    .region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 {
        display: inline-block;
        padding-top: 15px
    }

    .region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
    .region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
    .region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
    .region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
    .region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
    .region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
    .region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
    .region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
    .region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),
    .region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child) {
        border-top: 1px solid #c7cfd7;
        margin-left: -5px;
        padding-left: 25%;
        padding-top: 15px
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
.region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
.region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
.region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
.region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
.region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
.region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
.region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
.region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
.region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item {
    display: block;
    max-width: 100%;
    margin-right: unset
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
    .region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
    .region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
    .region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
    .region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
    .region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
    .region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
    .region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
    .region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,
    .region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item {
        padding: 0 1.5rem
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    font-family: canada-type-gibson, sans-serif;
    display: inline-block;
    font-size: 1.5rem;
    line-height: 1.2em;
    font-weight: 500;
    color: #000;
    padding: 10px 15px
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
        line-height: 30px;
        padding: 0
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    content: ""
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region a,
.region--hamburger-menu>nav .layout .container-lg .layout__region a,
.region--hamburger-menu>nav .layout .container-md .layout__region a,
.region--hamburger-menu>nav .layout .container-sm .layout__region a,
.region--hamburger-menu>nav .layout .container-xl .layout__region a,
.region--primary-menu>nav .layout .container-fluid .layout__region a,
.region--primary-menu>nav .layout .container-lg .layout__region a,
.region--primary-menu>nav .layout .container-md .layout__region a,
.region--primary-menu>nav .layout .container-sm .layout__region a,
.region--primary-menu>nav .layout .container-xl .layout__region a {
    color: #000
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid,
.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid,
.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid,
.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid,
.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid,
.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid,
.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid,
.region--primary-menu>nav .layout .container-md .layout__region .pt-grid,
.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid,
.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid {
    border-top: 1px solid #c7cfd7;
    padding-top: 15px;
    margin-left: 30px !important
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid,
    .region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid,
    .region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid,
    .region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid,
    .region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid,
    .region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid,
    .region--primary-menu>nav .layout .container-lg .layout__region .pt-grid,
    .region--primary-menu>nav .layout .container-md .layout__region .pt-grid,
    .region--primary-menu>nav .layout .container-sm .layout__region .pt-grid,
    .region--primary-menu>nav .layout .container-xl .layout__region .pt-grid {
        margin-left: 0 !important
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12,
.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12,
.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12,
.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12,
.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12,
.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12,
.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12,
.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12,
.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12,
.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 {
    padding: 0 !important
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12:first-child,
    .region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12:first-child,
    .region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12:first-child,
    .region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12:first-child,
    .region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12:first-child,
    .region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12:first-child,
    .region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12:first-child,
    .region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12:first-child,
    .region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12:first-child,
    .region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12:first-child {
        margin-left: -15px
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid,
.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid,
.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid,
.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid,
.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid,
.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid,
.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid,
.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid,
.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid,
.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid {
    margin-bottom: 0;
    display: flex;
    flex-direction: row;
    padding-top: 0 !important;
    padding-left: 0 !important
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid,
    .region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid,
    .region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid,
    .region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid,
    .region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid,
    .region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid,
    .region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid,
    .region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid,
    .region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid,
    .region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid {
        display: inline-flex;
        flex-direction: column;
        padding-top: 1.6rem !important;
        padding-left: 1.6rem !important
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container {
    flex: 0 0 33.3333%
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
    .region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
    .region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
    .region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
    .region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
    .region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
    .region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
    .region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
    .region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,
    .region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container {
        width: auto;
        flex: unset
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,
.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,
.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,
.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,
.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,
.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,
.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,
.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,
.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,
.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img {
    border-radius: 5px
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,
.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,
.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,
.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,
.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,
.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,
.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,
.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,
.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,
.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil {
    background-color: transparent
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__title {
    font-size: 1.5rem;
    line-height: 1.2em;
    color: #000;
    font-weight: 400;
    text-align: left;
    padding-left: 10px
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
    .region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
    .region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
    .region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
    .region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
    .region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
    .region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
    .region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
    .region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__title,
    .region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__title {
        padding-left: 0
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region .block__text,
.region--hamburger-menu>nav .layout .container-lg .layout__region .block__text,
.region--hamburger-menu>nav .layout .container-md .layout__region .block__text,
.region--hamburger-menu>nav .layout .container-sm .layout__region .block__text,
.region--hamburger-menu>nav .layout .container-xl .layout__region .block__text,
.region--primary-menu>nav .layout .container-fluid .layout__region .block__text,
.region--primary-menu>nav .layout .container-lg .layout__region .block__text,
.region--primary-menu>nav .layout .container-md .layout__region .block__text,
.region--primary-menu>nav .layout .container-sm .layout__region .block__text,
.region--primary-menu>nav .layout .container-xl .layout__region .block__text {
    margin-left: 30px !important
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region .block__text,
    .region--hamburger-menu>nav .layout .container-lg .layout__region .block__text,
    .region--hamburger-menu>nav .layout .container-md .layout__region .block__text,
    .region--hamburger-menu>nav .layout .container-sm .layout__region .block__text,
    .region--hamburger-menu>nav .layout .container-xl .layout__region .block__text,
    .region--primary-menu>nav .layout .container-fluid .layout__region .block__text,
    .region--primary-menu>nav .layout .container-lg .layout__region .block__text,
    .region--primary-menu>nav .layout .container-md .layout__region .block__text,
    .region--primary-menu>nav .layout .container-sm .layout__region .block__text,
    .region--primary-menu>nav .layout .container-xl .layout__region .block__text {
        margin-left: 0 !important
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region .block__text .wysiwyg a,
.region--hamburger-menu>nav .layout .container-lg .layout__region .block__text .wysiwyg a,
.region--hamburger-menu>nav .layout .container-md .layout__region .block__text .wysiwyg a,
.region--hamburger-menu>nav .layout .container-sm .layout__region .block__text .wysiwyg a,
.region--hamburger-menu>nav .layout .container-xl .layout__region .block__text .wysiwyg a,
.region--primary-menu>nav .layout .container-fluid .layout__region .block__text .wysiwyg a,
.region--primary-menu>nav .layout .container-lg .layout__region .block__text .wysiwyg a,
.region--primary-menu>nav .layout .container-md .layout__region .block__text .wysiwyg a,
.region--primary-menu>nav .layout .container-sm .layout__region .block__text .wysiwyg a,
.region--primary-menu>nav .layout .container-xl .layout__region .block__text .wysiwyg a {
    font-family: canada-type-gibson, sans-serif;
    font-size: 1.5rem
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region:not(:first-child) .pt-grid,
.region--hamburger-menu>nav .layout .container-lg .layout__region:not(:first-child) .pt-grid,
.region--hamburger-menu>nav .layout .container-md .layout__region:not(:first-child) .pt-grid,
.region--hamburger-menu>nav .layout .container-sm .layout__region:not(:first-child) .pt-grid,
.region--hamburger-menu>nav .layout .container-xl .layout__region:not(:first-child) .pt-grid,
.region--primary-menu>nav .layout .container-fluid .layout__region:not(:first-child) .pt-grid,
.region--primary-menu>nav .layout .container-lg .layout__region:not(:first-child) .pt-grid,
.region--primary-menu>nav .layout .container-md .layout__region:not(:first-child) .pt-grid,
.region--primary-menu>nav .layout .container-sm .layout__region:not(:first-child) .pt-grid,
.region--primary-menu>nav .layout .container-xl .layout__region:not(:first-child) .pt-grid {
    border-top: none;
    padding-top: 0
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region:not(:first-child) .pt-grid,
    .region--hamburger-menu>nav .layout .container-lg .layout__region:not(:first-child) .pt-grid,
    .region--hamburger-menu>nav .layout .container-md .layout__region:not(:first-child) .pt-grid,
    .region--hamburger-menu>nav .layout .container-sm .layout__region:not(:first-child) .pt-grid,
    .region--hamburger-menu>nav .layout .container-xl .layout__region:not(:first-child) .pt-grid,
    .region--primary-menu>nav .layout .container-fluid .layout__region:not(:first-child) .pt-grid,
    .region--primary-menu>nav .layout .container-lg .layout__region:not(:first-child) .pt-grid,
    .region--primary-menu>nav .layout .container-md .layout__region:not(:first-child) .pt-grid,
    .region--primary-menu>nav .layout .container-sm .layout__region:not(:first-child) .pt-grid,
    .region--primary-menu>nav .layout .container-xl .layout__region:not(:first-child) .pt-grid {
        border-top: 1px solid #c7cfd7;
        padding-top: 15px
    }
}

.region--hamburger-menu>nav .layout .container-fluid .layout__region:not(:first-child) h2,
.region--hamburger-menu>nav .layout .container-lg .layout__region:not(:first-child) h2,
.region--hamburger-menu>nav .layout .container-md .layout__region:not(:first-child) h2,
.region--hamburger-menu>nav .layout .container-sm .layout__region:not(:first-child) h2,
.region--hamburger-menu>nav .layout .container-xl .layout__region:not(:first-child) h2,
.region--primary-menu>nav .layout .container-fluid .layout__region:not(:first-child) h2,
.region--primary-menu>nav .layout .container-lg .layout__region:not(:first-child) h2,
.region--primary-menu>nav .layout .container-md .layout__region:not(:first-child) h2,
.region--primary-menu>nav .layout .container-sm .layout__region:not(:first-child) h2,
.region--primary-menu>nav .layout .container-xl .layout__region:not(:first-child) h2 {
    border-bottom: 1px solid #c7cfd7;
    padding-bottom: 5px;
    margin-bottom: 15px
}

@media (min-width: 1200px) {

    .region--hamburger-menu>nav .layout .container-fluid .layout__region:not(:first-child) h2,
    .region--hamburger-menu>nav .layout .container-lg .layout__region:not(:first-child) h2,
    .region--hamburger-menu>nav .layout .container-md .layout__region:not(:first-child) h2,
    .region--hamburger-menu>nav .layout .container-sm .layout__region:not(:first-child) h2,
    .region--hamburger-menu>nav .layout .container-xl .layout__region:not(:first-child) h2,
    .region--primary-menu>nav .layout .container-fluid .layout__region:not(:first-child) h2,
    .region--primary-menu>nav .layout .container-lg .layout__region:not(:first-child) h2,
    .region--primary-menu>nav .layout .container-md .layout__region:not(:first-child) h2,
    .region--primary-menu>nav .layout .container-sm .layout__region:not(:first-child) h2,
    .region--primary-menu>nav .layout .container-xl .layout__region:not(:first-child) h2 {
        border-bottom: none;
        padding-bottom: 0;
        margin-bottom: .8rem
    }
}

.region--primary-menu .menu--layout-navigation.menu-level-0 {
    display: none
}

@media (min-width: 1200px) {
    .region--primary-menu .menu--layout-navigation.menu-level-0 {
        display: flex
    }
}

.region--primary-menu .menu--layout-navigation.menu-level-0>.menu-item--dropdown .menu-dropdown-0 {
    padding-bottom: 0
}

.login-menu {
    transition: .3s ease-in
}

.login-menu .menu--login-menu {
    display: flex
}

.login-menu .menu--login-menu .menu-item {
    margin-right: 25px
}

.login-menu .menu--login-menu .menu-item:last-child {
    margin-right: 0
}

.login-menu .menu--login-menu .menu-item.icon a::before {
    content: "";
    display: block;
    height: 17px;
    margin-right: .7rem;
    width: 17px
}

.login-menu .menu--login-menu .menu-item a {
    align-items: center;
    color: #041e42;
    display: flex;
    font-size: 1.2rem
}

@media (min-width: 1200px) {
    .hamburger-menu .login-menu {
        display: none
    }
}

@media (max-width: 1199.98px) {
    .hamburger-menu .login-menu--hidden {
        transform: translateX(-200px)
    }
}

.region--primary-menu-spacer {
    height: 60px;
    background: #f2f6f8 0 0 no-repeat padding-box
}

.region--header-bar-spacer {
    height: 35px
}

@media (max-width: 1199.98px) {
    .region--header-bar-spacer {
        height: 0
    }
}

.menu-item--image-text-button {
    display: flex;
    padding-bottom: 7px
}

.menu-item--image-text-button img {
    max-height: 3em;
    max-width: 6.4rem;
    margin-right: 5px
}

.menu-item--image-text-button .btn {
    margin-left: .8rem
}

.menu--btn-full-width {
    border: 0 !important;
    border-top: 1px solid #8a8d8f !important;
    border-radius: unset !important;
    text-transform: none !important;
    transform: translate(0, 40px)
}

.region--primary-menu {
    display: flex;
    justify-content: space-between;
    padding-right: 1.6rem;
    position: fixed;
    left: 0;
    top: 0;
    transition: top .16s, height .16s;
    z-index: 1300;
    width: 100%;
    text-align: center;
    background: #f2f6f8 0 0 no-repeat padding-box;
    box-shadow: 3px 3px 6px rgba(0, 0, 0, .16);
    height: 60px
}

.region--primary-menu .menu-item:focus,
.region--primary-menu a:focus {
    outline: 0
}

.region--primary-menu .menu-item:focus-visible,
.region--primary-menu a:focus-visible {
    box-shadow: inset 0 0 0 1px #041e42;
    outline: 0
}

.region--primary-menu button {
    background: 0 0;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    text-align: left
}

@media (min-width: 1200px) {
    .region--primary-menu .submenu-container__title {
        display: none
    }
    .region--primary-menu {
        padding-right: 50px;
        z-index: 100
    }
    .region--primary-menu--with-header-bar {
        top: 36px
    }
}

.region--primary-menu--hidden {
    top: -61px
}

.region--primary-menu.is-sticky.scroll-down {
    top: 0
}

.region--primary-menu.is-sticky.scroll-down:not(.is-top) {
    height: 50px
}

.region--primary-menu.is-sticky.scroll-down:not(.is-top) #block-sitebranding .logo-container {
    height: 50px
}

.region--primary-menu:not(.is-top) {
    height: 50px
}

.region--primary-menu:not(.is-top) #block-sitebranding .logo-container {
    height: 50px;
    max-width: 50px;
    transition: max-width .5s ease
}

.region--primary-menu.scroll-up:not(.is-top) {
    height: 50px
}

.region--primary-menu.scroll-up:not(.is-top) #block-sitebranding .logo-container {
    height: 50px
}

.region--primary-menu .menu-level-2__item,
.region--primary-menu .menu-level-3__item {
    transition: background .3s ease
}

@media (min-width: 768px) {

    .region--primary-menu .menu-level-2__item:hover,
    .region--primary-menu .menu-level-3__item:hover {
        background: #f2f6f8
    }
}

.region--primary-menu::before {
    background: #f2f6f8 0 0 no-repeat padding-box;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.region--primary-menu .contextual-region {
    position: initial
}

@media (min-width: 1200px) {
    body.hamburger-opened .region--primary-menu {
        padding-right: 17px
    }
}

.region--primary-menu.is-top #block-sitebranding .logo-container {
    max-width: 118px;
    padding: 11px 11px 11px 14px
}

.region--primary-menu.is-top #block-sitebranding .logo-container .logo-full {
    display: block
}

.region--primary-menu.is-top #block-sitebranding .logo-container .logo-monogram {
    display: none
}

.region--primary-menu #block-sitebranding {
    align-items: center;
    background: #f2f6f8 0 0 no-repeat padding-box;
    display: flex;
    flex: 0 0 auto;
    z-index: 1
}

.region--primary-menu #block-sitebranding .logo-container {
    background-color: #041e42;
    display: flex;
    height: 60px;
    overflow: hidden;
    padding: 11px 14px;
    width: 100%;
    transition: max-width .5s ease 0s
}

.region--primary-menu #block-sitebranding .logo-container a {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: flex-start;
    width: 100%
}

.region--primary-menu #block-sitebranding .logo-container a .logo-full {
    height: 37px;
    width: 90px;
    display: none
}

.region--primary-menu #block-sitebranding .logo-container a .logo-monogram {
    height: 25px;
    width: 22px;
    display: block
}

.region--primary-menu #block-sitebranding .logo-container .logo-site__hide {
    display: none
}

.region--primary-menu #block-sitebranding .site-slogan-container {
    line-height: 1.6rem;
    max-width: 14.1rem;
    margin-left: 2.4rem;
    text-align: left
}

@media (min-width: 1200px) {
    .region--primary-menu #block-sitebranding .site-slogan-container {
        display: flex
    }
}

.region--primary-menu #block-sitebranding .site-slogan-container a {
    color: #041e42;
    letter-spacing: 0;
    font-size: 1.7rem;
    line-height: 1.8rem;
    text-align: left
}

.region--primary-menu #block-sitebranding .site-slogan-container a:hover {
    color: #041e42
}

.region--primary-menu #block-sitebranding.block-monogram .logo-container {
    padding: 12px 15px;
    width: 52px
}

.region--primary-menu #block-sitebranding.block-logo .logo-container {
    transition: width .5s ease 0s
}

.region--primary-menu .menu_link_content .menu-item--image-text-button img {
    height: 21.1rem;
    width: 21.1rem
}

@media (min-width: 1200px) {
    .region--primary-menu nav#block-ptbase-child-main-menu {
        height: 100%
    }
    .region--primary-menu .menu-level-0 {
        display: flex;
        align-items: stretch;
        height: 100%;
        background: #f2f6f8
    }
    .region--primary-menu .menu-level-0 .dropdown-0-opened {
        transform: translateY(0) !important;
        top: 100% !important
    }
}

.region--primary-menu .menu-level-0 .btn.btn--inverted,
.region--primary-menu .menu-level-0 a.btn__arrow.btn--inverted {
    background: #f2f6f8
}

.region--primary-menu .menu-level-0>.menu-item {
    flex: 0 1 auto;
    align-items: center
}

@media (max-width: 1199.98px) {
    .region--primary-menu .menu-level-0>.menu-item {
        max-width: 100%
    }
}

@media (min-width: 768px) {
    .region--primary-menu .menu-level-0>.menu-item:last-child:not(.menu-item--dropdown) {
        z-index: 1
    }
}

@media (max-width: 1199.98px) {
    .region--primary-menu .menu-level-0>.menu-item--mobiledisplay__show {
        margin: auto;
        flex: 0 0 auto;
        max-width: 22.4rem;
        padding: 1.26rem 3rem;
        display: flex;
        line-height: 1.8rem
    }
}

@media (min-width: 1200px) {
    .region--primary-menu .menu-level-0>.menu-item {
        display: flex
    }
}

.region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    color: #041e42;
    font-size: 1.7rem;
    text-decoration: none;
    padding: 0 2.1rem;
    position: relative;
    overflow: hidden;
    transition: color .25s ease-out;
    display: flex;
    height: 100%;
    align-items: center;
    background: 0 0
}

@media (min-width: 1200px) {
    .region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
        background: #f2f6f8 0 0 no-repeat padding-box
    }
}

@media (max-width: 1199.98px) {
    .region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #d2d2d2
    }
}

.region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary)::before {
    content: "";
    width: 0;
    height: 4px;
    background-color: #041e42;
    transition: width .1s ease-out;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%)
}

@media (max-width: 1199.98px) {
    .region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary)::before {
        content: unset
    }
}

.region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover {
    background-color: #fff;
    color: #041e42
}

.region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover::before {
    width: 100%
}

.region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary).font-weight-bold {
    font-weight: 700 !important
}

.region--primary-menu .menu-level-0>.menu-item>.menu-link.btn {
    background-color: #041e42;
    color: #fff
}

.region--primary-menu .menu-level-0>.menu-item>.menu-link.btn:hover {
    background-color: #0c2b57
}

.region--primary-menu .menu-level-0>.menu-item--active-trail>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover::before {
    width: 100%
}

@media (min-width: 1200px) {

    .region--primary-menu .menu-level-0>.menu-item--active-trail>.menu-link:focus-visible+.submenu-container .menu-dropdown-0,
    .region--primary-menu .menu-level-0>.menu-item--active-trail>.menu-link:focus-visible+.submenu-container .menu-dropdown-0:focus-visible {
        transform: translateY(0);
        top: 100%
    }
    .region--primary-menu .menu-level-0 .menu-dropdown-0:focus-visible {
        transform: translateY(0);
        top: 100%
    }
    .region--primary-menu .menu-level-0>.menu-item--dropdown>.menu-link:after {
        position: relative;
        content: "+";
        display: inline-block;
        margin-left: .8rem;
        left: 0;
        width: 10px
    }
}

@media (max-width: 1199.98px) {
    .region--primary-menu .menu-level-0>.menu-item--dropdown>.menu-link:after {
        /* background: url(/src/images/icons/chevron-down-dark-blue.svg) no-repeat center center/cover; */
        content: "";
        display: inline-block;
        height: 13px;
        transform: rotate(-90deg);
        width: 13px;
        margin-right: 15px
    }
}

@media (min-width: 1200px) {

    .region--primary-menu .menu-level-0>.menu-item--dropdown:focus-visible .menu-dropdown-0,
    .region--primary-menu .menu-level-0>.menu-item--dropdown:hover .menu-dropdown-0 {
        transform: translateY(0);
        top: 100%
    }

    .region--primary-menu .menu-level-0>.menu-item--dropdown:focus-visible>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
    .region--primary-menu .menu-level-0>.menu-item--dropdown:hover>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after {
        content: "-"
    }
}

.region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0 {
    box-shadow: 0 3px 3px rgba(0, 0, 0, .16);
    display: block;
    height: auto;
    width: 100%;
    background-color: #fff;
    position: absolute;
    left: 0;
    transition: transform .35s ease-in-out;
    text-align: left;
    top: 50px
}

@media (max-width: 1199.98px) {
    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0 {
        box-shadow: none
    }
}

@media (min-width: 1200px) {
    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0 {
        transform: translateY(-120%);
        z-index: -1;
        padding: 38px 0 30px;
        top: 15px
    }

    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0.footer-main-menu {
        padding-bottom: 0
    }
}

.region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0>.submenu-container--inside {
    max-width: 1030px;
    margin: 0 auto
}

@media (min-width: 1200px) {
    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0 {
        max-height: calc(80vh - 119px);
        overflow-y: hidden;
        display: flex
    }

    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0>.submenu-container--inside {
        overflow-y: auto
    }
    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0:hover {
        top: 100%
    }
}

.region--primary-menu .menu-level-1 {
    -moz-column-gap: 3rem;
         column-gap: 3rem;
    grid-template-columns: repeat(4, 1fr);
    margin: auto;
    max-width: 1030px;
    overflow: hidden;
    position: relative
}

@media (min-width: 1200px) {
    .region--primary-menu .menu-level-1 {
        display: grid;
        overflow-y: auto
    }

    .region--primary-menu .menu-level-1::-webkit-scrollbar {
        width: 10px;
        border: none
    }

    .region--primary-menu .menu-level-1::-webkit-scrollbar-track {
        background: rgba(138, 141, 143, .3);
        box-shadow: inset 0 0 6px rgba(0, 0, 0, .15);
        border-radius: 10px
    }

    .region--primary-menu .menu-level-1::-webkit-scrollbar-thumb {
        background: #8a8d8f;
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, .25)
    }

    .region--primary-menu .menu-level-1::-webkit-scrollbar-thumb:hover {
        background: #54585a
    }

    .region--primary-menu .menu-level-1::-webkit-scrollbar-button {
        height: 5px
    }
}

.region--primary-menu .menu-level-1__link {
    border-top: none;
    border-right: none;
    border-left: none;
    background: 0 0;
    border-bottom: 1px solid #d2d2d2;
    color: #041e42;
    display: inline-block;
    font-size: 1.4rem;
    font-weight: 900;
    line-height: 2rem;
    margin-bottom: 8px;
    padding-bottom: 5px;
    width: 100%
}

.region--primary-menu .menu-level-1 .menu-item--two-columns {
    grid-column: 1/3
}

.region--primary-menu .menu-level-1 .menu-item--two-columns .menu-level-2 {
    grid-template-columns: repeat(2, 1fr)
}

@media (min-width: 1200px) {

    .region--primary-menu .menu-level-2__item,
    .region--primary-menu .menu-level-3__item {
        display: grid;
        position: relative;
        border-radius: 5px
    }
}

.region--primary-menu .menu-level-2__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.region--primary-menu .menu-level-3__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    color: #041e42;
    font-size: 1.5rem;
    width: 100%;
    justify-self: flex-start;
    padding: 10px 1.6rem;
    position: relative
}

@media (max-width: 1199.98px) {

    .region--primary-menu .menu-level-2__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
    .region--primary-menu .menu-level-3__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
        padding: 10px 0
    }
}

.region--primary-menu .menu-level-2__link.font-weight-bold--arrow,
.region--primary-menu .menu-level-3__link.font-weight-bold--arrow {
    align-items: center;
    display: flex
}

.region--primary-menu .menu-level-2__link.font-weight-bold--arrow::after,
.region--primary-menu .menu-level-3__link.font-weight-bold--arrow::after {
    /* background: url(/src/images/icons/arrow-next-dark-blue.svg) no-repeat center center/contain; */
    height: 7.7px;
    margin-left: 7.5px;
    width: 9.7px
}

.region--primary-menu .menu-level-2__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) span,
.region--primary-menu .menu-level-3__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) span {
    background-image: linear-gradient(0deg, #041e42 8%, rgba(4, 30, 66, 0) 10%);
    background-size: 0;
    padding-bottom: 2px;
    background-repeat: no-repeat;
    background-position: bottom left;
    transition: background-size .5s
}

.region--primary-menu .menu-level-2 {
    display: grid
}

.region--primary-menu .menu-level-2 .menu-item:nth-of-type(11) .menu-dropdown-2,
.region--primary-menu .menu-level-2 .menu-item:nth-of-type(12) .menu-dropdown-2 {
    bottom: 0;
    top: unset
}

.region--primary-menu .menu-level-2:not(.menu-item--dropdown)>a {
    justify-self: flex-start
}

.region--primary-menu .menu-level-2__item:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover .menu-item--active-trail .menu-level-2__link span,
.region--primary-menu .menu-level-2__item:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover .menu-level-2__link span {
    background-size: 100%
}

.region--primary-menu .menu-level-2__item.menu-item--dropdown {
    transition: background-color .3s ease-in, border-radius .3s ease-in
}

@media (min-width: 1200px) {

    .region--primary-menu .menu-level-2__item.menu-item--dropdown.menu-item--active-trail,
    .region--primary-menu .menu-level-2__item.menu-item--dropdown:focus-visible,
    .region--primary-menu .menu-level-2__item.menu-item--dropdown:hover {
        background-color: #f2f6f8;
        border-radius: 5px 0 0 5px
    }
}

.region--primary-menu .menu-level-2__item.menu-item--dropdown .menu-level-2__link {
    align-items: center;
    display: flex;
    gap: 10px;
    justify-self: stretch;
    background: 0 0;
    text-align: left;
    padding: 10px 1.6rem
}

.region--primary-menu .menu-level-2__item.menu-item--dropdown .menu-level-2__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary)::before {
    display: none
}

.region--primary-menu .menu-level-2__item.menu-item--dropdown .menu-level-2__link::after {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) no-repeat center center/10.5px 7px;
    content: "";
    display: inline-block;
    height: 13px;
    flex: 0 0 auto;
    transform: rotate(-90deg);
    width: 20px
}

.region--primary-menu .menu-level-2__link {
    padding-left: 1.6rem;
    padding-right: 1.6rem
}

@media (min-width: 1200px) {
    .region--primary-menu .menu-level-2 .menu-dropdown-2 {
        left: 100%;
        opacity: 0;
        position: absolute;
        top: 0;
        visibility: hidden;
        width: 100%;
        z-index: 1;
        transition: opacity .3s ease-in, visibility .3s ease-in
    }
}

.region--primary-menu .menu-level-2 .menu-dropdown-2.view-mode-image-text-button {
    left: 50%;
    opacity: 1;
    visibility: visible;
    top: 50%
}

.region--primary-menu .menu-level-2 .btn {
    background-color: #041e42;
    color: #fff
}

.region--primary-menu .menu-level-2--visible .menu-dropdown-2 {
    opacity: 1;
    visibility: visible
}

.region--primary-menu .menu-level-3 {
    background-color: #fff;
    padding-left: 1.6rem
}

@media (max-width: 1199.98px) {
    .region--primary-menu .menu-level-3 {
        padding-left: 4.5rem
    }
}

.region--primary-menu .menu-level-3 .menu-level-3__item:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary).menu-item--active-trail a span,
.region--primary-menu .menu-level-3 .menu-level-3__item:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover a span,
.region--primary-menu .menu-level-3 .menu-level-3__item:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover button span {
    background-size: 100%
}

@media (min-width: 1200px) {
    .region--primary-menu--inverted {
        background: #041e42 0 0 no-repeat padding-box
    }

    .region--primary-menu--inverted .menu-level-0 {
        background: #041e42
    }

    .region--primary-menu--inverted .menu-level-0 .menu-item:focus,
    .region--primary-menu--inverted .menu-level-0 a:focus {
        outline: 0
    }

    .region--primary-menu--inverted .menu-level-0 .menu-item:focus-visible,
    .region--primary-menu--inverted .menu-level-0 a:focus-visible {
        box-shadow: inset 0 0 0 1px #fff;
        outline: 0
    }

    .region--primary-menu--inverted .menu-level-0 .menu-level-2 .menu-item:focus,
    .region--primary-menu--inverted .menu-level-0 .menu-level-2 a:focus,
    .region--primary-menu--inverted .menu-level-0 .menu-level-3 .menu-item:focus,
    .region--primary-menu--inverted .menu-level-0 .menu-level-3 a:focus {
        outline: 0
    }

    .region--primary-menu--inverted .menu-level-0 .menu-level-2 .menu-item:focus-visible,
    .region--primary-menu--inverted .menu-level-0 .menu-level-2 a:focus-visible,
    .region--primary-menu--inverted .menu-level-0 .menu-level-3 .menu-item:focus-visible,
    .region--primary-menu--inverted .menu-level-0 .menu-level-3 a:focus-visible {
        box-shadow: inset 0 0 0 1px #041e42;
        outline: 0
    }

    .region--primary-menu--inverted .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
        background: #041e42;
        color: #fff
    }

    .region--primary-menu--inverted .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover {
        color: #fff;
        background: #041e42
    }

    .region--primary-menu--inverted .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary)::before {
        background-color: #f2f6f8
    }
}

@media (min-width: 1200px) and (max-width:1199.98px) {
    .region--primary-menu--inverted .menu-level-0>.menu-item--expanded .menu-link::after {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___})
    }
    .region--primary-menu--inverted .menu-level-0>.menu-item--expanded:hover>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary)::after {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___})
    }
}

.toolbar-horizontal.toolbar-tray-open .region--primary-menu {
    top: 79px
}

@media (min-width: 1200px) {
    .toolbar-horizontal.toolbar-tray-open .region--primary-menu--with-header-bar {
        top: 115px
    }
}

.toolbar-horizontal.toolbar-tray-open .region--primary-menu--hidden {
    top: -61px
}

.toolbar-horizontal.toolbar-tray-open .region--primary-menu.is-sticky.scroll-down {
    top: 79px
}

@media (min-width: 1200px) {
    .menu-dropdown-2 {
        height: 100%
    }

    .menu-dropdown-2 .submenu-container--inside {
        border-left: 1px solid #041e42;
        min-height: 100%
    }
}

.header-bar .icon.menu-item.login a::before,
.region--primary-menu .icon.menu-item.login a::before {
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_35___}) no-repeat center center/cover
}

/* 
.header-bar .icon.menu-item.online_store a::before,
.region--primary-menu .icon.menu-item.online_store a::before {
    background: transparent url(/src/images/icons/online_store.svg) no-repeat center center/cover
} */

.header-bar .icon.menu-item.phone a::before,
.region--primary-menu .icon.menu-item.phone a::before {
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_36___}) no-repeat center center/cover
}

/* 
.header-bar .icon.menu-item.email a::before,
.region--primary-menu .icon.menu-item.email a::before {
    background: transparent url(/src/images/icons/icon-email-blue.svg) no-repeat center center/cover
} */

.menu {
    margin: 0;
    padding: 0;
    list-style-type: none
}

.menu__item {
    margin: 0;
    padding: 0
}

.menu__child {
    margin: 0;
    padding: 0
}

.option-tooltip {
    display: none;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 10px);
    background-color: #fff;
    box-shadow: 0 5px 15px 5px rgba(0, 0, 0, .3);
    width: 280px;
    border-top: 4px solid #41b6e6
}

.option-tooltip:before {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 22px 15px 22px;
    border-color: transparent transparent #41b6e6 transparent;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%)
}

.option-tooltip span {
    display: inline-block;
    padding: 25px 50px 25px 25px
}

.option-tooltip .btnOptionTooltipClose {
    position: absolute;
    top: 15px;
    right: 15px;
    /* background-image: url(/src/images/icons/x.svg); */
    background-repeat: no-repeat;
    background-size: cover;
    width: 15px;
    height: 15px;
    text-indent: -9999px;
    outline: 0
}

.cke_editable,
.wysiwyg {
    font-size: 1.8rem;
    line-height: 1.5em
}

.cke_editable p,
.wysiwyg p {
    font-size: 1.8rem;
    line-height: 2.8rem
}

.cke_editable .smallmargin,
.wysiwyg .smallmargin {
    display: block;
    margin-bottom: 2rem !important
}

.cke_editable .bigmargin,
.wysiwyg .bigmargin {
    display: block;
    margin-bottom: 5rem !important
}

.cke_editable .legaltext,
.wysiwyg .legaltext {
    font-size: 1.2rem;
    line-height: 1.8rem
}

.cke_editable img,
.wysiwyg img {
    max-width: 100%
}

.cke_editable ul:not(.contextual-links) li,
.wysiwyg ul:not(.contextual-links) li {
    margin-left: 3em;
    text-indent: -1.5em;
    font-size: 1.8rem
}

.cke_editable ul:not(.contextual-links) li a.btn,
.cke_editable ul:not(.contextual-links) li a.btn--inverted,
.cke_editable ul:not(.contextual-links) li a.btn-100-primary,
.cke_editable ul:not(.contextual-links) li a.btn-primary,
.cke_editable ul:not(.contextual-links) li a.btn-secondary,
.cke_editable ul:not(.contextual-links) li a.btn-tertiary,
.wysiwyg ul:not(.contextual-links) li a.btn,
.wysiwyg ul:not(.contextual-links) li a.btn--inverted,
.wysiwyg ul:not(.contextual-links) li a.btn-100-primary,
.wysiwyg ul:not(.contextual-links) li a.btn-primary,
.wysiwyg ul:not(.contextual-links) li a.btn-secondary,
.wysiwyg ul:not(.contextual-links) li a.btn-tertiary {
    display: inline
}

.cke_editable .title.title--light,
.wysiwyg .title.title--light {
    color: var(--color-light-blue)
}

.cke_editable .title.title--white,
.wysiwyg .title.title--white {
    color: #fff
}

.cke_editable .title--nomargin span,
.wysiwyg .title--nomargin span {
    margin-bottom: 0 !important
}

.cke_editable .text,
.wysiwyg .text {
    font-size: 1.8rem;
    line-height: 1.5em;
    font-weight: 700
}

.cke_editable .text--grey,
.wysiwyg .text--grey {
    color: rgba(0, 0, 0, .3)
}

.cke_editable .text--light,
.wysiwyg .text--light {
    color: var(--color-light-blue)
}

.cke_editable .text--white,
.wysiwyg .text--white {
    color: #fff
}

.cke_editable .text--black,
.wysiwyg .text--black {
    color: #000
}

.cke_editable .link,
.wysiwyg .link {
    font-size: 1.6rem;
    line-height: 1.1em;
    font-weight: 700;
    color: #041e42;
    display: flex;
    align-items: center
}

.cke_editable .box,
.wysiwyg .box {
    background-color: #f2f6f8
}

.cke_editable .box p,
.wysiwyg .box p {
    margin-bottom: 0;
    color: #041e42
}

.cke_editable .box--rounded,
.wysiwyg .box--rounded {
    border-bottom-left-radius: 50px;
    padding: 30px 35px
}

.cke_editable .box--dark,
.wysiwyg .box--dark {
    background-color: #041e42;
    color: #fff
}

.cke_editable .box--outline,
.wysiwyg .box--outline {
    border: 6px solid var(--color-light-blue)
}

.cke_editable ul:not(.contextual-links),
.wysiwyg ul:not(.contextual-links) {
    list-style-type: none;
    padding: 0
}

@media screen and (max-width: 991px) {

    .cke_editable ul:not(.contextual-links),
    .wysiwyg ul:not(.contextual-links) {
        margin-bottom: 0
    }
}

.cke_editable ul:not(.contextual-links) li:before,
.wysiwyg ul:not(.contextual-links) li:before {
    content: "";
    display: inline-block;
    height: .65em;
    width: .65em;
    background-size: contain;
    /* background-image: url(/src/images/icons/circle-dark-blue.svg); */
    background-repeat: no-repeat;
    padding-left: 1.2em;
    position: relative;
    top: .2em;
    margin-left: .2em
}

/*

.layout__black .cke_editable ul:not(.contextual-links) li:before,
.layout__black .wysiwyg ul:not(.contextual-links) li:before,
.layout__blue .cke_editable ul:not(.contextual-links) li:before,
.layout__blue .wysiwyg ul:not(.contextual-links) li:before,
.layout__dark_grey .cke_editable ul:not(.contextual-links) li:before,
.layout__dark_grey .wysiwyg ul:not(.contextual-links) li:before,
.layout__light_blue .cke_editable ul:not(.contextual-links) li:before,
.layout__light_blue .wysiwyg ul:not(.contextual-links) li:before {
    background-image: url(/src/images/icons/circle-white.svg)
}

.layout__black .cke_editable ul:not(.contextual-links) .point:before,
.layout__black .wysiwyg ul:not(.contextual-links) .point:before,
.layout__blue .cke_editable ul:not(.contextual-links) .point:before,
.layout__blue .wysiwyg ul:not(.contextual-links) .point:before,
.layout__dark_grey .cke_editable ul:not(.contextual-links) .point:before,
.layout__dark_grey .wysiwyg ul:not(.contextual-links) .point:before,
.layout__light_blue .cke_editable ul:not(.contextual-links) .point:before,
.layout__light_blue .wysiwyg ul:not(.contextual-links) .point:before {
    background-image: url(/src/images/icons/circle-white.svg)
}

.cke_editable ul:not(.contextual-links) .point:before,
.wysiwyg ul:not(.contextual-links) .point:before {
    background-image: url(/src/images/icons/circle-dark-blue.svg)
}

.cke_editable ul:not(.contextual-links) .point--lightblue:before,
.wysiwyg ul:not(.contextual-links) .point--lightblue:before {
    background-image: url(/src/images/icons/circle-light-blue.svg)
}

.cke_editable ul:not(.contextual-links) .check:before,
.wysiwyg ul:not(.contextual-links) .check:before {
    top: 0;
    margin-left: 0;
    padding-left: 1.4em;
    background-image: url(/src/images/icons/check.svg)
}

*/
.layout__black .cke_editable ul:not(.contextual-links) .check:before,
.layout__black .wysiwyg ul:not(.contextual-links) .check:before,
.layout__blue .cke_editable ul:not(.contextual-links) .check:before,
.layout__blue .wysiwyg ul:not(.contextual-links) .check:before,
.layout__dark_grey .cke_editable ul:not(.contextual-links) .check:before,
.layout__dark_grey .wysiwyg ul:not(.contextual-links) .check:before,
.layout__light_blue .cke_editable ul:not(.contextual-links) .check:before,
.layout__light_blue .wysiwyg ul:not(.contextual-links) .check:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___})
}

/* 
.cke_editable ul:not(.contextual-links) .check--lightblue:before,
.wysiwyg ul:not(.contextual-links) .check--lightblue:before {
    background-image: url(/src/images/icons/check-light-blue.svg)
} */

.cke_editable ul:not(.contextual-links) .mark--exclamation:before,
.wysiwyg ul:not(.contextual-links) .mark--exclamation:before {
    /* background-image: url(/src/images/icons/exclamation-mark.svg); */
    height: .8em;
    width: .8em;
    top: 1px;
    padding-left: 0;
    margin-right: 5px
}

@media (max-width: 575.98px) {

    .cke_editable .align-left,
    .cke_editable .align-right,
    .wysiwyg .align-left,
    .wysiwyg .align-right {
        float: none
    }
}

@media (min-width: 576px) {

    .cke_editable .align-right,
    .wysiwyg .align-right {
        margin-left: 10px
    }
}

@media (max-width: 575.98px) {

    .cke_editable .align-right.embedded-entity,
    .wysiwyg .align-right.embedded-entity {
        text-align: right
    }
}

@media (min-width: 576px) {

    .cke_editable .align-left,
    .wysiwyg .align-left {
        margin-right: 10px
    }
}

@media (max-width: 575.98px) {

    .cke_editable .align-left.embedded-entity,
    .wysiwyg .align-left.embedded-entity {
        text-align: left
    }

    .cke_editable .embedded-entity,
    .wysiwyg .embedded-entity {
        text-align: center
    }
}

.cke_editable .align-center,
.wysiwyg .align-center {
    text-align: center
}

.cke_editable iframe,
.wysiwyg iframe {
    width: 100%;
    border: none
}

.block__text .wysiwyg ul:not(.contextual-links) {
    margin-bottom: 1em
}

@media screen and (max-width: 991px) {
    .block__text .wysiwyg ul:not(.contextual-links) {
        margin-bottom: 2em
    }
}

.block__text .wysiwyg ul:not(.contextual-links) li {
    margin-left: 3.5em;
    text-indent: -1.5em
}

.block__text .wysiwyg ul:not(.contextual-links) li p {
    text-indent: 0;
    display: inline
}

.block__text .wysiwyg ul:not(.contextual-links) li h3 {
    text-indent: 0
}

@media (max-width: 1199.98px) {
    .block__text .wysiwyg ul:not(.contextual-links) li {
        margin-left: 3em
    }
}

@media (max-width: 767.98px) {
    .block__text .wysiwyg ul.no-margin {
        margin-bottom: 0
    }
}

@media (min-width: 992px) {
    .limited-w {
        max-width: 66%
    }
}

@keyframes pattern-text {
    25% {
        background-position: 50% center
    }

    50% {
        background-position: 100% center
    }

    75% {
        background-position: 150% center
    }

    100% {
        background-position: 200% center
    }
}

.gradient-text {
    /* background-image: url(/src/images/bg/ImageBackground_SmallerNew.webp); */
    -webkit-background-clip: text;
    color: transparent;
    background-repeat: repeat;
    background-position: 0 center;
    background-size: 200%;
    animation: pattern-text 40s linear infinite;
    animation-direction: reverse;
    display: inline
}

div.slick-cta {
    position: relative;
    text-align: left;
    width: 66%;
    --text-color: #FFFFFF;
    transform: translateY(0);
    bottom: 0;
    z-index: 1
}

@media (min-width: 992px) {
    div.slick-cta {
        position: absolute;
        transform: translateY(40%)
    }
}

@media screen and (max-width: 1199px) {
    div.slick-cta {
        width: 80%
    }
}

@media (max-width: 991.98px) {
    div.slick-cta {
        width: 100%
    }
}

div.slick-cta__question {
    position: absolute;
    z-index: 2;
    transform: translateY(-10%)
}

@media (max-width: 767.98px) {
    div.slick-cta__question {
        position: relative;
        transform: translateY(0)
    }
}

div.slick-cta div.slick-cta--content {
    position: relative;
    z-index: 1;
    width: 84%;
    padding: 30px 0;
    background-color: #041e42;
    font-size: 1.8rem
}

@media (max-width: 991.98px) {
    div.slick-cta div.slick-cta--content {
        width: 100%
    }
}

div.slick-cta div.slick-cta--content .row {
    margin-left: 10vw
}

div.slick-cta div.slick-cta--content .question {
    padding: 33px 15px 33px 0;
    font-size: 2.8rem
}

@media screen and (max-width: 767px) {
    div.slick-cta div.slick-cta--content .question {
        padding: 0 0 40px 15px;
        font-size: 2.2rem
    }
}

div.slick-cta div.slick-cta--content .select {
    position: absolute;
    z-index: 1;
    height: 40px;
    overflow: hidden;
    padding: 0;
    cursor: pointer;
    background-color: #041e42;
    margin: 40px 0 0
}

@media screen and (max-width: 767px) {
    div.slick-cta div.slick-cta--content .select {
        margin: -30px 0 0;
        height: 30px
    }
}

div.slick-cta div.slick-cta--content .select:hover {
    height: auto;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px
}

div.slick-cta div.slick-cta--content .select li {
    font-size: 2.2rem;
    padding: 10px 20px;
    color: #fff
}

@media screen and (max-width: 767px) {
    div.slick-cta div.slick-cta--content .select li {
        font-size: 1.4rem;
        padding: 8px 20px
    }
}

div.slick-cta div.slick-cta--content .select li:first-child {
    border-bottom: 2px solid #fff;
    padding: 2px 0
}

div.slick-cta div.slick-cta--content .select li:first-child span:after {
    content: " ";
    position: absolute;
    right: -18px;
    /* background-image: url(/src/images/icons/chevron-up.svg); */
    background-size: 24px 24px;
    background-position: right center;
    background-repeat: no-repeat;
    height: 36px;
    width: 36px;
    transform: rotate(180deg)
}

@media screen and (max-width: 991px) {
    div.slick-cta div.slick-cta--content .select li:first-child span:after {
        top: -4px
    }
}

div.slick-cta div.slick-cta--content .select li a {
    display: block;
    text-decoration: none;
    color: #fff
}

div.slick-cta div.slick-cta--content .select li:hover a {
    color: #40b4e5
}

div.slick-cta div.slick-cta--round {
    position: absolute;
    content: " ";
    background-color: #041e42;
    height: 100%;
    top: 0;
    left: 83.5%
}

@media (min-width: 992px) {
    div.slick-cta div.slick-cta--round {
        border-bottom-right-radius: 999px;
        border-top-right-radius: 999px
    }
}

.layout-builder__section div.slick-cta {
    transform: none
}

.swiper {
    position: unset !important;
    border-radius: 10px
}

.swiper .swiper-wrapper {
    margin-bottom: 40px
}

@media (min-width: 768px) {
    .swiper .swiper-wrapper {
        margin-bottom: 48px
    }
}

.swiper .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: auto;
    border-radius: 10px;
    transition: transform .3s ease
}

.swiper .swiper-wrapper .swiper-slide .media-360 .btn-360 {
    position: absolute;
    right: 15px;
    bottom: 15px
}

.swiper .swiper-wrapper .swiper-slide .media-360 .btn-360 .icon-360 {
    margin: 0
}

.swiper:not(.swiper-initialized) .swiper-button-next,
.swiper:not(.swiper-initialized) .swiper-button-prev,
.swiper:not(.swiper-initialized) .swiper-pagination,
.swiper:not(.swiper-initialized) .swiper-veil {
    display: none
}

.swiper .swiper-button-next,
.swiper .swiper-button-prev {
    background-color: #41b6e6;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    transition: transform .3s;
    top: calc(50% - 36px)
}

@media (max-width: 991.98px) {

    .swiper .swiper-button-next,
    .swiper .swiper-button-prev {
        width: 28px;
        height: 28px;
        top: calc(100% - 36px)
    }
}

.swiper .swiper-button-next:after,
.swiper .swiper-button-prev:after {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    background-position: center;
    background-size: 14px 10px;
    background-repeat: no-repeat;
    width: 100%;
    height: 14px;
    position: relative;
    top: 0;
    transform-origin: center center;
    transform: rotate(var(--swiper-btn-rotate)) translateY(1px)
}

@media (max-width: 991.98px) {

    .swiper .swiper-button-next:after,
    .swiper .swiper-button-prev:after {
        background-size: 12px 10px
    }
}

@media (min-width: 768px) {

    .swiper .swiper-button-next:hover,
    .swiper .swiper-button-prev:hover {
        transform: scale(1.11)
    }
}

.swiper .swiper-button-prev {
    left: -18px;
    --swiper-btn-rotate: 90deg
}

@media (max-width: 991.98px) {
    .swiper .swiper-button-prev {
        left: 0
    }
}

.swiper .swiper-button-next {
    right: -18px;
    --swiper-btn-rotate: -90deg
}

@media (max-width: 991.98px) {
    .swiper .swiper-button-next {
        right: 0
    }
}

.swiper .swiper-veil {
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, var(--bg-color) 50%);
    width: 10%;
    height: 100%;
    z-index: 1;
    cursor: pointer
}

@media (max-width: 991.98px) {
    .swiper .swiper-veil {
        right: -15px;
        width: 20%
    }
}

.swiper .swiper-wrapper+.swiper-pagination {
    --swiper-pagination-bullet-inactive-opacity: 1;
    bottom: 0;
    width: 90%
}

@media (max-width: 991.98px) {
    .swiper .swiper-wrapper+.swiper-pagination {
        width: 100%
    }
}

.swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet {
    background-color: #8a8d8f;
    border-radius: 10px;
    height: 3px;
    width: 5%;
    transition: background-color .3s
}

.swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet:hover:not(.swiper-pagination-bullet-active) {
    background-color: #54585a
}

.layout__black .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet:hover:not(.swiper-pagination-bullet-active),
.layout__blue .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet:hover:not(.swiper-pagination-bullet-active),
.layout__dark_grey .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet:hover:not(.swiper-pagination-bullet-active),
.layout__light_blue .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet:hover:not(.swiper-pagination-bullet-active) {
    background-color: #cfd3d6
}

.swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #000;
    cursor: default
}

.layout__black .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active,
.layout__blue .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active,
.layout__dark_grey .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active,
.layout__light_blue .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #fff
}

.swiper-thumbs .swiper-wrapper {
    overflow: hidden;
    justify-content: center
}

.swiper-thumbs .swiper-wrapper .swiper-slide {
    opacity: .4;
    background-color: #fff;
    border-radius: 5px
}

.swiper-thumbs .swiper-wrapper .swiper-slide.swiper-slide-thumb-active {
    opacity: 1;
    border: 1px solid #000
}

.swiper-thumbs .swiper-wrapper .swiper-slide .main-image-container div.splash-video-play-button {
    width: 19px;
    height: 19px;
    left: calc(50% - 9.5px);
    top: calc(50% - 9.5px);
    pointer-events: none
}

.swiper-thumbs .swiper-wrapper .swiper-slide img {
    border-radius: 5px;
    width: 100%;
    height: auto
}

.swiper-thumbs .swiper-wrapper .swiper-slide .media-360 .icon-media-360 {
    display: block;
    position: absolute;
    left: calc(50% - 9.5px);
    top: calc(50% - 9.5px);
    width: 19px;
    height: 19px;
    /* background-image: url(/src/images/icons/360.png); */
    background-position: center;
    background-size: cover
}

.pt-image-gallery-zoom {
    position: absolute;
    width: 400px;
    height: 400px;
    border: 1px solid #c7cfd7;
    box-shadow: 2px 2px 5px 1px #c7cfd7;
    display: none;
    z-index: 9999;
    background-color: #fff
}

.pt-image-gallery-zoom-display {
    position: absolute;
    top: 0;
    left: 0;
    height: 200px;
    width: 200px;
    z-index: 500;
    border: 1px solid #ff0;
    pointer-events: none;
    display: none;
    margin-top: -100px;
    margin-left: -100px
}

.swiper-image-mobile img {
    width: 100%;
    height: auto
}

.main-image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative
}

.main-image-container div.splash-video-play-button {
    cursor: pointer;
    position: absolute;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
    background-size: contain;
    background-repeat: no-repeat;
    width: 100px;
    height: 100px;
    left: calc(50% - 50px);
    top: calc(50% - 50px)
}

@media (min-width: 768px) and (max-width:1199.98px) {
    .main-image-container div.splash-video-play-button {
        width: 70px;
        height: 70px;
        left: calc(50% - 35px);
        top: calc(50% - 35px)
    }
}

@media (max-width: 767.98px) {
    .main-image-container div.splash-video-play-button {
        width: 50px;
        height: 50px;
        left: calc(50% - 25px);
        top: auto
    }
}

.main-image-container div.splash-video-play-button:hover {
    opacity: .65
}

.main-image-container div.splash-video-play-button.splash-video-left {
    left: 50%;
    transform: translateX(-50%)
}

@media \\0 screen\\,screen\\9 and (max-width: 991.98px),
screen\\0 and (max-width:991.98px) {
    .main-image-container div.splash-video-play-button.splash-video-left {
        top: 50%
    }
}

.main-image-container img {
    width: 100%
}

#cboxOverlay,
#cboxWrapper,
#colorbox {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    overflow: hidden
}

#cboxOverlay {
    position: fixed;
    width: 100%;
    height: 100%
}

#cboxBottomLeft,
#cboxMiddleLeft {
    clear: left
}

#cboxContent {
    position: relative;
    background-color: transparent !important;
    padding-top: 6.4rem;
    height: auto;
    width: inherit !important;
    height: inherit !important
}

@media (max-width: 767.98px) {
    #cboxContent {
        padding-top: 4.8rem
    }
}

@media (min-width: 768px) {
    #cboxContent {
        padding-top: 4.8rem
    }
}

@media (min-width: 992px) {
    #cboxContent {
        padding-top: 4.8rem
    }
}

@media screen and (orientation: landscape) {
    #cboxContent {
        padding-top: 5.1rem
    }
}

#cboxLoadedContent {
    overflow: hidden
}

#cboxTitle {
    margin: 0
}

#cboxLoadingGraphic,
#cboxLoadingOverlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%
}

#cboxContent,
#cboxLoadedContent,
#colorbox {
    box-sizing: content-box
}

div#cboxLoadedContent {
    width: inherit !important;
    height: inherit !important;
    overflow: hidden !important
}

#cboxOverlay {
    background-color: rgba(4, 30, 66, .95)
}

#colorbox {
    outline: 0
}

#cboxWrapper {
    background: 0 0;
    border-radius: 5px;
    width: inherit !important;
    height: inherit !important;
    overflow: hidden !important
}

#cboxTopLeft {
    width: 15px;
    height: 15px
}

#cboxTopCenter {
    height: 15px
}

#cboxTopRight {
    width: 15px;
    height: 15px
}

#cboxBottomLeft {
    width: 15px;
    height: 10px
}

#cboxBottomCenter {
    height: 10px
}

#cboxBottomRight {
    width: 15px;
    height: 10px
}

#cboxMiddleLeft {
    width: 15px
}

#cboxMiddleRight {
    width: 15px
}

#cboxContent {
    background: 0 0;
    overflow: hidden
}

#cboxError {
    padding: 50px;
    border: none
}

#cboxLoadedContent {
    margin-bottom: 28px
}

#cboxTitle {
    position: absolute;
    background: 0 0;
    bottom: 28px;
    left: 0;
    color: #535353;
    width: 100%;
    padding: 4px 6px;
    box-sizing: border-box
}

button#cboxClose {
    position: absolute;
    /* background: url(/src/images/icons/close-button-light.svg) no-repeat; */
    background-position: center center;
    background-size: contain;
    width: 3.5rem;
    height: 3.5rem;
    text-indent: -9999px;
    top: 0;
    border: none;
    right: 7px
}

button#cboxClose:hover {
    /* background: url(/src/images/icons/close-button-dark.svg) no-repeat; */
    background-position: center center;
    background-size: contain
}

button#cboxClose:active {
    outline: 0
}

@media (min-width: 768px) and (max-width:1199.98px) {
    button#cboxClose {
        width: 3.2rem;
        height: 3.2rem
    }
}

@media (max-width: 767.98px) {
    button#cboxClose {
        width: 2.8rem;
        height: 2.8rem
    }
}

.video-embed-field-responsive-modal {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
    box-sizing: border-box
}

.video-embed-field-responsive-modal iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute
}

div#colorbox {
    background: 0 0;
    max-width: calc(177.777778vh - 40px);
    width: 100%;
    overflow: hidden !important;
    left: 50% !important;
    top: 45% !important;
    transform: translate(-50%, -50%);
    position: fixed !important
}

@media screen and (orientation: landscape) {
    div#colorbox {
        width: 65vw !important;
        height: calc(42vw + 3.2rem) !important
    }
}

@media screen and (orientation: portrait) {
    div#colorbox {
        width: 85vw !important;
        height: calc(61vw + 8rem) !important
    }
}

div#cboxContent,
div.video-embed-field-responsive-modal {
    background: 0 0;
    max-width: calc(177.777778vh - 70px);
    width: 100%;
    overflow: hidden !important
}

@media screen and (orientation: landscape) {

    div#cboxContent,
    div.video-embed-field-responsive-modal {
        width: calc(65vw - 30px) !important;
        height: calc(36vw + 4.8rem) !important
    }
}

@media screen and (orientation: portrait) {

    div#cboxContent,
    div.video-embed-field-responsive-modal {
        width: calc(85vw - 30px) !important;
        height: calc(47vw + 4.8rem) !important
    }
}

.layout__black .webform-block,
.layout__blue .webform-block,
.layout__dark_grey .webform-block,
.layout__light_blue .webform-block {
    color: #fff
}

.webform-block .webform-submission-form>.form-item>input {
    width: auto
}

.webform-block .webform-submission-form .mandatory-label {
    float: right;
    font-size: 1.4rem;
    padding-top: 23px;
    color: #04325e
}

@media screen and (max-width: 767px) {
    .webform-block .webform-submission-form .mandatory-label {
        margin-top: -55px;
        color: #041e42
    }
}

.webform-block .webform-submission-form .form-item .option {
    font-weight: 400;
    margin-left: .3rem
}

.webform-block .webform-submission-form .form-item .form-required {
    font-weight: 600;
    margin-left: .3rem
}

@media screen and (min-width: 768px) {
    .webform-block .webform-submission-form .form-item input::-moz-placeholder {
        color: transparent
    }
    .webform-block .webform-submission-form .form-item input::placeholder {
        color: transparent
    }

    .webform-block .webform-submission-form .form-item ::-webkit-input-placeholder {
        color: transparent
    }

    .webform-block .webform-submission-form .form-item :-moz-placeholder {
        color: transparent
    }

    .webform-block .webform-submission-form .form-item ::-moz-placeholder {
        color: transparent
    }

    .webform-block .webform-submission-form .form-item :-ms-input-placeholder {
        color: transparent
    }
}

.webform-block .webform-submission-form .form-item .fieldset-legend {
    font-size: 1.8rem;
    line-height: 1.45em;
    letter-spacing: 0;
    opacity: 1;
    font-weight: 600
}

.webform-block .webform-submission-form .form-item .form-checkbox,
.webform-block .webform-submission-form .form-item .form-radio {
    width: auto
}

.webform-block .webform-submission-form .form-item .form-date,
.webform-block .webform-submission-form .form-item .form-email,
.webform-block .webform-submission-form .form-item .form-number,
.webform-block .webform-submission-form .form-item .form-tel,
.webform-block .webform-submission-form .form-item .form-text,
.webform-block .webform-submission-form .form-item .form-url {
    display: block;
    margin-top: .4rem;
    width: 100%;
    background-color: #f2f6f8;
    border-bottom: 3px solid #bdbfc1;
    border-top: none;
    border-left: none;
    border-right: none;
    color: #04325e;
    box-shadow: none;
    border-radius: 0;
    padding-left: 20px;
    font-size: 1.8rem
}

.webform-block .webform-submission-form .form-item .form-date:focus,
.webform-block .webform-submission-form .form-item .form-email:focus,
.webform-block .webform-submission-form .form-item .form-number:focus,
.webform-block .webform-submission-form .form-item .form-tel:focus,
.webform-block .webform-submission-form .form-item .form-text:focus,
.webform-block .webform-submission-form .form-item .form-url:focus {
    border-color: none;
    border-bottom: 3px solid #41b6e6
}

@media screen and (max-width: 767px) {

    .webform-block .webform-submission-form .form-item .form-date:focus,
    .webform-block .webform-submission-form .form-item .form-email:focus,
    .webform-block .webform-submission-form .form-item .form-number:focus,
    .webform-block .webform-submission-form .form-item .form-tel:focus,
    .webform-block .webform-submission-form .form-item .form-text:focus,
    .webform-block .webform-submission-form .form-item .form-url:focus {
        border-bottom: 2px solid #41b6e6
    }
}

@media screen and (min-width: 1025px) {

    .webform-block .webform-submission-form .form-item .form-date,
    .webform-block .webform-submission-form .form-item .form-email,
    .webform-block .webform-submission-form .form-item .form-number,
    .webform-block .webform-submission-form .form-item .form-tel,
    .webform-block .webform-submission-form .form-item .form-text,
    .webform-block .webform-submission-form .form-item .form-url {
        height: 60px
    }
}

@media screen and (max-width: 767px) {

    .webform-block .webform-submission-form .form-item .form-date,
    .webform-block .webform-submission-form .form-item .form-email,
    .webform-block .webform-submission-form .form-item .form-number,
    .webform-block .webform-submission-form .form-item .form-tel,
    .webform-block .webform-submission-form .form-item .form-text,
    .webform-block .webform-submission-form .form-item .form-url {
        padding-left: 10px;
        height: 40px;
        font-size: 1.9rem;
        border-bottom: none;
        color: #8a8d8f
    }
}

.webform-block .webform-submission-form .form-item .form-select {
    -moz-appearance: none;
    -webkit-appearance: none;
    width: 100%;
    padding-left: 20px;
    border-bottom: 3px solid #bdbfc1;
    border-top: none;
    border-left: none;
    border-right: none;
    box-shadow: none;
    border-radius: 0;
    background: #f2f6f8 0 0 url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat padding-box;
    background-size: 13px 8px;
    background-position: right 13px bottom 20px
}

.webform-block .webform-submission-form .form-item .form-select::-ms-expand {
    display: none
}

@media screen and (max-width: 767px) {
    .webform-block .webform-submission-form .form-item .form-select {
        font-weight: 400;
        font-size: 1.9rem;
        padding-left: 10px;
        height: 40px;
        border-bottom: none
    }
}

.webform-block .webform-submission-form .form-item .form-select:focus {
    border-color: none;
    border-bottom: 3px solid #41b6e6
}

@media screen and (max-width: 767px) {
    .webform-block .webform-submission-form .form-item .form-select:focus {
        border-bottom: 2px solid #41b6e6
    }
}

@media screen and (min-width: 1025px) {
    .webform-block .webform-submission-form .form-item .form-select {
        height: 60px;
        color: #04325e;
        font-weight: 400;
        font-size: 1.8rem
    }
}

.webform-block .webform-submission-form .form-item .form-textarea {
    height: 200px;
    font-size: 1.8rem;
    color: #041e42;
    width: 100%;
    padding-left: 20px;
    border: 3px solid #bdbfc1
}

@media screen and (max-width: 767px) {
    .webform-block .webform-submission-form .form-item .form-textarea {
        padding-left: 10px;
        background-color: #f2f6f8;
        border: none;
        font-size: 1.4rem
    }
}

.webform-block .webform-submission-form .form-item .form-textarea:focus {
    border: 3px solid #41b6e6;
    outline: 0
}

@media screen and (max-width: 767px) {
    .webform-block .webform-submission-form .form-item .form-textarea:focus {
        border: 2px solid #41b6e6
    }
}

.webform-block .webform-submission-form .form-item .form-managed-file {
    position: relative
}

.webform-block .webform-submission-form .form-item .form-managed-file .form-wrapper {
    margin-bottom: 20px
}

@media screen and (max-width: 767px) {
    .webform-block .webform-submission-form .form-item input {
        margin-bottom: 10px
    }
}

.webform-block .webform-submission-form .input-file {
    position: absolute;
    opacity: 0;
    left: 0;
    top: 0;
    height: 100%;
    z-index: 2;
    cursor: pointer
}

.webform-block .webform-submission-form .input-file:hover~.btn-secondary.btn__upload,
.webform-block .webform-submission-form .input-file:hover~.btn__upload.btn--inverted {
    box-shadow: 0 0 0 3px var(--color-light-blue);
    color: var(--color-light-blue);
    background-color: transparent;
    cursor: pointer
}

.webform-block .webform-submission-form .input-file:hover~.btn-secondary.btn__upload:before,
.webform-block .webform-submission-form .input-file:hover~.btn__upload.btn--inverted:before {
    background-color: var(--color-light-blue)
}

.webform-block .webform-submission-form .webform-button--submit {
    margin-bottom: 1.6rem
}

@media (min-width: 576px) {
    .webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .webform-elements {
        display: flex
    }
}

.webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item {
    display: inline-block;
    width: -moz-min-content;
    width: min-content
}

.webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item input {
    height: 50px;
    width: 375px;
    border-radius: 25px;
    border-color: #041e42;
    padding: 1px 15px;
    margin-right: 15px;
    outline: 0
}

@media (max-width: 767.98px) {
    .webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item input {
        width: 32rem
    }
}

.webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description {
    font-style: italic;
    padding-top: 10px
}

.webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description a {
    font-weight: 600
}

.webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-actions {
    display: inline-block;
    vertical-align: top
}

.webform-block .webform-submission-form .webform-progress-tracker .progress-step .progress-marker {
    background-color: #8a8d8f;
    padding-bottom: 0
}

.webform-block .webform-submission-form .webform-progress-tracker .progress-step .progress-text {
    color: #8a8d8f
}

.webform-block .webform-submission-form .webform-progress-tracker .progress-step.is-complete .progress-marker {
    background-color: #041e42
}

.webform-block .webform-submission-form .webform-progress-tracker .progress-step.is-complete .progress-text {
    color: #041e42
}

.webform-block .webform-submission-form .webform-progress-tracker .progress-step.is-active .progress-marker {
    background-color: #41b6e6
}

.webform-block .webform-submission-form .webform-progress-tracker .progress-step.is-active .progress-text {
    color: #41b6e6
}

.webform-block .webform-submission-form .form-item .form-required:after {
    content: " *"
}

.webform-block .webform-submission-form .form__text-area--html {
    height: 200px;
    background-color: #ededed;
    font-size: 1.8rem;
    color: #041e42;
    overflow-y: scroll;
    width: 100%;
    padding-left: 20px;
    border: 3px solid #bdbfc1
}

.webform-block .layout__black .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item input,
.webform-block .layout__blue .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item input {
    border: none
}

.webform-block .layout__black .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description,
.webform-block .layout__blue .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description {
    color: #fff
}

.webform-block .layout__black .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description a,
.webform-block .layout__blue .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description a {
    color: #fff
}

.webform-block .layout__black .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description a:hover,
.webform-block .layout__blue .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description a:hover {
    color: #fff
}

.webform-block .ui-dialog-buttonpane .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover,
.webform-block .ui-dialog-buttonpane .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover,
.webform-block .ui-dialog-buttonpane .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover,
.webform-block .webform-submission-form .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover,
.webform-block .webform-submission-form .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover,
.webform-block .webform-submission-form .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover {
    background-position: 92% center;
    transition: all .6s ease
}

@media screen and (max-width: 767px) {

    .webform-block .ui-dialog-buttonpane .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),
    .webform-block .ui-dialog-buttonpane .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),
    .webform-block .ui-dialog-buttonpane .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),
    .webform-block .webform-submission-form .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),
    .webform-block .webform-submission-form .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),
    .webform-block .webform-submission-form .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn) {
        margin-left: 0;
        margin-top: 1.2rem
    }
}

@media screen and (min-width: 1025px) {

    .webform-block .ui-dialog-buttonpane .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),
    .webform-block .ui-dialog-buttonpane .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),
    .webform-block .ui-dialog-buttonpane .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),
    .webform-block .webform-submission-form .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),
    .webform-block .webform-submission-form .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),
    .webform-block .webform-submission-form .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn) {
        float: right
    }
}

.webform-block .ui-dialog-buttonpane .webform-button--previous,
.webform-block .webform-submission-form .webform-button--previous {
    background-position: 13% center;
    /* background-image: url(/src/images/icons/arrow-previous-white.svg); */
    padding: 14px 20px 15px 55px
}

.webform-block .ui-dialog-buttonpane .webform-button--previous:hover,
.webform-block .webform-submission-form .webform-button--previous:hover {
    background-position: 8% center
}

@media screen and (min-width: 1025px) {

    .webform-block .ui-dialog-buttonpane .webform-button--previous,
    .webform-block .webform-submission-form .webform-button--previous {
        float: left
    }
}

.webform-block .checkbox-text-align.js-form-type-checkbox {
    display: inline-flex;
    align-items: baseline
}

.webform-block .checkbox-text-align.js-form-type-checkbox .form-checkbox {
    margin-right: 5px
}

.webform-confirmation-modal--content a {
    color: var(--link-color)
}

.webform-confirmation-modal--content a:hover {
    color: var(--link-hover-color)
}

.webform-submission-privacy-rights-form .js-form-type-textfield {
    margin-top: 14px
}

.webform-submission-privacy-rights-form .js-form-type-email {
    margin-top: 32px
}

.webform-submission-privacy-rights-form .js-form-type-textarea {
    margin-top: 32px
}

.webform-submission-privacy-rights-form .js-form-type-textarea label {
    font-weight: 700
}

.webform-submission-privacy-rights-form .js-form-type-checkbox label {
    width: 90%;
    vertical-align: top
}

.webform-submission-privacy-rights-form .js-form-type-checkbox:not(:first-of-type) {
    margin-top: 24px
}

.webform-submission-privacy-rights-form #edit-action-to-take--wrapper.checkboxes--wrapper {
    margin-top: 48px
}

.webform-submission-privacy-rights-form #edit-action-to-take--wrapper.checkboxes--wrapper .fieldset-wrapper {
    margin-top: 11px
}

.webform-submission-privacy-rights-form .js-form-item-i-agree-to-the-processing-of-my-data-by-premier-tech-ltd-in-orde {
    margin-top: 64px !important
}

.webform-submission-privacy-rights-form .js-form-item-i-agree-to-the-processing-of-my-data-by-premier-tech-ltd-in-orde label {
    font-size: 12px;
    margin-top: .4rem;
    color: #54585a
}

.webform-submission-privacy-rights-form .description .webform-element-description {
    font-size: 12px;
    margin-left: 20px;
    color: #54585a
}

.webform-submission-privacy-rights-form .webform-button--submit {
    margin-top: 48px
}

.form-item-telephone .iti--allow-dropdown {
    width: 100%;
    margin-top: 4px
}

@media screen and (min-width: 1025px) {
    .form-item-telephone .iti--allow-dropdown {
        height: 60px
    }
}

@media screen and (max-width: 767px) {
    .form-item-telephone .iti--allow-dropdown {
        height: 40px
    }
}

.form-item-telephone .iti--allow-dropdown .webform-webform-telephone-international#edit-telephone {
    padding-left: 50px
}

.webform-submission-downtime-calculator-form {
    margin: 64px 0
}

.webform-submission-downtime-calculator-form #edit-general {
    padding-right: 30px
}

.webform-submission-downtime-calculator-form #edit-sec-1,
.webform-submission-downtime-calculator-form #edit-sec-2,
.webform-submission-downtime-calculator-form #edit-sec-3,
.webform-submission-downtime-calculator-form #edit-sec-4 {
    margin: 24px 0
}

.webform-submission-downtime-calculator-form #edit-sec-1 .h2,
.webform-submission-downtime-calculator-form #edit-sec-2 .h2,
.webform-submission-downtime-calculator-form #edit-sec-3 .h2,
.webform-submission-downtime-calculator-form #edit-sec-4 .h2 {
    font-size: 30px
}

.webform-submission-downtime-calculator-form #edit-sec-1 .h3,
.webform-submission-downtime-calculator-form #edit-sec-2 .h3,
.webform-submission-downtime-calculator-form #edit-sec-3 .h3,
.webform-submission-downtime-calculator-form #edit-sec-4 .h3 {
    font-size: 24px
}

.webform-submission-downtime-calculator-form .js-form-type-number,
.webform-submission-downtime-calculator-form .js-webform-computed {
    margin-bottom: 32px
}

.webform-submission-downtime-calculator-form #edit-border {
    border: 1px solid;
    border-radius: 8px;
    padding: 24px;
    margin-right: 16px
}

.webform-submission-downtime-calculator-form #edit-border .js-webform-computed {
    margin: 0
}

.webform-submission-downtime-calculator-form .js-form-type-number label {
    font-size: 16px;
    font-weight: 700
}

.webform-submission-downtime-calculator-form .js-webform-computed {
    font-size: 16px;
    font-weight: 700
}

.webform-submission-downtime-calculator-form .js-webform-computed label {
    display: block;
    font-weight: 400;
    font-size: 16px
}

.webform-submission-downtime-calculator-form .js-webform-computed .form-item-total {
    font-size: 24px
}

.webform-submission-downtime-calculator-form .js-webform-computed .form-item-profit-loss {
    border-bottom: 1px solid;
    padding-bottom: 18px
}

.webform-submission-downtime-calculator-form .js-webform-computed .form-item-profit-loss label {
    font-weight: 700;
    font-size: 16px
}

.webform-submission-downtime-calculator-form .js-webform-computed .form-item-employee-pay-loss,
.webform-submission-downtime-calculator-form .js-webform-computed .form-item-profit-loss {
    margin-bottom: 12px
}

.webform-submission-downtime-calculator-form .webform-computed-loading {
    background-color: #fff
}

@media screen and (max-width: 767px) {

    .webform-submission-downtime-calculator-form #edit-employee-pay-loss-l,
    .webform-submission-downtime-calculator-form #edit-profit-loss-l {
        padding-right: 0
    }
}

.webform-submission-bon-de-commande-ecoflo-rewatec-q-form table[id^=edit-commande-canada-optional-2-items] thead,
.webform-submission-bon-de-commande-ecoflo-rewatec-q-form table[id^=edit-commande-optional-2-items] thead {
    display: none
}

.threesixty {
    background-repeat: no-repeat;
    background-position: top;
    background-color: #fff;
    background-size: contain
}

.threesixty.threesixty-teaser {
    width: inherit !important;
    height: inherit !important;
    overflow: hidden !important
}

.pt-text--xlarge {
    display: block;
    font-size: 5rem;
    line-height: 6.3rem;
    font-weight: 900;
    font-family: Axiforma
}

.style--xlarge {
    display: block;
    font-size: 5rem;
    line-height: 6.3rem;
    font-weight: 900;
    font-family: Axiforma
}

xlarge {
    display: block;
    font-size: 5rem;
    line-height: 6.3rem;
    font-weight: 900;
    font-family: Axiforma
}

.pt-text--h1 {
    display: block;
    font-size: 3.6rem;
    line-height: 6.3rem;
    font-weight: 900;
    font-family: Axiforma
}

.cke_editable .title.title--big,
.style--h1,
.wysiwyg .title.title--big {
    display: block;
    font-size: 3.6rem;
    line-height: 6.3rem;
    font-weight: 900;
    font-family: Axiforma
}

h1 {
    display: block;
    font-size: 3.6rem;
    line-height: 6.3rem;
    font-weight: 900;
    font-family: Axiforma
}

.pt-text--h2 {
    display: block;
    font-size: 3rem;
    line-height: 5rem;
    font-weight: 700;
    font-family: Axiforma
}

.cke_editable .title,
.style--h2,
.wysiwyg .title {
    display: block;
    font-size: 3rem;
    line-height: 5rem;
    font-weight: 700;
    font-family: Axiforma
}

h2 {
    display: block;
    font-size: 3rem;
    line-height: 5rem;
    font-weight: 700;
    font-family: Axiforma
}

.pt-text--h3 {
    display: block;
    font-size: 2.4rem;
    line-height: 4.3rem;
    font-weight: 700;
    font-family: Axiforma
}

.style--h3 {
    display: block;
    font-size: 2.4rem;
    line-height: 4.3rem;
    font-weight: 700;
    font-family: Axiforma
}

h3 {
    display: block;
    font-size: 2.4rem;
    line-height: 4.3rem;
    font-weight: 700;
    font-family: Axiforma
}

.pt-text--h4 {
    display: block;
    font-size: 2rem;
    line-height: 3.3rem;
    font-weight: 700;
    font-family: Axiforma
}

.style--h4 {
    display: block;
    font-size: 2rem;
    line-height: 3.3rem;
    font-weight: 700;
    font-family: Axiforma
}

h4 {
    display: block;
    font-size: 2rem;
    line-height: 3.3rem;
    font-weight: 700;
    font-family: Axiforma
}

.pt-text--normal {
    display: block;
    font-size: 1.8rem;
    line-height: 3rem;
    font-weight: 400;
    font-family: Axiforma
}

.style--normal {
    display: block;
    font-size: 1.8rem;
    line-height: 3rem;
    font-weight: 400;
    font-family: Axiforma
}

normal {
    display: block;
    font-size: 1.8rem;
    line-height: 3rem;
    font-weight: 400;
    font-family: Axiforma
}

.pt-text--small {
    display: block;
    font-size: 1.4rem;
    line-height: 2.8rem;
    font-weight: 400;
    font-family: Axiforma
}

.style--small {
    display: block;
    font-size: 1.4rem;
    line-height: 2.8rem;
    font-weight: 400;
    font-family: Axiforma
}

small {
    display: block;
    font-size: 1.4rem;
    line-height: 2.8rem;
    font-weight: 400;
    font-family: Axiforma
}

.pt-text--legal {
    display: block;
    font-size: 1.2rem;
    line-height: 1.8rem;
    font-weight: 400;
    font-family: Axiforma
}

.style--legal {
    display: block;
    font-size: 1.2rem;
    line-height: 1.8rem;
    font-weight: 400;
    font-family: Axiforma
}

legal {
    display: block;
    font-size: 1.2rem;
    line-height: 1.8rem;
    font-weight: 400;
    font-family: Axiforma
}

.pt-text--big-margin {
    margin-bottom: 5rem
}

.pt-text--small-margin {
    margin-bottom: 5rem
}

.pt-text--primary {
    color: #041e42
}

.pt-text--secondary {
    color: #41b6e6
}

.pt-text--tertiary {
    color: #54585a
}

.btn__upload--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__upload:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__upload--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__upload--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__upload:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__upload:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__upload--before:hover:after,
.btn__upload--before:hover:before,
.btn__upload:hover:after,
.btn__upload:hover:before {
    -webkit-mask-position: center, center 0
}

.btn__upload--before:before,
.btn__upload:after {
    position: relative;
    min-width: 20px;
    width: 20px;
    height: 30px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/upload-file-down.svg), url(/src/images/icons/upload-file-up.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/upload-file-down.svg), url(/src/images/icons/upload-file-up.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease
}

.btn__upload:after {
    content: "";
    margin-left: 10px
}

.btn__upload--before:before {
    content: "";
    margin-right: 10px
}

.btn__download--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.cke_editable .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.cke_editable .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.wysiwyg .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.wysiwyg .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__download--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__download--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.cke_editable .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.cke_editable .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.cke_editable .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.cke_editable .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.wysiwyg .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.wysiwyg .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.wysiwyg .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.wysiwyg .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__download--before:hover:after,
.btn__download--before:hover:before,
.btn__download:hover:after,
.btn__download:hover:before,
.cke_editable .link--download-outline:hover:after,
.cke_editable .link--download-outline:hover:before,
.cke_editable .link--download:hover:after,
.cke_editable .link--download:hover:before,
.wysiwyg .link--download-outline:hover:after,
.wysiwyg .link--download-outline:hover:before,
.wysiwyg .link--download:hover:after,
.wysiwyg .link--download:hover:before {
    -webkit-mask-position: center center, center 70%
}

.btn__download--before:before,
.btn__download:after,
.cke_editable .link--download-outline:before,
.cke_editable .link--download:after,
.wysiwyg .link--download-outline:before,
.wysiwyg .link--download:after {
    position: relative;
    min-width: 20px;
    width: 20px;
    height: 30px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/upload-file-down.svg), url(/src/images/icons/download-file-up.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/upload-file-down.svg), url(/src/images/icons/download-file-up.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease
}

.btn__download:after,
.cke_editable .link--download:after,
.wysiwyg .link--download:after {
    content: "";
    margin-left: 10px
}

.btn__download--before:before,
.cke_editable .link--download-outline:before,
.wysiwyg .link--download-outline:before {
    content: "";
    margin-right: 10px
}

.btn__video--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__video:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__video--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__video--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__video:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__video:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__video--before:hover:after,
.btn__video--before:hover:before,
.btn__video:hover:after,
.btn__video:hover:before {
    -webkit-mask-position: center, center
}

.btn__video--before:before,
.btn__video:after {
    position: relative;
    min-width: 20px;
    width: 20px;
    height: 30px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/play-circle.svg), url(/src/images/icons/play-icon.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/play-circle.svg), url(/src/images/icons/play-icon.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease
}

.btn__video:after {
    content: "";
    margin-left: 10px
}

.btn__video--before:before {
    content: "";
    margin-right: 10px
}

.btn__arrow--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__arrow:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__arrow--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__arrow--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__arrow:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__arrow:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__arrow--before:hover:after,
.btn__arrow--before:hover:before,
.btn__arrow:hover:after,
.btn__arrow:hover:before {
    transform: translateX(5px)
}

.btn__arrow--before:hover:before,
.btn__arrow:hover:before {
    transform: rotate(180deg) translateY(1px) translateX(5px)
}

.btn__arrow--before:before,
.btn__arrow:after {
    position: relative;
    min-width: 20px;
    width: 20px;
    height: 30px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/arrow-next-dark-blue.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/arrow-next-dark-blue.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease
}

.btn__arrow:after {
    content: "";
    margin-left: 10px
}

.btn__arrow--before:before {
    content: "";
    margin-right: 10px;
    transform: rotate(180deg) translateY(1px)
}

.btn__redirection--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__redirection:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__redirection--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__redirection--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__redirection:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__redirection:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__redirection--before:before,
.btn__redirection:after {
    position: relative;
    min-width: 20px;
    width: 20px;
    height: 30px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/redirection_icon.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/redirection_icon.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease
}

.btn__redirection:after {
    content: "";
    margin-left: 10px
}

.btn__redirection--before:before {
    content: "";
    margin-right: 10px
}

.btn__plus--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__plus:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__plus--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__plus--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__plus:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__plus:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__plus--before:before,
.btn__plus:after {
    position: relative;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/plus.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/plus.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;
    min-width: 12px;
    width: 12px;
    height: 12px
}

.btn__plus:after {
    content: "";
    margin-left: 10px
}

.btn__plus--before:before {
    content: "";
    margin-right: 10px
}

.btn__delete--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__delete:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__delete--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__delete--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__delete:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__delete:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__delete--before:before,
.btn__delete:after {
    position: relative;
    height: 30px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/trash.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/trash.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;
    min-width: 12px;
    width: 12px
}

.btn__delete:after {
    content: "";
    margin-left: 10px
}

.btn__delete--before:before {
    content: "";
    margin-right: 10px
}

.btn__x--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__x:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__x--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__x--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__x:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__x:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__x--before:before,
.btn__x:after {
    position: relative;
    min-width: 20px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/cross.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/cross.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;
    width: 20px;
    height: 30px
}

.btn__x:after {
    content: "";
    margin-left: 10px
}

.btn__x--before:before {
    content: "";
    margin-right: 10px
}

.btn__mail--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__mail:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__mail--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__mail--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__mail:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__mail:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__mail--before:before,
.btn__mail:after {
    position: relative;
    min-width: 20px;
    width: 20px;
    height: 30px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/enveloppe-icon.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/enveloppe-icon.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;
    mask-size: auto;
    -webkit-mask-size: auto;
    margin-right: 0 !important
}

.btn__mail:after {
    content: "";
    margin-left: 10px
}

.btn__mail--before:before {
    content: "";
    margin-right: 10px
}

.btn__phone--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__phone:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__phone--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__phone--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__phone:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__phone:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__phone--before:before,
.btn__phone:after {
    position: relative;
    min-width: 20px;
    width: 20px;
    height: 30px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/icon-telephone.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/icon-telephone.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;
    mask-size: auto;
    -webkit-mask-size: auto;
    margin-right: 0 !important
}

.btn__phone:after {
    content: "";
    margin-left: 10px
}

.btn__phone--before:before {
    content: "";
    margin-right: 10px
}

.btn__external-link--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),
.btn__external-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color)
}

.btn__external-link--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__external-link--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,
.btn__external-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,
.btn__external-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {
    background-color: var(--text-color)
}

.btn__external-link--before:before,
.btn__external-link:after {
    position: relative;
    min-width: 20px;
    width: 20px;
    height: 30px;
    mask-position: center center;
    mask-size: 100%;
    mask-repeat: no-repeat;
    /* mask-image: url(/src/images/icons/icon-external-link.svg); */
    -webkit-mask-position: center center;
    -webkit-mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    /* -webkit-mask-image: url(/src/images/icons/icon-external-link.svg); */
    background-color: var(--text-color);
    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;
    mask-size: auto;
    -webkit-mask-size: auto;
    margin-right: 0 !important
}

.btn__external-link:after {
    content: "";
    margin-left: 10px
}

.btn__external-link--before:before {
    content: "";
    margin-right: 10px
}

.pager {
    display: flex
}

.pager .pager__items {
    margin: auto
}

.pager .pager__items .disabled {
    opacity: .5;
    cursor: default;
    pointer-events: none
}

.pager .pager__items .pager__item--next,
.pager .pager__items .pager__item--previous {
    padding: 6px 25px;
    cursor: pointer;
    background-color: #f2f6f8;
    border-radius: 9px;
    display: inline
}

.pager .pager__items .pager__item--next a,
.pager .pager__items .pager__item--previous a {
    color: #041e42;
    font-weight: 700;
    font-size: 16px;
    vertical-align: middle
}

.pager .pager__items .pager__item--next a:hover,
.pager .pager__items .pager__item--previous a:hover {
    text-decoration: none
}

@media (max-width: 767.98px) {

    .pager .pager__items .pager__item--next a,
    .pager .pager__items .pager__item--previous a {
        padding: 7px
    }

    .pager .pager__items .pager__item--next a span,
    .pager .pager__items .pager__item--previous a span {
        display: none
    }

    .pager .pager__items .pager__item--next,
    .pager .pager__items .pager__item--previous {
        padding: 6px 0;
        border-radius: 6px
    }
}

.pager .pager__items .pager__item--previous:hover:before {
    right: 12px
}

@media (max-width: 767.98px) {
    .pager .pager__items .pager__item--previous:hover:before {
        right: 6px
    }
}

.pager .pager__items .pager__item--previous:before {
    transform: scaleX(-1);
    position: relative;
    top: 0;
    content: " ";
    display: inline-block;
    /* background-image: url(/src/images/icons/arrow-next-light-blue-old.svg); */
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 25px 25px;
    margin-left: 2px;
    width: 22px;
    height: 18px;
    transition: right .5s;
    right: 5px;
    vertical-align: middle
}

@media (max-width: 767.98px) {
    .pager .pager__items .pager__item--previous:before {
        height: 14px;
        background-size: 26px;
        top: 0;
        margin-right: 4px;
        right: -5px
    }
}

.pager .pager__items .pager__item--next:hover:after {
    left: 15px
}

@media (max-width: 767.98px) {
    .pager .pager__items .pager__item--next:hover:after {
        left: 6px
    }
}

.pager .pager__items .pager__item--next:after {
    position: relative;
    top: 0;
    content: " ";
    display: inline-block;
    /* background-image: url(/src/images/icons/arrow-next-light-blue-old.svg); */
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 25px 25px;
    margin-left: 2px;
    width: 22px;
    height: 18px;
    transition: left .5s;
    left: 8px;
    vertical-align: middle
}

@media (max-width: 767.98px) {
    .pager .pager__items .pager__item--next:after {
        height: 10px;
        background-size: 26px;
        top: 0;
        left: -5px
    }
}

.pager .pager__items .pager__item {
    position: relative;
    display: inline;
    list-style: none;
    background-color: #f2f6f8;
    padding: 6px 0
}

.pager .pager__items .pager__item a {
    position: relative;
    color: #041e42;
    font-weight: 700;
    font-size: 16px;
    padding: 4px 18px 4px 20px;
    vertical-align: middle
}

@media (max-width: 767.98px) {
    .pager .pager__items .pager__item a {
        padding: 10px 12px
    }
}

.pager .pager__items .pager__item:not(.selected) a:after {
    content: "";
    position: absolute;
    bottom: 0;
    width: 0;
    left: 15%;
    border-bottom: 4px solid #41b6e6;
    transition: width .3s
}

.pager .pager__items .pager__item:not(.selected) a:hover:after {
    width: 75%
}

.pager .pager__items .pager__item--first {
    border-radius: 9px
}

.pager .pager__items .pager__item--first span {
    color: #41b6e6
}

@media (max-width: 767.98px) {
    .pager .pager__items .pager__item--first {
        display: none
    }
}

.pager .pager__items .pager__item--first:not(.selected) a:hover:after {
    border-bottom: none
}

.pager .pager__items .pager__item--last {
    border-radius: 9px
}

.pager .pager__items .pager__item--last span {
    color: #41b6e6
}

@media (max-width: 767.98px) {
    .pager .pager__items .pager__item--last {
        display: none
    }
}

.pager .pager__items .pager__item--last:not(.selected) a:hover:after {
    border-bottom: none
}

.pager .pager__items .pager__item--ellipsis {
    padding: 6px 20px;
    margin-right: -4px
}

@media (max-width: 767.98px) {
    .pager .pager__items .pager__item--ellipsis {
        padding: 6px 7px
    }
}

.pager .pager__items li:nth-child(3) {
    border-radius: 9px 0 0 9px
}

.pager .pager__items li:nth-last-child(3) {
    border-radius: 0 9px 9px 0
}

.pager .pager__items li.is-active:nth-child(3),
.pager .pager__items li.is-active:nth-last-child(3) {
    border-radius: 7px
}

.pager .pager__items .is-active {
    background-color: #41b6e6;
    box-shadow: 0 3px 6px rgba(0, 0, 0, .1607843137);
    border-radius: 7px;
    pointer-events: none;
    padding: 6px 0;
    z-index: 1
}

@media (max-width: 767.98px) {
    .pager .pager__items .is-active {
        border-radius: 6px;
        padding: 7px 0 7px 2px
    }
}

.pager .pager__items .is-active a {
    color: #fff
}

.menu-dropdown-0 {
    flex-direction: column
}

.menu--footer-main-menu {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    font-size: 1.2rem;
    flex-wrap: wrap
}

.menu--footer-main-menu li.icon a {
    display: flex;
    align-items: center
}

.menu--footer-main-menu li.icon a::before {
    display: block;
    content: "";
    width: 1.2rem;
    height: 1.2rem;
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 5px
}

@media (max-width: 1199.98px) {
    .menu--footer-main-menu li.icon a::before {
        width: 1.6rem;
        height: 1.6rem
    }
}

#block-ptbase-child-main-menu>#block-footermainmenu {
    margin: 45px 0 0 15px;
    width: 80%;
    text-align: left;
    transition: .3s ease-in
}

#block-ptbase-child-main-menu>#block-footermainmenu.footer-main-menu--hidden {
    transform: translateX(-200px);
    position: relative;
    opacity: 0
}

@media (min-width: 992px) {
    #block-ptbase-child-main-menu>#block-footermainmenu {
        display: none
    }
}

#block-ptbase-child-main-menu>#block-footermainmenu .menu--footer-main-menu li {
    padding: 0;
    width: 50%;
    margin-bottom: 10px
}

#block-ptbase-child-main-menu>#block-footermainmenu .menu--footer-main-menu li a {
    color: #041e42;
    text-decoration: underline;
    font-size: 1.5rem
}

#block-ptbase-child-main-menu>#block-footermainmenu .footer_main_menu_title_mobile {
    font-weight: 700
}

.menu-dropdown-0 .footer-menu {
    margin-top: 25px;
    padding-left: 25px;
    color: #041e42;
    display: flex;
    background-color: #f2f6f8;
    align-items: center;
    min-height: 40px
}

@media (max-width: 1199.98px) {
    .menu-dropdown-0 .footer-menu {
        display: none
    }
}

.menu-dropdown-0 .footer-menu p {
    margin: 0;
    color: #54585a;
    font-size: 1.25rem
}

.menu-dropdown-0 .footer-menu .menu--footer-main-menu li {
    padding: 0 15px
}

.menu-dropdown-0 .footer-menu .menu--footer-main-menu li:not(:first-of-type) {
    border-left: solid 2px #c7cfd7
}

.menu-dropdown-0 .footer-menu .menu--footer-main-menu li a {
    color: #041e42;
    text-decoration: underline
}

.menu-dropdown-0 .footer-menu .footer_main_menu_text {
    display: none
}

.striped-table {
    margin-bottom: 2rem
}

.striped-table tr:nth-child(even) {
    background-color: #f2f2f2
}

.drupal-media--slideshow {
    position: relative
}

.drupal-media--slideshow .drupal-media__name {
    position: absolute;
    left: 40px;
    bottom: 61px;
    color: #fff;
    font-weight: 400;
    font-size: 1.4rem;
    text-shadow: 0 1px 3px #000;
    letter-spacing: .7px
}

.drupal-media--full-width img {
    width: 100%;
    height: auto
}

.drupal-media .drupal-media__image--full-width img {
    width: 100%;
    height: auto
}

#layout-builder-modal details article .badge-list__image {
    max-width: 100px
}

#layout-builder-modal details article .badge-list__image .media__image img {
    height: 100px
}

#layout-builder-modal details article .badge-list__text-block {
    max-width: 175px
}

#layout-builder-modal details article .badge-list__text-block .badge-list__title {
    font-size: 1.6rem;
    margin-top: 10px
}

.article-category {
    color: #41b6e6;
    font-weight: 500;
    font-size: 1.8rem;
    line-height: 1.55em
}

.article-category a:hover {
    text-decoration: none;
    color: #41b6e6
}

.article-category:before {
    content: "- "
}

.article-short-summary .article-date {
    font-size: 1.4rem;
    --text-color: #8A8D8F
}

.article-up-date:before {
    content: "-";
    display: inline-block;
    margin: 0 4px 0 1px
}

.layout-article .article-date {
    --text-color: #8A8D8F
}

.layout-article .node-title {
    font-weight: 700;
    font-size: 4rem;
    line-height: 1.2em;
    margin-bottom: 0
}

.layout-article img {
    width: 100%;
    height: auto
}

.layout-article .photo-credit {
    color: #54585a
}

.checklist--container {
    list-style: none;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #efefef;
    padding: 0
}

.checklist--items:not(:last-of-type) {
    border-bottom: 1px solid #efefef
}

.checklist--items:first-of-type {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px
}

.checklist--items:last-of-type {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px
}

.checklist--items p {
    margin: 0
}

.checklist--items .checklist--text {
    color: #4b4b4b;
    padding: 10px 0;
    margin: 0
}

@media (max-width: 575.98px) {
    .checklist--items .checklist--text {
        padding: 10px
    }
}

.checklist--items .checklist-row {
    flex-wrap: unset;
    width: 100%;
    margin: 0
}

.checklist-col {
    display: flex;
    flex-direction: column;
    justify-content: center
}

.checklist--icon.checkmark {
    display: block;
    width: 15px;
    height: 15px;
    /* background: url(/src/images/icons/check-checklist.svg); */
    background-repeat: no-repeat;
    margin: 0 auto
}

.checklist--icon.x {
    display: block;
    width: 12px;
    height: 12px;
    /* background: url(/src/images/icons/x-black-checklist.svg); */
    background-repeat: no-repeat;
    margin: 15px auto
}

.checklist--icon.none {
    display: block;
    width: 12px;
    height: 12px;
    background-repeat: no-repeat;
    margin: 15px auto
}

.media-wistia .video-embed-field-provider-wistia-video:after {
    padding-bottom: 0
}

.node-title {
    font-weight: 700;
    font-size: 4rem;
    line-height: 1.2em;
    margin-bottom: 0
}

.layout__region--content .node-title {
    font-size: 5.4rem;
    line-height: 6.3rem
}

@media (max-width: 767.98px) {
    .layout__region--content .node-title {
        font-size: 3.6rem;
        line-height: 4.5rem
    }
}

.breadcrumb {
    flex-wrap: unset;
    font-family: Axiforma
}

.layout__black .breadcrumb,
.layout__blue .breadcrumb,
.layout__dark_grey .breadcrumb,
.layout__light_blue .breadcrumb {
    color: #fff
}

.breadcrumb-item {
    font-weight: 400;
    font-size: 1.8rem
}

.layout__black .breadcrumb-item,
.layout__blue .breadcrumb-item,
.layout__dark_grey .breadcrumb-item,
.layout__light_blue .breadcrumb-item {
    color: #fff
}

.breadcrumb-item .breadcrumb-link {
    color: inherit;
    position: relative
}

.breadcrumb-item .breadcrumb-link:after {
    content: "";
    display: inline-block;
    position: absolute;
    height: 2px;
    width: 0;
    background: var(--color-light-blue);
    bottom: -2px;
    left: 0;
    transition: width .3s ease
}

.breadcrumb-item .breadcrumb-link:hover:after {
    width: 100%
}

.breadcrumb-item:last-child {
    font-weight: 400
}

.breadcrumb-item+.breadcrumb-item::before {
    color: #54585a;
    padding-right: .6rem;
    padding-left: .6rem
}

.layout__black .breadcrumb-item+.breadcrumb-item::before,
.layout__blue .breadcrumb-item+.breadcrumb-item::before,
.layout__dark_grey .breadcrumb-item+.breadcrumb-item::before,
.layout__light_blue .breadcrumb-item+.breadcrumb-item::before {
    color: #fff
}

.breadcrumb-items {
    display: inherit;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar
}

.breadcrumb-items::-webkit-scrollbar {
    display: none
}

.breadcrumb-back {
    padding-right: 1rem;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 3px
}

.breadcrumb-back svg {
    width: 8px;
    height: 8px
}

.breadcrumb-back svg path {
    stroke: #54585a;
    stroke-width: 2px
}

.layout__black .breadcrumb-back svg path,
.layout__blue .breadcrumb-back svg path,
.layout__dark_grey .breadcrumb-back svg path,
.layout__light_blue .breadcrumb-back svg path {
    stroke: #fff;
    fill: #fff;
    stroke-width: 2px
}

.product-breadcrumb {
    margin-left: 20px
}

@media (max-width: 575.98px) {
    .product-breadcrumb {
        margin-left: 10px
    }
    .product-breadcrumb .breadcrumb-back::after {
        content: "";
        width: 10vw;
        height: 100%;
        position: absolute;
        left: 16px;
        top: 0;
        background: linear-gradient(to left, rgba(255, 255, 255, 0), #fff)
    }
}

.product-breadcrumb .breadcrumb-back svg path {
    stroke: #54585a;
    stroke-width: 3px
}

.product-breadcrumb .breadcrumb-back.no-gradient::after {
    width: 0
}

.product-breadcrumb .breadcrumb-item,
.product-breadcrumb .breadcrumb-link {
    color: #54585a
}

.layout__black .product-breadcrumb .breadcrumb-item,
.layout__black .product-breadcrumb .breadcrumb-link,
.layout__blue .product-breadcrumb .breadcrumb-item,
.layout__blue .product-breadcrumb .breadcrumb-link,
.layout__dark_grey .product-breadcrumb .breadcrumb-item,
.layout__dark_grey .product-breadcrumb .breadcrumb-link,
.layout__light_blue .product-breadcrumb .breadcrumb-item,
.layout__light_blue .product-breadcrumb .breadcrumb-link {
    color: #fff
}

.listing-breadcrumb {
    --text-color: #54585A
}

.listing-breadcrumb .breadcrumb-back svg path {
    stroke: #54585a;
    fill: #54585a;
    stroke-width: 2px
}

.horizontal_link_menu {
    background-color: #fff;
    z-index: 1;
    height: -moz-fit-content;
    height: fit-content;
    width: 100%;
    position: relative
}

.horizontal_link_menu__veil {
    position: absolute;
    right: 0;
    pointer-events: none;
    height: 100%;
    transition: opacity .3s ease;
    background-image: linear-gradient(to right, transparent, #fff)
}

@media (min-width: 992px) {
    .horizontal_link_menu__veil--show {
        opacity: 0
    }
}

@media (max-width: 1199.98px) {
    .horizontal_link_menu__veil--show {
        display: inline-block;
        width: 27.5%
    }
}

@media (min-width: 768px) {
    .horizontal_link_menu__veil--show {
        width: 15%
    }
}

@media (min-width: 576px) {
    .horizontal_link_menu__veil--show {
        width: 20%
    }
}

.horizontal_link_menu__veil--hide {
    display: none
}

.horizontal_link_menu__overlay {
    width: 100%;
    background-color: inherit
}

.horizontal_link_menu__title h1,
.horizontal_link_menu__title h2,
.horizontal_link_menu__title h3,
.horizontal_link_menu__title h4 {
    background-color: inherit;
    margin: 0 15px 0 15px;
    padding-bottom: 10px
}

.horizontal_link_menu--sticky {
    position: fixed;
    width: 100%;
    z-index: 11;
    top: 0
}

.horizontal_link_menu--margin {
    margin-right: 0;
    margin-left: 0
}

.horizontal_link_menu__image {
    display: inline-block;
    max-width: 200px
}

@media (max-width: 991.98px) {
    .horizontal_link_menu__image {
        max-width: 120px
    }
}

.horizontal_link_menu .horizontal_link_menu_nav {
    pointer-events: auto;
    height: -moz-fit-content;
    height: fit-content;
    display: flex;
    scroll-behavior: smooth;
    align-items: center;
    overflow-x: auto;
    flex-direction: row;
    flex: 1 1 auto;
    text-align: center;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar
}

@media (max-width: 1199.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav {
        flex: 0 0 20%
    }
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav {
        flex: 0 0 30%;
        justify-content: left;
        overflow: auto;
        flex-flow: nowrap
    }
}

.horizontal_link_menu .horizontal_link_menu_nav::-webkit-scrollbar {
    display: none
}

.horizontal_link_menu .horizontal_link_menu_nav__item {
    display: inline-block;
    white-space: nowrap
}

.horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn) {
    color: inherit;
    font-size: inherit;
    margin: 0 10px;
    padding: 8px 10px;
    text-decoration: none;
    border-bottom: 2px solid transparent
}

@media (max-width: 1199.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn) {
        padding: 8px 0
    }
}

.horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn):hover {
    cursor: pointer;
    border-bottom: 2px solid #fff;
    text-decoration: none
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn):hover {
        border-bottom: 2px solid transparent
    }
}

.horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn):active {
    cursor: pointer;
    text-decoration: none
}

.horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn):focus {
    outline: unset;
    text-decoration: none
}

.horizontal_link_menu .horizontal_link_menu_nav__item--borderize:not(.btn) {
    border-bottom: 2px solid #fff !important
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav__item:not(.horizontal_link_menu_nav__item--borderize) {
        border-bottom: 2px solid transparent
    }
}

.horizontal_link_menu .horizontal_link_menu_nav--justify-content-center {
    justify-content: center
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav--justify-content-center {
        justify-content: left;
        overflow: auto;
        flex-flow: nowrap
    }
}

.horizontal_link_menu .horizontal_link_menu_nav--justify-content-end {
    justify-content: flex-end
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav--justify-content-end {
        justify-content: left;
        overflow: auto;
        flex-flow: nowrap
    }
}

.horizontal_link_menu .horizontal_link_menu_nav--justify-content-start {
    justify-content: flex-start
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav--justify-content-start {
        justify-content: left;
        overflow: auto;
        flex-flow: nowrap
    }
}

.horizontal_link_menu .horizontal_link_menu_nav--justify-content-around {
    justify-content: space-around
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav--justify-content-around {
        justify-content: left;
        overflow: auto;
        flex-flow: nowrap
    }
}

.horizontal_link_menu .horizontal_link_menu_nav--justify-content-between {
    justify-content: space-between
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav--justify-content-between {
        justify-content: left;
        overflow: auto;
        flex-flow: nowrap
    }
}

.horizontal_link_menu .horizontal_link_menu_nav--size_x_small {
    font-size: .8rem
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav--size_x_small {
        font-size: .5rem
    }
}

.horizontal_link_menu .horizontal_link_menu_nav--size_small {
    font-size: 1.2rem
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav--size_small {
        font-size: .8rem
    }
}

.horizontal_link_menu .horizontal_link_menu_nav--size_normal {
    font-size: 1.6rem
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav--size_normal {
        font-size: 1.2rem
    }
}

.horizontal_link_menu .horizontal_link_menu_nav--size_large {
    font-size: 2rem
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav--size_large {
        font-size: 1.6rem
    }
}

.horizontal_link_menu .horizontal_link_menu_nav--size_x_large {
    font-size: 2.4rem
}

@media (max-width: 991.98px) {
    .horizontal_link_menu .horizontal_link_menu_nav--size_x_large {
        font-size: 1.8rem
    }
}

.region--banner-top {
    background-color: #dedfe2;
    display: none;
    height: 35px;
    position: fixed;
    transition: top .3s linear;
    top: 60px;
    width: 100%;
    z-index: 50
}

.region--banner-top--hidden {
    top: -60px
}

.region--banner-top--with-header-bar {
    top: 60px
}

@media (min-width: 1200px) {
    .region--banner-top--with-header-bar {
        top: 96px
    }
}

.region--banner-top--with-header-bar.region--banner-top--hidden {
    top: -96px
}

.region--banner-top .banner-top-content {
    --text-color: #555;
    text-align: center
}

.region--banner-top .banner-top-content p {
    font-size: 1.3rem;
    line-height: 1.7rem;
    margin: 0
}

.region--banner-top .banner-top-close-button {
    align-items: center;
    display: flex;
    justify-content: center;
    position: absolute;
    right: 0;
    margin-right: 2.4rem;
    cursor: pointer
}

.region--banner-top .banner-top-close-button:hover {
    opacity: .75
}

.region--banner-top .banner-top-close-button svg {
    height: 10px;
    width: 10px
}

@media (max-width: 767.98px) {
    .region--banner-top .banner-top-close-button svg {
        width: 12px;
        height: 12px
    }
}

.toolbar-horizontal.toolbar-tray-open .region--banner-top--with-header-bar {
    top: 139px
}

@media (min-width: 992px) {
    .toolbar-horizontal.toolbar-tray-open .region--banner-top--with-header-bar {
        top: 174px
    }
}

.toolbar-horizontal.toolbar-tray-open .region--banner-top--with-header-bar.region--banner-top--hidden {
    top: -96px
}

.region.region--banner-top.banner-top-enabled {
    align-items: center;
    display: flex;
    justify-content: center
}

@media (max-width: 1199.98px) {
    .hamburger-menu {
        height: 100dvh;
        position: fixed;
        max-width: 500px;
        width: calc(100% - 30px);
        background-color: #fff;
        box-shadow: 0 1px 9px rgba(0, 0, 0, .1607843137);
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
        z-index: 1200;
        top: 60px;
        right: 0;
        bottom: 0;
        padding-top: 13px;
        transition: transform .3s ease;
        transform: translateX(100%);
        color: #04325e;
        font-size: 1.6rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start
    }
}

@media (max-width: 1199.98px) and (min-width:1200px) {
    .hamburger-menu {
        top: 0 !important;
        overflow-x: auto;
        z-index: 90
    }
}

@media (max-width: 1199.98px) {
    .hamburger-menu--open {
        transform: translateX(0)
    }

    .hamburger-menu__close {
        display: none;
        text-align: right;
        color: #41b6e6;
        padding: 30px 50px
    }
}

@media (max-width: 1199.98px) and (min-width:1200px) {
    .hamburger-menu__close {
        display: block
    }
}

@media (max-width: 1199.98px) {
    .hamburger-menu__close .js-hamburger-close {
        cursor: pointer;
        line-height: 18px;
        vertical-align: middle
    }

    .hamburger-menu__close .js-hamburger-close .x-icon {
        width: 16px;
        height: 16px;
        transition: transform .3s ease;
        margin-left: 5px;
        display: inline-block
    }

    .hamburger-menu__close .js-hamburger-close:hover .x-icon {
        transform: scale(.8)
    }

    .hamburger-menu.scroll-up {
        top: 49px
    }

    .hamburger-menu .views-exposed-form {
        margin: 14px 0 19px;
        padding: 0 15px
    }
}

@media (max-width: 1199.98px) and (min-width:992px) {
    .hamburger-menu .views-exposed-form {
        margin-top: 51px
    }
}

@media (max-width: 1199.98px) and (min-width:1200px) {
    .hamburger-menu .views-exposed-form {
        margin-top: 14px
    }
}

@media (max-width: 1199.98px) {
    .hamburger-menu .views-exposed-form .exposed-search {
        height: 35px
    }

    .hamburger-menu .views-exposed-form .form-item {
        flex-grow: 1
    }

    .hamburger-menu .views-exposed-form .form-text {
        background-color: #f2f6f8;
        height: 35px;
        width: 100%
    }

    .hamburger-menu .hamburger-menu,
    .hamburger-menu .main-navigation-menu {
        margin-bottom: 45px
    }

    .hamburger-menu .hamburger-menu+.hamburger-menu,
    .hamburger-menu .main-navigation-menu+.hamburger-menu {
        margin-bottom: 45px;
        margin-top: -45px
    }

    .hamburger-menu .hamburger-menu .menu-item,
    .hamburger-menu .main-navigation-menu .menu-item {
        padding: 0 15px
    }

    .hamburger-menu .hamburger-menu .menu-item.menu-level-0__item .menu-level-0__link.font-weight-bold,
    .hamburger-menu .main-navigation-menu .menu-item.menu-level-0__item .menu-level-0__link.font-weight-bold {
        font-weight: 700 !important
    }

    .hamburger-menu .hamburger-menu .menu-item.menu-level-0__item.menu-item--dropdown button,
    .hamburger-menu .main-navigation-menu .menu-item.menu-level-0__item.menu-item--dropdown button {
        display: flex;
        align-items: center
    }

    .hamburger-menu .hamburger-menu .menu-item.menu-level-0__item.menu-item--dropdown a,
    .hamburger-menu .main-navigation-menu .menu-item.menu-level-0__item.menu-item--dropdown a {
        display: flex;
        align-items: center
    }

    .hamburger-menu .hamburger-menu .menu-level-1__item,
    .hamburger-menu .main-navigation-menu .menu-level-1__item {
        padding-left: 0
    }

    .hamburger-menu .hamburger-menu .menu-level-1__item:not(:first-of-type) .d-flex>:not(.d-none),
    .hamburger-menu .main-navigation-menu .menu-level-1__item:not(:first-of-type) .d-flex>:not(.d-none) {
        margin-top: 57px
    }

    .hamburger-menu .hamburger-menu .menu-level-1__item.menu-level-2__item,
    .hamburger-menu .main-navigation-menu .menu-level-1__item.menu-level-2__item {
        padding-right: 0
    }

    .hamburger-menu .hamburger-menu .menu-level-1__item.menu-level-2__item .menu-level-2__link:not(.btn),
    .hamburger-menu .main-navigation-menu .menu-level-1__item.menu-level-2__item .menu-level-2__link:not(.btn) {
        border-bottom: none
    }

    .hamburger-menu .hamburger-menu .menu-level-1__item.menu-level-2__item .menu-level-2__link.font-weight-bold,
    .hamburger-menu .main-navigation-menu .menu-level-1__item.menu-level-2__item .menu-level-2__link.font-weight-bold {
        font-weight: 700 !important
    }

    .hamburger-menu .hamburger-menu .menu-level-1__item a.btn,
    .hamburger-menu .main-navigation-menu .menu-level-1__item a.btn {
        background-color: #041e42;
        margin-left: 15px;
        margin-bottom: 20px
    }

    .hamburger-menu .hamburger-menu .menu-level-1__item a.btn:hover,
    .hamburger-menu .main-navigation-menu .menu-level-1__item a.btn:hover {
        background-color: #041e42
    }

    .hamburger-menu .hamburger-menu--main,
    .hamburger-menu .main-navigation-menu--main {
        display: none
    }
}

@media (max-width: 1199.98px) and (max-width:1199.98px) {

    .hamburger-menu .hamburger-menu--main,
    .hamburger-menu .main-navigation-menu--main {
        display: block
    }
}

@media (max-width: 1199.98px) {
    .hamburger-menu--main {
        display: none
    }
}

@media (max-width: 1199.98px) and (max-width:1199.98px) {
    .hamburger-menu--main {
        display: block
    }
}

@media (max-width: 1199.98px) {
    .hamburger-menu--main .menu-item a.menu--btn-full-width {
        margin-left: 0;
        display: block;
        color: #04325e;
        padding: 20px;
        transition: color .3s ease;
        border-radius: 0;
        text-align: left;
        text-transform: none
    }
}

@media (max-width: 1199.98px) and (min-width:1200px) {
    .hamburger-menu--main .menu-item a.menu--btn-full-width:hover {
        color: #41b6e6;
        text-decoration: none
    }
}

@media (max-width: 1199.98px) {
    .hamburger-menu--main .menu-item a.menu--btn-full-width .hidden-parent .menu-level-2 .menu-item {
        margin-left: 0
    }

    .hamburger-menu--main--hamburger .menu:not(.menu-level-0) li {
        margin-left: 15px
    }

    .hamburger-menu .login-menu {
        margin: 35px 0
    }

    .hamburger-menu .login-menu .menu--login-menu {
        flex-direction: column
    }

    .hamburger-menu .login-menu .menu--login-menu .menu-item {
        margin-bottom: 15px;
        margin-right: 0
    }

    .hamburger-menu .login-menu .menu--login-menu .menu-item a {
        border-bottom: 0;
        font-size: 1.8rem
    }

    .hamburger-menu .login-menu .menu--login-menu .menu-item a::before {
        height: 20px;
        width: 20px
    }
}

@media (max-width: 1199.98px) and (max-width:1199.98px) {
    .hamburger-menu .hidden-parent div:first-child {
        display: block
    }

    .hamburger-menu .hidden-parent .menu-type-image_text_button:first-child {
        display: none
    }

    .hamburger-menu .hidden-parent li {
        margin-left: 0
    }

    .hamburger-menu .menu-item--image-text-button {
        display: none
    }

    .hamburger-menu .menu-level-0__link.btn {
        display: none
    }
}

@media (max-width: 1199.98px) {
    .hamburger-menu .submenu-container {
        background-color: #fff;
        height: calc(100% - 53px);
        left: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        position: absolute;
        top: 0;
        transition: left .3s ease-in;
        width: 100%;
        z-index: 1
    }

    .hamburger-menu .submenu-container--level-2 {
        height: 100%;
        position: fixed
    }

    .hamburger-menu .submenu-container--visible {
        left: 0
    }

    .hamburger-menu .submenu-container--level-1 {
        position: initial
    }

    .hamburger-menu .submenu-container__title {
        background-color: transparent;
        border: 0;
        color: #041e42;
        font-size: 1.7rem;
        font-weight: 700;
        margin: 26px 0 10px 1.7rem;
        outline: 0;
        padding: 0
    }

    .hamburger-menu .submenu-container__title::before {
        /* background: url(/src/images/icons/chevron-down-dark-blue.svg) no-repeat center center/cover; */
        content: "";
        display: inline-block;
        height: 9px;
        transform: rotate(90deg);
        width: 12px;
        margin-right: 5px
    }

    .hamburger-menu .submenu-container__title span {
        margin-left: 1.59rem
    }

    .hamburger-menu .submenu-container__title--level-1 {
        display: none
    }

    .hamburger-menu .submenu-container .collapse:not(.show) {
        display: block
    }

    .hamburger-menu .menu-level-3 {
        height: 100dvh
    }
}

body.hamburger-opened {
    overflow: hidden
}

@media (min-width: 1200px) {
    body.hamburger-opened {
        padding-right: 17px
    }
}

@media (max-width: 1199.98px) {
    body.toolbar-horizontal.toolbar-fixed .hamburger-menu {
        top: 39px;
        height: calc(100vh - 39px)
    }

    body.toolbar-horizontal.toolbar-fixed.toolbar-tray-open .hamburger-menu {
        top: 79px;
        height: calc(100vh - 79px)
    }

    body.toolbar-horizontal.toolbar-fixed.toolbar-tray-open .hamburger-menu .views-exposed-form {
        margin-top: 71px
    }
}

@media (max-width: 1199.98px) and (min-width:992px) {
    body.toolbar-horizontal.toolbar-fixed.toolbar-tray-open .hamburger-menu .views-exposed-form {
        margin-top: 107px
    }
}

.hamburger-icon {
    width: 19px;
    height: 17px;
    /* background: url(/src/images/icons/burger-pt-blue.svg) no-repeat center/contain; */
    cursor: pointer;
    align-self: center;
    z-index: 1
}

@media (min-width: 1200px) {
    .hamburger-icon {
        display: none;
        width: 20px;
        height: 15px;
        flex: 0 0 20px
    }
}

/* 
.hamburger-icon--open {
    background-image: url(/src/images/icons/x-dark-blue.svg)
} */

.region--primary-menu .menu-level-2 .submenu-container--visible .menu-dropdown-2 {
    left: 0;
    opacity: 1
}

.main-navigation-menu .menu-level-1__item.menu-link:not(.btn) {
    border-top: 0;
    border-right: 0;
    border-left: 0;
    cursor: default;
    border-bottom: 1px solid #d2d2d2;
    color: #041e42;
    text-align: left;
    font-size: 1.58rem;
    padding: 10px 0;
    transition: color .3s ease
}

@media (min-width: 992px) {
    .main-navigation-menu .menu-level-1__item.menu-link:not(.btn) {
        display: block
    }
}

.main-navigation-menu .menu-level-1__item.menu-link:not(.btn).menu-level-0__link {
    font-size: 1.81rem
}

.main-navigation-menu .menu-level-1__item.menu-link:not(.btn).menu-level-3__link {
    border-bottom: 0
}

.main-navigation-menu .menu-level-1__item.menu-link:not(.btn).is-active {
    font-weight: 700
}

@media (max-width: 1199.98px) {
    .menu__chevron-link {
        position: relative
    }

    .menu__chevron-link .menu__chevron {
        /* background: url(/src/images/icons/chevron-down-dark-blue.svg) no-repeat center center/cover; */
        height: 13px;
        transform: rotate(-90deg);
        width: 13px
    }

    .menu .menu-level-0__chevron-link,
    .menu .menu-level-2__chevron-link {
        align-items: center;
        background-color: transparent;
        display: flex;
        outline: 0;
        padding-left: 0;
        padding-right: 2.1rem
    }

    .menu-level-1__chevron-link {
        display: none
    }

    .menu-level-1 {
        padding-left: 4.5rem
    }

    .menu-level-1__item {
        background-color: #fff
    }

    .menu-level-3 {
        padding-left: 45px
    }
}

body.simplelogin {
    background-color: #041e42;
    font-family: Axiforma
}

body.simplelogin .simplelogin-logo img {
    background-color: #041e42
}

body.simplelogin .simplesamlphp-auth-login-link {
    display: block;
    text-align: center;
    text-transform: uppercase;
    font-size: 16px;
    height: 35px;
    padding-top: 6px;
    transition: font .3s ease
}

body.simplelogin .simplesamlphp-auth-login-link:hover {
    font-size: 17px;
    color: #041e42
}

body.simplelogin .simplelogin .link:focus,
body.simplelogin .simplelogin .link:hover,
body.simplelogin .simplelogin-form button.form-submit,
body.simplelogin .simplelogin-form input.form-submit,
body.simplelogin .simplelogin-form input.form-submit:active,
body.simplelogin .simplelogin-form input.form-submit:focus,
body.simplelogin .simplelogin-form input.form-submit:hover {
    background-color: #041e42
}

body.simplelogin a {
    color: #041e42
}

.third-row {
    margin: 32px auto 16px auto
}

.third-row .third-left {
    display: flex;
    justify-content: center;
    align-items: start;
    flex-direction: column
}

html {
    font-size: calc(8px + (10 - 8) * (100vw - 320px)/ (576 - 320))
}

@media (min-width: 576px) {
    html {
        font-size: calc(8px + (10 - 8) * (100vw - 576px)/ (992 - 576))
    }
}

@media (min-width: 992px) {
    html {
        font-size: calc(8px + (10 - 8) * (100vw - 992px)/ (1600 - 992))
    }
}

@media screen and (min-width: 1600px) {
    html {
        font-size: 10px
    }
}

body.language_vi * {
    font-family: "Be Vietnam Pro", sans-serif !important
}

.brands__title {
    color: #fff
}

.brands-grid {
    position: relative;
    margin: auto
}

.brands-grid__image {
    min-height: 7em;
    display: flex;
    align-items: center;
    justify-content: center
}

.brands-grid__image img {
    filter: grayscale(100%);
    max-width: 80%;
    height: auto;
    display: block;
    margin: 0 auto
}

.brands-grid__image img:hover {
    filter: grayscale(0);
    transition: all .5s ease
}

.brands-grid__link {
    height: 3em
}

.brands-grid__link div {
    display: inline;
    white-space: nowrap
}

.brands-grid__wrapper {
    height: 8em
}

.brands-grid__wrapper:hover {
    text-decoration: none
}

.brands-grid__wrapper:hover .brands-grid__link {
    opacity: 1;
    transition: all .5s ease;
    text-decoration: none;
    width: 100%;
    text-align: center
}

.brands-grid__link {
    color: #41b6e6;
    font-weight: 600;
    opacity: 0;
    text-align: center
}

.other-categories ul {
    display: flex;
    padding-left: 0
}

.other-categories ul li {
    list-style-type: none
}

.other-categories ul li a {
    font-size: 1.8rem;
    line-height: 1.56em;
    color: #41b6e6
}

.other-categories ul li a:hover {
    text-decoration: underline
}

@media (min-width: 1200px) {
    .ptsa-our-customer .slick--optionset--carousel-arrows-dotless-unlimite .carousel-media__container {
        width: 150px
    }
}

.industries .layout__background {
    background-size: contain;
    background-position: right center
}

.industries-list--group+.industries-list--group {
    border-top: 1px solid #8a8d8f;
    padding-top: 3.2rem
}

@media (min-width: 992px) {
    .industries-list--group+.industries-list--group {
        padding-top: 2rem
    }
}

.industries-list--title {
    color: #041e42;
    margin-bottom: 2rem
}

.industries-list--link {
    color: #41b6e6;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block
}

.industries-list--link:hover {
    color: #41b6e6
}

@media (min-width: 992px) {
    .industries-list--link {
        font-size: 1.8rem
    }
}

.industries-list--link-other {
    color: #41b6e6;
    font-size: 1.4rem
}

.industries-list--link-other:hover {
    color: #41b6e6
}

@media (min-width: 992px) {
    .industries-list--link-other {
        font-size: 1.8rem
    }
}

.industries-list--title-other {
    color: #041e42;
    font-size: 1.8rem;
    font-weight: 700
}

@media (min-width: 992px) {
    .industries-list--title-other {
        font-size: 2.2rem
    }
}

.engineering-product-card,
.product-card {
    --color-tag: #041E42
}

.engineering-product-card__content,
.product-card__content {
    margin-bottom: 0;
    position: relative;
    background-color: #fff;
    padding: 24px 34px
}

.engineering-product-card__content a,
.product-card__content a {
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 2;
    transition: box-shadow .5s ease
}

.engineering-product-card__content a:after,
.product-card__content a:after {
    content: " ";
    position: absolute;
    right: -25px;
    top: 50%;
    display: block;
    width: 50px;
    height: 50px;
    background-color: #41b6e6;
    border-radius: 50%;
    z-index: 3;
    opacity: 0;
    pointer-events: none;
    /* background-image: url(/src/images/icons/arrow-next-white.svg); */
    background-size: 18px;
    background-repeat: no-repeat;
    background-position: center;
    transform: translate(-5px, -50%);
    transition: opacity .3s ease, transform .3s ease
}

.engineering-product-card__content a:hover,
.product-card__content a:hover {
    box-shadow: 0 3px 6px rgba(0, 0, 0, .1607843137)
}

@media (min-width: 992px) {

    .engineering-product-card__content a:hover:after,
    .product-card__content a:hover:after {
        opacity: 1;
        transform: translate(0, -50%)
    }
}

.engineering-product-card__content>div,
.product-card__content>div {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%
}

.engineering-product-card__content h2,
.product-card__content h2 {
    order: 1
}

.engineering-product-card__content__title,
.product-card__content__title {
    order: 2;
    padding-top: 8px;
    position: relative;
    z-index: 1
}

.engineering-product-card__content__title p,
.product-card__content__title p {
    max-width: 80%
}

@media (min-width: 992px) {

    .engineering-product-card__content__title p,
    .product-card__content__title p {
        max-width: 50%
    }
}

.engineering-product-card__content__overview,
.product-card__content__overview {
    position: relative;
    z-index: 1;
    order: 4;
    max-width: 100%;
    padding-bottom: 15px
}

.engineering-product-card__content__overview p,
.product-card__content__overview p {
    font-size: 1.4rem;
    line-height: 1.25em
}

@media (min-width: 992px) {

    .engineering-product-card__content__overview p,
    .product-card__content__overview p {
        font-size: 1.9rem
    }
}

.engineering-product-card__content__overview ul,
.product-card__content__overview ul {
    padding-left: 15px
}

.engineering-product-card__content__overview ul li,
.product-card__content__overview ul li {
    font-size: 1.6rem;
    line-height: 1.25em;
    margin-bottom: 12px
}

.engineering-product-card__content__rate,
.product-card__content__rate {
    position: relative;
    order: 5;
    bottom: 0;
    left: 0;
    width: -moz-max-content;
    width: max-content;
    background-color: #041e42;
    --text-color: #FFFFFF;
    padding: 0 11px
}

.engineering-product-card__content__picture,
.product-card__content__picture {
    position: relative;
    order: 3;
    height: auto;
    padding-bottom: 30px
}

.engineering-product-card__content__picture article,
.engineering-product-card__content__picture div,
.engineering-product-card__content__picture img,
.product-card__content__picture article,
.product-card__content__picture div,
.product-card__content__picture img {
    width: 100%;
    height: 100%;
    text-align: right
}

@media (min-width: 992px) {

    .engineering-product-card__content__picture,
    .product-card__content__picture {
        padding-bottom: 0
    }

    .engineering-product-card__content__picture .drupal-media__image>img,
    .product-card__content__picture .drupal-media__image>img {
        width: auto;
        height: 100%
    }

    .engineering-product-card__content__picture .drupal-media .drupal-media__image--full-width img,
    .product-card__content__picture .drupal-media .drupal-media__image--full-width img {
        width: auto;
        height: 100%
    }

    .engineering-product-card__content__picture,
    .product-card__content__picture {
        height: 178px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%
    }
}

.engineering-product-card__content .series-title,
.product-card__content .series-title {
    --text-color: #0077C8;
    border-bottom: 1px solid #d6d6d6;
    padding-bottom: 6px;
    z-index: 1
}

@media (max-width: 991.98px) {

    .engineering-product-card__content .series-title,
    .product-card__content .series-title {
        max-width: 100%
    }
}

@media (min-width: 992px) {

    .engineering-product-card__content .series-title,
    .product-card__content .series-title {
        max-width: 50%
    }
}

.engineering-product-card__tag,
.product-card__tag {
    max-width: 25%;
    border-radius: 8px 8px 0 0;
    background-color: var(--color-tag);
    --text-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 16px
}

@media (max-width: 1199.98px) {

    .engineering-product-card__tag,
    .product-card__tag {
        max-width: 100%
    }
}

.engineering-product-card__tag img,
.product-card__tag img {
    width: 18px;
    margin-right: 8px
}

@media screen and (orientation: landscape) {

    .engineering-product-card__content__overview,
    .product-card__content__overview {
        max-width: 47.5%
    }
}

@media (min-width: 768px) {

    .engineering-product-card:not(.col-xl-6) .product-card__content__picture,
    .product-card:not(.col-xl-6) .product-card__content__picture {
        height: 100%;
        max-height: 100%
    }
}

@media (min-width: 992px) {

    .engineering-product-card .col-xl-6 .product-card__content__title p,
    .product-card .col-xl-6 .product-card__content__title p {
        font-size: 1.8rem
    }

    .engineering-product-card .col-xl-6 .product-card__content__overview p,
    .product-card .col-xl-6 .product-card__content__overview p {
        font-size: 1.6rem
    }

    .engineering-product-card .col-xl-6 .product-card__content__rate,
    .product-card .col-xl-6 .product-card__content__rate {
        font-size: 1.4rem
    }
}

@media (min-width: 1200px) {
    .col-xl-6 .product-card__content__picture {
        height: 150px;
        bottom: 20px
    }
}

#views-exposed-form-engineering-product-list-block-full-width label,
#views-exposed-form-product-list-block-full-width label {
    color: #041e42;
    font-size: 1.8rem;
    line-height: 3rem;
    font-weight: 700
}

#views-exposed-form-engineering-product-list-block-full-width select,
#views-exposed-form-product-list-block-full-width select {
    color: #041e42;
    font-size: 1.8rem;
    line-height: 3rem;
    border: .5px solid #8a8d8f;
    background-color: transparent;
    margin-left: 15px;
    padding: 10px 39px 10px 15px;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    /* background-image: url(/src/images/icons/chevron-down-dark-blue.svg); */
    background-repeat: no-repeat;
    background-position: calc(100% - 15px) 50%;
    background-size: 15px 15px
}

#views-exposed-form-engineering-product-list-block-full-width select::-ms-expand,
#views-exposed-form-product-list-block-full-width select::-ms-expand {
    display: none
}

.product-list-no-sorting {
    padding-top: 10.24rem
}

@media (max-width: 991.98px) {
    .product-list-no-sorting {
        padding-top: 4.8rem
    }
}

.best-seller-tag {
    --color-tag: #0077C8
}

.best-seller-tag .product-card__content {
    border: 4px solid var(--color-tag)
}

.title__success-story {
    color: #fff
}

.views-row:last-child .hr__success-story {
    display: none
}

.views-row .hr__success-story {
    border-top: 3px solid rgba(0, 0, 0, .1)
}

.success-stories-teaser__title {
    font-weight: 700;
    margin-bottom: .8rem;
    line-height: 1.2;
    font-size: 3.2rem
}

.taxonomy-list__title {
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 1.45em;
    color: #041e42;
    margin-bottom: 9px
}

@media (min-width: 768px) {
    .taxonomy-list__title {
        font-size: 2.2rem;
        margin-bottom: 15px
    }
}

.taxonomy-list__col {
    padding-left: 0
}

.taxonomy-list__item {
    list-style-type: none;
    padding-bottom: 12px;
    line-height: 0
}

.taxonomy-list__link {
    font-size: 1.4rem;
    line-height: 1.4em;
    color: #41b6e6
}

@media (min-width: 768px) {
    .taxonomy-list__link {
        font-size: 1.8rem
    }
}

.taxonomy-list__link:hover {
    text-decoration: underline
}

@media (max-width: 991.98px) {
    .taxonomy-list__empty {
        margin-left: 50%
    }

    .taxonomy-list__empty .empty-title {
        height: 0;
        margin-bottom: 0
    }
}

@media (max-width: 767.98px) {
    .slick--optionset--carousel-limited-variable-slides .carousel-media__container__title {
        max-width: 11.52rem
    }
}

.block--gallery .swiper {
    aspect-ratio: 3/2.6
}

.region--banner-top .banner-top-mobile-description {
    display: none
}

@media (max-width: 767.98px) {
    .region--banner-top .banner-top-desktop-description {
        display: none
    }

    .region--banner-top .banner-top-mobile-description {
        display: block
    }
}

.region--primary-menu {
    transform: translateY(0)
}

.region--banner-top-spacer {
    height: 35px
}

.product--world_regions {
    background-color: #f2f6f8;
    padding: 2.4rem 2.4rem 2.4rem 4.8rem;
    border-radius: 8px
}

.product--world_regions h4 {
    position: relative
}

.product--world_regions h4:before {
    content: "";
    position: absolute;
    left: -3rem;
    top: 50%;
    transform: translateY(-50%);
    /* background: url(/src/images/icons/check-green.svg) no-repeat center/contain; */
    width: 22px;
    height: 22px
}

#views-exposed-form-product-list-block-full-width {
    background-color: #fff;
    padding: 2rem;
    border-radius: 8px
}

#views-exposed-form-product-list-block-full-width .fieldgroup .fieldset-legend {
    display: block;
    font-size: 2rem;
    line-height: 3.3rem;
    font-weight: 700;
    font-family: Axiforma
}

#views-exposed-form-product-list-block-full-width ul {
    list-style: none;
    display: flex;
    justify-content: flex-start;
    padding: 0;
    margin-top: 1.6rem
}

@media (max-width: 991.98px) {
    #views-exposed-form-product-list-block-full-width ul {
        flex-direction: column
    }
}

#views-exposed-form-product-list-block-full-width ul li {
    margin: 0 1rem
}

@media (max-width: 991.98px) {
    #views-exposed-form-product-list-block-full-width ul li {
        margin: 1rem
    }
}

#views-exposed-form-product-list-block-full-width ul li .form-item {
    padding: 5px 15px;
    background-color: #f2f6f8;
    border-radius: 5px;
    box-shadow: 0 3px 3px -1px rgba(0, 0, 0, .2);
    position: relative;
    z-index: 1;
    transition: box-shadow .3s ease
}

#views-exposed-form-product-list-block-full-width ul li .form-item:hover {
    box-shadow: none
}

#views-exposed-form-product-list-block-full-width ul li .form-item .form-radio:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background: 0 0;
    left: 0;
    box-shadow: none;
    z-index: -1;
    border-radius: 5px;
    transition: box-shadow .3s ease
}

#views-exposed-form-product-list-block-full-width ul li .form-item .form-radio:checked:after {
    box-shadow: 0 0 0 1px #041e42
}

#views-exposed-form-product-list-block-full-width ul label {
    padding-left: 1rem;
    margin-bottom: 0;
    font-weight: 400
}

#views-exposed-form-product-list-block-full-width ul:first {
    margin-left: 0
}

#views-exposed-form-product-list-block-full-width ul:first>div {
    padding-left: 0
}

#views-exposed-form-product-list-block-full-width ul:last-child {
    margin-right: 0
}

.form__replacement {
    position: relative;
    height: 0
}

.mainfiltercontainer {
    display: flex;
    flex: 1 0 auto;
    padding-bottom: 75px;
    padding-top: 25px
}

@media (max-width: 767.98px) {
    .mainfiltercontainer {
        padding-bottom: 45px;
        padding-top: 15px;
        flex-wrap: wrap
    }
}

.mainfiltercontainer div {
    flex: 0 0 50%
}

@media (max-width: 767.98px) {
    .mainfiltercontainer div {
        flex: 0 0 100%
    }
}

.filtercontainer {
    background-color: transparent;
    position: relative;
    width: 95%
}

@media (max-width: 767.98px) {
    .filtercontainer {
        width: 100%
    }
}

.filtercontainer__left {
    margin-left: 0
}

.filtercontainer__right {
    margin-left: 5%
}

@media (max-width: 767.98px) {
    .filtercontainer__right {
        margin-left: 0;
        margin-top: 25px
    }
}

.filtercontainer__overlay {
    background-color: #fff;
    position: absolute;
    opacity: .4;
    width: 100%;
    height: 100%
}

.filtercontainer__selector {
    display: none
}

.filtercontainer__selector::-ms-expand {
    display: none
}

.filtercontainer__select--selected:after {
    color: #041e42;
    border-style: solid;
    border-width: .25em .25em 0 0;
    content: "";
    display: inline-block;
    height: 1em;
    position: absolute;
    right: 16px;
    vertical-align: top;
    width: 1em;
    top: 8px;
    transform: rotate(135deg)
}

.filtercontainer__select--selected {
    position: relative;
    color: #fff;
    font-weight: 700;
    padding: 8px 16px;
    border: 1px solid transparent;
    border-color: transparent transparent rgba(0, 0, 0, .1) transparent;
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none
}

.filtercontainer__select--selected.filtercontainer__select--arrow-active:after {
    transform: rotate(-45deg);
    top: 16px
}

.filtercontainer__select--hide {
    display: none
}

.filtercontainer__select--same-as-selected {
    background-color: rgba(0, 0, 0, .1)
}

.filtercontainer__select-items {
    position: absolute;
    background-color: #fff;
    opacity: 1;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 99
}

.filtercontainer__select-items div {
    color: #041e42;
    padding: 8px 16px;
    border: 1px solid transparent;
    border-color: transparent transparent rgba(0, 0, 0, .1) transparent;
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none
}

.filtercontainer__select-items div:hover {
    background-color: rgba(0, 0, 0, .1)
}

@media (min-width: 769px) {
    .layout .layout__region.mb {
        margin-bottom: 0
    }
}

.product-header-section-container {
    display: flex;
    min-height: 300px;
    margin-top: 1.6rem;
    align-items: stretch
}

@media (max-width: 767px) {
    .product-header-section-container {
        min-height: 200px
    }
}

.product-header-section-container .product-header-section .part-one {
    display: flex;
    width: -moz-max-content;
    width: max-content;
    padding-left: 15px;
    color: #0077c8
}

.product-header-section-container .product-header-section .part-one .product-model-section {
    width: -moz-max-content;
    width: max-content;
    line-height: 4rem;
    font-weight: 500;
    border-bottom: 1px solid #8a8d8f;
    display: flex
}

@media \\0 screen\\,screen\\9,
screen\\0 {
    .product-header-section-container .product-header-section .part-one .product-model-section {
        display: table
    }
}

.product-header-section-container .product-header-section .part-one .product-model-section:nth-child(2):before {
    color: #0077c8;
    display: flex;
    height: -moz-fit-content;
    height: fit-content;
    content: " • "
}

.product-header-section-container .product-header-section .part-two {
    color: #041e42;
    margin-top: 1.6rem;
    display: block
}

.product-header-section-container .product-header-section .part-three {
    margin-top: 4rem
}

.product-header-section-container .product-header-section .part-three .primary-blue-highlight {
    background-color: #041e42;
    width: -moz-fit-content;
    padding: 0 15px;
    color: #fff;
    display: table;
    font-size: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content
}

@media \\0 screen\\,screen\\9,
screen\\0 {
    .product-header-section-container .product-header-section .part-three .primary-blue-highlight {
        display: table
    }
}

.product-header-section-container .product-header-section .media-360 {
    margin-top: 3.2rem
}

.product-header-section-container .presentation-image,
.product-header-section-container .presentation-image-left-part {
    min-height: 300px;
    float: right
}

@media (max-width: 767px) {

    .product-header-section-container .presentation-image,
    .product-header-section-container .presentation-image-left-part {
        min-height: 200px
    }
}

.product-header-section-container .presentation-image .product-header-background-image {
    float: right;
    width: 100%
}

.product-header-section-container .world_regions {
    max-width: 500px
}

@media screen and (orientation: portrait) {
    .product-header-section-container .product-header-section .part-two .product-name-title {
        font-size: 2.3rem
    }

    .product-header-section-container .product-header-section .part-three .primary-blue-highlight {
        padding: 0 9px
    }

    .product-header-section-container .product-header-section .media-360 {
        display: none
    }

    .product-header-section-container .presentation-image-left-part {
        margin-top: .5rem
    }

    .product-header-section-container .presentation-image {
        margin-top: .5rem
    }
}

@media screen and (orientation: portrait) and (max-width:767px) {
    .product-header-section-container .product-header-section {
        display: block;
        position: relative;
        width: 100%;
        margin-top: 0
    }

    .product-header-section-container .product-header-section .part-one .bulk-point {
        font-size: 1.6rem
    }

    .product-header-section-container .product-header-section .part-one .product-model-section {
        font-size: 1.7rem;
        line-height: 4.4rem
    }

    .product-header-section-container .product-header-section .part-three .primary-blue-highlight {
        font-size: 1.6rem
    }

    .presentation-image-left-part {
        display: none
    }

    .presentation-image {
        max-width: 100%;
        flex: 0 0 100%
    }
}

@media screen and (orientation: portrait) and (min-width:767px) {
    .product-header-section-container .product-header-section {
        width: 40%;
        margin-top: 0
    }

    .product-header-section-container .product-header-section .part-one .bulk-point {
        font-size: 1.6rem
    }

    .product-header-section-container .product-header-section .part-one .product-model-section {
        font-size: 1.7rem;
        line-height: 4.4rem
    }
}

@media screen and (orientation: landscape) {
    .product-header-section-container .product-header-section .part-one .bulk-point {
        font-size: 1.6rem
    }

    .product-header-section-container .product-header-section .part-three {
        margin-top: 1.6rem
    }

    .product-header-section-container .product-header-section .part-three .primary-blue-highlight {
        padding: 0 9px;
        font-size: 1.7rem
    }

    .product-header-section-container .presentation-image-left-part {
        margin-top: 1.6rem
    }

    .product-header-section-container .presentation-image {
        margin-top: 1.6rem
    }
}

@media screen and (orientation: landscape) and (max-width:576px) {
    .product-header-section-container .product-header-section {
        width: 50%;
        margin-top: .8rem
    }

    .product-header-section-container .product-header-section .part-one .product-model-section {
        font-size: 1.6rem;
        line-height: 4rem
    }

    .product-header-section-container .product-header-section .part-two .product-name-title {
        font-size: 1.6rem
    }
}

@media screen and (orientation: landscape) and (min-width:577px) and (max-width:767.98px) {
    .product-header-section-container .product-header-section {
        width: 40%;
        margin-top: 0
    }

    .product-header-section-container .product-header-section .part-one .product-model-section {
        font-size: 1.6rem;
        line-height: 4rem
    }

    .product-header-section-container .product-header-section .part-two .product-name-title {
        font-size: 2rem
    }

    .product-header-section-container .product-header-section .media-360 {
        display: none
    }
}

@media screen and (orientation: landscape) and (min-width:767.99px) and (max-width:992px) {
    .product-header-section-container .product-header-section {
        width: 50%;
        margin-top: 1.6rem
    }

    .product-header-section-container .product-header-section .part-one .product-model-section {
        font-size: 2rem;
        line-height: 5.6rem
    }

    .product-header-section-container .product-header-section .part-two {
        margin-top: 1.6rem
    }

    .product-header-section-container .product-header-section .part-two .product-name-title {
        font-size: 2.4rem
    }

    .product-header-section-container .product-header-section .part-three {
        margin-top: 2.4rem
    }

    .product-header-section-container .product-header-section .part-three .primary-blue-highlight {
        padding: 0 15px;
        font-size: 1.8rem
    }

    .product-header-section-container .product-header-section .media-360 {
        display: none
    }
}

@media screen and (orientation: landscape) and (min-width:992px) {
    .product-header-section-container .part-two {
        margin-top: 1.6rem
    }

    .product-header-section-container .part-three {
        margin-top: 3.6rem
    }

    .product-header-section-container .part-three .primary-blue-highlight {
        padding: 0 15px;
        font-size: 2rem
    }

    .product-header-section-container .presentation-image-left-part {
        margin-top: 3.2rem
    }

    .product-header-section-container .presentation-image {
        margin-top: 3.2rem
    }
}

.splash-video-limit-height>article.drupal-media {
    max-height: 86.4rem;
    display: flex;
    overflow: hidden
}

@media (max-width: 1199.98px) {
    .splash-video-limit-height>article.drupal-media {
        max-height: 57.6rem
    }
}

@media (max-width: 991.98px) {
    .splash-video-limit-height>article.drupal-media {
        max-height: 40rem
    }
}

.pt-footer__ptsa ul li.menu-item {
    padding-left: 15px;
    margin-bottom: 5px
}

@media (max-width: 767.98px) {
    .pt-footer__ptsa ul li.menu-item ul {
        display: none
    }
}

.pt-footer__ptsa ul.menu-level-0 {
    display: block;
    margin-bottom: 45px
}

@media (max-width: 767.98px) {
    .pt-footer__ptsa ul.menu-level-0 {
        margin-bottom: 0
    }
}

.pt-footer__ptsa ul.menu-level-0>li.menu-item {
    width: auto;
    padding-left: 0
}

.pt-footer__ptsa ul.menu-level-0>li.menu-item>a {
    color: #041e42;
    margin-bottom: 5px
}

.pt-footer__ptsa ul.menu-level-1 {
    margin-top: 15px
}

.pt-footer__ptsa ul.menu-level-1 li.menu-item a {
    font-size: 1.5rem;
    line-height: 1.4em
}

.pt-footer__ptsa ul:not(.menu-level-0) {
    margin-bottom: 15px
}

.social-media p {
    font-weight: 700;
    margin-bottom: 5px
}

@media (max-width: 1199.98px) {
    .hamburger-menu .view-mode-image-text-button .menu-item--image-text-button {
        margin-left: 20px
    }

    .hamburger-menu .menu--btn-full-width {
        transform: translate(0, 0);
        border-bottom: 1px solid #8a8d8f !important;
        margin-bottom: 0 !important
    }

    .hamburger-menu .menu--main .menu:not(.menu-level-0) li a:after,
    .hamburger-menu .menu--main .menu:not(.menu-level-0) li a:before {
        content: unset
    }
}

@media (min-width: 1200px) {
    .language-redirection-banner .language-redirection-banner-inner :not(:last-child) {
        margin-right: 0
    }
}

body.stopScroll {
    overflow: hidden
}

.marketlanguageswitchercontainer {
    position: absolute;
    width: 65vw;
    height: 65vh;
    z-index: 1000;
    left: 17.5vw;
    top: 17.5vh;
    transform: translate(0, 15%)
}

@media (max-width: 1199.98px) {
    .marketlanguageswitchercontainer {
        width: 75vw;
        height: 75vh;
        left: 12.5vw;
        top: 12.5vh;
        transform: translate(0, 5%);
        z-index: 9999
    }
}

@media screen and (max-width: 1199.98px) and (orientation:portrait) {
    .marketlanguageswitchercontainer {
        transform: translate(0, 1%)
    }
}

@media (max-width: 767.98px) {
    .marketlanguageswitchercontainer {
        width: 85vw;
        height: 90vh;
        left: 7.5vw;
        top: 5vh;
        transform: translate(0, 5%)
    }
}

@media screen and (max-width: 767.98px) and (orientation:portrait) {
    .marketlanguageswitchercontainer {
        transform: translate(0, 1%)
    }
}

.marketlanguageswitchercontainer .ui-dialog-titlebar {
    border: none;
    display: none
}

.marketlanguageswitchercontainer .ui-dialog-titlebar button.ui-button {
    display: none
}

.ui-dialog-content.ui-dialog {
    overflow-y: unset !important
}

.marketlanguageswitcher__overlay {
    display: none;
    background-color: #041e42;
    opacity: .5;
    width: 100%;
    height: 100vh;
    position: absolute;
    z-index: 5
}

.marketlanguageswitcher__dialog {
    display: none;
    z-index: 6;
    height: 100%;
    padding: 32px
}

.marketlanguageswitcher__dialog.ui-dialog-content.ui-dialog {
    height: 100%
}

.marketlanguageswitcher__dialog .marketlanguageswitcher_maincontainer {
    display: flex;
    flex-direction: column;
    font-family: Axiforma;
    max-height: 100%
}

.marketlanguageswitcher__dialog--definition {
    display: flex;
    flex: 1 0 auto;
    flex-wrap: wrap;
    padding-left: 3.2rem;
    padding-right: 3.2rem
}

@media (max-width: 767.98px) {
    .marketlanguageswitcher__dialog--definition {
        padding-left: 1.92rem;
        padding-right: 1.92rem
    }
}

.marketlanguageswitcher__dialog--overflow {
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    height: inherit
}

.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar {
    width: 10px;
    border: none
}

.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-track {
    background: rgba(138, 141, 143, .3);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .15);
    border-radius: 10px
}

.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-thumb {
    background: #8a8d8f;
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .25)
}

.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-thumb:hover {
    background: #54585a
}

.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button {
    background-color: #fff;
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position: center center;
    height: 16px;
    width: 1em
}

/* 
.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:vertical:start {
    background-image: url(/src/images/icons/chevron-up-dark-blue.svg)
} */
/* 
.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:vertical:end {
    background-image: url(/src/images/icons/chevron-down-dark-blue.svg)
} */

.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:horizontal:end:decrement,
.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:horizontal:end:increment,
.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:vertical:end:decrement,
.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:vertical:start:increment {
    display: none
}

.marketlanguageswitcher__dialog--column {
    margin-top: 10px;
    margin-bottom: 15px;
    flex: 0 0 33%;
    padding: 10px
}

@media (max-width: 991.98px) {
    .marketlanguageswitcher__dialog--column {
        flex: 0 0 50%;
        margin-top: 10px;
        margin-bottom: 10px
    }
}

@media (max-width: 575.98px) {
    .marketlanguageswitcher__dialog--column {
        margin-top: 0;
        margin-bottom: 8px;
        padding: 0;
        flex: 0 0 100%
    }
}

.marketlanguageswitcher__dialog--columnadapted {
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 0 10px 0 10px
}

.marketlanguageswitcher__dialog--columnadapted .marketlanguageswitcher__list {
    margin-bottom: 0
}

.marketlanguageswitcher__titlecontainer {
    color: #041e42;
    position: relative;
    width: 100%;
    min-height: 25px;
    margin-top: 35px;
    margin-bottom: 15px
}

@media (max-width: 767.98px) {
    .marketlanguageswitcher__titlecontainer {
        margin-top: 20px;
        margin-bottom: 50px
    }
}

.marketlanguageswitcher__titlecontainer--std {
    min-height: 25px;
    margin-top: 36px;
    margin-bottom: 50px;
    position: relative
}

@media (max-width: 767.98px) {
    .marketlanguageswitcher__titlecontainer--std {
        margin-top: 18px;
        margin-bottom: 25px;
        min-height: 45px
    }
}

.marketlanguageswitcher__titlecontainer div {
    text-align: center
}

.marketlanguageswitcher__dialogbuttoncontainer {
    position: relative;
    width: 100%;
    min-height: 35px
}

.marketlanguageswitcher__dialogbuttoncontainer .marketlanguageswitcher__dialogbutton {
    color: #8a8d8f;
    font-weight: 700;
    flex-direction: row;
    text-transform: uppercase;
    position: absolute;
    right: 0;
    font-size: 1.6rem;
    cursor: pointer
}

.marketlanguageswitcher__dialogbuttoncontainer .marketlanguageswitcher__dialogbutton:before {
    content: "× ";
    font-size: 2.9rem;
    height: 4.48rem;
    font-weight: 500;
    width: .7em;
    line-height: unset;
    vertical-align: middle
}

.marketlanguageswitcher__dialogbuttoncontainer .marketlanguageswitcher__dialogbutton:hover {
    opacity: .7
}

.marketlanguageswitcher__marketname {
    color: #041e42;
    font-size: 2.2rem;
    font-weighT: bold;
    margin-top: 50px
}

@media (max-width: 991.98px) {
    .marketlanguageswitcher__marketname {
        font-size: 2rem;
        margin-top: 20px
    }
}

@media (max-width: 767.98px) {
    .marketlanguageswitcher__marketname {
        font-size: 1.8rem;
        margin-top: 20px
    }
}

.marketlanguageswitcher__list {
    list-style: none;
    padding-left: 0
}

.marketlanguageswitcher__list--selection .languageswitcher_pathalias {
    border: none;
    color: #41b6e6;
    font-size: 2rem;
    text-decoration: none
}

@media (max-width: 767.98px) {
    .marketlanguageswitcher__list--selection .languageswitcher_pathalias {
        font-size: 1.6rem
    }
}

.marketlanguageswitcher__list--selection .languageswitcher_pathalias:hover {
    text-decoration: underline
}

.marketlanguageswitcher__list--selection .languageswitcher_pathalias--active {
    font-weight: 700
}

@media (max-width: 991.98px) {
    .marketlanguageswitcher__list--selection {
        font-size: 1.7rem
    }
}

@media (max-width: 767.98px) {
    .marketlanguageswitcher__list--selection {
        font-size: 1.6rem
    }
}

@media (max-width: 1199.98px) {
    .cta-block {
        order: 8;
        z-index: auto
    }

    .cta-block .d-xl-none.menu-link {
        display: block;
        margin-bottom: 14px;
        padding-right: 40px;
        font-size: 14px;
        color: #031a39
    }
}

@media (max-width: 991.98px) {
    .helpButton {
        width: -moz-fit-content;
        width: fit-content
    }
}

.webform-submission-ptsa-web2lead-form label {
    color: var(--text-color)
}

.webform-submission-ptsa-web2lead-form #edit-container {
    background-color: rgba(242, 246, 248, .6);
    padding: 25px
}

.webform-submission-ptsa-web2lead-form #edit-container label {
    --text-color: #041E42
}

.client-stories-grid {
    max-width: 400px;
    margin: auto
}

.client-stories-grid__logo {
    position: absolute;
    bottom: 10%;
    z-index: 99;
    transition: opacity .3s ease;
    opacity: 0;
    margin-left: 30px;
    max-width: 150px;
    max-height: 150px
}

.client-stories-grid__logo img {
    width: 100%;
    height: 100%
}

.client-stories-grid__title {
    font-weight: 700;
    font-size: 3.6rem;
    padding: 13px 0 8px
}

.client-stories-grid__main-image {
    height: 430px;
    width: inherit;
    position: relative
}

.client-stories-grid__main-image img {
    max-width: 100%;
    max-height: 430px
}

.client-stories-grid__text {
    color: #041e42
}

.client-stories-grid__veil {
    max-width: 400px;
    width: 100%;
    height: 430px;
    position: absolute;
    opacity: 0;
    transition: opacity .3s ease;
    background: #041e42;
    z-index: 9
}

.client-stories-grid__wysiwyg p {
    margin-bottom: 0
}

.client-stories-grid .main-image-container .splash-video-play-button {
    width: 70px;
    height: 70px;
    left: 50%;
    top: 50%;
    transform: translateX(-35px) translateY(-35px);
    opacity: 0;
    transition: opacity .3s ease;
    z-index: 10
}

@media (max-width: 1199.98px) {
    .client-stories-grid .main-image-container .splash-video-play-button {
        opacity: 1
    }
}

.client-stories-grid hr {
    color: #54585a
}

@media (min-width: 992px) {
    .client-stories-grid:hover .client-stories-grid__veil {
        opacity: .92
    }

    .client-stories-grid:hover .client-stories-grid__logo {
        opacity: 1
    }

    .client-stories-grid:hover .splash-video-play-button {
        opacity: 1
    }

    .client-stories-grid:hover .splash-video-play-button:hover {
        opacity: 1
    }
}

.center .brochure-btn {
    justify-content: center
}

.right .brochure-btn {
    justify-content: end
}

.left .brochure-btn {
    justify-content: start
}

.engineering-services-grid {
    width: 100%
}

.engineering-services-grid a:hover {
    text-decoration: none
}

.engineering-services-grid__main-image {
    position: relative
}

.engineering-services-grid__main-image img {
    width: 100%;
    height: auto
}

.engineering-services-grid__overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: #41b6e6;
    /* background-image: url(/src/images/icons/arrow-next-white.svg); */
    background-size: 36px;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0;
    transition: opacity .3s ease
}

.engineering-services-grid__overlay:hover {
    opacity: .9
}

.engineering-services-grid__text {
    text-align: center;
    color: #041e42
}

.engineering-services-grid__title {
    font-weight: 700;
    font-size: 2rem
}

.engineering-services-grid__description {
    font-size: 1.4rem
}

.fourth-col {
    flex: 0 1 25%
}

.views-view-grid {
    display: flex;
    flex-wrap: wrap;
    flex: 1 0 auto
}

.views-view-grid .views-row {
    display: flex;
    flex-wrap: wrap;
    flex: 1 0 auto;
    box-sizing: border-box
}

@media (max-width: 991.98px) {
    .views-view-grid .views-row {
        flex-direction: inherit;
        flex-wrap: wrap;
        align-items: stretch;
        position: relative
    }
}

@media (max-width: 991.98px) and (max-width:767.98px) {
    .views-view-grid .views-row {
        flex-direction: column
    }
}

.views-view-grid .event-view-block {
    flex: 0 0 33%
}

@media (max-width: 767px) {
    .views-view-grid .event-view-block {
        flex: 1 0 auto
    }
}

@media screen and (max-width: 767px) and (orientation:landscape) and (max-height:767px) {
    .views-view-grid .event-view-block {
        flex: 0 0 50%
    }
}

@media (min-width: 767px) and (max-width:991px) {
    .views-view-grid .event-view-block {
        flex: 0 0 50%
    }
}

.event-row-item-container {
    width: 100%
}

.event-description-container {
    display: flex
}

.event-description-container .event-description-article {
    min-height: 368px;
    background-color: #fff;
    text-align: center;
    width: 100%;
    font-size: 2.1rem;
    line-height: 4.16rem;
    padding: 12px;
    margin: 10px;
    color: #041e42
}

.event-description-container .event-description-article .event-image {
    min-height: 125px;
    overflow: hidden
}

.event-description-container .event-description-article .event-title {
    font-weight: 700;
    max-height: 36px;
    overflow: hidden
}

.event-description-container .event-description-article .event-detail {
    font-size: 1.6rem;
    line-height: 1.8rem;
    margin-bottom: 7px;
    min-height: 3.2rem;
    overflow: hidden
}

.event-description-container .event-description-article .event-location {
    width: inherit;
    max-height: 36px;
    overflow: hidden
}

.event-description-container .event-description-article .event-date {
    display: inline-table;
    max-height: 36px;
    overflow: hidden
}

.event-description-container .event-description-article .event-date .event-start-date {
    display: table-cell;
    padding-right: 4px;
    white-space: nowrap
}

.event-description-container .event-description-article .event-date .event-end-date {
    display: table-cell
}

.event-description-container .event-description-article .event-date .event-end-date time {
    white-space: nowrap
}

@media (max-width: 767px) {
    .event-description-container .event-description-article .event-date {
        font-size: 2rem
    }
}

.event-description-container .event-description-article .event-website {
    margin-top: 10px;
    width: 80%;
    margin-left: 10%;
    max-height: 36px;
    overflow: hidden;
    border: 1px solid #fff
}

.event-description-container .event-description-article .event-website .event-website-external-link {
    text-decoration: none;
    color: #41b6e6
}

.event-description-container .event-description-article .event-website:hover {
    border: 1px solid #41b6e6;
    color: #41b6e6
}

.product-categories-grid {
    display: flex;
    flex-direction: column;
    margin: auto;
    position: relative
}

.product-categories-grid__image div {
    display: flex;
    flex: 1 0 auto;
    align-items: center;
    justify-content: center;
    justify-items: center
}

.product-categories-grid__veil {
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: 0;
    transition: opacity .3s ease;
    background: #041e42;
    z-index: 9
}

.product-categories-grid__main-container {
    position: relative;
    width: auto;
    overflow: hidden;
    --text-color: #FFFFFF
}

.product-categories-grid__main-container img {
    max-height: 300px
}

@media (max-width: 767.98px) {
    .product-categories-grid__main-container img {
        width: 100%
    }
}

.product-categories-grid__title {
    font-weight: 700;
    padding: 13px 0 8px;
    text-align: center
}

.product-categories-grid__text {
    display: none;
    --text-color: #F2F6F8;
    position: absolute;
    bottom: 10%
}

.product-categories-grid__wysiwyg p {
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0
}

.product-categories-grid__link a {
    margin-bottom: 0;
    color: #41b6e6;
    letter-spacing: 1px
}

.product-categories-grid__btn {
    box-shadow: 0 0 0 1.5px #fff;
    color: #fff
}

.product-categories-grid__btn:after {
    background-color: #fff
}

.product-categories-grid__btn:hover {
    color: #fff
}

.product-categories-grid:hover .product-categories-grid__text {
    display: block;
    z-index: 10
}

@media (max-width: 767.98px) {
    .product-categories-grid:hover .product-categories-grid__text {
        display: none
    }
}

.product-categories-grid:hover .product-categories-grid__veil {
    opacity: .92
}

@media (max-width: 767.98px) {
    .product-categories-grid:hover .product-categories-grid__veil {
        opacity: 0
    }
}

#views-exposed-form-products-category-list-block-product-categories {
    display: none
}`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;;IAEI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,gCAAgC;IACpC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,wBAAwB;QACxB,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;QAC9B,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;QACxB,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;QAC9B,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,0CAA0C;QAC1C,gCAAgC;IACpC;;IAEA;QACI,0CAA0C;QAC1C,gCAAgC;IACpC;;IAEA;QACI,0CAA0C;QAC1C,gCAAgC;IACpC;;IAEA;QACI,0CAA0C;QAC1C,gCAAgC;IACpC;;IAEA;QACI,0CAA0C;QAC1C,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,4CAA4C;;IAE5C;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,gDAAgD;IACpD;;IAEA;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;IACV,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;;IAEI,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IAEd,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,SAAS;IACT,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,UAAU;IACV,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,WAAW;IACX,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IAEtB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;;;;IAKI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;IAEI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,MAAM;AACV;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,UAAU;IACV,OAAO;AACX;;AAEA;;;;IAII,UAAU;IACV,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,OAAO;IACP,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,OAAO;IACP,MAAM;AACV;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,8BAA8B;IAC9B,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;;IAEI,2BAA2B;IAC3B,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,cAAc;IACd,uBAAuB;IACvB,oBAAoB;IACpB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,4BAA4B;IAC5B,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA;;;;;;;;;;;GAWG;;AAEH;IACI,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,8BAA8B;IAClC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yDAA2D;AAC/D;;AAEA;IACI,yDAA4D;AAChE;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,aAAa;IACb,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,6DAAqD;IACrD,eAAe;IACf,0BAA0B;AAC9B;;AAEA;;;IAGI,uBAAuB;IACvB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,8BAA8B;IAE9B,6BAA6B;IAC7B,+CAA+C;IAC/C,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAU;MAAV,cAAU;SAAV;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;;;;;;IAMI,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAKI,6BAA6B;IAC7B,2GAA2G;IAC3G,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAMI,8BAA8B;IAC9B,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,oBAAoB;IACpB,SAAS;IACT;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII,0BAA0B;IAC1B,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;IAaI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAQA;IAEI,cAAc;IACd;AACJ;;AAJA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;IAQI,cAAc;IACd;AACJ;;AAEA;;IAEI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,cAAc;IACd,eAAe;IACf,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,sCAAsC;IACtC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,2BAA2B;IAC3B,4BAA4B;IAC5B,uCAAuC;IACvC,kCAAkC;IAClC,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB;AACJ;;AAoDA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,cAAc;IACd,eAAe;IACf,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,sCAAsC;IACtC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,2BAA2B;IAC3B,4BAA4B;IAC5B,uCAAuC;IACvC,kCAAkC;IAClC,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IAEvB;AACJ;;AAEA;IACI,qBAAqB;IAErB;AACJ;;AAEA;IACI,mBAAmB;IAEnB;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAgB;SAAhB;AACJ;;AAEA;IACI,wBAAwB;IACxB,qBAAe;SAAf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,qBAAe;SAAf;AACJ;;AAEA;IAEI,qBAAe;SAAf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+EAA+E;IAC/E,iGAAiG;IACjG,kDAAkD;IAClD;AACJ;;AAEA;IACI,kFAAkF;IAClF,oGAAoG;IACpG,kDAAkD;IAClD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2GAA2G;IAC3G,yGAAyG;IACzG,0EAA0E;IAC1E;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,+QAA+Q;IAC/Q;AACJ;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,UAAU;IACV;AACJ;;AAEA;;IAEI,kCAAkC;IAClC,mCAAmC;IACnC,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,UAAU;QACV;IACJ;;IAEA;;QAEI,mCAAmC;QACnC;IACJ;;IAEA;QACI,2BAA2B;QAC3B,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,iEAAsE;IACtE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IAEI;AACJ;;AA6BA;IACI;QAEI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QAEI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,uDAAuD;IACvD,sDAAsD;IACtD,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,uDAAuD;IACvD,sDAAsD;IACtD,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ;AACJ;;AAEA;IACI,wBAAwB;IACxB,qBAAgB;SAAhB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,kDAAkD;IAClD;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QAEI,qBAAe;aAAf;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QAEvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;;IAMI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;;;;;IAOI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;;;;;;IAQI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;;;;;;;;IAUI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;;;;;IAMI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;IAGI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;IAGI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;;;IAGI,WAAW;IACX,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;;;IAGI,YAAY;IACZ,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;;;;;;GAQG;AACH;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;;AAEH;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;;;IAII,2BAA2B;AAC/B;;AAEA;;;;IAII,4BAA4B;AAChC;;AAEA;;;;IAII,8BAA8B;AAClC;;AAEA;;;;IAII,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IAEI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;AACJ;;AAEA,mEAAmE;AACnE;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,wBAAwB;IACxB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,0EAA0E;IAC1E,uCAAuC;IACvC,oCAAoC;IACpC,oCAAoC;IACpC,yEAAyE;IACzE,sCAAsC;IACtC,mCAAmC;IACnC,mCAAmC;IACnC,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,+MAA+M;IAC/M;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,8BAA8B;IAC9B;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;IACI,SAAS;IACT,kMAAkM;IAClM,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT;AACJ;;AAEA;;;;;;IAMI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B,yCAAiC;YAAjC,iCAAiC;IACjC,YAAY;IACZ,gBAAgB;IAChB,sCAA6B;YAA7B;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,+CAAuC;YAAvC,uCAAuC;IACvC;AACJ;;AAEA;IACI,8BAA8B;IAC9B,+CAAsC;YAAtC;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;;;IAII,iGAAiG;IACjG;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;;;;IAKI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII,UAAU;IACV;AACJ;;AAEA;;IAEI,sBAAsB;IACtB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;IAYI,oBAAoB;IACpB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;;QAGI;IACJ;AACJ;;AAEA;;IAEI;;;;QAII;IACJ;AACJ;;AAEA;;IAEI;;;;;QAKI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAsEI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB;AACJ;;AAEA;;;;IAII,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI,0BAA0B;IAC1B;AACJ;;AAEA;;;;;;IAMI,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,qCAAqC;IACrC;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;;;IAGI,cAAc;IACd;AACJ;;AAEA;;IAEI,0CAA0C;IAC1C;AACJ;;AAEA;;IAEI,8CAA8C;IAC9C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB;IACJ;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,oBAAe;aAAf,eAAe;QACf,wBAAmB;aAAnB,mBAAmB;QACnB,UAAU;QACV;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI,0BAAyB;IAIzB;AAHJ;;AAMA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,uBAAuB;IACvB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B,0CAA0C;IAC1C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B,0CAA0C;IAC1C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;;IAEI,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,sBAAsB;IACtB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;;IAEI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;;IAEI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,WAAW;IACX,yCAAyC;IACzC;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;;IAEI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;;IAEI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;;IAEI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;;IAEI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;;IAEI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,SAAS;IACT,wBAAe;OAAf,qBAAe;YAAf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,4BAA4B;IAC5B,mCAAmC;IACnC,oBAAoB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;IAClB,gCAAgC;IAChC,yCAAyC;IACzC;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,6BAA6B;IAC7B,6CAA6C;IAC7C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,SAAS;IACT,kMAAkM;IAClM,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,MAAM;IACN,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,OAAO;IACP,YAAY;IACZ;AACJ;;AAEA;;IAEI,QAAQ;IACR,iCAAiC;IACjC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,SAAS;IACT,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,QAAQ;IACR,YAAY;IACZ;AACJ;;AAEA;;IAEI,OAAO;IACP,iCAAiC;IACjC;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI,0CAA0C;IAC1C;AACJ;;AAEA;IACI,6CAA6C;IAC7C;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;;;;IAKI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP;AACJ;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;;;QAGI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,yBAAyB;QACzB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI,UAAU;QACV;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;;;;;;;;;IASI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,+CAA+C;IAC/C,kBAAkB;IAClB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;;;IAII,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI,mBAAmB;IACnB,oBAAoB;IAEpB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,+CAA+C;IAC/C;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,oBAAoB;IAEpB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,+CAA+C;IAC/C,UAAU;IACV,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,+EAA+E;IAC/E,qBAAqB;IACrB,kCAAkC;IAClC,4BAA4B;IAC5B,kBAAkB;IAClB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;;;;;IAMI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,0FAA0F;IAC1F,4BAA4B;IAC5B,gDAAgD;IAChD,oDAAoD;IACpD,UAAU;IACV;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;IAII,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,2BAA2B;IAC3B,6BAA6B;IAC7B,gBAAgB;IAChB,+CAA+C;IAC/C;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,OAAO;IACP,yEAAyE;IACzE;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;;;;;;;;;;;;;IAgBI;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,qFAAqF;IACrF,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,4DAA4D;IAC5D;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,sBAAsB;IACtB,mCAAmC;IACnC,iCAAiC;IACjC;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,0DAAkE;IAClE,4BAA4B;IAC5B,kCAAkC;IAClC,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;;GAGG;;AAEH;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAgB;OAAhB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,0DAAyD;QACzD,wBAAwB;QACxB,4BAA4B;QAC5B,oBAAoB;QACpB,UAAU;QACV,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd,UAAU;QACV;IACJ;;IAEA;QACI,OAAO;QACP;IACJ;;IAEA;QACI,WAAW;QACX,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,MAAM;QACN,QAAQ;QACR,mEAAmE;QACnE;IACJ;;IAEA;QACI,WAAW;QACX,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,MAAM;QACN,OAAO;QACP,kEAAkE;QAClE,oBAAoB;QACpB;IACJ;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;IAMI,oBAAoB;IACpB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;;;;;;;;;;;;IAeI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB;IACJ;;IAEA;;;;;;QAMI;IACJ;;IAEA;;;;;QAKI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,wBAAwB;IACxB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B;AACJ;;AAEA;;;;;IAKI,+BAA+B;IAC/B,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,4BAA4B;QAC5B,2BAA2B;QAC3B;IACJ;;IAEA;;;;;QAKI,gCAAgC;QAChC,eAAe;QACf,4BAA4B;QAC5B,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;;;;;;;;;IAUI,YAAY;IACZ,oBAAgB;OAAhB;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI;;;;;QAKI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,+BAA+B;IAC/B,8CAA8C;IAC9C,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,mBAAmB;QACnB;IACJ;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,SAAS;IACT;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI,WAAW;QACX;IACJ;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,gDAAgD;IAChD,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;IAwBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,uBAAuB;QACvB,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,UAAU;IACV,4BAA4B;IAC5B,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,QAAQ;IACR;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,OAAO;QACP,WAAW;QACX,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,wBAAoB;OAApB;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;IAIA;QACI,0EAA0E;QAC1E;IACJ;IAIA;QACI,aAAa;QACb;IACJ;AAbJ;;AAgBA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX;IACJ;IAIA;QACI,0DAAyD;QACzD,4BAA4B;QAC5B,kCAAkC;QAClC,qBAAqB;QACrB,YAAY;QACZ,eAAe;QACf,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT;IACJ;IAIA;QACI,0DAA+D;QAC/D;IACJ;AAtBJ;;AAyBA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gDAAgD;IAChD,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,2BAA2B;IAC3B;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,cAAc;IACd,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,OAAO;IACP;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,SAAS;QACT,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kEAAkE;IAClE,4BAA4B;IAC5B,kCAAkC;IAClC;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB;IACJ;AACJ;;AAEA;IACI,2CAA2C;IAC3C,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iEAAiE;IACjE,4BAA4B;IAC5B,kCAAkC;IAClC;AACJ;;AAEA;IACI;QACI,sEAAsE;IAC1E;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,6DAA6D;IAC7D,4BAA4B;IAC5B,kCAAkC;IAClC;AACJ;;AAEA;;;;;EAKE;AACF;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB;AACJ;;AAEA;IACI,WAAW;IACX,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB;AACJ;;AAEA;;;;IAII,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,wBAAwB;IACxB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,+EAA2E;WAA3E;IACJ;;IAEA;QACI,gFAA4E;WAA5E;IACJ;;IAEA;QACI,gFAA4E;WAA5E;IACJ;;IAEA;QACI,gFAA4E;WAA5E;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,8EAA2E;OAA3E,2EAA2E;IAC3E;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kDAAkD;IAClD,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,mCAAmC;IACnC,4BAA4B;IAC5B,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,sEAAsE;IACtE,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,8EAA8E;IAC9E,yBAAyB;IACzB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;IACnC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,gBAAgB;QAChB,0BAA0B;QAC1B,mCAAmC;QACnC;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,yEAAyE;IACzE;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,gDAAgD;IAChD,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,0DAA0D;IAC1D;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,6BAA6B;IAC7B,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,0DAAkD;IAClD,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,0CAA0C;IAC1C,4BAA4B;IAC5B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,MAAM;QACN,WAAW;QACX,yBAAyB;QACzB,UAAU;QACV,kBAAkB;QAClB,+BAA+B;QAC/B;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,MAAM;QACN,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,kBAAkB;IAClB,oFAAoF;IACpF;AACJ;;AAEA;IACI,4BAA4B;IAC5B,yFAAyF;AAC7F;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,yFAAyF;AAC7F;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX;AACJ;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX;AACJ;;AAEA;IACI,8CAA8C;IAC9C;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN;AACJ;;AAEA;;IAEI,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB;AACJ;;AAEA;IACI,QAAQ;IACR,OAAO;IACP,WAAW;IACX;AACJ;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;IAChB,yEAAyE;IACzE,4BAA4B;IAC5B,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,6BAA6B;IAC7B,8DAA8D;IAC9D,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8DAA8D;IAC9D;AACJ;;AAEA;IACI,gGAAgG;IAChG,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,SAAS;QACT,eAAe;QACf;IACJ;IAIA;QACI,eAAe;QACf,yBAAyB;QACzB;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;AAhBJ;;AAmBA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;AAEH;IACI,WAAW;IACX;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyCG;;AAEH;;IAEI,WAAW;IACX;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;;AAEH;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,4BAA4B;IAC5B,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B;IACJ;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mEAAmE;IACnE,4BAA4B;IAC5B,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+CAA+C;IAC/C;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,cAAc;QACd;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kDAAkD;IAClD;AACJ;;AAEA;;;;IAII,yBAAyB;IACzB,cAAc;IACd;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;;IAEI,YAAY;IACZ,WAAW;IACX,+DAA+D;IAC/D,YAAY;IACZ,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,+BAA+B;IAC/B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qEAAqE;IACrE,0BAA0B;IAC1B,wBAAwB;IACxB;AACJ;;AAEA;IACI,qEAAqE;IACrE,0BAA0B;IAC1B,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAiB;OAAjB,iBAAiB;IACjB,iCAA8B;OAA9B,8BAA8B;IAC9B,cAAc;IACd,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,6FAA6F;IAC7F,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,4BAA4B;IAC5B;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,sHAAyH;IACzH,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sHAA2H;IAC3H,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sHAAuI;IACvI,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sHAAyH;IACzH,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sHAAqI;IACrI,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,oHAA+H;IAC/H,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sHAA6H;IAC7H,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sHAA6H;IAC7H,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,oHAAyH;IACzH,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,4DAA6D;IAC7D,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sHAAuI;IACvI,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;;AAGA;IACI;QACI,cAAc;QACd,uBAAuB;QACvB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAoB;IACpB,WAAW;IACX,gDAAgD;IAChD;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb,kCAAkC;QAClC,0CAA0C;QAC1C,cAAa;QAMb;IALJ;AACJ;;AAQA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,WAAW;QACX,mBAAmB;QACnB,YAAY;QACZ,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;IAIA;QACI,cAAc;QACd,kBAAkB;QAClB,aAAa;QACb,qCAAqC;QACrC,kCAAkC;QAClC,sBAAsB;QACtB,kBAAkB;QAClB;IACJ;AAZJ;;AAeA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;;QAEI,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;QACX,kCAAkC;QAClC,QAAQ;QACR,wBAAwB;QACxB;IACJ;;IAEA;;QAEI,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;QACX,QAAQ;QACR;IACJ;;IAEA;;QAEI,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;QACX,kCAAkC;QAClC,QAAQ;QACR;IACJ;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,UAAU;IACV,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,yBAAyB;QACzB,aAAa;QACb,4BAA4B;QAC5B,sBAAsB;QACtB,mBAAmB;QACnB,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;QACX,kCAAkC;QAClC,QAAQ;QACR,wBAAwB;QACxB;IACJ;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;QACX,QAAQ;QACR;IACJ;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;QACX,kCAAkC;QAClC,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,qCAAqC;QACrC,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,uBAAiB;IAAjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAkB;IAAlB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,kBAAkB;QAClB,SAAS;QACT,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;QACX,kCAAkC;QAClC,QAAQ;QACR,wBAAwB;QACxB;IACJ;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;QACX,QAAQ;QACR;IACJ;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;QACX,kCAAkC;QAClC,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;IAIA;QACI;IACJ;AALJ;;AAQA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,gBAAgB;IAChB,oEAAoE;AACxE;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;GAmBG;;AAEH;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,cAAc;QACd,WAAW;QACX;IACJ;IAIA;QACI,qBAAqB;QACrB,WAAW;QACX,kBAAkB;QAClB;IACJ;IAIA;QACI,qBAAqB;QACrB,WAAW;QACX,oBAAoB;QACpB;IACJ;IAIA;QACI,qBAAqB;QACrB,WAAW;QACX,iBAAiB;QACjB;IACJ;AA1BJ;;AA6BA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,mEAAmE;IACnE,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,6BAA6B;IAC7B,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,4EAA4E;IAC5E;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,yEAAyE;IACzE,kCAAkC;IAClC,wBAAwB;IACxB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,MAAM;IACN,UAAU;IACV;AACJ;;AAEA;IACI,wEAAwE;IACxE,kCAAkC;IAClC;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,aAAa;IACb,WAAW;IACX,eAAe;IACf,MAAM;IACN,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,OAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI;QACI,aAAY;QAMZ;IALJ;AACJ;;AAQA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,MAAM;IACN;AACJ;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,wBAAe;OAAf,qBAAe;YAAf;AACJ;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,0EAA0E;IAC1E,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;;IAEI,kCAAkC;IAClC,4BAA4B;IAC5B,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,0DAAuD;IACvD,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,0DAAyD;IACzD,wBAAwB;IACxB,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;GAOG;;AAEH;IACI;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;;;;IAII,iBAAiB;IACjB,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI,YAAY;IACZ;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,gDAAgD;IAChD,+BAA+B;IAC/B,aAAa;IACb;AACJ;;AAEA;IACI;QACI,uBAAsB;QAMtB;IALJ;AACJ;;AAQA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,0DAAyD;IACzD,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mHAAkH;IAClH,QAAQ;IACR,MAAM;IACN,6CAA6C;IAC7C,4BAA4B;IAC5B,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI,eAAe;QACf;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,oBAAiB;OAAjB,iBAAiB;IACjB,4BAAyB;OAAzB,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,+BAA2B;OAA3B;AACJ;;AAEA;IACI,+BAA2B;OAA3B;AACJ;;AAEA;IACI;QACI,+BAA2B;WAA3B;IACJ;;IAEA;QACI,+BAA2B;WAA3B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAe;SAAf;AACJ;;AAEA;IACI,qBAAe;SAAf;AACJ;;AAEA;IACI,qBAAe;SAAf;AACJ;;AAEA;IACI,qBAAe;SAAf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII,mCAAmC;IACnC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI,oBAAoB;IACpB;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI,cAAc;IACd,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;IACd;AACJ;;AAEA;;;;;;;;;;IAUI,cAAc;IACd;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI,qBAAqB;QACrB;IACJ;;IAEA;;;;;;;;;;QAUI,6BAA6B;QAC7B,iBAAiB;QACjB,iBAAiB;QACjB;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI,2CAA2C;IAC3C,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;;;;;;;;;;IAUI,6BAA6B;IAC7B,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI,oBAAoB;QACpB,sBAAsB;QACtB,8BAA8B;QAC9B;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI,WAAW;QACX;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;;;;;;;;;;IAUI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI,2CAA2C;IAC3C;AACJ;;AAEA;;;;;;;;;;IAUI,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;;;;;;;;;;IAUI,gCAAgC;IAChC,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;;;;;;;;;;QAUI,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,wCAAwC;IACxC,+BAA+B;IAC/B,+BAA+B;IAC/B;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,eAAe;IACf,OAAO;IACP,MAAM;IACN,iCAAiC;IACjC,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,6CAA6C;IAC7C,0CAA0C;IAC1C;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,mCAAmC;IACnC;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,UAAU;IACV,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;IAIA;QACI,mBAAkB;QAMlB;IALJ;IAUA;QACI;IACJ;AAjBJ;;AAoBA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;IAC7C,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;IAIA;QACI,aAAa;QACb,oBAAoB;QACpB,YAAY;QACZ;IACJ;IAIA;QACI,mCAAmC;QACnC;IACJ;AAfJ;;AAkBA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,qBAAqB;QACrB,aAAa;QACb;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,8BAA8B;QAC9B,eAAe;QACf;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;;QAEI,wBAAwB;QACxB;IACJ;IAIA;QACI,wBAAwB;QACxB;IACJ;IAIA;QACI,kBAAkB;QAClB,YAAY;QACZ,qBAAqB;QACrB,kBAAkB;QAClB,OAAO;QACP;IACJ;AAjBJ;;AAoBA;IACI;QACI,iGAAiG;QACjG,WAAW;QACX,qBAAqB;QACrB,YAAY;QACZ,yBAAyB;QACzB,WAAW;QACX;IACJ;AACJ;;AAEA;;IAEI;;QAEI,wBAAwB;QACxB;IACJ;;IAKA;;QAEI;IACJ;AAPJ;;AAUA;IACI,wCAAwC;IACxC,cAAc;IACd,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,OAAO;IACP,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,WAAW;QACX,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;IAIA;QACI;IACJ;AALJ;;AAQA;IACI,qBAAgB;SAAhB,gBAAgB;IAChB,qCAAqC;IACrC,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,aAAY;QAMZ;IALJ;;IAQA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,mCAAmC;QACnC,4CAA4C;QAC5C;IACJ;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AA9BJ;;AAiCA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;;QAEI,aAAa;QACb,kBAAkB;QAClB;IACJ;AACJ;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,wBAAwB;IACxB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,iGAAiG;IACjG,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,2EAA2E;IAC3E,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;IAC5B,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;;;QAGI,yBAAyB;QACzB;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uFAAsG;IACtG,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,UAAU;QACV,kBAAkB;QAClB,MAAM;QACN,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI,gCAAgC;QAChC;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;;;;QAII,mCAAmC;QACnC;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;IAIA;QACI;IACJ;AALJ;;AAQA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;GAIG;;AAEH;;IAEI;AACJ;;AAEA;;;;GAIG;;AAEH;IACI,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,gCAAgC;IAChC,sBAAsB;IACtB,4CAA4C;IAC5C,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,yDAAyD;IACzD,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oDAAoD;IACpD,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB;AACJ;;AAEA;;IAEI,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,+BAA+B;IAC/B;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;;IAOI;AAJJ;;AAOA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,mEAAmE;IACnE,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA0CC;AACD;;;;;;;;IAQI;AACJ;;AAEA;;;;GAIG;;AAEH;;IAEI,mEAAmE;IACnE,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,eAAe;IACf;AACJ;;AAEA;;IAEI;;;;QAII;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAKA;;QAEI;IACJ;AAPJ;;AAUA;;IAEI;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,2EAA2E;IAC3E,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,qBAAqB;IACrB,2CAA2C;IAC3C,4BAA4B;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,wBAAwB;IACxB,SAAS;IACT;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,6DAA6D;IAC7D,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;IAC5B,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,MAAM;IACN;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;;QAEI,WAAW;QACX,YAAW;QAQX;IAPJ;AACJ;;AAUA;;IAEI,WAAW;IACX,0DAA+D;IAC/D,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,+BAA+B;IAC/B;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iFAAiF;IACjF,UAAU;IACV,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,8CAA8C;IAC9C,SAAS;IACT;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,sDAAsD;IACtD,2BAA2B;IAC3B;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mCAAmC;IACnC,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0DAAyD;IACzD,wBAAwB;IACxB,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX;AACJ;;AAEA;;;IAKI;AACJ;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IAGf,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,OAAO;IACP,cAAc;IACd,WAAW;IACX,gBAAgB;IAGhB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yEAAyE;IACzE,kCAAkC;IAClC,wBAAwB;IACxB,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,MAAM;IACN,YAAY;IACZ;AACJ;;AAEA;IACI,wEAAwE;IACxE,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,WAAW;IACX,2BAA2B;IAC3B,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;IAChC;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB;IACJ;AACJ;;AAEA;;IAEI,eAAe;IACf,oCAAoC;IACpC,WAAW;IACX;AACJ;;AAEA;;IAEI;;QAEI,mCAAmC;QACnC;IACJ;AACJ;;AAEA;;IAEI;;QAEI,mCAAmC;QACnC;IACJ;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;IAFA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;;;;;;IAMI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;;;;;;QAMI;IACJ;AACJ;;AAEA;;IAEI;;;;;;QAMI;IACJ;AACJ;;AAEA;;IAEI;;;;;;QAMI,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,sFAAqF;IACrF,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,MAAM;IACN,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;;IAEI,6CAA6C;IAC7C,8BAA8B;IAC9B,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,uBAAiB;IAAjB;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI,+BAA+B;IAC/B;AACJ;;AAEA;;IAEI;;;;;;QAMI,cAAc;QACd;IACJ;AACJ;;AAEA;;IAEI;;;;;;QAMI;IACJ;AACJ;;AAEA;;IAEI,+BAA+B;IAC/B,uEAAuE;IACvE;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;IACxB,sBAAsB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,wGAAwG;IACxG,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,gHAAgH;IAChH,mCAAmC;IACnC;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;;;;;IAMI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;;;;;;IAMI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,0GAA0G;IAC1G,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,kHAAkH;IAClH,mCAAmC;IACnC;AACJ;;AAEA;;;IAGI,WAAW;IACX;AACJ;;AAEA;;;IAGI,WAAW;IACX;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,8FAA8F;IAC9F,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,sGAAsG;IACtG,mCAAmC;IACnC;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,iEAAiE;IACjE,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,yEAAyE;IACzE,mCAAmC;IACnC;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,6DAA6D;IAC7D,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,qEAAqE;IACrE,mCAAmC;IACnC;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,kBAAkB;IAIlB,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,iDAAiD;IACjD,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,yDAAyD;IACzD,mCAAmC;IACnC,iHAAiH;IACjH,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,kBAAkB;IAGlB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,kDAAkD;IAClD,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,0DAA0D;IAC1D,mCAAmC;IACnC,iHAAiH;IACjH,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IAGf,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,kDAAkD;IAClD,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,0DAA0D;IAC1D,mCAAmC;IACnC,iHAAiH;IACjH,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,2DAA2D;IAC3D,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,mEAAmE;IACnE,mCAAmC;IACnC,iHAAiH;IACjH,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,2DAA2D;IAC3D,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,mEAAmE;IACnE,mCAAmC;IACnC,iHAAiH;IACjH,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,+DAA+D;IAC/D,oCAAoC;IACpC,uBAAuB;IACvB,8BAA8B;IAC9B,uEAAuE;IACvE,mCAAmC;IACnC,iHAAiH;IACjH,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAKA;;QAEI;IACJ;;IAKA;;QAEI,cAAc;QACd;IACJ;AAhBJ;;AAmBA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IAKI,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,qBAAqB;IACrB,4EAA4E;IAC5E,4BAA4B;IAC5B,kCAAkC;IAClC,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,qBAAqB;QACrB,MAAM;QACN,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,qBAAqB;IACrB,4EAA4E;IAC5E,4BAA4B;IAC5B,kCAAkC;IAClC,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,SAAS;IACT;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,qBAAqB;QACrB,MAAM;QACN;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB,gDAAgD;IAChD,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,cAAc;IACd,wBAAwB;IACxB,4BAA4B;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,4DAA4D;IAC5D,4BAA4B;IAC5B;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,8DAA8D;IAC9D,4BAA4B;IAC5B;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,mCAAmC;IACnC,YAAY;IACZ,OAAO;IACP;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;;;IAII,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;IAIA;QACI,WAAW;QACX,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,UAAU;QACV,MAAM;QACN;IACJ;AAXJ;;AAcA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,wBAAmB;IAAnB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,YAAY;IACZ,4BAA4B;IAC5B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;;;IAII,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB,wBAAmB;IAAnB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,iCAAiC;IACjC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAY;QAMZ,qBAAqB;QACrB,cAAc;QACd;IAPJ;AACJ;;AAUA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,wBAAwB;QACxB,sBAAsB;QACtB,gDAAgD;QAChD,kBAAkB;QAClB,iCAAiC;QACjC,4BAA4B;QAC5B,aAAa;QACb,SAAS;QACT,QAAQ;QACR,SAAS;QACT,iBAAiB;QACjB,8BAA8B;QAC9B,2BAA2B;QAC3B,cAAc;QACd,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,8BAA8B;QAC9B,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI,mBAAmB;QACnB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI,aAAa;QACb;IACJ;;IAEA;;QAEI,aAAa;QACb;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI,yBAAyB;QACzB,iBAAiB;QACjB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,cAAc;QACd,cAAc;QACd,aAAa;QACb,0BAA0B;QAC1B,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;QACV,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;QAClB,MAAM;QACN,4BAA4B;QAC5B,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,SAAS;QACT,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,0BAA0B;QAC1B,UAAU;QACV;IACJ;;IAEA;QACI,iGAAiG;QACjG,WAAW;QACX,qBAAqB;QACrB,WAAW;QACX,wBAAwB;QACxB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oFAAoF;IACpF,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,aAAY;QAMZ,WAAW;QACX,YAAY;QACZ;IAPJ;AACJ;;AAUA;;;GAGG;;AAEH;IACI,OAAO;IACP;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,iGAAiG;QACjG,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;;QAEI,mBAAmB;QACnB,6BAA6B;QAC7B,aAAa;QACb,UAAU;QACV,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,cAAc;IACd;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,MAAM;IACN,OAAO;IACP,UAAU;IACV;AACJ;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,oBAAoB;IACpB,mEAAmE;IACnE,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,gCAAgC;IAChC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI,UAAU;QACV;IACJ;AACJ;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;IACf;AACJ;;AAEA;;IAEI,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,OAAO;IACP,uBAAkB;IAAlB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ;AACJ;;AAEA;;;;;;IAMI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;;QAEI,WAAW;QACX;IACJ;;IAEA;;QAEI,WAAW;QACX;IACJ;;IAKA;;QAEI,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR;IACJ;AAZJ;;AAeA;;IAEI,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,cAAc;IACd,0BAA0B;IAC1B,kCAAkC;IAClC,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI,YAAY;QACZ;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;IAC7B,iBAAiB;IACjB,4BAA4B;IAC5B,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;IAChB,yEAAyE;IACzE,4BAA4B;IAC5B,0CAA0C;IAC1C;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,iFAAiF;IACjF,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,4CAA4C;IAC5C,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,eAAe;IACf,OAAO;IACP,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,mEAAmE;IACnE,eAAe;IACf,yBAAgB;OAAhB,sBAAgB;YAAhB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,mEAAmE;IACnE,eAAe;IACf,yBAAgB;OAAhB,sBAAgB;YAAhB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,wBAAmB;IAAnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B,2CAA2C;QAC3C;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,WAAW;QACX,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,WAAW;QACX,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,mCAAmC;IACnC,4CAA4C;IAC5C;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;IAClC,YAAY;IACZ;AACJ;;AAEA;;;GAGG;AACH;;;GAGG;;AAEH;;;;IAII;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;QAClB,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,QAAQ;QACR;IACJ;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,mBAAmB;QACnB,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI,uBAAiB;QAAjB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,4BAA4B;IAC5B,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,4BAA4B;IAC5B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,8CAA8C;IAC9C,UAAU;IACV,4BAA4B;IAC5B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,mEAAmE;IACnE,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,eAAe;QACf,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,4BAA4B;IAC5B,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ","sourcesContent":["/* @license GPL-2.0-or-later https://www.drupal.org/licensing/faq */\n.entity-browser-form__img img,\n.layout-builder-configure-block img {\n    width: 100% !important;\n    height: auto;\n}\n\n.linkit-ui-autocomplete {\n    position: fixed !important;\n}\n\n@media (min-width: 768px) {\n    .offset-md-1 {\n        margin-left: 8.33333% !important;\n    }\n\n    .offset-right-1 {\n        margin-right: 8.33333% !important;\n    }\n\n    .col-sm-40 {\n        flex: 0 0 40% !important;\n        max-width: 40% !important;\n    }\n\n    .col-sm-39 {\n        flex: 0 0 31.66666% !important;\n        max-width: 31.66666% !important;\n    }\n\n    .col-sm-38 {\n        flex: 0 0 23.33333% !important;\n        max-width: 23.33333% !important;\n    }\n\n    .col-sm-60 {\n        flex: 0 0 60% !important;\n        max-width: 60% !important;\n    }\n\n    .col-sm-59 {\n        flex: 0 0 51.66666% !important;\n        max-width: 51.66666% !important;\n    }\n\n    .col-sm-58 {\n        flex: 0 0 43.33333% !important;\n        max-width: 43.33333% !important;\n    }\n\n    .col-12 {\n        flex-shrink: 1 !important;\n    }\n\n    .layout__flex {\n        display: flex;\n    }\n\n    .col-sm-flex {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .col-sm-flex>*,\n    .col-sm-flex-1>* {\n        flex: 1 0 100% !important;\n    }\n\n    .col-sm-flex-2>* {\n        flex: 1 0 calc(100% / 2 - 10px) !important;\n        max-width: calc(100% / 2 - 10px);\n    }\n\n    .col-sm-flex-3>* {\n        flex: 1 0 calc(100% / 3 - 10px) !important;\n        max-width: calc(100% / 3 - 10px);\n    }\n\n    .col-sm-flex-4>* {\n        flex: 1 0 calc(100% / 4 - 10px) !important;\n        max-width: calc(100% / 4 - 10px);\n    }\n\n    .col-sm-flex-5>* {\n        flex: 1 0 calc(100% / 5 - 10px) !important;\n        max-width: calc(100% / 5 - 10px);\n    }\n\n    .col-sm-flex-6>* {\n        flex: 1 0 calc(100% / 6 - 10px) !important;\n        max-width: calc(100% / 6 - 10px);\n    }\n}\n\n@media (max-width: 767px) {\n    .col-sm-flex.justify-content-start {\n        text-align: left;\n    }\n\n    .col-sm-flex.justify-content-center {\n        text-align: center;\n    }\n\n    .col-sm-flex.justify-content-end {\n        text-align: right;\n    }\n}\n\n.pt {\n    padding-top: 50px;\n}\n\n.pb {\n    padding-bottom: 50px;\n}\n\n@media (max-width: 768px) {\n    .pb {\n        padding-bottom: 0;\n    }\n\n    .pt {\n        padding-top: 0;\n    }\n}\n\n@media (min-width: 769px) {\n    .pt {\n        padding-top: 160px;\n    }\n\n    .pb {\n        padding-bottom: 160px;\n    }\n\n    .mt {\n        margin-top: 60px;\n    }\n\n    .mb {\n        margin-bottom: 60px;\n    }\n}\n\n.layout-two-columns-with-action__container {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    grid-template-areas: \"left\" \"right\" \"action\";\n\n    @media (min-width: 768px) {\n        gap: 3.5rem;\n    }\n}\n\n@media (min-width: 768px) {\n    .layout-two-columns-with-action__container {\n        grid-template-columns: 1fr 1fr;\n        grid-template-areas: \"left right\" \"action right\";\n    }\n\n    .layout-two-columns-with-action__container.layout-two-columns-with-action-reversed {\n        grid-template-areas: \"right left\" \"right action\";\n    }\n}\n\n.layout-two-columns-with-action__action {\n    grid-area: action;\n    justify-self: start;\n    align-self: end;\n}\n\n.layout-two-columns-with-action__left {\n    grid-area: left;\n}\n\n.layout-two-columns-with-action__right {\n    grid-area: right;\n}\n\n.ui-helper-hidden {\n    display: none;\n}\n\n.ui-helper-hidden-accessible {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n}\n\n.ui-helper-reset {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    outline: 0;\n    line-height: 1.3;\n    text-decoration: none;\n    font-size: 100%;\n    list-style: none;\n}\n\n.ui-helper-clearfix:before,\n.ui-helper-clearfix:after {\n    content: \"\";\n    display: table;\n    border-collapse: collapse;\n}\n\n.ui-helper-clearfix:after {\n    clear: both;\n}\n\n.ui-helper-zfix {\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    position: absolute;\n    opacity: 0;\n    -ms-filter: \"alpha(opacity=0)\";\n}\n\n.ui-front {\n    z-index: 100;\n}\n\n.ui-state-disabled {\n    cursor: default !important;\n    pointer-events: none;\n}\n\n.ui-icon {\n    display: inline-block;\n    vertical-align: middle;\n    margin-top: -.25em;\n    position: relative;\n    text-indent: -99999px;\n    overflow: hidden;\n    background-repeat: no-repeat;\n}\n\n.ui-widget-icon-block {\n    left: 50%;\n    margin-left: -8px;\n    display: block;\n}\n\n.ui-widget-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.ui-controlgroup {\n    vertical-align: middle;\n    display: inline-block;\n}\n\n.ui-controlgroup>.ui-controlgroup-item {\n    float: left;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.ui-controlgroup>.ui-controlgroup-item:focus,\n.ui-controlgroup>.ui-controlgroup-item.ui-visual-focus {\n    z-index: 9999;\n}\n\n.ui-controlgroup-vertical>.ui-controlgroup-item {\n    display: block;\n    float: none;\n    width: 100%;\n    margin-top: 0;\n    margin-bottom: 0;\n    text-align: left;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-item {\n    box-sizing: border-box;\n}\n\n.ui-controlgroup .ui-controlgroup-label {\n    padding: .4em 1em;\n}\n\n.ui-controlgroup .ui-controlgroup-label span {\n    font-size: 80%;\n}\n\n.ui-controlgroup-horizontal .ui-controlgroup-label+.ui-controlgroup-item {\n    border-left: none;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-label+.ui-controlgroup-item {\n    border-top: none;\n}\n\n.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {\n    border-right: none;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {\n    border-bottom: none;\n}\n\n.ui-controlgroup-vertical .ui-spinner-input {\n    width: 75%;\n    width: calc(100% - 2.4em);\n}\n\n.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {\n    border-top-style: solid;\n}\n\n.ui-checkboxradio-label .ui-icon-background {\n    box-shadow: inset 1px 1px 1px #ccc;\n    border-radius: .12em;\n    border: none;\n}\n\n.ui-checkboxradio-radio-label .ui-icon-background {\n    width: 16px;\n    height: 16px;\n    border-radius: 1em;\n    overflow: visible;\n    border: none;\n}\n\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {\n    background-image: none;\n    width: 8px;\n    height: 8px;\n    border-width: 4px;\n    border-style: solid;\n}\n\n.ui-checkboxradio-disabled {\n    pointer-events: none;\n}\n\n.ui-resizable {\n    position: relative;\n}\n\n.ui-resizable-handle {\n    position: absolute;\n    font-size: 0.1px;\n    display: block;\n    -ms-touch-action: none;\n    touch-action: none;\n}\n\n.ui-resizable-disabled .ui-resizable-handle,\n.ui-resizable-autohide .ui-resizable-handle {\n    display: none;\n}\n\n.ui-resizable-n {\n    cursor: n-resize;\n    height: 7px;\n    width: 100%;\n    top: -5px;\n    left: 0;\n}\n\n.ui-resizable-s {\n    cursor: s-resize;\n    height: 7px;\n    width: 100%;\n    bottom: -5px;\n    left: 0;\n}\n\n.ui-resizable-e {\n    cursor: e-resize;\n    width: 7px;\n    right: -5px;\n    top: 0;\n    height: 100%;\n}\n\n.ui-resizable-w {\n    cursor: w-resize;\n    width: 7px;\n    left: -5px;\n    top: 0;\n    height: 100%;\n}\n\n.ui-resizable-se {\n    cursor: se-resize;\n    width: 12px;\n    height: 12px;\n    right: 1px;\n    bottom: 1px;\n}\n\n.ui-resizable-sw {\n    cursor: sw-resize;\n    width: 9px;\n    height: 9px;\n    left: -5px;\n    bottom: -5px;\n}\n\n.ui-resizable-nw {\n    cursor: nw-resize;\n    width: 9px;\n    height: 9px;\n    left: -5px;\n    top: -5px;\n}\n\n.ui-resizable-ne {\n    cursor: ne-resize;\n    width: 9px;\n    height: 9px;\n    right: -5px;\n    top: -5px;\n}\n\n.ui-button {\n    padding: .4em 1em;\n    display: inline-block;\n    position: relative;\n    line-height: normal;\n    margin-right: .1em;\n    cursor: pointer;\n    vertical-align: middle;\n    text-align: center;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    overflow: visible;\n}\n\n.ui-button,\n.ui-button:link,\n.ui-button:visited,\n.ui-button:hover,\n.ui-button:active {\n    text-decoration: none;\n}\n\n.ui-button-icon-only {\n    width: 2em;\n    box-sizing: border-box;\n    text-indent: -9999px;\n    white-space: nowrap;\n}\n\ninput.ui-button.ui-button-icon-only {\n    text-indent: 0;\n}\n\n.ui-button-icon-only .ui-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -8px;\n    margin-left: -8px;\n}\n\n.ui-button.ui-icon-notext .ui-icon {\n    padding: 0;\n    width: 2.1em;\n    height: 2.1em;\n    text-indent: -9999px;\n    white-space: nowrap;\n}\n\ninput.ui-button.ui-icon-notext .ui-icon {\n    width: auto;\n    height: auto;\n    text-indent: 0;\n    white-space: normal;\n    padding: .4em 1em;\n}\n\ninput.ui-button::-moz-focus-inner,\nbutton.ui-button::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n}\n\n.ui-dialog {\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: .2em;\n    outline: 0;\n}\n\n.ui-dialog .ui-dialog-titlebar {\n    padding: .4em 1em;\n    position: relative;\n}\n\n.ui-dialog .ui-dialog-title {\n    float: left;\n    margin: .1em 0;\n    white-space: nowrap;\n    width: 90%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.ui-dialog .ui-dialog-titlebar-close {\n    position: absolute;\n    right: .3em;\n    top: 50%;\n    width: 20px;\n    margin: -10px 0 0 0;\n    padding: 1px;\n    height: 20px;\n}\n\n.ui-dialog .ui-dialog-content {\n    position: relative;\n    border: 0;\n    padding: .5em 1em;\n    background: none;\n    overflow: auto;\n}\n\n.ui-dialog .ui-dialog-buttonpane {\n    text-align: left;\n    border-width: 1px 0 0 0;\n    background-image: none;\n    margin-top: .5em;\n    padding: .3em 1em .5em .4em;\n}\n\n.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {\n    float: right;\n}\n\n.ui-dialog .ui-dialog-buttonpane button {\n    margin: .5em .4em .5em 0;\n    cursor: pointer;\n}\n\n.ui-dialog .ui-resizable-n {\n    height: 2px;\n    top: 0;\n}\n\n.ui-dialog .ui-resizable-e {\n    width: 2px;\n    right: 0;\n}\n\n.ui-dialog .ui-resizable-s {\n    height: 2px;\n    bottom: 0;\n}\n\n.ui-dialog .ui-resizable-w {\n    width: 2px;\n    left: 0;\n}\n\n.ui-dialog .ui-resizable-se,\n.ui-dialog .ui-resizable-sw,\n.ui-dialog .ui-resizable-ne,\n.ui-dialog .ui-resizable-nw {\n    width: 7px;\n    height: 7px;\n}\n\n.ui-dialog .ui-resizable-se {\n    right: 0;\n    bottom: 0;\n}\n\n.ui-dialog .ui-resizable-sw {\n    left: 0;\n    bottom: 0;\n}\n\n.ui-dialog .ui-resizable-ne {\n    right: 0;\n    top: 0;\n}\n\n.ui-dialog .ui-resizable-nw {\n    left: 0;\n    top: 0;\n}\n\n.ui-draggable .ui-dialog-titlebar {\n    cursor: move;\n}\n\n.text-align-left {\n    text-align: left;\n}\n\n.text-align-right {\n    text-align: right;\n}\n\n.text-align-center {\n    text-align: center;\n}\n\n.text-align-justify {\n    text-align: justify;\n}\n\n.align-left {\n    float: left;\n}\n\n.align-right {\n    float: right;\n}\n\n.align-center {\n    display: block;\n    margin-right: auto;\n    margin-left: auto;\n}\n\n.fieldgroup {\n    padding: 0;\n    border-width: 0;\n}\n\n.container-inline div,\n.container-inline label {\n    display: inline;\n}\n\n.container-inline .details-wrapper {\n    display: block;\n}\n\n.clearfix:after {\n    display: table;\n    clear: both;\n    content: \"\";\n}\n\n.js details:not([open]) .details-wrapper {\n    display: none;\n}\n\n.hidden {\n    display: none;\n}\n\n.visually-hidden {\n    position: absolute !important;\n    overflow: hidden;\n    clip: rect(1px, 1px, 1px, 1px);\n    width: 1px;\n    height: 1px;\n    word-wrap: normal;\n}\n\n.visually-hidden.focusable:active,\n.visually-hidden.focusable:focus {\n    position: static !important;\n    overflow: visible;\n    clip: auto;\n    width: auto;\n    height: auto;\n}\n\n.invisible {\n    visibility: hidden;\n}\n\n.item-list__comma-list,\n.item-list__comma-list li {\n    display: inline;\n}\n\n.item-list__comma-list {\n    margin: 0;\n    padding: 0;\n}\n\n.item-list__comma-list li:after {\n    content: \", \";\n}\n\n.item-list__comma-list li:last-child:after {\n    content: \"\";\n}\n\n.js .js-hide {\n    display: none;\n}\n\n.js-show {\n    display: none;\n}\n\n.js .js-show {\n    display: block;\n}\n\n.nowrap {\n    white-space: nowrap;\n}\n\n.position-container {\n    position: relative;\n}\n\n.reset-appearance {\n    margin: 0;\n    padding: 0;\n    border: 0 none;\n    background: transparent;\n    line-height: inherit;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n.resize-none {\n    resize: none;\n}\n\n.resize-vertical {\n    min-height: 2em;\n    resize: vertical;\n}\n\n.resize-horizontal {\n    max-width: 100%;\n    resize: horizontal;\n}\n\n.resize-both {\n    max-width: 100%;\n    min-height: 2em;\n    resize: both;\n}\n\n.system-status-counter__status-icon {\n    display: inline-block;\n    width: 25px;\n    height: 25px;\n    vertical-align: middle;\n}\n\n.system-status-counter__status-icon:before {\n    display: block;\n    content: \"\";\n    background-repeat: no-repeat;\n    background-position: center 2px;\n    background-size: 20px;\n}\n\n/* \n.system-status-counter__status-icon--error:before {\n    background-image: url(/src/images/icons/error.svg);\n}\n\n.system-status-counter__status-icon--warning:before {\n    background-image: url(/src/images/icons/warning.svg);\n}\n\n.system-status-counter__status-icon--checked:before {\n    background-image: url(/src/images/icons/checked.svg);\n} */\n\n.system-status-report-counters__item {\n    width: 100%;\n    margin-bottom: 0.5em;\n    padding: 0.5em 0;\n    text-align: center;\n    white-space: nowrap;\n    background-color: rgba(0, 0, 0, 0.063);\n}\n\n@media screen and (min-width: 60em) {\n    .system-status-report-counters {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n\n    .system-status-report-counters__item--half-width {\n        width: 49%;\n    }\n\n    .system-status-report-counters__item--third-width {\n        width: 33%;\n    }\n}\n\n.system-status-general-info__item {\n    margin-top: 1em;\n    padding: 0 1em 1em;\n    border: 1px solid #ccc;\n}\n\n.system-status-general-info__item-title {\n    border-bottom: 1px solid #ccc;\n}\n\n.tablesort {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    background-size: 100%;\n}\n\n.tablesort--asc {\n    background-image: url(/src/images/icons/tablesort--asc.svg);\n}\n\n.tablesort--desc {\n    background-image: url(/src/images/icons/tablesort--desc.svg);\n}\n\n.progress {\n    position: relative;\n}\n\n.progress__track {\n    min-width: 100px;\n    max-width: 100%;\n    height: 16px;\n    margin-top: 5px;\n    border: 1px solid;\n    background-color: #fff;\n}\n\n.progress__bar {\n    width: 3%;\n    min-width: 3%;\n    max-width: 100%;\n    height: 1.5em;\n    background-color: #000;\n}\n\n.progress__description,\n.progress__percentage {\n    overflow: hidden;\n    margin-top: 0.2em;\n    color: #555;\n    font-size: 0.875em;\n}\n\n.progress__description {\n    float: left;\n}\n\n[dir=\"rtl\"] .progress__description {\n    float: right;\n}\n\n.progress__percentage {\n    float: right;\n}\n\n[dir=\"rtl\"] .progress__percentage {\n    float: left;\n}\n\n.progress--small .progress__track {\n    height: 7px;\n}\n\n.progress--small .progress__bar {\n    height: 7px;\n    background-size: 20px 20px;\n}\n\n.ajax-progress {\n    display: inline-block;\n    padding: 1px 5px 2px 5px;\n}\n\n[dir=\"rtl\"] .ajax-progress {\n    float: right;\n}\n\n\n.ajax-progress-throbber .message {\n    display: inline;\n    padding: 1px 5px 2px;\n}\n\ntr .ajax-progress-throbber .throbber {\n    margin: 0 2px;\n}\n\n.ajax-progress-bar {\n    width: 16em;\n}\n\n.ajax-progress-fullscreen {\n    position: fixed;\n    z-index: 1000;\n    top: 48.5%;\n    left: 49%;\n    width: 24px;\n    height: 24px;\n    padding: 4px;\n    opacity: 0.9;\n    border-radius: 7px;\n    background-color: #232323;\n    background-repeat: no-repeat;\n    background-position: center center;\n}\n\n[dir=\"rtl\"] .ajax-progress-fullscreen {\n    right: 49%;\n    left: auto;\n}\n\n.video-embed-field-responsive-video {\n    position: relative;\n}\n\n.video-embed-field-responsive-video:after {\n    content: '';\n    display: block;\n    padding-bottom: 56.25%;\n}\n\n.video-embed-field-responsive-video iframe {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n}\n\n.video-embed-field-responsive-modal {\n    max-width: 100%;\n}\n\n.video-embed-field-lazy {\n    cursor: pointer;\n    position: relative;\n}\n\n.video-embed-field-lazy img {\n    width: 100%;\n}\n\n.video-embed-field-lazy-play {\n    height: 72px;\n    width: 72px;\n    left: 50%;\n    top: 50%;\n    margin-left: -36px;\n    margin-top: -36px;\n    position: absolute;\n    background: url(/src/images/icons/play.svg) no-repeat;\n    cursor: pointer;\n    background-size: 72px 72px;\n}\n\n*,\n:after,\n:before {\n    border: 0 solid #e5e7eb;\n    box-sizing: border-box\n}\n\n:after,\n:before {\n    --tw-content: \"\"\n}\n\nhtml {\n    -webkit-text-size-adjust: 100%;\n    -webkit-font-feature-settings: normal;\n    font-feature-settings: normal;\n    font-family: Axiforma, ui-sans-serif, system-ui;\n    font-variation-settings: normal;\n    line-height: 1.5;\n    tab-size: 4\n}\n\nbody {\n    line-height: inherit;\n    margin: 0\n}\n\nhr {\n    border-top-width: 1px;\n    color: inherit;\n    height: 0\n}\n\nabbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-size: inherit;\n    font-weight: inherit\n}\n\na {\n    color: inherit;\n    text-decoration: inherit\n}\n\nb,\nstrong {\n    font-weight: bolder\n}\n\ncode,\nkbd,\npre,\nsamp {\n    -webkit-font-feature-settings: normal;\n    font-feature-settings: normal;\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;\n    font-size: 1em;\n    font-variation-settings: normal\n}\n\nsmall {\n    font-size: 80%\n}\n\nsub,\nsup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: initial\n}\n\nsub {\n    bottom: -.25em\n}\n\nsup {\n    top: -.5em\n}\n\ntable {\n    border-collapse: collapse;\n    border-color: inherit;\n    text-indent: 0\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    -webkit-font-feature-settings: inherit;\n    font-feature-settings: inherit;\n    color: inherit;\n    font-family: inherit;\n    font-size: 100%;\n    font-variation-settings: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n    margin: 0;\n    padding: 0\n}\n\nbutton,\nselect {\n    text-transform: none\n}\n\n[type=button],\n[type=reset],\n[type=submit],\nbutton {\n    -webkit-appearance: button;\n    background-color: initial;\n    background-image: none\n}\n\n:-moz-focusring {\n    outline: auto\n}\n\n:-moz-ui-invalid {\n    box-shadow: none\n}\n\nprogress {\n    vertical-align: initial\n}\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n    height: auto\n}\n\n[type=search] {\n    -webkit-appearance: textfield;\n    outline-offset: -2px\n}\n\n::-webkit-search-decoration {\n    -webkit-appearance: none\n}\n\n::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    font: inherit\n}\n\nsummary {\n    display: list-item\n}\n\nblockquote,\ndd,\ndl,\nfigure,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\np,\npre {\n    margin: 0\n}\n\nfieldset {\n    margin: 0\n}\n\nfieldset,\nlegend {\n    padding: 0\n}\n\nmenu,\nol,\nul {\n    list-style: none;\n    margin: 0;\n    padding: 0\n}\n\ndialog {\n    padding: 0\n}\n\ntextarea {\n    resize: vertical\n}\n\ninput::-webkit-input-placeholder,\ntextarea::-webkit-input-placeholder {\n    color: #9ca3af;\n    opacity: 1\n}\n\ninput::placeholder,\ntextarea::placeholder {\n    color: #9ca3af;\n    opacity: 1\n}\n\n[role=button],\nbutton {\n    cursor: pointer\n}\n\n:disabled {\n    cursor: default\n}\n\naudio,\ncanvas,\nembed,\niframe,\nimg,\nobject,\nsvg,\nvideo {\n    display: block;\n    vertical-align: middle\n}\n\nimg,\nvideo {\n    height: auto;\n    max-width: 100%\n}\n\n[hidden] {\n    display: none\n}\n\n*,\n:after,\n:before {\n    --tw-border-spacing-x: 0;\n    --tw-border-spacing-y: 0;\n    --tw-translate-x: 0;\n    --tw-translate-y: 0;\n    --tw-rotate: 0;\n    --tw-skew-x: 0;\n    --tw-skew-y: 0;\n    --tw-scale-x: 1;\n    --tw-scale-y: 1;\n    --tw-pan-x: ;\n    --tw-pan-y: ;\n    --tw-pinch-zoom: ;\n    --tw-scroll-snap-strictness: proximity;\n    --tw-gradient-from-position: ;\n    --tw-gradient-via-position: ;\n    --tw-gradient-to-position: ;\n    --tw-ordinal: ;\n    --tw-slashed-zero: ;\n    --tw-numeric-figure: ;\n    --tw-numeric-spacing: ;\n    --tw-numeric-fraction: ;\n    --tw-ring-inset: ;\n    --tw-ring-offset-width: 0px;\n    --tw-ring-offset-color: #fff;\n    --tw-ring-color: rgba(59, 130, 246, .5);\n    --tw-ring-offset-shadow: 0 0 #0000;\n    --tw-ring-shadow: 0 0 #0000;\n    --tw-shadow: 0 0 #0000;\n    --tw-shadow-colored: 0 0 #0000;\n    --tw-blur: ;\n    --tw-brightness: ;\n    --tw-contrast: ;\n    --tw-grayscale: ;\n    --tw-hue-rotate: ;\n    --tw-invert: ;\n    --tw-saturate: ;\n    --tw-sepia: ;\n    --tw-drop-shadow: ;\n    --tw-backdrop-blur: ;\n    --tw-backdrop-brightness: ;\n    --tw-backdrop-contrast: ;\n    --tw-backdrop-grayscale: ;\n    --tw-backdrop-hue-rotate: ;\n    --tw-backdrop-invert: ;\n    --tw-backdrop-opacity: ;\n    --tw-backdrop-saturate: ;\n    --tw-backdrop-sepia:\n}\n\n::-webkit-backdrop {\n    --tw-border-spacing-x: 0;\n    --tw-border-spacing-y: 0;\n    --tw-translate-x: 0;\n    --tw-translate-y: 0;\n    --tw-rotate: 0;\n    --tw-skew-x: 0;\n    --tw-skew-y: 0;\n    --tw-scale-x: 1;\n    --tw-scale-y: 1;\n    --tw-pan-x: ;\n    --tw-pan-y: ;\n    --tw-pinch-zoom: ;\n    --tw-scroll-snap-strictness: proximity;\n    --tw-gradient-from-position: ;\n    --tw-gradient-via-position: ;\n    --tw-gradient-to-position: ;\n    --tw-ordinal: ;\n    --tw-slashed-zero: ;\n    --tw-numeric-figure: ;\n    --tw-numeric-spacing: ;\n    --tw-numeric-fraction: ;\n    --tw-ring-inset: ;\n    --tw-ring-offset-width: 0px;\n    --tw-ring-offset-color: #fff;\n    --tw-ring-color: rgba(59, 130, 246, .5);\n    --tw-ring-offset-shadow: 0 0 #0000;\n    --tw-ring-shadow: 0 0 #0000;\n    --tw-shadow: 0 0 #0000;\n    --tw-shadow-colored: 0 0 #0000;\n    --tw-blur: ;\n    --tw-brightness: ;\n    --tw-contrast: ;\n    --tw-grayscale: ;\n    --tw-hue-rotate: ;\n    --tw-invert: ;\n    --tw-saturate: ;\n    --tw-sepia: ;\n    --tw-drop-shadow: ;\n    --tw-backdrop-blur: ;\n    --tw-backdrop-brightness: ;\n    --tw-backdrop-contrast: ;\n    --tw-backdrop-grayscale: ;\n    --tw-backdrop-hue-rotate: ;\n    --tw-backdrop-invert: ;\n    --tw-backdrop-opacity: ;\n    --tw-backdrop-saturate: ;\n    --tw-backdrop-sepia:\n}\n\n::backdrop {\n    --tw-border-spacing-x: 0;\n    --tw-border-spacing-y: 0;\n    --tw-translate-x: 0;\n    --tw-translate-y: 0;\n    --tw-rotate: 0;\n    --tw-skew-x: 0;\n    --tw-skew-y: 0;\n    --tw-scale-x: 1;\n    --tw-scale-y: 1;\n    --tw-pan-x: ;\n    --tw-pan-y: ;\n    --tw-pinch-zoom: ;\n    --tw-scroll-snap-strictness: proximity;\n    --tw-gradient-from-position: ;\n    --tw-gradient-via-position: ;\n    --tw-gradient-to-position: ;\n    --tw-ordinal: ;\n    --tw-slashed-zero: ;\n    --tw-numeric-figure: ;\n    --tw-numeric-spacing: ;\n    --tw-numeric-fraction: ;\n    --tw-ring-inset: ;\n    --tw-ring-offset-width: 0px;\n    --tw-ring-offset-color: #fff;\n    --tw-ring-color: rgba(59, 130, 246, .5);\n    --tw-ring-offset-shadow: 0 0 #0000;\n    --tw-ring-shadow: 0 0 #0000;\n    --tw-shadow: 0 0 #0000;\n    --tw-shadow-colored: 0 0 #0000;\n    --tw-blur: ;\n    --tw-brightness: ;\n    --tw-contrast: ;\n    --tw-grayscale: ;\n    --tw-hue-rotate: ;\n    --tw-invert: ;\n    --tw-saturate: ;\n    --tw-sepia: ;\n    --tw-drop-shadow: ;\n    --tw-backdrop-blur: ;\n    --tw-backdrop-brightness: ;\n    --tw-backdrop-contrast: ;\n    --tw-backdrop-grayscale: ;\n    --tw-backdrop-hue-rotate: ;\n    --tw-backdrop-invert: ;\n    --tw-backdrop-opacity: ;\n    --tw-backdrop-saturate: ;\n    --tw-backdrop-sepia:\n}\n\n.container {\n    width: 100%\n}\n\n@media (min-width: 640px) {\n    .container {\n        max-width: 640px\n    }\n}\n\n@media (min-width: 768px) {\n    .container {\n        max-width: 768px\n    }\n}\n\n@media (min-width: 1024px) {\n    .container {\n        max-width: 1024px\n    }\n}\n\n@media (min-width: 1280px) {\n    .container {\n        max-width: 1280px\n    }\n}\n\n@media (min-width: 1536px) {\n    .container {\n        max-width: 1536px\n    }\n}\n\n#premier-tech-calculator :is(.pointer-events-none) {\n    pointer-events: none\n}\n\n#premier-tech-calculator :is(.visible) {\n    visibility: visible\n}\n\n#premier-tech-calculator :is(.static) {\n    position: static\n}\n\n#premier-tech-calculator :is(.fixed) {\n    position: fixed\n}\n\n#premier-tech-calculator :is(.absolute) {\n    position: absolute\n}\n\n#premier-tech-calculator :is(.relative) {\n    position: relative\n}\n\n#premier-tech-calculator :is(.bottom-4) {\n    bottom: 16px\n}\n\n#premier-tech-calculator :is(.left-0) {\n    left: 0\n}\n\n#premier-tech-calculator :is(.left-4) {\n    left: 16px\n}\n\n#premier-tech-calculator :is(.right-3) {\n    right: 12px\n}\n\n#premier-tech-calculator :is(.right-4) {\n    right: 16px\n}\n\n#premier-tech-calculator :is(.top-0) {\n    top: 0\n}\n\n#premier-tech-calculator :is(.top-11) {\n    top: 44px\n}\n\n#premier-tech-calculator :is(.top-2) {\n    top: 8px\n}\n\n#premier-tech-calculator :is(.top-\\[10px\\]) {\n    top: 10px\n}\n\n#premier-tech-calculator :is(.z-10) {\n    z-index: 10\n}\n\n#premier-tech-calculator :is(.z-20) {\n    z-index: 20\n}\n\n#premier-tech-calculator :is(.col-span-2) {\n    grid-column: span 2/span 2\n}\n\n#premier-tech-calculator :is(.\\!m-0) {\n    margin: 0 !important\n}\n\n#premier-tech-calculator :is(.\\!my-10) {\n    margin-bottom: 40px !important;\n    margin-top: 40px !important\n}\n\n#premier-tech-calculator :is(.\\!my-14) {\n    margin-bottom: 56px !important;\n    margin-top: 56px !important\n}\n\n#premier-tech-calculator :is(.\\!my-2) {\n    margin-bottom: 8px !important;\n    margin-top: 8px !important\n}\n\n#premier-tech-calculator :is(.\\!my-8) {\n    margin-bottom: 32px !important;\n    margin-top: 32px !important\n}\n\n#premier-tech-calculator :is(.mx-auto) {\n    margin-left: auto;\n    margin-right: auto\n}\n\n#premier-tech-calculator :is(.my-14) {\n    margin-bottom: 56px;\n    margin-top: 56px\n}\n\n#premier-tech-calculator :is(.my-4) {\n    margin-bottom: 16px;\n    margin-top: 16px\n}\n\n#premier-tech-calculator :is(.my-8) {\n    margin-bottom: 32px;\n    margin-top: 32px\n}\n\n#premier-tech-calculator :is(.\\!-mt-8) {\n    margin-top: -32px !important\n}\n\n#premier-tech-calculator :is(.\\!mb-0) {\n    margin-bottom: 0 !important\n}\n\n#premier-tech-calculator :is(.\\!mb-1) {\n    margin-bottom: 4px !important\n}\n\n#premier-tech-calculator :is(.\\!mb-1\\.5) {\n    margin-bottom: 6px !important\n}\n\n#premier-tech-calculator :is(.\\!mb-4) {\n    margin-bottom: 16px !important\n}\n\n#premier-tech-calculator :is(.\\!mb-6) {\n    margin-bottom: 24px !important\n}\n\n#premier-tech-calculator :is(.\\!mb-8) {\n    margin-bottom: 32px !important\n}\n\n#premier-tech-calculator :is(.\\!ml-2) {\n    margin-left: 8px !important\n}\n\n#premier-tech-calculator :is(.\\!mr-0) {\n    margin-right: 0 !important\n}\n\n#premier-tech-calculator :is(.\\!mr-2) {\n    margin-right: 8px !important\n}\n\n#premier-tech-calculator :is(.\\!mr-4) {\n    margin-right: 16px !important\n}\n\n#premier-tech-calculator :is(.\\!mt-0) {\n    margin-top: 0 !important\n}\n\n#premier-tech-calculator :is(.\\!mt-10) {\n    margin-top: 40px !important\n}\n\n#premier-tech-calculator :is(.\\!mt-2) {\n    margin-top: 8px !important\n}\n\n#premier-tech-calculator :is(.\\!mt-4) {\n    margin-top: 16px !important\n}\n\n#premier-tech-calculator :is(.\\!mt-5) {\n    margin-top: 20px !important\n}\n\n#premier-tech-calculator :is(.\\!mt-7) {\n    margin-top: 28px !important\n}\n\n#premier-tech-calculator :is(.\\!mt-8) {\n    margin-top: 32px !important\n}\n\n#premier-tech-calculator :is(.-ml-\\[230px\\]) {\n    margin-left: -230px\n}\n\n#premier-tech-calculator :is(.-mt-1) {\n    margin-top: -4px\n}\n\n#premier-tech-calculator :is(.-mt-1\\.5) {\n    margin-top: -6px\n}\n\n#premier-tech-calculator :is(.-mt-\\[2px\\]) {\n    margin-top: -2px\n}\n\n#premier-tech-calculator :is(.mb-1) {\n    margin-bottom: 4px\n}\n\n#premier-tech-calculator :is(.mb-4) {\n    margin-bottom: 16px\n}\n\n#premier-tech-calculator :is(.ml-4) {\n    margin-left: 16px\n}\n\n#premier-tech-calculator :is(.ml-6) {\n    margin-left: 24px\n}\n\n#premier-tech-calculator :is(.ml-\\[230px\\]) {\n    margin-left: 230px\n}\n\n#premier-tech-calculator :is(.mr-4) {\n    margin-right: 16px\n}\n\n#premier-tech-calculator :is(.mr-6) {\n    margin-right: 24px\n}\n\n#premier-tech-calculator :is(.mt-1) {\n    margin-top: 4px\n}\n\n#premier-tech-calculator :is(.mt-10) {\n    margin-top: 40px\n}\n\n#premier-tech-calculator :is(.mt-12) {\n    margin-top: 48px\n}\n\n#premier-tech-calculator :is(.mt-4) {\n    margin-top: 16px\n}\n\n#premier-tech-calculator :is(.mt-5) {\n    margin-top: 20px\n}\n\n#premier-tech-calculator :is(.mt-8) {\n    margin-top: 32px\n}\n\n#premier-tech-calculator :is(.mt-\\[200px\\]) {\n    margin-top: 200px\n}\n\n#premier-tech-calculator :is(.mt-\\[75px\\]) {\n    margin-top: 75px\n}\n\n#premier-tech-calculator :is(.block) {\n    display: block\n}\n\n#premier-tech-calculator :is(.flex) {\n    display: flex\n}\n\n#premier-tech-calculator :is(.grid) {\n    display: grid\n}\n\n#premier-tech-calculator :is(.hidden) {\n    display: none\n}\n\n#premier-tech-calculator :is(.h-1) {\n    height: 4px\n}\n\n#premier-tech-calculator :is(.h-2) {\n    height: 8px\n}\n\n#premier-tech-calculator :is(.h-6) {\n    height: 24px\n}\n\n#premier-tech-calculator :is(.h-8) {\n    height: 32px\n}\n\n#premier-tech-calculator :is(.h-9) {\n    height: 36px\n}\n\n#premier-tech-calculator :is(.h-\\[350px\\]) {\n    height: 350px\n}\n\n#premier-tech-calculator :is(.h-\\[65px\\]) {\n    height: 65px\n}\n\n#premier-tech-calculator :is(.h-auto) {\n    height: auto\n}\n\n#premier-tech-calculator :is(.h-full) {\n    height: 100%\n}\n\n#premier-tech-calculator :is(.min-h-\\[60\\%\\]) {\n    min-height: 60%\n}\n\n#premier-tech-calculator :is(.\\!w-auto) {\n    width: auto !important\n}\n\n#premier-tech-calculator :is(.\\!w-full) {\n    width: 100% !important\n}\n\n#premier-tech-calculator :is(.w-2) {\n    width: 8px\n}\n\n#premier-tech-calculator :is(.w-6) {\n    width: 24px\n}\n\n#premier-tech-calculator :is(.w-7) {\n    width: 28px\n}\n\n#premier-tech-calculator :is(.w-\\[60px\\]) {\n    width: 60px\n}\n\n#premier-tech-calculator :is(.w-auto) {\n    width: auto\n}\n\n#premier-tech-calculator :is(.w-full) {\n    width: 100%\n}\n\n#premier-tech-calculator :is(.max-w-full) {\n    max-width: 100%\n}\n\n#premier-tech-calculator :is(.max-w-screen-xl) {\n    max-width: 1280px\n}\n\n#premier-tech-calculator :is(.flex-none) {\n    flex: none\n}\n\n#premier-tech-calculator :is(.grow) {\n    flex-grow: 1\n}\n\n#premier-tech-calculator :is(.-translate-y-4) {\n    --tw-translate-y: -16px;\n    -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))\n}\n\n#premier-tech-calculator :is(.translate-y-1) {\n    --tw-translate-y: 4px;\n    -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))\n}\n\n#premier-tech-calculator :is(.rotate-180) {\n    --tw-rotate: 180deg;\n    -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))\n}\n\n#premier-tech-calculator :is(.transform) {\n    -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))\n}\n\n#premier-tech-calculator :is(.cursor-pointer) {\n    cursor: pointer\n}\n\n#premier-tech-calculator :is(.select-none) {\n    -webkit-user-select: none;\n    user-select: none\n}\n\n#premier-tech-calculator :is(.appearance-none) {\n    -webkit-appearance: none;\n    appearance: none\n}\n\n#premier-tech-calculator :is(.grid-cols-1) {\n    grid-template-columns: repeat(1, minmax(0, 1fr))\n}\n\n#premier-tech-calculator :is(.grid-cols-2) {\n    grid-template-columns: repeat(2, minmax(0, 1fr))\n}\n\n#premier-tech-calculator :is(.flex-col) {\n    flex-direction: column\n}\n\n#premier-tech-calculator :is(.flex-wrap) {\n    flex-wrap: wrap\n}\n\n#premier-tech-calculator :is(.content-center) {\n    align-content: center\n}\n\n#premier-tech-calculator :is(.items-start) {\n    align-items: flex-start\n}\n\n#premier-tech-calculator :is(.items-center) {\n    align-items: center\n}\n\n#premier-tech-calculator :is(.justify-center) {\n    justify-content: center\n}\n\n#premier-tech-calculator :is(.justify-between) {\n    justify-content: space-between\n}\n\n#premier-tech-calculator :is(.gap-1) {\n    gap: 4px\n}\n\n#premier-tech-calculator :is(.gap-2) {\n    gap: 8px\n}\n\n#premier-tech-calculator :is(.gap-4) {\n    gap: 16px\n}\n\n#premier-tech-calculator :is(.gap-8) {\n    gap: 32px\n}\n\n#premier-tech-calculator :is(.gap-x-6) {\n    -webkit-column-gap: 24px;\n    column-gap: 24px\n}\n\n#premier-tech-calculator :is(.gap-x-8) {\n    -webkit-column-gap: 32px;\n    column-gap: 32px\n}\n\n#premier-tech-calculator :is(.gap-y-4) {\n    row-gap: 16px\n}\n\n#premier-tech-calculator :is(.overflow-hidden) {\n    overflow: hidden\n}\n\n#premier-tech-calculator :is(.whitespace-normal) {\n    white-space: normal\n}\n\n#premier-tech-calculator :is(.break-words) {\n    overflow-wrap: break-word\n}\n\n#premier-tech-calculator :is(.rounded) {\n    border-radius: 4px\n}\n\n#premier-tech-calculator :is(.rounded-2xl) {\n    border-radius: 16px\n}\n\n#premier-tech-calculator :is(.rounded-3xl) {\n    border-radius: 24px\n}\n\n#premier-tech-calculator :is(.rounded-\\[20px\\]) {\n    border-radius: 20px\n}\n\n#premier-tech-calculator :is(.rounded-full) {\n    border-radius: 9999px\n}\n\n#premier-tech-calculator :is(.rounded-lg) {\n    border-radius: 8px\n}\n\n#premier-tech-calculator :is(.rounded-xl) {\n    border-radius: 12px\n}\n\n#premier-tech-calculator :is(.rounded-bl-2xl) {\n    border-bottom-left-radius: 16px\n}\n\n#premier-tech-calculator :is(.rounded-bl-xl) {\n    border-bottom-left-radius: 12px\n}\n\n#premier-tech-calculator :is(.rounded-br-2xl) {\n    border-bottom-right-radius: 16px\n}\n\n#premier-tech-calculator :is(.rounded-br-xl) {\n    border-bottom-right-radius: 12px\n}\n\n#premier-tech-calculator :is(.rounded-tl-2xl) {\n    border-top-left-radius: 16px\n}\n\n#premier-tech-calculator :is(.rounded-tl-xl) {\n    border-top-left-radius: 12px\n}\n\n#premier-tech-calculator :is(.rounded-tr-2xl) {\n    border-top-right-radius: 16px\n}\n\n#premier-tech-calculator :is(.rounded-tr-xl) {\n    border-top-right-radius: 12px\n}\n\n#premier-tech-calculator :is(.\\!border) {\n    border-width: 1px !important\n}\n\n#premier-tech-calculator :is(.border) {\n    border-width: 1px\n}\n\n#premier-tech-calculator :is(.\\!border-b) {\n    border-bottom-width: 1px !important\n}\n\n#premier-tech-calculator :is(.\\!border-b-4) {\n    border-bottom-width: 4px !important\n}\n\n#premier-tech-calculator :is(.\\!border-mainBlue) {\n    --tw-border-opacity: 1 !important;\n    border-color: rgb(4 30 66/var(--tw-border-opacity)) !important\n}\n\n#premier-tech-calculator :is(.\\!border-paleGray) {\n    --tw-border-opacity: 1 !important;\n    border-color: rgb(189 194 201/var(--tw-border-opacity)) !important\n}\n\n#premier-tech-calculator :is(.\\!border-secondaryBlue) {\n    --tw-border-opacity: 1 !important;\n    border-color: rgb(65 182 230/var(--tw-border-opacity)) !important\n}\n\n#premier-tech-calculator :is(.\\!border-transparent) {\n    border-color: transparent !important\n}\n\n#premier-tech-calculator :is(.border-darkGray) {\n    --tw-border-opacity: 1;\n    border-color: rgb(138 141 143/var(--tw-border-opacity))\n}\n\n#premier-tech-calculator :is(.border-secondaryBlue) {\n    --tw-border-opacity: 1;\n    border-color: rgb(65 182 230/var(--tw-border-opacity))\n}\n\n#premier-tech-calculator :is(.border-tertiaryBlue) {\n    --tw-border-opacity: 1;\n    border-color: rgb(0 119 200/var(--tw-border-opacity))\n}\n\n#premier-tech-calculator :is(.border-b-error) {\n    --tw-border-opacity: 1;\n    border-bottom-color: rgb(233 52 63/var(--tw-border-opacity))\n}\n\n#premier-tech-calculator :is(.border-b-paleGray) {\n    --tw-border-opacity: 1;\n    border-bottom-color: rgb(189 194 201/var(--tw-border-opacity))\n}\n\n#premier-tech-calculator :is(.bg-darkGray-300) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(180 182 183/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-error-50) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(255 227 229/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-green-200) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(187 247 208/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-lightBlue) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(223 245 254/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-lightBlue-500) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(223 245 254/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-lightGray) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(242 246 248/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-lightGray\\/80) {\n    background-color: rgba(242, 246, 248, .8)\n}\n\n#premier-tech-calculator :is(.bg-mainBlue) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(4 30 66/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-paleGray-500) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(189 194 201/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-secondaryBlue) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(65 182 230/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-secondaryBlue-600) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(28 158 211/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-tertiaryBlue) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(0 119 200/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.bg-transparent) {\n    background-color: initial\n}\n\n#premier-tech-calculator :is(.bg-white) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(255 255 255/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.stroke-error) {\n    stroke: #e9343f\n}\n\n#premier-tech-calculator :is(.\\!p-0) {\n    padding: 0 !important\n}\n\n#premier-tech-calculator :is(.\\!p-4) {\n    padding: 16px !important\n}\n\n#premier-tech-calculator :is(.p-1) {\n    padding: 4px\n}\n\n#premier-tech-calculator :is(.p-2) {\n    padding: 8px\n}\n\n#premier-tech-calculator :is(.p-3) {\n    padding: 12px\n}\n\n#premier-tech-calculator :is(.p-4) {\n    padding: 16px\n}\n\n#premier-tech-calculator :is(.p-7) {\n    padding: 28px\n}\n\n#premier-tech-calculator :is(.\\!px-2) {\n    padding-left: 8px !important;\n    padding-right: 8px !important\n}\n\n#premier-tech-calculator :is(.\\!px-3) {\n    padding-left: 12px !important;\n    padding-right: 12px !important\n}\n\n#premier-tech-calculator :is(.\\!px-4) {\n    padding-left: 16px !important;\n    padding-right: 16px !important\n}\n\n#premier-tech-calculator :is(.\\!px-6) {\n    padding-left: 24px !important;\n    padding-right: 24px !important\n}\n\n#premier-tech-calculator :is(.\\!px-8) {\n    padding-left: 32px !important;\n    padding-right: 32px !important\n}\n\n#premier-tech-calculator :is(.\\!py-0) {\n    padding-bottom: 0 !important;\n    padding-top: 0 !important\n}\n\n#premier-tech-calculator :is(.\\!py-0\\.5) {\n    padding-bottom: 2px !important;\n    padding-top: 2px !important\n}\n\n#premier-tech-calculator :is(.\\!py-1) {\n    padding-bottom: 4px !important;\n    padding-top: 4px !important\n}\n\n#premier-tech-calculator :is(.\\!py-1\\.5) {\n    padding-bottom: 6px !important;\n    padding-top: 6px !important\n}\n\n#premier-tech-calculator :is(.\\!py-12) {\n    padding-bottom: 48px !important;\n    padding-top: 48px !important\n}\n\n#premier-tech-calculator :is(.\\!py-2) {\n    padding-bottom: 8px !important;\n    padding-top: 8px !important\n}\n\n#premier-tech-calculator :is(.\\!py-5) {\n    padding-bottom: 20px !important;\n    padding-top: 20px !important\n}\n\n#premier-tech-calculator :is(.\\!py-8) {\n    padding-bottom: 32px !important;\n    padding-top: 32px !important\n}\n\n#premier-tech-calculator :is(.px-4) {\n    padding-left: 16px;\n    padding-right: 16px\n}\n\n#premier-tech-calculator :is(.px-6) {\n    padding-left: 24px;\n    padding-right: 24px\n}\n\n#premier-tech-calculator :is(.py-2) {\n    padding-bottom: 8px;\n    padding-top: 8px\n}\n\n#premier-tech-calculator :is(.py-4) {\n    padding-bottom: 16px;\n    padding-top: 16px\n}\n\n#premier-tech-calculator :is(.\\!pb-4) {\n    padding-bottom: 16px !important\n}\n\n#premier-tech-calculator :is(.\\!pl-4) {\n    padding-left: 16px !important\n}\n\n#premier-tech-calculator :is(.\\!pr-3) {\n    padding-right: 12px !important\n}\n\n#premier-tech-calculator :is(.pl-1) {\n    padding-left: 4px\n}\n\n#premier-tech-calculator :is(.pl-1\\.5) {\n    padding-left: 6px\n}\n\n#premier-tech-calculator :is(.text-center) {\n    text-align: center\n}\n\n#premier-tech-calculator :is(.font-sans) {\n    font-family: Axiforma, ui-sans-serif, system-ui\n}\n\n#premier-tech-calculator :is(.text-4xl) {\n    font-size: 36px\n}\n\n#premier-tech-calculator :is(.text-base) {\n    font-size: 16px\n}\n\n#premier-tech-calculator :is(.text-lg) {\n    font-size: 18px\n}\n\n#premier-tech-calculator :is(.text-sm) {\n    font-size: 14px\n}\n\n#premier-tech-calculator :is(.text-xl) {\n    font-size: 20px\n}\n\n#premier-tech-calculator :is(.text-xs) {\n    font-size: 12px\n}\n\n#premier-tech-calculator :is(.font-bold) {\n    font-weight: 700\n}\n\n#premier-tech-calculator :is(.font-extrabold) {\n    font-weight: 800\n}\n\n#premier-tech-calculator :is(.font-normal) {\n    font-weight: 400\n}\n\n#premier-tech-calculator :is(.font-thin) {\n    font-weight: 100\n}\n\n#premier-tech-calculator :is(.uppercase) {\n    text-transform: uppercase\n}\n\n#premier-tech-calculator :is(.lowercase) {\n    text-transform: lowercase\n}\n\n#premier-tech-calculator :is(.capitalize) {\n    text-transform: capitalize\n}\n\n#premier-tech-calculator :is(.leading-\\[18px\\]) {\n    line-height: 18px\n}\n\n#premier-tech-calculator :is(.text-darkGray) {\n    --tw-text-opacity: 1;\n    color: rgb(138 141 143/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.text-darkGray-300) {\n    --tw-text-opacity: 1;\n    color: rgb(180 182 183/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.text-error) {\n    --tw-text-opacity: 1;\n    color: rgb(233 52 63 / var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.text-mainBlue) {\n    --tw-text-opacity: 1;\n    color: rgb(4 30 66/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.text-secondaryBlue) {\n    --tw-text-opacity: 1;\n    color: rgb(65 182 230/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.text-sky-800) {\n    --tw-text-opacity: 1;\n    color: rgb(7 89 133/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.text-tertiaryBlue) {\n    --tw-text-opacity: 1;\n    color: rgb(0 119 200/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.text-transparent) {\n    color: transparent\n}\n\n#premier-tech-calculator :is(.text-white) {\n    --tw-text-opacity: 1;\n    color: rgb(255 255 255/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.opacity-50) {\n    opacity: .5\n}\n\n#premier-tech-calculator :is(.shadow-md) {\n    --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -2px rgba(0, 0, 0, .1);\n    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\n    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)\n}\n\n#premier-tech-calculator :is(.shadow-xl) {\n    --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, .1), 0 8px 10px -6px rgba(0, 0, 0, .1);\n    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\n    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)\n}\n\n#premier-tech-calculator :is(.outline) {\n    outline-style: solid\n}\n\n#premier-tech-calculator :is(.ring-2) {\n    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;\n    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)\n}\n\n#premier-tech-calculator :is(.ring-sky-300) {\n    --tw-ring-opacity: 1;\n    --tw-ring-color: rgb(125 211 252/var(--tw-ring-opacity))\n}\n\n#premier-tech-calculator :is(.backdrop-blur-sm) {\n    --tw-backdrop-blur: blur(4px);\n    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);\n    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)\n}\n\n#premier-tech-calculator :is(.transition-all) {\n    transition-duration: .15s;\n    transition-property: all;\n    transition-timing-function: cubic-bezier(.4, 0, .2, 1)\n}\n\n@font-face {\n    font-display: swap;\n    font-family: Axiforma;\n    font-style: normal;\n    font-weight: 700;\n    src: url(/src/assets/fonts/Axiforma-Bold.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-Bold.woff) format(\"woff\"), url(/src/assets/fonts/Axiforma-Bold.ttf) format(\"truetype\")\n}\n\n@font-face {\n    font-display: swap;\n    font-family: Axiforma;\n    font-style: normal;\n    font-weight: 400;\n    src: url(/src/assets/fonts/Axiforma-Regular.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-Regular.woff) format(\"woff\"), url(/src/assets/fonts/Axiforma-Regular.ttf) format(\"truetype\")\n}\n\n#premier-tech-calculator {\n    font-size: 16px !important\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    appearance: none;\n    opacity: 0\n}\n\ninput[type=number] {\n    -moz-appearance: textfield\n}\n\n.arrow-up:after {\n    border-bottom: 5px solid #fff;\n    left: 30px;\n    top: -5px\n}\n\n.arrow-down:after,\n.arrow-up:after {\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    content: \"\";\n    height: 0;\n    position: absolute;\n    width: 0\n}\n\n.arrow-down:after {\n    border-top: 5px solid #fff;\n    left: 25px;\n    top: 20px\n}\n\n@media (min-width: 768px) {\n    .arrow-up:after {\n        border-bottom: 10px solid #fff;\n        left: 35px;\n        top: -10px\n    }\n\n    .arrow-down:after,\n    .arrow-up:after {\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent\n    }\n\n    .arrow-down:after {\n        border-top: 10px solid #fff;\n        left: 30px;\n        top: 35px\n    }\n}\n\n.select-arrow:after {\n    background: url(/src/images/icons/select-arrow-down.svg) 50% no-repeat;\n    content: \"\";\n    height: 6px;\n    position: absolute;\n    right: 0;\n    top: 11px;\n    width: 12px\n}\n\n.result-row>span>span {\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 400;\n    margin-left: 2px\n}\n\n.shine-animate {\n    -webkit-animation: shine 1.5s ease-in-out 1;\n    animation: shine 1.5s ease-in-out 1\n}\n\n@-webkit-keyframes shine {\n    0% {\n        -webkit-filter: brightness(1);\n        filter: brightness(1)\n    }\n\n    25% {\n        -webkit-filter: brightness(1.2);\n        filter: brightness(1.2)\n    }\n\n    50% {\n        -webkit-filter: brightness(.9);\n        filter: brightness(.9)\n    }\n\n    75% {\n        -webkit-filter: brightness(1.25);\n        filter: brightness(1.25)\n    }\n\n    to {\n        -webkit-filter: brightness(1);\n        filter: brightness(1)\n    }\n}\n\n@keyframes shine {\n    0% {\n        -webkit-filter: brightness(1);\n        filter: brightness(1)\n    }\n\n    25% {\n        -webkit-filter: brightness(1.2);\n        filter: brightness(1.2)\n    }\n\n    50% {\n        -webkit-filter: brightness(.9);\n        filter: brightness(.9)\n    }\n\n    75% {\n        -webkit-filter: brightness(1.25);\n        filter: brightness(1.25)\n    }\n\n    to {\n        -webkit-filter: brightness(1);\n        filter: brightness(1)\n    }\n}\n\ninput[type=range]::-webkit-slider-thumb {\n    --tw-border-opacity: 1;\n    --tw-bg-opacity: 1;\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: rgb(223 245 254/var(--tw-bg-opacity));\n    border-color: rgb(65 182 230/var(--tw-border-opacity));\n    border-radius: 9999px;\n    border-style: solid;\n    border-width: 4px;\n    height: 24px;\n    width: 24px\n}\n\ninput[type=range]::-moz-range-thumb {\n    --tw-border-opacity: 1;\n    --tw-bg-opacity: 1;\n    background-color: rgb(223 245 254/var(--tw-bg-opacity));\n    border-color: rgb(65 182 230/var(--tw-border-opacity));\n    border-radius: 9999px;\n    border-style: solid;\n    border-width: 4px;\n    height: 24px;\n    width: 24px\n}\n\n.rc-input-number input {\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: initial;\n    padding: 8px 16px;\n    width: 100%\n}\n\n@media not all and (min-width: 768px) {\n    .view3d__container canvas {\n        height: 100% !important;\n        width: auto !important\n    }\n}\n\n#premier-tech-calculator :is(.invalid\\:border-error:invalid) {\n    --tw-border-opacity: 1;\n    border-color: rgb(233 52 63/var(--tw-border-opacity))\n}\n\n#premier-tech-calculator :is(.hover\\:\\!border-sky-300:hover) {\n    --tw-border-opacity: 1 !important;\n    border-color: rgb(125 211 252/var(--tw-border-opacity)) !important\n}\n\n#premier-tech-calculator :is(.hover\\:bg-mainBlue:hover) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(4 30 66/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.hover\\:bg-secondaryBlue:hover) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(65 182 230/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.hover\\:bg-secondaryBlue-600:hover) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(28 158 211/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.hover\\:text-white:hover) {\n    --tw-text-opacity: 1;\n    color: rgb(255 255 255/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.disabled\\:\\!border-paleGray:disabled) {\n    --tw-border-opacity: 1 !important;\n    border-color: rgb(189 194 201/var(--tw-border-opacity)) !important\n}\n\n#premier-tech-calculator :is(.disabled\\:\\!border-paleGray-400:disabled) {\n    --tw-border-opacity: 1 !important;\n    border-color: rgb(211 215 219/var(--tw-border-opacity)) !important\n}\n\n#premier-tech-calculator :is(.disabled\\:bg-paleGray-300:disabled) {\n    --tw-bg-opacity: 1;\n    background-color: rgb(234 235 238/var(--tw-bg-opacity))\n}\n\n#premier-tech-calculator :is(.disabled\\:text-darkGray:disabled) {\n    --tw-text-opacity: 1;\n    color: rgb(138 141 143/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.disabled\\:text-paleGray:disabled) {\n    --tw-text-opacity: 1;\n    color: rgb(189 194 201/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.disabled\\:text-paleGray-500:disabled) {\n    --tw-text-opacity: 1;\n    color: rgb(189 194 201/var(--tw-text-opacity))\n}\n\n#premier-tech-calculator :is(.disabled\\:shadow-none:disabled) {\n    --tw-shadow: 0 0 #0000;\n    --tw-shadow-colored: 0 0 #0000;\n    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)\n}\n\n@media (min-width: 640px) {\n    #premier-tech-calculator :is(.sm\\:col-span-1) {\n        grid-column: span 1/span 1\n    }\n\n    #premier-tech-calculator :is(.sm\\:\\!my-5) {\n        margin-bottom: 20px !important;\n        margin-top: 20px !important\n    }\n\n    #premier-tech-calculator :is(.sm\\:ml-\\[-400px\\]) {\n        margin-left: -400px\n    }\n\n    #premier-tech-calculator :is(.sm\\:ml-\\[400px\\]) {\n        margin-left: 400px\n    }\n\n    #premier-tech-calculator :is(.sm\\:mt-\\[150px\\]) {\n        margin-top: 150px\n    }\n\n    #premier-tech-calculator :is(.sm\\:mt-\\[300px\\]) {\n        margin-top: 300px\n    }\n\n    #premier-tech-calculator :is(.sm\\:\\!flex) {\n        display: flex !important\n    }\n\n    #premier-tech-calculator :is(.sm\\:flex) {\n        display: flex\n    }\n\n    #premier-tech-calculator :is(.sm\\:grid-cols-2) {\n        grid-template-columns: repeat(2, minmax(0, 1fr))\n    }\n\n    #premier-tech-calculator :is(.sm\\:grid-cols-3) {\n        grid-template-columns: repeat(3, minmax(0, 1fr))\n    }\n\n    #premier-tech-calculator :is(.sm\\:gap-x-4) {\n        -webkit-column-gap: 16px;\n        column-gap: 16px\n    }\n\n    #premier-tech-calculator :is(.sm\\:text-sm) {\n        font-size: 14px\n    }\n}\n\n@media (min-width: 768px) {\n    #premier-tech-calculator :is(.md\\:\\!my-0) {\n        margin-bottom: 0 !important;\n        margin-top: 0 !important\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!my-8) {\n        margin-bottom: 32px !important;\n        margin-top: 32px !important\n    }\n\n    #premier-tech-calculator :is(.md\\:my-0) {\n        margin-bottom: 0;\n        margin-top: 0\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!mb-0) {\n        margin-bottom: 0 !important\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!mb-24) {\n        margin-bottom: 96px !important\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!mr-6) {\n        margin-right: 24px !important\n    }\n\n    #premier-tech-calculator :is(.md\\:ml-\\[-260px\\]) {\n        margin-left: -260px\n    }\n\n    #premier-tech-calculator :is(.md\\:ml-\\[260px\\]) {\n        margin-left: 260px\n    }\n\n    #premier-tech-calculator :is(.md\\:mt-24) {\n        margin-top: 96px\n    }\n\n    #premier-tech-calculator :is(.md\\:mt-\\[230px\\]) {\n        margin-top: 230px\n    }\n\n    #premier-tech-calculator :is(.md\\:mt-\\[75px\\]) {\n        margin-top: 75px\n    }\n\n    #premier-tech-calculator :is(.md\\:flex) {\n        display: flex\n    }\n\n    #premier-tech-calculator :is(.md\\:h-\\[720px\\]) {\n        height: 720px\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!w-auto) {\n        width: auto !important\n    }\n\n    #premier-tech-calculator :is(.md\\:w-2\\/5) {\n        width: 40%\n    }\n\n    #premier-tech-calculator :is(.md\\:w-3\\/5) {\n        width: 60%\n    }\n\n    #premier-tech-calculator :is(.md\\:grid-cols-1) {\n        grid-template-columns: repeat(1, minmax(0, 1fr))\n    }\n\n    #premier-tech-calculator :is(.md\\:grid-cols-3) {\n        grid-template-columns: repeat(3, minmax(0, 1fr))\n    }\n\n    #premier-tech-calculator :is(.md\\:gap-12) {\n        gap: 48px\n    }\n\n    #premier-tech-calculator :is(.md\\:gap-6) {\n        gap: 24px\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!p-0) {\n        padding: 0 !important\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!px-4) {\n        padding-left: 16px !important;\n        padding-right: 16px !important\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!px-6) {\n        padding-left: 24px !important;\n        padding-right: 24px !important\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!px-8) {\n        padding-left: 32px !important;\n        padding-right: 32px !important\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!py-2) {\n        padding-bottom: 8px !important;\n        padding-top: 8px !important\n    }\n\n    #premier-tech-calculator :is(.md\\:\\!py-44) {\n        padding-bottom: 176px !important;\n        padding-top: 176px !important\n    }\n\n    #premier-tech-calculator :is(.md\\:text-sm) {\n        font-size: 14px\n    }\n}\n\n@media (min-width: 1024px) {\n    #premier-tech-calculator :is(.lg\\:\\!mt-0) {\n        margin-top: 0 !important\n    }\n\n    #premier-tech-calculator :is(.lg\\:ml-\\[-310px\\]) {\n        margin-left: -310px\n    }\n\n    #premier-tech-calculator :is(.lg\\:ml-\\[310px\\]) {\n        margin-left: 310px\n    }\n\n    #premier-tech-calculator :is(.lg\\:mt-\\[150px\\]) {\n        margin-top: 150px\n    }\n\n    #premier-tech-calculator :is(.lg\\:mt-\\[280px\\]) {\n        margin-top: 280px\n    }\n\n    #premier-tech-calculator :is(.lg\\:inline-block) {\n        display: inline-block\n    }\n\n    #premier-tech-calculator :is(.lg\\:flex) {\n        display: flex\n    }\n\n    #premier-tech-calculator :is(.lg\\:min-h-\\[720px\\]) {\n        min-height: 720px\n    }\n\n    #premier-tech-calculator :is(.lg\\:w-5\\/12) {\n        width: 41.666667%\n    }\n\n    #premier-tech-calculator :is(.lg\\:w-7\\/12) {\n        width: 58.333333%\n    }\n\n    #premier-tech-calculator :is(.lg\\:basis-\\[155px\\]) {\n        flex-basis: 155px\n    }\n\n    #premier-tech-calculator :is(.lg\\:-translate-y-8) {\n        --tw-translate-y: -32px;\n        -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))\n    }\n\n    #premier-tech-calculator :is(.lg\\:grid-cols-2) {\n        grid-template-columns: repeat(2, minmax(0, 1fr))\n    }\n\n    #premier-tech-calculator :is(.lg\\:grid-cols-4) {\n        grid-template-columns: repeat(4, minmax(0, 1fr))\n    }\n\n    #premier-tech-calculator :is(.lg\\:flex-row) {\n        flex-direction: row\n    }\n\n    #premier-tech-calculator :is(.lg\\:items-start) {\n        align-items: flex-start\n    }\n\n    #premier-tech-calculator :is(.lg\\:text-lg) {\n        font-size: 18px\n    }\n}\n\n@media (min-width: 1280px) {\n    #premier-tech-calculator :is(.xl\\:\\!px-0) {\n        padding-left: 0 !important;\n        padding-right: 0 !important\n    }\n}\n\n#premier-tech-calculator :is(.\\[\\&\\>svg\\>path\\:nth-child\\(1\\)\\]\\:stroke-error>svg>path:first-child) {\n    stroke: #e9343f\n}\n\n#premier-tech-calculator :is(.\\[\\&\\>svg\\>path\\:nth-child\\(2\\)\\]\\:stroke-error>svg>path:nth-child(2)) {\n    stroke: #e9343f\n}\n\n#premier-tech-calculator :is(.\\[\\&\\>svg\\>path\\:nth-child\\(3\\)\\]\\:stroke-error>svg>path:nth-child(3)) {\n    stroke: #e9343f\n}\n\n#premier-tech-calculator :is(.\\[\\&\\>svg\\>path\\:nth-child\\(4\\)\\]\\:stroke-error>svg>path:nth-child(4)) {\n    stroke: #e9343f\n}\n\n.ui-widget {\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 1em;\n}\n\n.ui-widget .ui-widget {\n    font-size: 1em;\n}\n\n.ui-widget input,\n.ui-widget select,\n.ui-widget textarea,\n.ui-widget button {\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 1em;\n}\n\n.ui-widget.ui-widget-content {\n    border: 1px solid #c5c5c5;\n}\n\n.ui-widget-content {\n    border: 1px solid #dddddd;\n    background: #ffffff;\n    color: #333333;\n}\n\n.ui-widget-content a {\n    color: #333333;\n}\n\n.ui-widget-header {\n    border: 1px solid #dddddd;\n    background: #e9e9e9;\n    color: #333333;\n    font-weight: bold;\n}\n\n.ui-widget-header a {\n    color: #333333;\n}\n\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default,\n.ui-button,\nhtml .ui-button.ui-state-disabled:hover,\nhtml .ui-button.ui-state-disabled:active {\n    border: 1px solid #c5c5c5;\n    background: #f6f6f6;\n    font-weight: normal;\n    color: #454545;\n}\n\n.ui-state-default a,\n.ui-state-default a:link,\n.ui-state-default a:visited,\na.ui-button,\na:link.ui-button,\na:visited.ui-button,\n.ui-button {\n    color: #454545;\n    text-decoration: none;\n}\n\n.ui-state-hover,\n.ui-widget-content .ui-state-hover,\n.ui-widget-header .ui-state-hover,\n.ui-state-focus,\n.ui-widget-content .ui-state-focus,\n.ui-widget-header .ui-state-focus,\n.ui-button:hover,\n.ui-button:focus {\n    border: 1px solid #cccccc;\n    background: #ededed;\n    font-weight: normal;\n    color: #2b2b2b;\n}\n\n.ui-state-hover a,\n.ui-state-hover a:hover,\n.ui-state-hover a:link,\n.ui-state-hover a:visited,\n.ui-state-focus a,\n.ui-state-focus a:hover,\n.ui-state-focus a:link,\n.ui-state-focus a:visited,\na.ui-button:hover,\na.ui-button:focus {\n    color: #2b2b2b;\n    text-decoration: none;\n}\n\n.ui-visual-focus {\n    box-shadow: 0 0 3px 1px rgb(94, 158, 214);\n}\n\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active,\na.ui-button:active,\n.ui-button:active,\n.ui-button.ui-state-active:hover {\n    border: 1px solid #003eff;\n    background: #007fff;\n    font-weight: normal;\n    color: #ffffff;\n}\n\n.ui-icon-background,\n.ui-state-active .ui-icon-background {\n    border: #003eff;\n    background-color: #ffffff;\n}\n\n.ui-state-active a,\n.ui-state-active a:link,\n.ui-state-active a:visited {\n    color: #ffffff;\n    text-decoration: none;\n}\n\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n    border: 1px solid #dad55e;\n    background: #fffa90;\n    color: #777620;\n}\n\n.ui-state-checked {\n    border: 1px solid #dad55e;\n    background: #fffa90;\n}\n\n.ui-state-highlight a,\n.ui-widget-content .ui-state-highlight a,\n.ui-widget-header .ui-state-highlight a {\n    color: #777620;\n}\n\n.ui-state-error,\n.ui-widget-content .ui-state-error,\n.ui-widget-header .ui-state-error {\n    border: 1px solid #f1a899;\n    background: #fddfdf;\n    color: #5f3f3f;\n}\n\n.ui-state-error a,\n.ui-widget-content .ui-state-error a,\n.ui-widget-header .ui-state-error a {\n    color: #5f3f3f;\n}\n\n.ui-state-error-text,\n.ui-widget-content .ui-state-error-text,\n.ui-widget-header .ui-state-error-text {\n    color: #5f3f3f;\n}\n\n.ui-priority-primary,\n.ui-widget-content .ui-priority-primary,\n.ui-widget-header .ui-priority-primary {\n    font-weight: bold;\n}\n\n.ui-priority-secondary,\n.ui-widget-content .ui-priority-secondary,\n.ui-widget-header .ui-priority-secondary {\n    opacity: .7;\n    -ms-filter: \"alpha(opacity=70)\";\n    font-weight: normal;\n}\n\n.ui-state-disabled,\n.ui-widget-content .ui-state-disabled,\n.ui-widget-header .ui-state-disabled {\n    opacity: .35;\n    -ms-filter: \"alpha(opacity=35)\";\n    background-image: none;\n}\n\n.ui-state-disabled .ui-icon {\n    -ms-filter: \"alpha(opacity=35)\";\n}\n\n.ui-icon {\n    width: 16px;\n    height: 16px;\n}\n\n/* \n.ui-icon,\n.ui-widget-content .ui-icon {\n    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_444444_256x240.png);\n}\n\n.ui-widget-header .ui-icon {\n    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_444444_256x240.png);\n} */\n/* \n.ui-state-hover .ui-icon,\n.ui-state-focus .ui-icon,\n.ui-button:hover .ui-icon,\n.ui-button:focus .ui-icon {\n    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_555555_256x240.png);\n}\n\n.ui-state-active .ui-icon,\n.ui-button:active .ui-icon {\n    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_ffffff_256x240.png);\n}\n\n.ui-state-highlight .ui-icon,\n.ui-button .ui-state-highlight.ui-icon {\n    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_777620_256x240.png);\n}\n\n.ui-state-error .ui-icon,\n.ui-state-error-text .ui-icon {\n    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_cc0000_256x240.png);\n}\n\n.ui-button .ui-icon {\n    background-image: url(/core/assets/vendor/jquery.ui/themes/base/images/ui-icons_777777_256x240.png);\n} */\n\n.ui-icon-blank.ui-icon-blank.ui-icon-blank {\n    background-image: none;\n}\n\n.ui-icon-caret-1-n {\n    background-position: 0 0;\n}\n\n.ui-icon-caret-1-ne {\n    background-position: -16px 0;\n}\n\n.ui-icon-caret-1-e {\n    background-position: -32px 0;\n}\n\n.ui-icon-caret-1-se {\n    background-position: -48px 0;\n}\n\n.ui-icon-caret-1-s {\n    background-position: -65px 0;\n}\n\n.ui-icon-caret-1-sw {\n    background-position: -80px 0;\n}\n\n.ui-icon-caret-1-w {\n    background-position: -96px 0;\n}\n\n.ui-icon-caret-1-nw {\n    background-position: -112px 0;\n}\n\n.ui-icon-caret-2-n-s {\n    background-position: -128px 0;\n}\n\n.ui-icon-caret-2-e-w {\n    background-position: -144px 0;\n}\n\n.ui-icon-triangle-1-n {\n    background-position: 0 -16px;\n}\n\n.ui-icon-triangle-1-ne {\n    background-position: -16px -16px;\n}\n\n.ui-icon-triangle-1-e {\n    background-position: -32px -16px;\n}\n\n.ui-icon-triangle-1-se {\n    background-position: -48px -16px;\n}\n\n.ui-icon-triangle-1-s {\n    background-position: -65px -16px;\n}\n\n.ui-icon-triangle-1-sw {\n    background-position: -80px -16px;\n}\n\n.ui-icon-triangle-1-w {\n    background-position: -96px -16px;\n}\n\n.ui-icon-triangle-1-nw {\n    background-position: -112px -16px;\n}\n\n.ui-icon-triangle-2-n-s {\n    background-position: -128px -16px;\n}\n\n.ui-icon-triangle-2-e-w {\n    background-position: -144px -16px;\n}\n\n.ui-icon-arrow-1-n {\n    background-position: 0 -32px;\n}\n\n.ui-icon-arrow-1-ne {\n    background-position: -16px -32px;\n}\n\n.ui-icon-arrow-1-e {\n    background-position: -32px -32px;\n}\n\n.ui-icon-arrow-1-se {\n    background-position: -48px -32px;\n}\n\n.ui-icon-arrow-1-s {\n    background-position: -65px -32px;\n}\n\n.ui-icon-arrow-1-sw {\n    background-position: -80px -32px;\n}\n\n.ui-icon-arrow-1-w {\n    background-position: -96px -32px;\n}\n\n.ui-icon-arrow-1-nw {\n    background-position: -112px -32px;\n}\n\n.ui-icon-arrow-2-n-s {\n    background-position: -128px -32px;\n}\n\n.ui-icon-arrow-2-ne-sw {\n    background-position: -144px -32px;\n}\n\n.ui-icon-arrow-2-e-w {\n    background-position: -160px -32px;\n}\n\n.ui-icon-arrow-2-se-nw {\n    background-position: -176px -32px;\n}\n\n.ui-icon-arrowstop-1-n {\n    background-position: -192px -32px;\n}\n\n.ui-icon-arrowstop-1-e {\n    background-position: -208px -32px;\n}\n\n.ui-icon-arrowstop-1-s {\n    background-position: -224px -32px;\n}\n\n.ui-icon-arrowstop-1-w {\n    background-position: -240px -32px;\n}\n\n.ui-icon-arrowthick-1-n {\n    background-position: 1px -48px;\n}\n\n.ui-icon-arrowthick-1-ne {\n    background-position: -16px -48px;\n}\n\n.ui-icon-arrowthick-1-e {\n    background-position: -32px -48px;\n}\n\n.ui-icon-arrowthick-1-se {\n    background-position: -48px -48px;\n}\n\n.ui-icon-arrowthick-1-s {\n    background-position: -64px -48px;\n}\n\n.ui-icon-arrowthick-1-sw {\n    background-position: -80px -48px;\n}\n\n.ui-icon-arrowthick-1-w {\n    background-position: -96px -48px;\n}\n\n.ui-icon-arrowthick-1-nw {\n    background-position: -112px -48px;\n}\n\n.ui-icon-arrowthick-2-n-s {\n    background-position: -128px -48px;\n}\n\n.ui-icon-arrowthick-2-ne-sw {\n    background-position: -144px -48px;\n}\n\n.ui-icon-arrowthick-2-e-w {\n    background-position: -160px -48px;\n}\n\n.ui-icon-arrowthick-2-se-nw {\n    background-position: -176px -48px;\n}\n\n.ui-icon-arrowthickstop-1-n {\n    background-position: -192px -48px;\n}\n\n.ui-icon-arrowthickstop-1-e {\n    background-position: -208px -48px;\n}\n\n.ui-icon-arrowthickstop-1-s {\n    background-position: -224px -48px;\n}\n\n.ui-icon-arrowthickstop-1-w {\n    background-position: -240px -48px;\n}\n\n.ui-icon-arrowreturnthick-1-w {\n    background-position: 0 -64px;\n}\n\n.ui-icon-arrowreturnthick-1-n {\n    background-position: -16px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-e {\n    background-position: -32px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-s {\n    background-position: -48px -64px;\n}\n\n.ui-icon-arrowreturn-1-w {\n    background-position: -64px -64px;\n}\n\n.ui-icon-arrowreturn-1-n {\n    background-position: -80px -64px;\n}\n\n.ui-icon-arrowreturn-1-e {\n    background-position: -96px -64px;\n}\n\n.ui-icon-arrowreturn-1-s {\n    background-position: -112px -64px;\n}\n\n.ui-icon-arrowrefresh-1-w {\n    background-position: -128px -64px;\n}\n\n.ui-icon-arrowrefresh-1-n {\n    background-position: -144px -64px;\n}\n\n.ui-icon-arrowrefresh-1-e {\n    background-position: -160px -64px;\n}\n\n.ui-icon-arrowrefresh-1-s {\n    background-position: -176px -64px;\n}\n\n.ui-icon-arrow-4 {\n    background-position: 0 -80px;\n}\n\n.ui-icon-arrow-4-diag {\n    background-position: -16px -80px;\n}\n\n.ui-icon-extlink {\n    background-position: -32px -80px;\n}\n\n.ui-icon-newwin {\n    background-position: -48px -80px;\n}\n\n.ui-icon-refresh {\n    background-position: -64px -80px;\n}\n\n.ui-icon-shuffle {\n    background-position: -80px -80px;\n}\n\n.ui-icon-transfer-e-w {\n    background-position: -96px -80px;\n}\n\n.ui-icon-transferthick-e-w {\n    background-position: -112px -80px;\n}\n\n.ui-icon-folder-collapsed {\n    background-position: 0 -96px;\n}\n\n.ui-icon-folder-open {\n    background-position: -16px -96px;\n}\n\n.ui-icon-document {\n    background-position: -32px -96px;\n}\n\n.ui-icon-document-b {\n    background-position: -48px -96px;\n}\n\n.ui-icon-note {\n    background-position: -64px -96px;\n}\n\n.ui-icon-mail-closed {\n    background-position: -80px -96px;\n}\n\n.ui-icon-mail-open {\n    background-position: -96px -96px;\n}\n\n.ui-icon-suitcase {\n    background-position: -112px -96px;\n}\n\n.ui-icon-comment {\n    background-position: -128px -96px;\n}\n\n.ui-icon-person {\n    background-position: -144px -96px;\n}\n\n.ui-icon-print {\n    background-position: -160px -96px;\n}\n\n.ui-icon-trash {\n    background-position: -176px -96px;\n}\n\n.ui-icon-locked {\n    background-position: -192px -96px;\n}\n\n.ui-icon-unlocked {\n    background-position: -208px -96px;\n}\n\n.ui-icon-bookmark {\n    background-position: -224px -96px;\n}\n\n.ui-icon-tag {\n    background-position: -240px -96px;\n}\n\n.ui-icon-home {\n    background-position: 0 -112px;\n}\n\n.ui-icon-flag {\n    background-position: -16px -112px;\n}\n\n.ui-icon-calendar {\n    background-position: -32px -112px;\n}\n\n.ui-icon-cart {\n    background-position: -48px -112px;\n}\n\n.ui-icon-pencil {\n    background-position: -64px -112px;\n}\n\n.ui-icon-clock {\n    background-position: -80px -112px;\n}\n\n.ui-icon-disk {\n    background-position: -96px -112px;\n}\n\n.ui-icon-calculator {\n    background-position: -112px -112px;\n}\n\n.ui-icon-zoomin {\n    background-position: -128px -112px;\n}\n\n.ui-icon-zoomout {\n    background-position: -144px -112px;\n}\n\n.ui-icon-search {\n    background-position: -160px -112px;\n}\n\n.ui-icon-wrench {\n    background-position: -176px -112px;\n}\n\n.ui-icon-gear {\n    background-position: -192px -112px;\n}\n\n.ui-icon-heart {\n    background-position: -208px -112px;\n}\n\n.ui-icon-star {\n    background-position: -224px -112px;\n}\n\n.ui-icon-link {\n    background-position: -240px -112px;\n}\n\n.ui-icon-cancel {\n    background-position: 0 -128px;\n}\n\n.ui-icon-plus {\n    background-position: -16px -128px;\n}\n\n.ui-icon-plusthick {\n    background-position: -32px -128px;\n}\n\n.ui-icon-minus {\n    background-position: -48px -128px;\n}\n\n.ui-icon-minusthick {\n    background-position: -64px -128px;\n}\n\n.ui-icon-close {\n    background-position: -80px -128px;\n}\n\n.ui-icon-closethick {\n    background-position: -96px -128px;\n}\n\n.ui-icon-key {\n    background-position: -112px -128px;\n}\n\n.ui-icon-lightbulb {\n    background-position: -128px -128px;\n}\n\n.ui-icon-scissors {\n    background-position: -144px -128px;\n}\n\n.ui-icon-clipboard {\n    background-position: -160px -128px;\n}\n\n.ui-icon-copy {\n    background-position: -176px -128px;\n}\n\n.ui-icon-contact {\n    background-position: -192px -128px;\n}\n\n.ui-icon-image {\n    background-position: -208px -128px;\n}\n\n.ui-icon-video {\n    background-position: -224px -128px;\n}\n\n.ui-icon-script {\n    background-position: -240px -128px;\n}\n\n.ui-icon-alert {\n    background-position: 0 -144px;\n}\n\n.ui-icon-info {\n    background-position: -16px -144px;\n}\n\n.ui-icon-notice {\n    background-position: -32px -144px;\n}\n\n.ui-icon-help {\n    background-position: -48px -144px;\n}\n\n.ui-icon-check {\n    background-position: -64px -144px;\n}\n\n.ui-icon-bullet {\n    background-position: -80px -144px;\n}\n\n.ui-icon-radio-on {\n    background-position: -96px -144px;\n}\n\n.ui-icon-radio-off {\n    background-position: -112px -144px;\n}\n\n.ui-icon-pin-w {\n    background-position: -128px -144px;\n}\n\n.ui-icon-pin-s {\n    background-position: -144px -144px;\n}\n\n.ui-icon-play {\n    background-position: 0 -160px;\n}\n\n.ui-icon-pause {\n    background-position: -16px -160px;\n}\n\n.ui-icon-seek-next {\n    background-position: -32px -160px;\n}\n\n.ui-icon-seek-prev {\n    background-position: -48px -160px;\n}\n\n.ui-icon-seek-end {\n    background-position: -64px -160px;\n}\n\n.ui-icon-seek-start {\n    background-position: -80px -160px;\n}\n\n.ui-icon-seek-first {\n    background-position: -80px -160px;\n}\n\n.ui-icon-stop {\n    background-position: -96px -160px;\n}\n\n.ui-icon-eject {\n    background-position: -112px -160px;\n}\n\n.ui-icon-volume-off {\n    background-position: -128px -160px;\n}\n\n.ui-icon-volume-on {\n    background-position: -144px -160px;\n}\n\n.ui-icon-power {\n    background-position: 0 -176px;\n}\n\n.ui-icon-signal-diag {\n    background-position: -16px -176px;\n}\n\n.ui-icon-signal {\n    background-position: -32px -176px;\n}\n\n.ui-icon-battery-0 {\n    background-position: -48px -176px;\n}\n\n.ui-icon-battery-1 {\n    background-position: -64px -176px;\n}\n\n.ui-icon-battery-2 {\n    background-position: -80px -176px;\n}\n\n.ui-icon-battery-3 {\n    background-position: -96px -176px;\n}\n\n.ui-icon-circle-plus {\n    background-position: 0 -192px;\n}\n\n.ui-icon-circle-minus {\n    background-position: -16px -192px;\n}\n\n.ui-icon-circle-close {\n    background-position: -32px -192px;\n}\n\n.ui-icon-circle-triangle-e {\n    background-position: -48px -192px;\n}\n\n.ui-icon-circle-triangle-s {\n    background-position: -64px -192px;\n}\n\n.ui-icon-circle-triangle-w {\n    background-position: -80px -192px;\n}\n\n.ui-icon-circle-triangle-n {\n    background-position: -96px -192px;\n}\n\n.ui-icon-circle-arrow-e {\n    background-position: -112px -192px;\n}\n\n.ui-icon-circle-arrow-s {\n    background-position: -128px -192px;\n}\n\n.ui-icon-circle-arrow-w {\n    background-position: -144px -192px;\n}\n\n.ui-icon-circle-arrow-n {\n    background-position: -160px -192px;\n}\n\n.ui-icon-circle-zoomin {\n    background-position: -176px -192px;\n}\n\n.ui-icon-circle-zoomout {\n    background-position: -192px -192px;\n}\n\n.ui-icon-circle-check {\n    background-position: -208px -192px;\n}\n\n.ui-icon-circlesmall-plus {\n    background-position: 0 -208px;\n}\n\n.ui-icon-circlesmall-minus {\n    background-position: -16px -208px;\n}\n\n.ui-icon-circlesmall-close {\n    background-position: -32px -208px;\n}\n\n.ui-icon-squaresmall-plus {\n    background-position: -48px -208px;\n}\n\n.ui-icon-squaresmall-minus {\n    background-position: -64px -208px;\n}\n\n.ui-icon-squaresmall-close {\n    background-position: -80px -208px;\n}\n\n.ui-icon-grip-dotted-vertical {\n    background-position: 0 -224px;\n}\n\n.ui-icon-grip-dotted-horizontal {\n    background-position: -16px -224px;\n}\n\n.ui-icon-grip-solid-vertical {\n    background-position: -32px -224px;\n}\n\n.ui-icon-grip-solid-horizontal {\n    background-position: -48px -224px;\n}\n\n.ui-icon-gripsmall-diagonal-se {\n    background-position: -64px -224px;\n}\n\n.ui-icon-grip-diagonal-se {\n    background-position: -80px -224px;\n}\n\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-left,\n.ui-corner-tl {\n    border-top-left-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-right,\n.ui-corner-tr {\n    border-top-right-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-left,\n.ui-corner-bl {\n    border-bottom-left-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-right,\n.ui-corner-br {\n    border-bottom-right-radius: 3px;\n}\n\n.ui-widget-overlay {\n    background: #aaaaaa;\n    opacity: .3;\n    -ms-filter: \"alpha(opacity=30)\";\n}\n\n.ui-widget-shadow {\n    -webkit-box-shadow: 0 0 5px #666666;\n    box-shadow: 0 0 5px #666666;\n}\n\n.theme-100 .pt-global-footer {\n    background-color: #000000;\n}\n\n.pt-global-footer {\n    position: relative;\n    display: flex;\n    background-color: #041e42;\n    color: #fff;\n    padding: 16px 21px;\n    z-index: 1000;\n}\n\n.layout-builder-block .pt-global-footer {\n    z-index: 499;\n}\n\n.pt-global-footer-logo {\n    max-width: 200px\n}\n\n.pt-global-footer-logo a {\n    display: flex;\n    align-items: center\n}\n\n.pt-global-footer-logo a #pt-global-footer-logo-pt {\n    width: 100%\n}\n\n.pt-global-footer-logo a #pt-global-footer-logo-secondaire {\n    height: 42px;\n    margin-left: 8px\n}\n\n.pt-global-footer-menu {\n    padding: 0;\n    margin: 0 0 0 126px;\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n}\n\n.pt-global-footer-menu-element {\n    padding-right: 30px;\n    display: flex;\n    align-items: center;\n}\n\n.pt-global-footer-menu-link {\n    color: #fff;\n    text-decoration: none;\n    transition: 0.3s color ease;\n    font-size: 14px;\n    font-weight: 400;\n    letter-spacing: 0.02em;\n}\n\nspan.pt-global-footer-menu-link {\n    font-size: 14px !important;\n}\n\n.pt-global-footer-menu-link:hover {\n    color: #41b6e6;\n    text-decoration: none;\n}\n\nspan.pt-global-footer-menu-link:hover {\n    color: #41b6e6 !important;\n    text-decoration: none;\n}\n\n.pt-global-footer-text {\n    margin-left: auto;\n}\n\n@media screen and (max-width: 768px) {\n    .pt-global-footer {\n        flex-direction: column;\n        padding: 0;\n    }\n\n    .pt-global-footer-menu {\n        order: 0;\n        margin: 0;\n        border-bottom: 2px solid #364B68;\n        padding: 16px 17px 0;\n    }\n\n    .pt-global-footer-menu-element {\n        margin-bottom: 16px;\n    }\n\n    .pt-global-footer-logo {\n        order: 1;\n        margin: 0;\n        max-width: 150px;\n        padding: 10px 12px;\n        flex: 0 0 auto;\n    }\n\n    .pt-global-footer-menu-link {\n        font-size: 12px;\n    }\n\n    span.pt-global-footer-menu-link {\n        font-size: 12px !important;\n        margin-bottom: 0 !important;\n    }\n}\n\n/* @license GPL-2.0-or-later https://www.drupal.org/licensing/faq */\n:root {\n    --secondary-font: Axiforma;\n    --link-decoration: none;\n    --link-color: #0077C8;\n    --link-hover-color: #0060A1;\n    --btn-txt-color: #041E42;\n    --text-color: #041E42\n}\n\n.webform-confirmation-modal--content,\n.wysiwyg {\n    --link-decoration: underline\n}\n\n:root {\n    --color-light-blue: hsl(197.4545454545deg, 76.7441860465%, 57.8431372549%);\n    --color-light-blue-h: 197.4545454545deg;\n    --color-light-blue-s: 76.7441860465%;\n    --color-light-blue-l: 57.8431372549%;\n    --color-dark-blue: hsl(214.8387096774deg, 88.5714285714%, 13.7254901961%);\n    --color-dark-blue-h: 214.8387096774deg;\n    --color-dark-blue-s: 88.5714285714%;\n    --color-dark-blue-l: 13.7254901961%;\n    --color-white: #FFFFFF;\n    --color-other-light-blue: #41B6E6\n}\n\n.fill-light-blue-var {\n    fill: var(--color-light-blue)\n}\n\n.pt-fill-blue-primary {\n    fill: #041e42\n}\n\n.pt-fill-white-secondary {\n    fill: #fff\n}\n\n.pt-fill-light-blue-secondary {\n    fill: #41b6e6\n}\n\n.pt-fill-grey-secondary {\n    fill: #8a8d8f\n}\n\n.pt-fill-light-blue-tertiary {\n    fill: #0077c8\n}\n\n.pt-fill-blue-tertiary {\n    fill: #04325e\n}\n\n.pt-fill-grey-tertiary {\n    fill: #54585a\n}\n\n.pt-fill-white-tertiary {\n    fill: #f2f6f8\n}\n\n.liveline-fill-primary {\n    fill: #1791f9\n}\n\n.liveline-fill-secondary {\n    fill: #4ffafe\n}\n\n.pt-fill-green {\n    fill: #00a84f\n}\n\n.pt-fill-red {\n    fill: #e21b23\n}\n\n.pt-fill-orange {\n    fill: #f05c22\n}\n\n.pt-fill-yellow {\n    fill: #fcba30\n}\n\n.pt-fill-black {\n    fill: #000\n}\n\n:root {\n    --blue: #007bff;\n    --indigo: #6610f2;\n    --purple: #6f42c1;\n    --pink: #e83e8c;\n    --red: #dc3545;\n    --orange: #fd7e14;\n    --yellow: #ffc107;\n    --green: #28a745;\n    --teal: #20c997;\n    --cyan: #17a2b8;\n    --white: #fff;\n    --gray: #6c757d;\n    --gray-dark: #343a40;\n    --primary: #007bff;\n    --secondary: #6c757d;\n    --success: #28a745;\n    --info: #17a2b8;\n    --warning: #ffc107;\n    --danger: #dc3545;\n    --light: #f8f9fa;\n    --dark: #343a40;\n    --breakpoint-xs: 0;\n    --breakpoint-sm: 576px;\n    --breakpoint-md: 768px;\n    --breakpoint-lg: 992px;\n    --breakpoint-xl: 1200px;\n    --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace\n}\n\n*,\n::after,\n::before {\n    box-sizing: border-box\n}\n\nhtml {\n    font-family: sans-serif;\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n    -webkit-tap-highlight-color: transparent\n}\n\narticle,\naside,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n    display: block\n}\n\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1.6rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    text-align: left;\n    background-color: #fff\n}\n\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n    outline: 0 !important\n}\n\nhr {\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-top: 0;\n    margin-bottom: .8rem\n}\n\np {\n    margin-top: 0;\n    margin-bottom: 1.6rem\n}\n\nabbr[data-original-title],\nabbr[title] {\n    text-decoration: underline;\n    text-decoration: underline dotted;\n    cursor: help;\n    border-bottom: 0;\n    text-decoration-skip-ink: none\n}\n\naddress {\n    margin-bottom: 1rem;\n    font-style: normal;\n    line-height: inherit\n}\n\ndl,\nol,\nul {\n    margin-top: 0;\n    margin-bottom: 1rem\n}\n\nol ol,\nol ul,\nul ol,\nul ul {\n    margin-bottom: 0\n}\n\ndt {\n    font-weight: 700\n}\n\ndd {\n    margin-bottom: .5rem;\n    margin-left: 0\n}\n\nblockquote {\n    margin: 0 0 1rem\n}\n\nb,\nstrong {\n    font-weight: bolder\n}\n\nsmall {\n    font-size: 80%\n}\n\nsub,\nsup {\n    position: relative;\n    font-size: 75%;\n    line-height: 0;\n    vertical-align: baseline\n}\n\nsub {\n    bottom: -.25em\n}\n\nsup {\n    top: -.5em\n}\n\na {\n    color: var(--link-color);\n    text-decoration: var(--link-decoration);\n    background-color: transparent\n}\n\na:hover {\n    color: var(--link-hover-color);\n    text-decoration: var(--link-decoration)\n}\n\na:not([href]) {\n    color: inherit;\n    text-decoration: none\n}\n\na:not([href]):hover {\n    color: inherit;\n    text-decoration: none\n}\n\ncode,\nkbd,\npre,\nsamp {\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    font-size: 1em\n}\n\npre {\n    margin-top: 0;\n    margin-bottom: 1rem;\n    overflow: auto\n}\n\nfigure {\n    margin: 0 0 1rem\n}\n\nimg {\n    vertical-align: middle;\n    border-style: none\n}\n\nsvg {\n    overflow: hidden;\n    vertical-align: middle\n}\n\ntable {\n    border-collapse: collapse\n}\n\ncaption {\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n    color: #6c757d;\n    text-align: left;\n    caption-side: bottom\n}\n\nth {\n    text-align: inherit\n}\n\n.table-wrapper {\n    overflow: auto\n}\n\nlabel {\n    display: inline-block;\n    margin-bottom: .5rem\n}\n\nbutton {\n    border-radius: 0\n}\n\nbutton:focus {\n    outline: 1px dotted;\n    outline: 5px auto -webkit-focus-ring-color\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit\n}\n\nbutton,\ninput {\n    overflow: visible\n}\n\nbutton,\nselect {\n    text-transform: none\n}\n\nselect {\n    word-wrap: normal\n}\n\n[type=button],\n[type=reset],\n[type=submit],\nbutton {\n    -webkit-appearance: button\n}\n\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled),\nbutton:not(:disabled) {\n    cursor: pointer\n}\n\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner,\nbutton::-moz-focus-inner {\n    padding: 0;\n    border-style: none\n}\n\ninput[type=checkbox],\ninput[type=radio] {\n    box-sizing: border-box;\n    padding: 0\n}\n\ninput[type=date],\ninput[type=datetime-local],\ninput[type=month],\ninput[type=time] {\n    -webkit-appearance: listbox\n}\n\ntextarea {\n    overflow: auto;\n    resize: vertical\n}\n\nfieldset {\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0\n}\n\nlegend {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n    margin-bottom: .5rem;\n    font-size: 1.5rem;\n    line-height: inherit;\n    color: inherit;\n    white-space: normal\n}\n\nprogress {\n    vertical-align: baseline\n}\n\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n    height: auto\n}\n\n[type=search] {\n    outline-offset: -2px;\n    -webkit-appearance: none\n}\n\n[type=search]::-webkit-search-decoration {\n    -webkit-appearance: none\n}\n\n::-webkit-file-upload-button {\n    font: inherit;\n    -webkit-appearance: button\n}\n\noutput {\n    display: inline-block\n}\n\nsummary {\n    display: list-item;\n    cursor: pointer\n}\n\ntemplate {\n    display: none\n}\n\n[hidden] {\n    display: none !important\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-bottom: .8rem;\n    font-weight: 500;\n    line-height: 1.2\n}\n\n.h1,\nh1 {\n    font-size: 4rem\n}\n\n.h2,\nh2 {\n    font-size: 3.2rem\n}\n\n.h3,\nh3 {\n    font-size: 2.8rem\n}\n\n.h4,\nh4 {\n    font-size: 2.4rem\n}\n\n.h5,\nh5 {\n    font-size: 2rem\n}\n\n.h6,\nh6 {\n    font-size: 1.6rem\n}\n\n.lead {\n    font-size: 2rem;\n    font-weight: 300\n}\n\n.display-1 {\n    font-size: 6rem;\n    font-weight: 300;\n    line-height: 1.2\n}\n\n.display-2 {\n    font-size: 5.5rem;\n    font-weight: 300;\n    line-height: 1.2\n}\n\n.display-3 {\n    font-size: 4.5rem;\n    font-weight: 300;\n    line-height: 1.2\n}\n\n.display-4 {\n    font-size: 3.5rem;\n    font-weight: 300;\n    line-height: 1.2\n}\n\nhr {\n    margin-top: 1.6rem;\n    margin-bottom: 1.6rem;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, .1)\n}\n\n.small,\nsmall {\n    font-size: 80%;\n    font-weight: 400\n}\n\n.mark,\nmark {\n    padding: .2em;\n    background-color: #fcf8e3\n}\n\n.list-unstyled {\n    padding-left: 0;\n    list-style: none\n}\n\n.list-inline {\n    padding-left: 0;\n    list-style: none\n}\n\n.list-inline-item {\n    display: inline-block\n}\n\n.list-inline-item:not(:last-child) {\n    margin-right: .5rem\n}\n\n.initialism {\n    font-size: 90%;\n    text-transform: uppercase\n}\n\n.blockquote {\n    margin-bottom: 1.6rem;\n    font-size: 2rem\n}\n\n.blockquote-footer {\n    display: block;\n    font-size: 80%;\n    color: #6c757d\n}\n\n.blockquote-footer::before {\n    content: \"— \"\n}\n\ncode {\n    font-size: 87.5%;\n    color: #e83e8c;\n    word-wrap: break-word\n}\n\na>code {\n    color: inherit\n}\n\nkbd {\n    padding: .2rem .4rem;\n    font-size: 87.5%;\n    color: #fff;\n    background-color: #212529;\n    border-radius: .2rem\n}\n\nkbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700\n}\n\npre {\n    display: block;\n    font-size: 87.5%;\n    color: #212529\n}\n\npre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal\n}\n\n.pre-scrollable {\n    max-height: 340px;\n    overflow-y: scroll\n}\n\n.container {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto\n}\n\n@media (min-width: 576px) {\n    .container {\n        max-width: 540px\n    }\n}\n\n@media (min-width: 768px) {\n    .container {\n        max-width: 720px\n    }\n}\n\n@media (min-width: 992px) {\n    .container {\n        max-width: 960px\n    }\n}\n\n@media (min-width: 1200px) {\n    .container {\n        max-width: 1140px\n    }\n}\n\n.container-fluid,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto\n}\n\n@media (min-width: 576px) {\n\n    .container,\n    .container-sm {\n        max-width: 540px\n    }\n}\n\n@media (min-width: 768px) {\n\n    .container,\n    .container-md,\n    .container-sm {\n        max-width: 720px\n    }\n}\n\n@media (min-width: 992px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm {\n        max-width: 960px\n    }\n}\n\n@media (min-width: 1200px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl {\n        max-width: 1140px\n    }\n}\n\n.row {\n    display: flex;\n    flex-wrap: wrap;\n    margin-right: -15px;\n    margin-left: -15px\n}\n\n.no-gutters {\n    margin-right: 0;\n    margin-left: 0\n}\n\n.no-gutters>.col,\n.no-gutters>[class*=col-] {\n    padding-right: 0;\n    padding-left: 0\n}\n\n.col,\n.col-1,\n.col-10,\n.col-11,\n.col-12,\n.col-2,\n.col-3,\n.col-4,\n.col-5,\n.col-6,\n.col-7,\n.col-8,\n.col-9,\n.col-auto,\n.col-lg,\n.col-lg-1,\n.col-lg-10,\n.col-lg-11,\n.col-lg-12,\n.col-lg-2,\n.col-lg-3,\n.col-lg-4,\n.col-lg-5,\n.col-lg-6,\n.col-lg-7,\n.col-lg-8,\n.col-lg-9,\n.col-lg-auto,\n.col-md,\n.col-md-1,\n.col-md-10,\n.col-md-11,\n.col-md-12,\n.col-md-2,\n.col-md-3,\n.col-md-4,\n.col-md-5,\n.col-md-6,\n.col-md-7,\n.col-md-8,\n.col-md-9,\n.col-md-auto,\n.col-sm,\n.col-sm-1,\n.col-sm-10,\n.col-sm-11,\n.col-sm-12,\n.col-sm-2,\n.col-sm-3,\n.col-sm-4,\n.col-sm-5,\n.col-sm-6,\n.col-sm-7,\n.col-sm-8,\n.col-sm-9,\n.col-sm-auto,\n.col-xl,\n.col-xl-1,\n.col-xl-10,\n.col-xl-11,\n.col-xl-12,\n.col-xl-2,\n.col-xl-3,\n.col-xl-4,\n.col-xl-5,\n.col-xl-6,\n.col-xl-7,\n.col-xl-8,\n.col-xl-9,\n.col-xl-auto {\n    position: relative;\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px\n}\n\n.col {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%\n}\n\n.row-cols-1>* {\n    flex: 0 0 100%;\n    max-width: 100%\n}\n\n.row-cols-2>* {\n    flex: 0 0 50%;\n    max-width: 50%\n}\n\n.row-cols-3>* {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%\n}\n\n.row-cols-4>* {\n    flex: 0 0 25%;\n    max-width: 25%\n}\n\n.row-cols-5>* {\n    flex: 0 0 20%;\n    max-width: 20%\n}\n\n.row-cols-6>* {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%\n}\n\n.col-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%\n}\n\n.col-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%\n}\n\n.col-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%\n}\n\n.col-3 {\n    flex: 0 0 25%;\n    max-width: 25%\n}\n\n.col-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%\n}\n\n.col-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%\n}\n\n.col-6 {\n    flex: 0 0 50%;\n    max-width: 50%\n}\n\n.col-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%\n}\n\n.col-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%\n}\n\n.col-9 {\n    flex: 0 0 75%;\n    max-width: 75%\n}\n\n.col-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%\n}\n\n.col-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%\n}\n\n.col-12 {\n    flex: 0 0 100%;\n    max-width: 100%\n}\n\n.order-first {\n    order: -1\n}\n\n.order-last {\n    order: 13\n}\n\n.order-0 {\n    order: 0\n}\n\n.order-1 {\n    order: 1\n}\n\n.order-2 {\n    order: 2\n}\n\n.order-3 {\n    order: 3\n}\n\n.order-4 {\n    order: 4\n}\n\n.order-5 {\n    order: 5\n}\n\n.order-6 {\n    order: 6\n}\n\n.order-7 {\n    order: 7\n}\n\n.order-8 {\n    order: 8\n}\n\n.order-9 {\n    order: 9\n}\n\n.order-10 {\n    order: 10\n}\n\n.order-11 {\n    order: 11\n}\n\n.order-12 {\n    order: 12\n}\n\n.offset-1 {\n    margin-left: 8.3333333333%\n}\n\n.offset-2 {\n    margin-left: 16.6666666667%\n}\n\n.offset-3 {\n    margin-left: 25%\n}\n\n.offset-4 {\n    margin-left: 33.3333333333%\n}\n\n.offset-5 {\n    margin-left: 41.6666666667%\n}\n\n.offset-6 {\n    margin-left: 50%\n}\n\n.offset-7 {\n    margin-left: 58.3333333333%\n}\n\n.offset-8 {\n    margin-left: 66.6666666667%\n}\n\n.offset-9 {\n    margin-left: 75%\n}\n\n.offset-10 {\n    margin-left: 83.3333333333%\n}\n\n.offset-11 {\n    margin-left: 91.6666666667%\n}\n\n@media (min-width: 576px) {\n    .col-sm {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%\n    }\n\n    .row-cols-sm-1>* {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .row-cols-sm-2>* {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .row-cols-sm-3>* {\n        flex: 0 0 33.3333333333%;\n        max-width: 33.3333333333%\n    }\n\n    .row-cols-sm-4>* {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .row-cols-sm-5>* {\n        flex: 0 0 20%;\n        max-width: 20%\n    }\n\n    .row-cols-sm-6>* {\n        flex: 0 0 16.6666666667%;\n        max-width: 16.6666666667%\n    }\n\n    .col-sm-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%\n    }\n\n    .col-sm-1 {\n        flex: 0 0 8.3333333333%;\n        max-width: 8.3333333333%\n    }\n\n    .col-sm-2 {\n        flex: 0 0 16.6666666667%;\n        max-width: 16.6666666667%\n    }\n\n    .col-sm-3 {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .col-sm-4 {\n        flex: 0 0 33.3333333333%;\n        max-width: 33.3333333333%\n    }\n\n    .col-sm-5 {\n        flex: 0 0 41.6666666667%;\n        max-width: 41.6666666667%\n    }\n\n    .col-sm-6 {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .col-sm-7 {\n        flex: 0 0 58.3333333333%;\n        max-width: 58.3333333333%\n    }\n\n    .col-sm-8 {\n        flex: 0 0 66.6666666667%;\n        max-width: 66.6666666667%\n    }\n\n    .col-sm-9 {\n        flex: 0 0 75%;\n        max-width: 75%\n    }\n\n    .col-sm-10 {\n        flex: 0 0 83.3333333333%;\n        max-width: 83.3333333333%\n    }\n\n    .col-sm-11 {\n        flex: 0 0 91.6666666667%;\n        max-width: 91.6666666667%\n    }\n\n    .col-sm-12 {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .order-sm-first {\n        order: -1\n    }\n\n    .order-sm-last {\n        order: 13\n    }\n\n    .order-sm-0 {\n        order: 0\n    }\n\n    .order-sm-1 {\n        order: 1\n    }\n\n    .order-sm-2 {\n        order: 2\n    }\n\n    .order-sm-3 {\n        order: 3\n    }\n\n    .order-sm-4 {\n        order: 4\n    }\n\n    .order-sm-5 {\n        order: 5\n    }\n\n    .order-sm-6 {\n        order: 6\n    }\n\n    .order-sm-7 {\n        order: 7\n    }\n\n    .order-sm-8 {\n        order: 8\n    }\n\n    .order-sm-9 {\n        order: 9\n    }\n\n    .order-sm-10 {\n        order: 10\n    }\n\n    .order-sm-11 {\n        order: 11\n    }\n\n    .order-sm-12 {\n        order: 12\n    }\n\n    .offset-sm-0 {\n        margin-left: 0\n    }\n\n    .offset-sm-1 {\n        margin-left: 8.3333333333%\n    }\n\n    .offset-sm-2 {\n        margin-left: 16.6666666667%\n    }\n\n    .offset-sm-3 {\n        margin-left: 25%\n    }\n\n    .offset-sm-4 {\n        margin-left: 33.3333333333%\n    }\n\n    .offset-sm-5 {\n        margin-left: 41.6666666667%\n    }\n\n    .offset-sm-6 {\n        margin-left: 50%\n    }\n\n    .offset-sm-7 {\n        margin-left: 58.3333333333%\n    }\n\n    .offset-sm-8 {\n        margin-left: 66.6666666667%\n    }\n\n    .offset-sm-9 {\n        margin-left: 75%\n    }\n\n    .offset-sm-10 {\n        margin-left: 83.3333333333%\n    }\n\n    .offset-sm-11 {\n        margin-left: 91.6666666667%\n    }\n}\n\n@media (min-width: 768px) {\n    .col-md {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%\n    }\n\n    .row-cols-md-1>* {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .row-cols-md-2>* {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .row-cols-md-3>* {\n        flex: 0 0 33.3333333333%;\n        max-width: 33.3333333333%\n    }\n\n    .row-cols-md-4>* {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .row-cols-md-5>* {\n        flex: 0 0 20%;\n        max-width: 20%\n    }\n\n    .row-cols-md-6>* {\n        flex: 0 0 16.6666666667%;\n        max-width: 16.6666666667%\n    }\n\n    .col-md-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%\n    }\n\n    .col-md-1 {\n        flex: 0 0 8.3333333333%;\n        max-width: 8.3333333333%\n    }\n\n    .col-md-2 {\n        flex: 0 0 16.6666666667%;\n        max-width: 16.6666666667%\n    }\n\n    .col-md-3 {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .col-md-4 {\n        flex: 0 0 33.3333333333%;\n        max-width: 33.3333333333%\n    }\n\n    .col-md-5 {\n        flex: 0 0 41.6666666667%;\n        max-width: 41.6666666667%\n    }\n\n    .col-md-6 {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .col-md-7 {\n        flex: 0 0 58.3333333333%;\n        max-width: 58.3333333333%\n    }\n\n    .col-md-8 {\n        flex: 0 0 66.6666666667%;\n        max-width: 66.6666666667%\n    }\n\n    .col-md-9 {\n        flex: 0 0 75%;\n        max-width: 75%\n    }\n\n    .col-md-10 {\n        flex: 0 0 83.3333333333%;\n        max-width: 83.3333333333%\n    }\n\n    .col-md-11 {\n        flex: 0 0 91.6666666667%;\n        max-width: 91.6666666667%\n    }\n\n    .col-md-12 {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .order-md-first {\n        order: -1\n    }\n\n    .order-md-last {\n        order: 13\n    }\n\n    .order-md-0 {\n        order: 0\n    }\n\n    .order-md-1 {\n        order: 1\n    }\n\n    .order-md-2 {\n        order: 2\n    }\n\n    .order-md-3 {\n        order: 3\n    }\n\n    .order-md-4 {\n        order: 4\n    }\n\n    .order-md-5 {\n        order: 5\n    }\n\n    .order-md-6 {\n        order: 6\n    }\n\n    .order-md-7 {\n        order: 7\n    }\n\n    .order-md-8 {\n        order: 8\n    }\n\n    .order-md-9 {\n        order: 9\n    }\n\n    .order-md-10 {\n        order: 10\n    }\n\n    .order-md-11 {\n        order: 11\n    }\n\n    .order-md-12 {\n        order: 12\n    }\n\n    .offset-md-0 {\n        margin-left: 0\n    }\n\n    .offset-md-1 {\n        margin-left: 8.3333333333%\n    }\n\n    .offset-md-2 {\n        margin-left: 16.6666666667%\n    }\n\n    .offset-md-3 {\n        margin-left: 25%\n    }\n\n    .offset-md-4 {\n        margin-left: 33.3333333333%\n    }\n\n    .offset-md-5 {\n        margin-left: 41.6666666667%\n    }\n\n    .offset-md-6 {\n        margin-left: 50%\n    }\n\n    .offset-md-7 {\n        margin-left: 58.3333333333%\n    }\n\n    .offset-md-8 {\n        margin-left: 66.6666666667%\n    }\n\n    .offset-md-9 {\n        margin-left: 75%\n    }\n\n    .offset-md-10 {\n        margin-left: 83.3333333333%\n    }\n\n    .offset-md-11 {\n        margin-left: 91.6666666667%\n    }\n}\n\n@media (min-width: 992px) {\n    .col-lg {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%\n    }\n\n    .row-cols-lg-1>* {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .row-cols-lg-2>* {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .row-cols-lg-3>* {\n        flex: 0 0 33.3333333333%;\n        max-width: 33.3333333333%\n    }\n\n    .row-cols-lg-4>* {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .row-cols-lg-5>* {\n        flex: 0 0 20%;\n        max-width: 20%\n    }\n\n    .row-cols-lg-6>* {\n        flex: 0 0 16.6666666667%;\n        max-width: 16.6666666667%\n    }\n\n    .col-lg-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%\n    }\n\n    .col-lg-1 {\n        flex: 0 0 8.3333333333%;\n        max-width: 8.3333333333%\n    }\n\n    .col-lg-2 {\n        flex: 0 0 16.6666666667%;\n        max-width: 16.6666666667%\n    }\n\n    .col-lg-3 {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .col-lg-4 {\n        flex: 0 0 33.3333333333%;\n        max-width: 33.3333333333%\n    }\n\n    .col-lg-5 {\n        flex: 0 0 41.6666666667%;\n        max-width: 41.6666666667%\n    }\n\n    .col-lg-6 {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .col-lg-7 {\n        flex: 0 0 58.3333333333%;\n        max-width: 58.3333333333%\n    }\n\n    .col-lg-8 {\n        flex: 0 0 66.6666666667%;\n        max-width: 66.6666666667%\n    }\n\n    .col-lg-9 {\n        flex: 0 0 75%;\n        max-width: 75%\n    }\n\n    .col-lg-10 {\n        flex: 0 0 83.3333333333%;\n        max-width: 83.3333333333%\n    }\n\n    .col-lg-11 {\n        flex: 0 0 91.6666666667%;\n        max-width: 91.6666666667%\n    }\n\n    .col-lg-12 {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .order-lg-first {\n        order: -1\n    }\n\n    .order-lg-last {\n        order: 13\n    }\n\n    .order-lg-0 {\n        order: 0\n    }\n\n    .order-lg-1 {\n        order: 1\n    }\n\n    .order-lg-2 {\n        order: 2\n    }\n\n    .order-lg-3 {\n        order: 3\n    }\n\n    .order-lg-4 {\n        order: 4\n    }\n\n    .order-lg-5 {\n        order: 5\n    }\n\n    .order-lg-6 {\n        order: 6\n    }\n\n    .order-lg-7 {\n        order: 7\n    }\n\n    .order-lg-8 {\n        order: 8\n    }\n\n    .order-lg-9 {\n        order: 9\n    }\n\n    .order-lg-10 {\n        order: 10\n    }\n\n    .order-lg-11 {\n        order: 11\n    }\n\n    .order-lg-12 {\n        order: 12\n    }\n\n    .offset-lg-0 {\n        margin-left: 0\n    }\n\n    .offset-lg-1 {\n        margin-left: 8.3333333333%\n    }\n\n    .offset-lg-2 {\n        margin-left: 16.6666666667%\n    }\n\n    .offset-lg-3 {\n        margin-left: 25%\n    }\n\n    .offset-lg-4 {\n        margin-left: 33.3333333333%\n    }\n\n    .offset-lg-5 {\n        margin-left: 41.6666666667%\n    }\n\n    .offset-lg-6 {\n        margin-left: 50%\n    }\n\n    .offset-lg-7 {\n        margin-left: 58.3333333333%\n    }\n\n    .offset-lg-8 {\n        margin-left: 66.6666666667%\n    }\n\n    .offset-lg-9 {\n        margin-left: 75%\n    }\n\n    .offset-lg-10 {\n        margin-left: 83.3333333333%\n    }\n\n    .offset-lg-11 {\n        margin-left: 91.6666666667%\n    }\n}\n\n@media (min-width: 1200px) {\n    .col-xl {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%\n    }\n\n    .row-cols-xl-1>* {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .row-cols-xl-2>* {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .row-cols-xl-3>* {\n        flex: 0 0 33.3333333333%;\n        max-width: 33.3333333333%\n    }\n\n    .row-cols-xl-4>* {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .row-cols-xl-5>* {\n        flex: 0 0 20%;\n        max-width: 20%\n    }\n\n    .row-cols-xl-6>* {\n        flex: 0 0 16.6666666667%;\n        max-width: 16.6666666667%\n    }\n\n    .col-xl-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%\n    }\n\n    .col-xl-1 {\n        flex: 0 0 8.3333333333%;\n        max-width: 8.3333333333%\n    }\n\n    .col-xl-2 {\n        flex: 0 0 16.6666666667%;\n        max-width: 16.6666666667%\n    }\n\n    .col-xl-3 {\n        flex: 0 0 25%;\n        max-width: 25%\n    }\n\n    .col-xl-4 {\n        flex: 0 0 33.3333333333%;\n        max-width: 33.3333333333%\n    }\n\n    .col-xl-5 {\n        flex: 0 0 41.6666666667%;\n        max-width: 41.6666666667%\n    }\n\n    .col-xl-6 {\n        flex: 0 0 50%;\n        max-width: 50%\n    }\n\n    .col-xl-7 {\n        flex: 0 0 58.3333333333%;\n        max-width: 58.3333333333%\n    }\n\n    .col-xl-8 {\n        flex: 0 0 66.6666666667%;\n        max-width: 66.6666666667%\n    }\n\n    .col-xl-9 {\n        flex: 0 0 75%;\n        max-width: 75%\n    }\n\n    .col-xl-10 {\n        flex: 0 0 83.3333333333%;\n        max-width: 83.3333333333%\n    }\n\n    .col-xl-11 {\n        flex: 0 0 91.6666666667%;\n        max-width: 91.6666666667%\n    }\n\n    .col-xl-12 {\n        flex: 0 0 100%;\n        max-width: 100%\n    }\n\n    .order-xl-first {\n        order: -1\n    }\n\n    .order-xl-last {\n        order: 13\n    }\n\n    .order-xl-0 {\n        order: 0\n    }\n\n    .order-xl-1 {\n        order: 1\n    }\n\n    .order-xl-2 {\n        order: 2\n    }\n\n    .order-xl-3 {\n        order: 3\n    }\n\n    .order-xl-4 {\n        order: 4\n    }\n\n    .order-xl-5 {\n        order: 5\n    }\n\n    .order-xl-6 {\n        order: 6\n    }\n\n    .order-xl-7 {\n        order: 7\n    }\n\n    .order-xl-8 {\n        order: 8\n    }\n\n    .order-xl-9 {\n        order: 9\n    }\n\n    .order-xl-10 {\n        order: 10\n    }\n\n    .order-xl-11 {\n        order: 11\n    }\n\n    .order-xl-12 {\n        order: 12\n    }\n\n    .offset-xl-0 {\n        margin-left: 0\n    }\n\n    .offset-xl-1 {\n        margin-left: 8.3333333333%\n    }\n\n    .offset-xl-2 {\n        margin-left: 16.6666666667%\n    }\n\n    .offset-xl-3 {\n        margin-left: 25%\n    }\n\n    .offset-xl-4 {\n        margin-left: 33.3333333333%\n    }\n\n    .offset-xl-5 {\n        margin-left: 41.6666666667%\n    }\n\n    .offset-xl-6 {\n        margin-left: 50%\n    }\n\n    .offset-xl-7 {\n        margin-left: 58.3333333333%\n    }\n\n    .offset-xl-8 {\n        margin-left: 66.6666666667%\n    }\n\n    .offset-xl-9 {\n        margin-left: 75%\n    }\n\n    .offset-xl-10 {\n        margin-left: 83.3333333333%\n    }\n\n    .offset-xl-11 {\n        margin-left: 91.6666666667%\n    }\n}\n\n.table {\n    width: 100%;\n    margin-bottom: 1.6rem;\n    color: #212529\n}\n\n.table td,\n.table th {\n    padding: .75rem;\n    vertical-align: top;\n    border-top: 1px solid #dee2e6\n}\n\n.table thead th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #dee2e6\n}\n\n.table tbody+tbody {\n    border-top: 2px solid #dee2e6\n}\n\n.table-sm td,\n.table-sm th {\n    padding: .3rem\n}\n\n.table-bordered {\n    border: 1px solid #dee2e6\n}\n\n.table-bordered td,\n.table-bordered th {\n    border: 1px solid #dee2e6\n}\n\n.table-bordered thead td,\n.table-bordered thead th {\n    border-bottom-width: 2px\n}\n\n.table-borderless tbody+tbody,\n.table-borderless td,\n.table-borderless th,\n.table-borderless thead th {\n    border: 0\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(0, 0, 0, .05)\n}\n\n.table-hover tbody tr:hover {\n    color: #212529;\n    background-color: rgba(0, 0, 0, .075)\n}\n\n.table-primary,\n.table-primary>td,\n.table-primary>th {\n    background-color: rgb(183.6, 218.04, 255)\n}\n\n.table-primary tbody+tbody,\n.table-primary td,\n.table-primary th,\n.table-primary thead th {\n    border-color: rgb(122.4, 186.36, 255)\n}\n\n.table-hover .table-primary:hover {\n    background-color: rgb(158.1, 204.84, 255)\n}\n\n.table-hover .table-primary:hover>td,\n.table-hover .table-primary:hover>th {\n    background-color: rgb(158.1, 204.84, 255)\n}\n\n.table-secondary,\n.table-secondary>td,\n.table-secondary>th {\n    background-color: rgb(213.84, 216.36, 218.6)\n}\n\n.table-secondary tbody+tbody,\n.table-secondary td,\n.table-secondary th,\n.table-secondary thead th {\n    border-color: rgb(178.56, 183.24, 187.4)\n}\n\n.table-hover .table-secondary:hover {\n    background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747)\n}\n\n.table-hover .table-secondary:hover>td,\n.table-hover .table-secondary:hover>th {\n    background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747)\n}\n\n.table-success,\n.table-success>td,\n.table-success>th {\n    background-color: rgb(194.8, 230.36, 202.92)\n}\n\n.table-success tbody+tbody,\n.table-success td,\n.table-success th,\n.table-success thead th {\n    border-color: rgb(143.2, 209.24, 158.28)\n}\n\n.table-hover .table-success:hover {\n    background-color: rgb(176.7059405941, 222.9540594059, 187.2665346535)\n}\n\n.table-hover .table-success:hover>td,\n.table-hover .table-success:hover>th {\n    background-color: rgb(176.7059405941, 222.9540594059, 187.2665346535)\n}\n\n.table-info,\n.table-info>td,\n.table-info>th {\n    background-color: rgb(190.04, 228.96, 235.12)\n}\n\n.table-info tbody+tbody,\n.table-info td,\n.table-info th,\n.table-info thead th {\n    border-color: rgb(134.36, 206.64, 218.08)\n}\n\n.table-hover .table-info:hover {\n    background-color: rgb(170.5152475248, 221.1332673267, 229.1447524752)\n}\n\n.table-hover .table-info:hover>td,\n.table-hover .table-info:hover>th {\n    background-color: rgb(170.5152475248, 221.1332673267, 229.1447524752)\n}\n\n.table-warning,\n.table-warning>td,\n.table-warning>th {\n    background-color: rgb(255, 237.64, 185.56)\n}\n\n.table-warning tbody+tbody,\n.table-warning td,\n.table-warning th,\n.table-warning thead th {\n    border-color: rgb(255, 222.76, 126.04)\n}\n\n.table-hover .table-warning:hover {\n    background-color: rgb(255, 231.265, 160.06)\n}\n\n.table-hover .table-warning:hover>td,\n.table-hover .table-warning:hover>th {\n    background-color: rgb(255, 231.265, 160.06)\n}\n\n.table-danger,\n.table-danger>td,\n.table-danger>th {\n    background-color: rgb(245.2, 198.44, 202.92)\n}\n\n.table-danger tbody+tbody,\n.table-danger td,\n.table-danger th,\n.table-danger thead th {\n    border-color: rgb(236.8, 149.96, 158.28)\n}\n\n.table-hover .table-danger:hover {\n    background-color: rgb(241.4341772152, 176.7058227848, 182.9073417722)\n}\n\n.table-hover .table-danger:hover>td,\n.table-hover .table-danger:hover>th {\n    background-color: rgb(241.4341772152, 176.7058227848, 182.9073417722)\n}\n\n.table-light,\n.table-light>td,\n.table-light>th {\n    background-color: rgb(253.04, 253.32, 253.6)\n}\n\n.table-light tbody+tbody,\n.table-light td,\n.table-light th,\n.table-light thead th {\n    border-color: rgb(251.36, 251.88, 252.4)\n}\n\n.table-hover .table-light:hover {\n    background-color: rgb(238.165, 240.57, 242.975)\n}\n\n.table-hover .table-light:hover>td,\n.table-hover .table-light:hover>th {\n    background-color: rgb(238.165, 240.57, 242.975)\n}\n\n.table-dark,\n.table-dark>td,\n.table-dark>th {\n    background-color: rgb(198.16, 199.84, 201.52)\n}\n\n.table-dark tbody+tbody,\n.table-dark td,\n.table-dark th,\n.table-dark thead th {\n    border-color: rgb(149.44, 152.56, 155.68)\n}\n\n.table-hover .table-dark:hover {\n    background-color: rgb(185.0216751269, 187.09, 189.1583248731)\n}\n\n.table-hover .table-dark:hover>td,\n.table-hover .table-dark:hover>th {\n    background-color: rgb(185.0216751269, 187.09, 189.1583248731)\n}\n\n.table-active,\n.table-active>td,\n.table-active>th {\n    background-color: rgba(0, 0, 0, .075)\n}\n\n.table-hover .table-active:hover {\n    background-color: rgba(0, 0, 0, .075)\n}\n\n.table-hover .table-active:hover>td,\n.table-hover .table-active:hover>th {\n    background-color: rgba(0, 0, 0, .075)\n}\n\n.table .thead-dark th {\n    color: #fff;\n    background-color: #343a40;\n    border-color: rgb(69.1465517241, 77.125, 85.1034482759)\n}\n\n.table .thead-light th {\n    color: #495057;\n    background-color: #e9ecef;\n    border-color: #dee2e6\n}\n\n.table-dark {\n    color: #fff;\n    background-color: #343a40\n}\n\n.table-dark td,\n.table-dark th,\n.table-dark thead th {\n    border-color: rgb(69.1465517241, 77.125, 85.1034482759)\n}\n\n.table-dark.table-bordered {\n    border: 0\n}\n\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(255, 255, 255, .05)\n}\n\n.table-dark.table-hover tbody tr:hover {\n    color: #fff;\n    background-color: rgba(255, 255, 255, .075)\n}\n\n@media (max-width: 575.98px) {\n    .table-responsive-sm {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n\n    .table-responsive-sm>.table-bordered {\n        border: 0\n    }\n}\n\n@media (max-width: 767.98px) {\n    .table-responsive-md {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n\n    .table-responsive-md>.table-bordered {\n        border: 0\n    }\n}\n\n@media (max-width: 991.98px) {\n    .table-responsive-lg {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n\n    .table-responsive-lg>.table-bordered {\n        border: 0\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .table-responsive-xl {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n\n    .table-responsive-xl>.table-bordered {\n        border: 0\n    }\n}\n\n.table-responsive {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch\n}\n\n.table-responsive>.table-bordered {\n    border: 0\n}\n\n.fade {\n    transition: opacity .15s linear\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .fade {\n        transition: none\n    }\n}\n\n.fade:not(.show) {\n    opacity: 0\n}\n\n.collapse:not(.show) {\n    display: none\n}\n\n.collapsing {\n    position: relative;\n    height: 0;\n    overflow: hidden;\n    transition: height .35s ease\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .collapsing {\n        transition: none\n    }\n}\n\n.input-group {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    width: 100%\n}\n\n.input-group>.custom-file,\n.input-group>.custom-select,\n.input-group>.form-control,\n.input-group>.form-control-plaintext {\n    position: relative;\n    flex: 1 1 0%;\n    min-width: 0;\n    margin-bottom: 0\n}\n\n.input-group>.custom-file+.custom-file,\n.input-group>.custom-file+.custom-select,\n.input-group>.custom-file+.form-control,\n.input-group>.custom-select+.custom-file,\n.input-group>.custom-select+.custom-select,\n.input-group>.custom-select+.form-control,\n.input-group>.form-control+.custom-file,\n.input-group>.form-control+.custom-select,\n.input-group>.form-control+.form-control,\n.input-group>.form-control-plaintext+.custom-file,\n.input-group>.form-control-plaintext+.custom-select,\n.input-group>.form-control-plaintext+.form-control {\n    margin-left: -1px\n}\n\n.input-group>.custom-file .custom-file-input:focus~.custom-file-label,\n.input-group>.custom-select:focus,\n.input-group>.form-control:focus {\n    z-index: 3\n}\n\n.input-group>.custom-file .custom-file-input:focus {\n    z-index: 4\n}\n\n.input-group>.custom-select:not(:last-child),\n.input-group>.form-control:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.input-group>.custom-select:not(:first-child),\n.input-group>.form-control:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.input-group>.custom-file {\n    display: flex;\n    align-items: center\n}\n\n.input-group>.custom-file:not(:last-child) .custom-file-label,\n.input-group>.custom-file:not(:last-child) .custom-file-label::after {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.input-group>.custom-file:not(:first-child) .custom-file-label {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.input-group-append,\n.input-group-prepend {\n    display: flex\n}\n\n.input-group-append .btn,\n.input-group-prepend .btn {\n    position: relative;\n    z-index: 2\n}\n\n.input-group-append .btn:focus,\n.input-group-prepend .btn:focus {\n    z-index: 3\n}\n\n.input-group-append .btn+.btn,\n.input-group-append .btn+.input-group-text,\n.input-group-append .input-group-text+.btn,\n.input-group-append .input-group-text+.input-group-text,\n.input-group-prepend .btn+.btn,\n.input-group-prepend .btn+.input-group-text,\n.input-group-prepend .input-group-text+.btn,\n.input-group-prepend .input-group-text+.input-group-text {\n    margin-left: -1px\n}\n\n.input-group-prepend {\n    margin-right: -1px\n}\n\n.input-group-append {\n    margin-left: -1px\n}\n\n.input-group-text {\n    display: flex;\n    align-items: center;\n    padding: .375rem .75rem;\n    margin-bottom: 0;\n    font-size: 1.6rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #495057;\n    text-align: center;\n    white-space: nowrap;\n    background-color: #e9ecef;\n    border: 1px solid #ced4da;\n    border-radius: .25rem\n}\n\n.input-group-text input[type=checkbox],\n.input-group-text input[type=radio] {\n    margin-top: 0\n}\n\n.input-group-lg>.custom-select,\n.input-group-lg>.form-control:not(textarea) {\n    height: calc(1.5em + 1rem + 2px)\n}\n\n.input-group-lg>.custom-select,\n.input-group-lg>.form-control,\n.input-group-lg>.input-group-append>.btn,\n.input-group-lg>.input-group-append>.input-group-text,\n.input-group-lg>.input-group-prepend>.btn,\n.input-group-lg>.input-group-prepend>.input-group-text {\n    padding: .5rem 1rem;\n    font-size: 2rem;\n    line-height: 1.5;\n    border-radius: .3rem\n}\n\n.input-group-sm>.custom-select,\n.input-group-sm>.form-control:not(textarea) {\n    height: calc(1.5em + .5rem + 2px)\n}\n\n.input-group-sm>.custom-select,\n.input-group-sm>.form-control,\n.input-group-sm>.input-group-append>.btn,\n.input-group-sm>.input-group-append>.input-group-text,\n.input-group-sm>.input-group-prepend>.btn,\n.input-group-sm>.input-group-prepend>.input-group-text {\n    padding: .25rem .5rem;\n    font-size: 1.4rem;\n    line-height: 1.5;\n    border-radius: .2rem\n}\n\n.input-group-lg>.custom-select,\n.input-group-sm>.custom-select {\n    padding-right: 1.75rem\n}\n\n.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),\n.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),\n.input-group>.input-group-append:not(:last-child)>.btn,\n.input-group>.input-group-append:not(:last-child)>.input-group-text,\n.input-group>.input-group-prepend>.btn,\n.input-group>.input-group-prepend>.input-group-text {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.input-group>.input-group-append>.btn,\n.input-group>.input-group-append>.input-group-text,\n.input-group>.input-group-prepend:first-child>.btn:not(:first-child),\n.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),\n.input-group>.input-group-prepend:not(:first-child)>.btn,\n.input-group>.input-group-prepend:not(:first-child)>.input-group-text {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.nav {\n    display: flex;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none\n}\n\n.nav-link {\n    display: block;\n    padding: .5rem 1rem\n}\n\n.nav-link:focus,\n.nav-link:hover {\n    text-decoration: none\n}\n\n.nav-link.disabled {\n    color: #6c757d;\n    pointer-events: none;\n    cursor: default\n}\n\n.nav-tabs {\n    border-bottom: 1px solid #dee2e6\n}\n\n.nav-tabs .nav-item {\n    margin-bottom: -1px\n}\n\n.nav-tabs .nav-link {\n    border: 1px solid transparent;\n    border-top-left-radius: .25rem;\n    border-top-right-radius: .25rem\n}\n\n.nav-tabs .nav-link:focus,\n.nav-tabs .nav-link:hover {\n    border-color: #e9ecef #e9ecef #dee2e6\n}\n\n.nav-tabs .nav-link.disabled {\n    color: #6c757d;\n    background-color: transparent;\n    border-color: transparent\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n    color: #495057;\n    background-color: #fff;\n    border-color: #dee2e6 #dee2e6 #fff\n}\n\n.nav-tabs .dropdown-menu {\n    margin-top: -1px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0\n}\n\n.nav-pills .nav-link {\n    border-radius: .25rem\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n    color: #fff;\n    background-color: #007bff\n}\n\n.nav-fill .nav-item {\n    flex: 1 1 auto;\n    text-align: center\n}\n\n.nav-justified .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center\n}\n\n.tab-content>.tab-pane {\n    display: none\n}\n\n.tab-content>.active {\n    display: block\n}\n\n.card {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: border-box;\n    border: 1px solid rgba(0, 0, 0, .125);\n    border-radius: .25rem\n}\n\n.card>hr {\n    margin-right: 0;\n    margin-left: 0\n}\n\n.card>.list-group:first-child .list-group-item:first-child {\n    border-top-left-radius: .25rem;\n    border-top-right-radius: .25rem\n}\n\n.card>.list-group:last-child .list-group-item:last-child {\n    border-bottom-right-radius: .25rem;\n    border-bottom-left-radius: .25rem\n}\n\n.card-body {\n    flex: 1 1 auto;\n    min-height: 1px;\n    padding: 1.25rem\n}\n\n.card-title {\n    margin-bottom: .75rem\n}\n\n.card-subtitle {\n    margin-top: -.375rem;\n    margin-bottom: 0\n}\n\n.card-text:last-child {\n    margin-bottom: 0\n}\n\n.card-link:hover {\n    text-decoration: none\n}\n\n.card-link+.card-link {\n    margin-left: 1.25rem\n}\n\n.card-header {\n    padding: .75rem 1.25rem;\n    margin-bottom: 0;\n    background-color: rgba(0, 0, 0, .03);\n    border-bottom: 1px solid rgba(0, 0, 0, .125)\n}\n\n.card-header:first-child {\n    border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0\n}\n\n.card-header+.list-group .list-group-item:first-child {\n    border-top: 0\n}\n\n.card-footer {\n    padding: .75rem 1.25rem;\n    background-color: rgba(0, 0, 0, .03);\n    border-top: 1px solid rgba(0, 0, 0, .125)\n}\n\n.card-footer:last-child {\n    border-radius: 0 0 calc(.25rem - 1px) calc(.25rem - 1px)\n}\n\n.card-header-tabs {\n    margin-right: -.625rem;\n    margin-bottom: -.75rem;\n    margin-left: -.625rem;\n    border-bottom: 0\n}\n\n.card-header-pills {\n    margin-right: -.625rem;\n    margin-left: -.625rem\n}\n\n.card-img-overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 1.25rem\n}\n\n.card-img,\n.card-img-bottom,\n.card-img-top {\n    flex-shrink: 0;\n    width: 100%\n}\n\n.card-img,\n.card-img-top {\n    border-top-left-radius: calc(.25rem - 1px);\n    border-top-right-radius: calc(.25rem - 1px)\n}\n\n.card-img,\n.card-img-bottom {\n    border-bottom-right-radius: calc(.25rem - 1px);\n    border-bottom-left-radius: calc(.25rem - 1px)\n}\n\n.card-deck .card {\n    margin-bottom: 15px\n}\n\n@media (min-width: 576px) {\n    .card-deck {\n        display: flex;\n        flex-flow: row wrap;\n        margin-right: -15px;\n        margin-left: -15px\n    }\n\n    .card-deck .card {\n        flex: 1 0 0%;\n        margin-right: 15px;\n        margin-bottom: 0;\n        margin-left: 15px\n    }\n}\n\n.card-group>.card {\n    margin-bottom: 15px\n}\n\n@media (min-width: 576px) {\n    .card-group {\n        display: flex;\n        flex-flow: row wrap\n    }\n\n    .card-group>.card {\n        flex: 1 0 0%;\n        margin-bottom: 0\n    }\n\n    .card-group>.card+.card {\n        margin-left: 0;\n        border-left: 0\n    }\n\n    .card-group>.card:not(:last-child) {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0\n    }\n\n    .card-group>.card:not(:last-child) .card-header,\n    .card-group>.card:not(:last-child) .card-img-top {\n        border-top-right-radius: 0\n    }\n\n    .card-group>.card:not(:last-child) .card-footer,\n    .card-group>.card:not(:last-child) .card-img-bottom {\n        border-bottom-right-radius: 0\n    }\n\n    .card-group>.card:not(:first-child) {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0\n    }\n\n    .card-group>.card:not(:first-child) .card-header,\n    .card-group>.card:not(:first-child) .card-img-top {\n        border-top-left-radius: 0\n    }\n\n    .card-group>.card:not(:first-child) .card-footer,\n    .card-group>.card:not(:first-child) .card-img-bottom {\n        border-bottom-left-radius: 0\n    }\n}\n\n.card-columns .card {\n    margin-bottom: .75rem\n}\n\n@media (min-width: 576px) {\n    .card-columns {\n        column-count: 3;\n        column-gap: 1.25rem;\n        orphans: 1;\n        widows: 1\n    }\n\n    .card-columns .card {\n        display: inline-block;\n        width: 100%\n    }\n}\n\n.accordion>.card {\n    overflow: hidden\n}\n\n.accordion>.card:not(:last-of-type) {\n    border-bottom: 0;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.accordion>.card:not(:first-of-type) {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0\n}\n\n.accordion>.card>.card-header {\n    border-radius: 0;\n    margin-bottom: -1px\n}\n\n.breadcrumb {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0 0;\n    margin-bottom: 0;\n    font-size: 1.8rem;\n    list-style: none;\n    background-color: transparent;\n    border-radius: .25rem\n}\n\n.breadcrumb-back {\n    max-height: 25px\n}\n\n.breadcrumb-item+.breadcrumb-item {\n    padding-left: .5rem\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n    display: inline-block;\n    padding-right: .5rem;\n    color: #8a8d8f;\n    content: \"/\"\n}\n\n.breadcrumb-item+.breadcrumb-item:hover::before {\n    text-decoration: underline\n}\n\n.breadcrumb-item+.breadcrumb-item:hover::before {\n    text-decoration: none\n}\n\n.breadcrumb-item.active {\n    color: #6c757d\n}\n\n.alert {\n    position: relative;\n    padding: .75rem 1.25rem;\n    margin-bottom: 1rem;\n    border: 1px solid transparent;\n    border-radius: .25rem\n}\n\n.alert-heading {\n    color: inherit\n}\n\n.alert-link {\n    font-weight: 700\n}\n\n.alert-dismissible {\n    padding-right: 4.9rem\n}\n\n.alert-dismissible .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: .75rem 1.25rem;\n    color: inherit\n}\n\n.alert-primary {\n    color: rgb(0, 63.96, 132.6);\n    background-color: rgb(204, 228.6, 255);\n    border-color: rgb(183.6, 218.04, 255)\n}\n\n.alert-primary hr {\n    border-top-color: rgb(158.1, 204.84, 255)\n}\n\n.alert-primary .alert-link {\n    color: rgb(0, 39.36, 81.6)\n}\n\n.alert-secondary {\n    color: rgb(56.16, 60.84, 65);\n    background-color: rgb(225.6, 227.4, 229);\n    border-color: rgb(213.84, 216.36, 218.6)\n}\n\n.alert-secondary hr {\n    border-top-color: rgb(200.3075090253, 203.6560288809, 206.6324909747)\n}\n\n.alert-secondary .alert-link {\n    color: rgb(32.5205150215, 35.2305579399, 37.6394849785)\n}\n\n.alert-success {\n    color: rgb(20.8, 86.84, 35.88);\n    background-color: rgb(212, 237.4, 217.8);\n    border-color: rgb(194.8, 230.36, 202.92)\n}\n\n.alert-success hr {\n    border-top-color: rgb(176.7059405941, 222.9540594059, 187.2665346535)\n}\n\n.alert-success .alert-link {\n    color: rgb(10.9449275362, 45.6950724638, 18.88)\n}\n\n.alert-info {\n    color: rgb(11.96, 84.24, 95.68);\n    background-color: rgb(208.6, 236.4, 240.8);\n    border-color: rgb(190.04, 228.96, 235.12)\n}\n\n.alert-info hr {\n    border-top-color: rgb(170.5152475248, 221.1332673267, 229.1447524752)\n}\n\n.alert-info .alert-link {\n    color: rgb(6.2933333333, 44.3269565217, 50.3466666667)\n}\n\n.alert-warning {\n    color: rgb(132.6, 100.36, 3.64);\n    background-color: rgb(255, 242.6, 205.4);\n    border-color: rgb(255, 237.64, 185.56)\n}\n\n.alert-warning hr {\n    border-top-color: rgb(255, 231.265, 160.06)\n}\n\n.alert-warning .alert-link {\n    color: rgb(82.9625954198, 62.7912977099, 2.2774045802)\n}\n\n.alert-danger {\n    color: rgb(114.4, 27.56, 35.88);\n    background-color: rgb(248, 214.6, 217.8);\n    border-color: rgb(245.2, 198.44, 202.92)\n}\n\n.alert-danger hr {\n    border-top-color: rgb(241.4341772152, 176.7058227848, 182.9073417722)\n}\n\n.alert-danger .alert-link {\n    color: rgb(73.3010989011, 17.6589010989, 22.9898901099)\n}\n\n.alert-light {\n    color: rgb(128.96, 129.48, 130);\n    background-color: rgb(253.6, 253.8, 254);\n    border-color: rgb(253.04, 253.32, 253.6)\n}\n\n.alert-light hr {\n    border-top-color: rgb(238.165, 240.57, 242.975)\n}\n\n.alert-light .alert-link {\n    color: rgb(103.5492351816, 103.98, 104.4107648184)\n}\n\n.alert-dark {\n    color: rgb(27.04, 30.16, 33.28);\n    background-color: rgb(214.4, 215.6, 216.8);\n    border-color: rgb(198.16, 199.84, 201.52)\n}\n\n.alert-dark hr {\n    border-top-color: rgb(185.0216751269, 187.09, 189.1583248731)\n}\n\n.alert-dark .alert-link {\n    color: rgb(4.1779310345, 4.66, 5.1420689655)\n}\n\n.media {\n    display: flex;\n    align-items: flex-start\n}\n\n.media-body {\n    flex: 1\n}\n\n.list-group {\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0\n}\n\n.list-group-item-action {\n    width: 100%;\n    color: #495057;\n    text-align: inherit\n}\n\n.list-group-item-action:focus,\n.list-group-item-action:hover {\n    z-index: 1;\n    color: #495057;\n    text-decoration: none;\n    background-color: #f8f9fa\n}\n\n.list-group-item-action:active {\n    color: #212529;\n    background-color: #e9ecef\n}\n\n.list-group-item {\n    position: relative;\n    display: block;\n    padding: .75rem 1.25rem;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, .125)\n}\n\n.list-group-item:first-child {\n    border-top-left-radius: .25rem;\n    border-top-right-radius: .25rem\n}\n\n.list-group-item:last-child {\n    border-bottom-right-radius: .25rem;\n    border-bottom-left-radius: .25rem\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n    color: #6c757d;\n    pointer-events: none;\n    background-color: #fff\n}\n\n.list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff\n}\n\n.list-group-item+.list-group-item {\n    border-top-width: 0\n}\n\n.list-group-item+.list-group-item.active {\n    margin-top: -1px;\n    border-top-width: 1px\n}\n\n.list-group-horizontal {\n    flex-direction: row\n}\n\n.list-group-horizontal .list-group-item:first-child {\n    border-bottom-left-radius: .25rem;\n    border-top-right-radius: 0\n}\n\n.list-group-horizontal .list-group-item:last-child {\n    border-top-right-radius: .25rem;\n    border-bottom-left-radius: 0\n}\n\n.list-group-horizontal .list-group-item.active {\n    margin-top: 0\n}\n\n.list-group-horizontal .list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0\n}\n\n.list-group-horizontal .list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px\n}\n\n@media (min-width: 576px) {\n    .list-group-horizontal-sm {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-sm .list-group-item:first-child {\n        border-bottom-left-radius: .25rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-sm .list-group-item:last-child {\n        border-top-right-radius: .25rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-sm .list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-sm .list-group-item+.list-group-item {\n        border-top-width: 1px;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-sm .list-group-item+.list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px\n    }\n}\n\n@media (min-width: 768px) {\n    .list-group-horizontal-md {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-md .list-group-item:first-child {\n        border-bottom-left-radius: .25rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-md .list-group-item:last-child {\n        border-top-right-radius: .25rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-md .list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-md .list-group-item+.list-group-item {\n        border-top-width: 1px;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-md .list-group-item+.list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px\n    }\n}\n\n@media (min-width: 992px) {\n    .list-group-horizontal-lg {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-lg .list-group-item:first-child {\n        border-bottom-left-radius: .25rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-lg .list-group-item:last-child {\n        border-top-right-radius: .25rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-lg .list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-lg .list-group-item+.list-group-item {\n        border-top-width: 1px;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-lg .list-group-item+.list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px\n    }\n}\n\n@media (min-width: 1200px) {\n    .list-group-horizontal-xl {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-xl .list-group-item:first-child {\n        border-bottom-left-radius: .25rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-xl .list-group-item:last-child {\n        border-top-right-radius: .25rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-xl .list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-xl .list-group-item+.list-group-item {\n        border-top-width: 1px;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-xl .list-group-item+.list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px\n    }\n}\n\n.list-group-flush .list-group-item {\n    border-right-width: 0;\n    border-left-width: 0;\n    border-radius: 0\n}\n\n.list-group-flush .list-group-item:first-child {\n    border-top-width: 0\n}\n\n.list-group-flush:last-child .list-group-item:last-child {\n    border-bottom-width: 0\n}\n\n.list-group-item-primary {\n    color: rgb(0, 63.96, 132.6);\n    background-color: rgb(183.6, 218.04, 255)\n}\n\n.list-group-item-primary.list-group-item-action:focus,\n.list-group-item-primary.list-group-item-action:hover {\n    color: rgb(0, 63.96, 132.6);\n    background-color: rgb(158.1, 204.84, 255)\n}\n\n.list-group-item-primary.list-group-item-action.active {\n    color: #fff;\n    background-color: rgb(0, 63.96, 132.6);\n    border-color: rgb(0, 63.96, 132.6)\n}\n\n.list-group-item-secondary {\n    color: rgb(56.16, 60.84, 65);\n    background-color: rgb(213.84, 216.36, 218.6)\n}\n\n.list-group-item-secondary.list-group-item-action:focus,\n.list-group-item-secondary.list-group-item-action:hover {\n    color: rgb(56.16, 60.84, 65);\n    background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747)\n}\n\n.list-group-item-secondary.list-group-item-action.active {\n    color: #fff;\n    background-color: rgb(56.16, 60.84, 65);\n    border-color: rgb(56.16, 60.84, 65)\n}\n\n.list-group-item-success {\n    color: rgb(20.8, 86.84, 35.88);\n    background-color: rgb(194.8, 230.36, 202.92)\n}\n\n.list-group-item-success.list-group-item-action:focus,\n.list-group-item-success.list-group-item-action:hover {\n    color: rgb(20.8, 86.84, 35.88);\n    background-color: rgb(176.7059405941, 222.9540594059, 187.2665346535)\n}\n\n.list-group-item-success.list-group-item-action.active {\n    color: #fff;\n    background-color: rgb(20.8, 86.84, 35.88);\n    border-color: rgb(20.8, 86.84, 35.88)\n}\n\n.list-group-item-info {\n    color: rgb(11.96, 84.24, 95.68);\n    background-color: rgb(190.04, 228.96, 235.12)\n}\n\n.list-group-item-info.list-group-item-action:focus,\n.list-group-item-info.list-group-item-action:hover {\n    color: rgb(11.96, 84.24, 95.68);\n    background-color: rgb(170.5152475248, 221.1332673267, 229.1447524752)\n}\n\n.list-group-item-info.list-group-item-action.active {\n    color: #fff;\n    background-color: rgb(11.96, 84.24, 95.68);\n    border-color: rgb(11.96, 84.24, 95.68)\n}\n\n.list-group-item-warning {\n    color: rgb(132.6, 100.36, 3.64);\n    background-color: rgb(255, 237.64, 185.56)\n}\n\n.list-group-item-warning.list-group-item-action:focus,\n.list-group-item-warning.list-group-item-action:hover {\n    color: rgb(132.6, 100.36, 3.64);\n    background-color: rgb(255, 231.265, 160.06)\n}\n\n.list-group-item-warning.list-group-item-action.active {\n    color: #fff;\n    background-color: rgb(132.6, 100.36, 3.64);\n    border-color: rgb(132.6, 100.36, 3.64)\n}\n\n.list-group-item-danger {\n    color: rgb(114.4, 27.56, 35.88);\n    background-color: rgb(245.2, 198.44, 202.92)\n}\n\n.list-group-item-danger.list-group-item-action:focus,\n.list-group-item-danger.list-group-item-action:hover {\n    color: rgb(114.4, 27.56, 35.88);\n    background-color: rgb(241.4341772152, 176.7058227848, 182.9073417722)\n}\n\n.list-group-item-danger.list-group-item-action.active {\n    color: #fff;\n    background-color: rgb(114.4, 27.56, 35.88);\n    border-color: rgb(114.4, 27.56, 35.88)\n}\n\n.list-group-item-light {\n    color: rgb(128.96, 129.48, 130);\n    background-color: rgb(253.04, 253.32, 253.6)\n}\n\n.list-group-item-light.list-group-item-action:focus,\n.list-group-item-light.list-group-item-action:hover {\n    color: rgb(128.96, 129.48, 130);\n    background-color: rgb(238.165, 240.57, 242.975)\n}\n\n.list-group-item-light.list-group-item-action.active {\n    color: #fff;\n    background-color: rgb(128.96, 129.48, 130);\n    border-color: rgb(128.96, 129.48, 130)\n}\n\n.list-group-item-dark {\n    color: rgb(27.04, 30.16, 33.28);\n    background-color: rgb(198.16, 199.84, 201.52)\n}\n\n.list-group-item-dark.list-group-item-action:focus,\n.list-group-item-dark.list-group-item-action:hover {\n    color: rgb(27.04, 30.16, 33.28);\n    background-color: rgb(185.0216751269, 187.09, 189.1583248731)\n}\n\n.list-group-item-dark.list-group-item-action.active {\n    color: #fff;\n    background-color: rgb(27.04, 30.16, 33.28);\n    border-color: rgb(27.04, 30.16, 33.28)\n}\n\n.close {\n    float: right;\n    font-size: 2.4rem;\n    font-weight: 700;\n    line-height: 1;\n    color: #000;\n    text-shadow: 0 1px 0 #fff;\n    opacity: .5\n}\n\n.close:hover {\n    color: #000;\n    text-decoration: none\n}\n\n.close:not(:disabled):not(.disabled):focus,\n.close:not(:disabled):not(.disabled):hover {\n    opacity: .75\n}\n\nbutton.close {\n    padding: 0;\n    background-color: transparent;\n    border: 0;\n    appearance: none\n}\n\na.close.disabled {\n    pointer-events: none\n}\n\n.modal-open {\n    overflow: hidden\n}\n\n.modal-open .modal {\n    overflow-x: hidden;\n    overflow-y: auto\n}\n\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1050;\n    display: none;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    outline: 0\n}\n\n.modal-dialog {\n    position: relative;\n    width: auto;\n    margin: .5rem;\n    pointer-events: none\n}\n\n.modal.fade .modal-dialog {\n    transition: transform .3s ease-out;\n    transform: translate(0, -50px)\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .modal.fade .modal-dialog {\n        transition: none\n    }\n}\n\n.modal.show .modal-dialog {\n    transform: none\n}\n\n.modal.modal-static .modal-dialog {\n    transform: scale(1.02)\n}\n\n.modal-dialog-scrollable {\n    display: flex;\n    max-height: calc(100% - 1rem)\n}\n\n.modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 1rem);\n    overflow: hidden\n}\n\n.modal-dialog-scrollable .modal-footer,\n.modal-dialog-scrollable .modal-header {\n    flex-shrink: 0\n}\n\n.modal-dialog-scrollable .modal-body {\n    overflow-y: auto\n}\n\n.modal-dialog-centered {\n    display: flex;\n    align-items: center;\n    min-height: calc(100% - 1rem)\n}\n\n.modal-dialog-centered::before {\n    display: block;\n    height: calc(100vh - 1rem);\n    content: \"\"\n}\n\n.modal-dialog-centered.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%\n}\n\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\n    max-height: none\n}\n\n.modal-dialog-centered.modal-dialog-scrollable::before {\n    content: none\n}\n\n.modal-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    pointer-events: auto;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, .2);\n    border-radius: .3rem;\n    outline: 0\n}\n\n.modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1040;\n    width: 100vw;\n    height: 100vh;\n    background-color: #000\n}\n\n.modal-backdrop.fade {\n    opacity: 0\n}\n\n.modal-backdrop.show {\n    opacity: .5\n}\n\n.modal-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding: 1rem 1rem;\n    border-bottom: 1px solid #dee2e6;\n    border-top-left-radius: calc(.3rem - 1px);\n    border-top-right-radius: calc(.3rem - 1px)\n}\n\n.modal-header .close {\n    padding: 1rem 1rem;\n    margin: -1rem -1rem -1rem auto\n}\n\n.modal-title {\n    margin-bottom: 0;\n    line-height: 1.5\n}\n\n.modal-body {\n    position: relative;\n    flex: 1 1 auto;\n    padding: 1rem\n}\n\n.modal-footer {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    padding: .75rem;\n    border-top: 1px solid #dee2e6;\n    border-bottom-right-radius: calc(.3rem - 1px);\n    border-bottom-left-radius: calc(.3rem - 1px)\n}\n\n.modal-footer>* {\n    margin: .25rem\n}\n\n.modal-scrollbar-measure {\n    position: absolute;\n    top: -9999px;\n    width: 50px;\n    height: 50px;\n    overflow: scroll\n}\n\n@media (min-width: 576px) {\n    .modal-dialog {\n        max-width: 500px;\n        margin: 1.75rem auto\n    }\n\n    .modal-dialog-scrollable {\n        max-height: calc(100% - 3.5rem)\n    }\n\n    .modal-dialog-scrollable .modal-content {\n        max-height: calc(100vh - 3.5rem)\n    }\n\n    .modal-dialog-centered {\n        min-height: calc(100% - 3.5rem)\n    }\n\n    .modal-dialog-centered::before {\n        height: calc(100vh - 3.5rem)\n    }\n\n    .modal-sm {\n        max-width: 300px\n    }\n}\n\n@media (min-width: 992px) {\n\n    .modal-lg,\n    .modal-xl {\n        max-width: 800px\n    }\n}\n\n@media (min-width: 1200px) {\n    .modal-xl {\n        max-width: 1140px\n    }\n}\n\n.tooltip {\n    position: absolute;\n    z-index: 1070;\n    display: block;\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    word-spacing: normal;\n    white-space: normal;\n    line-break: auto;\n    font-size: 1.4rem;\n    word-wrap: break-word;\n    opacity: 0\n}\n\n.tooltip.show {\n    opacity: .9\n}\n\n.tooltip .arrow {\n    position: absolute;\n    display: block;\n    width: .8rem;\n    height: .4rem\n}\n\n.tooltip .arrow::before {\n    position: absolute;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid\n}\n\n.bs-tooltip-auto[x-placement^=top],\n.bs-tooltip-top {\n    padding: .4rem 0\n}\n\n.bs-tooltip-auto[x-placement^=top] .arrow,\n.bs-tooltip-top .arrow {\n    bottom: 0\n}\n\n.bs-tooltip-auto[x-placement^=top] .arrow::before,\n.bs-tooltip-top .arrow::before {\n    top: 0;\n    border-width: .4rem .4rem 0;\n    border-top-color: #000\n}\n\n.bs-tooltip-auto[x-placement^=right],\n.bs-tooltip-right {\n    padding: 0 .4rem\n}\n\n.bs-tooltip-auto[x-placement^=right] .arrow,\n.bs-tooltip-right .arrow {\n    left: 0;\n    width: .4rem;\n    height: .8rem\n}\n\n.bs-tooltip-auto[x-placement^=right] .arrow::before,\n.bs-tooltip-right .arrow::before {\n    right: 0;\n    border-width: .4rem .4rem .4rem 0;\n    border-right-color: #000\n}\n\n.bs-tooltip-auto[x-placement^=bottom],\n.bs-tooltip-bottom {\n    padding: .4rem 0\n}\n\n.bs-tooltip-auto[x-placement^=bottom] .arrow,\n.bs-tooltip-bottom .arrow {\n    top: 0\n}\n\n.bs-tooltip-auto[x-placement^=bottom] .arrow::before,\n.bs-tooltip-bottom .arrow::before {\n    bottom: 0;\n    border-width: 0 .4rem .4rem;\n    border-bottom-color: #000\n}\n\n.bs-tooltip-auto[x-placement^=left],\n.bs-tooltip-left {\n    padding: 0 .4rem\n}\n\n.bs-tooltip-auto[x-placement^=left] .arrow,\n.bs-tooltip-left .arrow {\n    right: 0;\n    width: .4rem;\n    height: .8rem\n}\n\n.bs-tooltip-auto[x-placement^=left] .arrow::before,\n.bs-tooltip-left .arrow::before {\n    left: 0;\n    border-width: .4rem 0 .4rem .4rem;\n    border-left-color: #000\n}\n\n.tooltip-inner {\n    max-width: 200px;\n    padding: .25rem .5rem;\n    color: #fff;\n    text-align: center;\n    background-color: #000;\n    border-radius: .25rem\n}\n\n.align-baseline {\n    vertical-align: baseline !important\n}\n\n.align-top {\n    vertical-align: top !important\n}\n\n.align-middle {\n    vertical-align: middle !important\n}\n\n.align-bottom {\n    vertical-align: bottom !important\n}\n\n.align-text-bottom {\n    vertical-align: text-bottom !important\n}\n\n.align-text-top {\n    vertical-align: text-top !important\n}\n\n.bg-primary {\n    background-color: #007bff !important\n}\n\na.bg-primary:focus,\na.bg-primary:hover,\nbutton.bg-primary:focus,\nbutton.bg-primary:hover {\n    background-color: rgb(0, 98.4, 204) !important\n}\n\n.bg-secondary {\n    background-color: #6c757d !important\n}\n\na.bg-secondary:focus,\na.bg-secondary:hover,\nbutton.bg-secondary:focus,\nbutton.bg-secondary:hover {\n    background-color: rgb(84.3605150215, 91.3905579399, 97.6394849785) !important\n}\n\n.bg-success {\n    background-color: #28a745 !important\n}\n\na.bg-success:focus,\na.bg-success:hover,\nbutton.bg-success:focus,\nbutton.bg-success:hover {\n    background-color: rgb(30.1449275362, 125.8550724638, 52) !important\n}\n\n.bg-info {\n    background-color: #17a2b8 !important\n}\n\na.bg-info:focus,\na.bg-info:hover,\nbutton.bg-info:focus,\nbutton.bg-info:hover {\n    background-color: rgb(17.3333333333, 122.0869565217, 138.6666666667) !important\n}\n\n.bg-warning {\n    background-color: #ffc107 !important\n}\n\na.bg-warning:focus,\na.bg-warning:hover,\nbutton.bg-warning:focus,\nbutton.bg-warning:hover {\n    background-color: rgb(211, 158.25, 0) !important\n}\n\n.bg-danger {\n    background-color: #dc3545 !important\n}\n\na.bg-danger:focus,\na.bg-danger:hover,\nbutton.bg-danger:focus,\nbutton.bg-danger:hover {\n    background-color: rgb(189.2151898734, 32.7848101266, 47.7721518987) !important\n}\n\n.bg-light {\n    background-color: #f8f9fa !important\n}\n\na.bg-light:focus,\na.bg-light:hover,\nbutton.bg-light:focus,\nbutton.bg-light:hover {\n    background-color: rgb(218.25, 223.5, 228.75) !important\n}\n\n.bg-dark {\n    background-color: #343a40 !important\n}\n\na.bg-dark:focus,\na.bg-dark:hover,\nbutton.bg-dark:focus,\nbutton.bg-dark:hover {\n    background-color: rgb(29.1379310345, 32.5, 35.8620689655) !important\n}\n\n.bg-white {\n    background-color: #fff !important\n}\n\n.bg-transparent {\n    background-color: transparent !important\n}\n\n.border {\n    border: 1px solid #dee2e6 !important\n}\n\n.border-top {\n    border-top: 1px solid #dee2e6 !important\n}\n\n.border-right {\n    border-right: 1px solid #dee2e6 !important\n}\n\n.border-bottom {\n    border-bottom: 1px solid #dee2e6 !important\n}\n\n.border-left {\n    border-left: 1px solid #dee2e6 !important\n}\n\n.border-0 {\n    border: 0 !important\n}\n\n.border-top-0 {\n    border-top: 0 !important\n}\n\n.border-right-0 {\n    border-right: 0 !important\n}\n\n.border-bottom-0 {\n    border-bottom: 0 !important\n}\n\n.border-left-0 {\n    border-left: 0 !important\n}\n\n.border-primary {\n    border-color: #007bff !important\n}\n\n.border-secondary {\n    border-color: #6c757d !important\n}\n\n.border-success {\n    border-color: #28a745 !important\n}\n\n.border-info {\n    border-color: #17a2b8 !important\n}\n\n.border-warning {\n    border-color: #ffc107 !important\n}\n\n.border-danger {\n    border-color: #dc3545 !important\n}\n\n.border-light {\n    border-color: #f8f9fa !important\n}\n\n.border-dark {\n    border-color: #343a40 !important\n}\n\n.border-white {\n    border-color: #fff !important\n}\n\n.rounded-sm {\n    border-radius: .2rem !important\n}\n\n.rounded {\n    border-radius: .25rem !important\n}\n\n.rounded-top {\n    border-top-left-radius: .25rem !important;\n    border-top-right-radius: .25rem !important\n}\n\n.rounded-right {\n    border-top-right-radius: .25rem !important;\n    border-bottom-right-radius: .25rem !important\n}\n\n.rounded-bottom {\n    border-bottom-right-radius: .25rem !important;\n    border-bottom-left-radius: .25rem !important\n}\n\n.rounded-left {\n    border-top-left-radius: .25rem !important;\n    border-bottom-left-radius: .25rem !important\n}\n\n.rounded-lg {\n    border-radius: .3rem !important\n}\n\n.rounded-circle {\n    border-radius: 50% !important\n}\n\n.rounded-pill {\n    border-radius: 50rem !important\n}\n\n.rounded-0 {\n    border-radius: 0 !important\n}\n\n.clearfix::after {\n    display: block;\n    clear: both;\n    content: \"\"\n}\n\n.d-none {\n    display: none !important\n}\n\n.d-inline {\n    display: inline !important\n}\n\n.d-inline-block {\n    display: inline-block !important\n}\n\n.d-block {\n    display: block !important\n}\n\n.d-table {\n    display: table !important\n}\n\n.d-table-row {\n    display: table-row !important\n}\n\n.d-table-cell {\n    display: table-cell !important\n}\n\n.d-flex {\n    display: flex !important\n}\n\n.d-inline-flex {\n    display: inline-flex !important\n}\n\n@media (min-width: 576px) {\n    .d-sm-none {\n        display: none !important\n    }\n\n    .d-sm-inline {\n        display: inline !important\n    }\n\n    .d-sm-inline-block {\n        display: inline-block !important\n    }\n\n    .d-sm-block {\n        display: block !important\n    }\n\n    .d-sm-table {\n        display: table !important\n    }\n\n    .d-sm-table-row {\n        display: table-row !important\n    }\n\n    .d-sm-table-cell {\n        display: table-cell !important\n    }\n\n    .d-sm-flex {\n        display: flex !important\n    }\n\n    .d-sm-inline-flex {\n        display: inline-flex !important\n    }\n}\n\n@media (min-width: 768px) {\n    .d-md-none {\n        display: none !important\n    }\n\n    .d-md-inline {\n        display: inline !important\n    }\n\n    .d-md-inline-block {\n        display: inline-block !important\n    }\n\n    .d-md-block {\n        display: block !important\n    }\n\n    .d-md-table {\n        display: table !important\n    }\n\n    .d-md-table-row {\n        display: table-row !important\n    }\n\n    .d-md-table-cell {\n        display: table-cell !important\n    }\n\n    .d-md-flex {\n        display: flex !important\n    }\n\n    .d-md-inline-flex {\n        display: inline-flex !important\n    }\n}\n\n@media (min-width: 992px) {\n    .d-lg-none {\n        display: none !important\n    }\n\n    .d-lg-inline {\n        display: inline !important\n    }\n\n    .d-lg-inline-block {\n        display: inline-block !important\n    }\n\n    .d-lg-block {\n        display: block !important\n    }\n\n    .d-lg-table {\n        display: table !important\n    }\n\n    .d-lg-table-row {\n        display: table-row !important\n    }\n\n    .d-lg-table-cell {\n        display: table-cell !important\n    }\n\n    .d-lg-flex {\n        display: flex !important\n    }\n\n    .d-lg-inline-flex {\n        display: inline-flex !important\n    }\n}\n\n@media (min-width: 1200px) {\n    .d-xl-none {\n        display: none !important\n    }\n\n    .d-xl-inline {\n        display: inline !important\n    }\n\n    .d-xl-inline-block {\n        display: inline-block !important\n    }\n\n    .d-xl-block {\n        display: block !important\n    }\n\n    .d-xl-table {\n        display: table !important\n    }\n\n    .d-xl-table-row {\n        display: table-row !important\n    }\n\n    .d-xl-table-cell {\n        display: table-cell !important\n    }\n\n    .d-xl-flex {\n        display: flex !important\n    }\n\n    .d-xl-inline-flex {\n        display: inline-flex !important\n    }\n}\n\n@media print {\n    .d-print-none {\n        display: none !important\n    }\n\n    .d-print-inline {\n        display: inline !important\n    }\n\n    .d-print-inline-block {\n        display: inline-block !important\n    }\n\n    .d-print-block {\n        display: block !important\n    }\n\n    .d-print-table {\n        display: table !important\n    }\n\n    .d-print-table-row {\n        display: table-row !important\n    }\n\n    .d-print-table-cell {\n        display: table-cell !important\n    }\n\n    .d-print-flex {\n        display: flex !important\n    }\n\n    .d-print-inline-flex {\n        display: inline-flex !important\n    }\n}\n\n.embed-responsive {\n    position: relative;\n    display: block;\n    width: 100%;\n    padding: 0;\n    overflow: hidden\n}\n\n.embed-responsive::before {\n    display: block;\n    content: \"\"\n}\n\n.embed-responsive .embed-responsive-item,\n.embed-responsive embed,\n.embed-responsive iframe,\n.embed-responsive object,\n.embed-responsive video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0\n}\n\n.embed-responsive-21by9::before {\n    padding-top: .4285714286\n}\n\n.embed-responsive-16by9::before {\n    padding-top: .5625\n}\n\n.embed-responsive-4by3::before {\n    padding-top: .75\n}\n\n.embed-responsive-1by1::before {\n    padding-top: 1\n}\n\n.flex-row {\n    flex-direction: row !important\n}\n\n.flex-column {\n    flex-direction: column !important\n}\n\n.flex-row-reverse {\n    flex-direction: row-reverse !important\n}\n\n.flex-column-reverse {\n    flex-direction: column-reverse !important\n}\n\n.flex-wrap {\n    flex-wrap: wrap !important\n}\n\n.flex-nowrap {\n    flex-wrap: nowrap !important\n}\n\n.flex-wrap-reverse {\n    flex-wrap: wrap-reverse !important\n}\n\n.flex-fill {\n    flex: 1 1 auto !important\n}\n\n.flex-grow-0 {\n    flex-grow: 0 !important\n}\n\n.flex-grow-1 {\n    flex-grow: 1 !important\n}\n\n.flex-shrink-0 {\n    flex-shrink: 0 !important\n}\n\n.flex-shrink-1 {\n    flex-shrink: 1 !important\n}\n\n.justify-content-start {\n    justify-content: flex-start !important\n}\n\n.justify-content-end {\n    justify-content: flex-end !important\n}\n\n.justify-content-center {\n    justify-content: center !important\n}\n\n.justify-content-between {\n    justify-content: space-between !important\n}\n\n.justify-content-around {\n    justify-content: space-around !important\n}\n\n.align-items-start {\n    align-items: flex-start !important\n}\n\n.align-items-end {\n    align-items: flex-end !important\n}\n\n.align-items-center {\n    align-items: center !important\n}\n\n.align-items-baseline {\n    align-items: baseline !important\n}\n\n.align-items-stretch {\n    align-items: stretch !important\n}\n\n.align-content-start {\n    align-content: flex-start !important\n}\n\n.align-content-end {\n    align-content: flex-end !important\n}\n\n.align-content-center {\n    align-content: center !important\n}\n\n.align-content-between {\n    align-content: space-between !important\n}\n\n.align-content-around {\n    align-content: space-around !important\n}\n\n.align-content-stretch {\n    align-content: stretch !important\n}\n\n.align-self-auto {\n    align-self: auto !important\n}\n\n.align-self-start {\n    align-self: flex-start !important\n}\n\n.align-self-end {\n    align-self: flex-end !important\n}\n\n.align-self-center {\n    align-self: center !important\n}\n\n.align-self-baseline {\n    align-self: baseline !important\n}\n\n.align-self-stretch {\n    align-self: stretch !important\n}\n\n@media (min-width: 576px) {\n    .flex-sm-row {\n        flex-direction: row !important\n    }\n\n    .flex-sm-column {\n        flex-direction: column !important\n    }\n\n    .flex-sm-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-sm-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-sm-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-sm-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-sm-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .flex-sm-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-sm-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-sm-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-sm-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-sm-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .justify-content-sm-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-sm-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-sm-center {\n        justify-content: center !important\n    }\n\n    .justify-content-sm-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-sm-around {\n        justify-content: space-around !important\n    }\n\n    .align-items-sm-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-sm-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-sm-center {\n        align-items: center !important\n    }\n\n    .align-items-sm-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-sm-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-sm-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-sm-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-sm-center {\n        align-content: center !important\n    }\n\n    .align-content-sm-between {\n        align-content: space-between !important\n    }\n\n    .align-content-sm-around {\n        align-content: space-around !important\n    }\n\n    .align-content-sm-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-sm-auto {\n        align-self: auto !important\n    }\n\n    .align-self-sm-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-sm-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-sm-center {\n        align-self: center !important\n    }\n\n    .align-self-sm-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-sm-stretch {\n        align-self: stretch !important\n    }\n}\n\n@media (min-width: 768px) {\n    .flex-md-row {\n        flex-direction: row !important\n    }\n\n    .flex-md-column {\n        flex-direction: column !important\n    }\n\n    .flex-md-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-md-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-md-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-md-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-md-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .flex-md-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-md-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-md-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-md-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-md-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .justify-content-md-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-md-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-md-center {\n        justify-content: center !important\n    }\n\n    .justify-content-md-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-md-around {\n        justify-content: space-around !important\n    }\n\n    .align-items-md-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-md-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-md-center {\n        align-items: center !important\n    }\n\n    .align-items-md-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-md-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-md-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-md-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-md-center {\n        align-content: center !important\n    }\n\n    .align-content-md-between {\n        align-content: space-between !important\n    }\n\n    .align-content-md-around {\n        align-content: space-around !important\n    }\n\n    .align-content-md-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-md-auto {\n        align-self: auto !important\n    }\n\n    .align-self-md-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-md-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-md-center {\n        align-self: center !important\n    }\n\n    .align-self-md-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-md-stretch {\n        align-self: stretch !important\n    }\n}\n\n@media (min-width: 992px) {\n    .flex-lg-row {\n        flex-direction: row !important\n    }\n\n    .flex-lg-column {\n        flex-direction: column !important\n    }\n\n    .flex-lg-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-lg-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-lg-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-lg-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-lg-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .flex-lg-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-lg-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-lg-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-lg-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-lg-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .justify-content-lg-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-lg-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-lg-center {\n        justify-content: center !important\n    }\n\n    .justify-content-lg-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-lg-around {\n        justify-content: space-around !important\n    }\n\n    .align-items-lg-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-lg-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-lg-center {\n        align-items: center !important\n    }\n\n    .align-items-lg-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-lg-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-lg-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-lg-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-lg-center {\n        align-content: center !important\n    }\n\n    .align-content-lg-between {\n        align-content: space-between !important\n    }\n\n    .align-content-lg-around {\n        align-content: space-around !important\n    }\n\n    .align-content-lg-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-lg-auto {\n        align-self: auto !important\n    }\n\n    .align-self-lg-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-lg-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-lg-center {\n        align-self: center !important\n    }\n\n    .align-self-lg-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-lg-stretch {\n        align-self: stretch !important\n    }\n}\n\n@media (min-width: 1200px) {\n    .flex-xl-row {\n        flex-direction: row !important\n    }\n\n    .flex-xl-column {\n        flex-direction: column !important\n    }\n\n    .flex-xl-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-xl-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-xl-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-xl-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-xl-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .flex-xl-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-xl-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-xl-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-xl-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-xl-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .justify-content-xl-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-xl-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-xl-center {\n        justify-content: center !important\n    }\n\n    .justify-content-xl-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-xl-around {\n        justify-content: space-around !important\n    }\n\n    .align-items-xl-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-xl-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-xl-center {\n        align-items: center !important\n    }\n\n    .align-items-xl-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-xl-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-xl-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-xl-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-xl-center {\n        align-content: center !important\n    }\n\n    .align-content-xl-between {\n        align-content: space-between !important\n    }\n\n    .align-content-xl-around {\n        align-content: space-around !important\n    }\n\n    .align-content-xl-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-xl-auto {\n        align-self: auto !important\n    }\n\n    .align-self-xl-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-xl-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-xl-center {\n        align-self: center !important\n    }\n\n    .align-self-xl-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-xl-stretch {\n        align-self: stretch !important\n    }\n}\n\n.float-left {\n    float: left !important\n}\n\n.float-right {\n    float: right !important\n}\n\n.float-none {\n    float: none !important\n}\n\n@media (min-width: 576px) {\n    .float-sm-left {\n        float: left !important\n    }\n\n    .float-sm-right {\n        float: right !important\n    }\n\n    .float-sm-none {\n        float: none !important\n    }\n}\n\n@media (min-width: 768px) {\n    .float-md-left {\n        float: left !important\n    }\n\n    .float-md-right {\n        float: right !important\n    }\n\n    .float-md-none {\n        float: none !important\n    }\n}\n\n@media (min-width: 992px) {\n    .float-lg-left {\n        float: left !important\n    }\n\n    .float-lg-right {\n        float: right !important\n    }\n\n    .float-lg-none {\n        float: none !important\n    }\n}\n\n@media (min-width: 1200px) {\n    .float-xl-left {\n        float: left !important\n    }\n\n    .float-xl-right {\n        float: right !important\n    }\n\n    .float-xl-none {\n        float: none !important\n    }\n}\n\n.overflow-auto {\n    overflow: auto !important\n}\n\n.overflow-hidden {\n    overflow: hidden !important\n}\n\n.position-static {\n    position: static !important\n}\n\n.position-relative {\n    position: relative !important\n}\n\n.position-absolute {\n    position: absolute !important\n}\n\n.position-fixed {\n    position: fixed !important\n}\n\n.position-sticky {\n    position: sticky !important\n}\n\n.fixed-top {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1030\n}\n\n.fixed-bottom {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1030\n}\n\n@supports (position: sticky) {\n    .sticky-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n}\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0\n}\n\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal\n}\n\n.shadow-sm {\n    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important\n}\n\n.shadow {\n    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important\n}\n\n.shadow-lg {\n    box-shadow: 0 1rem 3rem rgba(0, 0, 0, .175) !important\n}\n\n.shadow-none {\n    box-shadow: none !important\n}\n\n.w-25 {\n    width: 25% !important\n}\n\n.w-50 {\n    width: 50% !important\n}\n\n.w-75 {\n    width: 75% !important\n}\n\n.w-100 {\n    width: 100% !important\n}\n\n.w-auto {\n    width: auto !important\n}\n\n.h-25 {\n    height: 25% !important\n}\n\n.h-50 {\n    height: 50% !important\n}\n\n.h-75 {\n    height: 75% !important\n}\n\n.h-100 {\n    height: 100% !important\n}\n\n.h-auto {\n    height: auto !important\n}\n\n.mw-100 {\n    max-width: 100% !important\n}\n\n.mh-100 {\n    max-height: 100% !important\n}\n\n.min-vw-100 {\n    min-width: 100vw !important\n}\n\n.min-vh-100 {\n    min-height: 100vh !important\n}\n\n.vw-100 {\n    width: 100vw !important\n}\n\n.vh-100 {\n    height: 100vh !important\n}\n\n.stretched-link::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    pointer-events: auto;\n    content: \"\";\n    background-color: rgba(0, 0, 0, 0)\n}\n\n.m-0 {\n    margin: 0 !important\n}\n\n.mt-0,\n.my-0 {\n    margin-top: 0 !important\n}\n\n.mr-0,\n.mx-0 {\n    margin-right: 0 !important\n}\n\n.mb-0,\n.my-0 {\n    margin-bottom: 0 !important\n}\n\n.ml-0,\n.mx-0 {\n    margin-left: 0 !important\n}\n\n.m-1 {\n    margin: .4rem !important\n}\n\n.mt-1,\n.my-1 {\n    margin-top: .4rem !important\n}\n\n.mr-1,\n.mx-1 {\n    margin-right: .4rem !important\n}\n\n.mb-1,\n.my-1 {\n    margin-bottom: .4rem !important\n}\n\n.ml-1,\n.mx-1 {\n    margin-left: .4rem !important\n}\n\n.m-2 {\n    margin: .8rem !important\n}\n\n.mt-2,\n.my-2 {\n    margin-top: .8rem !important\n}\n\n.mr-2,\n.mx-2 {\n    margin-right: .8rem !important\n}\n\n.mb-2,\n.my-2 {\n    margin-bottom: .8rem !important\n}\n\n.ml-2,\n.mx-2 {\n    margin-left: .8rem !important\n}\n\n.m-3 {\n    margin: 1.6rem !important\n}\n\n.mt-3,\n.my-3 {\n    margin-top: 1.6rem !important\n}\n\n.mr-3,\n.mx-3 {\n    margin-right: 1.6rem !important\n}\n\n.mb-3,\n.my-3 {\n    margin-bottom: 1.6rem !important\n}\n\n.ml-3,\n.mx-3 {\n    margin-left: 1.6rem !important\n}\n\n.m-4 {\n    margin: 2.4rem !important\n}\n\n.mt-4,\n.my-4 {\n    margin-top: 2.4rem !important\n}\n\n.mr-4,\n.mx-4 {\n    margin-right: 2.4rem !important\n}\n\n.mb-4,\n.my-4 {\n    margin-bottom: 2.4rem !important\n}\n\n.ml-4,\n.mx-4 {\n    margin-left: 2.4rem !important\n}\n\n.m-5 {\n    margin: 4.8rem !important\n}\n\n.mt-5,\n.my-5 {\n    margin-top: 4.8rem !important\n}\n\n.mr-5,\n.mx-5 {\n    margin-right: 4.8rem !important\n}\n\n.mb-5,\n.my-5 {\n    margin-bottom: 4.8rem !important\n}\n\n.ml-5,\n.mx-5 {\n    margin-left: 4.8rem !important\n}\n\n.p-0 {\n    padding: 0 !important\n}\n\n.pt-0,\n.py-0 {\n    padding-top: 0 !important\n}\n\n.pr-0,\n.px-0 {\n    padding-right: 0 !important\n}\n\n.pb-0,\n.py-0 {\n    padding-bottom: 0 !important\n}\n\n.pl-0,\n.px-0 {\n    padding-left: 0 !important\n}\n\n.p-1 {\n    padding: .4rem !important\n}\n\n.pt-1,\n.py-1 {\n    padding-top: .4rem !important\n}\n\n.pr-1,\n.px-1 {\n    padding-right: .4rem !important\n}\n\n.pb-1,\n.py-1 {\n    padding-bottom: .4rem !important\n}\n\n.pl-1,\n.px-1 {\n    padding-left: .4rem !important\n}\n\n.p-2 {\n    padding: .8rem !important\n}\n\n.pt-2,\n.py-2 {\n    padding-top: .8rem !important\n}\n\n.pr-2,\n.px-2 {\n    padding-right: .8rem !important\n}\n\n.pb-2,\n.py-2 {\n    padding-bottom: .8rem !important\n}\n\n.pl-2,\n.px-2 {\n    padding-left: .8rem !important\n}\n\n.p-3 {\n    padding: 1.6rem !important\n}\n\n.pt-3,\n.py-3 {\n    padding-top: 1.6rem !important\n}\n\n.pr-3,\n.px-3 {\n    padding-right: 1.6rem !important\n}\n\n.pb-3,\n.py-3 {\n    padding-bottom: 1.6rem !important\n}\n\n.pl-3,\n.px-3 {\n    padding-left: 1.6rem !important\n}\n\n.p-4 {\n    padding: 2.4rem !important\n}\n\n.pt-4,\n.py-4 {\n    padding-top: 2.4rem !important\n}\n\n.pr-4,\n.px-4 {\n    padding-right: 2.4rem !important\n}\n\n.pb-4,\n.py-4 {\n    padding-bottom: 2.4rem !important\n}\n\n.pl-4,\n.px-4 {\n    padding-left: 2.4rem !important\n}\n\n.p-5 {\n    padding: 4.8rem !important\n}\n\n.pt-5,\n.py-5 {\n    padding-top: 4.8rem !important\n}\n\n.pr-5,\n.px-5 {\n    padding-right: 4.8rem !important\n}\n\n.pb-5,\n.py-5 {\n    padding-bottom: 4.8rem !important\n}\n\n.pl-5,\n.px-5 {\n    padding-left: 4.8rem !important\n}\n\n.m-n1 {\n    margin: -.4rem !important\n}\n\n.mt-n1,\n.my-n1 {\n    margin-top: -.4rem !important\n}\n\n.mr-n1,\n.mx-n1 {\n    margin-right: -.4rem !important\n}\n\n.mb-n1,\n.my-n1 {\n    margin-bottom: -.4rem !important\n}\n\n.ml-n1,\n.mx-n1 {\n    margin-left: -.4rem !important\n}\n\n.m-n2 {\n    margin: -.8rem !important\n}\n\n.mt-n2,\n.my-n2 {\n    margin-top: -.8rem !important\n}\n\n.mr-n2,\n.mx-n2 {\n    margin-right: -.8rem !important\n}\n\n.mb-n2,\n.my-n2 {\n    margin-bottom: -.8rem !important\n}\n\n.ml-n2,\n.mx-n2 {\n    margin-left: -.8rem !important\n}\n\n.m-n3 {\n    margin: -1.6rem !important\n}\n\n.mt-n3,\n.my-n3 {\n    margin-top: -1.6rem !important\n}\n\n.mr-n3,\n.mx-n3 {\n    margin-right: -1.6rem !important\n}\n\n.mb-n3,\n.my-n3 {\n    margin-bottom: -1.6rem !important\n}\n\n.ml-n3,\n.mx-n3 {\n    margin-left: -1.6rem !important\n}\n\n.m-n4 {\n    margin: -2.4rem !important\n}\n\n.mt-n4,\n.my-n4 {\n    margin-top: -2.4rem !important\n}\n\n.mr-n4,\n.mx-n4 {\n    margin-right: -2.4rem !important\n}\n\n.mb-n4,\n.my-n4 {\n    margin-bottom: -2.4rem !important\n}\n\n.ml-n4,\n.mx-n4 {\n    margin-left: -2.4rem !important\n}\n\n.m-n5 {\n    margin: -4.8rem !important\n}\n\n.mt-n5,\n.my-n5 {\n    margin-top: -4.8rem !important\n}\n\n.mr-n5,\n.mx-n5 {\n    margin-right: -4.8rem !important\n}\n\n.mb-n5,\n.my-n5 {\n    margin-bottom: -4.8rem !important\n}\n\n.ml-n5,\n.mx-n5 {\n    margin-left: -4.8rem !important\n}\n\n.m-auto {\n    margin: auto !important\n}\n\n.mt-auto,\n.my-auto {\n    margin-top: auto !important\n}\n\n.mr-auto,\n.mx-auto {\n    margin-right: auto !important\n}\n\n.mb-auto,\n.my-auto {\n    margin-bottom: auto !important\n}\n\n.ml-auto,\n.mx-auto {\n    margin-left: auto !important\n}\n\n@media (min-width: 576px) {\n    .m-sm-0 {\n        margin: 0 !important\n    }\n\n    .mt-sm-0,\n    .my-sm-0 {\n        margin-top: 0 !important\n    }\n\n    .mr-sm-0,\n    .mx-sm-0 {\n        margin-right: 0 !important\n    }\n\n    .mb-sm-0,\n    .my-sm-0 {\n        margin-bottom: 0 !important\n    }\n\n    .ml-sm-0,\n    .mx-sm-0 {\n        margin-left: 0 !important\n    }\n\n    .m-sm-1 {\n        margin: .4rem !important\n    }\n\n    .mt-sm-1,\n    .my-sm-1 {\n        margin-top: .4rem !important\n    }\n\n    .mr-sm-1,\n    .mx-sm-1 {\n        margin-right: .4rem !important\n    }\n\n    .mb-sm-1,\n    .my-sm-1 {\n        margin-bottom: .4rem !important\n    }\n\n    .ml-sm-1,\n    .mx-sm-1 {\n        margin-left: .4rem !important\n    }\n\n    .m-sm-2 {\n        margin: .8rem !important\n    }\n\n    .mt-sm-2,\n    .my-sm-2 {\n        margin-top: .8rem !important\n    }\n\n    .mr-sm-2,\n    .mx-sm-2 {\n        margin-right: .8rem !important\n    }\n\n    .mb-sm-2,\n    .my-sm-2 {\n        margin-bottom: .8rem !important\n    }\n\n    .ml-sm-2,\n    .mx-sm-2 {\n        margin-left: .8rem !important\n    }\n\n    .m-sm-3 {\n        margin: 1.6rem !important\n    }\n\n    .mt-sm-3,\n    .my-sm-3 {\n        margin-top: 1.6rem !important\n    }\n\n    .mr-sm-3,\n    .mx-sm-3 {\n        margin-right: 1.6rem !important\n    }\n\n    .mb-sm-3,\n    .my-sm-3 {\n        margin-bottom: 1.6rem !important\n    }\n\n    .ml-sm-3,\n    .mx-sm-3 {\n        margin-left: 1.6rem !important\n    }\n\n    .m-sm-4 {\n        margin: 2.4rem !important\n    }\n\n    .mt-sm-4,\n    .my-sm-4 {\n        margin-top: 2.4rem !important\n    }\n\n    .mr-sm-4,\n    .mx-sm-4 {\n        margin-right: 2.4rem !important\n    }\n\n    .mb-sm-4,\n    .my-sm-4 {\n        margin-bottom: 2.4rem !important\n    }\n\n    .ml-sm-4,\n    .mx-sm-4 {\n        margin-left: 2.4rem !important\n    }\n\n    .m-sm-5 {\n        margin: 4.8rem !important\n    }\n\n    .mt-sm-5,\n    .my-sm-5 {\n        margin-top: 4.8rem !important\n    }\n\n    .mr-sm-5,\n    .mx-sm-5 {\n        margin-right: 4.8rem !important\n    }\n\n    .mb-sm-5,\n    .my-sm-5 {\n        margin-bottom: 4.8rem !important\n    }\n\n    .ml-sm-5,\n    .mx-sm-5 {\n        margin-left: 4.8rem !important\n    }\n\n    .p-sm-0 {\n        padding: 0 !important\n    }\n\n    .pt-sm-0,\n    .py-sm-0 {\n        padding-top: 0 !important\n    }\n\n    .pr-sm-0,\n    .px-sm-0 {\n        padding-right: 0 !important\n    }\n\n    .pb-sm-0,\n    .py-sm-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pl-sm-0,\n    .px-sm-0 {\n        padding-left: 0 !important\n    }\n\n    .p-sm-1 {\n        padding: .4rem !important\n    }\n\n    .pt-sm-1,\n    .py-sm-1 {\n        padding-top: .4rem !important\n    }\n\n    .pr-sm-1,\n    .px-sm-1 {\n        padding-right: .4rem !important\n    }\n\n    .pb-sm-1,\n    .py-sm-1 {\n        padding-bottom: .4rem !important\n    }\n\n    .pl-sm-1,\n    .px-sm-1 {\n        padding-left: .4rem !important\n    }\n\n    .p-sm-2 {\n        padding: .8rem !important\n    }\n\n    .pt-sm-2,\n    .py-sm-2 {\n        padding-top: .8rem !important\n    }\n\n    .pr-sm-2,\n    .px-sm-2 {\n        padding-right: .8rem !important\n    }\n\n    .pb-sm-2,\n    .py-sm-2 {\n        padding-bottom: .8rem !important\n    }\n\n    .pl-sm-2,\n    .px-sm-2 {\n        padding-left: .8rem !important\n    }\n\n    .p-sm-3 {\n        padding: 1.6rem !important\n    }\n\n    .pt-sm-3,\n    .py-sm-3 {\n        padding-top: 1.6rem !important\n    }\n\n    .pr-sm-3,\n    .px-sm-3 {\n        padding-right: 1.6rem !important\n    }\n\n    .pb-sm-3,\n    .py-sm-3 {\n        padding-bottom: 1.6rem !important\n    }\n\n    .pl-sm-3,\n    .px-sm-3 {\n        padding-left: 1.6rem !important\n    }\n\n    .p-sm-4 {\n        padding: 2.4rem !important\n    }\n\n    .pt-sm-4,\n    .py-sm-4 {\n        padding-top: 2.4rem !important\n    }\n\n    .pr-sm-4,\n    .px-sm-4 {\n        padding-right: 2.4rem !important\n    }\n\n    .pb-sm-4,\n    .py-sm-4 {\n        padding-bottom: 2.4rem !important\n    }\n\n    .pl-sm-4,\n    .px-sm-4 {\n        padding-left: 2.4rem !important\n    }\n\n    .p-sm-5 {\n        padding: 4.8rem !important\n    }\n\n    .pt-sm-5,\n    .py-sm-5 {\n        padding-top: 4.8rem !important\n    }\n\n    .pr-sm-5,\n    .px-sm-5 {\n        padding-right: 4.8rem !important\n    }\n\n    .pb-sm-5,\n    .py-sm-5 {\n        padding-bottom: 4.8rem !important\n    }\n\n    .pl-sm-5,\n    .px-sm-5 {\n        padding-left: 4.8rem !important\n    }\n\n    .m-sm-n1 {\n        margin: -.4rem !important\n    }\n\n    .mt-sm-n1,\n    .my-sm-n1 {\n        margin-top: -.4rem !important\n    }\n\n    .mr-sm-n1,\n    .mx-sm-n1 {\n        margin-right: -.4rem !important\n    }\n\n    .mb-sm-n1,\n    .my-sm-n1 {\n        margin-bottom: -.4rem !important\n    }\n\n    .ml-sm-n1,\n    .mx-sm-n1 {\n        margin-left: -.4rem !important\n    }\n\n    .m-sm-n2 {\n        margin: -.8rem !important\n    }\n\n    .mt-sm-n2,\n    .my-sm-n2 {\n        margin-top: -.8rem !important\n    }\n\n    .mr-sm-n2,\n    .mx-sm-n2 {\n        margin-right: -.8rem !important\n    }\n\n    .mb-sm-n2,\n    .my-sm-n2 {\n        margin-bottom: -.8rem !important\n    }\n\n    .ml-sm-n2,\n    .mx-sm-n2 {\n        margin-left: -.8rem !important\n    }\n\n    .m-sm-n3 {\n        margin: -1.6rem !important\n    }\n\n    .mt-sm-n3,\n    .my-sm-n3 {\n        margin-top: -1.6rem !important\n    }\n\n    .mr-sm-n3,\n    .mx-sm-n3 {\n        margin-right: -1.6rem !important\n    }\n\n    .mb-sm-n3,\n    .my-sm-n3 {\n        margin-bottom: -1.6rem !important\n    }\n\n    .ml-sm-n3,\n    .mx-sm-n3 {\n        margin-left: -1.6rem !important\n    }\n\n    .m-sm-n4 {\n        margin: -2.4rem !important\n    }\n\n    .mt-sm-n4,\n    .my-sm-n4 {\n        margin-top: -2.4rem !important\n    }\n\n    .mr-sm-n4,\n    .mx-sm-n4 {\n        margin-right: -2.4rem !important\n    }\n\n    .mb-sm-n4,\n    .my-sm-n4 {\n        margin-bottom: -2.4rem !important\n    }\n\n    .ml-sm-n4,\n    .mx-sm-n4 {\n        margin-left: -2.4rem !important\n    }\n\n    .m-sm-n5 {\n        margin: -4.8rem !important\n    }\n\n    .mt-sm-n5,\n    .my-sm-n5 {\n        margin-top: -4.8rem !important\n    }\n\n    .mr-sm-n5,\n    .mx-sm-n5 {\n        margin-right: -4.8rem !important\n    }\n\n    .mb-sm-n5,\n    .my-sm-n5 {\n        margin-bottom: -4.8rem !important\n    }\n\n    .ml-sm-n5,\n    .mx-sm-n5 {\n        margin-left: -4.8rem !important\n    }\n\n    .m-sm-auto {\n        margin: auto !important\n    }\n\n    .mt-sm-auto,\n    .my-sm-auto {\n        margin-top: auto !important\n    }\n\n    .mr-sm-auto,\n    .mx-sm-auto {\n        margin-right: auto !important\n    }\n\n    .mb-sm-auto,\n    .my-sm-auto {\n        margin-bottom: auto !important\n    }\n\n    .ml-sm-auto,\n    .mx-sm-auto {\n        margin-left: auto !important\n    }\n}\n\n@media (min-width: 768px) {\n    .m-md-0 {\n        margin: 0 !important\n    }\n\n    .mt-md-0,\n    .my-md-0 {\n        margin-top: 0 !important\n    }\n\n    .mr-md-0,\n    .mx-md-0 {\n        margin-right: 0 !important\n    }\n\n    .mb-md-0,\n    .my-md-0 {\n        margin-bottom: 0 !important\n    }\n\n    .ml-md-0,\n    .mx-md-0 {\n        margin-left: 0 !important\n    }\n\n    .m-md-1 {\n        margin: .4rem !important\n    }\n\n    .mt-md-1,\n    .my-md-1 {\n        margin-top: .4rem !important\n    }\n\n    .mr-md-1,\n    .mx-md-1 {\n        margin-right: .4rem !important\n    }\n\n    .mb-md-1,\n    .my-md-1 {\n        margin-bottom: .4rem !important\n    }\n\n    .ml-md-1,\n    .mx-md-1 {\n        margin-left: .4rem !important\n    }\n\n    .m-md-2 {\n        margin: .8rem !important\n    }\n\n    .mt-md-2,\n    .my-md-2 {\n        margin-top: .8rem !important\n    }\n\n    .mr-md-2,\n    .mx-md-2 {\n        margin-right: .8rem !important\n    }\n\n    .mb-md-2,\n    .my-md-2 {\n        margin-bottom: .8rem !important\n    }\n\n    .ml-md-2,\n    .mx-md-2 {\n        margin-left: .8rem !important\n    }\n\n    .m-md-3 {\n        margin: 1.6rem !important\n    }\n\n    .mt-md-3,\n    .my-md-3 {\n        margin-top: 1.6rem !important\n    }\n\n    .mr-md-3,\n    .mx-md-3 {\n        margin-right: 1.6rem !important\n    }\n\n    .mb-md-3,\n    .my-md-3 {\n        margin-bottom: 1.6rem !important\n    }\n\n    .ml-md-3,\n    .mx-md-3 {\n        margin-left: 1.6rem !important\n    }\n\n    .m-md-4 {\n        margin: 2.4rem !important\n    }\n\n    .mt-md-4,\n    .my-md-4 {\n        margin-top: 2.4rem !important\n    }\n\n    .mr-md-4,\n    .mx-md-4 {\n        margin-right: 2.4rem !important\n    }\n\n    .mb-md-4,\n    .my-md-4 {\n        margin-bottom: 2.4rem !important\n    }\n\n    .ml-md-4,\n    .mx-md-4 {\n        margin-left: 2.4rem !important\n    }\n\n    .m-md-5 {\n        margin: 4.8rem !important\n    }\n\n    .mt-md-5,\n    .my-md-5 {\n        margin-top: 4.8rem !important\n    }\n\n    .mr-md-5,\n    .mx-md-5 {\n        margin-right: 4.8rem !important\n    }\n\n    .mb-md-5,\n    .my-md-5 {\n        margin-bottom: 4.8rem !important\n    }\n\n    .ml-md-5,\n    .mx-md-5 {\n        margin-left: 4.8rem !important\n    }\n\n    .p-md-0 {\n        padding: 0 !important\n    }\n\n    .pt-md-0,\n    .py-md-0 {\n        padding-top: 0 !important\n    }\n\n    .pr-md-0,\n    .px-md-0 {\n        padding-right: 0 !important\n    }\n\n    .pb-md-0,\n    .py-md-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pl-md-0,\n    .px-md-0 {\n        padding-left: 0 !important\n    }\n\n    .p-md-1 {\n        padding: .4rem !important\n    }\n\n    .pt-md-1,\n    .py-md-1 {\n        padding-top: .4rem !important\n    }\n\n    .pr-md-1,\n    .px-md-1 {\n        padding-right: .4rem !important\n    }\n\n    .pb-md-1,\n    .py-md-1 {\n        padding-bottom: .4rem !important\n    }\n\n    .pl-md-1,\n    .px-md-1 {\n        padding-left: .4rem !important\n    }\n\n    .p-md-2 {\n        padding: .8rem !important\n    }\n\n    .pt-md-2,\n    .py-md-2 {\n        padding-top: .8rem !important\n    }\n\n    .pr-md-2,\n    .px-md-2 {\n        padding-right: .8rem !important\n    }\n\n    .pb-md-2,\n    .py-md-2 {\n        padding-bottom: .8rem !important\n    }\n\n    .pl-md-2,\n    .px-md-2 {\n        padding-left: .8rem !important\n    }\n\n    .p-md-3 {\n        padding: 1.6rem !important\n    }\n\n    .pt-md-3,\n    .py-md-3 {\n        padding-top: 1.6rem !important\n    }\n\n    .pr-md-3,\n    .px-md-3 {\n        padding-right: 1.6rem !important\n    }\n\n    .pb-md-3,\n    .py-md-3 {\n        padding-bottom: 1.6rem !important\n    }\n\n    .pl-md-3,\n    .px-md-3 {\n        padding-left: 1.6rem !important\n    }\n\n    .p-md-4 {\n        padding: 2.4rem !important\n    }\n\n    .pt-md-4,\n    .py-md-4 {\n        padding-top: 2.4rem !important\n    }\n\n    .pr-md-4,\n    .px-md-4 {\n        padding-right: 2.4rem !important\n    }\n\n    .pb-md-4,\n    .py-md-4 {\n        padding-bottom: 2.4rem !important\n    }\n\n    .pl-md-4,\n    .px-md-4 {\n        padding-left: 2.4rem !important\n    }\n\n    .p-md-5 {\n        padding: 4.8rem !important\n    }\n\n    .pt-md-5,\n    .py-md-5 {\n        padding-top: 4.8rem !important\n    }\n\n    .pr-md-5,\n    .px-md-5 {\n        padding-right: 4.8rem !important\n    }\n\n    .pb-md-5,\n    .py-md-5 {\n        padding-bottom: 4.8rem !important\n    }\n\n    .pl-md-5,\n    .px-md-5 {\n        padding-left: 4.8rem !important\n    }\n\n    .m-md-n1 {\n        margin: -.4rem !important\n    }\n\n    .mt-md-n1,\n    .my-md-n1 {\n        margin-top: -.4rem !important\n    }\n\n    .mr-md-n1,\n    .mx-md-n1 {\n        margin-right: -.4rem !important\n    }\n\n    .mb-md-n1,\n    .my-md-n1 {\n        margin-bottom: -.4rem !important\n    }\n\n    .ml-md-n1,\n    .mx-md-n1 {\n        margin-left: -.4rem !important\n    }\n\n    .m-md-n2 {\n        margin: -.8rem !important\n    }\n\n    .mt-md-n2,\n    .my-md-n2 {\n        margin-top: -.8rem !important\n    }\n\n    .mr-md-n2,\n    .mx-md-n2 {\n        margin-right: -.8rem !important\n    }\n\n    .mb-md-n2,\n    .my-md-n2 {\n        margin-bottom: -.8rem !important\n    }\n\n    .ml-md-n2,\n    .mx-md-n2 {\n        margin-left: -.8rem !important\n    }\n\n    .m-md-n3 {\n        margin: -1.6rem !important\n    }\n\n    .mt-md-n3,\n    .my-md-n3 {\n        margin-top: -1.6rem !important\n    }\n\n    .mr-md-n3,\n    .mx-md-n3 {\n        margin-right: -1.6rem !important\n    }\n\n    .mb-md-n3,\n    .my-md-n3 {\n        margin-bottom: -1.6rem !important\n    }\n\n    .ml-md-n3,\n    .mx-md-n3 {\n        margin-left: -1.6rem !important\n    }\n\n    .m-md-n4 {\n        margin: -2.4rem !important\n    }\n\n    .mt-md-n4,\n    .my-md-n4 {\n        margin-top: -2.4rem !important\n    }\n\n    .mr-md-n4,\n    .mx-md-n4 {\n        margin-right: -2.4rem !important\n    }\n\n    .mb-md-n4,\n    .my-md-n4 {\n        margin-bottom: -2.4rem !important\n    }\n\n    .ml-md-n4,\n    .mx-md-n4 {\n        margin-left: -2.4rem !important\n    }\n\n    .m-md-n5 {\n        margin: -4.8rem !important\n    }\n\n    .mt-md-n5,\n    .my-md-n5 {\n        margin-top: -4.8rem !important\n    }\n\n    .mr-md-n5,\n    .mx-md-n5 {\n        margin-right: -4.8rem !important\n    }\n\n    .mb-md-n5,\n    .my-md-n5 {\n        margin-bottom: -4.8rem !important\n    }\n\n    .ml-md-n5,\n    .mx-md-n5 {\n        margin-left: -4.8rem !important\n    }\n\n    .m-md-auto {\n        margin: auto !important\n    }\n\n    .mt-md-auto,\n    .my-md-auto {\n        margin-top: auto !important\n    }\n\n    .mr-md-auto,\n    .mx-md-auto {\n        margin-right: auto !important\n    }\n\n    .mb-md-auto,\n    .my-md-auto {\n        margin-bottom: auto !important\n    }\n\n    .ml-md-auto,\n    .mx-md-auto {\n        margin-left: auto !important\n    }\n}\n\n@media (min-width: 992px) {\n    .m-lg-0 {\n        margin: 0 !important\n    }\n\n    .mt-lg-0,\n    .my-lg-0 {\n        margin-top: 0 !important\n    }\n\n    .mr-lg-0,\n    .mx-lg-0 {\n        margin-right: 0 !important\n    }\n\n    .mb-lg-0,\n    .my-lg-0 {\n        margin-bottom: 0 !important\n    }\n\n    .ml-lg-0,\n    .mx-lg-0 {\n        margin-left: 0 !important\n    }\n\n    .m-lg-1 {\n        margin: .4rem !important\n    }\n\n    .mt-lg-1,\n    .my-lg-1 {\n        margin-top: .4rem !important\n    }\n\n    .mr-lg-1,\n    .mx-lg-1 {\n        margin-right: .4rem !important\n    }\n\n    .mb-lg-1,\n    .my-lg-1 {\n        margin-bottom: .4rem !important\n    }\n\n    .ml-lg-1,\n    .mx-lg-1 {\n        margin-left: .4rem !important\n    }\n\n    .m-lg-2 {\n        margin: .8rem !important\n    }\n\n    .mt-lg-2,\n    .my-lg-2 {\n        margin-top: .8rem !important\n    }\n\n    .mr-lg-2,\n    .mx-lg-2 {\n        margin-right: .8rem !important\n    }\n\n    .mb-lg-2,\n    .my-lg-2 {\n        margin-bottom: .8rem !important\n    }\n\n    .ml-lg-2,\n    .mx-lg-2 {\n        margin-left: .8rem !important\n    }\n\n    .m-lg-3 {\n        margin: 1.6rem !important\n    }\n\n    .mt-lg-3,\n    .my-lg-3 {\n        margin-top: 1.6rem !important\n    }\n\n    .mr-lg-3,\n    .mx-lg-3 {\n        margin-right: 1.6rem !important\n    }\n\n    .mb-lg-3,\n    .my-lg-3 {\n        margin-bottom: 1.6rem !important\n    }\n\n    .ml-lg-3,\n    .mx-lg-3 {\n        margin-left: 1.6rem !important\n    }\n\n    .m-lg-4 {\n        margin: 2.4rem !important\n    }\n\n    .mt-lg-4,\n    .my-lg-4 {\n        margin-top: 2.4rem !important\n    }\n\n    .mr-lg-4,\n    .mx-lg-4 {\n        margin-right: 2.4rem !important\n    }\n\n    .mb-lg-4,\n    .my-lg-4 {\n        margin-bottom: 2.4rem !important\n    }\n\n    .ml-lg-4,\n    .mx-lg-4 {\n        margin-left: 2.4rem !important\n    }\n\n    .m-lg-5 {\n        margin: 4.8rem !important\n    }\n\n    .mt-lg-5,\n    .my-lg-5 {\n        margin-top: 4.8rem !important\n    }\n\n    .mr-lg-5,\n    .mx-lg-5 {\n        margin-right: 4.8rem !important\n    }\n\n    .mb-lg-5,\n    .my-lg-5 {\n        margin-bottom: 4.8rem !important\n    }\n\n    .ml-lg-5,\n    .mx-lg-5 {\n        margin-left: 4.8rem !important\n    }\n\n    .p-lg-0 {\n        padding: 0 !important\n    }\n\n    .pt-lg-0,\n    .py-lg-0 {\n        padding-top: 0 !important\n    }\n\n    .pr-lg-0,\n    .px-lg-0 {\n        padding-right: 0 !important\n    }\n\n    .pb-lg-0,\n    .py-lg-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pl-lg-0,\n    .px-lg-0 {\n        padding-left: 0 !important\n    }\n\n    .p-lg-1 {\n        padding: .4rem !important\n    }\n\n    .pt-lg-1,\n    .py-lg-1 {\n        padding-top: .4rem !important\n    }\n\n    .pr-lg-1,\n    .px-lg-1 {\n        padding-right: .4rem !important\n    }\n\n    .pb-lg-1,\n    .py-lg-1 {\n        padding-bottom: .4rem !important\n    }\n\n    .pl-lg-1,\n    .px-lg-1 {\n        padding-left: .4rem !important\n    }\n\n    .p-lg-2 {\n        padding: .8rem !important\n    }\n\n    .pt-lg-2,\n    .py-lg-2 {\n        padding-top: .8rem !important\n    }\n\n    .pr-lg-2,\n    .px-lg-2 {\n        padding-right: .8rem !important\n    }\n\n    .pb-lg-2,\n    .py-lg-2 {\n        padding-bottom: .8rem !important\n    }\n\n    .pl-lg-2,\n    .px-lg-2 {\n        padding-left: .8rem !important\n    }\n\n    .p-lg-3 {\n        padding: 1.6rem !important\n    }\n\n    .pt-lg-3,\n    .py-lg-3 {\n        padding-top: 1.6rem !important\n    }\n\n    .pr-lg-3,\n    .px-lg-3 {\n        padding-right: 1.6rem !important\n    }\n\n    .pb-lg-3,\n    .py-lg-3 {\n        padding-bottom: 1.6rem !important\n    }\n\n    .pl-lg-3,\n    .px-lg-3 {\n        padding-left: 1.6rem !important\n    }\n\n    .p-lg-4 {\n        padding: 2.4rem !important\n    }\n\n    .pt-lg-4,\n    .py-lg-4 {\n        padding-top: 2.4rem !important\n    }\n\n    .pr-lg-4,\n    .px-lg-4 {\n        padding-right: 2.4rem !important\n    }\n\n    .pb-lg-4,\n    .py-lg-4 {\n        padding-bottom: 2.4rem !important\n    }\n\n    .pl-lg-4,\n    .px-lg-4 {\n        padding-left: 2.4rem !important\n    }\n\n    .p-lg-5 {\n        padding: 4.8rem !important\n    }\n\n    .pt-lg-5,\n    .py-lg-5 {\n        padding-top: 4.8rem !important\n    }\n\n    .pr-lg-5,\n    .px-lg-5 {\n        padding-right: 4.8rem !important\n    }\n\n    .pb-lg-5,\n    .py-lg-5 {\n        padding-bottom: 4.8rem !important\n    }\n\n    .pl-lg-5,\n    .px-lg-5 {\n        padding-left: 4.8rem !important\n    }\n\n    .m-lg-n1 {\n        margin: -.4rem !important\n    }\n\n    .mt-lg-n1,\n    .my-lg-n1 {\n        margin-top: -.4rem !important\n    }\n\n    .mr-lg-n1,\n    .mx-lg-n1 {\n        margin-right: -.4rem !important\n    }\n\n    .mb-lg-n1,\n    .my-lg-n1 {\n        margin-bottom: -.4rem !important\n    }\n\n    .ml-lg-n1,\n    .mx-lg-n1 {\n        margin-left: -.4rem !important\n    }\n\n    .m-lg-n2 {\n        margin: -.8rem !important\n    }\n\n    .mt-lg-n2,\n    .my-lg-n2 {\n        margin-top: -.8rem !important\n    }\n\n    .mr-lg-n2,\n    .mx-lg-n2 {\n        margin-right: -.8rem !important\n    }\n\n    .mb-lg-n2,\n    .my-lg-n2 {\n        margin-bottom: -.8rem !important\n    }\n\n    .ml-lg-n2,\n    .mx-lg-n2 {\n        margin-left: -.8rem !important\n    }\n\n    .m-lg-n3 {\n        margin: -1.6rem !important\n    }\n\n    .mt-lg-n3,\n    .my-lg-n3 {\n        margin-top: -1.6rem !important\n    }\n\n    .mr-lg-n3,\n    .mx-lg-n3 {\n        margin-right: -1.6rem !important\n    }\n\n    .mb-lg-n3,\n    .my-lg-n3 {\n        margin-bottom: -1.6rem !important\n    }\n\n    .ml-lg-n3,\n    .mx-lg-n3 {\n        margin-left: -1.6rem !important\n    }\n\n    .m-lg-n4 {\n        margin: -2.4rem !important\n    }\n\n    .mt-lg-n4,\n    .my-lg-n4 {\n        margin-top: -2.4rem !important\n    }\n\n    .mr-lg-n4,\n    .mx-lg-n4 {\n        margin-right: -2.4rem !important\n    }\n\n    .mb-lg-n4,\n    .my-lg-n4 {\n        margin-bottom: -2.4rem !important\n    }\n\n    .ml-lg-n4,\n    .mx-lg-n4 {\n        margin-left: -2.4rem !important\n    }\n\n    .m-lg-n5 {\n        margin: -4.8rem !important\n    }\n\n    .mt-lg-n5,\n    .my-lg-n5 {\n        margin-top: -4.8rem !important\n    }\n\n    .mr-lg-n5,\n    .mx-lg-n5 {\n        margin-right: -4.8rem !important\n    }\n\n    .mb-lg-n5,\n    .my-lg-n5 {\n        margin-bottom: -4.8rem !important\n    }\n\n    .ml-lg-n5,\n    .mx-lg-n5 {\n        margin-left: -4.8rem !important\n    }\n\n    .m-lg-auto {\n        margin: auto !important\n    }\n\n    .mt-lg-auto,\n    .my-lg-auto {\n        margin-top: auto !important\n    }\n\n    .mr-lg-auto,\n    .mx-lg-auto {\n        margin-right: auto !important\n    }\n\n    .mb-lg-auto,\n    .my-lg-auto {\n        margin-bottom: auto !important\n    }\n\n    .ml-lg-auto,\n    .mx-lg-auto {\n        margin-left: auto !important\n    }\n}\n\n@media (min-width: 1200px) {\n    .m-xl-0 {\n        margin: 0 !important\n    }\n\n    .mt-xl-0,\n    .my-xl-0 {\n        margin-top: 0 !important\n    }\n\n    .mr-xl-0,\n    .mx-xl-0 {\n        margin-right: 0 !important\n    }\n\n    .mb-xl-0,\n    .my-xl-0 {\n        margin-bottom: 0 !important\n    }\n\n    .ml-xl-0,\n    .mx-xl-0 {\n        margin-left: 0 !important\n    }\n\n    .m-xl-1 {\n        margin: .4rem !important\n    }\n\n    .mt-xl-1,\n    .my-xl-1 {\n        margin-top: .4rem !important\n    }\n\n    .mr-xl-1,\n    .mx-xl-1 {\n        margin-right: .4rem !important\n    }\n\n    .mb-xl-1,\n    .my-xl-1 {\n        margin-bottom: .4rem !important\n    }\n\n    .ml-xl-1,\n    .mx-xl-1 {\n        margin-left: .4rem !important\n    }\n\n    .m-xl-2 {\n        margin: .8rem !important\n    }\n\n    .mt-xl-2,\n    .my-xl-2 {\n        margin-top: .8rem !important\n    }\n\n    .mr-xl-2,\n    .mx-xl-2 {\n        margin-right: .8rem !important\n    }\n\n    .mb-xl-2,\n    .my-xl-2 {\n        margin-bottom: .8rem !important\n    }\n\n    .ml-xl-2,\n    .mx-xl-2 {\n        margin-left: .8rem !important\n    }\n\n    .m-xl-3 {\n        margin: 1.6rem !important\n    }\n\n    .mt-xl-3,\n    .my-xl-3 {\n        margin-top: 1.6rem !important\n    }\n\n    .mr-xl-3,\n    .mx-xl-3 {\n        margin-right: 1.6rem !important\n    }\n\n    .mb-xl-3,\n    .my-xl-3 {\n        margin-bottom: 1.6rem !important\n    }\n\n    .ml-xl-3,\n    .mx-xl-3 {\n        margin-left: 1.6rem !important\n    }\n\n    .m-xl-4 {\n        margin: 2.4rem !important\n    }\n\n    .mt-xl-4,\n    .my-xl-4 {\n        margin-top: 2.4rem !important\n    }\n\n    .mr-xl-4,\n    .mx-xl-4 {\n        margin-right: 2.4rem !important\n    }\n\n    .mb-xl-4,\n    .my-xl-4 {\n        margin-bottom: 2.4rem !important\n    }\n\n    .ml-xl-4,\n    .mx-xl-4 {\n        margin-left: 2.4rem !important\n    }\n\n    .m-xl-5 {\n        margin: 4.8rem !important\n    }\n\n    .mt-xl-5,\n    .my-xl-5 {\n        margin-top: 4.8rem !important\n    }\n\n    .mr-xl-5,\n    .mx-xl-5 {\n        margin-right: 4.8rem !important\n    }\n\n    .mb-xl-5,\n    .my-xl-5 {\n        margin-bottom: 4.8rem !important\n    }\n\n    .ml-xl-5,\n    .mx-xl-5 {\n        margin-left: 4.8rem !important\n    }\n\n    .p-xl-0 {\n        padding: 0 !important\n    }\n\n    .pt-xl-0,\n    .py-xl-0 {\n        padding-top: 0 !important\n    }\n\n    .pr-xl-0,\n    .px-xl-0 {\n        padding-right: 0 !important\n    }\n\n    .pb-xl-0,\n    .py-xl-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pl-xl-0,\n    .px-xl-0 {\n        padding-left: 0 !important\n    }\n\n    .p-xl-1 {\n        padding: .4rem !important\n    }\n\n    .pt-xl-1,\n    .py-xl-1 {\n        padding-top: .4rem !important\n    }\n\n    .pr-xl-1,\n    .px-xl-1 {\n        padding-right: .4rem !important\n    }\n\n    .pb-xl-1,\n    .py-xl-1 {\n        padding-bottom: .4rem !important\n    }\n\n    .pl-xl-1,\n    .px-xl-1 {\n        padding-left: .4rem !important\n    }\n\n    .p-xl-2 {\n        padding: .8rem !important\n    }\n\n    .pt-xl-2,\n    .py-xl-2 {\n        padding-top: .8rem !important\n    }\n\n    .pr-xl-2,\n    .px-xl-2 {\n        padding-right: .8rem !important\n    }\n\n    .pb-xl-2,\n    .py-xl-2 {\n        padding-bottom: .8rem !important\n    }\n\n    .pl-xl-2,\n    .px-xl-2 {\n        padding-left: .8rem !important\n    }\n\n    .p-xl-3 {\n        padding: 1.6rem !important\n    }\n\n    .pt-xl-3,\n    .py-xl-3 {\n        padding-top: 1.6rem !important\n    }\n\n    .pr-xl-3,\n    .px-xl-3 {\n        padding-right: 1.6rem !important\n    }\n\n    .pb-xl-3,\n    .py-xl-3 {\n        padding-bottom: 1.6rem !important\n    }\n\n    .pl-xl-3,\n    .px-xl-3 {\n        padding-left: 1.6rem !important\n    }\n\n    .p-xl-4 {\n        padding: 2.4rem !important\n    }\n\n    .pt-xl-4,\n    .py-xl-4 {\n        padding-top: 2.4rem !important\n    }\n\n    .pr-xl-4,\n    .px-xl-4 {\n        padding-right: 2.4rem !important\n    }\n\n    .pb-xl-4,\n    .py-xl-4 {\n        padding-bottom: 2.4rem !important\n    }\n\n    .pl-xl-4,\n    .px-xl-4 {\n        padding-left: 2.4rem !important\n    }\n\n    .p-xl-5 {\n        padding: 4.8rem !important\n    }\n\n    .pt-xl-5,\n    .py-xl-5 {\n        padding-top: 4.8rem !important\n    }\n\n    .pr-xl-5,\n    .px-xl-5 {\n        padding-right: 4.8rem !important\n    }\n\n    .pb-xl-5,\n    .py-xl-5 {\n        padding-bottom: 4.8rem !important\n    }\n\n    .pl-xl-5,\n    .px-xl-5 {\n        padding-left: 4.8rem !important\n    }\n\n    .m-xl-n1 {\n        margin: -.4rem !important\n    }\n\n    .mt-xl-n1,\n    .my-xl-n1 {\n        margin-top: -.4rem !important\n    }\n\n    .mr-xl-n1,\n    .mx-xl-n1 {\n        margin-right: -.4rem !important\n    }\n\n    .mb-xl-n1,\n    .my-xl-n1 {\n        margin-bottom: -.4rem !important\n    }\n\n    .ml-xl-n1,\n    .mx-xl-n1 {\n        margin-left: -.4rem !important\n    }\n\n    .m-xl-n2 {\n        margin: -.8rem !important\n    }\n\n    .mt-xl-n2,\n    .my-xl-n2 {\n        margin-top: -.8rem !important\n    }\n\n    .mr-xl-n2,\n    .mx-xl-n2 {\n        margin-right: -.8rem !important\n    }\n\n    .mb-xl-n2,\n    .my-xl-n2 {\n        margin-bottom: -.8rem !important\n    }\n\n    .ml-xl-n2,\n    .mx-xl-n2 {\n        margin-left: -.8rem !important\n    }\n\n    .m-xl-n3 {\n        margin: -1.6rem !important\n    }\n\n    .mt-xl-n3,\n    .my-xl-n3 {\n        margin-top: -1.6rem !important\n    }\n\n    .mr-xl-n3,\n    .mx-xl-n3 {\n        margin-right: -1.6rem !important\n    }\n\n    .mb-xl-n3,\n    .my-xl-n3 {\n        margin-bottom: -1.6rem !important\n    }\n\n    .ml-xl-n3,\n    .mx-xl-n3 {\n        margin-left: -1.6rem !important\n    }\n\n    .m-xl-n4 {\n        margin: -2.4rem !important\n    }\n\n    .mt-xl-n4,\n    .my-xl-n4 {\n        margin-top: -2.4rem !important\n    }\n\n    .mr-xl-n4,\n    .mx-xl-n4 {\n        margin-right: -2.4rem !important\n    }\n\n    .mb-xl-n4,\n    .my-xl-n4 {\n        margin-bottom: -2.4rem !important\n    }\n\n    .ml-xl-n4,\n    .mx-xl-n4 {\n        margin-left: -2.4rem !important\n    }\n\n    .m-xl-n5 {\n        margin: -4.8rem !important\n    }\n\n    .mt-xl-n5,\n    .my-xl-n5 {\n        margin-top: -4.8rem !important\n    }\n\n    .mr-xl-n5,\n    .mx-xl-n5 {\n        margin-right: -4.8rem !important\n    }\n\n    .mb-xl-n5,\n    .my-xl-n5 {\n        margin-bottom: -4.8rem !important\n    }\n\n    .ml-xl-n5,\n    .mx-xl-n5 {\n        margin-left: -4.8rem !important\n    }\n\n    .m-xl-auto {\n        margin: auto !important\n    }\n\n    .mt-xl-auto,\n    .my-xl-auto {\n        margin-top: auto !important\n    }\n\n    .mr-xl-auto,\n    .mx-xl-auto {\n        margin-right: auto !important\n    }\n\n    .mb-xl-auto,\n    .my-xl-auto {\n        margin-bottom: auto !important\n    }\n\n    .ml-xl-auto,\n    .mx-xl-auto {\n        margin-left: auto !important\n    }\n}\n\n.text-monospace {\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important\n}\n\n.text-justify {\n    text-align: justify !important\n}\n\n.text-wrap {\n    white-space: normal !important\n}\n\n.text-nowrap {\n    white-space: nowrap !important\n}\n\n.text-truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap\n}\n\n.text-left {\n    text-align: left !important\n}\n\n.text-right {\n    text-align: right !important\n}\n\n.text-center {\n    text-align: center !important\n}\n\n@media (min-width: 576px) {\n    .text-sm-left {\n        text-align: left !important\n    }\n\n    .text-sm-right {\n        text-align: right !important\n    }\n\n    .text-sm-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width: 768px) {\n    .text-md-left {\n        text-align: left !important\n    }\n\n    .text-md-right {\n        text-align: right !important\n    }\n\n    .text-md-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width: 992px) {\n    .text-lg-left {\n        text-align: left !important\n    }\n\n    .text-lg-right {\n        text-align: right !important\n    }\n\n    .text-lg-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width: 1200px) {\n    .text-xl-left {\n        text-align: left !important\n    }\n\n    .text-xl-right {\n        text-align: right !important\n    }\n\n    .text-xl-center {\n        text-align: center !important\n    }\n}\n\n.text-lowercase {\n    text-transform: lowercase !important\n}\n\n.text-uppercase {\n    text-transform: uppercase !important\n}\n\n.text-capitalize {\n    text-transform: capitalize !important\n}\n\n.font-weight-light {\n    font-weight: 300 !important\n}\n\n.font-weight-lighter {\n    font-weight: lighter !important\n}\n\n.font-weight-normal {\n    font-weight: 400 !important\n}\n\n.font-weight-bold {\n    font-weight: 700 !important\n}\n\n.font-weight-bolder {\n    font-weight: bolder !important\n}\n\n.font-italic {\n    font-style: italic !important\n}\n\n.text-white {\n    color: #fff !important\n}\n\n.text-primary {\n    color: #007bff !important\n}\n\na.text-primary:focus,\na.text-primary:hover {\n    color: rgb(0, 86.1, 178.5) !important\n}\n\n.text-secondary {\n    color: #6c757d !important\n}\n\na.text-secondary:focus,\na.text-secondary:hover {\n    color: rgb(72.5407725322, 78.5858369099, 83.9592274678) !important\n}\n\n.text-success {\n    color: #28a745 !important\n}\n\na.text-success:focus,\na.text-success:hover {\n    color: rgb(25.2173913043, 105.2826086957, 43.5) !important\n}\n\n.text-info {\n    color: #17a2b8 !important\n}\n\na.text-info:focus,\na.text-info:hover {\n    color: rgb(14.5, 102.1304347826, 116) !important\n}\n\n.text-warning {\n    color: #ffc107 !important\n}\n\na.text-warning:focus,\na.text-warning:hover {\n    color: rgb(185.5, 139.125, 0) !important\n}\n\n.text-danger {\n    color: #dc3545 !important\n}\n\na.text-danger:focus,\na.text-danger:hover {\n    color: rgb(167.4810126582, 29.0189873418, 42.2848101266) !important\n}\n\n.text-light {\n    color: #f8f9fa !important\n}\n\na.text-light:focus,\na.text-light:hover {\n    color: rgb(203.375, 210.75, 218.125) !important\n}\n\n.text-dark {\n    color: #343a40 !important\n}\n\na.text-dark:focus,\na.text-dark:hover {\n    color: rgb(17.7068965517, 19.75, 21.7931034483) !important\n}\n\n.text-body {\n    color: #212529 !important\n}\n\n.text-muted {\n    color: #6c757d !important\n}\n\n.text-black-50 {\n    color: rgba(0, 0, 0, .5) !important\n}\n\n.text-white-50 {\n    color: rgba(255, 255, 255, .5) !important\n}\n\n.text-hide {\n    font: 0/0 a;\n    color: transparent;\n    text-shadow: none;\n    background-color: transparent;\n    border: 0\n}\n\n.text-decoration-none {\n    text-decoration: none !important\n}\n\n.text-break {\n    word-break: break-word !important;\n    overflow-wrap: break-word !important\n}\n\n.text-reset {\n    color: inherit !important\n}\n\n.visible {\n    visibility: visible !important\n}\n\n.invisible {\n    visibility: hidden !important\n}\n\n@media print {\n\n    *,\n    ::after,\n    ::before {\n        text-shadow: none !important;\n        box-shadow: none !important\n    }\n\n    a:not(.btn) {\n        text-decoration: underline\n    }\n\n    abbr[title]::after {\n        content: \" (\" attr(title) \")\"\n    }\n\n    pre {\n        white-space: pre-wrap !important\n    }\n\n    blockquote,\n    pre {\n        border: 1px solid #adb5bd;\n        page-break-inside: avoid\n    }\n\n    thead {\n        display: table-header-group\n    }\n\n    img,\n    tr {\n        page-break-inside: avoid\n    }\n\n    h2,\n    h3,\n    p {\n        orphans: 3;\n        widows: 3\n    }\n\n    h2,\n    h3 {\n        page-break-after: avoid\n    }\n\n    @page {\n        size: a3\n    }\n\n    body {\n        min-width: 992px !important\n    }\n\n    .container {\n        min-width: 992px !important\n    }\n\n    .navbar {\n        display: none\n    }\n\n    .badge {\n        border: 1px solid #000\n    }\n\n    .table {\n        border-collapse: collapse !important\n    }\n\n    .table td,\n    .table th {\n        background-color: #fff !important\n    }\n\n    .table-bordered td,\n    .table-bordered th {\n        border: 1px solid #dee2e6 !important\n    }\n\n    .table-dark {\n        color: inherit\n    }\n\n    .table-dark tbody+tbody,\n    .table-dark td,\n    .table-dark th,\n    .table-dark thead th {\n        border-color: #dee2e6\n    }\n\n    .table .thead-dark th {\n        color: inherit;\n        border-color: #dee2e6\n    }\n}\n\n.btn,\n.btn-100-primary,\n.btn-primary,\n.theme-100 .btn,\n.theme-100 .btn-primary,\n.theme-100 a.btn-primary,\na.btn,\na.btn-100-primary,\na.btn-primary {\n    border-radius: 20px;\n    display: inline-flex;\n    min-height: 40px;\n    color: var(--text-color);\n    border: none;\n    font-weight: 700;\n    text-decoration: none !important;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    --text-color: var(--btn-txt-color);\n    padding: 0 25px;\n    min-width: 165px;\n    background-color: var(--color-light-blue);\n    box-shadow: 0 10px 17px -10px rgba(0, 0, 0, .5);\n    text-align: center;\n    transition: background-color .3s ease, box-shadow .3s ease\n}\n\n.btn-100-primary:hover,\n.btn-primary:hover,\n.btn:hover,\na.btn-primary:hover {\n    color: var(--text-color)\n}\n\n.btn a,\n.btn-100-primary a,\n.btn-primary a,\n.theme-100 .btn a,\n.theme-100 .btn-primary a,\na.btn-primary a {\n    color: inherit\n}\n\n.btn-100-primary:hover,\n.btn-primary:hover,\n.btn:hover,\na.btn-primary:hover {\n    box-shadow: none;\n    background-color: hsl(var(--color-light-blue-h), var(--color-light-blue-s), calc(var(--color-light-blue-l) - 10%))\n}\n\n.btn--inverted,\n.btn-secondary,\na.btn-secondary {\n    border-radius: 20px;\n    display: inline-flex;\n    min-height: 40px;\n    color: var(--text-color);\n    border: none;\n    font-weight: 700;\n    text-decoration: none !important;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    min-height: 37px;\n    padding: 0 25px;\n    background-color: transparent;\n    text-align: center;\n    min-width: 165px;\n    transition: box-shadow .3s ease, color .3s ease;\n    box-shadow: 0 0 0 1.5px var(--color-light-blue)\n}\n\n.btn--inverted:hover,\n.btn-secondary:hover,\na.btn-secondary:hover {\n    color: var(--text-color)\n}\n\n.btn--inverted a,\n.btn-secondary a,\na.btn-secondary a {\n    color: inherit\n}\n\n.btn--inverted:hover,\n.btn-secondary:hover,\na.btn-secondary:hover {\n    box-shadow: 0 0 0 3px var(--color-light-blue)\n}\n\n.btn-tertiary,\na.btn-tertiary {\n    border-radius: 20px;\n    display: inline-flex;\n    min-height: 40px;\n    color: var(--text-color);\n    border: none;\n    font-weight: 700;\n    text-decoration: none !important;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 0;\n    box-shadow: 0 1.5px 0 0 var(--color-light-blue);\n    padding: 0;\n    min-height: 25px;\n    background-color: transparent;\n    transition: box-shadow .3s ease, color .3s ease\n}\n\n.btn-tertiary:hover,\na.btn-tertiary:hover {\n    color: var(--text-color)\n}\n\n.btn-tertiary a,\na.btn-tertiary a {\n    color: inherit\n}\n\n.btn-tertiary:hover,\na.btn-tertiary:hover {\n    box-shadow: 0 3px 0 0 var(--color-light-blue)\n}\n\n.btn-100-primary,\n.theme-100 .btn,\n.theme-100 .btn-100-primary,\n.theme-100 .btn-primary,\n.theme-100 a.btn-primary,\na.btn-100-primary {\n    border-radius: 20px;\n    display: inline-flex;\n    min-height: 40px;\n    color: var(--text-color);\n    border: none;\n    font-weight: 700;\n    text-decoration: none !important;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    --text-color: #FFFFFF;\n    --bg-pos-X: 0%;\n    --bg-pos-Y: 0%;\n    --bg-opacity: 0;\n    --bg-width: 100px;\n    background-image: linear-gradient(-55deg, #e04f39 0, #e0457b 50%, #0077c8 100%);\n    background-size: 100%;\n    background-position: center center;\n    background-repeat: no-repeat;\n    position: relative;\n    overflow: hidden\n}\n\n.btn-100-primary:hover,\n.theme-100 .btn-primary:hover,\n.theme-100 .btn:hover,\n.theme-100 a.btn-primary:hover,\na.btn-100-primary:hover {\n    color: var(--text-color)\n}\n\n.btn-100-primary a,\n.theme-100 .btn a,\n.theme-100 .btn-100-primary a,\n.theme-100 .btn-primary a,\n.theme-100 a.btn-primary a,\na.btn-100-primary a {\n    color: inherit\n}\n\n.btn-100-primary::before,\n.theme-100 .btn-100-primary::before,\n.theme-100 .btn-primary::before,\n.theme-100 .btn::before,\n.theme-100 a.btn-primary::before,\na.btn-100-primary::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background-image: radial-gradient(circle, rgba(255, 255, 255, .3) 0, rgba(0, 0, 0, 0) 50%);\n    background-repeat: no-repeat;\n    background-size: var(--bg-width) var(--bg-width);\n    background-position: var(--bg-pos-X) var(--bg-pos-Y);\n    opacity: 1;\n    transition: opacity .3s ease\n}\n\n.btn-100-primary:hover,\n.theme-100 .btn-primary:hover,\n.theme-100 .btn:hover,\n.theme-100 a.btn-primary:hover,\na.btn-100-primary:hover {\n    box-shadow: none\n}\n\n.btn-100-primary:hover::before,\n.theme-100 .btn-primary:hover::before,\n.theme-100 .btn:hover::before,\n.theme-100 a.btn-primary:hover::before,\na.btn-100-primary:hover::before {\n    opacity: 1\n}\n\n.btn-100-tertiary,\n.theme-100 .btn-tertiary,\n.theme-100 a.btn-tertiary,\na.btn-100-tertiary {\n    border-radius: 20px;\n    display: inline-flex;\n    min-height: 40px;\n    color: var(--text-color);\n    border: none;\n    font-weight: 700;\n    text-decoration: none !important;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #000;\n    border-radius: 0;\n    min-height: unset;\n    padding: 0;\n    --color-light-blue: #000000;\n    background-color: transparent;\n    box-shadow: none;\n    transition: box-shadow .3s ease, color .3s ease;\n    position: relative\n}\n\n.btn-100-tertiary:hover,\n.theme-100 .btn-tertiary:hover,\n.theme-100 a.btn-tertiary:hover,\na.btn-100-tertiary:hover {\n    color: var(--text-color)\n}\n\n.btn-100-tertiary a,\n.theme-100 .btn-tertiary a,\n.theme-100 a.btn-tertiary a,\na.btn-100-tertiary a {\n    color: inherit\n}\n\n.btn-100-tertiary::before,\n.theme-100 .btn-tertiary::before,\n.theme-100 a.btn-tertiary::before,\na.btn-100-tertiary::before {\n    content: \"\";\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    transform: scaleY(1.5);\n    bottom: 0;\n    left: 0;\n    background: linear-gradient(-55deg, #e04f39 0, #e0457b 50%, #0077c8 100%);\n    transition: transform .3s ease\n}\n\n.btn-100-tertiary:hover::before,\n.theme-100 .btn-tertiary:hover::before,\n.theme-100 a.btn-tertiary:hover::before,\na.btn-100-tertiary:hover::before {\n    transform: scaleY(3)\n}\n\n.layout__black .btn-100-tertiary,\n.layout__black .theme-100 .btn-tertiary,\n.layout__black .theme-100 a.btn-tertiary,\n.layout__black a.btn-100-tertiary,\n.layout__blue .btn-100-tertiary,\n.layout__blue .theme-100 .btn-tertiary,\n.layout__blue .theme-100 a.btn-tertiary,\n.layout__blue a.btn-100-tertiary,\n.layout__dark_grey .btn-100-tertiary,\n.layout__dark_grey .theme-100 .btn-tertiary,\n.layout__dark_grey .theme-100 a.btn-tertiary,\n.layout__dark_grey a.btn-100-tertiary,\n.layout__light_blue .btn-100-tertiary,\n.layout__light_blue .theme-100 .btn-tertiary,\n.layout__light_blue .theme-100 a.btn-tertiary,\n.layout__light_blue a.btn-100-tertiary {\n    color: #fff\n}\n\n.layout__black,\n.wrapper__elipsis__black {\n    --bg-color: #000000;\n    --text-color: #FFFFFF\n}\n\n.layout__blue,\n.wrapper__elipsis__blue {\n    --bg-color: #041E42;\n    --text-color: #FFFFFF;\n    box-shadow: #041e42 0 .2rem 0 0\n}\n\n.layout__dark_grey,\n.wrapper__elipsis__dark_grey {\n    --bg-color: #484B4D;\n    --text-color: #FFFFFF\n}\n\n.layout__light_blue,\n.wrapper__elipsis__light_blue {\n    --bg-color: #0077C8;\n    --text-color: #FFFFFF\n}\n\n.layout__white,\n.wrapper__elipsis__white {\n    --bg-color: #FFFFFF;\n    --text-color: #041E42\n}\n\n.layout__grey,\n.wrapper__elipsis__grey {\n    --bg-color: #F2F6F8;\n    --text-color: #041E42\n}\n\n.layout__grey__white,\n.wrapper__elipsis__grey__white {\n    --bg-color: linear-gradient(0deg, #FFFFFF 0%, #FFFFFF 50%, #F2F6F8 50%, #F2F6F8 100%);\n    --text-color: #041E42;\n    flex: 0 1 auto\n}\n\n.layout__gradient_blue,\n.wrapper__elipsis__gradient_blue {\n    --bg-color: linear-gradient(90deg, #1791F9 0%, #4FFAFE 100%);\n    --text-color: #000000\n}\n\n#toolbar-administration {\n    position: relative;\n    z-index: 2000\n}\n\n.ui-dialog {\n    z-index: 501 !important\n}\n\n.alt-font {\n    --secondary-font: \"Roboto Flex\"\n}\n\n.alt-font>:not(xlarge):not(h1):not(h2):not(h3):not(h4) {\n    font-family: var(--secondary-font)\n}\n\nmain[role=main] {\n    position: relative\n}\n\nmain[role=main].main--menu-hidden {\n    margin-top: 0\n}\n\n.toolbar-horizontal.toolbar-tray-open main[role=main].main--with-header-bar {\n    margin-top: 94px\n}\n\n@media (min-width: 992px) {\n    .toolbar-horizontal.toolbar-tray-open main[role=main].main--with-header-bar {\n        margin-top: 130px\n    }\n}\n\n.toolbar-horizontal.toolbar-tray-open main[role=main].main--with-header-bar.main--menu-hidden {\n    margin-top: 0\n}\n\n.error-message {\n    font-size: .8em;\n    color: #e21b23\n}\n\n.webform-submission-form .form-item .form-date.error,\n.webform-submission-form .form-item .form-email.error,\n.webform-submission-form .form-item .form-tel.error,\n.webform-submission-form .form-item .form-text.error,\n.webform-submission-form .form-item .form-url.error {\n    border-bottom-color: #e21b23\n}\n\n.icon-360 {\n    width: 90px;\n    height: 90px;\n    margin: 50px 0;\n    cursor: pointer\n}\n\n.icon-360__circle {\n    fill: #41b6e6\n}\n\n.icon-360__arrow {\n    fill: #fff;\n    animation-name: spin;\n    animation-duration: 5s;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n    transform-origin: 44px 45px\n}\n\n@keyframes spin {\n    0% {\n        transform: translate(45 45);\n        transform: rotate(0)\n    }\n\n    50% {\n        transform: translate(45 45);\n        transform: rotate(360deg)\n    }\n\n    100% {\n        transform: translate(45 45);\n        transform: rotate(360deg)\n    }\n}\n\n.icon-360__360 {\n    fill: #fff\n}\n\n.icon-360__loader {\n    position: absolute;\n    border: 16px solid #fff;\n    border-top: 16px solid #04325e;\n    border-radius: 50%;\n    width: 120px;\n    height: 120px;\n    animation: spin 2s linear infinite;\n    top: 25%;\n    left: 0;\n    right: 0;\n    margin: auto;\n    filter: none;\n    visibility: hidden;\n    z-index: 9999\n}\n\n.icon-360__loader:hover {\n    cursor: wait\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0)\n    }\n\n    100% {\n        transform: rotate(360deg)\n    }\n}\n\n.threesixty:hover {\n    cursor: ew-resize\n}\n\n.anchor-list>div {\n    display: inline-block\n}\n\n.anchor-list>div>div>a {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-weight: 700;\n    font-size: 1.8rem;\n    line-height: .89em;\n    color: #41b6e6;\n    border-bottom: 2px solid #41b6e6;\n    margin-bottom: 19px;\n    padding-bottom: 19px\n}\n\n.anchor-list>div>div>a:after {\n    content: \" \";\n    background-image: url(/src/images/icons/arrow-next-light-blue.svg);\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100%;\n    margin-left: 30px;\n    width: 18px;\n    height: 18px;\n    transition: transform .3s;\n    right: 0\n}\n\n.anchor-list>div>div>a:hover {\n    text-decoration: none\n}\n\n.anchor-list>div>div>a:hover:after {\n    transform: translateX(5px)\n}\n\n.anchor-list>div>div:first-child>a {\n    margin-top: 19px\n}\n\n.anchor-list>div>div:last-child>a {\n    border-bottom: none !important;\n    padding-bottom: 0\n}\n\n.anchor-list__dark>div>div>a {\n    color: #041e42;\n    border-bottom: 2px solid #041e42\n}\n\n/* \n.anchor-list__dark>div>div>a:after {\n    background-image: url(/src/images/icons/arrow-next-dark-blue.svg)\n} */\n\n.article_list__gobackurl {\n    font-size: 1.8rem;\n    line-height: 1.33em;\n    color: #04325e;\n    font-weight: 700;\n    text-transform: uppercase;\n    position: relative;\n    padding-bottom: 5px\n}\n\n.article_list__gobackurl--leftshift {\n    left: 0\n}\n\n.article_list__social_media__caption {\n    display: none\n}\n\n.views-element-container .article_list__social_media {\n    position: absolute;\n    right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: -10px\n}\n\n.views-element-container .article_list__social_media .social-media__title {\n    display: none\n}\n\n.views-element-container .article_list__social_media__caption {\n    display: block;\n    margin-right: 15px\n}\n\n.views-element-container .article_list__social_media__caption--modifier {\n    font-size: 1.6rem\n}\n\n.views-element-container .article_list__social_media ul.menu--social-media.social-media__nav {\n    margin-bottom: 0\n}\n\n@media (max-width: 991.98px) {\n    .views-element-container .article_list__social_media {\n        display: none\n    }\n}\n\n.article_list .views-element-container .menu--social-media.social-media__nav .social-media__nav__icon {\n    width: 4.8rem;\n    height: 4.8rem\n}\n\n.article-long-summary {\n    margin: 0 5px;\n    background-color: #fff;\n    border-bottom: 2px solid #f2f6f8\n}\n\n@media (min-width: 992px) {\n    .article-long-summary {\n        margin: 50px 0;\n        background-color: #f2f6f8;\n        border-bottom: none\n    }\n}\n\n.article-long-summary .field--field-long-summary-image {\n    height: 100%\n}\n\n.article-long-summary .field--field-long-summary-image .drupal-media {\n    height: 100%\n}\n\n.article-long-summary .field--field-long-summary-image .drupal-media .drupal-media__image {\n    height: 100%\n}\n\n.article-long-summary .field--field-long-summary-image .drupal-media .drupal-media__image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover\n}\n\n.article-long-summary .article-long-summary--featured {\n    background-color: #041e42\n}\n\n@media (min-width: 992px) {\n    .article-long-summary .article-long-summary--featured {\n        min-height: 436px\n    }\n}\n\n@media (min-width: 1200px) {\n    .article-long-summary .article-long-summary--featured {\n        min-height: 489px\n    }\n}\n\n.article-long-summary .article-long-summary--featured .article-image {\n    display: block;\n    padding-bottom: 0\n}\n\n@media (min-width: 992px) {\n    .article-long-summary .article-long-summary--featured .long-summary-description {\n        padding-bottom: 20px\n    }\n}\n\n@media (min-width: 1200px) {\n    .article-long-summary .article-long-summary--featured .long-summary-description {\n        padding-bottom: 40px\n    }\n}\n\n.article-long-summary .article-text {\n    padding: 25px 50px 20px 27px\n}\n\n@media (min-width: 992px) {\n    .article-long-summary .article-text {\n        padding: 85px 100px 85px 65px\n    }\n}\n\n.article-long-summary .article-title .node-title {\n    font-size: 2.4rem;\n    line-height: 3rem;\n    font-weight: 600\n}\n\n.article-long-summary .article-date {\n    padding-bottom: 20px;\n    font-size: 1.4rem\n}\n\n@media (min-width: 992px) {\n    .article-long-summary .article-date {\n        padding-bottom: 30px\n    }\n}\n\n.article-long-summary .long-summary-description {\n    padding-bottom: 40px;\n    display: none\n}\n\n@media (min-width: 992px) {\n    .article-long-summary .long-summary-description {\n        display: block\n    }\n}\n\n.article-long-summary .article-category {\n    padding-bottom: 10px\n}\n\n@media (min-width: 992px) {\n    .article-long-summary .article-category {\n        padding-bottom: 30px\n    }\n}\n\n.article-long-summary .article-image {\n    background-size: cover;\n    padding-bottom: 100%;\n    display: none\n}\n\n@media (min-width: 992px) {\n    .article-long-summary .article-image {\n        padding-bottom: 0;\n        display: block\n    }\n}\n\n.article-long-summary .article-text a:hover {\n    text-decoration: none\n}\n\n@media screen and (max-width: 991px) {\n    #views-exposed-form-article-list-block-article-list {\n        padding-bottom: 36px\n    }\n}\n\n#views-exposed-form-article-list-block-article-list .form-radios {\n    margin: 0;\n    padding: 0\n}\n\n#views-exposed-form-article-list-block-article-list .form-select {\n    padding: 0;\n    border: none;\n    background: 0 0\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id {\n    display: inline-block\n}\n\n@media (min-width: 768px) and (max-width:991.98px) {\n    #views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id {\n        margin-bottom: 20px\n    }\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-select.bef-links {\n    padding: 0;\n    border: none;\n    background: 0 0\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id a.bef-links {\n    opacity: 0;\n    position: fixed;\n    width: 0\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios {\n    display: flex\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios .js-form-item {\n    list-style: none\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios .js-form-item a {\n    display: inline-block;\n    font-size: 1.8rem;\n    line-height: 1.33em;\n    color: #04325e;\n    font-weight: 700;\n    margin: 0 20px;\n    padding-bottom: 5px\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios .js-form-item a:first-child {\n    margin-left: 0\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios .js-form-item a.bef-link--selected,\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .form-radios .js-form-item a:hover {\n    color: #41b6e6;\n    border-bottom: 4px solid #41b6e6\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id a,\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id label {\n    font-size: 1.8rem;\n    line-height: 1.33em;\n    color: #04325e;\n    font-weight: 700;\n    margin: 0 10px;\n    padding-bottom: 5px\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id a:first-child,\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id label:first-child {\n    margin-left: 0\n}\n\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id .bef-link--selected,\n#views-exposed-form-article-list-block-article-list .form-item-field-article-category-target-id a:hover {\n    color: #41b6e6;\n    border-bottom: 4px solid #41b6e6\n}\n\n#views-exposed-form-article-list-block-article-list input[type=submit] {\n    display: none\n}\n\n#views-exposed-form-article-list-block-article-list .btn-pager-category {\n    display: none\n}\n\n#views-exposed-form-article-list-block-article-list .btn-after,\n#views-exposed-form-article-list-block-article-list .btn-before {\n    display: none\n}\n\n@media (max-width: 767.98px) {\n\n    #views-exposed-form-article-list-block-article-list .btn-after,\n    #views-exposed-form-article-list-block-article-list .btn-before {\n        display: block\n    }\n}\n\n@media (min-width: 992px) {\n    #views-exposed-form-article-list-block-article-list .article-list-filters {\n        margin-bottom: 25px\n    }\n}\n\n@media (max-width: 767.98px) {\n    #views-exposed-form-article-list-block-article-list fieldset {\n        position: relative\n    }\n\n    #views-exposed-form-article-list-block-article-list fieldset .article-list-filters {\n        position: relative\n    }\n\n    #views-exposed-form-article-list-block-article-list fieldset .article-list-filters .btn-pager-category {\n        position: absolute;\n        top: 3px;\n        z-index: 1;\n        background-image: url(/src/images/icons/chevron-down.svg);\n        background-size: contain;\n        background-repeat: no-repeat;\n        text-indent: -9999px;\n        outline: 0;\n        height: 14px;\n        width: 14px\n    }\n\n    #views-exposed-form-article-list-block-article-list fieldset .article-list-filters .btn-next-category {\n        display: block;\n        right: 5px;\n        transform: rotate(-90deg)\n    }\n\n    #views-exposed-form-article-list-block-article-list fieldset .article-list-filters .btn-previous-category {\n        left: 0;\n        transform: rotate(90deg)\n    }\n\n    #views-exposed-form-article-list-block-article-list fieldset.after-gradient:after {\n        content: \"\";\n        display: block;\n        width: 95px;\n        position: absolute;\n        height: 30px;\n        top: 0;\n        right: 0;\n        background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff);\n        pointer-events: none\n    }\n\n    #views-exposed-form-article-list-block-article-list fieldset.before-gradient:before {\n        content: \"\";\n        display: block;\n        width: 95px;\n        position: absolute;\n        height: 30px;\n        top: 0;\n        left: 0;\n        background: linear-gradient(to left, rgba(255, 255, 255, 0), #fff);\n        pointer-events: none;\n        z-index: 1\n    }\n\n    #views-exposed-form-article-list-block-article-list .form-radios {\n        width: 90%;\n        overflow-x: scroll;\n        overflow-y: hidden;\n        white-space: nowrap\n    }\n}\n\n@media (max-width: 767.98px) and (max-width:767.98px) {\n    #views-exposed-form-article-list-block-article-list .form-radios {\n        margin-left: 15px\n    }\n\n    #views-exposed-form-article-list-block-article-list .form-radios::-webkit-scrollbar {\n        display: none\n    }\n}\n\n.views-element-container .pager .pager__items {\n    text-align: center;\n    padding: 15px 0\n}\n\n.related-articles-row {\n    padding-bottom: 74px\n}\n\n@media screen and (max-width: 991px) {\n    .related-articles-row {\n        padding-bottom: 33px\n    }\n}\n\n.related-articles-title {\n    font-size: 4rem;\n    line-height: 1.2em;\n    font-weight: 700;\n    padding: 74px 0 31px\n}\n\n@media screen and (max-width: 991px) {\n    .related-articles-title {\n        font-size: 2.3rem;\n        line-height: 1.3em;\n        padding: 33px 0 20px\n    }\n}\n\n.short-article {\n    display: flex;\n    flex-wrap: wrap\n}\n\n.article-short-summary {\n    background-color: #fff;\n    height: 100%;\n    box-shadow: 0 0 10px rgba(0, 0, 0, .5);\n    transition: box-shadow .3s ease\n}\n\n.article-short-summary:hover {\n    box-shadow: 0 0 3px rgba(0, 0, 0, .5)\n}\n\n.article-short-summary:hover .short-summary__view__image {\n    transform: scale(1.1)\n}\n\n.layout__grey .article-short-summary {\n    background-color: #f2f6f8\n}\n\n.layout__blue .article-short-summary {\n    box-shadow: none;\n    background-color: #0c2b57;\n    transition: background-color .3s ease\n}\n\n.layout__blue .article-short-summary:hover {\n    background-color: #0b274f\n}\n\n.article-short-summary .disabled-btn {\n    flex: 0 0 auto\n}\n\n.article-short-summary .disabled-btn .btn {\n    color: #41b6e6;\n    font-weight: 700;\n    background-color: transparent\n}\n\n.article-short-summary .short-summary__text {\n    padding: 3.5rem 5.1rem 5.7rem 2.9rem\n}\n\n@media (max-width: 767.98px) {\n    .article-short-summary .short-summary__text {\n        padding: 2.5rem 2.1rem 2.8rem 2rem\n    }\n}\n\n.article-short-summary .short-summary__text__description .node-title {\n    display: block;\n    font-size: 2rem;\n    line-height: 3.3rem;\n    font-weight: 700;\n    font-family: Axiforma;\n    color: var(--text-color);\n    padding-bottom: 2rem\n}\n\n.article-short-summary .short-summary__text__date {\n    padding-bottom: 3.5rem\n}\n\n.article-short-summary .short-summary__text__readmore .btn {\n    padding: 0 .2rem 0 0\n}\n\n.article-short-summary .short-summary__text__category {\n    padding-bottom: 2rem\n}\n\n.article-short-summary .short-summary__text__category a {\n    color: #41b6e6\n}\n\n.article-short-summary .short-summary__view {\n    overflow: hidden\n}\n\n.article-short-summary .short-summary__view__image {\n    font-size: 2.8rem;\n    line-height: 1.25;\n    color: #041e42;\n    font-weight: 700;\n    transition: transform .3s ease\n}\n\n.grid-equal-height .badge.horizontal,\n.grid-equal-height .badge.horizontal.link--v-bottom,\n.grid-equal-height .badge:not(.vertical) {\n    height: calc(100% - 1em)\n}\n\n.badge__link-bottom {\n    height: 100%\n}\n\n.layout-builder__section .badge__link-bottom {\n    height: auto\n}\n\n.badge {\n    margin: 15px 0;\n    height: auto;\n    text-align: center;\n    display: flex;\n    transition: all .3s ease\n}\n\n.badge.link--v-bottom {\n    height: calc(100% - 2em)\n}\n\n.badge.vertical {\n    flex-direction: column\n}\n\n.badge.vertical .badge__text_block {\n    display: none\n}\n\n.badge.vertical.layout__blue .badge__description,\n.badge.vertical.layout__blue .badge__title,\n.badge.vertical.layout__grey .badge__description,\n.badge.vertical.layout__grey .badge__title,\n.badge.vertical.layout__white .badge__description,\n.badge.vertical.layout__white .badge__title {\n    padding-left: 1.2rem;\n    padding-right: 1.2rem;\n    backface-visibility: hidden\n}\n\n.badge.vertical .badge__description {\n    padding-bottom: 2.4rem\n}\n\n.badge.horizontal {\n    display: flex;\n    flex-direction: row;\n    padding-bottom: 0;\n    width: 100%\n}\n\n.badge.horizontal a>.badge__description,\n.badge.horizontal a>.badge__link,\n.badge.horizontal a>.badge__title,\n.badge.horizontal>.badge__description,\n.badge.horizontal>.badge__link,\n.badge.horizontal>.badge__title {\n    display: none\n}\n\n.badge.horizontal .badge__title {\n    margin-bottom: 0\n}\n\n.badge.horizontal .badge__text_block {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex: 0 0 60%;\n    min-height: 7em;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    max-width: 100%\n}\n\n.badge.horizontal .badge__text_block .badge__description.v-top {\n    justify-content: flex-start\n}\n\n.badge.horizontal .badge__text_block .badge__description.v-center {\n    justify-content: center\n}\n\n.badge.horizontal .badge__text_block .badge__description.v-bottom {\n    justify-content: flex-end\n}\n\n.badge.horizontal .badge__image--col100,\n.badge.horizontal .badge__image--col25,\n.badge.horizontal .badge__image--col33,\n.badge.horizontal .badge__image--col50,\n.badge.horizontal .badge__image--col75 {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex: 0 0 40%;\n    overflow: hidden;\n    max-width: 45%\n}\n\n.badge.horizontal .badge__image--col100 img,\n.badge.horizontal .badge__image--col25 img,\n.badge.horizontal .badge__image--col33 img,\n.badge.horizontal .badge__image--col50 img,\n.badge.horizontal .badge__image--col75 img {\n    transition: all .3s ease-in-out\n}\n\n.badge.horizontal .badge__image--col100>div,\n.badge.horizontal .badge__image--col100>div .drupal-media,\n.badge.horizontal .badge__image--col100>div .drupal-media .drupal-media__image,\n.badge.horizontal .badge__image--col25>div,\n.badge.horizontal .badge__image--col25>div .drupal-media,\n.badge.horizontal .badge__image--col25>div .drupal-media .drupal-media__image,\n.badge.horizontal .badge__image--col33>div,\n.badge.horizontal .badge__image--col33>div .drupal-media,\n.badge.horizontal .badge__image--col33>div .drupal-media .drupal-media__image,\n.badge.horizontal .badge__image--col50>div,\n.badge.horizontal .badge__image--col50>div .drupal-media,\n.badge.horizontal .badge__image--col50>div .drupal-media .drupal-media__image,\n.badge.horizontal .badge__image--col75>div,\n.badge.horizontal .badge__image--col75>div .drupal-media,\n.badge.horizontal .badge__image--col75>div .drupal-media .drupal-media__image {\n    height: 100%\n}\n\n.badge.horizontal.link--v-bottom {\n    height: auto\n}\n\n@media (max-width: 767.98px) {\n    .badge.horizontal.vertical--mobile {\n        flex-direction: column;\n        height: 100%\n    }\n\n    .badge.horizontal.vertical--mobile a>.badge__description,\n    .badge.horizontal.vertical--mobile a>.badge__link,\n    .badge.horizontal.vertical--mobile a>.badge__title,\n    .badge.horizontal.vertical--mobile>.badge__description,\n    .badge.horizontal.vertical--mobile>.badge__link,\n    .badge.horizontal.vertical--mobile>.badge__title {\n        display: none\n    }\n\n    .badge.horizontal.vertical--mobile .badge__image--col100,\n    .badge.horizontal.vertical--mobile .badge__image--col25,\n    .badge.horizontal.vertical--mobile .badge__image--col33,\n    .badge.horizontal.vertical--mobile .badge__image--col50,\n    .badge.horizontal.vertical--mobile .badge__image--col75 {\n        max-width: 100%\n    }\n\n    .badge.horizontal.vertical--mobile .badge__text_block {\n        max-width: 100%\n    }\n}\n\n.badge.horizontal .image-top {\n    justify-content: flex-start\n}\n\n.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary),\n.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary):hover {\n    color: var(--link-color);\n    text-decoration: none\n}\n\n.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary) .badge__description,\n.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary) .badge__text_block,\n.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary):hover .badge__description,\n.badge a:not(.btn-primary, .btn, a.btn, .btn-100-primary, a.btn-100-primary, .btn-secondary, .btn--inverted, .btn-tertiary):hover .badge__text_block {\n    color: var(--text-color)\n}\n\n@media (min-width: 576px) {\n    .badge.link--v-bottom>a {\n        display: flex;\n        flex-direction: column;\n        height: 100%\n    }\n\n    .badge.link--v-bottom div:not(.v-bottom)>.badge__link {\n        display: flex;\n        height: 100%;\n        align-items: flex-end\n    }\n\n    .badge.link--v-bottom .badge__description.v-center {\n        margin-top: auto\n    }\n\n    .badge.link--v-bottom>.badge__link,\n    .badge.link--v-bottom>a>.badge__link {\n        margin-top: auto\n    }\n}\n\n.badge.fully--clickable {\n    text-decoration: none;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .5)\n}\n\n.badge.fully--clickable.horizontal a {\n    display: flex;\n    flex-direction: row;\n    width: 100%\n}\n\n@media (max-width: 767.98px) {\n    .badge.fully--clickable.horizontal.vertical--mobile a {\n        flex-direction: column\n    }\n}\n\n.badge.fully--clickable:hover {\n    box-shadow: 0 0 3px 0 rgba(0, 0, 0, .5);\n    text-decoration: none\n}\n\n.badge.outline {\n    border: 1px solid #d2d2d2;\n    border-radius: 5px\n}\n\n.badge.outline.vertical img {\n    border-top-right-radius: 5px;\n    border-top-left-radius: 5px;\n    overflow: hidden;\n    transition: all .3s ease-in-out\n}\n\n.badge.outline.vertical .badge__image--col100,\n.badge.outline.vertical .badge__image--col25,\n.badge.outline.vertical .badge__image--col33,\n.badge.outline.vertical .badge__image--col50,\n.badge.outline.vertical .badge__image--col75 {\n    border-bottom: 1px solid #d2d2d2\n}\n\n.badge.outline.vertical .badge__image--col100.no_image,\n.badge.outline.vertical .badge__image--col25.no_image,\n.badge.outline.vertical .badge__image--col33.no_image,\n.badge.outline.vertical .badge__image--col50.no_image,\n.badge.outline.vertical .badge__image--col75.no_image {\n    border-bottom: none\n}\n\n.badge.outline.horizontal img {\n    border-bottom-left-radius: 5px;\n    border-top-left-radius: 5px;\n    overflow: hidden\n}\n\n.badge.outline.horizontal .badge__image--col100,\n.badge.outline.horizontal .badge__image--col25,\n.badge.outline.horizontal .badge__image--col33,\n.badge.outline.horizontal .badge__image--col50,\n.badge.outline.horizontal .badge__image--col75 {\n    border-right: 1px solid #d2d2d2;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px\n}\n\n@media (max-width: 767.98px) {\n    .badge.outline.horizontal.vertical--mobile img {\n        overflow: hidden;\n        border-top-right-radius: 5px;\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 0\n    }\n\n    .badge.outline.horizontal.vertical--mobile .badge__image--col100,\n    .badge.outline.horizontal.vertical--mobile .badge__image--col25,\n    .badge.outline.horizontal.vertical--mobile .badge__image--col33,\n    .badge.outline.horizontal.vertical--mobile .badge__image--col50,\n    .badge.outline.horizontal.vertical--mobile .badge__image--col75 {\n        border-bottom: 1px solid #d2d2d2;\n        border-right: 0;\n        border-top-right-radius: 5px;\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 0\n    }\n}\n\n.badge.limit-width {\n    max-width: 33vw;\n    margin: 15px auto\n}\n\n.badge .inner-spacing {\n    padding: 15px\n}\n\n.badge .inner-spacing img {\n    border-bottom-left-radius: 0 !important;\n    border-top-left-radius: 0 !important\n}\n\n.badge.image-zoom .badge__image--col100 .drupal-media__image.drupal-media__image--full-width,\n.badge.image-zoom .badge__image--col25 .drupal-media__image.drupal-media__image--full-width,\n.badge.image-zoom .badge__image--col33 .drupal-media__image.drupal-media__image--full-width,\n.badge.image-zoom .badge__image--col50 .drupal-media__image.drupal-media__image--full-width,\n.badge.image-zoom .badge__image--col75 .drupal-media__image.drupal-media__image--full-width {\n    overflow: hidden\n}\n\n.badge.image-zoom .badge__image--col100 .drupal-media__image.drupal-media__image--full-width img,\n.badge.image-zoom .badge__image--col25 .drupal-media__image.drupal-media__image--full-width img,\n.badge.image-zoom .badge__image--col33 .drupal-media__image.drupal-media__image--full-width img,\n.badge.image-zoom .badge__image--col50 .drupal-media__image.drupal-media__image--full-width img,\n.badge.image-zoom .badge__image--col75 .drupal-media__image.drupal-media__image--full-width img {\n    transition: transform .3s ease\n}\n\n.badge.image-zoom:hover .badge__image--col100 img,\n.badge.image-zoom:hover .badge__image--col25 img,\n.badge.image-zoom:hover .badge__image--col33 img,\n.badge.image-zoom:hover .badge__image--col50 img,\n.badge.image-zoom:hover .badge__image--col75 img {\n    transform: scale(1.1)\n}\n\n.badge__image {\n    height: auto\n}\n\n.badge__image img {\n    max-width: 100%;\n    margin-bottom: 16px\n}\n\n.badge__image--col100,\n.badge__image--col25,\n.badge__image--col33,\n.badge__image--col50,\n.badge__image--col75 {\n    height: auto\n}\n\n.badge__image--col100 .drupal-media .drupal-media__image--full-width img,\n.badge__image--col100 .drupal-media .drupal-media__image--full-width svg,\n.badge__image--col25 .drupal-media .drupal-media__image--full-width img,\n.badge__image--col25 .drupal-media .drupal-media__image--full-width svg,\n.badge__image--col33 .drupal-media .drupal-media__image--full-width img,\n.badge__image--col33 .drupal-media .drupal-media__image--full-width svg,\n.badge__image--col50 .drupal-media .drupal-media__image--full-width img,\n.badge__image--col50 .drupal-media .drupal-media__image--full-width svg,\n.badge__image--col75 .drupal-media .drupal-media__image--full-width img,\n.badge__image--col75 .drupal-media .drupal-media__image--full-width svg {\n    height: 100%;\n    object-fit: cover\n}\n\n.badge__image--col25 .drupal-media .drupal-media__image--full-width img,\n.badge__image--col25 .drupal-media .drupal-media__image--full-width svg {\n    width: 25%;\n    border-radius: 0\n}\n\n.badge__image--col33 .drupal-media .drupal-media__image--full-width img,\n.badge__image--col33 .drupal-media .drupal-media__image--full-width svg {\n    width: 33%;\n    border-radius: 0\n}\n\n.badge__image--col50 .drupal-media .drupal-media__image--full-width img,\n.badge__image--col50 .drupal-media .drupal-media__image--full-width svg {\n    width: 50%;\n    border-radius: 0\n}\n\n.badge__image--col75 .drupal-media .drupal-media__image--full-width img,\n.badge__image--col75 .drupal-media .drupal-media__image--full-width svg {\n    width: 75%;\n    border-radius: 0\n}\n\n.badge__image--col100 .drupal-media .drupal-media__image--full-width img,\n.badge__image--col100 .drupal-media .drupal-media__image--full-width svg {\n    width: 100%\n}\n\n.badge__title {\n    font-size: 2.2rem;\n    line-height: 1.45em;\n    font-weight: 700\n}\n\n.badge__description {\n    display: flex;\n    flex-direction: column;\n    font-size: 1.4rem;\n    line-height: 1.71em;\n    font-weight: 400;\n    height: 100%;\n    padding-top: 1rem\n}\n\n.badge__description p {\n    margin-bottom: 0;\n    word-wrap: break-word;\n    overflow-wrap: break-word\n}\n\n.badge__description.v-top {\n    margin-top: 0\n}\n\n.badge__description.v-bottom {\n    margin-top: auto\n}\n\n.badge .badge__description.text-center .badge__link {\n    display: flex;\n    justify-content: center\n}\n\n.badge .badge__description.text-right .badge__link {\n    display: flex;\n    justify-content: flex-end\n}\n\n.badge .badge__description.text-left .badge__link {\n    display: flex;\n    justify-content: flex-start\n}\n\n.badge .layout__black,\n.badge .layout__gradient_blue,\n.badge .layout__grey,\n.badge.layout__blue {\n    background-color: var(--bg-color);\n    box-shadow: unset\n}\n\n.badge.layout__grey.outline {\n    border: 1px solid #f5f6f6\n}\n\n.badge.layout__grey.horizontal .badge__image--col100,\n.badge.layout__grey.horizontal .badge__image--col25,\n.badge.layout__grey.horizontal .badge__image--col33,\n.badge.layout__grey.horizontal .badge__image--col50,\n.badge.layout__grey.horizontal .badge__image--col75 {\n    border-right: 1px solid #f5f6f6\n}\n\n@media (max-width: 767.98px) {\n\n    .badge.layout__grey.horizontal.vertical--mobile .badge__image--col100,\n    .badge.layout__grey.horizontal.vertical--mobile .badge__image--col25,\n    .badge.layout__grey.horizontal.vertical--mobile .badge__image--col33,\n    .badge.layout__grey.horizontal.vertical--mobile .badge__image--col50,\n    .badge.layout__grey.horizontal.vertical--mobile .badge__image--col75 {\n        border-bottom: 1px solid #f5f6f6\n    }\n}\n\n.badge.layout__white .wysiwyg .link--download:before {\n    background-image: url(/src/images/icons/download-circle-dark.svg)\n}\n\n.align-self-stretch .entity-media {\n    height: 100%\n}\n\n.layout .media__card {\n    height: 100%;\n    padding: 40px 36px\n}\n\n.block--carousel {\n    position: relative;\n    width: 100%\n}\n\n.block--carousel-tips .swiper {\n    padding-left: 1.6rem\n}\n\n.block--carousel-tips .swiper .swiper-button-prev {\n    left: -4px\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide>article a {\n    display: inline-block;\n    width: 100%\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide>article a:hover h2 {\n    text-decoration: underline\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide>article a:hover .swiper-slide--img img {\n    transform: scale(1.1)\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide>article a:hover p .read-more-link {\n    color: var(--link-hover-color)\n}\n\n.block--carousel p {\n    color: #54585a;\n    font-size: 1.5rem;\n    line-height: 1.45em\n}\n\n.layout__black .block--carousel p,\n.layout__blue .block--carousel p,\n.layout__dark_grey .block--carousel p,\n.layout__light_blue .block--carousel p {\n    color: #d2d2d2\n}\n\n@media (max-width: 991.98px) {\n    .block--carousel .swiper .swiper-wrapper {\n        margin-left: 0\n    }\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide h2 {\n    color: #041e42;\n    font-size: 1.8rem;\n    line-height: 3rem;\n    font-weight: 900;\n    margin-bottom: 12px\n}\n\n.layout__black .block--carousel .swiper .swiper-wrapper .swiper-slide h2,\n.layout__blue .block--carousel .swiper .swiper-wrapper .swiper-slide h2,\n.layout__dark_grey .block--carousel .swiper .swiper-wrapper .swiper-slide h2,\n.layout__light_blue .block--carousel .swiper .swiper-wrapper .swiper-slide h2 {\n    color: #fff\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide p {\n    color: #8a8d8f;\n    font-size: 1.5rem;\n    line-height: 2.2rem;\n    margin-bottom: 0\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide p .read-more-link {\n    display: block;\n    color: var(--link-color);\n    text-decoration: underline\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img {\n    position: relative\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .image-container {\n    overflow: hidden;\n    border-radius: 10px;\n    z-index: 1\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .swiper-tag {\n    position: absolute;\n    top: 8px;\n    left: -4px;\n    background: #fff;\n    font-size: 1.2rem;\n    color: #041e42;\n    padding: 4px 8px;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    box-shadow: 3px 1px 10px 2px rgba(0, 0, 0, .1);\n    font-weight: 600;\n    z-index: 2\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .swiper-action {\n    position: absolute;\n    bottom: 8px;\n    display: block;\n    width: 32px;\n    height: 32px\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .swiper-action--fullscreen {\n    right: 8px;\n    background-image: url(/src/images/icons/icon-fullscreen.svg)\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .swiper-action--play {\n    left: 8px;\n    background-image: url(/src/images/icons/play.svg)\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .swiper-action--duration {\n    right: 8px;\n    height: 16px;\n    color: #fff;\n    font-size: 1.2rem\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide .swiper-slide--img .splash-video-play-button {\n    display: none\n}\n\n@media (min-width: 768px) {\n    .block--carousel .swiper .swiper-wrapper .swiper-slide.swiper-slide--full-width .swiper-slide--img {\n        display: inline-block;\n        vertical-align: top;\n        width: 33%\n    }\n\n    .block--carousel .swiper .swiper-wrapper .swiper-slide.swiper-slide--full-width .swiper-slide--content {\n        display: inline-flex;\n        padding-left: 16px;\n        position: absolute;\n        height: 100%\n    }\n\n    .block--carousel .swiper .swiper-wrapper .swiper-slide.swiper-slide--full-width .swiper-slide--inner {\n        margin: auto\n    }\n}\n\n@media (max-width: 767.98px) {\n    .block--carousel .swiper .swiper-wrapper .swiper-slide.swiper-slide--full-width .swiper-slide--inner {\n        margin-top: 16px\n    }\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide:not(.swiper-slide--full-width) .swiper-slide--inner {\n    margin-top: 16px\n}\n\n.block--carousel .swiper .swiper-wrapper .swiper-slide-description--tablet {\n    display: none\n}\n\n@media (min-width: 768px) and (max-width:1199.98px) {\n    .block--carousel .swiper .swiper-wrapper .swiper-slide--full-width .swiper-slide-description {\n        display: none\n    }\n\n    .block--carousel .swiper .swiper-wrapper .swiper-slide--full-width .swiper-slide-description--tablet {\n        display: block\n    }\n}\n\n.block--carousel .swiper .swiper-button-prev {\n    top: calc(50% - 18px)\n}\n\n@media (max-width: 991.98px) {\n    .block--carousel .swiper .swiper-button-prev {\n        top: unset;\n        bottom: 10px\n    }\n}\n\n.block--carousel .swiper .swiper-button-next {\n    right: calc(10% - 16px);\n    top: calc(50% - 18px)\n}\n\n@media (max-width: 991.98px) {\n    .block--carousel .swiper .swiper-button-next {\n        top: unset;\n        bottom: 10px;\n        right: 0\n    }\n}\n\n.block--carousel.swiper-tag--hidden .swiper-tag {\n    display: none\n}\n\n.theme-100 .swiper .swiper-wrapper .swiper-slide h2 {\n    color: #000\n}\n\n.swiper-container {\n    position: relative\n}\n\n.carousel-sided-arrows,\n.slick--skin--pt-sided-arrows {\n    margin: 0\n}\n\n.carousel-sided-arrows .slick-track,\n.slick--skin--pt-sided-arrows .slick-track {\n    display: flex;\n    align-items: center\n}\n\n.carousel-sided-arrows .slick-arrow,\n.slick--skin--pt-sided-arrows .slick-arrow {\n    margin: 0;\n    visibility: visible\n}\n\n@media (min-width: 768px) {\n\n    .carousel-sided-arrows .slick-arrow,\n    .slick--skin--pt-sided-arrows .slick-arrow {\n        margin: 0 15px\n    }\n}\n\n@media (max-width: 767.98px) {\n\n    .carousel-sided-arrows .slick-arrow svg,\n    .slick--skin--pt-sided-arrows .slick-arrow svg {\n        width: 38px;\n        height: 38px\n    }\n}\n\n.carousel-sided-arrows .slick__arrow .slick-disabled,\n.slick--skin--pt-sided-arrows .slick__arrow .slick-disabled {\n    opacity: 0;\n    transition: opacity .2s ease\n}\n\n.slick--optionset--carousel-arrows-dotless-unlimite .carousel-media__container {\n    width: 90px;\n    padding: 0\n}\n\n@media (min-width: 768px) {\n    .slick--optionset--carousel-arrows-dotless-unlimite .carousel-media__container {\n        width: 110px\n    }\n}\n\n.slick--optionset--carousel-arrows-dotless-unlimite .slick-list,\n.slick--optionset--carousel-limited-variable-slides .slick-list {\n    width: 80%;\n    padding-left: 35px;\n    margin: auto\n}\n\n@media (min-width: 768px) {\n\n    .slick--optionset--carousel-arrows-dotless-unlimite .slick-list,\n    .slick--optionset--carousel-limited-variable-slides .slick-list {\n        padding-left: 0\n    }\n}\n\n@media (min-width: 992px) {\n\n    .slick--optionset--carousel-arrows-dotless-unlimite .slick-list,\n    .slick--optionset--carousel-limited-variable-slides .slick-list {\n        width: 90%\n    }\n}\n\n.slick--optionset--carousel-arrows-dotless-unlimite .slick-slide,\n.slick--optionset--carousel-limited-variable-slides .slick-slide {\n    margin: 0 20px\n}\n\n@media (min-width: 992px) {\n\n    .slick--optionset--carousel-arrows-dotless-unlimite .slick-slide,\n    .slick--optionset--carousel-limited-variable-slides .slick-slide {\n        margin: 0 35px\n    }\n}\n\n.zoom-shade .slick--optionset--carousel-arrows-unlimited-center {\n    margin: 5% 0\n}\n\n.zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick__slider {\n    padding: 0 50px\n}\n\n@media (max-width: 767.98px) {\n    .zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick__slider {\n        padding: 0\n    }\n}\n\n.zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick-slide {\n    opacity: 0;\n    transition: opacity .2s ease, transform .3s ease;\n    width: 486px;\n    max-width: 100%;\n    margin: 0 16px\n}\n\n@media (max-width: 767.98px) {\n    .zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick-slide {\n        width: 245px;\n        margin: 0\n    }\n}\n\n.zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick_slide__active {\n    transform: scale(1);\n    opacity: .4\n}\n\n.zoom-shade .slick--optionset--carousel-arrows-unlimited-center .slick_slide__current {\n    transform: scale(1.13);\n    opacity: 1\n}\n\n.zoom-shade .slick--optionset--carousel-arrows-unlimited-center .main-image-container picture {\n    max-width: 100%\n}\n\n.zoom-shade .slick-list {\n    overflow: visible\n}\n\n.zoom-shade.theme-100 .image_description {\n    background: linear-gradient(0deg, rgba(0, 0, 0, .75) 0, rgba(0, 0, 0, .75) 66%, rgba(0, 0, 0, 0) 100%)\n}\n\n@media (max-width: 767.98px) {\n    .zoom-shade.theme-100 .image_description {\n        background-color: #000\n    }\n}\n\n.zoom-shade.theme-100 .image_description p {\n    color: #fff\n}\n\n.zoom-shade.theme-100 .slick-arrow svg rect {\n    fill: #e0457b\n}\n\n@media (max-width: 767.98px) {\n    .zoom-shade.theme-100.showDescription .image__veil::after {\n        background: linear-gradient(0deg, #000 0, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0) 100%)\n    }\n}\n\n.zoom-shade .image_description {\n    position: absolute;\n    bottom: -2px;\n    left: -1px;\n    width: calc(100% + 1px);\n    height: 66%;\n    background: linear-gradient(0deg, rgba(4, 30, 66, .75) 0, rgba(4, 30, 66, .75) 66%, rgba(4, 30, 66, 0) 100%)\n}\n\n@media (max-width: 767.98px) {\n    .zoom-shade .image_description {\n        background-color: #041e42\n    }\n}\n\n.zoom-shade .image_description .text-container {\n    position: absolute;\n    bottom: 0;\n    padding: 32px\n}\n\n@media (max-width: 767.98px) {\n    .zoom-shade .image_description .text-container {\n        position: relative;\n        padding: 24px\n    }\n}\n\n.zoom-shade .image_description p {\n    color: #fff\n}\n\n@media (max-width: 767.98px) {\n    .zoom-shade .image_description {\n        position: relative;\n        bottom: 0\n    }\n}\n\n.zoom-shade .image_description p {\n    text-align: left;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    position: relative;\n    -webkit-line-clamp: 3;\n    margin-bottom: 8px\n}\n\n@media (max-width: 767.98px) {\n    .zoom-shade .image_description p {\n        -webkit-line-clamp: 4\n    }\n}\n\n.zoom-shade .cta .btn--inverted,\n.zoom-shade .cta .btn-secondary,\n.zoom-shade .cta .btn-tertiary {\n    color: #fff\n}\n\n.cke_editable .zoom-shade .cta .btn--inverted.link--download:after,\n.cke_editable .zoom-shade .cta .btn-secondary.link--download:after,\n.cke_editable .zoom-shade .cta .btn-tertiary.link--download:after,\n.wysiwyg .zoom-shade .cta .btn--inverted.link--download:after,\n.wysiwyg .zoom-shade .cta .btn-secondary.link--download:after,\n.wysiwyg .zoom-shade .cta .btn-tertiary.link--download:after,\n.zoom-shade .cta .btn-secondary.btn__arrow:after,\n.zoom-shade .cta .btn-secondary.btn__download:after,\n.zoom-shade .cta .btn-secondary.btn__upload:after,\n.zoom-shade .cta .btn-secondary.btn__video:after,\n.zoom-shade .cta .btn-tertiary.btn__arrow:after,\n.zoom-shade .cta .btn-tertiary.btn__download:after,\n.zoom-shade .cta .btn-tertiary.btn__upload:after,\n.zoom-shade .cta .btn-tertiary.btn__video:after,\n.zoom-shade .cta .btn__arrow.btn--inverted:after,\n.zoom-shade .cta .btn__download.btn--inverted:after,\n.zoom-shade .cta .btn__upload.btn--inverted:after,\n.zoom-shade .cta .btn__video.btn--inverted:after,\n.zoom-shade .cta .cke_editable .btn--inverted.link--download:after,\n.zoom-shade .cta .cke_editable .btn-secondary.link--download:after,\n.zoom-shade .cta .cke_editable .btn-tertiary.link--download:after,\n.zoom-shade .cta .wysiwyg .btn--inverted.link--download:after,\n.zoom-shade .cta .wysiwyg .btn-secondary.link--download:after,\n.zoom-shade .cta .wysiwyg .btn-tertiary.link--download:after {\n    background: #fff\n}\n\n.zoom-shade.hideDescription .image_description {\n    display: none\n}\n\n@media (max-width: 767.98px) {\n    .zoom-shade.showDescription .image__veil {\n        position: relative\n    }\n\n    .zoom-shade.showDescription .image__veil::after {\n        content: \"\";\n        position: absolute;\n        left: -1px;\n        top: 1px;\n        width: calc(100% + 1px);\n        height: 100%;\n        background: linear-gradient(0deg, #041e42 0, rgba(4, 30, 66, 0) 25%, rgba(4, 30, 66, 0) 100%)\n    }\n}\n\n.slick--optionset--carousel-limited-variable-slides .carousel-media__container {\n    width: 110px\n}\n\n@media (max-width: 767.98px) {\n    .slick--optionset--carousel-limited-variable-slides .carousel-media__container {\n        width: 90px\n    }\n}\n\n.slick--optionset--carousel-limited-variable-slides .carousel-media__container__title {\n    font-size: 1.8rem;\n    display: flex;\n    justify-content: center;\n    margin: 20px 0 0 0;\n    font-weight: 400;\n    text-align: center\n}\n\n.slick--optionset--carousel-limited-variable-slides .slick-slide {\n    margin: 0 23px\n}\n\n.carousel-media {\n    margin-bottom: 100px\n}\n\n@media screen and (min-width: 1024px) {\n    .carousel-media {\n        margin: 0 0 100px 120px\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .carousel-media .slick__arrow--mobile {\n        margin-top: 50px\n    }\n}\n\n@media screen and (max-width: 768px) and (max-width:767.98px) {\n    .carousel-media .slick-slide {\n        margin: 0 30px\n    }\n}\n\n@media screen and (min-width: 1024px) {\n    .carousel-media__container {\n        width: 400px\n    }\n}\n\n@media (min-width: 1200px) {\n    .carousel-media__container:hover .carousel-media__container__main-box__title {\n        opacity: 0\n    }\n\n    .carousel-media__container:hover .carousel-media__container__infos-box {\n        opacity: 1\n    }\n}\n\n@media screen and (max-width: 1023px) {\n    .carousel-media__container {\n        width: 335px;\n        margin: auto;\n        padding-bottom: 40px\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .carousel-media__container {\n        padding-bottom: 0\n    }\n}\n\n.carousel-media__container__title {\n    margin: 30px 0 0 30px;\n    color: #04325e;\n    font-weight: 700;\n    font-size: 3.2rem\n}\n\n.carousel-media__container__main-box {\n    margin-top: -20px\n}\n\n.carousel-media__container__main-box__image {\n    min-height: 1px;\n    max-height: 430px;\n    overflow: hidden;\n    margin-top: 20px\n}\n\n.carousel-media__container__main-box__info-icon {\n    display: block;\n    position: absolute;\n    top: 300px;\n    right: 20px;\n    width: 42px\n}\n\n.carousel-media__container__main-box__info-icon--hide {\n    opacity: 0\n}\n\n.carousel-media__container__main-box__info-icon__svg {\n    fill: #fff\n}\n\n@media screen and (min-width: 1025px) {\n    .carousel-media__container__main-box__info-icon {\n        display: none\n    }\n}\n\n.carousel-media__container__infos-box {\n    height: 100%;\n    width: 100%;\n    max-width: 400px;\n    background-color: rgba(4, 50, 94, .8);\n    opacity: 0;\n    transition: opacity .3s ease;\n    position: absolute;\n    top: 0;\n    color: #fff;\n    padding: 0 30px\n}\n\n@media screen and (max-width: 768px) {\n    .carousel-media__container__infos-box {\n        max-width: 335px\n    }\n}\n\n.carousel-media__container__infos-box--mobile {\n    opacity: 1\n}\n\n.carousel-media__container__infos-box__description {\n    padding-top: 20px;\n    margin-top: 30px\n}\n\n.carousel-media__container__infos-box__description .wysiwyg p {\n    color: #fff\n}\n\n.carousel-media__container__infos-box__description.layout__blue {\n    box-shadow: none\n}\n\n.carousel-media__container__infos-box__description.layout__blue .wysiwyg ul:not(.contextual-links) li {\n    color: #fff\n}\n\n.carousel-media__container__infos-box__description.layout__blue .wysiwyg ul:not(.contextual-links) li:before {\n    background-image: url(/src/images/icons/check-white.svg)\n}\n\n.carousel-media__container__infos-box .layout__blue {\n    background-color: transparent\n}\n\n.carousel-media__container__infos-box__cross-box {\n    display: block;\n    width: 42px;\n    transform: rotate(45deg);\n    position: absolute;\n    right: 0;\n    top: 0\n}\n\n@media screen and (min-width: 1025px) {\n    .carousel-media__container__infos-box__cross-box {\n        display: none\n    }\n}\n\n.carousel-media__container__infos-box__cross-box__cross {\n    fill: #41b6e6\n}\n\n.field--name-field-client-success-video .main-image-container .splash-video-play-button {\n    display: none\n}\n\n.client-success__blue-overlay {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #041e42;\n    color: #fff;\n    flex: 0 0 50%\n}\n\n@media (max-width: 991.98px) {\n    .client-success__blue-overlay {\n        position: relative;\n        left: 0;\n        width: 100%;\n        justify-content: center;\n        align-items: center;\n        background: #041e42;\n        color: #fff\n    }\n}\n\n.client-success__container {\n    position: relative;\n    max-width: 80vw;\n    margin: auto\n}\n\n@media (max-width: 767.98px) {\n    .client-success__container {\n        max-width: 100vw\n    }\n}\n\n@media (min-width: 768px) {\n    .client-success__container {\n        display: flex\n    }\n}\n\n.client-success__container .drupal-media {\n    flex: 0 0 50%\n}\n\n.client-success__container .main-image-container {\n    justify-content: flex-start;\n    height: 100%\n}\n\n.client-success__container .main-image-container picture {\n    height: 100%\n}\n\n.client-success__container .main-image-container picture img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: left\n}\n\n@media (max-width: 991.98px) {\n    .client-success__container .main-image-container picture picture {\n        width: 100%;\n        height: 100%\n    }\n}\n\n.client-success__logo-container {\n    width: 75%;\n    margin: auto\n}\n\n.client-success__logo-container img {\n    max-width: 100%\n}\n\n.client-success__logo {\n    height: auto;\n    padding: 1.5em\n}\n\n.client-success__textQuote {\n    line-height: 1.8;\n    max-width: 75%;\n    margin: auto;\n    font-weight: 100\n}\n\n@media (max-width: 991.98px) {\n    .client-success__textQuote {\n        text-align: center;\n        max-width: 100%\n    }\n}\n\n@media (max-width: 991.98px) {\n    .ellipsis-content-overlay {\n        -webkit-mask-image: linear-gradient(to bottom, #000 65%, transparent 100%);\n        mask-image: linear-gradient(to bottom, #000 50%, transparent 100%)\n    }\n}\n\n@media (max-width: 991.98px) {\n    .ellipsis-render-container .ellipsis-content-section.read-more {\n        height: 200px;\n        overflow: hidden\n    }\n}\n\n.ellipsis-render-container .ellipsis-content-section.read-more .ellipsis-overlay {\n    position: absolute;\n    height: 9.6rem;\n    bottom: 36px;\n    z-index: 10;\n    width: 100%\n}\n\n@media (max-width: 991.98px) {\n    .ellipsis-render-container .ellipsis-button-section {\n        height: 67px;\n        width: 100%;\n        padding-top: 16px\n    }\n}\n\n@media (max-width: 991.98px) {\n    .ellipsis-load-more-button.read-more__link {\n        background-image: url(/src/images/icons/chevron-down.svg);\n        background-repeat: no-repeat;\n        background-position: center center;\n        background-size: 10px;\n        height: 20px;\n        cursor: pointer;\n        width: 20px;\n        opacity: 15%;\n        position: absolute;\n        left: 50%;\n        transform: translate(-50%)\n    }\n}\n\n@media (max-width: 991.98px) {\n    .layout__blue .ellipsis-load-more-button.read-more__link {\n        background-image: url(/src/images/icons/chevron-down-white.svg);\n        opacity: 35%\n    }\n}\n\n.embedded-video .video-embed-field-responsive-video:after {\n    padding-bottom: 0\n}\n\n.pt-footer {\n    background-color: #f2f6f8\n}\n\n.pt-footer__top {\n    border-bottom: 1px solid rgba(138, 141, 143, .4);\n    height: 80px;\n    margin-bottom: 50px\n}\n\n@media (max-width: 767.98px) {\n    .pt-footer__top {\n        margin-bottom: 25px\n    }\n}\n\n.pt-footer__menu>div {\n    width: 100%\n}\n\n@media (min-width: 768px) {\n    .pt-footer__menu>div {\n        flex-wrap: wrap;\n        justify-content: flex-end\n    }\n}\n\n.pt-footer__menu>div nav {\n    width: 100%\n}\n\n@media (min-width: 768px) {\n    .pt-footer__menu>div nav {\n        flex: 1 0 25%\n    }\n}\n\n.pt-footer__menu ul {\n    margin-bottom: 0;\n    padding-left: 0;\n    list-style-type: none\n}\n\n.pt-footer__menu ul.menu-level-0 {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    max-width: 1300px\n}\n\n.pt-footer__menu ul.menu-level-0>.menu-item {\n    padding: 0 1.5rem;\n    width: 25%\n}\n\n@media (max-width: 767.98px) {\n    .pt-footer__menu ul.menu-level-0>.menu-item {\n        width: 100%\n    }\n}\n\n.pt-footer__menu ul li {\n    margin-bottom: 34px\n}\n\n@media (max-width: 767.98px) {\n    .pt-footer__menu ul li {\n        margin-bottom: 15px\n    }\n}\n\n.pt-footer__menu ul li a {\n    font-size: 1.7rem;\n    line-height: 1.4em;\n    color: #8a8d8f\n}\n\n.pt-footer__menu ul li a.font-weight-bold {\n    color: #041e42\n}\n\n.pt-footer__menu__social p {\n    color: #04325e;\n    font-size: 1.7rem;\n    line-height: 1.4em;\n    font-weight: 700;\n    margin-bottom: 0\n}\n\n.pt-footer__copyright p {\n    color: #8a8d8f;\n    font-size: 1.4rem;\n    line-height: .64em\n}\n\n.pt-footer--inverted {\n    background-color: #041e42\n}\n\n.pt-footer--inverted a {\n    color: #8a8d8f\n}\n\n.pt-footer--inverted a.font-weight-extrabold {\n    color: #fff\n}\n\n.block--gallery {\n    position: relative;\n    width: 575px;\n    max-width: 100%;\n    margin: 0 auto\n}\n\n@media (max-width: 991.98px) {\n    .block--gallery {\n        width: 90vw\n    }\n}\n\n.block--gallery .swiper {\n    aspect-ratio: 1/1\n}\n\n.block--gallery .swiper .swiper-wrapper {\n    margin-bottom: 0;\n    border-radius: inherit\n}\n\n.block--gallery .swiper .swiper-wrapper .swiper-slide {\n    background-color: #fff;\n    border-radius: inherit;\n    border: 1px solid #c7cfd7\n}\n\n@media (max-width: 991.98px) {\n\n    .block--gallery .swiper-button-next,\n    .block--gallery .swiper-button-prev {\n        display: none\n    }\n}\n\n#colorbox.colorbox--gallery {\n    height: 100% !important;\n    width: 100vw !important\n}\n\n#colorbox.colorbox--gallery #cboxContent {\n    width: calc(100vw - 30px) !important;\n    height: auto !important\n}\n\n#colorbox.colorbox--gallery #cboxContent .swiper-image-mobile img {\n    width: 100%\n}\n\n:not(.layout-builder-block).landing-banner {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    z-index: 9;\n    background-color: #fff\n}\n\n.media-2-columns__thumbnail img {\n    width: 100%\n}\n\n.media-2-columns__play {\n    position: relative;\n    display: block\n}\n\n.media-2-columns__play:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: block;\n    height: 100%;\n    width: 100%;\n    background: url(/src/images/icons/play.svg) no-repeat center\n}\n\n.media-2-columns__content h3 {\n    color: #04325e;\n    font-size: 1.8rem;\n    line-height: 1.56em;\n    font-weight: 700\n}\n\n.media-2-columns__content p {\n    color: #04325e;\n    font-size: 1.4rem;\n    line-height: 1.43em\n}\n\n@media (min-width: 768px) {\n    .media-2-columns__content p {\n        line-height: 1.71em\n    }\n}\n\n.media-2-columns .video-embed-field-responsive-video:after {\n    padding-bottom: 0\n}\n\n.region--primary-menu .block--menu-button {\n    position: fixed;\n    bottom: 15px;\n    left: 0;\n    padding-top: 10px !important\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .block--menu-button {\n        position: relative;\n        bottom: 0;\n        background-color: #484b4d;\n        height: 100%\n    }\n\n    .region--primary-menu .block--menu-button a {\n        position: relative;\n        top: 4px\n    }\n}\n\n.region--primary-menu .layout .block--menu-button {\n    display: none\n}\n\n.region--hamburger-menu .block--menu-button a,\n.region--primary-menu .block--menu-button a {\n    border-radius: 5px;\n    background-color: #fff;\n    color: #000;\n    font-size: 1.4rem;\n    line-height: 1.2em;\n    font-family: canada-type-gibson, sans-serif;\n    font-weight: 500;\n    padding: 8px 15px;\n    min-width: 130px;\n    min-height: 35px;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, .1607843137)\n}\n\n.region--hamburger-menu .block--menu-button a.btn--where:before,\n.region--primary-menu .block--menu-button a.btn--where:before {\n    --btn-text-color: none;\n    content: \"\";\n    display: inline-block;\n    width: 10px;\n    height: 14px;\n    margin-right: 5px;\n    /* background-image: url(/src/images/icons/icon-wheretobuy.svg); */\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100%\n}\n\n.block--menu-footer {\n    --text-color: #000000;\n    line-height: 1.2em;\n    padding-right: 15px;\n    padding-left: 15px\n}\n\n@media (min-width: 1200px) {\n    .block--menu-footer {\n        background-color: #484b4d;\n        --text-color: #FFFFFF\n    }\n}\n\n.block--menu-footer--title {\n    font-family: canada-type-gibson, sans-serif;\n    font-size: 1.5rem;\n    font-weight: 600\n}\n\n@media (min-width: 1200px) {\n    .block--menu-footer--title {\n        font-size: 1.4rem;\n        font-weight: 500\n    }\n}\n\n.block--menu-footer--description {\n    font-size: 1.4rem;\n    line-height: 1.6em;\n    color: #4b4b4b\n}\n\n.block--menu-footer--phone {\n    order: 2\n}\n\n.block--menu-footer--phone a {\n    color: #000 !important;\n    text-decoration: underline;\n    font-size: 1.6rem\n}\n\n@media (min-width: 1200px) {\n    .block--menu-footer--phone a {\n        color: #fff !important;\n        font-size: 1.3rem\n    }\n}\n\n.block--menu-footer--phone a:before {\n    position: relative;\n    top: 3px;\n    content: \"\";\n    display: inline-block;\n    width: 17px;\n    height: 17px;\n    margin-right: 5px;\n    /* background-image: url(/src/images/icons/icon-telephone.svg); */\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100%\n}\n\n@media (min-width: 1200px) {\n    .block--menu-footer--phone a:before {\n        /* background-image: url(/src/images/icons/icon-telephone-white.svg) */\n    }\n}\n\n.block--menu-footer--phone a:hover {\n    text-decoration: none\n}\n\n.block--menu-footer--email {\n    font-size: 1.6rem;\n    order: 1\n}\n\n@media (min-width: 1200px) {\n    .block--menu-footer--email {\n        border-left: 1px solid #6c757d;\n        font-size: 1.3rem\n    }\n}\n\n.block--menu-footer--email a {\n    color: #000 !important;\n    text-decoration: underline\n}\n\n@media (min-width: 1200px) {\n    .block--menu-footer--email a {\n        color: #fff !important\n    }\n}\n\n.block--menu-footer--email a:before {\n    position: relative;\n    top: 3px;\n    content: \"\";\n    display: inline-block;\n    width: 17px;\n    height: 17px;\n    margin-right: 5px;\n    /* background-image: url(/src/images/icons/icon-email.svg); */\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100%\n}\n\n/* \n@media (min-width: 1200px) {\n    .block--menu-footer--email a:before {\n        /* background-image: url(/src/images/icons/icon-email-white.svg) \n}\n}*/\n.block--menu-footer--email a:hover {\n    text-decoration: none\n}\n\n.truncate {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    width: 100%;\n    position: relative;\n    -webkit-line-clamp: 1\n}\n\n@media (max-width: 991.98px) {\n    .truncate {\n        -webkit-line-clamp: 2\n    }\n}\n\n@media (max-width: 575.98px) {\n    .truncate {\n        -webkit-line-clamp: 3\n    }\n}\n\n.truncate p {\n    margin: 0\n}\n\n.layout-container>.promotional-banner {\n    display: none;\n    justify-content: space-between;\n    align-items: center;\n    position: absolute;\n    width: 100%;\n    padding: 16px 50px;\n    z-index: 1;\n    color: var(--text-color);\n    box-shadow: none\n}\n\n.layout-container>.promotional-banner:after {\n    content: \"\";\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: var(--bg-color);\n    opacity: .8;\n    position: absolute;\n    z-index: -1\n}\n\n@media (max-width: 1199.98px) {\n    .layout-container>.promotional-banner {\n        padding: 16px 36px 16px 16px\n    }\n}\n\n.layout-container>.promotional-banner svg path {\n    fill: var(--text-color)\n}\n\n.layout-container>.promotional-banner a {\n    margin-left: 40px;\n    flex: 0 0 auto\n}\n\n@media (max-width: 1199.98px) {\n    .layout-container>.promotional-banner a {\n        margin-left: 0;\n        margin-top: 16px\n    }\n}\n\n.layout-container>.promotional-banner .btn__redirection::after {\n    min-width: 12px;\n    width: 12px;\n    height: 12px\n}\n\n.layout-container>.promotional-banner .close-promotional-banner {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    cursor: pointer;\n    width: 12px;\n    height: 12px;\n    display: flex\n}\n\n.layout-container>.promotional-banner--header-hidden {\n    margin-top: -10px\n}\n\n@media (min-width: 1200px) {\n    .layout-container>.promotional-banner--header-hidden {\n        margin-top: -36px\n    }\n}\n\n.layout-container #block-ptbase-child-main-menu .promotional-banner,\n.layout-container .region--hamburger-menu-wilson .promotional-banner {\n    background-color: var(--bg-color);\n    box-shadow: none;\n    text-align: left;\n    padding: 16px 50px 16px 15px;\n    position: relative;\n    margin: 16px 0\n}\n\n.layout-container #block-ptbase-child-main-menu .promotional-banner .btn-100-tertiary::after,\n.layout-container #block-ptbase-child-main-menu .promotional-banner .btn-tertiary::after,\n.layout-container .region--hamburger-menu-wilson .promotional-banner .btn-100-tertiary::after,\n.layout-container .region--hamburger-menu-wilson .promotional-banner .btn-tertiary::after {\n    min-width: 12px;\n    width: 12px;\n    height: 12px\n}\n\n.layout-container #block-ptbase-child-main-menu .promotional-banner .truncate,\n.layout-container .region--hamburger-menu-wilson .promotional-banner .truncate {\n    -webkit-line-clamp: 3\n}\n\n.layout-container #block-ptbase-child-main-menu .promotional-banner a,\n.layout-container .region--hamburger-menu-wilson .promotional-banner a {\n    margin-top: 16px\n}\n\n.layout-container #block-ptbase-child-main-menu .promotional-banner .close-promotional-banner,\n.layout-container .region--hamburger-menu-wilson .promotional-banner .close-promotional-banner {\n    display: none\n}\n\n@media (min-width: 1200px) {\n\n    .layout-container #block-ptbase-child-main-menu .promotional-banner,\n    .layout-container .region--hamburger-menu-wilson .promotional-banner {\n        display: none\n    }\n}\n\n.next-block-arrow {\n    display: flex;\n    pointer-events: none;\n    position: absolute;\n    bottom: 0;\n    width: 100%\n}\n\n.next-block-arrow.layout-builder-block {\n    position: relative;\n    pointer-events: auto\n}\n\n.next-block-arrow__alignment {\n    width: 50px;\n    cursor: pointer;\n    transition: all .3s ease;\n    pointer-events: auto\n}\n\n.next-block-arrow__alignment:hover {\n    transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -webkit-transform: translateY(10px)\n}\n\n.next-block-arrow__alignment--left {\n    justify-content: flex-start\n}\n\n.next-block-arrow__alignment--center {\n    justify-content: center\n}\n\n.next-block-arrow__alignment--right {\n    justify-content: flex-end\n}\n\n.next-block-arrow__alignment--color {\n    fill: #04325e\n}\n\n.layout__white .next-block-arrow__alignment--color {\n    fill: #04325e\n}\n\n.layout__grey .next-block-arrow__alignment--color {\n    fill: #04325e\n}\n\n.layout__blue .next-block-arrow__alignment--color {\n    fill: #fff\n}\n\n.layout__black .next-block-arrow__alignment--color {\n    fill: #fff\n}\n\n.next-block-arrow__color--blue .next-block-arrow__alignment--color {\n    fill: #04325e !important\n}\n\n.next-block-arrow__color--white .next-block-arrow__alignment--color {\n    fill: #fff !important\n}\n\n@keyframes moving-border {\n    25% {\n        border-image: linear-gradient(90deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1\n    }\n\n    50% {\n        border-image: linear-gradient(180deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1\n    }\n\n    75% {\n        border-image: linear-gradient(270deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1\n    }\n\n    100% {\n        border-image: linear-gradient(360deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1\n    }\n}\n\n.block-quote {\n    margin: auto;\n    position: relative;\n    max-height: 80vh;\n    overflow: hidden;\n    z-index: 99;\n    justify-content: center;\n    align-items: center\n}\n\n@media (max-width: 991.98px) {\n    .block-quote {\n        max-height: none\n    }\n}\n\n.block-quote--pt {\n    border: 8px solid #41b6e6\n}\n\n.block-quote--100 {\n    --fade-deg: 45deg;\n    border-style: solid;\n    border-width: 8px;\n    border-image: linear-gradient(0deg, #e04f39 0, #e0457b 50%, #0077c8 100%) 1;\n    animation: moving-border 25s linear infinite\n}\n\n.block-quote__media p {\n    margin: 0\n}\n\n.block-quote__text {\n    padding: 42px 32px\n}\n\n.block-quote__text--person {\n    padding-top: 36px;\n    font-weight: 700\n}\n\n.slideshow__wysiwyg {\n    position: absolute;\n    bottom: 30%;\n    max-width: 400px;\n    left: 8.33%\n}\n\n.slideshow__wysiwyg .big--title {\n    margin-bottom: 0\n}\n\n.slideshow__wysiwyg p {\n    margin: 0\n}\n\n.slideshow--left .slideshow__wysiwyg {\n    left: 8.33%\n}\n\n.slideshow--left .slick--skin--pt-lines .slick-dots {\n    left: 8.33%\n}\n\n.slideshow--right .slideshow__wysiwyg {\n    right: 8.33%;\n    left: unset\n}\n\n.slideshow--right .slick--skin--pt-lines .slick-dots {\n    right: 8.33%;\n    left: unset\n}\n\n.social-media-sharing ul {\n    margin-bottom: 0\n}\n\n.social-media-sharing li {\n    margin-right: 0;\n    margin-left: 8px\n}\n\n.social-media-sharing__logo {\n    width: 32px;\n    height: 32px;\n    background: 0 0;\n    margin-bottom: 4px;\n    box-shadow: 1px 2px 4px rgba(0, 0, 0, .1607843137);\n    border-radius: 50%;\n    transition: all .3s ease\n}\n\n.social-media-sharing__logo g,\n.social-media-sharing__logo path,\n.social-media-sharing__logo svg {\n    fill: var(--color-dark-blue)\n}\n\n.social-media-sharing__logo:hover {\n    box-shadow: none;\n    background-color: #f2f6f8\n}\n\n.social-media-sharing .share {\n    transition: transform .3s ease;\n    display: inline-block\n}\n\n.social-media-sharing .share img {\n    width: 32px;\n    height: 32px\n}\n\n.social-media-sharing__text {\n    display: none\n}\n\n.layout__grey .social-media-sharing__logo:hover {\n    background-color: #e8ebed\n}\n\n.layout__blue .social-media-sharing__logo {\n    background-color: #17407a\n}\n\n.layout__blue .social-media-sharing__logo g,\n.layout__blue .social-media-sharing__logo path,\n.layout__blue .social-media-sharing__logo svg {\n    fill: #fff\n}\n\n.layout__blue .social-media-sharing__logo:hover {\n    background-color: #133666\n}\n\n.layout__black .social-media-sharing__logo,\n.layout__dark_grey .social-media-sharing__logo {\n    background-color: #4d4d4d\n}\n\n.layout__black .social-media-sharing__logo g,\n.layout__black .social-media-sharing__logo path,\n.layout__black .social-media-sharing__logo svg,\n.layout__dark_grey .social-media-sharing__logo g,\n.layout__dark_grey .social-media-sharing__logo path,\n.layout__dark_grey .social-media-sharing__logo svg {\n    fill: #fff\n}\n\n.layout__black .social-media-sharing__logo:hover,\n.layout__dark_grey .social-media-sharing__logo:hover {\n    background-color: #333\n}\n\n@media (min-width: 576px) {\n    .social-share--hide-desktop:not(.layout-builder-block) {\n        display: none\n    }\n}\n\n.date-block {\n    width: 100%\n}\n\n.filtering-articles-list {\n    position: relative;\n    background: #f2f6f8 0 0 no-repeat padding-box\n}\n\n.filtering-articles-list-banner {\n    padding: 30px 0 0;\n    position: relative;\n    display: block\n}\n\n.filtering-articles-list-banner .back-news-list {\n    color: #0077c8;\n    padding: 6px 24px 6px 44px;\n    background: rgba(255, 255, 255, .6);\n    border-radius: 0 18px 18px 0;\n    display: inline-flex;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n    transition: all .3s ease-in-out\n}\n\n.filtering-articles-list-banner .back-news-list::before {\n    content: \"\";\n    width: 18px;\n    height: 12px;\n    margin-right: 3px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/arrow-previous-light-blue.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/arrow-previous-light-blue.svg); */\n    background-color: #0077c8;\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease\n}\n\n.filtering-articles-list-banner .back-news-list:hover {\n    text-decoration: underline;\n    background: rgba(255, 255, 255, .8);\n    color: var(--link-hover-color)\n}\n\n.filtering-articles-list-banner .back-news-list:hover:before {\n    background-color: var(--link-hover-color)\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list-banner .back-news-list {\n        padding-left: 15px;\n        margin-top: 25px;\n        text-decoration: underline;\n        background: rgba(255, 255, 255, .6);\n        color: var(--link-hover-color)\n    }\n\n    .filtering-articles-list-banner .back-news-list:before {\n        background-color: var(--link-hover-color)\n    }\n}\n\n.filtering-articles-list-banner-bkg {\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 2px;\n    left: 0;\n    background: linear-gradient(to bottom, rgba(255, 0, 0, 0) 0, #f2f6f8 90%);\n    z-index: 2\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list-banner-bkg {\n        background: linear-gradient(to bottom, rgba(255, 0, 0, 0) -50%, #f2f6f8 80%)\n    }\n}\n\n.filtering-articles-list-banner-image {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 2\n}\n\n.filtering-articles-list-text {\n    padding: 45px;\n    position: relative;\n    z-index: 2\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list-text {\n        padding: 30px 15px\n    }\n}\n\n.filtering-articles-list-text h1 {\n    font-weight: 700;\n    margin-bottom: 2px\n}\n\n.filtering-articles-list-text .description {\n    max-width: 60%;\n    padding-left: 2px\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list-text .description {\n        max-width: none\n    }\n}\n\n.filtering-articles-list-raw {\n    align-items: flex-start\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list-raw {\n        background-color: #f2f6f8\n    }\n}\n\n.filtering-articles-list .filters-mobile-open-btn {\n    padding: 8px;\n    text-align: center;\n    border: 1.5px solid #41b6e6;\n    background-color: #fff;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, .1607843137);\n    border-radius: 8px;\n    color: #041e42;\n    width: calc(100% - 30px);\n    margin-left: 15px;\n    z-index: 5;\n    position: relative;\n    display: none\n}\n\n.filtering-articles-list .filters-mobile-open-btn::before {\n    content: \"\";\n    display: inline-block;\n    width: 16px;\n    height: 13px;\n    margin-right: 5px;\n    /* background-image: url(/src/images/icons/filters.svg); */\n    background-size: contain\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .filters-mobile-open-btn {\n        display: block\n    }\n}\n\n.filtering-articles-list .filters-mobile-close-btn {\n    position: absolute;\n    top: 33px;\n    right: 15px;\n    background-color: transparent;\n    border: 1.5px solid #41b6e6;\n    text-align: center;\n    width: 36px;\n    height: 36px;\n    line-height: 40px;\n    border-radius: 50%;\n    box-shadow: none;\n    display: none\n}\n\n.filtering-articles-list .filters-mobile-close-btn::after {\n    content: \"\";\n    display: inline-block;\n    background-image: url(/src/images/icons/close.svg);\n    width: 16px;\n    height: 16px\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .filters-mobile-close-btn {\n        display: block\n    }\n}\n\n.filtering-articles-list .filtering-articles-wrap {\n    background: #fff 0 0 no-repeat padding-box;\n    border-radius: 0 16px 16px 0;\n    padding: 32px 25px 38px 60px\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .filtering-articles-wrap {\n        position: absolute;\n        top: 0;\n        left: -15px;\n        width: calc(100vw - 45px);\n        z-index: 5;\n        padding: 33px 15px;\n        transition: all .3s ease-in-out;\n        transform: translateX(calc(-100% - 45px))\n    }\n\n    .filtering-articles-list .filtering-articles-wrap.opened {\n        transform: none;\n        padding-left: 30px\n    }\n\n    .filtering-articles-list .filtering-articles-wrap.opened::after {\n        content: \"\";\n        display: block;\n        position: absolute;\n        top: 0;\n        right: -60px;\n        width: 60px;\n        height: 100%;\n        background: #041e42;\n        opacity: .5\n    }\n}\n\n.filtering-articles-list .filtering-articles-wrap .filters-details {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 30px\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .filtering-articles-wrap .filters-details {\n        flex-direction: column\n    }\n}\n\n.filtering-articles-list .filtering-articles-wrap .filters-counter {\n    display: inline-block;\n    vertical-align: top\n}\n\n.filtering-articles-list .filtering-articles-wrap .filters-counter h2 .active-filters-counter-h2 {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    vertical-align: middle;\n    margin-left: 15px;\n    width: 20px;\n    height: 20px;\n    border: 1px solid #041e42;\n    border-radius: 50%;\n    color: #041e42;\n    text-align: center\n}\n\n.filtering-articles-list .filtering-articles-wrap .filters-counter span {\n    color: #8a8d8f\n}\n\n.filtering-articles-list .filtering-articles-wrap hr {\n    border-top: 1px solid #8a8d8f;\n    margin: 45px 0 42px\n}\n\n.filtering-articles-list .filtering-articles-wrap hr.filters-separatpr-mobile {\n    display: none\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .filtering-articles-wrap hr.filters-separatpr-mobile {\n        display: block\n    }\n}\n\n.filtering-articles-list .filters-reset-btn {\n    text-align: right;\n    margin-top: 5px\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .filters-reset-btn {\n        margin-top: 14px\n    }\n}\n\n.filtering-articles-list .facet-clear-all {\n    position: relative;\n    color: #0077c8\n}\n\n.filtering-articles-list .facet-clear-all::before {\n    content: \"\";\n    position: absolute;\n    left: 19px;\n    bottom: 4px;\n    height: 1px;\n    background: #0060a1\n}\n\n.filtering-articles-list .facet-clear-all:hover {\n    color: #0060a1\n}\n\n.filtering-articles-list .facet-clear-all:hover::before {\n    right: 0\n}\n\n.filtering-articles-list .facet-clear-all:hover .close-btn:after,\n.filtering-articles-list .facet-clear-all:hover .close-btn:before {\n    background-color: #0060a1\n}\n\n.filtering-articles-list .facet-clear-all .close-btn {\n    position: relative;\n    display: inline-block;\n    vertical-align: super;\n    width: 10px;\n    height: 10px;\n    margin-right: 8px\n}\n\n.filtering-articles-list .facet-clear-all .close-btn:hover {\n    opacity: 1\n}\n\n.filtering-articles-list .facet-clear-all .close-btn:after,\n.filtering-articles-list .facet-clear-all .close-btn:before {\n    position: absolute;\n    top: 5px;\n    left: 3px;\n    content: \"\";\n    height: 12px;\n    width: 2px;\n    background-color: #0077c8\n}\n\n.filtering-articles-list .facet-clear-all .close-btn:before {\n    transform: rotate(45deg)\n}\n\n.filtering-articles-list .facet-clear-all .close-btn:after {\n    transform: rotate(-45deg)\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .facet-clear-all {\n        color: #0060a1\n    }\n\n    .filtering-articles-list .facet-clear-all::before {\n        right: 0\n    }\n\n    .filtering-articles-list .facet-clear-all .close-btn:after,\n    .filtering-articles-list .facet-clear-all .close-btn:before {\n        background-color: #0060a1\n    }\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox {\n    list-style: none;\n    padding-left: 10px\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item {\n    margin-bottom: 25px\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item.facet-item--expanded.open .plus-icon::after {\n    transform: rotate(90deg)\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item.facet-item--expanded .plus-icon {\n    display: inline-block !important\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>.facets-checkbox[id^=tags] {\n    display: none\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>.facets-checkbox[id^=tags]>ul {\n    padding-left: 16px\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox {\n    --form-radio-border: #041E42;\n    appearance: none;\n    margin-right: 10px;\n    width: 17px;\n    height: 17px;\n    box-shadow: 0 0 0 1px var(--form-radio-border);\n    border-radius: 4px;\n    /* background: no-repeat top/50% url(/src/images/icons/checkmark-white.svg), #fff; */\n    transition: box-shadow .2s ease, background .2s ease\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:hover {\n    --form-radio-border: #041E42;\n    /* background: no-repeat center/50% url(/src/images/icons/checkmark-white.svg), #8a8d8f */\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:hover.disabled:not(:checked) {\n    background: rgba(4, 30, 66, .3)\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:checked {\n    box-shadow: none;\n    --form-bg-color: pt-blue-primary;\n    /* background: no-repeat center/50% url(/src/images/icons/checkmark-white.svg), #041e42 */\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:checked.disabled {\n    --form-bg-color: pt-blue-primary;\n    opacity: .5;\n    box-shadow: none\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:checked.disabled:hover {\n    --form-bg-color: pt-blue-primary;\n    opacity: .5;\n    box-shadow: none\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facets-checkbox:checked:hover {\n    box-shadow: 0 0 0 1px var(--form-radio-border);\n    --form-bg-color: rgba(4, 30, 66, 0.7)\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>.facets-widget- {\n    display: none;\n    padding-bottom: 1px\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>.facets-widget->ul {\n    padding-left: 16px\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value {\n    font-weight: 700;\n    color: #041e42;\n    cursor: pointer;\n    position: relative\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value .plus-icon {\n    display: none;\n    position: relative;\n    width: 16px;\n    height: 16px;\n    top: 0;\n    left: -8px\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value .plus-icon::after,\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value .plus-icon::before {\n    content: \"\";\n    background: #0077c8 0 0 no-repeat padding-box;\n    position: absolute;\n    transition: all .3s ease-in-out\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value .plus-icon::before {\n    top: 9px;\n    left: 0;\n    width: 16px;\n    height: 3px\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item>label>.facet-item__value .plus-icon::after {\n    top: 3px;\n    width: 3px;\n    height: 16px;\n    left: 7px\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .term-description {\n    color: #041e42;\n    margin-top: 6px;\n    margin-bottom: 17px;\n    display: none;\n    padding-left: 16px\n}\n\n.open .filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .term-description {\n    display: block\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facet-item-children-count {\n    color: #041e42;\n    border: 1px solid #041e42;\n    width: 20px;\n    height: 20px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    text-align: center;\n    vertical-align: initial;\n    margin-left: 10px\n}\n\n.filtering-articles-list .facets-widget-checkbox ul.item-list__checkbox>.facet-item .facet-item {\n    list-style: none;\n    margin-bottom: 10px\n}\n\n.filtering-articles-list .categories-filter {\n    display: block\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .categories-filter {\n        display: none\n    }\n}\n\n.filtering-articles-list .categories-filter.mobile {\n    display: none;\n    width: 100%;\n    padding: 0 15px\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .categories-filter.mobile {\n        display: block\n    }\n}\n\n.filtering-articles-list .categories-filter.mobile hr {\n    border-top: 1px solid #8a8d8f;\n    margin: 40px 0 50px\n}\n\n.filtering-articles-list .categories-filter-title {\n    margin-bottom: 10px\n}\n\n.filtering-articles-list .categories-filter .facets-widget-links>ul {\n    list-style: none;\n    margin-bottom: 22px;\n    padding: 0\n}\n\n.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item {\n    position: relative;\n    margin-bottom: 22px\n}\n\n.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a {\n    letter-spacing: 0;\n    color: #0077c8;\n    position: relative;\n    padding-bottom: 5px\n}\n\n.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a::after {\n    content: \"\";\n    width: 100%;\n    height: 1px;\n    background: #0077c8;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    transition: all .1s ease-in-out\n}\n\n.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a .facet-item__status {\n    display: none\n}\n\n.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a.is-active {\n    color: #041e42\n}\n\n.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a.is-active::after {\n    width: 0 !important\n}\n\n.filtering-articles-list .categories-filter .facets-widget-links>ul .facet-item a:hover::after {\n    height: 3px;\n    background: #0060a1\n}\n\n.filtering-articles-list .filtering-articles-content {\n    padding-left: 30px;\n    padding-right: 50px\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .filtering-articles-content {\n        padding: 0 15px;\n        margin: 0\n    }\n}\n\n.filtering-articles-list .filtering-articles-content .articles-sort-counter {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 24px\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .filtering-articles-content .articles-sort-counter {\n        padding: 0 15px\n    }\n}\n\n.filtering-articles-list .filtering-articles-content .articles-sort-counter #edit-sort-by,\n.filtering-articles-list .filtering-articles-content .articles-sort-counter #edit-submit-filtering-articles {\n    display: none\n}\n\n.filtering-articles-list .filtering-articles-content .articles-sort-counter label.edit-sort-by {\n    font-weight: 700;\n    color: #041e42\n}\n\n.filtering-articles-list .filtering-articles-content .articles-sort-counter select#edit-sort-order {\n    position: relative;\n    width: 186px;\n    height: 40px;\n    border: 0;\n    color: #041e42;\n    border-radius: 8px;\n    padding: 0 15px;\n    appearance: none;\n    /* background-image: url(/src/images/icons/chevron-down-dark-blue.svg); */\n    background-repeat: no-repeat;\n    background-size: 13px;\n    background-position: calc(100% - 15px) 50%\n}\n\n.filtering-articles-list .filtering-articles-content .articles-sort-counter .form-item-sort-by {\n    display: inline-block;\n    width: 186px;\n    text-align: left\n}\n\n.filtering-articles-list .filtering-articles-content .articles-sort-counter .counter {\n    color: #54585a\n}\n\n.filtering-articles-list .facets-applied {\n    padding-top: 37px;\n    position: relative\n}\n\n.filtering-articles-list .facets-applied.no-filters {\n    margin: 0\n}\n\n.filtering-articles-list .facets-applied.mobile {\n    max-height: none;\n    margin-bottom: 0;\n    padding: 10px 0 0;\n    display: none\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .facets-applied.mobile {\n        display: block\n    }\n}\n\n.filtering-articles-list .facets-applied.mobile .applied-facets-tags {\n    margin: 0\n}\n\n.filtering-articles-list .facets-applied.mobile .applied-facets-tags .facet-tag {\n    margin: 0 8px 15px 0\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .facets-applied {\n        max-height: 120px;\n        overflow: hidden;\n        margin-bottom: 64px;\n        padding: 32px 15px 0;\n        transition: all .3s ease-in-out\n    }\n}\n\n.filtering-articles-list .facets-applied-title {\n    font-weight: 700;\n    color: #041e42\n}\n\n.filtering-articles-list .facets-applied .empty-tags-label {\n    color: #041e42\n}\n\n.filtering-articles-list .facets-applied .applied-facets-tags {\n    margin-top: 12px;\n    margin-bottom: 42px\n}\n\n.filtering-articles-list .facets-applied .facet-tag {\n    color: #041e42;\n    background-color: #f2f6f8;\n    padding: 0 10px;\n    border: 2px solid #041e42;\n    border-radius: 10px;\n    margin: 0 15px 12px 0;\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n    transition: all .3s ease-in-out\n}\n\n.filtering-articles-list .facets-applied .facet-tag .remove {\n    padding: 0;\n    border: 0;\n    width: 16px;\n    height: 16px;\n    vertical-align: text-top;\n    margin-left: 12px;\n    background-color: transparent;\n    /* background-image: url(/src/images/icons/x-dark-blue.svg); */\n    background-size: 8px 8px;\n    background-repeat: no-repeat;\n    background-position: center;\n    border-radius: 50%\n}\n\n.filtering-articles-list .facets-applied .facet-tag .remove:hover {\n    background-color: #fff\n}\n\n.filtering-articles-list .facets-applied .facet-tag:hover {\n    background-color: #e8ebed\n}\n\n.filtering-articles-list .facets-applied .facet-clear-all {\n    margin-left: 30px\n}\n\n.filtering-articles-list .facets-applied .ellipsis-buttons {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    z-index: 3\n}\n\n@media (min-width: 576px) {\n    .filtering-articles-list .facets-applied .ellipsis-buttons {\n        display: none !important\n    }\n}\n\n.filtering-articles-list .facets-applied .ellipsis-buttons button {\n    padding: 0;\n    background-color: transparent;\n    border: 0;\n    box-shadow: none;\n    font-weight: 700;\n    color: #041e42;\n    border-bottom: 1px solid #41b6e6\n}\n\n.filtering-articles-list .facets-applied .ellipsis-buttons button::before {\n    content: \"\";\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    margin-right: 6px;\n    /* background-image: url(/src/images/icons/x-dark-blue.svg); */\n    transform: rotate(45deg)\n}\n\n.filtering-articles-list .facets-applied .ellipsis-overlay {\n    background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 20%, #f2f6f8 80%, #f2f6f8 100%);\n    position: absolute;\n    display: block;\n    width: 100%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 100%;\n    z-index: 2\n}\n\n@media (min-width: 576px) {\n    .filtering-articles-list .facets-applied .ellipsis-overlay {\n        display: none !important\n    }\n}\n\n.filtering-articles-list .article-long-summary--featured {\n    background: 0 0;\n    box-shadow: none\n}\n\n.filtering-articles-list .article-long-summary--featured .article-text {\n    border-radius: 8px 0 0 8px;\n    background: #041e42\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .article-long-summary--featured .article-text {\n        border-radius: 0 0 8px 8px\n    }\n}\n\n.filtering-articles-list .article-long-summary--featured .article-image .drupal-media__image--full-width img {\n    border-radius: 0 8px 8px 0\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .article-long-summary--featured .article-image .drupal-media__image--full-width img {\n        border-radius: 8px 8px 0 0\n    }\n}\n\n.filtering-articles-list .article-long-summary {\n    margin-top: 0\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .article-long-summary {\n        margin: 0;\n        padding: 0 15px;\n        background-color: #f2f6f8\n    }\n}\n\n@media (max-width: 767.98px) {\n    .filtering-articles-list .article-short-summary {\n        padding: 0 15px;\n        background-color: #f2f6f8;\n        box-shadow: none\n    }\n\n    .filtering-articles-list .article-short-summary .short-summary__text {\n        background-color: #fff;\n        border-radius: 0 0 8px 8px\n    }\n\n    .filtering-articles-list .article-short-summary .drupal-media__image--full-width img {\n        border-radius: 8px 8px 0 0\n    }\n}\n\n.wysiwyg-accordion {\n    margin-bottom: 7px;\n    margin-top: 7px;\n    transition: all .3s ease-in-out\n}\n\n.wysiwyg-accordion:not(.border-bottom) .wysiwyg-accordion__title,\n.wysiwyg-accordion:not(.outline) .wysiwyg-accordion__title {\n    padding-bottom: 12px\n}\n\n.wysiwyg-accordion.outline .accordion-container {\n    box-shadow: 0 0 0 1px #8a8d8f;\n    border-radius: 10px;\n    position: relative\n}\n\n.wysiwyg-accordion.outline .accordion-container:hover {\n    box-shadow: 0 0 0 2px #8a8d8f\n}\n\n.wysiwyg-accordion.outline a {\n    padding: 10px 25px\n}\n\n.wysiwyg-accordion.outline .wysiwyg-accordion__title {\n    padding: 8px 0\n}\n\n.wysiwyg-accordion.outline .wysiwyg-accordion__title.left {\n    padding: 0\n}\n\n.wysiwyg-accordion.outline .wysiwyg-accordion__body p {\n    margin-bottom: 0\n}\n\n.wysiwyg-accordion .right .text {\n    margin-left: 0\n}\n\n.wysiwyg-accordion .right a {\n    justify-content: space-between\n}\n\n.wysiwyg-accordion .icon {\n    max-width: 16px;\n    width: 100%;\n    height: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center\n}\n\n.wysiwyg-accordion .icon:before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    width: 16px;\n    height: 2px\n}\n\n.wysiwyg-accordion .icon:after {\n    content: \"\";\n    display: block;\n    width: 2px;\n    height: 16px;\n    transition: transform .3s ease\n}\n\n.wysiwyg-accordion .text {\n    margin-left: 10px\n}\n\n.wysiwyg-accordion.bottom-border .accordion-container {\n    box-shadow: 0 1px 0 0 #8a8d8f\n}\n\n.wysiwyg-accordion.bottom-border .accordion-container:hover {\n    box-shadow: 0 2px 0 0 #8a8d8f\n}\n\n.wysiwyg-accordion.bottom-border .wysiwyg-accordion__body p {\n    margin-bottom: 0;\n    margin-top: 5px\n}\n\n.wysiwyg-accordion.bottom-border .wysiwyg-accordion__title {\n    padding-bottom: 8px\n}\n\n.wysiwyg-accordion .opener {\n    flex-direction: row;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start\n}\n\n.wysiwyg-accordion__body {\n    padding: 0 45px 25px 25px\n}\n\n.wysiwyg-accordion__title.left {\n    padding-bottom: 25px\n}\n\n.wysiwyg-accordion__title a {\n    font-weight: 700;\n    font-size: 1.8rem;\n    line-height: 2.8rem;\n    font-family: Axiforma;\n    position: relative;\n    --text-color: #41B6E6;\n    display: inline-flex\n}\n\n.wysiwyg-accordion__title a:hover {\n    text-decoration: none;\n    cursor: pointer\n}\n\n.wysiwyg-accordion__title a:hover:after,\n.wysiwyg-accordion__title a:hover:before {\n    width: 3px\n}\n\n.wysiwyg-accordion__title a:not(.collapsed) .icon:after {\n    transform: rotate(90deg)\n}\n\n.wysiwyg-accordion__title__dark a {\n    --text-color: var(--color-dark-blue)\n}\n\n.wysiwyg-accordion__title__dark a .icon:after,\n.wysiwyg-accordion__title__dark a .icon:before {\n    background-color: var(--color-dark-blue)\n}\n\n.wysiwyg-accordion__title__light a {\n    --text-color: var(--color-light-blue)\n}\n\n.wysiwyg-accordion__title__light a .icon:after,\n.wysiwyg-accordion__title__light a .icon:before {\n    background-color: var(--color-light-blue)\n}\n\n.theme-100.wysiwyg-accordion .wysiwyg-accordion__title a {\n    --text-color: $pt-white-secondary\n}\n\n.theme-100.wysiwyg-accordion .wysiwyg-accordion__title a .icon:after,\n.theme-100.wysiwyg-accordion .wysiwyg-accordion__title a .icon:before {\n    background-color: #fff\n}\n\n.social-media__title {\n    font-size: 2.8rem;\n    line-height: 1.1em;\n    font-weight: 700\n}\n\n@media screen and (max-width: 767px) {\n    .social-media__title {\n        font-size: 2.3rem;\n        line-height: 1.3em\n    }\n}\n\n.social-media__nav {\n    padding-left: 0;\n    display: flex;\n    list-style: none\n}\n\n.social-media__nav__icon {\n    outline: 0;\n    text-indent: -9999px;\n    background-repeat: no-repeat;\n    width: 25px;\n    height: 25px;\n    margin-right: 4px\n}\n\n.social-media__nav__icon:before {\n    content: unset !important\n}\n\n.social-media__nav__icon a {\n    display: block;\n    width: 100%;\n    height: 100%\n}\n\n/* \n.social-media__nav__facebook {\n    background-image: url(/src/images/icons/facebook-white.svg)\n}\n\n.social-media__nav__instagram {\n    background-image: url(/src/images/icons/instagram-white.svg)\n}\n\n.social-media__nav__linkedin {\n    background-image: url(/src/images/icons/linkedin-white.svg)\n}\n\n.social-media__nav__pinterest {\n    background-image: url(/src/images/icons/pinterest-white.svg)\n}\n\n.social-media__nav__twitter {\n    background-image: url(/src/images/icons/twitter-white.svg)\n}\n\n.social-media__nav__youtube {\n    background-image: url(/src/images/icons/youtube-white.svg)\n} */\n\n.social-media--big .social-media__nav__icon {\n    width: 52px;\n    height: 52px\n}\n\n/* \n.layout__grey .social-media__nav__facebook,\n.layout__white .social-media__nav__facebook,\n.pt-footer__ptsa .social-media__nav__facebook,\n.ptwe-footer .social-media__nav__facebook {\n    background-image: url(/src/images/icons/facebook-light-blue.svg)\n}\n\n.layout__grey .social-media__nav__instagram,\n.layout__white .social-media__nav__instagram,\n.pt-footer__ptsa .social-media__nav__instagram,\n.ptwe-footer .social-media__nav__instagram {\n    background-image: url(/src/images/icons/instagram-light-blue.svg)\n}\n\n.layout__grey .social-media__nav__linkedin,\n.layout__white .social-media__nav__linkedin,\n.pt-footer__ptsa .social-media__nav__linkedin,\n.ptwe-footer .social-media__nav__linkedin {\n    background-image: url(/src/images/icons/linkedin-light-blue.svg)\n}\n\n.layout__grey .social-media__nav__pinterest,\n.layout__white .social-media__nav__pinterest,\n.pt-footer__ptsa .social-media__nav__pinterest,\n.ptwe-footer .social-media__nav__pinterest {\n    background-image: url(/src/images/icons/pinterest-light-blue.svg)\n}\n\n.layout__grey .social-media__nav__twitter,\n.layout__white .social-media__nav__twitter,\n.pt-footer__ptsa .social-media__nav__twitter,\n.ptwe-footer .social-media__nav__twitter {\n    background-image: url(/src/images/icons/twitter-light-blue.svg)\n}\n\n.layout__grey .social-media__nav__youtube,\n.layout__white .social-media__nav__youtube,\n.pt-footer__ptsa .social-media__nav__youtube,\n.ptwe-footer .social-media__nav__youtube {\n    background-image: url(/src/images/icons/youtube-light-blue.svg)\n} */\n\n.pt-footer__ptsa .social-media__nav__icon,\n.ptwe-footer .social-media__nav__icon {\n    width: 25px;\n    height: 25px\n}\n\n/* \n.pt-footer__ptsa .social-media__nav__facebook,\n.ptwe-footer .social-media__nav__facebook {\n    background-image: url(/src/images/icons/facebook.svg)\n}\n\n.pt-footer__ptsa .social-media__nav__instagram,\n.ptwe-footer .social-media__nav__instagram {\n    background-image: url(/src/images/icons/instagram.svg)\n}\n\n.pt-footer__ptsa .social-media__nav__linkedin,\n.ptwe-footer .social-media__nav__linkedin {\n    background-image: url(/src/images/icons/linkedin.svg)\n}\n\n.pt-footer__ptsa .social-media__nav__pinterest,\n.ptwe-footer .social-media__nav__pinterest {\n    background-image: url(/src/images/icons/pinterest.svg)\n}\n\n.pt-footer__ptsa .social-media__nav__twitter,\n.ptwe-footer .social-media__nav__twitter {\n    background-image: url(/src/images/icons/twitter.svg)\n}\n\n.pt-footer__ptsa .social-media__nav__youtube,\n.ptwe-footer .social-media__nav__youtube {\n    background-image: url(/src/images/icons/youtube.svg)\n} */\n\n.media__quote {\n    color: #000\n}\n\n.media__quote__body {\n    font-weight: 700;\n    font-size: 3.4rem;\n    line-height: 1.18em;\n    padding-bottom: 15px\n}\n\n.media__quote__signature__name {\n    font-weight: 700;\n    font-size: 1.4rem;\n    line-height: 1.14em;\n    padding-bottom: 5px\n}\n\n.media__quote__signature__title {\n    font-size: 1.1rem;\n    line-height: 1.45em\n}\n\n.node-grid {\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto auto auto;\n    position: relative\n}\n\n.node-grid__image div {\n    display: flex;\n    flex: 1 0 auto;\n    align-items: center;\n    justify-content: center;\n    justify-items: center\n}\n\n.node-grid__veil {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    opacity: 0;\n    transition: opacity .3s ease;\n    background: #041e42;\n    z-index: 9\n}\n\n.node-grid__main-container {\n    position: relative;\n    width: auto;\n    overflow: hidden\n}\n\n@media (max-width: 767.98px) {\n    .node-grid__main-container img {\n        width: 100%\n    }\n}\n\n.node-grid__title {\n    padding: 13px 0 8px;\n    text-align: center\n}\n\n.node-grid__text {\n    display: none;\n    color: #f2f6f8;\n    position: absolute;\n    bottom: 10%\n}\n\n.node-grid__wysiwyg p {\n    font-size: 2rem;\n    font-weight: 800;\n    margin-bottom: 0\n}\n\n.node-grid__link {\n    box-shadow: none\n}\n\n.node-grid__link a {\n    margin-bottom: 0;\n    color: #41b6e6;\n    letter-spacing: 1px\n}\n\n.node-grid__btn div {\n    display: inline;\n    white-space: nowrap\n}\n\n.node-grid:hover .node-grid__text {\n    display: block;\n    z-index: 10\n}\n\n@media (max-width: 767.98px) {\n    .node-grid:hover .node-grid__text {\n        display: none\n    }\n}\n\n.node-grid:hover .node-grid__veil {\n    opacity: .92\n}\n\n@media (max-width: 767.98px) {\n    .node-grid:hover .node-grid__veil {\n        opacity: 0\n    }\n}\n\n.layout__black .node-grid__text,\n.layout__black .node-grid__title,\n.layout__blue .node-grid__text,\n.layout__blue .node-grid__title,\n.layout__gradient_blue .node-grid__text,\n.layout__gradient_blue .node-grid__title {\n    color: #fff\n}\n\n@media (min-width: 1200px) {\n    .col-lg-5ths {\n        flex: 0 0 20%;\n        position: relative;\n        min-height: 1px;\n        padding-left: 15px;\n        padding-right: 15px\n    }\n}\n\n.node-hgrid .listing {\n    display: inline-flex;\n    flex-direction: column;\n    border: 1px solid #8a8d8f;\n    border-radius: 5px\n}\n\n@media (min-width: 992px) {\n    .node-hgrid .listing {\n        flex-direction: row;\n        width: 100%\n    }\n}\n\n.node-hgrid .listing__image {\n    max-width: 165px;\n    border-radius: 5px 5px 0 0;\n    overflow: hidden;\n    flex: 50% 0 1\n}\n\n@media (min-width: 992px) {\n    .node-hgrid .listing__image {\n        border-right: 1px solid #8a8d8f;\n        border-radius: 10px\n    }\n}\n\n.node-hgrid .listing__image img {\n    border-radius: 5px 5px 0 0;\n    transition: transform .3s ease\n}\n\n@media (min-width: 992px) {\n    .node-hgrid .listing__image img {\n        border-radius: 10px\n    }\n}\n\n.node-hgrid .listing__text {\n    max-width: 250px;\n    color: #000;\n    margin: 10px;\n    flex: 50% 1 0\n}\n\n@media (min-width: 992px) {\n    .node-hgrid .listing__text {\n        margin: auto 10px\n    }\n}\n\n.node-hgrid .listing__title {\n    font-weight: 600;\n    font-size: 1.5rem\n}\n\n.node-hgrid .listing__link {\n    font-size: 1.2rem;\n    display: flex\n}\n\n.node-hgrid .listing__link:after {\n    content: \"\";\n    display: inline-block;\n    position: relative;\n    width: 16px;\n    height: 18px;\n    margin-left: 3px;\n    /* background-image: url(/src/images/icons/arrow-next-black.svg); */\n    background-repeat: no-repeat;\n    background-position: center center;\n    transition: transform .3s ease\n}\n\n.node-hgrid .listing:hover .listing__image img {\n    transform: scale(1.1)\n}\n\n.node-hgrid .listing:hover .listing__link:after {\n    transform: translateX(5px)\n}\n\n.shadow-media {\n    box-shadow: 15px 15px 30px 0 rgba(0, 0, 0, .15);\n    margin-bottom: 40px\n}\n\n.author-box {\n    display: flex;\n    margin-bottom: 16px\n}\n\n.author-box .column {\n    position: relative\n}\n\n.author-box .author-image .drupal-media img {\n    width: 76px;\n    border: 2px solid #f2f6f8;\n    border-radius: 250px;\n    background: #fff 0 0 no-repeat padding-box\n}\n\n.author-box .author-details {\n    margin: auto 24px;\n    max-width: 225px;\n    width: 100%\n}\n\n.author-box .author-details .author-name {\n    margin-bottom: 4px;\n    line-height: 2.8rem\n}\n\n.author-box .author-details .author-description,\n.author-box .author-details .author-organization {\n    line-height: 2.8rem\n}\n\n.author-box .author-details .author-name,\n.author-box .author-details .author-organization {\n    font-weight: 700\n}\n\n.back-to-top {\n    position: absolute;\n    right: 15px;\n    bottom: 15px;\n    color: #41b6e6;\n    padding: 5px 15px;\n    font-size: 1.6rem;\n    font-weight: 600;\n    letter-spacing: 0;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    letter-spacing: .4px;\n    text-indent: -50000px\n}\n\n@media (min-width: 768px) {\n    .back-to-top {\n        padding: 10px 30px;\n        right: 15px;\n        top: 15px;\n        text-indent: 0;\n        height: 50px\n    }\n}\n\n.back-to-top__svg {\n    display: block;\n    margin-left: 10px;\n    width: 38px;\n    height: 38px\n}\n\n@media (min-width: 768px) {\n    .back-to-top__svg {\n        width: 50px;\n        height: 50px\n    }\n}\n\n.badge-list {\n    margin: 13px 0\n}\n\n.badge-list__title {\n    font-size: 2.8rem;\n    font-weight: 700;\n    margin-bottom: 10px\n}\n\n.badge-list__description {\n    font-size: 1.4rem\n}\n\n@media (min-width: 768px) and (max-width:991.98px) {\n    .team-members {\n        margin-left: -40px\n    }\n}\n\n.team-members .badge-list__text-block {\n    color: #041e42;\n    padding-left: 32px\n}\n\n@media (max-width: 767.98px) {\n    .team-members .badge-list__text-block {\n        padding-left: 15px\n    }\n}\n\n.team-members .badge-list__image {\n    margin: 0;\n    padding: 0;\n    display: contents\n}\n\n@media (max-width: 1199.98px) {\n    .team-members .badge-list__image {\n        display: block\n    }\n}\n\n@media (max-width: 767.98px) {\n    .team-members .badge-list__image {\n        flex-basis: auto;\n        text-align: center;\n        padding-top: 40px;\n        padding-bottom: 15px\n    }\n}\n\n.team-members .badge-list__image picture {\n    margin: 0\n}\n\n@media (max-width: 1199.98px) {\n    .team-members .badge-list__image picture {\n        margin: auto;\n        padding-bottom: 10px\n    }\n}\n\n.team-members .badge-list__image picture img {\n    width: 228px\n}\n\n.features {\n    max-width: 300px\n}\n\n.features .badge-list__image {\n    margin: 0;\n    padding-bottom: 30px\n}\n\n.features .badge-list__image.text-align-center .media__image {\n    margin: 0 auto\n}\n\n.features .badge-list__image picture {\n    margin: 0\n}\n\n.features .badge-list__image .media__image {\n    width: 100px\n}\n\n.features .badge-list__image .media__image img {\n    height: 100px\n}\n\n.features .badge-list__title {\n    --text-color: #41B6E6\n}\n\n.features .badge-list__description {\n    --text-color: #8A8D8F\n}\n\n.features .badge-list__title {\n    font-size: 2.2rem;\n    font-weight: 500\n}\n\n.badge-features-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n    max-width: 100%\n}\n\n.badge-features-container>div {\n    flex-grow: 1;\n    flex-basis: 0\n}\n\n.btn__filter,\na.btn__filter {\n    padding: 10px 15px;\n    display: flex;\n    border-radius: 5px;\n    position: absolute;\n    width: 80%;\n    top: 20px;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    color: #000;\n    margin: 0 auto;\n    font-size: 1.5rem;\n    text-align: left;\n    cursor: pointer;\n    line-height: 15px;\n    height: 35px;\n    border: none;\n    margin: 5px;\n    box-shadow: 1px 2px 4px rgba(0, 0, 0, .1607843137);\n    transition: all ease .3s\n}\n\n.btn__filter:focus,\n.btn__filter:hover,\na.btn__filter:focus,\na.btn__filter:hover {\n    background-color: #f2f6f8;\n    color: #041e42;\n    outline: 0\n}\n\n.btn__filter .svg-before,\na.btn__filter .svg-before {\n    width: 18px;\n    margin-right: 15px;\n    display: flex\n}\n\n.btn__filter .svg-before #lineOne,\na.btn__filter .svg-before #lineOne {\n    transform: translate(3px, 3px) rotate(-90deg)\n}\n\n.btn__filter .svg-before #lineTwo,\na.btn__filter .svg-before #lineTwo {\n    transform: translate(3px, 8px) rotate(-90deg)\n}\n\n.btn__filter .svg-before #lineThree,\na.btn__filter .svg-before #lineThree {\n    transform: translate(3px, 13px) rotate(-90deg)\n}\n\n.btn__filter .svg-before #dotOne,\n.btn__filter .svg-before #dotThree,\n.btn__filter .svg-before #dotTwo,\na.btn__filter .svg-before #dotOne,\na.btn__filter .svg-before #dotThree,\na.btn__filter .svg-before #dotTwo {\n    transition: transform .3s ease\n}\n\n.btn__filter .svg-before #dotOne,\n.btn__filter .svg-before #dotThree,\na.btn__filter .svg-before #dotOne,\na.btn__filter .svg-before #dotThree {\n    transform: translateX(-6.5px)\n}\n\n.btn__filter .svg-before #dotTwo,\na.btn__filter .svg-before #dotTwo {\n    transform: translateX(6.5px)\n}\n\n.btn__filter .svg-after,\na.btn__filter .svg-after {\n    width: 14px;\n    display: flex;\n    position: absolute;\n    right: 15px;\n    transition: transform .3s ease;\n    transform: scale(1)\n}\n\n.btn__cross,\na.btn__cross {\n    padding: 10px 50px 10px 25px\n}\n\n.btn__cross:before,\na.btn__cross:before {\n    content: \"\";\n    width: 19px;\n    height: 19px;\n    position: absolute;\n    display: inline-block;\n    border-radius: 25px;\n    background-color: #041e42;\n    right: 15px;\n    top: 9px\n}\n\n.btn__cross:after,\na.btn__cross:after {\n    content: \" \";\n    width: 16px;\n    /* background: url(/src/images/icons/close-button-white.svg); */\n    height: 16px;\n    background-size: 100%;\n    background-repeat: no-repeat;\n    margin-left: 8px;\n    position: absolute;\n    right: 16.5px;\n    top: 10px;\n    transform: translate3d(0, 0, 0);\n    transition: transform ease .2s\n}\n\n.btn__cross:hover:after,\na.btn__cross:hover:after {\n    transform: scale(1.1)\n}\n\n.btn__filter.collapsed:after {\n    opacity: 0\n}\n\n.btn__filter.collapsed .svg-before #dotOne,\n.btn__filter.collapsed .svg-before #dotThree,\n.btn__filter.collapsed .svg-before #dotTwo {\n    transform: translateX(0)\n}\n\n.btn__filter.collapsed .svg-after {\n    transform: scale(0)\n}\n\nlayout__black,\nlayout__blue,\nlayout__dark_grey,\nlayout__light_blue {\n    --link-color: #41B6E6;\n    --link-hover-color: #0077C8\n}\n\n.cta-block {\n    position: relative;\n    right: 0;\n    align-items: center;\n    z-index: 1;\n    transition: .3s ease-in\n}\n\n.cta-block--desktop {\n    display: none\n}\n\n@media (min-width: 1200px) {\n    .cta-block--desktop {\n        display: flex\n    }\n}\n\n.cta-block a {\n    background-color: #041e42;\n    --text-color: #FFFFFF\n}\n\n.cta-block a:hover {\n    background-color: #041e42\n}\n\n.cta-block.block-cta--hidden {\n    transform: translateX(-500px);\n    position: relative;\n    opacity: 0\n}\n\n.cta-block--mobile .d-xl-none {\n    display: none\n}\n\n.cta-description {\n    display: none\n}\n\n.hamburger-menu .cta-block {\n    z-index: 999;\n    width: 100%;\n    margin: 30px 0\n}\n\n.hamburger-menu .cta-block li {\n    align-items: flex-end;\n    display: flex;\n    flex-direction: column\n}\n\n.hamburger-menu .cta-block li a {\n    background-color: #041e42\n}\n\n.hamburger-menu .cta-block.sticky-left .menu-item {\n    justify-content: flex-start\n}\n\n.hamburger-menu .cta-block.sticky-right .menu-item {\n    justify-content: flex-end\n}\n\n.hamburger-menu .cta-block .cta-description {\n    display: block;\n    text-align: left\n}\n\n@media (min-width: 1200px) {\n    .hamburger-menu .cta-block {\n        display: none\n    }\n}\n\n.region--primary-menu .hamburger-menu .menu-level-0>.menu-item {\n    align-items: flex-start\n}\n\n.region--primary-menu .hamburger-menu .menu-level-0>.menu-item>.menu-link.btn {\n    background-color: #041e42;\n    color: #fff\n}\n\n.layout-container>.cta-block {\n    z-index: 999;\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    display: none;\n    padding: 0 15px 15px;\n    background-image: linear-gradient(0deg, #fff, transparent)\n}\n\n@media (max-width: 1199.98px) {\n    .layout-container>.cta-block {\n        display: flex\n    }\n}\n\n.layout-container>.cta-block.sticky-right {\n    justify-content: flex-end\n}\n\n.layout-container>.cta-block.sticky-left {\n    justify-content: flex-start\n}\n\n.pt-form__checkbox {\n    appearance: none;\n    margin-right: 10px;\n    width: 21px;\n    height: 21px;\n    border: 1px solid #616365;\n    border-radius: 3px;\n    background: #fff;\n    transition: background .1s ease\n}\n\n.pt-form__checkbox:hover {\n    /* background: url(/src/images/icons/checkmark-white.svg), #8a8d8f; */\n    background-size: 50%, 100%;\n    background-position: 50%;\n    background-repeat: no-repeat\n}\n\n.pt-form__checkbox:checked {\n    /* background: url(/src/images/icons/checkmark-white.svg), #041e42; */\n    background-size: 50%, 100%;\n    background-position: 50%;\n    background-repeat: no-repeat\n}\n\n.pt-form .align-checkbox-label {\n    margin-left: 31px\n}\n\n.entity-media--cover_fit {\n    height: 100%\n}\n\n.drupal-media--cover-fit {\n    height: 100%\n}\n\n.drupal-media--cover-fit .drupal-media__image {\n    height: 100%\n}\n\n.drupal-media--cover-fit .drupal-media__image picture {\n    height: 100%\n}\n\n.drupal-media--cover-fit .drupal-media__image picture img {\n    object-fit: cover;\n    object-position: center center;\n    display: block;\n    width: 100%;\n    height: 100%;\n    visibility: hidden\n}\n\n.exposed-search {\n    align-items: center;\n    display: flex;\n    height: 26px;\n    position: relative\n}\n\n.exposed-search .form-item label {\n    position: fixed;\n    top: -100px;\n    visibility: hidden;\n    z-index: -1\n}\n\n.exposed-search .form-actions {\n    display: flex;\n    height: 15px;\n    position: absolute;\n    right: 1.65rem;\n    width: 15px\n}\n\n.exposed-search .form-actions input {\n    /* background: transparent url(/src/images/icons/search.svg) no-repeat center center/cover; */\n    border: 0;\n    font-size: 0;\n    height: 15px;\n    margin: 0;\n    padding: 0;\n    width: 15px\n}\n\n.exposed-search .form-text {\n    border: 0;\n    border-radius: 4px;\n    color: #7b7b7b;\n    font-size: 1.2rem;\n    height: 26px;\n    padding: 0 4.65rem 0 1.65rem;\n    width: 289px\n}\n\ndiv,\nh1,\nh2,\nh3,\nh4,\np {\n    color: var(--text-color)\n}\n\nbody {\n    color: var(--text-color);\n    background: 0 0;\n    font-family: var(--secondary-font);\n    font-style: normal\n}\n\n.pt-font--pt-blue-primary {\n    color: #041e42\n}\n\n.pt-font--pt-white-secondary {\n    color: #fff\n}\n\n.pt-font--pt-light-blue-secondary {\n    color: #41b6e6\n}\n\n.pt-font--pt-grey-secondary {\n    color: #8a8d8f\n}\n\n.pt-font--pt-grey {\n    color: #c7cfd7\n}\n\n.pt-font--pt-light-blue-tertiary {\n    color: #0077c8\n}\n\n.pt-font--pt-blue-tertiary {\n    color: #04325e\n}\n\n.pt-font--pt-grey-tertiary {\n    color: #54585a\n}\n\n.pt-font--pt-white-tertiary {\n    color: #f2f6f8\n}\n\n.pt-font--liveline-primary {\n    color: #1791f9\n}\n\n.pt-font--liveline-secondary {\n    color: #4ffafe\n}\n\n.pt-font--wilson-dark-grey {\n    color: #484b4d\n}\n\n.pt-font--pt-green {\n    color: #00a84f\n}\n\n.pt-font--pt-red {\n    color: #e21b23\n}\n\n.pt-font--pt-orange {\n    color: #f05c22\n}\n\n.pt-font--pt-yellow {\n    color: #fcba30\n}\n\n.pt-font--pt-black {\n    color: #000\n}\n\n.pt-font--epic-pink {\n    color: #e0457b\n}\n\n.pt-font--passionate-tangerine {\n    color: #e04f39\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-Thin.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-Thin.woff) format(\"woff\");\n    font-weight: 100;\n    font-style: normal;\n    font-display: swap\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-Light.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-Light.woff) format(\"woff\");\n    font-weight: 200;\n    font-style: normal;\n    font-display: swap\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-LightItalic.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-LightItalic.woff) format(\"woff\");\n    font-weight: 200;\n    font-style: italic;\n    font-display: swap\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-Book.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-Book.woff) format(\"woff\");\n    font-weight: 300;\n    font-style: normal;\n    font-display: swap\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-BookItalic.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-BookItalic.woff) format(\"woff\");\n    font-weight: 300;\n    font-style: italic;\n    font-display: swap\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-Regular.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-Regular.woff) format(\"woff\");\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-Italic.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-Italic.woff) format(\"woff\");\n    font-weight: 400;\n    font-style: italic;\n    font-display: swap\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-Medium.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-Medium.woff) format(\"woff\");\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-Bold.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-Bold.woff) format(\"woff\");\n    font-weight: 700;\n    font-style: normal;\n    font-display: swap\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-Book.woff) format(\"woff\");\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap\n}\n\n@font-face {\n    font-family: Axiforma;\n    src: url(/src/assets/fonts/Axiforma-BlackItalic.woff2) format(\"woff2\"), url(/src/assets/fonts/Axiforma-BlackItalic.woff) format(\"woff\");\n    font-weight: 900;\n    font-style: italic;\n    font-display: swap\n}\n\n\n@media (min-width: 992px) {\n    .collapse.dont-collapse-sm {\n        display: block;\n        height: auto !important;\n        visibility: visible\n    }\n}\n\n.toolbox-footer {\n    position: relative;\n    color: var(--color-dark-blue);\n    display: inline-grid;\n    width: 100%;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    margin: 0 15px\n}\n\n.toolbox-footer .btn__arrow:after {\n    min-width: 10px;\n    width: 10px\n}\n\n.toolbox-footer .contextual-region {\n    position: unset\n}\n\n.toolbox-footer .grid-span {\n    grid-column: span 2\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .grid-span {\n        grid-column: span 3\n    }\n}\n\n.toolbox-footer a {\n    color: var(--color-dark-blue)\n}\n\n.toolbox-footer a:hover {\n    color: var(--color-dark-blue)\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer {\n        display: grid;\n        grid-template-columns: 40% 35% 25%;\n        grid-template-rows: repeat(6, min-content);\n        margin: 0 auto\n    }\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer {\n        margin: 0 50px\n    }\n}\n\n.toolbox-footer .menus {\n    font-size: 1.4rem\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .menus a {\n        position: relative\n    }\n\n    .toolbox-footer .menus a:before {\n        content: \"\";\n        overflow: hidden;\n        position: absolute;\n        height: 2px;\n        background: #da291c;\n        bottom: -2px;\n        width: 0;\n        transition: width .3s ease\n    }\n\n    .toolbox-footer .menus a:hover:before {\n        width: 100%\n    }\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .menus {\n        grid-column: 2;\n        grid-row: 1/span 2;\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        grid-template-rows: repeat(2, 1fr);\n        grid-auto-flow: column;\n        padding-left: 30px;\n        border-left: 1px solid #c7cfd7\n    }\n}\n\n.toolbox-footer .menus ul {\n    padding-left: 0\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .menus .menu-1 li:first-of-type {\n        padding-top: 0\n    }\n}\n\n.toolbox-footer .menus .menu-1 a:not(.font-weight-bold) a,\n.toolbox-footer .menus .menu-2 a:not(.font-weight-bold) a {\n    font-weight: 400\n}\n\n.toolbox-footer .menus .menu-1 li,\n.toolbox-footer .menus .menu-2 li {\n    padding-top: 25px;\n    padding-left: 10px;\n    color: var(--color-dark-blue)\n}\n\n@media (max-width: 991.98px) {\n\n    .toolbox-footer .menus .menu-1 li,\n    .toolbox-footer .menus .menu-2 li {\n        border-bottom: 1px solid #c7cfd7\n    }\n}\n\n.toolbox-footer .menus .menu-2 li:first-of-type {\n    padding-top: 50px\n}\n\n.toolbox-footer .menus .menu-3 {\n    margin-top: 50px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .menus .menu-3 {\n        margin-top: 0\n    }\n}\n\n@media (max-width: 991.98px) {\n\n    .toolbox-footer .menus .menu-3 .menu-collapse li,\n    .toolbox-footer .menus .menu-4 .menu-collapse li {\n        padding-left: 20px\n    }\n}\n\n.toolbox-footer .menus .menu-3 li,\n.toolbox-footer .menus .menu-4 li {\n    padding-left: 10px\n}\n\n.toolbox-footer .menus .menu-3 h4,\n.toolbox-footer .menus .menu-4 h4 {\n    font-weight: 600;\n    margin-bottom: 0;\n    position: relative\n}\n\n@media (max-width: 991.98px) {\n\n    .toolbox-footer .menus .menu-3 h4:before,\n    .toolbox-footer .menus .menu-4 h4:before {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 1px;\n        right: 10px;\n        background: var(--color-dark-blue);\n        top: 50%;\n        transform: rotate(90deg);\n        transition: transform .3s ease\n    }\n\n    .toolbox-footer .menus .menu-3 h4:after,\n    .toolbox-footer .menus .menu-4 h4:after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 1px;\n        right: 10px;\n        top: 50%;\n        background: var(--color-dark-blue)\n    }\n\n    .toolbox-footer .menus .menu-3 h4:not(.collapsed):before,\n    .toolbox-footer .menus .menu-4 h4:not(.collapsed):before {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 1px;\n        right: 10px;\n        background: var(--color-dark-blue);\n        top: 50%;\n        transform: rotate(0)\n    }\n}\n\n.toolbox-footer .menus .menu-3 h4,\n.toolbox-footer .menus .menu-4 h4 {\n    margin-top: 25px;\n    padding-top: 25px;\n    padding-left: 10px;\n    color: var(--color-dark-blue);\n    padding-top: 0\n}\n\n@media (max-width: 991.98px) {\n\n    .toolbox-footer .menus .menu-3 h4,\n    .toolbox-footer .menus .menu-4 h4 {\n        border-bottom: 1px solid #c7cfd7\n    }\n}\n\n@media (min-width: 992px) {\n\n    .toolbox-footer .menus .menu-3 h4,\n    .toolbox-footer .menus .menu-4 h4 {\n        margin-top: 0\n    }\n}\n\n.toolbox-footer__header {\n    display: flex;\n    position: relative;\n    width: 100%;\n    height: 45px;\n    margin-bottom: 35px;\n    justify-content: space-between;\n    box-shadow: 0 5px 5px 1px #d2d2d2\n}\n\n.toolbox-footer__header .back-to-top {\n    position: relative;\n    text-indent: 0;\n    right: unset;\n    top: unset;\n    bottom: unset;\n    padding: 0;\n    margin-right: 15px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer__header .back-to-top {\n        margin-right: 30px\n    }\n}\n\n.toolbox-footer__header .back-to-top h4 {\n    color: #000;\n    margin-left: 5px;\n    margin-bottom: 0\n}\n\n.toolbox-footer__header .back-to-top__svg {\n    display: flex;\n    margin: auto;\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    background: #000;\n    padding: 6px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer__header .back-to-top__svg {\n        width: 30px;\n        height: 30px;\n        display: flex;\n        top: unset\n    }\n}\n\n.toolbox-footer .contact-us {\n    font-size: 1.4rem;\n    padding-right: 10px;\n    padding-left: 10px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .contact-us {\n        padding-left: 0;\n        grid-column: 1\n    }\n}\n\n.toolbox-footer .contact-us .phone {\n    padding: 8px 11.5px;\n    border-radius: 5px;\n    margin-right: 25px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .contact-us .phone {\n        padding-left: 0\n    }\n}\n\n@media (max-width: 991.98px) {\n    .toolbox-footer .contact-us .phone {\n        border: 1px solid #c7cfd7\n    }\n}\n\n.toolbox-footer .contact-us .mail {\n    padding: 7px 11.5px;\n    border-radius: 5px\n}\n\n@media (max-width: 991.98px) {\n    .toolbox-footer .contact-us .mail {\n        border: 1px solid #c7cfd7\n    }\n}\n\n.toolbox-footer ul {\n    list-style: none;\n    color: var(--color-dark-blue)\n}\n\n.toolbox-footer .company {\n    font-size: 1.2rem;\n    color: #616365\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .company {\n        grid-column: 1;\n        grid-row: 1\n    }\n}\n\n.toolbox-footer .company img {\n    width: 33%\n}\n\n.toolbox-footer .brands {\n    justify-items: center;\n    align-items: center;\n    position: relative;\n    padding-left: 10px;\n    margin-top: 50px;\n    margin-bottom: 25px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .brands {\n        grid-column: span 3;\n        width: calc(100% + 100px);\n        display: flex;\n        transform: translateX(-50px);\n        flex-direction: column;\n        align-items: center;\n        padding: 15px 0;\n        box-shadow: 0 0 5px 1px #d2d2d2\n    }\n}\n\n@media (max-width: 991.98px) {\n    .toolbox-footer .brands h4 {\n        border-bottom: 1px solid #c7cfd7\n    }\n}\n\n.toolbox-footer .brands h4 {\n    font-weight: 600;\n    margin-bottom: 0;\n    position: relative\n}\n\n@media (max-width: 991.98px) {\n    .toolbox-footer .brands h4:before {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 1px;\n        right: 10px;\n        background: var(--color-dark-blue);\n        top: 50%;\n        transform: rotate(90deg);\n        transition: transform .3s ease\n    }\n\n    .toolbox-footer .brands h4:after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 1px;\n        right: 10px;\n        top: 50%;\n        background: var(--color-dark-blue)\n    }\n\n    .toolbox-footer .brands h4:not(.collapsed):before {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 1px;\n        right: 10px;\n        background: var(--color-dark-blue);\n        top: 50%;\n        transform: rotate(0)\n    }\n}\n\n.toolbox-footer .brands img {\n    width: 80px\n}\n\n.toolbox-footer .brands ul {\n    display: flex;\n    margin-right: 5px;\n    justify-items: center;\n    align-items: center\n}\n\n@media (max-width: 1199.98px) {\n    .toolbox-footer .brands ul {\n        display: grid;\n        grid-template-columns: repeat(4, 1fr);\n        grid-row-gap: 10px;\n        padding-left: 0\n    }\n}\n\n.toolbox-footer .brands ul li {\n    width: max-content\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .brands ul li {\n        padding: 0 20px\n    }\n}\n\n.toolbox-footer .brands__link.btn__arrow {\n    position: relative;\n    font-weight: 400;\n    font-size: 1.4rem;\n    width: fit-content;\n    grid-column-start: 4;\n    max-width: 80px\n}\n\n.toolbox-footer .brands__link.btn__arrow:after {\n    position: absolute;\n    right: 0\n}\n\n.toolbox-footer .other-brands {\n    margin-bottom: 50px;\n    padding-left: 10px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .other-brands {\n        grid-column: span 3;\n        width: 100vw;\n        display: flex;\n        margin-left: -50vw;\n        position: relative;\n        left: 50%;\n        flex-direction: column;\n        align-items: center;\n        padding: 15px 0\n    }\n}\n\n@media (max-width: 991.98px) {\n    .toolbox-footer .other-brands h4 {\n        border-bottom: 1px solid #c7cfd7\n    }\n}\n\n.toolbox-footer .other-brands h4 {\n    font-weight: 600;\n    margin-bottom: 0;\n    position: relative\n}\n\n@media (max-width: 991.98px) {\n    .toolbox-footer .other-brands h4:before {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 1px;\n        right: 10px;\n        background: var(--color-dark-blue);\n        top: 50%;\n        transform: rotate(90deg);\n        transition: transform .3s ease\n    }\n\n    .toolbox-footer .other-brands h4:after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 1px;\n        right: 10px;\n        top: 50%;\n        background: var(--color-dark-blue)\n    }\n\n    .toolbox-footer .other-brands h4:not(.collapsed):before {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 1px;\n        right: 10px;\n        background: var(--color-dark-blue);\n        top: 50%;\n        transform: rotate(0)\n    }\n}\n\n.toolbox-footer .other-brands ul {\n    padding-left: 10px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .other-brands ul {\n        display: flex;\n        margin-right: 5px\n    }\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .other-brands ul li {\n        padding: 0 30px\n    }\n}\n\n.toolbox-footer .other-brands__link .link-text {\n    font-size: 1.4rem;\n    margin-bottom: 5px;\n    width: fit-content;\n    position: relative\n}\n\n.toolbox-footer .other-brands__link .link-text:after {\n    content: \"\";\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    top: 25%;\n    margin-left: 5px;\n    /* background-image: url(/src/images/icons/icon-external-link.svg) */\n}\n\n.toolbox-footer .menu-collapse {\n    margin-top: 10px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .menu-collapse {\n        display: block\n    }\n}\n\n.toolbox-footer .socials {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px\n}\n\n.toolbox-footer .socials ul {\n    padding-left: 0;\n    display: flex;\n    margin-bottom: 0\n}\n\n.toolbox-footer .socials li {\n    padding-right: 25px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .socials li {\n        padding-right: 20px\n    }\n}\n\n.toolbox-footer .socials .icon {\n    display: block;\n    text-indent: -50000px;\n    width: 20px;\n    background-repeat: no-repeat\n}\n\n/* \n.toolbox-footer .socials .facebook {\n    background-image: url(/src/images/icons/icon-facebook.svg);\n    background-position: 50% 50%\n}\n\n.toolbox-footer .socials .instagram {\n    background-image: url(/src/images/icons/icon-instagram.svg);\n    background-position: 50% 50%\n}\n\n.toolbox-footer .socials .pinterest {\n    background-image: url(/src/images/icons/icon-pinterest.svg);\n    background-position: 50% 50%\n}\n\n.toolbox-footer .socials .youtube {\n    background-image: url(/src/images/icons/icon-youtube.svg);\n    background-position: 50% 50%\n} */\n\n.toolbox-footer .btn__arrow {\n    --color-light-blue: var(--color-dark-blue)\n}\n\n.toolbox-footer .btn__arrow a {\n    font-weight: 500\n}\n\n.toolbox-footer .copyright p {\n    font-size: 1rem;\n    color: #c7cfd7\n}\n\n.toolbox-footer .footer-links {\n    font-size: 1rem;\n    color: #c7cfd7\n}\n\n.toolbox-footer .footer-links ul {\n    display: flex;\n    padding-left: 0\n}\n\n.toolbox-footer .footer-links li a {\n    margin: 0 10px\n}\n\n@media (max-width: 991.98px) {\n    .toolbox-footer .footer-links li a {\n        border-bottom: 1px solid #c7cfd7\n    }\n}\n\n.toolbox-footer .footer-links li a:first-of-type {\n    margin-left: 0\n}\n\n.toolbox-footer .lang-switcher.pt-langswitcher {\n    justify-self: center;\n    margin-bottom: 5px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .lang-switcher.pt-langswitcher {\n        grid-column: 3;\n        grid-row: 2;\n        align-self: baseline;\n        justify-self: end\n    }\n}\n\n.toolbox-footer .newsletters {\n    margin-bottom: 40px;\n    margin-top: 25px\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .newsletters {\n        margin-top: 0;\n        grid-column: 3;\n        grid-row: 1;\n        justify-self: center\n    }\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .copyright {\n        grid-column: 1/span 3;\n        grid-row: 6;\n        justify-self: left;\n        align-self: center\n    }\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .footer-links {\n        grid-column: 1/span 3;\n        grid-row: 6;\n        justify-self: center;\n        align-self: center\n    }\n}\n\n@media (min-width: 992px) {\n    .toolbox-footer .socials {\n        grid-column: 1/span 3;\n        grid-row: 6;\n        justify-self: end;\n        align-self: center\n    }\n}\n\n.pt-footer__logo_secondaire a img {\n    transition: all .3s ease-in-out\n}\n\n.pt-footer__logo_secondaire a img:hover {\n    transform: scale(1.05)\n}\n\n.font-weight-extrabold {\n    font-weight: 700 !important\n}\n\n.font-weight-bold--arrow:after,\n.font-weight-extrabold--arrow:after {\n    /* background-image: url(/src/images/icons/arrow-next-black.svg); */\n    background-repeat: no-repeat;\n    width: 30px;\n    height: 30px;\n    transition: left .2s ease-out;\n    left: 0;\n    position: relative;\n    content: \"\";\n    display: inline-block;\n    background-color: transparent;\n    vertical-align: middle;\n    top: -1px\n}\n\n.font-weight-bold--arrow:after:hover:after,\n.font-weight-extrabold--arrow:after:hover:after {\n    /* background-image: url(/src/images/icons/arrow-next-light-blue-old.svg); */\n    left: 3px\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .ui-dialog-titlebar {\n    background: 0 0;\n    border: none;\n    height: 45px\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .ui-widget-content {\n    border: none;\n    background-color: #fff\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .ui-widget.ui-widget-content {\n    border: none\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .ui-dialog-title {\n    display: none\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .ui-front .ui-dialog-content {\n    background-color: #fff\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .ui-dialog-buttonpane {\n    background-color: #fff;\n    height: 9.6rem;\n    text-align: left;\n    border-width: 1px 0 0 0;\n    background-image: none;\n    margin-top: 0;\n    padding: .3em 1em .5em .4em\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .ui-icon-closethick {\n    display: none\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .ui-button.ui-corner-all.ui-widget.ui-button-icon-only.ui-dialog-titlebar-close {\n    position: absolute;\n    /* background: url(/src/images/icons/close-button-light.svg) no-repeat; */\n    background-position: center center;\n    background-size: contain;\n    width: 3.52rem;\n    height: 3.52rem;\n    text-indent: -9999px;\n    top: 0;\n    right: 7px;\n    border: none\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .ui-button.ui-corner-all.ui-widget.ui-button-icon-only.ui-dialog-titlebar-close:hover {\n    /* background: url(/src/images/icons/close-button-dark.svg) no-repeat; */\n    background-position: center center;\n    background-size: contain\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .download-button {\n    position: relative;\n    left: 50%;\n    transform: translate(-50%);\n    margin-top: 6.4rem;\n    margin-bottom: 2.4rem\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .js-webform-confirmation-back-link-ajax {\n    color: #041e42 !important;\n    font-weight: 700\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .webform-button--submit {\n    cursor: pointer;\n    background-color: #41b6e6\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .webform-button--submit:hover {\n    background-color: #41b6e6 !important;\n    font-weight: 700 !important\n}\n\n@media screen and (max-width: 767.98px) and (orientation:portrait) {\n    .ui-dialog[aria-describedby=drupal-modal] .ui-dialog-buttonpane .ui-dialog-buttonset+.form-actions {\n        float: left\n    }\n\n    .ui-dialog[aria-describedby=drupal-modal] .ui-dialog.ui-widget-content.ui-front {\n        max-width: 95vw\n    }\n}\n\n@media screen and (max-width: 767.98px) and (orientation:landscape) {\n    .ui-dialog[aria-describedby=drupal-modal] .ui-dialog-buttonpane .ui-dialog-buttonset+.form-actions {\n        float: left\n    }\n\n    .ui-dialog[aria-describedby=drupal-modal] .ui-dialog.ui-widget-content.ui-front {\n        max-width: 75vw;\n        left: 12.5vw\n    }\n}\n\n.ui-dialog[aria-describedby=drupal-modal] .webform-confirmation__back {\n    display: none\n}\n\n.ui-dialog[aria-describedby=drupal-modal].ui-widget-content.ui-front {\n    background-color: transparent;\n    max-width: 750px;\n    border: 0\n}\n\n@media screen and (max-width: 767.98px) and (orientation:portrait) {\n    .ui-dialog[aria-describedby=drupal-modal].ui-widget-content.ui-front {\n        max-width: 95vw\n    }\n}\n\n@media screen and (max-width: 767.98px) and (orientation:landscape) {\n    .ui-dialog[aria-describedby=drupal-modal].ui-widget-content.ui-front {\n        max-width: 70vw;\n        left: 15vw\n    }\n}\n\n.ui-widget-overlay {\n    background-color: rgba(4, 30, 66, .95)\n}\n\n@media (max-width: 767.98px) {\n    .ui-dialog.ui-widget-content.ui-front {\n        max-width: 100% !important\n    }\n}\n\n.ajax-spinner--fullscreen {\n    z-index: 9999;\n    background-color: rgba(255, 255, 255, .7);\n    height: 100vh;\n    width: 100%;\n    position: fixed;\n    top: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center\n}\n\n.ajax-progress-throbber .throbber {\n    display: none;\n    padding: 0;\n    background: transparent no-repeat 0 center\n}\n\n@keyframes waiting_spinner {\n    from {\n        transform: rotate(0)\n    }\n\n    to {\n        transform: rotate(359deg)\n    }\n}\n\n.header-bar {\n    align-items: center;\n    background-color: #f2f6f8;\n    border-bottom: 1px solid #c7cfd7;\n    display: none;\n    height: 36px;\n    left: 0;\n    padding-left: 5px;\n    padding-right: 5rem;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 1400;\n    transition: top .16s ease\n}\n\n@media (min-width: 1200px) {\n    .header-bar {\n        display: flex\n    }\n}\n\n@media (min-width: 1200px) {\n    .header-bar {\n        z-index: 200\n    }\n}\n\n.header-bar--hidden {\n    top: -36px\n}\n\n.header-bar .marketlanguageswitcher__selector {\n    align-items: center;\n    color: #4a5b72;\n    display: flex;\n    font-size: 1.2rem;\n    height: auto;\n    margin: 0;\n    padding: 0;\n    width: auto\n}\n\n.header-bar .marketlanguageswitcher__selector:hover {\n    font-weight: 400\n}\n\n.header-bar .marketlanguageswitcher__selector:hover::after {\n    transform: rotate(0)\n}\n\n.header-bar .marketlanguageswitcher__selector::before {\n    background-size: cover;\n    height: 15px;\n    top: 0;\n    width: 15px\n}\n\n.header-bar .marketlanguageswitcher__selector::after {\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 4px;\n    margin: 0 0 0 10px;\n    width: 9px\n}\n\n.header-bar__right {\n    align-items: center;\n    display: flex;\n    flex-grow: 1;\n    justify-content: flex-end\n}\n\n.header-bar .views-exposed-form {\n    margin-left: 2.9rem\n}\n\n.toolbar-horizontal.toolbar-tray-open .header-bar {\n    top: 79px\n}\n\n.toolbar-horizontal.toolbar-tray-open .header-bar--hidden {\n    top: -36px\n}\n\n.highlighted {\n    position: absolute;\n    top: 170px;\n    right: 50%;\n    width: 75%;\n    z-index: 500;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    transform: translateX(50%);\n    max-width: 900px\n}\n\n@media (min-width: 1200px) {\n    .highlighted {\n        width: 50%\n    }\n}\n\n.pt-langswitcher :focus-visible {\n    outline: 0\n}\n\n.pt-langswitcher:focus-visible {\n    outline: 0;\n    box-shadow: inset 0 0 0 1px #000;\n    border-radius: 6px\n}\n\n.pt-langswitcher .dropdown-container {\n    position: relative;\n    display: inline-flex;\n    flex-direction: row;\n    align-items: center;\n    border-radius: 5px;\n    margin-bottom: 1px\n}\n\n.pt-langswitcher .dropdown-container:hover {\n    background-color: #fff\n}\n\n.pt-langswitcher .dropdown-container:hover .dropdown-container__veil {\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 8%, #fff 50%)\n}\n\n.pt-langswitcher .dropdown-container p {\n    display: none\n}\n\n.pt-langswitcher .dropdown-container .language-switcher-language-url,\n.pt-langswitcher .dropdown-container .links {\n    border: none;\n    background: 0 0;\n    padding: 9px 30px;\n    position: relative;\n    max-width: 150px;\n    font-size: 1.2rem;\n    color: #4a5b72;\n    appearance: none\n}\n\n.pt-langswitcher .dropdown-container__veil {\n    height: calc(100% - 18px);\n    width: 30%;\n    background: linear-gradient(90deg, rgba(242, 246, 248, 0) 8%, #f2f6f8 50%);\n    position: absolute;\n    right: 1px;\n    pointer-events: none\n}\n\n.pt-langswitcher .dropdown-container__arrow,\n.pt-langswitcher .dropdown-container__earth {\n    position: absolute;\n    display: flex;\n    pointer-events: none\n}\n\n.pt-langswitcher .dropdown-container__arrow::before,\n.pt-langswitcher .dropdown-container__earth::before {\n    background-position: center center;\n    background-repeat: no-repeat;\n    content: \"\";\n    display: inline-block\n}\n\n.pt-langswitcher .dropdown-container__earth {\n    display: flex;\n    left: 10px\n}\n\n.pt-langswitcher .dropdown-container__earth::before {\n    background-image: url(/src/images/icons/earth-grid.svg);\n    width: 12px;\n    height: 12px;\n    background-size: cover\n}\n\n.pt-langswitcher .dropdown-container__arrow {\n    display: flex;\n    right: 10px\n}\n\n.pt-langswitcher .dropdown-container__arrow::before {\n    background-image: url(/src/images/icons/chevron-down.svg);\n    background-size: contain;\n    height: 4px;\n    width: 9px\n}\n\n.pt-langswitcher--inverted .dropdown-container .language-switcher-language-url,\n.pt-langswitcher--inverted .dropdown-container .links {\n    color: #fff\n}\n\n.pt-langswitcher--inverted .dropdown-container .language-switcher-language-url option,\n.pt-langswitcher--inverted .dropdown-container .links option {\n    background: #04325e\n}\n\n.pt-langswitcher--inverted .dropdown-container:hover {\n    background-color: #04325e\n}\n\n.pt-langswitcher--inverted .dropdown-container:hover .dropdown-container__veil {\n    background: linear-gradient(90deg, rgba(4, 53, 46, 0) 8%, #04325e 50%)\n}\n\n.pt-langswitcher--inverted .dropdown-container__veil {\n    background: linear-gradient(90deg, rgba(4, 30, 66, 0) 8%, #041e42 50%)\n}\n\n/* \n.pt-langswitcher--inverted .dropdown-container__earth::before {\n    background-image: url(/src/images/icons/earth-grid-white.svg)\n}\n\n.pt-langswitcher--inverted .dropdown-container__arrow::before {\n    background-image: url(/src/images/icons/chevron-down-white.svg)\n} */\n\n@media (max-width: 1199.98px) {\n    #block-ptbase-child-main-menu .pt-langswitcher {\n        width: 100%;\n        transition: .3s ease-in\n    }\n\n    #block-ptbase-child-main-menu .pt-langswitcher.lang-switcher--hidden {\n        transform: translateX(-200px)\n    }\n}\n\n.region--hamburger-menu-wilson .pt-langswitcher,\nfooter .pt-langswitcher {\n    display: inline-flex;\n    align-items: center;\n    position: relative\n}\n\n.region--hamburger-menu-wilson .pt-langswitcher .dropdown-container .language-switcher-language-url,\n.region--hamburger-menu-wilson .pt-langswitcher .dropdown-container .links,\nfooter .pt-langswitcher .dropdown-container .language-switcher-language-url,\nfooter .pt-langswitcher .dropdown-container .links {\n    font-size: 1.6rem;\n    padding: 9px 30px 9px 45px;\n    max-width: 185px\n}\n\n.region--hamburger-menu-wilson .pt-langswitcher .dropdown-container__earth:before,\nfooter .pt-langswitcher .dropdown-container__earth:before {\n    height: 24px;\n    width: 24px\n}\n\n.region--hamburger-menu-wilson .pt-langswitcher .dropdown-container__arrow:before,\nfooter .pt-langswitcher .dropdown-container__arrow:before {\n    height: 8px;\n    width: 13px\n}\n\n.hamburger-menu .pt-langswitcher {\n    display: none;\n    padding: 30px 5px\n}\n\n.hamburger-menu .pt-langswitcher .dropdown-container__veil {\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 8%, #fff 50%)\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu .pt-langswitcher {\n        display: flex\n    }\n}\n\n.in_layout_builder .banner,\n.simplelogin-bg .banner {\n    display: none\n}\n\n.region--content {\n    position: relative\n}\n\n.region--content .banner {\n    position: absolute;\n    width: 100%;\n    z-index: 99;\n    background-color: rgba(255, 255, 255, .95)\n}\n\n.region--content .banner .container {\n    margin: 0;\n    max-width: 100%\n}\n\n.language-redirection-banner {\n    position: relative;\n    align-items: flex-end;\n    display: none;\n    max-width: none;\n    border-bottom: 1px solid rgba(138, 141, 143, .4);\n    border-top: solid 1.5px #c7cfd7;\n    padding: 15px;\n    --color-light-blue: #41B6E6\n}\n\n@media (max-width: 991.98px) {\n    .language-redirection-banner {\n        align-items: flex-start\n    }\n}\n\n@media (max-width: 991.98px) {\n    .language-redirection-banner {\n        flex-direction: column\n    }\n}\n\n@media (min-width: 1200px) {\n    .language-redirection-banner .language-redirection-banner-inner :not(:last-child) {\n        margin-right: 25px\n    }\n}\n\n.language-redirection-banner .text {\n    margin: 0 0 10px 35px;\n    color: #041e42;\n    font-size: 1.4rem\n}\n\n@media (max-width: 991.98px) {\n    .language-redirection-banner .text {\n        margin: 0\n    }\n}\n\n.language-redirection-banner .text .welcome-text {\n    display: flex;\n    margin-bottom: 5px;\n    font-size: 1.8rem;\n    font-weight: 700\n}\n\n@media (max-width: 991.98px) {\n    .language-redirection-banner .text .welcome-text {\n        flex-direction: column\n    }\n}\n\n.language-redirection-banner .text .block-body {\n    margin-bottom: 0\n}\n\n.language-redirection-banner .marketlanguageswitcher__selector,\n.language-redirection-banner select {\n    color: #041e42;\n    background-color: #f2f6f8;\n    border: none;\n    width: 100%;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    font-size: 1.8rem;\n    padding: 0 40px 0 13px\n}\n\n.language-redirection-banner .sel-language-redirection,\n.language-redirection-banner select {\n    background-image: url(/src/images/icons/chevron-down.svg);\n    background-repeat: no-repeat;\n    background-position: calc(100% - 20px);\n    background-size: 16px;\n    height: 40px;\n    cursor: pointer;\n    white-space: nowrap;\n    overflow: hidden\n}\n\n.language-redirection-banner .sel-language-redirection option.selected,\n.language-redirection-banner select option.selected {\n    font-weight: 700\n}\n\n.language-redirection-banner .sel-language-redirection:after,\n.language-redirection-banner select:after {\n    content: \"\";\n    position: absolute;\n    width: 75px;\n    height: 40px;\n    background: url(/src/images/icons/chevron-down.svg), linear-gradient(90deg, rgba(255, 255, 255, 0) 0, #f2f6f8 50%);\n    right: 0;\n    top: 0;\n    background-position: calc(100% - 20px), right;\n    background-repeat: no-repeat;\n    background-size: 16px, 100%;\n    border-radius: inherit\n}\n\n.language-redirection-banner .language-switcher,\n.language-redirection-banner .marketlanguageswitcher {\n    display: flex;\n    position: relative;\n    border-radius: 4px;\n    width: 100%;\n    max-width: 325px;\n    margin: 0 10px;\n    box-shadow: 0 0 0 1px #b3bbbf;\n    transition: .3s\n}\n\n.language-redirection-banner .language-switcher:hover,\n.language-redirection-banner .marketlanguageswitcher:hover {\n    box-shadow: 0 0 0 3px #41b6e6\n}\n\n@media (max-width: 991.98px) {\n\n    .language-redirection-banner .language-switcher,\n    .language-redirection-banner .marketlanguageswitcher {\n        max-width: 100%;\n        margin: 10px 0\n    }\n}\n\n.language-redirection-banner .language-switcher .sel-language-redirection,\n.language-redirection-banner .marketlanguageswitcher .sel-language-redirection {\n    border-radius: inherit\n}\n\n@media (max-width: 991.98px) {\n    .language-redirection-banner .btn-language-redirection {\n        align-self: flex-end\n    }\n}\n\n.language-redirection-banner .btn-close {\n    justify-content: flex-end;\n    margin-left: auto;\n    padding-right: 20px;\n    position: absolute;\n    top: 0;\n    right: 0\n}\n\n.language-redirection-banner .btn-close-banner {\n    color: #8a8d8f;\n    font-size: 1.6rem;\n    font-weight: 700;\n    text-decoration: none;\n    position: absolute;\n    right: 15px;\n    top: 10px\n}\n\n.language-redirection-banner .btn-close-banner svg {\n    fill: #041e42;\n    width: 13px;\n    height: 13px\n}\n\n.layout-container {\n    position: relative;\n    overflow-x: hidden\n}\n\n@media (max-width: 767.98px) {\n    .layout-container {\n        overflow-y: hidden\n    }\n}\n\nimg {\n    -ms-interpolation-mode: bicubic;\n    height: auto\n}\n\nhtml {\n    scroll-behavior: smooth;\n    scroll-padding-top: 70px\n}\n\nbody {\n    font-size: 1.8rem\n}\n\ndiv[data-drupal-messages] {\n    width: 100%\n}\n\n.site-width {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 1300px\n}\n\n.layout {\n    position: relative;\n    background: var(--bg-color)\n}\n\n.layout__background {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    object-fit: cover;\n    object-position: top left;\n    z-index: 0\n}\n\n.layout__gradient {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 0\n}\n\n.layout__actually_transparent {\n    background-color: transparent;\n    box-shadow: none\n}\n\n.background-image-valign--center .layout__background {\n    object-position: center left\n}\n\n.background-image-valign--bottom .layout__background {\n    object-position: bottom left\n}\n\n@media (max-width: 991.98px) {\n    .background-image-mobile-valign--center .layout__background {\n        object-position: center left\n    }\n\n    .background-image-mobile-valign--bottom .layout__background {\n        object-position: bottom left\n    }\n}\n\n@media (max-width: 767.98px) {\n    .layout__grey--nomobile {\n        --bg-color: #FFFFFF\n    }\n}\n\n.layout__banner {\n    padding: 50px calc(50px - 1.6rem)\n}\n\n@media (max-width: 767.98px) {\n    .layout__banner {\n        padding: 40px calc(40px - 1.6rem)\n    }\n}\n\n@media (min-width: 1200px) {\n    .custom-5-col {\n        flex: 0 0 20%;\n        max-width: 20%\n    }\n}\n\n.pt-grid-layout {\n    display: grid\n}\n\n.pt-grid-layout--1-col {\n    grid-template-columns: 1fr\n}\n\n.pt-grid-layout--2-col {\n    grid-template-columns: repeat(2, 1fr)\n}\n\n.pt-grid-layout--3-col {\n    grid-template-columns: repeat(3, 1fr)\n}\n\n.pt-grid-layout--4-col {\n    grid-template-columns: repeat(4, 1fr)\n}\n\n.pt-grid-layout--5-col {\n    grid-template-columns: repeat(5, 1fr)\n}\n\n.pt-grid-layout--6-col {\n    grid-template-columns: repeat(6, 1fr)\n}\n\n@media (min-width: 576px) and (max-width:991.98px) {\n    .pt-grid-layout.grid-tablet--1 {\n        grid-template-columns: 1fr\n    }\n\n    .pt-grid-layout.grid-tablet--2 {\n        grid-template-columns: repeat(2, 1fr)\n    }\n\n    .pt-grid-layout.grid-tablet--3 {\n        grid-template-columns: repeat(3, 1fr)\n    }\n\n    .pt-grid-layout.grid-tablet--4 {\n        grid-template-columns: repeat(4, 1fr)\n    }\n}\n\n@media (max-width: 575.98px) {\n    .pt-grid-layout.grid-mobile--1 {\n        grid-template-columns: 1fr\n    }\n\n    .pt-grid-layout.grid-mobile--2 {\n        grid-template-columns: repeat(2, 1fr)\n    }\n\n    .pt-grid-layout.grid-mobile--3 {\n        grid-template-columns: repeat(3, 1fr)\n    }\n}\n\n.pt-grid-layout.grid-justify-items-start {\n    justify-items: flex-start\n}\n\n.pt-grid-layout.grid-justify-items-center {\n    justify-items: center\n}\n\n.pt-grid-layout.grid-justify-items-end {\n    justify-items: flex-end\n}\n\n.pt-grid-layout.grid-justify-items-stretch {\n    justify-items: stretch\n}\n\n.pt-grid-layout.grid-align-items-start {\n    align-items: flex-start\n}\n\n.pt-grid-layout.grid-align-items-center {\n    align-items: center\n}\n\n.pt-grid-layout.grid-align-items-end {\n    align-items: flex-end\n}\n\n.pt-grid-layout.grid-align-items-stretch {\n    align-items: stretch\n}\n\n.pt-grid-layout.grid-hgap--xs {\n    column-gap: 1rem\n}\n\n.pt-grid-layout.grid-hgap--sm {\n    column-gap: 2rem\n}\n\n.pt-grid-layout.grid-hgap--md {\n    column-gap: 3rem\n}\n\n.pt-grid-layout.grid-hgap--lg {\n    column-gap: 4rem\n}\n\n.pt-grid-layout.grid-vgap--xs {\n    row-gap: 1rem\n}\n\n.pt-grid-layout.grid-vgap--sm {\n    row-gap: 2rem\n}\n\n.pt-grid-layout.grid-vgap--md {\n    row-gap: 3rem\n}\n\n.pt-grid-layout.grid-vgap--lg {\n    row-gap: 4rem\n}\n\n.pt-grid-layout.grid-equal-height {\n    grid-auto-rows: 1fr\n}\n\n.pt-grid-layout.grid-equal-height.grid-align-items-start {\n    align-items: unset\n}\n\n.pt-grid-layout.grid-row-equal-height {\n    grid-auto-rows: auto\n}\n\n.pt-grid-layout.grid-row-equal-height.grid-align-items-start {\n    align-items: unset\n}\n\n@media (min-width: 768px) {\n\n    .col-xl-fit-content,\n    .col-xl-flex-fill {\n        width: auto\n    }\n\n    .col-xl-fit-content {\n        flex: 0 0 auto\n    }\n\n    .col-xl-flex-fill {\n        flex: 1 1 min-content\n    }\n}\n\n@media (min-width: 576px) and (max-width:991.98px) {\n\n    .col-sm-fit-content,\n    .col-sm-flex-fill {\n        width: auto\n    }\n\n    .col-sm-fit-content {\n        flex: 0 0 auto\n    }\n\n    .col-sm-flex-fill {\n        flex: 1 1 min-content\n    }\n}\n\n.layout-builder-configure-block div[role=alert] {\n    color: red !important\n}\n\n.layout-builder-configure-block div[role=alert] li {\n    color: red !important\n}\n\ndetails {\n    font-size: 1.2rem\n}\n\n.layout-builder-block {\n    padding: 0;\n    background: 0 0\n}\n\n.layout-builder__region {\n    outline: 1px dashed #2f91da\n}\n\n.layout-builder__region:first-child {\n    margin-left: 0\n}\n\n.layout-builder__add-section {\n    margin-bottom: .5em;\n    padding: 1.2em;\n    outline: 1px dashed #979797\n}\n\n.layout-builder__add-block {\n    padding: .8em\n}\n\n.layout-builder {\n    background: 0 0;\n    padding: 0;\n    border: none\n}\n\n.layout-builder__link--remove {\n    margin-left: 5px;\n    margin-top: 5px\n}\n\n.layout-builder__section {\n    margin-bottom: .5em;\n    outline: 1px dashed #979797\n}\n\n.layout-builder-form {\n    padding-left: 15px;\n    padding-right: 15px\n}\n\n.region--hamburger-menu>nav .menu-item:focus,\n.region--hamburger-menu>nav a:focus,\n.region--primary-menu>nav .menu-item:focus,\n.region--primary-menu>nav a:focus {\n    outline: 0\n}\n\n.region--hamburger-menu>nav .menu-item:focus-visible,\n.region--hamburger-menu>nav a:focus-visible,\n.region--primary-menu>nav .menu-item:focus-visible,\n.region--primary-menu>nav a:focus-visible {\n    box-shadow: inset 0 0 0 1px #041e42;\n    outline: 0\n}\n\n.region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0,\n.region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0 {\n    justify-content: center\n}\n\n.region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child,\n.region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child {\n    padding: 0\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child,\n    .region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child {\n        margin-right: unset;\n        padding: 0 1.5rem\n    }\n}\n\n.region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    font-size: 1.6rem !important\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n        font-size: 1.4rem !important\n    }\n}\n\n.region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    content: \"\"\n}\n\n.region--hamburger-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover,\n.region--primary-menu>nav>ul.menu--layout-navigation.menu-level-0>.menu-item:first-child .menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover {\n    color: #f2f6f8\n}\n\n.region--hamburger-menu>nav .layout .container-fluid,\n.region--hamburger-menu>nav .layout .container-lg,\n.region--hamburger-menu>nav .layout .container-md,\n.region--hamburger-menu>nav .layout .container-sm,\n.region--hamburger-menu>nav .layout .container-xl,\n.region--primary-menu>nav .layout .container-fluid,\n.region--primary-menu>nav .layout .container-lg,\n.region--primary-menu>nav .layout .container-md,\n.region--primary-menu>nav .layout .container-sm,\n.region--primary-menu>nav .layout .container-xl {\n    padding-right: 0\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid,\n    .region--hamburger-menu>nav .layout .container-lg,\n    .region--hamburger-menu>nav .layout .container-md,\n    .region--hamburger-menu>nav .layout .container-sm,\n    .region--hamburger-menu>nav .layout .container-xl,\n    .region--primary-menu>nav .layout .container-fluid,\n    .region--primary-menu>nav .layout .container-lg,\n    .region--primary-menu>nav .layout .container-md,\n    .region--primary-menu>nav .layout .container-sm,\n    .region--primary-menu>nav .layout .container-xl {\n        padding-left: 0\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region h2,\n.region--hamburger-menu>nav .layout .container-lg .layout__region h2,\n.region--hamburger-menu>nav .layout .container-md .layout__region h2,\n.region--hamburger-menu>nav .layout .container-sm .layout__region h2,\n.region--hamburger-menu>nav .layout .container-xl .layout__region h2,\n.region--primary-menu>nav .layout .container-fluid .layout__region h2,\n.region--primary-menu>nav .layout .container-lg .layout__region h2,\n.region--primary-menu>nav .layout .container-md .layout__region h2,\n.region--primary-menu>nav .layout .container-sm .layout__region h2,\n.region--primary-menu>nav .layout .container-xl .layout__region h2 {\n    font-size: 1.4rem;\n    line-height: 1.2em;\n    font-weight: 400;\n    color: #54585a;\n    margin-left: 30px\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region h2,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region h2,\n    .region--hamburger-menu>nav .layout .container-md .layout__region h2,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region h2,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region h2,\n    .region--primary-menu>nav .layout .container-fluid .layout__region h2,\n    .region--primary-menu>nav .layout .container-lg .layout__region h2,\n    .region--primary-menu>nav .layout .container-md .layout__region h2,\n    .region--primary-menu>nav .layout .container-sm .layout__region h2,\n    .region--primary-menu>nav .layout .container-xl .layout__region h2 {\n        margin-left: 0\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region nav,\n.region--hamburger-menu>nav .layout .container-lg .layout__region nav,\n.region--hamburger-menu>nav .layout .container-md .layout__region nav,\n.region--hamburger-menu>nav .layout .container-sm .layout__region nav,\n.region--hamburger-menu>nav .layout .container-xl .layout__region nav,\n.region--primary-menu>nav .layout .container-fluid .layout__region nav,\n.region--primary-menu>nav .layout .container-lg .layout__region nav,\n.region--primary-menu>nav .layout .container-md .layout__region nav,\n.region--primary-menu>nav .layout .container-sm .layout__region nav,\n.region--primary-menu>nav .layout .container-xl .layout__region nav {\n    padding-bottom: 60px;\n    margin-left: 30px\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region nav,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region nav,\n    .region--hamburger-menu>nav .layout .container-md .layout__region nav,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region nav,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region nav,\n    .region--primary-menu>nav .layout .container-fluid .layout__region nav,\n    .region--primary-menu>nav .layout .container-lg .layout__region nav,\n    .region--primary-menu>nav .layout .container-md .layout__region nav,\n    .region--primary-menu>nav .layout .container-sm .layout__region nav,\n    .region--primary-menu>nav .layout .container-xl .layout__region nav {\n        padding-bottom: 0;\n        margin-left: 0\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0,\n.region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0,\n.region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0,\n.region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0,\n.region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0,\n.region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0,\n.region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0,\n.region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0,\n.region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0,\n.region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 {\n    display: block;\n    border-top: 1px solid #c7cfd7;\n    background-color: unset;\n    padding-top: 0;\n    vertical-align: top\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n.region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n.region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n.region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n.region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n.region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n.region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n.region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n.region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n.region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child) {\n    padding-top: 0;\n    border-top: none\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0,\n    .region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0,\n    .region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0,\n    .region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0,\n    .region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0,\n    .region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0,\n    .region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 {\n        display: inline-block;\n        padding-top: 15px\n    }\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n    .region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n    .region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n    .region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n    .region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n    .region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n    .region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n    .region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n    .region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child),\n    .region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0:not(:first-child) {\n        border-top: 1px solid #c7cfd7;\n        margin-left: -5px;\n        padding-left: 25%;\n        padding-top: 15px\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n.region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n.region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n.region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n.region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n.region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n.region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n.region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n.region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n.region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item {\n    display: block;\n    max-width: 100%;\n    margin-right: unset\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n    .region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n    .region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n    .region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n    .region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n    .region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item,\n    .region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item {\n        padding: 0 1.5rem\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    font-family: canada-type-gibson, sans-serif;\n    display: inline-block;\n    font-size: 1.5rem;\n    line-height: 1.2em;\n    font-weight: 500;\n    color: #000;\n    padding: 10px 15px\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n        line-height: 30px;\n        padding: 0\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.region--hamburger-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.region--hamburger-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.region--hamburger-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.region--hamburger-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.region--primary-menu>nav .layout .container-fluid .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.region--primary-menu>nav .layout .container-lg .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.region--primary-menu>nav .layout .container-md .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.region--primary-menu>nav .layout .container-sm .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.region--primary-menu>nav .layout .container-xl .layout__region nav ul.menu--layout-navigation.menu-level-0 li.menu-item a.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    content: \"\"\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region a,\n.region--hamburger-menu>nav .layout .container-lg .layout__region a,\n.region--hamburger-menu>nav .layout .container-md .layout__region a,\n.region--hamburger-menu>nav .layout .container-sm .layout__region a,\n.region--hamburger-menu>nav .layout .container-xl .layout__region a,\n.region--primary-menu>nav .layout .container-fluid .layout__region a,\n.region--primary-menu>nav .layout .container-lg .layout__region a,\n.region--primary-menu>nav .layout .container-md .layout__region a,\n.region--primary-menu>nav .layout .container-sm .layout__region a,\n.region--primary-menu>nav .layout .container-xl .layout__region a {\n    color: #000\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid,\n.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid,\n.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid,\n.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid,\n.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid,\n.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid,\n.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid,\n.region--primary-menu>nav .layout .container-md .layout__region .pt-grid,\n.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid,\n.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid {\n    border-top: 1px solid #c7cfd7;\n    padding-top: 15px;\n    margin-left: 30px !important\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid,\n    .region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid,\n    .region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid,\n    .region--primary-menu>nav .layout .container-lg .layout__region .pt-grid,\n    .region--primary-menu>nav .layout .container-md .layout__region .pt-grid,\n    .region--primary-menu>nav .layout .container-sm .layout__region .pt-grid,\n    .region--primary-menu>nav .layout .container-xl .layout__region .pt-grid {\n        margin-left: 0 !important\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12,\n.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12,\n.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12,\n.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12,\n.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12,\n.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12,\n.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12,\n.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12,\n.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12,\n.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 {\n    padding: 0 !important\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12:first-child,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12:first-child,\n    .region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12:first-child,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12:first-child,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12:first-child,\n    .region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12:first-child,\n    .region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12:first-child,\n    .region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12:first-child,\n    .region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12:first-child,\n    .region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12:first-child {\n        margin-left: -15px\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid,\n.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid,\n.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid,\n.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid,\n.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid,\n.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid,\n.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid,\n.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid,\n.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid,\n.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid {\n    margin-bottom: 0;\n    display: flex;\n    flex-direction: row;\n    padding-top: 0 !important;\n    padding-left: 0 !important\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid,\n    .region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid,\n    .region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid,\n    .region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid,\n    .region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid,\n    .region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid,\n    .region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid {\n        display: inline-flex;\n        flex-direction: column;\n        padding-top: 1.6rem !important;\n        padding-left: 1.6rem !important\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container {\n    flex: 0 0 33.3333%\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n    .region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n    .region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n    .region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n    .region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n    .region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container,\n    .region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container {\n        width: auto;\n        flex: unset\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,\n.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,\n.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,\n.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,\n.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,\n.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,\n.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,\n.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,\n.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img,\n.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container img {\n    border-radius: 5px\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,\n.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,\n.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,\n.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,\n.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,\n.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,\n.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,\n.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,\n.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil,\n.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__main-container .node-grid__veil {\n    background-color: transparent\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n.region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n.region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n.region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n.region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n.region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n.region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n.region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n.region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n.region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__title {\n    font-size: 1.5rem;\n    line-height: 1.2em;\n    color: #000;\n    font-weight: 400;\n    text-align: left;\n    padding-left: 10px\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n    .region--hamburger-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n    .region--primary-menu>nav .layout .container-fluid .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n    .region--primary-menu>nav .layout .container-lg .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n    .region--primary-menu>nav .layout .container-md .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n    .region--primary-menu>nav .layout .container-sm .layout__region .pt-grid .col-12 .node-grid .node-grid__title,\n    .region--primary-menu>nav .layout .container-xl .layout__region .pt-grid .col-12 .node-grid .node-grid__title {\n        padding-left: 0\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region .block__text,\n.region--hamburger-menu>nav .layout .container-lg .layout__region .block__text,\n.region--hamburger-menu>nav .layout .container-md .layout__region .block__text,\n.region--hamburger-menu>nav .layout .container-sm .layout__region .block__text,\n.region--hamburger-menu>nav .layout .container-xl .layout__region .block__text,\n.region--primary-menu>nav .layout .container-fluid .layout__region .block__text,\n.region--primary-menu>nav .layout .container-lg .layout__region .block__text,\n.region--primary-menu>nav .layout .container-md .layout__region .block__text,\n.region--primary-menu>nav .layout .container-sm .layout__region .block__text,\n.region--primary-menu>nav .layout .container-xl .layout__region .block__text {\n    margin-left: 30px !important\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region .block__text,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region .block__text,\n    .region--hamburger-menu>nav .layout .container-md .layout__region .block__text,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region .block__text,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region .block__text,\n    .region--primary-menu>nav .layout .container-fluid .layout__region .block__text,\n    .region--primary-menu>nav .layout .container-lg .layout__region .block__text,\n    .region--primary-menu>nav .layout .container-md .layout__region .block__text,\n    .region--primary-menu>nav .layout .container-sm .layout__region .block__text,\n    .region--primary-menu>nav .layout .container-xl .layout__region .block__text {\n        margin-left: 0 !important\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region .block__text .wysiwyg a,\n.region--hamburger-menu>nav .layout .container-lg .layout__region .block__text .wysiwyg a,\n.region--hamburger-menu>nav .layout .container-md .layout__region .block__text .wysiwyg a,\n.region--hamburger-menu>nav .layout .container-sm .layout__region .block__text .wysiwyg a,\n.region--hamburger-menu>nav .layout .container-xl .layout__region .block__text .wysiwyg a,\n.region--primary-menu>nav .layout .container-fluid .layout__region .block__text .wysiwyg a,\n.region--primary-menu>nav .layout .container-lg .layout__region .block__text .wysiwyg a,\n.region--primary-menu>nav .layout .container-md .layout__region .block__text .wysiwyg a,\n.region--primary-menu>nav .layout .container-sm .layout__region .block__text .wysiwyg a,\n.region--primary-menu>nav .layout .container-xl .layout__region .block__text .wysiwyg a {\n    font-family: canada-type-gibson, sans-serif;\n    font-size: 1.5rem\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region:not(:first-child) .pt-grid,\n.region--hamburger-menu>nav .layout .container-lg .layout__region:not(:first-child) .pt-grid,\n.region--hamburger-menu>nav .layout .container-md .layout__region:not(:first-child) .pt-grid,\n.region--hamburger-menu>nav .layout .container-sm .layout__region:not(:first-child) .pt-grid,\n.region--hamburger-menu>nav .layout .container-xl .layout__region:not(:first-child) .pt-grid,\n.region--primary-menu>nav .layout .container-fluid .layout__region:not(:first-child) .pt-grid,\n.region--primary-menu>nav .layout .container-lg .layout__region:not(:first-child) .pt-grid,\n.region--primary-menu>nav .layout .container-md .layout__region:not(:first-child) .pt-grid,\n.region--primary-menu>nav .layout .container-sm .layout__region:not(:first-child) .pt-grid,\n.region--primary-menu>nav .layout .container-xl .layout__region:not(:first-child) .pt-grid {\n    border-top: none;\n    padding-top: 0\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region:not(:first-child) .pt-grid,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region:not(:first-child) .pt-grid,\n    .region--hamburger-menu>nav .layout .container-md .layout__region:not(:first-child) .pt-grid,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region:not(:first-child) .pt-grid,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region:not(:first-child) .pt-grid,\n    .region--primary-menu>nav .layout .container-fluid .layout__region:not(:first-child) .pt-grid,\n    .region--primary-menu>nav .layout .container-lg .layout__region:not(:first-child) .pt-grid,\n    .region--primary-menu>nav .layout .container-md .layout__region:not(:first-child) .pt-grid,\n    .region--primary-menu>nav .layout .container-sm .layout__region:not(:first-child) .pt-grid,\n    .region--primary-menu>nav .layout .container-xl .layout__region:not(:first-child) .pt-grid {\n        border-top: 1px solid #c7cfd7;\n        padding-top: 15px\n    }\n}\n\n.region--hamburger-menu>nav .layout .container-fluid .layout__region:not(:first-child) h2,\n.region--hamburger-menu>nav .layout .container-lg .layout__region:not(:first-child) h2,\n.region--hamburger-menu>nav .layout .container-md .layout__region:not(:first-child) h2,\n.region--hamburger-menu>nav .layout .container-sm .layout__region:not(:first-child) h2,\n.region--hamburger-menu>nav .layout .container-xl .layout__region:not(:first-child) h2,\n.region--primary-menu>nav .layout .container-fluid .layout__region:not(:first-child) h2,\n.region--primary-menu>nav .layout .container-lg .layout__region:not(:first-child) h2,\n.region--primary-menu>nav .layout .container-md .layout__region:not(:first-child) h2,\n.region--primary-menu>nav .layout .container-sm .layout__region:not(:first-child) h2,\n.region--primary-menu>nav .layout .container-xl .layout__region:not(:first-child) h2 {\n    border-bottom: 1px solid #c7cfd7;\n    padding-bottom: 5px;\n    margin-bottom: 15px\n}\n\n@media (min-width: 1200px) {\n\n    .region--hamburger-menu>nav .layout .container-fluid .layout__region:not(:first-child) h2,\n    .region--hamburger-menu>nav .layout .container-lg .layout__region:not(:first-child) h2,\n    .region--hamburger-menu>nav .layout .container-md .layout__region:not(:first-child) h2,\n    .region--hamburger-menu>nav .layout .container-sm .layout__region:not(:first-child) h2,\n    .region--hamburger-menu>nav .layout .container-xl .layout__region:not(:first-child) h2,\n    .region--primary-menu>nav .layout .container-fluid .layout__region:not(:first-child) h2,\n    .region--primary-menu>nav .layout .container-lg .layout__region:not(:first-child) h2,\n    .region--primary-menu>nav .layout .container-md .layout__region:not(:first-child) h2,\n    .region--primary-menu>nav .layout .container-sm .layout__region:not(:first-child) h2,\n    .region--primary-menu>nav .layout .container-xl .layout__region:not(:first-child) h2 {\n        border-bottom: none;\n        padding-bottom: 0;\n        margin-bottom: .8rem\n    }\n}\n\n.region--primary-menu .menu--layout-navigation.menu-level-0 {\n    display: none\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu--layout-navigation.menu-level-0 {\n        display: flex\n    }\n}\n\n.region--primary-menu .menu--layout-navigation.menu-level-0>.menu-item--dropdown .menu-dropdown-0 {\n    padding-bottom: 0\n}\n\n.login-menu {\n    transition: .3s ease-in\n}\n\n.login-menu .menu--login-menu {\n    display: flex\n}\n\n.login-menu .menu--login-menu .menu-item {\n    margin-right: 25px\n}\n\n.login-menu .menu--login-menu .menu-item:last-child {\n    margin-right: 0\n}\n\n.login-menu .menu--login-menu .menu-item.icon a::before {\n    content: \"\";\n    display: block;\n    height: 17px;\n    margin-right: .7rem;\n    width: 17px\n}\n\n.login-menu .menu--login-menu .menu-item a {\n    align-items: center;\n    color: #041e42;\n    display: flex;\n    font-size: 1.2rem\n}\n\n@media (min-width: 1200px) {\n    .hamburger-menu .login-menu {\n        display: none\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu .login-menu--hidden {\n        transform: translateX(-200px)\n    }\n}\n\n.region--primary-menu-spacer {\n    height: 60px;\n    background: #f2f6f8 0 0 no-repeat padding-box\n}\n\n.region--header-bar-spacer {\n    height: 35px\n}\n\n@media (max-width: 1199.98px) {\n    .region--header-bar-spacer {\n        height: 0\n    }\n}\n\n.menu-item--image-text-button {\n    display: flex;\n    padding-bottom: 7px\n}\n\n.menu-item--image-text-button img {\n    max-height: 3em;\n    max-width: 6.4rem;\n    margin-right: 5px\n}\n\n.menu-item--image-text-button .btn {\n    margin-left: .8rem\n}\n\n.menu--btn-full-width {\n    border: 0 !important;\n    border-top: 1px solid #8a8d8f !important;\n    border-radius: unset !important;\n    text-transform: none !important;\n    transform: translate(0, 40px)\n}\n\n.region--primary-menu {\n    display: flex;\n    justify-content: space-between;\n    padding-right: 1.6rem;\n    position: fixed;\n    left: 0;\n    top: 0;\n    transition: top .16s, height .16s;\n    z-index: 1300;\n    width: 100%;\n    text-align: center;\n    background: #f2f6f8 0 0 no-repeat padding-box;\n    box-shadow: 3px 3px 6px rgba(0, 0, 0, .16);\n    height: 60px\n}\n\n.region--primary-menu .menu-item:focus,\n.region--primary-menu a:focus {\n    outline: 0\n}\n\n.region--primary-menu .menu-item:focus-visible,\n.region--primary-menu a:focus-visible {\n    box-shadow: inset 0 0 0 1px #041e42;\n    outline: 0\n}\n\n.region--primary-menu button {\n    background: 0 0;\n    color: inherit;\n    border: none;\n    padding: 0;\n    font: inherit;\n    cursor: pointer;\n    outline: inherit;\n    text-align: left\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .submenu-container__title {\n        display: none\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu {\n        padding-right: 50px\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu {\n        z-index: 100\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu--with-header-bar {\n        top: 36px\n    }\n}\n\n.region--primary-menu--hidden {\n    top: -61px\n}\n\n.region--primary-menu.is-sticky.scroll-down {\n    top: 0\n}\n\n.region--primary-menu.is-sticky.scroll-down:not(.is-top) {\n    height: 50px\n}\n\n.region--primary-menu.is-sticky.scroll-down:not(.is-top) #block-sitebranding .logo-container {\n    height: 50px\n}\n\n.region--primary-menu:not(.is-top) {\n    height: 50px\n}\n\n.region--primary-menu:not(.is-top) #block-sitebranding .logo-container {\n    height: 50px;\n    max-width: 50px;\n    transition: max-width .5s ease\n}\n\n.region--primary-menu.scroll-up:not(.is-top) {\n    height: 50px\n}\n\n.region--primary-menu.scroll-up:not(.is-top) #block-sitebranding .logo-container {\n    height: 50px\n}\n\n.region--primary-menu .menu-level-2__item,\n.region--primary-menu .menu-level-3__item {\n    transition: background .3s ease\n}\n\n@media (min-width: 768px) {\n\n    .region--primary-menu .menu-level-2__item:hover,\n    .region--primary-menu .menu-level-3__item:hover {\n        background: #f2f6f8\n    }\n}\n\n.region--primary-menu::before {\n    background: #f2f6f8 0 0 no-repeat padding-box;\n    content: \"\";\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%\n}\n\n.region--primary-menu .contextual-region {\n    position: initial\n}\n\n@media (min-width: 1200px) {\n    body.hamburger-opened .region--primary-menu {\n        padding-right: 17px\n    }\n}\n\n.region--primary-menu.is-top #block-sitebranding .logo-container {\n    max-width: 118px;\n    padding: 11px 11px 11px 14px\n}\n\n.region--primary-menu.is-top #block-sitebranding .logo-container .logo-full {\n    display: block\n}\n\n.region--primary-menu.is-top #block-sitebranding .logo-container .logo-monogram {\n    display: none\n}\n\n.region--primary-menu #block-sitebranding {\n    align-items: center;\n    background: #f2f6f8 0 0 no-repeat padding-box;\n    display: flex;\n    flex: 0 0 auto;\n    z-index: 1\n}\n\n.region--primary-menu #block-sitebranding .logo-container {\n    background-color: #041e42;\n    display: flex;\n    height: 60px;\n    overflow: hidden;\n    padding: 11px 14px;\n    width: 100%;\n    transition: max-width .5s ease 0s\n}\n\n.region--primary-menu #block-sitebranding .logo-container a {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: flex-start;\n    width: 100%\n}\n\n.region--primary-menu #block-sitebranding .logo-container a .logo-full {\n    height: 37px;\n    width: 90px;\n    display: none\n}\n\n.region--primary-menu #block-sitebranding .logo-container a .logo-monogram {\n    height: 25px;\n    width: 22px;\n    display: block\n}\n\n.region--primary-menu #block-sitebranding .logo-container .logo-site__hide {\n    display: none\n}\n\n.region--primary-menu #block-sitebranding .site-slogan-container {\n    line-height: 1.6rem;\n    max-width: 14.1rem;\n    margin-left: 2.4rem;\n    text-align: left\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu #block-sitebranding .site-slogan-container {\n        display: flex\n    }\n}\n\n.region--primary-menu #block-sitebranding .site-slogan-container a {\n    color: #041e42;\n    letter-spacing: 0;\n    font-size: 1.7rem;\n    line-height: 1.8rem;\n    text-align: left\n}\n\n.region--primary-menu #block-sitebranding .site-slogan-container a:hover {\n    color: #041e42\n}\n\n.region--primary-menu #block-sitebranding.block-monogram .logo-container {\n    padding: 12px 15px;\n    width: 52px\n}\n\n.region--primary-menu #block-sitebranding.block-logo .logo-container {\n    transition: width .5s ease 0s\n}\n\n.region--primary-menu .menu_link_content .menu-item--image-text-button img {\n    height: 21.1rem;\n    width: 21.1rem\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu nav#block-ptbase-child-main-menu {\n        height: 100%\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-0 {\n        display: flex;\n        align-items: stretch;\n        height: 100%;\n        background: #f2f6f8\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-0 .dropdown-0-opened {\n        transform: translateY(0) !important;\n        top: 100% !important\n    }\n}\n\n.region--primary-menu .menu-level-0 .btn.btn--inverted,\n.region--primary-menu .menu-level-0 a.btn__arrow.btn--inverted {\n    background: #f2f6f8\n}\n\n.region--primary-menu .menu-level-0>.menu-item {\n    flex: 0 1 auto;\n    align-items: center\n}\n\n@media (max-width: 1199.98px) {\n    .region--primary-menu .menu-level-0>.menu-item {\n        max-width: 100%\n    }\n}\n\n@media (min-width: 768px) {\n    .region--primary-menu .menu-level-0>.menu-item:last-child:not(.menu-item--dropdown) {\n        z-index: 1\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .region--primary-menu .menu-level-0>.menu-item--mobiledisplay__show {\n        margin: auto;\n        flex: 0 0 auto;\n        max-width: 22.4rem;\n        padding: 1.26rem 3rem;\n        display: flex;\n        line-height: 1.8rem\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-0>.menu-item {\n        display: flex\n    }\n}\n\n.region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    color: #041e42;\n    font-size: 1.7rem;\n    text-decoration: none;\n    padding: 0 2.1rem;\n    position: relative;\n    overflow: hidden;\n    transition: color .25s ease-out;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    background: 0 0\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n        background: #f2f6f8 0 0 no-repeat padding-box\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n        display: flex;\n        justify-content: space-between;\n        padding: 10px 0;\n        border-bottom: 1px solid #d2d2d2\n    }\n}\n\n.region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary)::before {\n    content: \"\";\n    width: 0;\n    height: 4px;\n    background-color: #041e42;\n    transition: width .1s ease-out;\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%)\n}\n\n@media (max-width: 1199.98px) {\n    .region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary)::before {\n        content: unset\n    }\n}\n\n.region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover {\n    background-color: #fff;\n    color: #041e42\n}\n\n.region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover::before {\n    width: 100%\n}\n\n.region--primary-menu .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary).font-weight-bold {\n    font-weight: 700 !important\n}\n\n.region--primary-menu .menu-level-0>.menu-item>.menu-link.btn {\n    background-color: #041e42;\n    color: #fff\n}\n\n.region--primary-menu .menu-level-0>.menu-item>.menu-link.btn:hover {\n    background-color: #0c2b57\n}\n\n.region--primary-menu .menu-level-0>.menu-item--active-trail>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover::before {\n    width: 100%\n}\n\n@media (min-width: 1200px) {\n\n    .region--primary-menu .menu-level-0>.menu-item--active-trail>.menu-link:focus-visible+.submenu-container .menu-dropdown-0,\n    .region--primary-menu .menu-level-0>.menu-item--active-trail>.menu-link:focus-visible+.submenu-container .menu-dropdown-0:focus-visible {\n        transform: translateY(0);\n        top: 100%\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-0 .menu-dropdown-0:focus-visible {\n        transform: translateY(0);\n        top: 100%\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-0>.menu-item--dropdown>.menu-link:after {\n        position: relative;\n        content: \"+\";\n        display: inline-block;\n        margin-left: .8rem;\n        left: 0;\n        width: 10px\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .region--primary-menu .menu-level-0>.menu-item--dropdown>.menu-link:after {\n        /* background: url(/src/images/icons/chevron-down-dark-blue.svg) no-repeat center center/cover; */\n        content: \"\";\n        display: inline-block;\n        height: 13px;\n        transform: rotate(-90deg);\n        width: 13px;\n        margin-right: 15px\n    }\n}\n\n@media (min-width: 1200px) {\n\n    .region--primary-menu .menu-level-0>.menu-item--dropdown:focus-visible .menu-dropdown-0,\n    .region--primary-menu .menu-level-0>.menu-item--dropdown:hover .menu-dropdown-0 {\n        transform: translateY(0);\n        top: 100%\n    }\n}\n\n@media (min-width: 1200px) {\n\n    .region--primary-menu .menu-level-0>.menu-item--dropdown:focus-visible>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n    .region--primary-menu .menu-level-0>.menu-item--dropdown:hover>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after {\n        content: \"-\"\n    }\n}\n\n.region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0 {\n    box-shadow: 0 3px 3px rgba(0, 0, 0, .16);\n    display: block;\n    height: auto;\n    width: 100%;\n    background-color: #fff;\n    position: absolute;\n    left: 0;\n    transition: transform .35s ease-in-out;\n    text-align: left;\n    top: 50px\n}\n\n@media (max-width: 1199.98px) {\n    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0 {\n        box-shadow: none\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0 {\n        transform: translateY(-120%);\n        z-index: -1;\n        padding: 38px 0 30px;\n        top: 15px\n    }\n\n    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0.footer-main-menu {\n        padding-bottom: 0\n    }\n}\n\n.region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0>.submenu-container--inside {\n    max-width: 1030px;\n    margin: 0 auto\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0 {\n        max-height: calc(80vh - 119px);\n        overflow-y: hidden;\n        display: flex\n    }\n\n    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0>.submenu-container--inside {\n        overflow-y: auto\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-0>.menu-item--dropdown .menu-dropdown-0:hover {\n        top: 100%\n    }\n}\n\n.region--primary-menu .menu-level-1 {\n    column-gap: 3rem;\n    grid-template-columns: repeat(4, 1fr);\n    margin: auto;\n    max-width: 1030px;\n    overflow: hidden;\n    position: relative\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-1 {\n        display: grid\n    }\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-1 {\n        overflow-y: auto\n    }\n\n    .region--primary-menu .menu-level-1::-webkit-scrollbar {\n        width: 10px;\n        border: none\n    }\n\n    .region--primary-menu .menu-level-1::-webkit-scrollbar-track {\n        background: rgba(138, 141, 143, .3);\n        box-shadow: inset 0 0 6px rgba(0, 0, 0, .15);\n        border-radius: 10px\n    }\n\n    .region--primary-menu .menu-level-1::-webkit-scrollbar-thumb {\n        background: #8a8d8f;\n        border-radius: 10px;\n        box-shadow: inset 0 0 6px rgba(0, 0, 0, .25)\n    }\n\n    .region--primary-menu .menu-level-1::-webkit-scrollbar-thumb:hover {\n        background: #54585a\n    }\n\n    .region--primary-menu .menu-level-1::-webkit-scrollbar-button {\n        height: 5px\n    }\n}\n\n.region--primary-menu .menu-level-1__link {\n    border-top: none;\n    border-right: none;\n    border-left: none;\n    background: 0 0;\n    border-bottom: 1px solid #d2d2d2;\n    color: #041e42;\n    display: inline-block;\n    font-size: 1.4rem;\n    font-weight: 900;\n    line-height: 2rem;\n    margin-bottom: 8px;\n    padding-bottom: 5px;\n    width: 100%\n}\n\n.region--primary-menu .menu-level-1 .menu-item--two-columns {\n    grid-column: 1/3\n}\n\n.region--primary-menu .menu-level-1 .menu-item--two-columns .menu-level-2 {\n    grid-template-columns: repeat(2, 1fr)\n}\n\n@media (min-width: 1200px) {\n\n    .region--primary-menu .menu-level-2__item,\n    .region--primary-menu .menu-level-3__item {\n        display: grid;\n        position: relative;\n        border-radius: 5px\n    }\n}\n\n.region--primary-menu .menu-level-2__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.region--primary-menu .menu-level-3__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    color: #041e42;\n    font-size: 1.5rem;\n    width: 100%;\n    justify-self: flex-start;\n    padding: 10px 1.6rem;\n    position: relative\n}\n\n@media (max-width: 1199.98px) {\n\n    .region--primary-menu .menu-level-2__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n    .region--primary-menu .menu-level-3__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n        padding: 10px 0\n    }\n}\n\n.region--primary-menu .menu-level-2__link.font-weight-bold--arrow,\n.region--primary-menu .menu-level-3__link.font-weight-bold--arrow {\n    align-items: center;\n    display: flex\n}\n\n.region--primary-menu .menu-level-2__link.font-weight-bold--arrow::after,\n.region--primary-menu .menu-level-3__link.font-weight-bold--arrow::after {\n    /* background: url(/src/images/icons/arrow-next-dark-blue.svg) no-repeat center center/contain; */\n    height: 7.7px;\n    margin-left: 7.5px;\n    width: 9.7px\n}\n\n.region--primary-menu .menu-level-2__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) span,\n.region--primary-menu .menu-level-3__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) span {\n    background-image: linear-gradient(0deg, #041e42 8%, rgba(4, 30, 66, 0) 10%);\n    background-size: 0;\n    padding-bottom: 2px;\n    background-repeat: no-repeat;\n    background-position: bottom left;\n    transition: background-size .5s\n}\n\n.region--primary-menu .menu-level-2 {\n    display: grid\n}\n\n.region--primary-menu .menu-level-2 .menu-item:nth-of-type(11) .menu-dropdown-2,\n.region--primary-menu .menu-level-2 .menu-item:nth-of-type(12) .menu-dropdown-2 {\n    bottom: 0;\n    top: unset\n}\n\n.region--primary-menu .menu-level-2:not(.menu-item--dropdown)>a {\n    justify-self: flex-start\n}\n\n.region--primary-menu .menu-level-2__item:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover .menu-item--active-trail .menu-level-2__link span,\n.region--primary-menu .menu-level-2__item:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover .menu-level-2__link span {\n    background-size: 100%\n}\n\n.region--primary-menu .menu-level-2__item.menu-item--dropdown {\n    transition: background-color .3s ease-in, border-radius .3s ease-in\n}\n\n@media (min-width: 1200px) {\n\n    .region--primary-menu .menu-level-2__item.menu-item--dropdown.menu-item--active-trail,\n    .region--primary-menu .menu-level-2__item.menu-item--dropdown:focus-visible,\n    .region--primary-menu .menu-level-2__item.menu-item--dropdown:hover {\n        background-color: #f2f6f8;\n        border-radius: 5px 0 0 5px\n    }\n}\n\n.region--primary-menu .menu-level-2__item.menu-item--dropdown .menu-level-2__link {\n    align-items: center;\n    display: flex;\n    gap: 10px;\n    justify-self: stretch;\n    background: 0 0;\n    text-align: left;\n    padding: 10px 1.6rem\n}\n\n.region--primary-menu .menu-level-2__item.menu-item--dropdown .menu-level-2__link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary)::before {\n    display: none\n}\n\n.region--primary-menu .menu-level-2__item.menu-item--dropdown .menu-level-2__link::after {\n    background: url(/src/images/icons/chevron-down-dark-blue-round.svg) no-repeat center center/10.5px 7px;\n    content: \"\";\n    display: inline-block;\n    height: 13px;\n    flex: 0 0 auto;\n    transform: rotate(-90deg);\n    width: 20px\n}\n\n.region--primary-menu .menu-level-2__link {\n    padding-left: 1.6rem;\n    padding-right: 1.6rem\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu .menu-level-2 .menu-dropdown-2 {\n        left: 100%;\n        opacity: 0;\n        position: absolute;\n        top: 0;\n        visibility: hidden;\n        width: 100%;\n        z-index: 1;\n        transition: opacity .3s ease-in, visibility .3s ease-in\n    }\n}\n\n.region--primary-menu .menu-level-2 .menu-dropdown-2.view-mode-image-text-button {\n    left: 50%;\n    opacity: 1;\n    visibility: visible;\n    top: 50%\n}\n\n.region--primary-menu .menu-level-2 .btn {\n    background-color: #041e42;\n    color: #fff\n}\n\n.region--primary-menu .menu-level-2--visible .menu-dropdown-2 {\n    opacity: 1;\n    visibility: visible\n}\n\n.region--primary-menu .menu-level-3 {\n    background-color: #fff;\n    padding-left: 1.6rem\n}\n\n@media (max-width: 1199.98px) {\n    .region--primary-menu .menu-level-3 {\n        padding-left: 4.5rem\n    }\n}\n\n.region--primary-menu .menu-level-3 .menu-level-3__item:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary).menu-item--active-trail a span,\n.region--primary-menu .menu-level-3 .menu-level-3__item:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover a span,\n.region--primary-menu .menu-level-3 .menu-level-3__item:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover button span {\n    background-size: 100%\n}\n\n@media (min-width: 1200px) {\n    .region--primary-menu--inverted {\n        background: #041e42 0 0 no-repeat padding-box\n    }\n\n    .region--primary-menu--inverted .menu-level-0 {\n        background: #041e42\n    }\n\n    .region--primary-menu--inverted .menu-level-0 .menu-item:focus,\n    .region--primary-menu--inverted .menu-level-0 a:focus {\n        outline: 0\n    }\n\n    .region--primary-menu--inverted .menu-level-0 .menu-item:focus-visible,\n    .region--primary-menu--inverted .menu-level-0 a:focus-visible {\n        box-shadow: inset 0 0 0 1px #fff;\n        outline: 0\n    }\n\n    .region--primary-menu--inverted .menu-level-0 .menu-level-2 .menu-item:focus,\n    .region--primary-menu--inverted .menu-level-0 .menu-level-2 a:focus,\n    .region--primary-menu--inverted .menu-level-0 .menu-level-3 .menu-item:focus,\n    .region--primary-menu--inverted .menu-level-0 .menu-level-3 a:focus {\n        outline: 0\n    }\n\n    .region--primary-menu--inverted .menu-level-0 .menu-level-2 .menu-item:focus-visible,\n    .region--primary-menu--inverted .menu-level-0 .menu-level-2 a:focus-visible,\n    .region--primary-menu--inverted .menu-level-0 .menu-level-3 .menu-item:focus-visible,\n    .region--primary-menu--inverted .menu-level-0 .menu-level-3 a:focus-visible {\n        box-shadow: inset 0 0 0 1px #041e42;\n        outline: 0\n    }\n\n    .region--primary-menu--inverted .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n        background: #041e42;\n        color: #fff\n    }\n\n    .region--primary-menu--inverted .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):hover {\n        color: #fff;\n        background: #041e42\n    }\n\n    .region--primary-menu--inverted .menu-level-0>.menu-item>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary)::before {\n        background-color: #f2f6f8\n    }\n}\n\n@media (min-width: 1200px) and (max-width:1199.98px) {\n    .region--primary-menu--inverted .menu-level-0>.menu-item--expanded .menu-link::after {\n        background-image: url(/src/images/icons/chevron-down-white.svg)\n    }\n}\n\n@media (min-width: 1200px) and (max-width:1199.98px) {\n    .region--primary-menu--inverted .menu-level-0>.menu-item--expanded:hover>.menu-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary)::after {\n        background-image: url(/src/images/icons/chevron-down-white.svg)\n    }\n}\n\n.toolbar-horizontal.toolbar-tray-open .region--primary-menu {\n    top: 79px\n}\n\n@media (min-width: 1200px) {\n    .toolbar-horizontal.toolbar-tray-open .region--primary-menu--with-header-bar {\n        top: 115px\n    }\n}\n\n.toolbar-horizontal.toolbar-tray-open .region--primary-menu--hidden {\n    top: -61px\n}\n\n.toolbar-horizontal.toolbar-tray-open .region--primary-menu.is-sticky.scroll-down {\n    top: 79px\n}\n\n@media (min-width: 1200px) {\n    .menu-dropdown-2 {\n        height: 100%\n    }\n\n    .menu-dropdown-2 .submenu-container--inside {\n        border-left: 1px solid #041e42;\n        min-height: 100%\n    }\n}\n\n.header-bar .icon.menu-item.login a::before,\n.region--primary-menu .icon.menu-item.login a::before {\n    background: transparent url(/src/images/icons/login.svg) no-repeat center center/cover\n}\n\n/* \n.header-bar .icon.menu-item.online_store a::before,\n.region--primary-menu .icon.menu-item.online_store a::before {\n    background: transparent url(/src/images/icons/online_store.svg) no-repeat center center/cover\n} */\n\n.header-bar .icon.menu-item.phone a::before,\n.region--primary-menu .icon.menu-item.phone a::before {\n    background: transparent url(/src/images/icons/phone.svg) no-repeat center center/cover\n}\n\n/* \n.header-bar .icon.menu-item.email a::before,\n.region--primary-menu .icon.menu-item.email a::before {\n    background: transparent url(/src/images/icons/icon-email-blue.svg) no-repeat center center/cover\n} */\n\n.menu {\n    margin: 0;\n    padding: 0;\n    list-style-type: none\n}\n\n.menu__item {\n    margin: 0;\n    padding: 0\n}\n\n.menu__child {\n    margin: 0;\n    padding: 0\n}\n\n.option-tooltip {\n    display: none;\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, 10px);\n    background-color: #fff;\n    box-shadow: 0 5px 15px 5px rgba(0, 0, 0, .3);\n    width: 280px;\n    border-top: 4px solid #41b6e6\n}\n\n.option-tooltip:before {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 22px 15px 22px;\n    border-color: transparent transparent #41b6e6 transparent;\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -100%)\n}\n\n.option-tooltip span {\n    display: inline-block;\n    padding: 25px 50px 25px 25px\n}\n\n.option-tooltip .btnOptionTooltipClose {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    /* background-image: url(/src/images/icons/x.svg); */\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 15px;\n    height: 15px;\n    text-indent: -9999px;\n    outline: 0\n}\n\n.cke_editable,\n.wysiwyg {\n    font-size: 1.8rem;\n    line-height: 1.5em\n}\n\n.cke_editable p,\n.wysiwyg p {\n    font-size: 1.8rem;\n    line-height: 2.8rem\n}\n\n.cke_editable .smallmargin,\n.wysiwyg .smallmargin {\n    display: block;\n    margin-bottom: 2rem !important\n}\n\n.cke_editable .bigmargin,\n.wysiwyg .bigmargin {\n    display: block;\n    margin-bottom: 5rem !important\n}\n\n.cke_editable .legaltext,\n.wysiwyg .legaltext {\n    font-size: 1.2rem;\n    line-height: 1.8rem\n}\n\n.cke_editable img,\n.wysiwyg img {\n    max-width: 100%\n}\n\n.cke_editable ul:not(.contextual-links) li,\n.wysiwyg ul:not(.contextual-links) li {\n    margin-left: 3em;\n    text-indent: -1.5em;\n    font-size: 1.8rem\n}\n\n.cke_editable ul:not(.contextual-links) li a.btn,\n.cke_editable ul:not(.contextual-links) li a.btn--inverted,\n.cke_editable ul:not(.contextual-links) li a.btn-100-primary,\n.cke_editable ul:not(.contextual-links) li a.btn-primary,\n.cke_editable ul:not(.contextual-links) li a.btn-secondary,\n.cke_editable ul:not(.contextual-links) li a.btn-tertiary,\n.wysiwyg ul:not(.contextual-links) li a.btn,\n.wysiwyg ul:not(.contextual-links) li a.btn--inverted,\n.wysiwyg ul:not(.contextual-links) li a.btn-100-primary,\n.wysiwyg ul:not(.contextual-links) li a.btn-primary,\n.wysiwyg ul:not(.contextual-links) li a.btn-secondary,\n.wysiwyg ul:not(.contextual-links) li a.btn-tertiary {\n    display: inline\n}\n\n.cke_editable .title.title--light,\n.wysiwyg .title.title--light {\n    color: var(--color-light-blue)\n}\n\n.cke_editable .title.title--white,\n.wysiwyg .title.title--white {\n    color: #fff\n}\n\n.cke_editable .title--nomargin span,\n.wysiwyg .title--nomargin span {\n    margin-bottom: 0 !important\n}\n\n.cke_editable .text,\n.wysiwyg .text {\n    font-size: 1.8rem;\n    line-height: 1.5em;\n    font-weight: 700\n}\n\n.cke_editable .text--grey,\n.wysiwyg .text--grey {\n    color: rgba(0, 0, 0, .3)\n}\n\n.cke_editable .text--light,\n.wysiwyg .text--light {\n    color: var(--color-light-blue)\n}\n\n.cke_editable .text--white,\n.wysiwyg .text--white {\n    color: #fff\n}\n\n.cke_editable .text--black,\n.wysiwyg .text--black {\n    color: #000\n}\n\n.cke_editable .link,\n.wysiwyg .link {\n    font-size: 1.6rem;\n    line-height: 1.1em;\n    font-weight: 700;\n    color: #041e42;\n    display: flex;\n    align-items: center\n}\n\n.cke_editable .box,\n.wysiwyg .box {\n    background-color: #f2f6f8\n}\n\n.cke_editable .box p,\n.wysiwyg .box p {\n    margin-bottom: 0;\n    color: #041e42\n}\n\n.cke_editable .box--rounded,\n.wysiwyg .box--rounded {\n    border-bottom-left-radius: 50px;\n    padding: 30px 35px\n}\n\n.cke_editable .box--dark,\n.wysiwyg .box--dark {\n    background-color: #041e42;\n    color: #fff\n}\n\n.cke_editable .box--outline,\n.wysiwyg .box--outline {\n    border: 6px solid var(--color-light-blue)\n}\n\n.cke_editable .box--outline,\n.wysiwyg .box--outline {\n    border: 6px solid var(--color-light-blue)\n}\n\n.cke_editable ul:not(.contextual-links),\n.wysiwyg ul:not(.contextual-links) {\n    list-style-type: none;\n    padding: 0\n}\n\n@media screen and (max-width: 991px) {\n\n    .cke_editable ul:not(.contextual-links),\n    .wysiwyg ul:not(.contextual-links) {\n        margin-bottom: 0\n    }\n}\n\n.cke_editable ul:not(.contextual-links) li:before,\n.wysiwyg ul:not(.contextual-links) li:before {\n    content: \"\";\n    display: inline-block;\n    height: .65em;\n    width: .65em;\n    background-size: contain;\n    /* background-image: url(/src/images/icons/circle-dark-blue.svg); */\n    background-repeat: no-repeat;\n    padding-left: 1.2em;\n    position: relative;\n    top: .2em;\n    margin-left: .2em\n}\n\n/*\n\n.layout__black .cke_editable ul:not(.contextual-links) li:before,\n.layout__black .wysiwyg ul:not(.contextual-links) li:before,\n.layout__blue .cke_editable ul:not(.contextual-links) li:before,\n.layout__blue .wysiwyg ul:not(.contextual-links) li:before,\n.layout__dark_grey .cke_editable ul:not(.contextual-links) li:before,\n.layout__dark_grey .wysiwyg ul:not(.contextual-links) li:before,\n.layout__light_blue .cke_editable ul:not(.contextual-links) li:before,\n.layout__light_blue .wysiwyg ul:not(.contextual-links) li:before {\n    background-image: url(/src/images/icons/circle-white.svg)\n}\n\n.layout__black .cke_editable ul:not(.contextual-links) .point:before,\n.layout__black .wysiwyg ul:not(.contextual-links) .point:before,\n.layout__blue .cke_editable ul:not(.contextual-links) .point:before,\n.layout__blue .wysiwyg ul:not(.contextual-links) .point:before,\n.layout__dark_grey .cke_editable ul:not(.contextual-links) .point:before,\n.layout__dark_grey .wysiwyg ul:not(.contextual-links) .point:before,\n.layout__light_blue .cke_editable ul:not(.contextual-links) .point:before,\n.layout__light_blue .wysiwyg ul:not(.contextual-links) .point:before {\n    background-image: url(/src/images/icons/circle-white.svg)\n}\n\n.cke_editable ul:not(.contextual-links) .point:before,\n.wysiwyg ul:not(.contextual-links) .point:before {\n    background-image: url(/src/images/icons/circle-dark-blue.svg)\n}\n\n.cke_editable ul:not(.contextual-links) .point--lightblue:before,\n.wysiwyg ul:not(.contextual-links) .point--lightblue:before {\n    background-image: url(/src/images/icons/circle-light-blue.svg)\n}\n\n.cke_editable ul:not(.contextual-links) .check:before,\n.wysiwyg ul:not(.contextual-links) .check:before {\n    top: 0;\n    margin-left: 0;\n    padding-left: 1.4em;\n    background-image: url(/src/images/icons/check.svg)\n}\n\n*/\n.layout__black .cke_editable ul:not(.contextual-links) .check:before,\n.layout__black .wysiwyg ul:not(.contextual-links) .check:before,\n.layout__blue .cke_editable ul:not(.contextual-links) .check:before,\n.layout__blue .wysiwyg ul:not(.contextual-links) .check:before,\n.layout__dark_grey .cke_editable ul:not(.contextual-links) .check:before,\n.layout__dark_grey .wysiwyg ul:not(.contextual-links) .check:before,\n.layout__light_blue .cke_editable ul:not(.contextual-links) .check:before,\n.layout__light_blue .wysiwyg ul:not(.contextual-links) .check:before {\n    background-image: url(/src/images/icons/check-white.svg)\n}\n\n/* \n.cke_editable ul:not(.contextual-links) .check--lightblue:before,\n.wysiwyg ul:not(.contextual-links) .check--lightblue:before {\n    background-image: url(/src/images/icons/check-light-blue.svg)\n} */\n\n.cke_editable ul:not(.contextual-links) .mark--exclamation:before,\n.wysiwyg ul:not(.contextual-links) .mark--exclamation:before {\n    /* background-image: url(/src/images/icons/exclamation-mark.svg); */\n    height: .8em;\n    width: .8em;\n    top: 1px;\n    padding-left: 0;\n    margin-right: 5px\n}\n\n@media (max-width: 575.98px) {\n\n    .cke_editable .align-left,\n    .cke_editable .align-right,\n    .wysiwyg .align-left,\n    .wysiwyg .align-right {\n        float: none\n    }\n}\n\n@media (min-width: 576px) {\n\n    .cke_editable .align-right,\n    .wysiwyg .align-right {\n        margin-left: 10px\n    }\n}\n\n@media (max-width: 575.98px) {\n\n    .cke_editable .align-right.embedded-entity,\n    .wysiwyg .align-right.embedded-entity {\n        text-align: right\n    }\n}\n\n@media (min-width: 576px) {\n\n    .cke_editable .align-left,\n    .wysiwyg .align-left {\n        margin-right: 10px\n    }\n}\n\n@media (max-width: 575.98px) {\n\n    .cke_editable .align-left.embedded-entity,\n    .wysiwyg .align-left.embedded-entity {\n        text-align: left\n    }\n}\n\n@media (max-width: 575.98px) {\n\n    .cke_editable .embedded-entity,\n    .wysiwyg .embedded-entity {\n        text-align: center\n    }\n}\n\n.cke_editable .align-center,\n.wysiwyg .align-center {\n    text-align: center\n}\n\n.cke_editable iframe,\n.wysiwyg iframe {\n    width: 100%;\n    border: none\n}\n\n.block__text .wysiwyg ul:not(.contextual-links) {\n    margin-bottom: 1em\n}\n\n@media screen and (max-width: 991px) {\n    .block__text .wysiwyg ul:not(.contextual-links) {\n        margin-bottom: 2em\n    }\n}\n\n.block__text .wysiwyg ul:not(.contextual-links) li {\n    margin-left: 3.5em;\n    text-indent: -1.5em\n}\n\n.block__text .wysiwyg ul:not(.contextual-links) li p {\n    text-indent: 0;\n    display: inline\n}\n\n.block__text .wysiwyg ul:not(.contextual-links) li h3 {\n    text-indent: 0\n}\n\n@media (max-width: 1199.98px) {\n    .block__text .wysiwyg ul:not(.contextual-links) li {\n        margin-left: 3em\n    }\n}\n\n@media (max-width: 767.98px) {\n    .block__text .wysiwyg ul.no-margin {\n        margin-bottom: 0\n    }\n}\n\n@media (min-width: 992px) {\n    .limited-w {\n        max-width: 66%\n    }\n}\n\n@keyframes pattern-text {\n    25% {\n        background-position: 50% center\n    }\n\n    50% {\n        background-position: 100% center\n    }\n\n    75% {\n        background-position: 150% center\n    }\n\n    100% {\n        background-position: 200% center\n    }\n}\n\n.gradient-text {\n    /* background-image: url(/src/images/bg/ImageBackground_SmallerNew.webp); */\n    -webkit-background-clip: text;\n    color: transparent;\n    background-repeat: repeat;\n    background-position: 0 center;\n    background-size: 200%;\n    animation: pattern-text 40s linear infinite;\n    animation-direction: reverse;\n    display: inline\n}\n\ndiv.slick-cta {\n    position: relative;\n    text-align: left;\n    width: 66%;\n    --text-color: #FFFFFF;\n    transform: translateY(0);\n    bottom: 0;\n    z-index: 1\n}\n\n@media (min-width: 992px) {\n    div.slick-cta {\n        position: absolute;\n        transform: translateY(40%)\n    }\n}\n\n@media screen and (max-width: 1199px) {\n    div.slick-cta {\n        width: 80%\n    }\n}\n\n@media (max-width: 991.98px) {\n    div.slick-cta {\n        width: 100%\n    }\n}\n\ndiv.slick-cta__question {\n    position: absolute;\n    z-index: 2;\n    transform: translateY(-10%)\n}\n\n@media (max-width: 767.98px) {\n    div.slick-cta__question {\n        position: relative;\n        transform: translateY(0)\n    }\n}\n\ndiv.slick-cta div.slick-cta--content {\n    position: relative;\n    z-index: 1;\n    width: 84%;\n    padding: 30px 0;\n    background-color: #041e42;\n    font-size: 1.8rem\n}\n\n@media (max-width: 991.98px) {\n    div.slick-cta div.slick-cta--content {\n        width: 100%\n    }\n}\n\ndiv.slick-cta div.slick-cta--content .row {\n    margin-left: 10vw\n}\n\ndiv.slick-cta div.slick-cta--content .question {\n    padding: 33px 15px 33px 0;\n    font-size: 2.8rem\n}\n\n@media screen and (max-width: 767px) {\n    div.slick-cta div.slick-cta--content .question {\n        padding: 0 0 40px 15px;\n        font-size: 2.2rem\n    }\n}\n\ndiv.slick-cta div.slick-cta--content .select {\n    position: absolute;\n    z-index: 1;\n    height: 40px;\n    overflow: hidden;\n    padding: 0;\n    cursor: pointer;\n    background-color: #041e42;\n    margin: 40px 0 0\n}\n\n@media screen and (max-width: 767px) {\n    div.slick-cta div.slick-cta--content .select {\n        margin: -30px 0 0;\n        height: 30px\n    }\n}\n\ndiv.slick-cta div.slick-cta--content .select:hover {\n    height: auto;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px\n}\n\ndiv.slick-cta div.slick-cta--content .select li {\n    font-size: 2.2rem;\n    padding: 10px 20px;\n    color: #fff\n}\n\n@media screen and (max-width: 767px) {\n    div.slick-cta div.slick-cta--content .select li {\n        font-size: 1.4rem;\n        padding: 8px 20px\n    }\n}\n\ndiv.slick-cta div.slick-cta--content .select li:first-child {\n    border-bottom: 2px solid #fff;\n    padding: 2px 0\n}\n\ndiv.slick-cta div.slick-cta--content .select li:first-child span:after {\n    content: \" \";\n    position: absolute;\n    right: -18px;\n    /* background-image: url(/src/images/icons/chevron-up.svg); */\n    background-size: 24px 24px;\n    background-position: right center;\n    background-repeat: no-repeat;\n    height: 36px;\n    width: 36px;\n    transform: rotate(180deg)\n}\n\n@media screen and (max-width: 991px) {\n    div.slick-cta div.slick-cta--content .select li:first-child span:after {\n        top: -4px\n    }\n}\n\ndiv.slick-cta div.slick-cta--content .select li a {\n    display: block;\n    text-decoration: none;\n    color: #fff\n}\n\ndiv.slick-cta div.slick-cta--content .select li:hover a {\n    color: #40b4e5\n}\n\ndiv.slick-cta div.slick-cta--round {\n    position: absolute;\n    content: \" \";\n    background-color: #041e42;\n    height: 100%;\n    top: 0;\n    left: 83.5%\n}\n\n@media (min-width: 992px) {\n    div.slick-cta div.slick-cta--round {\n        border-bottom-right-radius: 999px;\n        border-top-right-radius: 999px\n    }\n}\n\n.layout-builder__section div.slick-cta {\n    transform: none\n}\n\n.swiper {\n    position: unset !important;\n    border-radius: 10px\n}\n\n.swiper .swiper-wrapper {\n    margin-bottom: 40px\n}\n\n@media (min-width: 768px) {\n    .swiper .swiper-wrapper {\n        margin-bottom: 48px\n    }\n}\n\n.swiper .swiper-wrapper .swiper-slide img {\n    width: 100%;\n    height: auto;\n    border-radius: 10px;\n    transition: transform .3s ease\n}\n\n.swiper .swiper-wrapper .swiper-slide .media-360 .btn-360 {\n    position: absolute;\n    right: 15px;\n    bottom: 15px\n}\n\n.swiper .swiper-wrapper .swiper-slide .media-360 .btn-360 .icon-360 {\n    margin: 0\n}\n\n.swiper:not(.swiper-initialized) .swiper-button-next,\n.swiper:not(.swiper-initialized) .swiper-button-prev,\n.swiper:not(.swiper-initialized) .swiper-pagination,\n.swiper:not(.swiper-initialized) .swiper-veil {\n    display: none\n}\n\n.swiper .swiper-button-next,\n.swiper .swiper-button-prev {\n    background-color: #41b6e6;\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    transition: transform .3s;\n    top: calc(50% - 36px)\n}\n\n@media (max-width: 991.98px) {\n\n    .swiper .swiper-button-next,\n    .swiper .swiper-button-prev {\n        width: 28px;\n        height: 28px\n    }\n}\n\n@media (max-width: 991.98px) {\n\n    .swiper .swiper-button-next,\n    .swiper .swiper-button-prev {\n        top: calc(100% - 36px)\n    }\n}\n\n.swiper .swiper-button-next:after,\n.swiper .swiper-button-prev:after {\n    content: \"\";\n    background-image: url(/src/images/icons/chevron-down-white.svg);\n    background-position: center;\n    background-size: 14px 10px;\n    background-repeat: no-repeat;\n    width: 100%;\n    height: 14px;\n    position: relative;\n    top: 0;\n    transform-origin: center center;\n    transform: rotate(var(--swiper-btn-rotate)) translateY(1px)\n}\n\n@media (max-width: 991.98px) {\n\n    .swiper .swiper-button-next:after,\n    .swiper .swiper-button-prev:after {\n        background-size: 12px 10px\n    }\n}\n\n@media (min-width: 768px) {\n\n    .swiper .swiper-button-next:hover,\n    .swiper .swiper-button-prev:hover {\n        transform: scale(1.11)\n    }\n}\n\n.swiper .swiper-button-prev {\n    left: -18px;\n    --swiper-btn-rotate: 90deg\n}\n\n@media (max-width: 991.98px) {\n    .swiper .swiper-button-prev {\n        left: 0\n    }\n}\n\n.swiper .swiper-button-next {\n    right: -18px;\n    --swiper-btn-rotate: -90deg\n}\n\n@media (max-width: 991.98px) {\n    .swiper .swiper-button-next {\n        right: 0\n    }\n}\n\n.swiper .swiper-veil {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, var(--bg-color) 50%);\n    width: 10%;\n    height: 100%;\n    z-index: 1;\n    cursor: pointer\n}\n\n@media (max-width: 991.98px) {\n    .swiper .swiper-veil {\n        right: -15px;\n        width: 20%\n    }\n}\n\n.swiper .swiper-wrapper+.swiper-pagination {\n    --swiper-pagination-bullet-inactive-opacity: 1;\n    bottom: 0;\n    width: 90%\n}\n\n@media (max-width: 991.98px) {\n    .swiper .swiper-wrapper+.swiper-pagination {\n        width: 100%\n    }\n}\n\n.swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet {\n    background-color: #8a8d8f;\n    border-radius: 10px;\n    height: 3px;\n    width: 5%;\n    transition: background-color .3s\n}\n\n.swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet:hover:not(.swiper-pagination-bullet-active) {\n    background-color: #54585a\n}\n\n.layout__black .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet:hover:not(.swiper-pagination-bullet-active),\n.layout__blue .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet:hover:not(.swiper-pagination-bullet-active),\n.layout__dark_grey .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet:hover:not(.swiper-pagination-bullet-active),\n.layout__light_blue .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet:hover:not(.swiper-pagination-bullet-active) {\n    background-color: #cfd3d6\n}\n\n.swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n    background-color: #000;\n    cursor: default\n}\n\n.layout__black .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active,\n.layout__blue .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active,\n.layout__dark_grey .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active,\n.layout__light_blue .swiper .swiper-wrapper+.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n    background-color: #fff\n}\n\n.swiper-thumbs .swiper-wrapper {\n    overflow: hidden;\n    justify-content: center\n}\n\n.swiper-thumbs .swiper-wrapper .swiper-slide {\n    opacity: .4;\n    background-color: #fff;\n    border-radius: 5px\n}\n\n.swiper-thumbs .swiper-wrapper .swiper-slide.swiper-slide-thumb-active {\n    opacity: 1;\n    border: 1px solid #000\n}\n\n.swiper-thumbs .swiper-wrapper .swiper-slide .main-image-container div.splash-video-play-button {\n    width: 19px;\n    height: 19px;\n    left: calc(50% - 9.5px);\n    top: calc(50% - 9.5px);\n    pointer-events: none\n}\n\n.swiper-thumbs .swiper-wrapper .swiper-slide img {\n    border-radius: 5px;\n    width: 100%;\n    height: auto\n}\n\n.swiper-thumbs .swiper-wrapper .swiper-slide .media-360 .icon-media-360 {\n    display: block;\n    position: absolute;\n    left: calc(50% - 9.5px);\n    top: calc(50% - 9.5px);\n    width: 19px;\n    height: 19px;\n    /* background-image: url(/src/images/icons/360.png); */\n    background-position: center;\n    background-size: cover\n}\n\n.pt-image-gallery-zoom {\n    position: absolute;\n    width: 400px;\n    height: 400px;\n    border: 1px solid #c7cfd7;\n    box-shadow: 2px 2px 5px 1px #c7cfd7;\n    display: none;\n    z-index: 9999;\n    background-color: #fff\n}\n\n.pt-image-gallery-zoom-display {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 200px;\n    width: 200px;\n    z-index: 500;\n    border: 1px solid #ff0;\n    pointer-events: none;\n    display: none;\n    margin-top: -100px;\n    margin-left: -100px\n}\n\n.swiper-image-mobile img {\n    width: 100%;\n    height: auto\n}\n\n.main-image-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative\n}\n\n.main-image-container div.splash-video-play-button {\n    cursor: pointer;\n    position: absolute;\n    background-image: url(/src/images/icons/playInverted.svg);\n    background-size: contain;\n    background-repeat: no-repeat;\n    width: 100px;\n    height: 100px;\n    left: calc(50% - 50px);\n    top: calc(50% - 50px)\n}\n\n@media (min-width: 768px) and (max-width:1199.98px) {\n    .main-image-container div.splash-video-play-button {\n        width: 70px;\n        height: 70px;\n        left: calc(50% - 35px);\n        top: calc(50% - 35px)\n    }\n}\n\n@media (max-width: 767.98px) {\n    .main-image-container div.splash-video-play-button {\n        width: 50px;\n        height: 50px;\n        left: calc(50% - 25px);\n        top: auto\n    }\n}\n\n.main-image-container div.splash-video-play-button:hover {\n    opacity: .65\n}\n\n.main-image-container div.splash-video-play-button.splash-video-left {\n    left: 50%;\n    transform: translateX(-50%)\n}\n\n@media \\0 screen\\,screen\\9 and (max-width: 991.98px),\nscreen\\0 and (max-width:991.98px) {\n    .main-image-container div.splash-video-play-button.splash-video-left {\n        top: 50%\n    }\n}\n\n.main-image-container img {\n    width: 100%\n}\n\n#cboxOverlay,\n#cboxWrapper,\n#colorbox {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 9999;\n    overflow: hidden\n}\n\n#cboxOverlay {\n    position: fixed;\n    width: 100%;\n    height: 100%\n}\n\n#cboxBottomLeft,\n#cboxMiddleLeft {\n    clear: left\n}\n\n#cboxContent {\n    position: relative;\n    background-color: transparent !important;\n    padding-top: 6.4rem;\n    height: auto;\n    width: inherit !important;\n    height: inherit !important\n}\n\n@media (max-width: 767.98px) {\n    #cboxContent {\n        padding-top: 4.8rem\n    }\n}\n\n@media (min-width: 768px) {\n    #cboxContent {\n        padding-top: 4.8rem\n    }\n}\n\n@media (min-width: 992px) {\n    #cboxContent {\n        padding-top: 4.8rem\n    }\n}\n\n@media screen and (orientation: landscape) {\n    #cboxContent {\n        padding-top: 5.1rem\n    }\n}\n\n#cboxLoadedContent {\n    overflow: hidden\n}\n\n#cboxTitle {\n    margin: 0\n}\n\n#cboxLoadingGraphic,\n#cboxLoadingOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%\n}\n\n#cboxContent,\n#cboxLoadedContent,\n#colorbox {\n    -moz-box-sizing: content-box;\n    -webkit-box-sizing: content-box;\n    box-sizing: content-box\n}\n\ndiv#cboxLoadedContent {\n    width: inherit !important;\n    height: inherit !important;\n    overflow: hidden !important\n}\n\n#cboxOverlay {\n    background-color: rgba(4, 30, 66, .95)\n}\n\n#colorbox {\n    outline: 0\n}\n\n#cboxWrapper {\n    background: 0 0;\n    -moz-border-radius: 5px;\n    -webkit-border-radius: 5px;\n    border-radius: 5px;\n    width: inherit !important;\n    height: inherit !important;\n    overflow: hidden !important\n}\n\n#cboxTopLeft {\n    width: 15px;\n    height: 15px\n}\n\n#cboxTopCenter {\n    height: 15px\n}\n\n#cboxTopRight {\n    width: 15px;\n    height: 15px\n}\n\n#cboxBottomLeft {\n    width: 15px;\n    height: 10px\n}\n\n#cboxBottomCenter {\n    height: 10px\n}\n\n#cboxBottomRight {\n    width: 15px;\n    height: 10px\n}\n\n#cboxMiddleLeft {\n    width: 15px\n}\n\n#cboxMiddleRight {\n    width: 15px\n}\n\n#cboxContent {\n    background: 0 0;\n    overflow: hidden\n}\n\n#cboxError {\n    padding: 50px;\n    border: none\n}\n\n#cboxLoadedContent {\n    margin-bottom: 28px\n}\n\n#cboxTitle {\n    position: absolute;\n    background: 0 0;\n    bottom: 28px;\n    left: 0;\n    color: #535353;\n    width: 100%;\n    padding: 4px 6px;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box\n}\n\nbutton#cboxClose {\n    position: absolute;\n    /* background: url(/src/images/icons/close-button-light.svg) no-repeat; */\n    background-position: center center;\n    background-size: contain;\n    width: 3.5rem;\n    height: 3.5rem;\n    text-indent: -9999px;\n    top: 0;\n    border: none;\n    right: 7px\n}\n\nbutton#cboxClose:hover {\n    /* background: url(/src/images/icons/close-button-dark.svg) no-repeat; */\n    background-position: center center;\n    background-size: contain\n}\n\nbutton#cboxClose:active {\n    outline: 0\n}\n\n@media (min-width: 768px) and (max-width:1199.98px) {\n    button#cboxClose {\n        width: 3.2rem;\n        height: 3.2rem\n    }\n}\n\n@media (max-width: 767.98px) {\n    button#cboxClose {\n        width: 2.8rem;\n        height: 2.8rem\n    }\n}\n\n.video-embed-field-responsive-modal {\n    overflow: hidden;\n    padding-bottom: 56.25%;\n    position: relative;\n    height: 0;\n    box-sizing: border-box\n}\n\n.video-embed-field-responsive-modal iframe {\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    position: absolute\n}\n\ndiv#colorbox {\n    background: 0 0;\n    max-width: calc(177.777778vh - 40px);\n    width: 100%;\n    overflow: hidden !important;\n    left: 50% !important;\n    top: 45% !important;\n    transform: translate(-50%, -50%);\n    position: fixed !important\n}\n\n@media screen and (orientation: landscape) {\n    div#colorbox {\n        width: 65vw !important;\n        height: calc(42vw + 3.2rem) !important\n    }\n}\n\n@media screen and (orientation: portrait) {\n    div#colorbox {\n        width: 85vw !important;\n        height: calc(61vw + 8rem) !important\n    }\n}\n\ndiv#cboxContent,\ndiv.video-embed-field-responsive-modal {\n    background: 0 0;\n    max-width: calc(177.777778vh - 70px);\n    width: 100%;\n    overflow: hidden !important\n}\n\n@media screen and (orientation: landscape) {\n\n    div#cboxContent,\n    div.video-embed-field-responsive-modal {\n        width: calc(65vw - 30px) !important;\n        height: calc(36vw + 4.8rem) !important\n    }\n}\n\n@media screen and (orientation: portrait) {\n\n    div#cboxContent,\n    div.video-embed-field-responsive-modal {\n        width: calc(85vw - 30px) !important;\n        height: calc(47vw + 4.8rem) !important\n    }\n}\n\n.layout__black .webform-block,\n.layout__blue .webform-block,\n.layout__dark_grey .webform-block,\n.layout__light_blue .webform-block {\n    color: #fff\n}\n\n.webform-block .webform-submission-form>.form-item>input {\n    width: auto\n}\n\n.webform-block .webform-submission-form .mandatory-label {\n    float: right;\n    font-size: 1.4rem;\n    padding-top: 23px;\n    color: #04325e\n}\n\n@media screen and (max-width: 767px) {\n    .webform-block .webform-submission-form .mandatory-label {\n        margin-top: -55px;\n        color: #041e42\n    }\n}\n\n.webform-block .webform-submission-form .form-item .option {\n    font-weight: 400;\n    margin-left: .3rem\n}\n\n.webform-block .webform-submission-form .form-item .form-required {\n    font-weight: 600;\n    margin-left: .3rem\n}\n\n@media screen and (min-width: 768px) {\n    .webform-block .webform-submission-form .form-item input::placeholder {\n        color: transparent\n    }\n\n    .webform-block .webform-submission-form .form-item ::-webkit-input-placeholder {\n        color: transparent\n    }\n\n    .webform-block .webform-submission-form .form-item :-moz-placeholder {\n        color: transparent\n    }\n\n    .webform-block .webform-submission-form .form-item ::-moz-placeholder {\n        color: transparent\n    }\n\n    .webform-block .webform-submission-form .form-item :-ms-input-placeholder {\n        color: transparent\n    }\n}\n\n.webform-block .webform-submission-form .form-item .fieldset-legend {\n    font-size: 1.8rem;\n    line-height: 1.45em;\n    letter-spacing: 0;\n    opacity: 1;\n    font-weight: 600\n}\n\n.webform-block .webform-submission-form .form-item .form-checkbox,\n.webform-block .webform-submission-form .form-item .form-radio {\n    width: auto\n}\n\n.webform-block .webform-submission-form .form-item .form-date,\n.webform-block .webform-submission-form .form-item .form-email,\n.webform-block .webform-submission-form .form-item .form-number,\n.webform-block .webform-submission-form .form-item .form-tel,\n.webform-block .webform-submission-form .form-item .form-text,\n.webform-block .webform-submission-form .form-item .form-url {\n    display: block;\n    margin-top: .4rem;\n    width: 100%;\n    background-color: #f2f6f8;\n    border-bottom: 3px solid #bdbfc1;\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    color: #04325e;\n    box-shadow: none;\n    border-radius: 0;\n    padding-left: 20px;\n    font-size: 1.8rem\n}\n\n.webform-block .webform-submission-form .form-item .form-date:focus,\n.webform-block .webform-submission-form .form-item .form-email:focus,\n.webform-block .webform-submission-form .form-item .form-number:focus,\n.webform-block .webform-submission-form .form-item .form-tel:focus,\n.webform-block .webform-submission-form .form-item .form-text:focus,\n.webform-block .webform-submission-form .form-item .form-url:focus {\n    border-color: none;\n    border-bottom: 3px solid #41b6e6\n}\n\n@media screen and (max-width: 767px) {\n\n    .webform-block .webform-submission-form .form-item .form-date:focus,\n    .webform-block .webform-submission-form .form-item .form-email:focus,\n    .webform-block .webform-submission-form .form-item .form-number:focus,\n    .webform-block .webform-submission-form .form-item .form-tel:focus,\n    .webform-block .webform-submission-form .form-item .form-text:focus,\n    .webform-block .webform-submission-form .form-item .form-url:focus {\n        border-bottom: 2px solid #41b6e6\n    }\n}\n\n@media screen and (min-width: 1025px) {\n\n    .webform-block .webform-submission-form .form-item .form-date,\n    .webform-block .webform-submission-form .form-item .form-email,\n    .webform-block .webform-submission-form .form-item .form-number,\n    .webform-block .webform-submission-form .form-item .form-tel,\n    .webform-block .webform-submission-form .form-item .form-text,\n    .webform-block .webform-submission-form .form-item .form-url {\n        height: 60px\n    }\n}\n\n@media screen and (max-width: 767px) {\n\n    .webform-block .webform-submission-form .form-item .form-date,\n    .webform-block .webform-submission-form .form-item .form-email,\n    .webform-block .webform-submission-form .form-item .form-number,\n    .webform-block .webform-submission-form .form-item .form-tel,\n    .webform-block .webform-submission-form .form-item .form-text,\n    .webform-block .webform-submission-form .form-item .form-url {\n        padding-left: 10px;\n        height: 40px;\n        font-size: 1.9rem;\n        border-bottom: none;\n        color: #8a8d8f\n    }\n}\n\n.webform-block .webform-submission-form .form-item .form-select {\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    width: 100%;\n    padding-left: 20px;\n    border-bottom: 3px solid #bdbfc1;\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    box-shadow: none;\n    border-radius: 0;\n    background: #f2f6f8 0 0 url(/src/images/icons/chevron-down.svg) no-repeat padding-box;\n    background-size: 13px 8px;\n    background-position: right 13px bottom 20px\n}\n\n.webform-block .webform-submission-form .form-item .form-select::-ms-expand {\n    display: none\n}\n\n@media screen and (max-width: 767px) {\n    .webform-block .webform-submission-form .form-item .form-select {\n        font-weight: 400;\n        font-size: 1.9rem;\n        padding-left: 10px;\n        height: 40px;\n        border-bottom: none\n    }\n}\n\n.webform-block .webform-submission-form .form-item .form-select:focus {\n    border-color: none;\n    border-bottom: 3px solid #41b6e6\n}\n\n@media screen and (max-width: 767px) {\n    .webform-block .webform-submission-form .form-item .form-select:focus {\n        border-bottom: 2px solid #41b6e6\n    }\n}\n\n@media screen and (min-width: 1025px) {\n    .webform-block .webform-submission-form .form-item .form-select {\n        height: 60px;\n        color: #04325e;\n        font-weight: 400;\n        font-size: 1.8rem\n    }\n}\n\n.webform-block .webform-submission-form .form-item .form-textarea {\n    height: 200px;\n    font-size: 1.8rem;\n    color: #041e42;\n    width: 100%;\n    padding-left: 20px;\n    border: 3px solid #bdbfc1\n}\n\n@media screen and (max-width: 767px) {\n    .webform-block .webform-submission-form .form-item .form-textarea {\n        padding-left: 10px;\n        background-color: #f2f6f8;\n        border: none;\n        font-size: 1.4rem\n    }\n}\n\n.webform-block .webform-submission-form .form-item .form-textarea:focus {\n    border: 3px solid #41b6e6;\n    outline: 0\n}\n\n@media screen and (max-width: 767px) {\n    .webform-block .webform-submission-form .form-item .form-textarea:focus {\n        border: 2px solid #41b6e6\n    }\n}\n\n.webform-block .webform-submission-form .form-item .form-managed-file {\n    position: relative\n}\n\n.webform-block .webform-submission-form .form-item .form-managed-file .form-wrapper {\n    margin-bottom: 20px\n}\n\n@media screen and (max-width: 767px) {\n    .webform-block .webform-submission-form .form-item input {\n        margin-bottom: 10px\n    }\n}\n\n.webform-block .webform-submission-form .input-file {\n    position: absolute;\n    opacity: 0;\n    left: 0;\n    top: 0;\n    height: 100%;\n    z-index: 2;\n    cursor: pointer\n}\n\n.webform-block .webform-submission-form .input-file:hover~.btn-secondary.btn__upload,\n.webform-block .webform-submission-form .input-file:hover~.btn__upload.btn--inverted {\n    box-shadow: 0 0 0 3px var(--color-light-blue);\n    color: var(--color-light-blue);\n    background-color: transparent;\n    cursor: pointer\n}\n\n.webform-block .webform-submission-form .input-file:hover~.btn-secondary.btn__upload:before,\n.webform-block .webform-submission-form .input-file:hover~.btn__upload.btn--inverted:before {\n    background-color: var(--color-light-blue)\n}\n\n.webform-block .webform-submission-form .webform-button--submit {\n    margin-bottom: 1.6rem\n}\n\n@media (min-width: 576px) {\n    .webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .webform-elements {\n        display: flex\n    }\n}\n\n.webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item {\n    display: inline-block;\n    width: min-content\n}\n\n.webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item input {\n    height: 50px;\n    width: 375px;\n    border-radius: 25px;\n    border-color: #041e42;\n    padding: 1px 15px;\n    margin-right: 15px;\n    outline: 0\n}\n\n@media (max-width: 767.98px) {\n    .webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item input {\n        width: 32rem\n    }\n}\n\n.webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description {\n    font-style: italic;\n    padding-top: 10px\n}\n\n.webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description a {\n    font-weight: 600\n}\n\n.webform-block .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-actions {\n    display: inline-block;\n    vertical-align: top\n}\n\n.webform-block .webform-submission-form .webform-progress-tracker .progress-step .progress-marker {\n    background-color: #8a8d8f;\n    padding-bottom: 0\n}\n\n.webform-block .webform-submission-form .webform-progress-tracker .progress-step .progress-text {\n    color: #8a8d8f\n}\n\n.webform-block .webform-submission-form .webform-progress-tracker .progress-step.is-complete .progress-marker {\n    background-color: #041e42\n}\n\n.webform-block .webform-submission-form .webform-progress-tracker .progress-step.is-complete .progress-text {\n    color: #041e42\n}\n\n.webform-block .webform-submission-form .webform-progress-tracker .progress-step.is-active .progress-marker {\n    background-color: #41b6e6\n}\n\n.webform-block .webform-submission-form .webform-progress-tracker .progress-step.is-active .progress-text {\n    color: #41b6e6\n}\n\n.webform-block .webform-submission-form .form-item .form-required:after {\n    content: \" *\"\n}\n\n.webform-block .webform-submission-form .form__text-area--html {\n    height: 200px;\n    background-color: #ededed;\n    font-size: 1.8rem;\n    color: #041e42;\n    overflow-y: scroll;\n    width: 100%;\n    padding-left: 20px;\n    border: 3px solid #bdbfc1\n}\n\n.webform-block .layout__black .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item input,\n.webform-block .layout__blue .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item input {\n    border: none\n}\n\n.webform-block .layout__black .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description,\n.webform-block .layout__blue .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description {\n    color: #fff\n}\n\n.webform-block .layout__black .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description a,\n.webform-block .layout__blue .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description a {\n    color: #fff\n}\n\n.webform-block .layout__black .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description a:hover,\n.webform-block .layout__blue .webform-submission-form.webform-submission-request-early-access-form:not(.webform-submission-request-early-access-liveline-add-form) .form-item .webform-element-description a:hover {\n    color: #fff\n}\n\n.webform-block .ui-dialog-buttonpane .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover,\n.webform-block .ui-dialog-buttonpane .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover,\n.webform-block .ui-dialog-buttonpane .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover,\n.webform-block .webform-submission-form .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover,\n.webform-block .webform-submission-form .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover,\n.webform-block .webform-submission-form .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):hover {\n    background-position: 92% center;\n    transition: all .6s ease\n}\n\n@media screen and (max-width: 767px) {\n\n    .webform-block .ui-dialog-buttonpane .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),\n    .webform-block .ui-dialog-buttonpane .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),\n    .webform-block .ui-dialog-buttonpane .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),\n    .webform-block .webform-submission-form .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),\n    .webform-block .webform-submission-form .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),\n    .webform-block .webform-submission-form .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn) {\n        margin-left: 0;\n        margin-top: 1.2rem\n    }\n}\n\n@media screen and (min-width: 1025px) {\n\n    .webform-block .ui-dialog-buttonpane .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),\n    .webform-block .ui-dialog-buttonpane .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),\n    .webform-block .ui-dialog-buttonpane .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),\n    .webform-block .webform-submission-form .webform-button--next:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),\n    .webform-block .webform-submission-form .webform-button--previous:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn),\n    .webform-block .webform-submission-form .webform-button--submit:not(.btn):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn) {\n        float: right\n    }\n}\n\n.webform-block .ui-dialog-buttonpane .webform-button--previous,\n.webform-block .webform-submission-form .webform-button--previous {\n    background-position: 13% center;\n    /* background-image: url(/src/images/icons/arrow-previous-white.svg); */\n    padding: 14px 20px 15px 55px\n}\n\n.webform-block .ui-dialog-buttonpane .webform-button--previous:hover,\n.webform-block .webform-submission-form .webform-button--previous:hover {\n    background-position: 8% center\n}\n\n@media screen and (min-width: 1025px) {\n\n    .webform-block .ui-dialog-buttonpane .webform-button--previous,\n    .webform-block .webform-submission-form .webform-button--previous {\n        float: left\n    }\n}\n\n.webform-block .checkbox-text-align.js-form-type-checkbox {\n    display: inline-flex;\n    align-items: baseline\n}\n\n.webform-block .checkbox-text-align.js-form-type-checkbox .form-checkbox {\n    margin-right: 5px\n}\n\n.webform-confirmation-modal--content a {\n    color: var(--link-color)\n}\n\n.webform-confirmation-modal--content a:hover {\n    color: var(--link-hover-color)\n}\n\n.webform-submission-privacy-rights-form .js-form-type-textfield {\n    margin-top: 14px\n}\n\n.webform-submission-privacy-rights-form .js-form-type-email {\n    margin-top: 32px\n}\n\n.webform-submission-privacy-rights-form .js-form-type-textarea {\n    margin-top: 32px\n}\n\n.webform-submission-privacy-rights-form .js-form-type-textarea label {\n    font-weight: 700\n}\n\n.webform-submission-privacy-rights-form .js-form-type-checkbox label {\n    width: 90%;\n    vertical-align: top\n}\n\n.webform-submission-privacy-rights-form .js-form-type-checkbox:not(:first-of-type) {\n    margin-top: 24px\n}\n\n.webform-submission-privacy-rights-form #edit-action-to-take--wrapper.checkboxes--wrapper {\n    margin-top: 48px\n}\n\n.webform-submission-privacy-rights-form #edit-action-to-take--wrapper.checkboxes--wrapper .fieldset-wrapper {\n    margin-top: 11px\n}\n\n.webform-submission-privacy-rights-form .js-form-item-i-agree-to-the-processing-of-my-data-by-premier-tech-ltd-in-orde {\n    margin-top: 64px !important\n}\n\n.webform-submission-privacy-rights-form .js-form-item-i-agree-to-the-processing-of-my-data-by-premier-tech-ltd-in-orde label {\n    font-size: 12px;\n    margin-top: .4rem;\n    color: #54585a\n}\n\n.webform-submission-privacy-rights-form .description .webform-element-description {\n    font-size: 12px;\n    margin-left: 20px;\n    color: #54585a\n}\n\n.webform-submission-privacy-rights-form .webform-button--submit {\n    margin-top: 48px\n}\n\n.form-item-telephone .iti--allow-dropdown {\n    width: 100%;\n    margin-top: 4px\n}\n\n@media screen and (min-width: 1025px) {\n    .form-item-telephone .iti--allow-dropdown {\n        height: 60px\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .form-item-telephone .iti--allow-dropdown {\n        height: 40px\n    }\n}\n\n.form-item-telephone .iti--allow-dropdown .webform-webform-telephone-international#edit-telephone {\n    padding-left: 50px\n}\n\n.webform-submission-downtime-calculator-form {\n    margin: 64px 0\n}\n\n.webform-submission-downtime-calculator-form #edit-general {\n    padding-right: 30px\n}\n\n.webform-submission-downtime-calculator-form #edit-sec-1,\n.webform-submission-downtime-calculator-form #edit-sec-2,\n.webform-submission-downtime-calculator-form #edit-sec-3,\n.webform-submission-downtime-calculator-form #edit-sec-4 {\n    margin: 24px 0\n}\n\n.webform-submission-downtime-calculator-form #edit-sec-1 .h2,\n.webform-submission-downtime-calculator-form #edit-sec-2 .h2,\n.webform-submission-downtime-calculator-form #edit-sec-3 .h2,\n.webform-submission-downtime-calculator-form #edit-sec-4 .h2 {\n    font-size: 30px\n}\n\n.webform-submission-downtime-calculator-form #edit-sec-1 .h3,\n.webform-submission-downtime-calculator-form #edit-sec-2 .h3,\n.webform-submission-downtime-calculator-form #edit-sec-3 .h3,\n.webform-submission-downtime-calculator-form #edit-sec-4 .h3 {\n    font-size: 24px\n}\n\n.webform-submission-downtime-calculator-form .js-form-type-number,\n.webform-submission-downtime-calculator-form .js-webform-computed {\n    margin-bottom: 32px\n}\n\n.webform-submission-downtime-calculator-form #edit-border {\n    border: 1px solid;\n    border-radius: 8px;\n    padding: 24px;\n    margin-right: 16px\n}\n\n.webform-submission-downtime-calculator-form #edit-border .js-webform-computed {\n    margin: 0\n}\n\n.webform-submission-downtime-calculator-form .js-form-type-number label {\n    font-size: 16px;\n    font-weight: 700\n}\n\n.webform-submission-downtime-calculator-form .js-webform-computed {\n    font-size: 16px;\n    font-weight: 700\n}\n\n.webform-submission-downtime-calculator-form .js-webform-computed label {\n    display: block;\n    font-weight: 400;\n    font-size: 16px\n}\n\n.webform-submission-downtime-calculator-form .js-webform-computed .form-item-total {\n    font-size: 24px\n}\n\n.webform-submission-downtime-calculator-form .js-webform-computed .form-item-profit-loss {\n    border-bottom: 1px solid;\n    padding-bottom: 18px\n}\n\n.webform-submission-downtime-calculator-form .js-webform-computed .form-item-profit-loss label {\n    font-weight: 700;\n    font-size: 16px\n}\n\n.webform-submission-downtime-calculator-form .js-webform-computed .form-item-employee-pay-loss,\n.webform-submission-downtime-calculator-form .js-webform-computed .form-item-profit-loss {\n    margin-bottom: 12px\n}\n\n.webform-submission-downtime-calculator-form .webform-computed-loading {\n    background-color: #fff\n}\n\n@media screen and (max-width: 767px) {\n\n    .webform-submission-downtime-calculator-form #edit-employee-pay-loss-l,\n    .webform-submission-downtime-calculator-form #edit-profit-loss-l {\n        padding-right: 0\n    }\n}\n\n.webform-submission-bon-de-commande-ecoflo-rewatec-q-form table[id^=edit-commande-canada-optional-2-items] thead,\n.webform-submission-bon-de-commande-ecoflo-rewatec-q-form table[id^=edit-commande-optional-2-items] thead {\n    display: none\n}\n\n.threesixty {\n    background-repeat: no-repeat;\n    background-position: top;\n    background-color: #fff;\n    background-size: contain\n}\n\n.threesixty.threesixty-teaser {\n    width: inherit !important;\n    height: inherit !important;\n    overflow: hidden !important\n}\n\n.pt-text--xlarge {\n    display: block;\n    font-size: 5rem;\n    line-height: 6.3rem;\n    font-weight: 900;\n    font-family: Axiforma\n}\n\n.style--xlarge {\n    display: block;\n    font-size: 5rem;\n    line-height: 6.3rem;\n    font-weight: 900;\n    font-family: Axiforma\n}\n\nxlarge {\n    display: block;\n    font-size: 5rem;\n    line-height: 6.3rem;\n    font-weight: 900;\n    font-family: Axiforma\n}\n\n.pt-text--h1 {\n    display: block;\n    font-size: 3.6rem;\n    line-height: 6.3rem;\n    font-weight: 900;\n    font-family: Axiforma\n}\n\n.cke_editable .title.title--big,\n.style--h1,\n.wysiwyg .title.title--big {\n    display: block;\n    font-size: 3.6rem;\n    line-height: 6.3rem;\n    font-weight: 900;\n    font-family: Axiforma\n}\n\nh1 {\n    display: block;\n    font-size: 3.6rem;\n    line-height: 6.3rem;\n    font-weight: 900;\n    font-family: Axiforma\n}\n\n.pt-text--h2 {\n    display: block;\n    font-size: 3rem;\n    line-height: 5rem;\n    font-weight: 700;\n    font-family: Axiforma\n}\n\n.cke_editable .title,\n.style--h2,\n.wysiwyg .title {\n    display: block;\n    font-size: 3rem;\n    line-height: 5rem;\n    font-weight: 700;\n    font-family: Axiforma\n}\n\nh2 {\n    display: block;\n    font-size: 3rem;\n    line-height: 5rem;\n    font-weight: 700;\n    font-family: Axiforma\n}\n\n.pt-text--h3 {\n    display: block;\n    font-size: 2.4rem;\n    line-height: 4.3rem;\n    font-weight: 700;\n    font-family: Axiforma\n}\n\n.style--h3 {\n    display: block;\n    font-size: 2.4rem;\n    line-height: 4.3rem;\n    font-weight: 700;\n    font-family: Axiforma\n}\n\nh3 {\n    display: block;\n    font-size: 2.4rem;\n    line-height: 4.3rem;\n    font-weight: 700;\n    font-family: Axiforma\n}\n\n.pt-text--h4 {\n    display: block;\n    font-size: 2rem;\n    line-height: 3.3rem;\n    font-weight: 700;\n    font-family: Axiforma\n}\n\n.style--h4 {\n    display: block;\n    font-size: 2rem;\n    line-height: 3.3rem;\n    font-weight: 700;\n    font-family: Axiforma\n}\n\nh4 {\n    display: block;\n    font-size: 2rem;\n    line-height: 3.3rem;\n    font-weight: 700;\n    font-family: Axiforma\n}\n\n.pt-text--normal {\n    display: block;\n    font-size: 1.8rem;\n    line-height: 3rem;\n    font-weight: 400;\n    font-family: Axiforma\n}\n\n.style--normal {\n    display: block;\n    font-size: 1.8rem;\n    line-height: 3rem;\n    font-weight: 400;\n    font-family: Axiforma\n}\n\nnormal {\n    display: block;\n    font-size: 1.8rem;\n    line-height: 3rem;\n    font-weight: 400;\n    font-family: Axiforma\n}\n\n.pt-text--small {\n    display: block;\n    font-size: 1.4rem;\n    line-height: 2.8rem;\n    font-weight: 400;\n    font-family: Axiforma\n}\n\n.style--small {\n    display: block;\n    font-size: 1.4rem;\n    line-height: 2.8rem;\n    font-weight: 400;\n    font-family: Axiforma\n}\n\nsmall {\n    display: block;\n    font-size: 1.4rem;\n    line-height: 2.8rem;\n    font-weight: 400;\n    font-family: Axiforma\n}\n\n.pt-text--legal {\n    display: block;\n    font-size: 1.2rem;\n    line-height: 1.8rem;\n    font-weight: 400;\n    font-family: Axiforma\n}\n\n.style--legal {\n    display: block;\n    font-size: 1.2rem;\n    line-height: 1.8rem;\n    font-weight: 400;\n    font-family: Axiforma\n}\n\nlegal {\n    display: block;\n    font-size: 1.2rem;\n    line-height: 1.8rem;\n    font-weight: 400;\n    font-family: Axiforma\n}\n\n.pt-text--big-margin {\n    margin-bottom: 5rem\n}\n\n.pt-text--small-margin {\n    margin-bottom: 5rem\n}\n\n.pt-text--primary {\n    color: #041e42\n}\n\n.pt-text--secondary {\n    color: #41b6e6\n}\n\n.pt-text--tertiary {\n    color: #54585a\n}\n\n.btn__upload--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__upload:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__upload--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__upload--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__upload:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__upload:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__upload--before:hover:after,\n.btn__upload--before:hover:before,\n.btn__upload:hover:after,\n.btn__upload:hover:before {\n    -webkit-mask-position: center, center 0\n}\n\n.btn__upload--before:before,\n.btn__upload:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/upload-file-down.svg), url(/src/images/icons/upload-file-up.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/upload-file-down.svg), url(/src/images/icons/upload-file-up.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease\n}\n\n.btn__upload:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__upload--before:before {\n    content: \"\";\n    margin-right: 10px\n}\n\n.btn__download--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.cke_editable .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.cke_editable .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.wysiwyg .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.wysiwyg .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__download--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__download--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.cke_editable .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.cke_editable .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.cke_editable .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.cke_editable .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.wysiwyg .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.wysiwyg .link--download-outline:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.wysiwyg .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.wysiwyg .link--download:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__download--before:hover:after,\n.btn__download--before:hover:before,\n.btn__download:hover:after,\n.btn__download:hover:before,\n.cke_editable .link--download-outline:hover:after,\n.cke_editable .link--download-outline:hover:before,\n.cke_editable .link--download:hover:after,\n.cke_editable .link--download:hover:before,\n.wysiwyg .link--download-outline:hover:after,\n.wysiwyg .link--download-outline:hover:before,\n.wysiwyg .link--download:hover:after,\n.wysiwyg .link--download:hover:before {\n    -webkit-mask-position: center center, center 70%\n}\n\n.btn__download--before:before,\n.btn__download:after,\n.cke_editable .link--download-outline:before,\n.cke_editable .link--download:after,\n.wysiwyg .link--download-outline:before,\n.wysiwyg .link--download:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/upload-file-down.svg), url(/src/images/icons/download-file-up.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/upload-file-down.svg), url(/src/images/icons/download-file-up.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease\n}\n\n.btn__download:after,\n.cke_editable .link--download:after,\n.wysiwyg .link--download:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__download--before:before,\n.cke_editable .link--download-outline:before,\n.wysiwyg .link--download-outline:before {\n    content: \"\";\n    margin-right: 10px\n}\n\n.btn__video--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__video:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__video--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__video--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__video:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__video:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__video--before:hover:after,\n.btn__video--before:hover:before,\n.btn__video:hover:after,\n.btn__video:hover:before {\n    -webkit-mask-position: center, center\n}\n\n.btn__video--before:before,\n.btn__video:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/play-circle.svg), url(/src/images/icons/play-icon.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/play-circle.svg), url(/src/images/icons/play-icon.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease\n}\n\n.btn__video:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__video--before:before {\n    content: \"\";\n    margin-right: 10px\n}\n\n.btn__arrow--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__arrow:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__arrow--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__arrow--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__arrow:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__arrow:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__arrow--before:hover:after,\n.btn__arrow--before:hover:before,\n.btn__arrow:hover:after,\n.btn__arrow:hover:before {\n    transform: translateX(5px)\n}\n\n.btn__arrow--before:hover:before,\n.btn__arrow:hover:before {\n    transform: rotate(180deg) translateY(1px) translateX(5px)\n}\n\n.btn__arrow--before:before,\n.btn__arrow:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/arrow-next-dark-blue.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/arrow-next-dark-blue.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease\n}\n\n.btn__arrow:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__arrow--before:before {\n    content: \"\";\n    margin-right: 10px;\n    transform: rotate(180deg) translateY(1px)\n}\n\n.btn__redirection--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__redirection:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__redirection--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__redirection--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__redirection:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__redirection:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__redirection--before:before,\n.btn__redirection:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/redirection_icon.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/redirection_icon.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease\n}\n\n.btn__redirection:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__redirection--before:before {\n    content: \"\";\n    margin-right: 10px\n}\n\n.btn__plus--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__plus:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__plus--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__plus--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__plus:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__plus:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__plus--before:before,\n.btn__plus:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/plus.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/plus.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;\n    min-width: 12px;\n    width: 12px;\n    height: 12px\n}\n\n.btn__plus:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__plus--before:before {\n    content: \"\";\n    margin-right: 10px\n}\n\n.btn__delete--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__delete:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__delete--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__delete--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__delete:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__delete:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__delete--before:before,\n.btn__delete:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/trash.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/trash.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;\n    min-width: 12px;\n    width: 12px\n}\n\n.btn__delete:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__delete--before:before {\n    content: \"\";\n    margin-right: 10px\n}\n\n.btn__x--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__x:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__x--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__x--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__x:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__x:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__x--before:before,\n.btn__x:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/cross.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/cross.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;\n    width: 20px;\n    height: 30px\n}\n\n.btn__x:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__x--before:before {\n    content: \"\";\n    margin-right: 10px\n}\n\n.btn__mail--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__mail:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__mail--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__mail--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__mail:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__mail:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__mail--before:before,\n.btn__mail:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/enveloppe-icon.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/enveloppe-icon.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;\n    mask-size: auto;\n    -webkit-mask-size: auto;\n    margin-right: 0 !important\n}\n\n.btn__mail:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__mail--before:before {\n    content: \"\";\n    margin-right: 10px\n}\n\n.btn__phone--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__phone:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__phone--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__phone--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__phone:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__phone:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__phone--before:before,\n.btn__phone:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/icon-telephone.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/icon-telephone.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;\n    mask-size: auto;\n    -webkit-mask-size: auto;\n    margin-right: 0 !important\n}\n\n.btn__phone:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__phone--before:before {\n    content: \"\";\n    margin-right: 10px\n}\n\n.btn__external-link--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary),\n.btn__external-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-color)\n}\n\n.btn__external-link--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__external-link--before:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before,\n.btn__external-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):after,\n.btn__external-link:not(.btn):not(.btn--inverted):not(.btn-primary):not(.btn-100-primary):not(a.btn-100-primary):not(.btn):not(a.btn):not(.btn-secondary):not(.btn--inverted):not(.btn-tertiary):not(.btn-100-primary):not(.btn-100-secondary):not(.btn-100-tertiary):before {\n    background-color: var(--text-color)\n}\n\n.btn__external-link--before:before,\n.btn__external-link:after {\n    position: relative;\n    min-width: 20px;\n    width: 20px;\n    height: 30px;\n    mask-position: center center;\n    mask-size: 100%;\n    mask-repeat: no-repeat;\n    /* mask-image: url(/src/images/icons/icon-external-link.svg); */\n    -webkit-mask-position: center center;\n    -webkit-mask-size: 100%;\n    -webkit-mask-repeat: no-repeat;\n    /* -webkit-mask-image: url(/src/images/icons/icon-external-link.svg); */\n    background-color: var(--text-color);\n    transition: mask-position .3s ease, -webkit-mask-position .3s ease, background-color .3s ease, transform .3s ease;\n    mask-size: auto;\n    -webkit-mask-size: auto;\n    margin-right: 0 !important\n}\n\n.btn__external-link:after {\n    content: \"\";\n    margin-left: 10px\n}\n\n.btn__external-link--before:before {\n    content: \"\";\n    margin-right: 10px\n}\n\n.pager {\n    display: flex\n}\n\n.pager .pager__items {\n    margin: auto\n}\n\n.pager .pager__items .disabled {\n    opacity: .5;\n    cursor: default;\n    pointer-events: none\n}\n\n.pager .pager__items .pager__item--next,\n.pager .pager__items .pager__item--previous {\n    padding: 6px 25px;\n    cursor: pointer;\n    background-color: #f2f6f8;\n    border-radius: 9px;\n    display: inline\n}\n\n.pager .pager__items .pager__item--next a,\n.pager .pager__items .pager__item--previous a {\n    color: #041e42;\n    font-weight: 700;\n    font-size: 16px;\n    vertical-align: middle\n}\n\n.pager .pager__items .pager__item--next a:hover,\n.pager .pager__items .pager__item--previous a:hover {\n    text-decoration: none\n}\n\n@media (max-width: 767.98px) {\n\n    .pager .pager__items .pager__item--next a,\n    .pager .pager__items .pager__item--previous a {\n        padding: 7px\n    }\n}\n\n@media (max-width: 767.98px) {\n\n    .pager .pager__items .pager__item--next a span,\n    .pager .pager__items .pager__item--previous a span {\n        display: none\n    }\n}\n\n@media (max-width: 767.98px) {\n\n    .pager .pager__items .pager__item--next,\n    .pager .pager__items .pager__item--previous {\n        padding: 6px 0;\n        border-radius: 6px\n    }\n}\n\n.pager .pager__items .pager__item--previous:hover:before {\n    right: 12px\n}\n\n@media (max-width: 767.98px) {\n    .pager .pager__items .pager__item--previous:hover:before {\n        right: 6px\n    }\n}\n\n.pager .pager__items .pager__item--previous:before {\n    -webkit-transform: scaleX(-1);\n    -moz-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n    -o-transform: scaleX(-1);\n    transform: scaleX(-1);\n    position: relative;\n    top: 0;\n    content: \" \";\n    display: inline-block;\n    /* background-image: url(/src/images/icons/arrow-next-light-blue-old.svg); */\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 25px 25px;\n    margin-left: 2px;\n    width: 22px;\n    height: 18px;\n    transition: right .5s;\n    right: 5px;\n    vertical-align: middle\n}\n\n@media (max-width: 767.98px) {\n    .pager .pager__items .pager__item--previous:before {\n        height: 14px;\n        background-size: 26px;\n        top: 0;\n        margin-right: 4px;\n        right: -5px\n    }\n}\n\n.pager .pager__items .pager__item--next:hover:after {\n    left: 15px\n}\n\n@media (max-width: 767.98px) {\n    .pager .pager__items .pager__item--next:hover:after {\n        left: 6px\n    }\n}\n\n.pager .pager__items .pager__item--next:after {\n    position: relative;\n    top: 0;\n    content: \" \";\n    display: inline-block;\n    /* background-image: url(/src/images/icons/arrow-next-light-blue-old.svg); */\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 25px 25px;\n    margin-left: 2px;\n    width: 22px;\n    height: 18px;\n    transition: left .5s;\n    left: 8px;\n    vertical-align: middle\n}\n\n@media (max-width: 767.98px) {\n    .pager .pager__items .pager__item--next:after {\n        height: 10px;\n        background-size: 26px;\n        top: 0;\n        left: -5px\n    }\n}\n\n.pager .pager__items .pager__item {\n    position: relative;\n    display: inline;\n    list-style: none;\n    background-color: #f2f6f8;\n    padding: 6px 0\n}\n\n.pager .pager__items .pager__item a {\n    position: relative;\n    color: #041e42;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 4px 18px 4px 20px;\n    vertical-align: middle\n}\n\n@media (max-width: 767.98px) {\n    .pager .pager__items .pager__item a {\n        padding: 10px 12px\n    }\n}\n\n.pager .pager__items .pager__item:not(.selected) a:after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    width: 0;\n    left: 15%;\n    border-bottom: 4px solid #41b6e6;\n    transition: width .3s\n}\n\n.pager .pager__items .pager__item:not(.selected) a:hover:after {\n    width: 75%\n}\n\n.pager .pager__items .pager__item--first {\n    border-radius: 9px\n}\n\n.pager .pager__items .pager__item--first span {\n    color: #41b6e6\n}\n\n@media (max-width: 767.98px) {\n    .pager .pager__items .pager__item--first {\n        display: none\n    }\n}\n\n.pager .pager__items .pager__item--first:not(.selected) a:hover:after {\n    border-bottom: none\n}\n\n.pager .pager__items .pager__item--last {\n    border-radius: 9px\n}\n\n.pager .pager__items .pager__item--last span {\n    color: #41b6e6\n}\n\n@media (max-width: 767.98px) {\n    .pager .pager__items .pager__item--last {\n        display: none\n    }\n}\n\n.pager .pager__items .pager__item--last:not(.selected) a:hover:after {\n    border-bottom: none\n}\n\n.pager .pager__items .pager__item--ellipsis {\n    padding: 6px 20px;\n    margin-right: -4px\n}\n\n@media (max-width: 767.98px) {\n    .pager .pager__items .pager__item--ellipsis {\n        padding: 6px 7px\n    }\n}\n\n.pager .pager__items li:nth-child(3) {\n    border-radius: 9px 0 0 9px\n}\n\n.pager .pager__items li:nth-last-child(3) {\n    border-radius: 0 9px 9px 0\n}\n\n.pager .pager__items li.is-active:nth-child(3),\n.pager .pager__items li.is-active:nth-last-child(3) {\n    border-radius: 7px\n}\n\n.pager .pager__items .is-active {\n    background-color: #41b6e6;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, .1607843137);\n    border-radius: 7px;\n    pointer-events: none;\n    padding: 6px 0;\n    z-index: 1\n}\n\n@media (max-width: 767.98px) {\n    .pager .pager__items .is-active {\n        border-radius: 6px;\n        padding: 7px 0 7px 2px\n    }\n}\n\n.pager .pager__items .is-active a {\n    color: #fff\n}\n\n.menu-dropdown-0 {\n    flex-direction: column\n}\n\n.menu--footer-main-menu {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    font-size: 1.2rem;\n    flex-wrap: wrap\n}\n\n.menu--footer-main-menu li.icon a {\n    display: flex;\n    align-items: center\n}\n\n.menu--footer-main-menu li.icon a::before {\n    display: block;\n    content: \"\";\n    width: 1.2rem;\n    height: 1.2rem;\n    background-size: contain;\n    background-repeat: no-repeat;\n    margin-right: 5px\n}\n\n@media (max-width: 1199.98px) {\n    .menu--footer-main-menu li.icon a::before {\n        width: 1.6rem;\n        height: 1.6rem\n    }\n}\n\n#block-ptbase-child-main-menu>#block-footermainmenu {\n    margin: 45px 0 0 15px;\n    width: 80%;\n    text-align: left;\n    transition: .3s ease-in\n}\n\n#block-ptbase-child-main-menu>#block-footermainmenu.footer-main-menu--hidden {\n    transform: translateX(-200px);\n    position: relative;\n    opacity: 0\n}\n\n@media (min-width: 992px) {\n    #block-ptbase-child-main-menu>#block-footermainmenu {\n        display: none\n    }\n}\n\n#block-ptbase-child-main-menu>#block-footermainmenu .menu--footer-main-menu li {\n    padding: 0;\n    width: 50%;\n    margin-bottom: 10px\n}\n\n#block-ptbase-child-main-menu>#block-footermainmenu .menu--footer-main-menu li a {\n    color: #041e42;\n    text-decoration: underline;\n    font-size: 1.5rem\n}\n\n#block-ptbase-child-main-menu>#block-footermainmenu .footer_main_menu_title_mobile {\n    font-weight: 700\n}\n\n.menu-dropdown-0 .footer-menu {\n    margin-top: 25px;\n    padding-left: 25px;\n    color: #041e42;\n    display: flex;\n    background-color: #f2f6f8;\n    align-items: center;\n    min-height: 40px\n}\n\n@media (max-width: 1199.98px) {\n    .menu-dropdown-0 .footer-menu {\n        display: none\n    }\n}\n\n.menu-dropdown-0 .footer-menu p {\n    margin: 0;\n    color: #54585a;\n    font-size: 1.25rem\n}\n\n.menu-dropdown-0 .footer-menu .menu--footer-main-menu li {\n    padding: 0 15px\n}\n\n.menu-dropdown-0 .footer-menu .menu--footer-main-menu li:not(:first-of-type) {\n    border-left: solid 2px #c7cfd7\n}\n\n.menu-dropdown-0 .footer-menu .menu--footer-main-menu li a {\n    color: #041e42;\n    text-decoration: underline\n}\n\n.menu-dropdown-0 .footer-menu .footer_main_menu_text {\n    display: none\n}\n\n.striped-table {\n    margin-bottom: 2rem\n}\n\n.striped-table tr:nth-child(even) {\n    background-color: #f2f2f2\n}\n\n.drupal-media--slideshow {\n    position: relative\n}\n\n.drupal-media--slideshow .drupal-media__name {\n    position: absolute;\n    left: 40px;\n    bottom: 61px;\n    color: #fff;\n    font-weight: 400;\n    font-size: 1.4rem;\n    text-shadow: 0 1px 3px #000;\n    letter-spacing: .7px\n}\n\n.drupal-media--full-width img {\n    width: 100%;\n    height: auto\n}\n\n.drupal-media .drupal-media__image--full-width img {\n    width: 100%;\n    height: auto\n}\n\n#layout-builder-modal details article .badge-list__image {\n    max-width: 100px\n}\n\n#layout-builder-modal details article .badge-list__image .media__image img {\n    height: 100px\n}\n\n#layout-builder-modal details article .badge-list__text-block {\n    max-width: 175px\n}\n\n#layout-builder-modal details article .badge-list__text-block .badge-list__title {\n    font-size: 1.6rem;\n    margin-top: 10px\n}\n\n.article-category {\n    color: #41b6e6;\n    font-weight: 500;\n    font-size: 1.8rem;\n    line-height: 1.55em\n}\n\n.article-category a:hover {\n    text-decoration: none;\n    color: #41b6e6\n}\n\n.article-category:before {\n    content: \"- \"\n}\n\n.article-short-summary .article-date {\n    font-size: 1.4rem;\n    --text-color: #8A8D8F\n}\n\n.article-up-date:before {\n    content: \"-\";\n    display: inline-block;\n    margin: 0 4px 0 1px\n}\n\n.layout-article .article-date {\n    --text-color: #8A8D8F\n}\n\n.layout-article .node-title {\n    font-weight: 700;\n    font-size: 4rem;\n    line-height: 1.2em;\n    margin-bottom: 0\n}\n\n.layout-article img {\n    width: 100%;\n    height: auto\n}\n\n.layout-article .photo-credit {\n    color: #54585a\n}\n\n.checklist--container {\n    list-style: none;\n    background-color: #fff;\n    border-radius: 5px;\n    border: 1px solid #efefef;\n    padding: 0\n}\n\n.checklist--items:not(:last-of-type) {\n    border-bottom: 1px solid #efefef\n}\n\n.checklist--items:first-of-type {\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px\n}\n\n.checklist--items:last-of-type {\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px\n}\n\n.checklist--items p {\n    margin: 0\n}\n\n.checklist--items .checklist--text {\n    color: #4b4b4b;\n    padding: 10px 0;\n    margin: 0\n}\n\n@media (max-width: 575.98px) {\n    .checklist--items .checklist--text {\n        padding: 10px\n    }\n}\n\n.checklist--items .checklist-row {\n    flex-wrap: unset;\n    width: 100%;\n    margin: 0\n}\n\n.checklist-col {\n    display: flex;\n    flex-direction: column;\n    justify-content: center\n}\n\n.checklist--icon.checkmark {\n    display: block;\n    width: 15px;\n    height: 15px;\n    /* background: url(/src/images/icons/check-checklist.svg); */\n    background-repeat: no-repeat;\n    margin: 0 auto\n}\n\n.checklist--icon.x {\n    display: block;\n    width: 12px;\n    height: 12px;\n    /* background: url(/src/images/icons/x-black-checklist.svg); */\n    background-repeat: no-repeat;\n    margin: 15px auto\n}\n\n.checklist--icon.none {\n    display: block;\n    width: 12px;\n    height: 12px;\n    background-repeat: no-repeat;\n    margin: 15px auto\n}\n\n.media-wistia .video-embed-field-provider-wistia-video:after {\n    padding-bottom: 0\n}\n\n.node-title {\n    font-weight: 700;\n    font-size: 4rem;\n    line-height: 1.2em;\n    margin-bottom: 0\n}\n\n.layout__region--content .node-title {\n    font-size: 5.4rem;\n    line-height: 6.3rem\n}\n\n@media (max-width: 767.98px) {\n    .layout__region--content .node-title {\n        font-size: 3.6rem;\n        line-height: 4.5rem\n    }\n}\n\n.breadcrumb {\n    flex-wrap: unset;\n    font-family: Axiforma\n}\n\n.layout__black .breadcrumb,\n.layout__blue .breadcrumb,\n.layout__dark_grey .breadcrumb,\n.layout__light_blue .breadcrumb {\n    color: #fff\n}\n\n.breadcrumb-item {\n    font-weight: 400;\n    font-size: 1.8rem\n}\n\n.layout__black .breadcrumb-item,\n.layout__blue .breadcrumb-item,\n.layout__dark_grey .breadcrumb-item,\n.layout__light_blue .breadcrumb-item {\n    color: #fff\n}\n\n.breadcrumb-item .breadcrumb-link {\n    color: inherit;\n    position: relative\n}\n\n.breadcrumb-item .breadcrumb-link:after {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    height: 2px;\n    width: 0;\n    background: var(--color-light-blue);\n    bottom: -2px;\n    left: 0;\n    transition: width .3s ease\n}\n\n.breadcrumb-item .breadcrumb-link:hover:after {\n    width: 100%\n}\n\n.breadcrumb-item:last-child {\n    font-weight: 400\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n    color: #54585a;\n    padding-right: .6rem;\n    padding-left: .6rem\n}\n\n.layout__black .breadcrumb-item+.breadcrumb-item::before,\n.layout__blue .breadcrumb-item+.breadcrumb-item::before,\n.layout__dark_grey .breadcrumb-item+.breadcrumb-item::before,\n.layout__light_blue .breadcrumb-item+.breadcrumb-item::before {\n    color: #fff\n}\n\n.breadcrumb-items {\n    display: inherit;\n    overflow-x: auto;\n    white-space: nowrap;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar\n}\n\n.breadcrumb-items::-webkit-scrollbar {\n    display: none\n}\n\n.breadcrumb-back {\n    padding-right: 1rem;\n    flex-direction: column;\n    justify-content: center;\n    padding-bottom: 3px\n}\n\n.breadcrumb-back svg {\n    width: 8px;\n    height: 8px\n}\n\n.breadcrumb-back svg path {\n    stroke: #54585a;\n    stroke-width: 2px\n}\n\n.layout__black .breadcrumb-back svg path,\n.layout__blue .breadcrumb-back svg path,\n.layout__dark_grey .breadcrumb-back svg path,\n.layout__light_blue .breadcrumb-back svg path {\n    stroke: #fff;\n    fill: #fff;\n    stroke-width: 2px\n}\n\n.product-breadcrumb {\n    margin-left: 20px\n}\n\n@media (max-width: 575.98px) {\n    .product-breadcrumb {\n        margin-left: 10px\n    }\n}\n\n@media (max-width: 575.98px) {\n    .product-breadcrumb .breadcrumb-back::after {\n        content: \"\";\n        width: 10vw;\n        height: 100%;\n        position: absolute;\n        left: 16px;\n        top: 0;\n        background: linear-gradient(to left, rgba(255, 255, 255, 0), #fff)\n    }\n}\n\n.product-breadcrumb .breadcrumb-back svg path {\n    stroke: #54585a;\n    stroke-width: 3px\n}\n\n.product-breadcrumb .breadcrumb-back.no-gradient::after {\n    width: 0\n}\n\n.product-breadcrumb .breadcrumb-item,\n.product-breadcrumb .breadcrumb-link {\n    color: #54585a\n}\n\n.layout__black .product-breadcrumb .breadcrumb-item,\n.layout__black .product-breadcrumb .breadcrumb-link,\n.layout__blue .product-breadcrumb .breadcrumb-item,\n.layout__blue .product-breadcrumb .breadcrumb-link,\n.layout__dark_grey .product-breadcrumb .breadcrumb-item,\n.layout__dark_grey .product-breadcrumb .breadcrumb-link,\n.layout__light_blue .product-breadcrumb .breadcrumb-item,\n.layout__light_blue .product-breadcrumb .breadcrumb-link {\n    color: #fff\n}\n\n.listing-breadcrumb {\n    --text-color: #54585A\n}\n\n.listing-breadcrumb .breadcrumb-back svg path {\n    stroke: #54585a;\n    fill: #54585a;\n    stroke-width: 2px\n}\n\n.horizontal_link_menu {\n    background-color: #fff;\n    z-index: 1;\n    height: fit-content;\n    width: 100%;\n    position: relative\n}\n\n.horizontal_link_menu__veil {\n    position: absolute;\n    right: 0;\n    pointer-events: none;\n    height: 100%;\n    transition: opacity .3s ease;\n    background-image: linear-gradient(to right, transparent, #fff)\n}\n\n@media (min-width: 992px) {\n    .horizontal_link_menu__veil--show {\n        opacity: 0\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .horizontal_link_menu__veil--show {\n        display: inline-block;\n        width: 27.5%\n    }\n}\n\n@media (min-width: 768px) {\n    .horizontal_link_menu__veil--show {\n        width: 15%\n    }\n}\n\n@media (min-width: 576px) {\n    .horizontal_link_menu__veil--show {\n        width: 20%\n    }\n}\n\n.horizontal_link_menu__veil--hide {\n    display: none\n}\n\n.horizontal_link_menu__overlay {\n    width: 100%;\n    background-color: inherit\n}\n\n.horizontal_link_menu__title h1,\n.horizontal_link_menu__title h2,\n.horizontal_link_menu__title h3,\n.horizontal_link_menu__title h4 {\n    background-color: inherit;\n    margin: 0 15px 0 15px;\n    padding-bottom: 10px\n}\n\n.horizontal_link_menu--sticky {\n    position: fixed;\n    width: 100%;\n    z-index: 11;\n    top: 0\n}\n\n.horizontal_link_menu--margin {\n    margin-right: 0;\n    margin-left: 0\n}\n\n.horizontal_link_menu__image {\n    display: inline-block;\n    max-width: 200px\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu__image {\n        max-width: 120px\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav {\n    pointer-events: auto;\n    height: fit-content;\n    display: flex;\n    scroll-behavior: smooth;\n    align-items: center;\n    overflow-x: auto;\n    flex-direction: row;\n    flex: 1 1 auto;\n    text-align: center;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar\n}\n\n@media (max-width: 1199.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav {\n        flex: 0 0 20%\n    }\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav {\n        flex: 0 0 30%\n    }\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav {\n        justify-content: left;\n        overflow: auto;\n        flex-flow: nowrap\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav::-webkit-scrollbar {\n    display: none\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav__item {\n    display: inline-block;\n    white-space: nowrap\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn) {\n    color: inherit;\n    font-size: inherit;\n    margin: 0 10px;\n    padding: 8px 10px;\n    text-decoration: none;\n    border-bottom: 2px solid transparent\n}\n\n@media (max-width: 1199.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn) {\n        padding: 8px 0\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn):hover {\n    cursor: pointer;\n    border-bottom: 2px solid #fff;\n    text-decoration: none\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn):hover {\n        border-bottom: 2px solid transparent\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn):active {\n    cursor: pointer;\n    text-decoration: none\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav__item:not(.btn):focus {\n    outline: unset;\n    text-decoration: none\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav__item--borderize:not(.btn) {\n    border-bottom: 2px solid #fff !important\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav__item:not(.horizontal_link_menu_nav__item--borderize) {\n        border-bottom: 2px solid transparent\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav--justify-content-center {\n    justify-content: center\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav--justify-content-center {\n        justify-content: left;\n        overflow: auto;\n        flex-flow: nowrap\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav--justify-content-end {\n    justify-content: flex-end\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav--justify-content-end {\n        justify-content: left;\n        overflow: auto;\n        flex-flow: nowrap\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav--justify-content-start {\n    justify-content: flex-start\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav--justify-content-start {\n        justify-content: left;\n        overflow: auto;\n        flex-flow: nowrap\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav--justify-content-around {\n    justify-content: space-around\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav--justify-content-around {\n        justify-content: left;\n        overflow: auto;\n        flex-flow: nowrap\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav--justify-content-between {\n    justify-content: space-between\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav--justify-content-between {\n        justify-content: left;\n        overflow: auto;\n        flex-flow: nowrap\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav--size_x_small {\n    font-size: .8rem\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav--size_x_small {\n        font-size: .5rem\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav--size_small {\n    font-size: 1.2rem\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav--size_small {\n        font-size: .8rem\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav--size_normal {\n    font-size: 1.6rem\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav--size_normal {\n        font-size: 1.2rem\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav--size_large {\n    font-size: 2rem\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav--size_large {\n        font-size: 1.6rem\n    }\n}\n\n.horizontal_link_menu .horizontal_link_menu_nav--size_x_large {\n    font-size: 2.4rem\n}\n\n@media (max-width: 991.98px) {\n    .horizontal_link_menu .horizontal_link_menu_nav--size_x_large {\n        font-size: 1.8rem\n    }\n}\n\n.region--banner-top {\n    background-color: #dedfe2;\n    display: none;\n    height: 35px;\n    position: fixed;\n    transition: top .3s linear;\n    top: 60px;\n    width: 100%;\n    z-index: 50\n}\n\n.region--banner-top--hidden {\n    top: -60px\n}\n\n.region--banner-top--with-header-bar {\n    top: 60px\n}\n\n@media (min-width: 1200px) {\n    .region--banner-top--with-header-bar {\n        top: 96px\n    }\n}\n\n.region--banner-top--with-header-bar.region--banner-top--hidden {\n    top: -96px\n}\n\n.region--banner-top .banner-top-content {\n    --text-color: #555;\n    text-align: center\n}\n\n.region--banner-top .banner-top-content p {\n    font-size: 1.3rem;\n    line-height: 1.7rem;\n    margin: 0\n}\n\n.region--banner-top .banner-top-close-button {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    right: 0;\n    margin-right: 2.4rem;\n    cursor: pointer\n}\n\n.region--banner-top .banner-top-close-button:hover {\n    opacity: .75\n}\n\n.region--banner-top .banner-top-close-button svg {\n    height: 10px;\n    width: 10px\n}\n\n@media (max-width: 767.98px) {\n    .region--banner-top .banner-top-close-button svg {\n        width: 12px;\n        height: 12px\n    }\n}\n\n.toolbar-horizontal.toolbar-tray-open .region--banner-top--with-header-bar {\n    top: 139px\n}\n\n@media (min-width: 992px) {\n    .toolbar-horizontal.toolbar-tray-open .region--banner-top--with-header-bar {\n        top: 174px\n    }\n}\n\n.toolbar-horizontal.toolbar-tray-open .region--banner-top--with-header-bar.region--banner-top--hidden {\n    top: -96px\n}\n\n.region.region--banner-top.banner-top-enabled {\n    align-items: center;\n    display: flex;\n    justify-content: center\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu {\n        height: 100dvh;\n        position: fixed;\n        max-width: 500px;\n        width: calc(100% - 30px);\n        background-color: #fff;\n        box-shadow: 0 1px 9px rgba(0, 0, 0, .1607843137);\n        overflow-x: hidden;\n        -webkit-overflow-scrolling: touch;\n        overscroll-behavior: contain;\n        z-index: 1200;\n        top: 60px;\n        right: 0;\n        bottom: 0;\n        padding-top: 13px;\n        transition: transform .3s ease;\n        transform: translateX(100%);\n        color: #04325e;\n        font-size: 1.6rem;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start\n    }\n}\n\n@media (max-width: 1199.98px) and (min-width:1200px) {\n    .hamburger-menu {\n        top: 0 !important;\n        overflow-x: auto;\n        z-index: 90\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu--open {\n        transform: translateX(0)\n    }\n\n    .hamburger-menu__close {\n        display: none;\n        text-align: right;\n        color: #41b6e6;\n        padding: 30px 50px\n    }\n}\n\n@media (max-width: 1199.98px) and (min-width:1200px) {\n    .hamburger-menu__close {\n        display: block\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu__close .js-hamburger-close {\n        cursor: pointer;\n        line-height: 18px;\n        vertical-align: middle\n    }\n\n    .hamburger-menu__close .js-hamburger-close .x-icon {\n        width: 16px;\n        height: 16px;\n        transition: transform .3s ease;\n        margin-left: 5px;\n        display: inline-block\n    }\n\n    .hamburger-menu__close .js-hamburger-close:hover .x-icon {\n        transform: scale(.8)\n    }\n\n    .hamburger-menu.scroll-up {\n        top: 49px\n    }\n\n    .hamburger-menu .views-exposed-form {\n        margin: 14px 0 19px;\n        padding: 0 15px\n    }\n}\n\n@media (max-width: 1199.98px) and (min-width:992px) {\n    .hamburger-menu .views-exposed-form {\n        margin-top: 51px\n    }\n}\n\n@media (max-width: 1199.98px) and (min-width:1200px) {\n    .hamburger-menu .views-exposed-form {\n        margin-top: 14px\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu .views-exposed-form .exposed-search {\n        height: 35px\n    }\n\n    .hamburger-menu .views-exposed-form .form-item {\n        flex-grow: 1\n    }\n\n    .hamburger-menu .views-exposed-form .form-text {\n        background-color: #f2f6f8;\n        height: 35px;\n        width: 100%\n    }\n\n    .hamburger-menu .hamburger-menu,\n    .hamburger-menu .main-navigation-menu {\n        margin-bottom: 45px\n    }\n\n    .hamburger-menu .hamburger-menu+.hamburger-menu,\n    .hamburger-menu .main-navigation-menu+.hamburger-menu {\n        margin-bottom: 45px;\n        margin-top: -45px\n    }\n\n    .hamburger-menu .hamburger-menu .menu-item,\n    .hamburger-menu .main-navigation-menu .menu-item {\n        padding: 0 15px\n    }\n\n    .hamburger-menu .hamburger-menu .menu-item.menu-level-0__item .menu-level-0__link.font-weight-bold,\n    .hamburger-menu .main-navigation-menu .menu-item.menu-level-0__item .menu-level-0__link.font-weight-bold {\n        font-weight: 700 !important\n    }\n\n    .hamburger-menu .hamburger-menu .menu-item.menu-level-0__item.menu-item--dropdown button,\n    .hamburger-menu .main-navigation-menu .menu-item.menu-level-0__item.menu-item--dropdown button {\n        display: flex;\n        align-items: center\n    }\n\n    .hamburger-menu .hamburger-menu .menu-item.menu-level-0__item.menu-item--dropdown a,\n    .hamburger-menu .main-navigation-menu .menu-item.menu-level-0__item.menu-item--dropdown a {\n        display: flex;\n        align-items: center\n    }\n\n    .hamburger-menu .hamburger-menu .menu-level-1__item,\n    .hamburger-menu .main-navigation-menu .menu-level-1__item {\n        padding-left: 0\n    }\n\n    .hamburger-menu .hamburger-menu .menu-level-1__item:not(:first-of-type) .d-flex>:not(.d-none),\n    .hamburger-menu .main-navigation-menu .menu-level-1__item:not(:first-of-type) .d-flex>:not(.d-none) {\n        margin-top: 57px\n    }\n\n    .hamburger-menu .hamburger-menu .menu-level-1__item.menu-level-2__item,\n    .hamburger-menu .main-navigation-menu .menu-level-1__item.menu-level-2__item {\n        padding-right: 0\n    }\n\n    .hamburger-menu .hamburger-menu .menu-level-1__item.menu-level-2__item .menu-level-2__link:not(.btn),\n    .hamburger-menu .main-navigation-menu .menu-level-1__item.menu-level-2__item .menu-level-2__link:not(.btn) {\n        border-bottom: none\n    }\n\n    .hamburger-menu .hamburger-menu .menu-level-1__item.menu-level-2__item .menu-level-2__link.font-weight-bold,\n    .hamburger-menu .main-navigation-menu .menu-level-1__item.menu-level-2__item .menu-level-2__link.font-weight-bold {\n        font-weight: 700 !important\n    }\n\n    .hamburger-menu .hamburger-menu .menu-level-1__item a.btn,\n    .hamburger-menu .main-navigation-menu .menu-level-1__item a.btn {\n        background-color: #041e42;\n        margin-left: 15px;\n        margin-bottom: 20px\n    }\n\n    .hamburger-menu .hamburger-menu .menu-level-1__item a.btn:hover,\n    .hamburger-menu .main-navigation-menu .menu-level-1__item a.btn:hover {\n        background-color: #041e42\n    }\n\n    .hamburger-menu .hamburger-menu--main,\n    .hamburger-menu .main-navigation-menu--main {\n        display: none\n    }\n}\n\n@media (max-width: 1199.98px) and (max-width:1199.98px) {\n\n    .hamburger-menu .hamburger-menu--main,\n    .hamburger-menu .main-navigation-menu--main {\n        display: block\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu--main {\n        display: none\n    }\n}\n\n@media (max-width: 1199.98px) and (max-width:1199.98px) {\n    .hamburger-menu--main {\n        display: block\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu--main .menu-item a.menu--btn-full-width {\n        margin-left: 0;\n        display: block;\n        color: #04325e;\n        padding: 20px;\n        transition: color .3s ease;\n        border-radius: 0;\n        text-align: left;\n        text-transform: none\n    }\n}\n\n@media (max-width: 1199.98px) and (min-width:1200px) {\n    .hamburger-menu--main .menu-item a.menu--btn-full-width:hover {\n        color: #41b6e6;\n        text-decoration: none\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu--main .menu-item a.menu--btn-full-width .hidden-parent .menu-level-2 .menu-item {\n        margin-left: 0\n    }\n\n    .hamburger-menu--main--hamburger .menu:not(.menu-level-0) li {\n        margin-left: 15px\n    }\n\n    .hamburger-menu .login-menu {\n        margin: 35px 0\n    }\n\n    .hamburger-menu .login-menu .menu--login-menu {\n        flex-direction: column\n    }\n\n    .hamburger-menu .login-menu .menu--login-menu .menu-item {\n        margin-bottom: 15px;\n        margin-right: 0\n    }\n\n    .hamburger-menu .login-menu .menu--login-menu .menu-item a {\n        border-bottom: 0;\n        font-size: 1.8rem\n    }\n\n    .hamburger-menu .login-menu .menu--login-menu .menu-item a::before {\n        height: 20px;\n        width: 20px\n    }\n}\n\n@media (max-width: 1199.98px) and (max-width:1199.98px) {\n    .hamburger-menu .hidden-parent div:first-child {\n        display: block\n    }\n\n    .hamburger-menu .hidden-parent .menu-type-image_text_button:first-child {\n        display: none\n    }\n\n    .hamburger-menu .hidden-parent li {\n        margin-left: 0\n    }\n\n    .hamburger-menu .menu-item--image-text-button {\n        display: none\n    }\n\n    .hamburger-menu .menu-level-0__link.btn {\n        display: none\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu .submenu-container {\n        background-color: #fff;\n        height: calc(100% - 53px);\n        left: 100%;\n        overflow-y: auto;\n        overflow-x: hidden;\n        position: absolute;\n        top: 0;\n        transition: left .3s ease-in;\n        width: 100%;\n        z-index: 1\n    }\n\n    .hamburger-menu .submenu-container--level-2 {\n        height: 100%;\n        position: fixed\n    }\n\n    .hamburger-menu .submenu-container--visible {\n        left: 0\n    }\n\n    .hamburger-menu .submenu-container--level-1 {\n        position: initial\n    }\n\n    .hamburger-menu .submenu-container__title {\n        background-color: transparent;\n        border: 0;\n        color: #041e42;\n        font-size: 1.7rem;\n        font-weight: 700;\n        margin: 26px 0 10px 1.7rem;\n        outline: 0;\n        padding: 0\n    }\n\n    .hamburger-menu .submenu-container__title::before {\n        /* background: url(/src/images/icons/chevron-down-dark-blue.svg) no-repeat center center/cover; */\n        content: \"\";\n        display: inline-block;\n        height: 9px;\n        transform: rotate(90deg);\n        width: 12px;\n        margin-right: 5px\n    }\n\n    .hamburger-menu .submenu-container__title span {\n        margin-left: 1.59rem\n    }\n\n    .hamburger-menu .submenu-container__title--level-1 {\n        display: none\n    }\n\n    .hamburger-menu .submenu-container .collapse:not(.show) {\n        display: block\n    }\n\n    .hamburger-menu .menu-level-3 {\n        height: 100dvh\n    }\n}\n\nbody.hamburger-opened {\n    overflow: hidden\n}\n\n@media (min-width: 1200px) {\n    body.hamburger-opened {\n        padding-right: 17px\n    }\n}\n\n@media (max-width: 1199.98px) {\n    body.toolbar-horizontal.toolbar-fixed .hamburger-menu {\n        top: 39px;\n        height: calc(100vh - 39px)\n    }\n\n    body.toolbar-horizontal.toolbar-fixed.toolbar-tray-open .hamburger-menu {\n        top: 79px;\n        height: calc(100vh - 79px)\n    }\n\n    body.toolbar-horizontal.toolbar-fixed.toolbar-tray-open .hamburger-menu .views-exposed-form {\n        margin-top: 71px\n    }\n}\n\n@media (max-width: 1199.98px) and (min-width:992px) {\n    body.toolbar-horizontal.toolbar-fixed.toolbar-tray-open .hamburger-menu .views-exposed-form {\n        margin-top: 107px\n    }\n}\n\n.hamburger-icon {\n    width: 19px;\n    height: 17px;\n    /* background: url(/src/images/icons/burger-pt-blue.svg) no-repeat center/contain; */\n    cursor: pointer;\n    align-self: center;\n    z-index: 1\n}\n\n@media (min-width: 1200px) {\n    .hamburger-icon {\n        display: none\n    }\n}\n\n@media (min-width: 1200px) {\n    .hamburger-icon {\n        width: 20px;\n        height: 15px;\n        flex: 0 0 20px\n    }\n}\n\n/* \n.hamburger-icon--open {\n    background-image: url(/src/images/icons/x-dark-blue.svg)\n} */\n\n.region--primary-menu .menu-level-2 .submenu-container--visible .menu-dropdown-2 {\n    left: 0;\n    opacity: 1\n}\n\n.main-navigation-menu .menu-level-1__item.menu-link:not(.btn) {\n    border-top: 0;\n    border-right: 0;\n    border-left: 0;\n    cursor: default;\n    border-bottom: 1px solid #d2d2d2;\n    color: #041e42;\n    text-align: left;\n    font-size: 1.58rem;\n    padding: 10px 0;\n    transition: color .3s ease\n}\n\n@media (min-width: 992px) {\n    .main-navigation-menu .menu-level-1__item.menu-link:not(.btn) {\n        display: block\n    }\n}\n\n.main-navigation-menu .menu-level-1__item.menu-link:not(.btn).menu-level-0__link {\n    font-size: 1.81rem\n}\n\n.main-navigation-menu .menu-level-1__item.menu-link:not(.btn).menu-level-3__link {\n    border-bottom: 0\n}\n\n.main-navigation-menu .menu-level-1__item.menu-link:not(.btn).is-active {\n    font-weight: 700\n}\n\n@media (max-width: 1199.98px) {\n    .menu__chevron-link {\n        position: relative\n    }\n\n    .menu__chevron-link .menu__chevron {\n        /* background: url(/src/images/icons/chevron-down-dark-blue.svg) no-repeat center center/cover; */\n        height: 13px;\n        transform: rotate(-90deg);\n        width: 13px\n    }\n\n    .menu .menu-level-0__chevron-link,\n    .menu .menu-level-2__chevron-link {\n        align-items: center;\n        background-color: transparent;\n        display: flex;\n        outline: 0;\n        padding-left: 0;\n        padding-right: 2.1rem\n    }\n\n    .menu-level-1__chevron-link {\n        display: none\n    }\n\n    .menu-level-1 {\n        padding-left: 4.5rem\n    }\n\n    .menu-level-1__item {\n        background-color: #fff\n    }\n\n    .menu-level-3 {\n        padding-left: 45px\n    }\n}\n\nbody.simplelogin {\n    background-color: #041e42;\n    font-family: Axiforma\n}\n\nbody.simplelogin .simplelogin-logo img {\n    background-color: #041e42\n}\n\nbody.simplelogin .simplesamlphp-auth-login-link {\n    display: block;\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 16px;\n    height: 35px;\n    padding-top: 6px;\n    transition: font .3s ease\n}\n\nbody.simplelogin .simplesamlphp-auth-login-link:hover {\n    font-size: 17px;\n    color: #041e42\n}\n\nbody.simplelogin .simplelogin .link:focus,\nbody.simplelogin .simplelogin .link:hover,\nbody.simplelogin .simplelogin-form button.form-submit,\nbody.simplelogin .simplelogin-form input.form-submit,\nbody.simplelogin .simplelogin-form input.form-submit:active,\nbody.simplelogin .simplelogin-form input.form-submit:focus,\nbody.simplelogin .simplelogin-form input.form-submit:hover {\n    background-color: #041e42\n}\n\nbody.simplelogin a {\n    color: #041e42\n}\n\n.third-row {\n    margin: 32px auto 16px auto\n}\n\n.third-row .third-left {\n    display: flex;\n    justify-content: center;\n    align-items: start;\n    flex-direction: column\n}\n\nhtml {\n    font-size: calc(8px + (10 - 8) * (100vw - 320px)/ (576 - 320))\n}\n\n@media (min-width: 576px) {\n    html {\n        font-size: calc(8px + (10 - 8) * (100vw - 576px)/ (992 - 576))\n    }\n}\n\n@media (min-width: 992px) {\n    html {\n        font-size: calc(8px + (10 - 8) * (100vw - 992px)/ (1600 - 992))\n    }\n}\n\n@media screen and (min-width: 1600px) {\n    html {\n        font-size: 10px\n    }\n}\n\nbody.language_vi * {\n    font-family: \"Be Vietnam Pro\", sans-serif !important\n}\n\n.brands__title {\n    color: #fff\n}\n\n.brands-grid {\n    position: relative;\n    margin: auto\n}\n\n.brands-grid__image {\n    min-height: 7em;\n    display: flex;\n    align-items: center;\n    justify-content: center\n}\n\n.brands-grid__image img {\n    filter: grayscale(100%);\n    max-width: 80%;\n    height: auto;\n    display: block;\n    margin: 0 auto\n}\n\n.brands-grid__image img:hover {\n    filter: grayscale(0);\n    transition: all .5s ease\n}\n\n.brands-grid__link {\n    height: 3em\n}\n\n.brands-grid__link div {\n    display: inline;\n    white-space: nowrap\n}\n\n.brands-grid__wrapper {\n    height: 8em\n}\n\n.brands-grid__wrapper:hover {\n    text-decoration: none\n}\n\n.brands-grid__wrapper:hover .brands-grid__link {\n    opacity: 1;\n    transition: all .5s ease;\n    text-decoration: none;\n    width: 100%;\n    text-align: center\n}\n\n.brands-grid__link {\n    color: #41b6e6;\n    font-weight: 600;\n    opacity: 0;\n    text-align: center\n}\n\n.other-categories ul {\n    display: flex;\n    padding-left: 0\n}\n\n.other-categories ul li {\n    list-style-type: none\n}\n\n.other-categories ul li a {\n    font-size: 1.8rem;\n    line-height: 1.56em;\n    color: #41b6e6\n}\n\n.other-categories ul li a:hover {\n    text-decoration: underline\n}\n\n@media (min-width: 1200px) {\n    .ptsa-our-customer .slick--optionset--carousel-arrows-dotless-unlimite .carousel-media__container {\n        width: 150px\n    }\n}\n\n.industries .layout__background {\n    background-size: contain;\n    background-position: right center\n}\n\n.industries-list--group+.industries-list--group {\n    border-top: 1px solid #8a8d8f;\n    padding-top: 3.2rem\n}\n\n@media (min-width: 992px) {\n    .industries-list--group+.industries-list--group {\n        padding-top: 2rem\n    }\n}\n\n.industries-list--title {\n    color: #041e42;\n    margin-bottom: 2rem\n}\n\n.industries-list--link {\n    color: #41b6e6;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    display: block\n}\n\n.industries-list--link:hover {\n    color: #41b6e6\n}\n\n@media (min-width: 992px) {\n    .industries-list--link {\n        font-size: 1.8rem\n    }\n}\n\n.industries-list--link-other {\n    color: #41b6e6;\n    font-size: 1.4rem\n}\n\n.industries-list--link-other:hover {\n    color: #41b6e6\n}\n\n@media (min-width: 992px) {\n    .industries-list--link-other {\n        font-size: 1.8rem\n    }\n}\n\n.industries-list--title-other {\n    color: #041e42;\n    font-size: 1.8rem;\n    font-weight: 700\n}\n\n@media (min-width: 992px) {\n    .industries-list--title-other {\n        font-size: 2.2rem\n    }\n}\n\n.engineering-product-card,\n.product-card {\n    --color-tag: #041E42\n}\n\n.engineering-product-card__content,\n.product-card__content {\n    margin-bottom: 0;\n    position: relative;\n    background-color: #fff;\n    padding: 24px 34px\n}\n\n.engineering-product-card__content a,\n.product-card__content a {\n    position: absolute;\n    display: block;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    transition: box-shadow .5s ease\n}\n\n.engineering-product-card__content a:after,\n.product-card__content a:after {\n    content: \" \";\n    position: absolute;\n    right: -25px;\n    top: 50%;\n    display: block;\n    width: 50px;\n    height: 50px;\n    background-color: #41b6e6;\n    border-radius: 50%;\n    z-index: 3;\n    opacity: 0;\n    pointer-events: none;\n    /* background-image: url(/src/images/icons/arrow-next-white.svg); */\n    background-size: 18px;\n    background-repeat: no-repeat;\n    background-position: center;\n    transform: translate(-5px, -50%);\n    transition: opacity .3s ease, transform .3s ease\n}\n\n.engineering-product-card__content a:hover,\n.product-card__content a:hover {\n    box-shadow: 0 3px 6px rgba(0, 0, 0, .1607843137)\n}\n\n@media (min-width: 992px) {\n\n    .engineering-product-card__content a:hover:after,\n    .product-card__content a:hover:after {\n        opacity: 1;\n        transform: translate(0, -50%)\n    }\n}\n\n.engineering-product-card__content>div,\n.product-card__content>div {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    height: 100%\n}\n\n.engineering-product-card__content h2,\n.product-card__content h2 {\n    order: 1\n}\n\n.engineering-product-card__content__title,\n.product-card__content__title {\n    order: 2;\n    padding-top: 8px;\n    position: relative;\n    z-index: 1\n}\n\n.engineering-product-card__content__title p,\n.product-card__content__title p {\n    max-width: 80%\n}\n\n@media (min-width: 992px) {\n\n    .engineering-product-card__content__title p,\n    .product-card__content__title p {\n        max-width: 50%\n    }\n}\n\n.engineering-product-card__content__overview,\n.product-card__content__overview {\n    position: relative;\n    z-index: 1;\n    order: 4;\n    max-width: 100%;\n    padding-bottom: 15px\n}\n\n.engineering-product-card__content__overview p,\n.product-card__content__overview p {\n    font-size: 1.4rem;\n    line-height: 1.25em\n}\n\n@media (min-width: 992px) {\n\n    .engineering-product-card__content__overview p,\n    .product-card__content__overview p {\n        font-size: 1.9rem\n    }\n}\n\n.engineering-product-card__content__overview ul,\n.product-card__content__overview ul {\n    padding-left: 15px\n}\n\n.engineering-product-card__content__overview ul li,\n.product-card__content__overview ul li {\n    font-size: 1.6rem;\n    line-height: 1.25em;\n    margin-bottom: 12px\n}\n\n.engineering-product-card__content__rate,\n.product-card__content__rate {\n    position: relative;\n    order: 5;\n    bottom: 0;\n    left: 0;\n    width: max-content;\n    background-color: #041e42;\n    --text-color: #FFFFFF;\n    padding: 0 11px\n}\n\n.engineering-product-card__content__picture,\n.product-card__content__picture {\n    position: relative;\n    order: 3;\n    height: auto;\n    padding-bottom: 30px\n}\n\n.engineering-product-card__content__picture article,\n.engineering-product-card__content__picture div,\n.engineering-product-card__content__picture img,\n.product-card__content__picture article,\n.product-card__content__picture div,\n.product-card__content__picture img {\n    width: 100%;\n    height: 100%;\n    text-align: right\n}\n\n@media (min-width: 992px) {\n\n    .engineering-product-card__content__picture,\n    .product-card__content__picture {\n        padding-bottom: 0\n    }\n\n    .engineering-product-card__content__picture .drupal-media__image>img,\n    .product-card__content__picture .drupal-media__image>img {\n        width: auto;\n        height: 100%\n    }\n\n    .engineering-product-card__content__picture .drupal-media .drupal-media__image--full-width img,\n    .product-card__content__picture .drupal-media .drupal-media__image--full-width img {\n        width: auto;\n        height: 100%\n    }\n}\n\n@media (min-width: 992px) {\n\n    .engineering-product-card__content__picture,\n    .product-card__content__picture {\n        height: 178px;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 100%\n    }\n}\n\n.engineering-product-card__content .series-title,\n.product-card__content .series-title {\n    --text-color: #0077C8;\n    border-bottom: 1px solid #d6d6d6;\n    padding-bottom: 6px;\n    z-index: 1\n}\n\n@media (max-width: 991.98px) {\n\n    .engineering-product-card__content .series-title,\n    .product-card__content .series-title {\n        max-width: 100%\n    }\n}\n\n@media (min-width: 992px) {\n\n    .engineering-product-card__content .series-title,\n    .product-card__content .series-title {\n        max-width: 50%\n    }\n}\n\n.engineering-product-card__tag,\n.product-card__tag {\n    max-width: 25%;\n    border-radius: 8px 8px 0 0;\n    background-color: var(--color-tag);\n    --text-color: #FFFFFF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px 16px\n}\n\n@media (max-width: 1199.98px) {\n\n    .engineering-product-card__tag,\n    .product-card__tag {\n        max-width: 100%\n    }\n}\n\n.engineering-product-card__tag img,\n.product-card__tag img {\n    width: 18px;\n    margin-right: 8px\n}\n\n@media screen and (orientation: landscape) {\n\n    .engineering-product-card__content__overview,\n    .product-card__content__overview {\n        max-width: 47.5%\n    }\n}\n\n@media (min-width: 768px) {\n\n    .engineering-product-card:not(.col-xl-6) .product-card__content__picture,\n    .product-card:not(.col-xl-6) .product-card__content__picture {\n        height: 100%;\n        max-height: 100%\n    }\n}\n\n@media (min-width: 992px) {\n\n    .engineering-product-card .col-xl-6 .product-card__content__title p,\n    .product-card .col-xl-6 .product-card__content__title p {\n        font-size: 1.8rem\n    }\n\n    .engineering-product-card .col-xl-6 .product-card__content__overview p,\n    .product-card .col-xl-6 .product-card__content__overview p {\n        font-size: 1.6rem\n    }\n\n    .engineering-product-card .col-xl-6 .product-card__content__rate,\n    .product-card .col-xl-6 .product-card__content__rate {\n        font-size: 1.4rem\n    }\n}\n\n@media (min-width: 1200px) {\n    .col-xl-6 .product-card__content__picture {\n        height: 150px;\n        bottom: 20px\n    }\n}\n\n#views-exposed-form-engineering-product-list-block-full-width label,\n#views-exposed-form-product-list-block-full-width label {\n    color: #041e42;\n    font-size: 1.8rem;\n    line-height: 3rem;\n    font-weight: 700\n}\n\n#views-exposed-form-engineering-product-list-block-full-width select,\n#views-exposed-form-product-list-block-full-width select {\n    color: #041e42;\n    font-size: 1.8rem;\n    line-height: 3rem;\n    border: .5px solid #8a8d8f;\n    background-color: transparent;\n    margin-left: 15px;\n    padding: 10px 39px 10px 15px;\n    appearance: none;\n    /* background-image: url(/src/images/icons/chevron-down-dark-blue.svg); */\n    background-repeat: no-repeat;\n    background-position: calc(100% - 15px) 50%;\n    background-size: 15px 15px\n}\n\n#views-exposed-form-engineering-product-list-block-full-width select::-ms-expand,\n#views-exposed-form-product-list-block-full-width select::-ms-expand {\n    display: none\n}\n\n.product-list-no-sorting {\n    padding-top: 10.24rem\n}\n\n@media (max-width: 991.98px) {\n    .product-list-no-sorting {\n        padding-top: 4.8rem\n    }\n}\n\n.best-seller-tag {\n    --color-tag: #0077C8\n}\n\n.best-seller-tag .product-card__content {\n    border: 4px solid var(--color-tag)\n}\n\n.title__success-story {\n    color: #fff\n}\n\n.views-row:last-child .hr__success-story {\n    display: none\n}\n\n.views-row .hr__success-story {\n    border-top: 3px solid rgba(0, 0, 0, .1)\n}\n\n.success-stories-teaser__title {\n    font-weight: 700;\n    margin-bottom: .8rem;\n    line-height: 1.2;\n    font-size: 3.2rem\n}\n\n.taxonomy-list__title {\n    font-weight: 700;\n    font-size: 1.6rem;\n    line-height: 1.45em;\n    color: #041e42;\n    margin-bottom: 9px\n}\n\n@media (min-width: 768px) {\n    .taxonomy-list__title {\n        font-size: 2.2rem;\n        margin-bottom: 15px\n    }\n}\n\n.taxonomy-list__col {\n    padding-left: 0\n}\n\n.taxonomy-list__item {\n    list-style-type: none;\n    padding-bottom: 12px;\n    line-height: 0\n}\n\n.taxonomy-list__link {\n    font-size: 1.4rem;\n    line-height: 1.4em;\n    color: #41b6e6\n}\n\n@media (min-width: 768px) {\n    .taxonomy-list__link {\n        font-size: 1.8rem\n    }\n}\n\n.taxonomy-list__link:hover {\n    text-decoration: underline\n}\n\n@media (max-width: 991.98px) {\n    .taxonomy-list__empty {\n        margin-left: 50%\n    }\n\n    .taxonomy-list__empty .empty-title {\n        height: 0;\n        margin-bottom: 0\n    }\n}\n\n@media (max-width: 767.98px) {\n    .slick--optionset--carousel-limited-variable-slides .carousel-media__container__title {\n        max-width: 11.52rem\n    }\n}\n\n.block--gallery .swiper {\n    aspect-ratio: 3/2.6\n}\n\n.region--banner-top .banner-top-mobile-description {\n    display: none\n}\n\n@media (max-width: 767.98px) {\n    .region--banner-top .banner-top-desktop-description {\n        display: none\n    }\n\n    .region--banner-top .banner-top-mobile-description {\n        display: block\n    }\n}\n\n.region--primary-menu {\n    transform: translateY(0)\n}\n\n.region--banner-top-spacer {\n    height: 35px\n}\n\n.product--world_regions {\n    background-color: #f2f6f8;\n    padding: 2.4rem 2.4rem 2.4rem 4.8rem;\n    border-radius: 8px\n}\n\n.product--world_regions h4 {\n    position: relative\n}\n\n.product--world_regions h4:before {\n    content: \"\";\n    position: absolute;\n    left: -3rem;\n    top: 50%;\n    transform: translateY(-50%);\n    /* background: url(/src/images/icons/check-green.svg) no-repeat center/contain; */\n    width: 22px;\n    height: 22px\n}\n\n#views-exposed-form-product-list-block-full-width {\n    background-color: #fff;\n    padding: 2rem;\n    border-radius: 8px\n}\n\n#views-exposed-form-product-list-block-full-width .fieldgroup .fieldset-legend {\n    display: block;\n    font-size: 2rem;\n    line-height: 3.3rem;\n    font-weight: 700;\n    font-family: Axiforma\n}\n\n#views-exposed-form-product-list-block-full-width ul {\n    list-style: none;\n    display: flex;\n    justify-content: flex-start;\n    padding: 0;\n    margin-top: 1.6rem\n}\n\n@media (max-width: 991.98px) {\n    #views-exposed-form-product-list-block-full-width ul {\n        flex-direction: column\n    }\n}\n\n#views-exposed-form-product-list-block-full-width ul li {\n    margin: 0 1rem\n}\n\n@media (max-width: 991.98px) {\n    #views-exposed-form-product-list-block-full-width ul li {\n        margin: 1rem\n    }\n}\n\n#views-exposed-form-product-list-block-full-width ul li .form-item {\n    padding: 5px 15px;\n    background-color: #f2f6f8;\n    border-radius: 5px;\n    box-shadow: 0 3px 3px -1px rgba(0, 0, 0, .2);\n    position: relative;\n    z-index: 1;\n    transition: box-shadow .3s ease\n}\n\n#views-exposed-form-product-list-block-full-width ul li .form-item:hover {\n    box-shadow: none\n}\n\n#views-exposed-form-product-list-block-full-width ul li .form-item .form-radio:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    background: 0 0;\n    left: 0;\n    box-shadow: none;\n    z-index: -1;\n    border-radius: 5px;\n    transition: box-shadow .3s ease\n}\n\n#views-exposed-form-product-list-block-full-width ul li .form-item .form-radio:checked:after {\n    box-shadow: 0 0 0 1px #041e42\n}\n\n#views-exposed-form-product-list-block-full-width ul label {\n    padding-left: 1rem;\n    margin-bottom: 0;\n    font-weight: 400\n}\n\n#views-exposed-form-product-list-block-full-width ul:first {\n    margin-left: 0\n}\n\n#views-exposed-form-product-list-block-full-width ul:first>div {\n    padding-left: 0\n}\n\n#views-exposed-form-product-list-block-full-width ul:last-child {\n    margin-right: 0\n}\n\n.form__replacement {\n    position: relative;\n    height: 0\n}\n\n.mainfiltercontainer {\n    display: flex;\n    flex: 1 0 auto;\n    padding-bottom: 75px;\n    padding-top: 25px\n}\n\n@media (max-width: 767.98px) {\n    .mainfiltercontainer {\n        padding-bottom: 45px;\n        padding-top: 15px;\n        flex-wrap: wrap\n    }\n}\n\n.mainfiltercontainer div {\n    flex: 0 0 50%\n}\n\n@media (max-width: 767.98px) {\n    .mainfiltercontainer div {\n        flex: 0 0 100%\n    }\n}\n\n.filtercontainer {\n    background-color: transparent;\n    position: relative;\n    width: 95%\n}\n\n@media (max-width: 767.98px) {\n    .filtercontainer {\n        width: 100%\n    }\n}\n\n.filtercontainer__left {\n    margin-left: 0\n}\n\n.filtercontainer__right {\n    margin-left: 5%\n}\n\n@media (max-width: 767.98px) {\n    .filtercontainer__right {\n        margin-left: 0;\n        margin-top: 25px\n    }\n}\n\n.filtercontainer__overlay {\n    background-color: #fff;\n    position: absolute;\n    opacity: .4;\n    width: 100%;\n    height: 100%\n}\n\n.filtercontainer__selector {\n    display: none\n}\n\n.filtercontainer__selector::-ms-expand {\n    display: none\n}\n\n.filtercontainer__select--selected:after {\n    color: #041e42;\n    border-style: solid;\n    border-width: .25em .25em 0 0;\n    content: \"\";\n    display: inline-block;\n    height: 1em;\n    position: absolute;\n    right: 16px;\n    vertical-align: top;\n    width: 1em;\n    top: 8px;\n    transform: rotate(135deg)\n}\n\n.filtercontainer__select--selected {\n    position: relative;\n    color: #fff;\n    font-weight: 700;\n    padding: 8px 16px;\n    border: 1px solid transparent;\n    border-color: transparent transparent rgba(0, 0, 0, .1) transparent;\n    cursor: pointer;\n    user-select: none\n}\n\n.filtercontainer__select--selected.filtercontainer__select--arrow-active:after {\n    transform: rotate(-45deg);\n    top: 16px\n}\n\n.filtercontainer__select--hide {\n    display: none\n}\n\n.filtercontainer__select--same-as-selected {\n    background-color: rgba(0, 0, 0, .1)\n}\n\n.filtercontainer__select-items {\n    position: absolute;\n    background-color: #fff;\n    opacity: 1;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 99\n}\n\n.filtercontainer__select-items div {\n    color: #041e42;\n    padding: 8px 16px;\n    border: 1px solid transparent;\n    border-color: transparent transparent rgba(0, 0, 0, .1) transparent;\n    cursor: pointer;\n    user-select: none\n}\n\n.filtercontainer__select-items div:hover {\n    background-color: rgba(0, 0, 0, .1)\n}\n\n@media (min-width: 769px) {\n    .layout .layout__region.mb {\n        margin-bottom: 0\n    }\n}\n\n.product-header-section-container {\n    display: flex;\n    min-height: 300px;\n    margin-top: 1.6rem;\n    align-items: stretch\n}\n\n@media (max-width: 767px) {\n    .product-header-section-container {\n        min-height: 200px\n    }\n}\n\n.product-header-section-container .product-header-section .part-one {\n    display: flex;\n    width: max-content;\n    padding-left: 15px;\n    color: #0077c8\n}\n\n.product-header-section-container .product-header-section .part-one .product-model-section {\n    width: max-content;\n    line-height: 4rem;\n    font-weight: 500;\n    border-bottom: 1px solid #8a8d8f;\n    display: flex\n}\n\n@media \\0 screen\\,screen\\9,\nscreen\\0 {\n    .product-header-section-container .product-header-section .part-one .product-model-section {\n        display: table\n    }\n}\n\n.product-header-section-container .product-header-section .part-one .product-model-section:nth-child(2):before {\n    color: #0077c8;\n    display: flex;\n    height: fit-content;\n    content: \" • \"\n}\n\n.product-header-section-container .product-header-section .part-two {\n    color: #041e42;\n    margin-top: 1.6rem;\n    display: block\n}\n\n.product-header-section-container .product-header-section .part-three {\n    margin-top: 4rem\n}\n\n.product-header-section-container .product-header-section .part-three .primary-blue-highlight {\n    background-color: #041e42;\n    width: -moz-fit-content;\n    padding: 0 15px;\n    color: #fff;\n    display: table;\n    font-size: 2rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: fit-content\n}\n\n@media \\0 screen\\,screen\\9,\nscreen\\0 {\n    .product-header-section-container .product-header-section .part-three .primary-blue-highlight {\n        display: table\n    }\n}\n\n.product-header-section-container .product-header-section .media-360 {\n    margin-top: 3.2rem\n}\n\n.product-header-section-container .presentation-image,\n.product-header-section-container .presentation-image-left-part {\n    min-height: 300px;\n    float: right\n}\n\n@media (max-width: 767px) {\n\n    .product-header-section-container .presentation-image,\n    .product-header-section-container .presentation-image-left-part {\n        min-height: 200px\n    }\n}\n\n.product-header-section-container .presentation-image .product-header-background-image {\n    float: right;\n    width: 100%\n}\n\n.product-header-section-container .world_regions {\n    max-width: 500px\n}\n\n@media screen and (orientation: portrait) {\n    .product-header-section-container .product-header-section .part-two .product-name-title {\n        font-size: 2.3rem\n    }\n\n    .product-header-section-container .product-header-section .part-three .primary-blue-highlight {\n        padding: 0 9px\n    }\n\n    .product-header-section-container .product-header-section .media-360 {\n        display: none\n    }\n\n    .product-header-section-container .presentation-image-left-part {\n        margin-top: .5rem\n    }\n\n    .product-header-section-container .presentation-image {\n        margin-top: .5rem\n    }\n}\n\n@media screen and (orientation: portrait) and (max-width:767px) {\n    .product-header-section-container .product-header-section {\n        display: block;\n        position: relative;\n        width: 100%;\n        margin-top: 0\n    }\n\n    .product-header-section-container .product-header-section .part-one .bulk-point {\n        font-size: 1.6rem\n    }\n\n    .product-header-section-container .product-header-section .part-one .product-model-section {\n        font-size: 1.7rem;\n        line-height: 4.4rem\n    }\n\n    .product-header-section-container .product-header-section .part-three .primary-blue-highlight {\n        font-size: 1.6rem\n    }\n\n    .presentation-image-left-part {\n        display: none\n    }\n\n    .presentation-image {\n        max-width: 100%;\n        flex: 0 0 100%\n    }\n}\n\n@media screen and (orientation: portrait) and (min-width:767px) {\n    .product-header-section-container .product-header-section {\n        width: 40%;\n        margin-top: 0\n    }\n\n    .product-header-section-container .product-header-section .part-one .bulk-point {\n        font-size: 1.6rem\n    }\n\n    .product-header-section-container .product-header-section .part-one .product-model-section {\n        font-size: 1.7rem;\n        line-height: 4.4rem\n    }\n}\n\n@media screen and (orientation: landscape) {\n    .product-header-section-container .product-header-section .part-one .bulk-point {\n        font-size: 1.6rem\n    }\n\n    .product-header-section-container .product-header-section .part-three {\n        margin-top: 1.6rem\n    }\n\n    .product-header-section-container .product-header-section .part-three .primary-blue-highlight {\n        padding: 0 9px;\n        font-size: 1.7rem\n    }\n\n    .product-header-section-container .presentation-image-left-part {\n        margin-top: 1.6rem\n    }\n\n    .product-header-section-container .presentation-image {\n        margin-top: 1.6rem\n    }\n}\n\n@media screen and (orientation: landscape) and (max-width:576px) {\n    .product-header-section-container .product-header-section {\n        width: 50%;\n        margin-top: .8rem\n    }\n\n    .product-header-section-container .product-header-section .part-one .product-model-section {\n        font-size: 1.6rem;\n        line-height: 4rem\n    }\n\n    .product-header-section-container .product-header-section .part-two .product-name-title {\n        font-size: 1.6rem\n    }\n}\n\n@media screen and (orientation: landscape) and (min-width:577px) and (max-width:767.98px) {\n    .product-header-section-container .product-header-section {\n        width: 40%;\n        margin-top: 0\n    }\n\n    .product-header-section-container .product-header-section .part-one .product-model-section {\n        font-size: 1.6rem;\n        line-height: 4rem\n    }\n\n    .product-header-section-container .product-header-section .part-two .product-name-title {\n        font-size: 2rem\n    }\n\n    .product-header-section-container .product-header-section .media-360 {\n        display: none\n    }\n}\n\n@media screen and (orientation: landscape) and (min-width:767.99px) and (max-width:992px) {\n    .product-header-section-container .product-header-section {\n        width: 50%;\n        margin-top: 1.6rem\n    }\n\n    .product-header-section-container .product-header-section .part-one .product-model-section {\n        font-size: 2rem;\n        line-height: 5.6rem\n    }\n\n    .product-header-section-container .product-header-section .part-two {\n        margin-top: 1.6rem\n    }\n\n    .product-header-section-container .product-header-section .part-two .product-name-title {\n        font-size: 2.4rem\n    }\n\n    .product-header-section-container .product-header-section .part-three {\n        margin-top: 2.4rem\n    }\n\n    .product-header-section-container .product-header-section .part-three .primary-blue-highlight {\n        padding: 0 15px;\n        font-size: 1.8rem\n    }\n\n    .product-header-section-container .product-header-section .media-360 {\n        display: none\n    }\n}\n\n@media screen and (orientation: landscape) and (min-width:992px) {\n    .product-header-section-container .part-two {\n        margin-top: 1.6rem\n    }\n\n    .product-header-section-container .part-three {\n        margin-top: 3.6rem\n    }\n\n    .product-header-section-container .part-three .primary-blue-highlight {\n        padding: 0 15px;\n        font-size: 2rem\n    }\n\n    .product-header-section-container .presentation-image-left-part {\n        margin-top: 3.2rem\n    }\n\n    .product-header-section-container .presentation-image {\n        margin-top: 3.2rem\n    }\n}\n\n.splash-video-limit-height>article.drupal-media {\n    max-height: 86.4rem;\n    display: flex;\n    overflow: hidden\n}\n\n@media (max-width: 1199.98px) {\n    .splash-video-limit-height>article.drupal-media {\n        max-height: 57.6rem\n    }\n}\n\n@media (max-width: 991.98px) {\n    .splash-video-limit-height>article.drupal-media {\n        max-height: 40rem\n    }\n}\n\n.pt-footer__ptsa ul li.menu-item {\n    padding-left: 15px;\n    margin-bottom: 5px\n}\n\n@media (max-width: 767.98px) {\n    .pt-footer__ptsa ul li.menu-item ul {\n        display: none\n    }\n}\n\n.pt-footer__ptsa ul.menu-level-0 {\n    display: block;\n    margin-bottom: 45px\n}\n\n@media (max-width: 767.98px) {\n    .pt-footer__ptsa ul.menu-level-0 {\n        margin-bottom: 0\n    }\n}\n\n.pt-footer__ptsa ul.menu-level-0>li.menu-item {\n    width: auto;\n    padding-left: 0\n}\n\n.pt-footer__ptsa ul.menu-level-0>li.menu-item>a {\n    color: #041e42;\n    margin-bottom: 5px\n}\n\n.pt-footer__ptsa ul.menu-level-1 {\n    margin-top: 15px\n}\n\n.pt-footer__ptsa ul.menu-level-1 li.menu-item a {\n    font-size: 1.5rem;\n    line-height: 1.4em\n}\n\n.pt-footer__ptsa ul:not(.menu-level-0) {\n    margin-bottom: 15px\n}\n\n.social-media p {\n    font-weight: 700;\n    margin-bottom: 5px\n}\n\n@media (max-width: 1199.98px) {\n    .hamburger-menu .view-mode-image-text-button .menu-item--image-text-button {\n        margin-left: 20px\n    }\n\n    .hamburger-menu .menu--btn-full-width {\n        transform: translate(0, 0);\n        border-bottom: 1px solid #8a8d8f !important;\n        margin-bottom: 0 !important\n    }\n\n    .hamburger-menu .menu--main .menu:not(.menu-level-0) li a:after,\n    .hamburger-menu .menu--main .menu:not(.menu-level-0) li a:before {\n        content: unset\n    }\n}\n\n@media (min-width: 1200px) {\n    .language-redirection-banner .language-redirection-banner-inner :not(:last-child) {\n        margin-right: 0\n    }\n}\n\nbody.stopScroll {\n    overflow: hidden\n}\n\n.marketlanguageswitchercontainer {\n    position: absolute;\n    width: 65vw;\n    height: 65vh;\n    z-index: 1000;\n    left: 17.5vw;\n    top: 17.5vh;\n    transform: translate(0, 15%)\n}\n\n@media (max-width: 1199.98px) {\n    .marketlanguageswitchercontainer {\n        width: 75vw;\n        height: 75vh;\n        left: 12.5vw;\n        top: 12.5vh;\n        transform: translate(0, 5%);\n        z-index: 9999\n    }\n}\n\n@media screen and (max-width: 1199.98px) and (orientation:portrait) {\n    .marketlanguageswitchercontainer {\n        transform: translate(0, 1%)\n    }\n}\n\n@media (max-width: 767.98px) {\n    .marketlanguageswitchercontainer {\n        width: 85vw;\n        height: 90vh;\n        left: 7.5vw;\n        top: 5vh;\n        transform: translate(0, 5%)\n    }\n}\n\n@media screen and (max-width: 767.98px) and (orientation:portrait) {\n    .marketlanguageswitchercontainer {\n        transform: translate(0, 1%)\n    }\n}\n\n.marketlanguageswitchercontainer .ui-dialog-titlebar {\n    border: none;\n    display: none\n}\n\n.marketlanguageswitchercontainer .ui-dialog-titlebar button.ui-button {\n    display: none\n}\n\n.ui-dialog-content.ui-dialog {\n    overflow-y: unset !important\n}\n\n.marketlanguageswitcher__overlay {\n    display: none;\n    background-color: #041e42;\n    opacity: .5;\n    width: 100%;\n    height: 100vh;\n    position: absolute;\n    z-index: 5\n}\n\n.marketlanguageswitcher__dialog {\n    display: none;\n    z-index: 6;\n    height: 100%;\n    padding: 32px\n}\n\n.marketlanguageswitcher__dialog.ui-dialog-content.ui-dialog {\n    height: 100%\n}\n\n.marketlanguageswitcher__dialog .marketlanguageswitcher_maincontainer {\n    display: flex;\n    flex-direction: column;\n    font-family: Axiforma;\n    max-height: 100%\n}\n\n.marketlanguageswitcher__dialog--definition {\n    display: flex;\n    flex: 1 0 auto;\n    flex-wrap: wrap;\n    padding-left: 3.2rem;\n    padding-right: 3.2rem\n}\n\n@media (max-width: 767.98px) {\n    .marketlanguageswitcher__dialog--definition {\n        padding-left: 1.92rem;\n        padding-right: 1.92rem\n    }\n}\n\n.marketlanguageswitcher__dialog--overflow {\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    height: inherit\n}\n\n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar {\n    width: 10px;\n    border: none\n}\n\n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-track {\n    background: rgba(138, 141, 143, .3);\n    box-shadow: inset 0 0 6px rgba(0, 0, 0, .15);\n    border-radius: 10px\n}\n\n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-thumb {\n    background: #8a8d8f;\n    border-radius: 10px;\n    box-shadow: inset 0 0 6px rgba(0, 0, 0, .25)\n}\n\n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-thumb:hover {\n    background: #54585a\n}\n\n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button {\n    background-color: #fff;\n    background-size: 16px 16px;\n    background-repeat: no-repeat;\n    background-position: center center;\n    height: 16px;\n    width: 1em\n}\n\n/* \n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:vertical:start {\n    background-image: url(/src/images/icons/chevron-up-dark-blue.svg)\n} */\n/* \n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:vertical:end {\n    background-image: url(/src/images/icons/chevron-down-dark-blue.svg)\n} */\n\n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:horizontal:end:decrement,\n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:horizontal:end:increment,\n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:vertical:end:decrement,\n.marketlanguageswitcher__dialog--overflow::-webkit-scrollbar-button:vertical:start:increment {\n    display: none\n}\n\n.marketlanguageswitcher__dialog--column {\n    margin-top: 10px;\n    margin-bottom: 15px;\n    flex: 0 0 33%;\n    padding: 10px\n}\n\n@media (max-width: 991.98px) {\n    .marketlanguageswitcher__dialog--column {\n        flex: 0 0 50%;\n        margin-top: 10px;\n        margin-bottom: 10px\n    }\n}\n\n@media (max-width: 575.98px) {\n    .marketlanguageswitcher__dialog--column {\n        margin-top: 0;\n        margin-bottom: 8px;\n        padding: 0;\n        flex: 0 0 100%\n    }\n}\n\n.marketlanguageswitcher__dialog--columnadapted {\n    margin-top: 5px;\n    margin-bottom: 5px;\n    padding: 0 10px 0 10px\n}\n\n.marketlanguageswitcher__dialog--columnadapted .marketlanguageswitcher__list {\n    margin-bottom: 0\n}\n\n.marketlanguageswitcher__titlecontainer {\n    color: #041e42;\n    position: relative;\n    width: 100%;\n    min-height: 25px;\n    margin-top: 35px;\n    margin-bottom: 15px\n}\n\n@media (max-width: 767.98px) {\n    .marketlanguageswitcher__titlecontainer {\n        margin-top: 20px;\n        margin-bottom: 50px\n    }\n}\n\n.marketlanguageswitcher__titlecontainer--std {\n    min-height: 25px;\n    margin-top: 36px;\n    margin-bottom: 50px;\n    position: relative\n}\n\n@media (max-width: 767.98px) {\n    .marketlanguageswitcher__titlecontainer--std {\n        margin-top: 18px;\n        margin-bottom: 25px;\n        min-height: 45px\n    }\n}\n\n.marketlanguageswitcher__titlecontainer div {\n    text-align: center\n}\n\n.marketlanguageswitcher__dialogbuttoncontainer {\n    position: relative;\n    width: 100%;\n    min-height: 35px\n}\n\n.marketlanguageswitcher__dialogbuttoncontainer .marketlanguageswitcher__dialogbutton {\n    color: #8a8d8f;\n    font-weight: 700;\n    flex-direction: row;\n    text-transform: uppercase;\n    position: absolute;\n    right: 0;\n    font-size: 1.6rem;\n    cursor: pointer\n}\n\n.marketlanguageswitcher__dialogbuttoncontainer .marketlanguageswitcher__dialogbutton:before {\n    content: \"× \";\n    font-size: 2.9rem;\n    height: 4.48rem;\n    font-weight: 500;\n    width: .7em;\n    line-height: unset;\n    vertical-align: middle\n}\n\n.marketlanguageswitcher__dialogbuttoncontainer .marketlanguageswitcher__dialogbutton:hover {\n    opacity: .7\n}\n\n.marketlanguageswitcher__marketname {\n    color: #041e42;\n    font-size: 2.2rem;\n    font-weighT: bold;\n    margin-top: 50px\n}\n\n@media (max-width: 991.98px) {\n    .marketlanguageswitcher__marketname {\n        font-size: 2rem;\n        margin-top: 20px\n    }\n}\n\n@media (max-width: 767.98px) {\n    .marketlanguageswitcher__marketname {\n        font-size: 1.8rem;\n        margin-top: 20px\n    }\n}\n\n.marketlanguageswitcher__list {\n    list-style: none;\n    padding-left: 0\n}\n\n.marketlanguageswitcher__list--selection .languageswitcher_pathalias {\n    border: none;\n    color: #41b6e6;\n    font-size: 2rem;\n    text-decoration: none\n}\n\n@media (max-width: 767.98px) {\n    .marketlanguageswitcher__list--selection .languageswitcher_pathalias {\n        font-size: 1.6rem\n    }\n}\n\n.marketlanguageswitcher__list--selection .languageswitcher_pathalias:hover {\n    text-decoration: underline\n}\n\n.marketlanguageswitcher__list--selection .languageswitcher_pathalias--active {\n    font-weight: 700\n}\n\n@media (max-width: 991.98px) {\n    .marketlanguageswitcher__list--selection {\n        font-size: 1.7rem\n    }\n}\n\n@media (max-width: 767.98px) {\n    .marketlanguageswitcher__list--selection {\n        font-size: 1.6rem\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .cta-block {\n        order: 8;\n        z-index: auto\n    }\n\n    .cta-block .d-xl-none.menu-link {\n        display: block;\n        margin-bottom: 14px;\n        padding-right: 40px;\n        font-size: 14px;\n        color: #031a39\n    }\n}\n\n@media (max-width: 991.98px) {\n    .helpButton {\n        width: fit-content\n    }\n}\n\n.webform-submission-ptsa-web2lead-form label {\n    color: var(--text-color)\n}\n\n.webform-submission-ptsa-web2lead-form #edit-container {\n    background-color: rgba(242, 246, 248, .6);\n    padding: 25px\n}\n\n.webform-submission-ptsa-web2lead-form #edit-container label {\n    --text-color: #041E42\n}\n\n.client-stories-grid {\n    max-width: 400px;\n    margin: auto\n}\n\n.client-stories-grid__logo {\n    position: absolute;\n    bottom: 10%;\n    z-index: 99;\n    transition: opacity .3s ease;\n    opacity: 0;\n    margin-left: 30px;\n    max-width: 150px;\n    max-height: 150px\n}\n\n.client-stories-grid__logo img {\n    width: 100%;\n    height: 100%\n}\n\n.client-stories-grid__title {\n    font-weight: 700;\n    font-size: 3.6rem;\n    padding: 13px 0 8px\n}\n\n.client-stories-grid__main-image {\n    height: 430px;\n    width: inherit;\n    position: relative\n}\n\n.client-stories-grid__main-image img {\n    max-width: 100%;\n    max-height: 430px\n}\n\n.client-stories-grid__text {\n    color: #041e42\n}\n\n.client-stories-grid__veil {\n    max-width: 400px;\n    width: 100%;\n    height: 430px;\n    position: absolute;\n    opacity: 0;\n    transition: opacity .3s ease;\n    background: #041e42;\n    z-index: 9\n}\n\n.client-stories-grid__wysiwyg p {\n    margin-bottom: 0\n}\n\n.client-stories-grid .main-image-container .splash-video-play-button {\n    width: 70px;\n    height: 70px;\n    left: 50%;\n    top: 50%;\n    transform: translateX(-35px) translateY(-35px);\n    opacity: 0;\n    transition: opacity .3s ease;\n    z-index: 10\n}\n\n@media (max-width: 1199.98px) {\n    .client-stories-grid .main-image-container .splash-video-play-button {\n        opacity: 1\n    }\n}\n\n.client-stories-grid hr {\n    color: #54585a\n}\n\n@media (min-width: 992px) {\n    .client-stories-grid:hover .client-stories-grid__veil {\n        opacity: .92\n    }\n\n    .client-stories-grid:hover .client-stories-grid__logo {\n        opacity: 1\n    }\n\n    .client-stories-grid:hover .splash-video-play-button {\n        opacity: 1\n    }\n\n    .client-stories-grid:hover .splash-video-play-button:hover {\n        opacity: 1\n    }\n}\n\n.center .brochure-btn {\n    justify-content: center\n}\n\n.right .brochure-btn {\n    justify-content: end\n}\n\n.left .brochure-btn {\n    justify-content: start\n}\n\n.engineering-services-grid {\n    width: 100%\n}\n\n.engineering-services-grid a:hover {\n    text-decoration: none\n}\n\n.engineering-services-grid__main-image {\n    position: relative\n}\n\n.engineering-services-grid__main-image img {\n    width: 100%;\n    height: auto\n}\n\n.engineering-services-grid__overlay {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    background-color: #41b6e6;\n    /* background-image: url(/src/images/icons/arrow-next-white.svg); */\n    background-size: 36px;\n    background-repeat: no-repeat;\n    background-position: center;\n    opacity: 0;\n    transition: opacity .3s ease\n}\n\n.engineering-services-grid__overlay:hover {\n    opacity: .9\n}\n\n.engineering-services-grid__text {\n    text-align: center;\n    color: #041e42\n}\n\n.engineering-services-grid__title {\n    font-weight: 700;\n    font-size: 2rem\n}\n\n.engineering-services-grid__description {\n    font-size: 1.4rem\n}\n\n.fourth-col {\n    flex: 0 1 25%\n}\n\n.views-view-grid {\n    display: flex;\n    flex-wrap: wrap;\n    flex: 1 0 auto\n}\n\n.views-view-grid .views-row {\n    display: flex;\n    flex-wrap: wrap;\n    flex: 1 0 auto;\n    box-sizing: border-box\n}\n\n@media (max-width: 991.98px) {\n    .views-view-grid .views-row {\n        flex-direction: inherit;\n        flex-wrap: wrap;\n        align-items: stretch;\n        position: relative\n    }\n}\n\n@media (max-width: 991.98px) and (max-width:767.98px) {\n    .views-view-grid .views-row {\n        flex-direction: column\n    }\n}\n\n.views-view-grid .event-view-block {\n    flex: 0 0 33%\n}\n\n@media (max-width: 767px) {\n    .views-view-grid .event-view-block {\n        flex: 1 0 auto\n    }\n}\n\n@media screen and (max-width: 767px) and (orientation:landscape) and (max-height:767px) {\n    .views-view-grid .event-view-block {\n        flex: 0 0 50%\n    }\n}\n\n@media (min-width: 767px) and (max-width:991px) {\n    .views-view-grid .event-view-block {\n        flex: 0 0 50%\n    }\n}\n\n.event-row-item-container {\n    width: 100%\n}\n\n.event-description-container {\n    display: flex\n}\n\n.event-description-container .event-description-article {\n    min-height: 368px;\n    background-color: #fff;\n    text-align: center;\n    width: 100%;\n    font-size: 2.1rem;\n    line-height: 4.16rem;\n    padding: 12px;\n    margin: 10px;\n    color: #041e42\n}\n\n.event-description-container .event-description-article .event-image {\n    min-height: 125px;\n    overflow: hidden\n}\n\n.event-description-container .event-description-article .event-title {\n    font-weight: 700;\n    max-height: 36px;\n    overflow: hidden\n}\n\n.event-description-container .event-description-article .event-detail {\n    font-size: 1.6rem;\n    line-height: 1.8rem;\n    margin-bottom: 7px;\n    min-height: 3.2rem;\n    overflow: hidden\n}\n\n.event-description-container .event-description-article .event-location {\n    width: inherit;\n    max-height: 36px;\n    overflow: hidden\n}\n\n.event-description-container .event-description-article .event-date {\n    display: inline-table;\n    max-height: 36px;\n    overflow: hidden\n}\n\n.event-description-container .event-description-article .event-date .event-start-date {\n    display: table-cell;\n    padding-right: 4px;\n    white-space: nowrap\n}\n\n.event-description-container .event-description-article .event-date .event-end-date {\n    display: table-cell\n}\n\n.event-description-container .event-description-article .event-date .event-end-date time {\n    white-space: nowrap\n}\n\n@media (max-width: 767px) {\n    .event-description-container .event-description-article .event-date {\n        font-size: 2rem\n    }\n}\n\n.event-description-container .event-description-article .event-website {\n    margin-top: 10px;\n    width: 80%;\n    margin-left: 10%;\n    max-height: 36px;\n    overflow: hidden;\n    border: 1px solid #fff\n}\n\n.event-description-container .event-description-article .event-website .event-website-external-link {\n    text-decoration: none;\n    color: #41b6e6\n}\n\n.event-description-container .event-description-article .event-website:hover {\n    border: 1px solid #41b6e6;\n    color: #41b6e6\n}\n\n.product-categories-grid {\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n    position: relative\n}\n\n.product-categories-grid__image div {\n    display: flex;\n    flex: 1 0 auto;\n    align-items: center;\n    justify-content: center;\n    justify-items: center\n}\n\n.product-categories-grid__veil {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    opacity: 0;\n    transition: opacity .3s ease;\n    background: #041e42;\n    z-index: 9\n}\n\n.product-categories-grid__main-container {\n    position: relative;\n    width: auto;\n    overflow: hidden;\n    --text-color: #FFFFFF\n}\n\n.product-categories-grid__main-container img {\n    max-height: 300px\n}\n\n@media (max-width: 767.98px) {\n    .product-categories-grid__main-container img {\n        width: 100%\n    }\n}\n\n.product-categories-grid__title {\n    font-weight: 700;\n    padding: 13px 0 8px;\n    text-align: center\n}\n\n.product-categories-grid__text {\n    display: none;\n    --text-color: #F2F6F8;\n    position: absolute;\n    bottom: 10%\n}\n\n.product-categories-grid__wysiwyg p {\n    font-size: 2rem;\n    font-weight: 800;\n    margin-bottom: 0\n}\n\n.product-categories-grid__link a {\n    margin-bottom: 0;\n    color: #41b6e6;\n    letter-spacing: 1px\n}\n\n.product-categories-grid__btn {\n    box-shadow: 0 0 0 1.5px #fff;\n    color: #fff\n}\n\n.product-categories-grid__btn:after {\n    background-color: #fff\n}\n\n.product-categories-grid__btn:hover {\n    color: #fff\n}\n\n.product-categories-grid:hover .product-categories-grid__text {\n    display: block;\n    z-index: 10\n}\n\n@media (max-width: 767.98px) {\n    .product-categories-grid:hover .product-categories-grid__text {\n        display: none\n    }\n}\n\n.product-categories-grid:hover .product-categories-grid__veil {\n    opacity: .92\n}\n\n@media (max-width: 767.98px) {\n    .product-categories-grid:hover .product-categories-grid__veil {\n        opacity: 0\n    }\n}\n\n#views-exposed-form-products-category-list-block-product-categories {\n    display: none\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
